import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { FormGroup as FormGroup$1, Label as Label$2, TextArea as TextArea$2, RaketaUIProvider, Container as Container$1, List, TextInput, LinkSettings, SelectMenu, Img, ButtonSettings, imageSrc, Link as Link$6, Button as Button$4 } from '@raketa-cms/raketa-cms';
import { imagePlaceholder, ImagePicker } from '@raketa-cms/raketa-image-picker';
import Swiper from 'react-id-swiper';
import { useQuery, ApolloProvider } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import fetch$1 from 'cross-fetch';
import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { HttpLink } from 'apollo-link-http';
import jQuery from 'jquery';
import Recaptcha from 'react-google-recaptcha';
import MarkdownIt from 'markdown-it';
import Autocomplete from 'react-autocomplete';
import ReactCompareImage from 'react-compare-image';
import moment from 'moment-timezone';
import { RectShape, TextBlock } from 'react-placeholder/lib/placeholders';
import ReactPlaceholder from 'react-placeholder';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { docco } from 'react-syntax-highlighter/dist/cjs/styles/hljs';
import styled, { css } from 'styled-components';
import { Tabs as Tabs$1, TabList, Tab as Tab$5, TabPanel } from 'react-tabs';
import ReactDatePicker from 'react-datepicker';
import Disqus from 'disqus-react';
function _wrapRegExp() {
  _wrapRegExp = function (e, r) {
    return new BabelRegExp(e, void 0, r);
  };
  var e = RegExp.prototype,
    r = new WeakMap();
  function BabelRegExp(e, t, p) {
    var o = RegExp(e, t);
    return r.set(o, p || r.get(e)), _setPrototypeOf(o, BabelRegExp.prototype);
  }
  function buildGroups(e, t) {
    var p = r.get(t);
    return Object.keys(p).reduce(function (r, t) {
      var o = p[t];
      if ("number" == typeof o) r[t] = e[o];else {
        for (var i = 0; void 0 === e[o[i]] && i + 1 < o.length;) i++;
        r[t] = e[o[i]];
      }
      return r;
    }, Object.create(null));
  }
  return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (r) {
    var t = e.exec.call(this, r);
    if (t) {
      t.groups = buildGroups(t, this);
      var p = t.indices;
      p && (p.groups = buildGroups(p, this));
    }
    return t;
  }, BabelRegExp.prototype[Symbol.replace] = function (t, p) {
    if ("string" == typeof p) {
      var o = r.get(this);
      return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)>/g, function (e, r) {
        var t = o[r];
        return "$" + (Array.isArray(t) ? t.join("$") : t);
      }));
    }
    if ("function" == typeof p) {
      var i = this;
      return e[Symbol.replace].call(this, t, function () {
        var e = arguments;
        return "object" != typeof e[e.length - 1] && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
      });
    }
    return e[Symbol.replace].call(this, t, p);
  }, _wrapRegExp.apply(this, arguments);
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var INLINE_STYLE_BUTTONS = [{
  label: "Bold",
  style: "BOLD"
}, {
  label: "Italic",
  style: "ITALIC"
}, {
  label: "Strikethrough",
  style: "STRIKETHROUGH"
}, {
  label: "Monospace",
  style: "CODE"
}, {
  label: "Underline",
  style: "UNDERLINE"
}];
var BLOCK_ALIGNMENT_BUTTONS = [{
  label: "Align Left",
  style: "ALIGN_LEFT"
}, {
  label: "Align Center",
  style: "ALIGN_CENTER"
}, {
  label: "Align Right",
  style: "ALIGN_RIGHT"
}, {
  label: "Align Justify",
  style: "ALIGN_JUSTIFY"
}];
var BLOCK_TYPE_DROPDOWN = [{
  label: "Normal",
  style: "unstyled"
}, {
  label: "Heading Large",
  style: "header-one"
}, {
  label: "Heading Medium",
  style: "header-two"
}, {
  label: "Heading Small",
  style: "header-three"
}, {
  label: "Code Block",
  style: "code-block"
}];
var BLOCK_TYPE_BUTTONS = [{
  label: "UL",
  style: "unordered-list-item"
}, {
  label: "OL",
  style: "ordered-list-item"
}, {
  label: "Blockquote",
  style: "blockquote"
}];
var TOOLBAR_CONFIG = {
  display: ["INLINE_STYLE_BUTTONS", "BLOCK_ALIGNMENT_BUTTONS", "BLOCK_TYPE_BUTTONS", "LINK_BUTTONS", "IMAGE_BUTTON", "BLOCK_TYPE_DROPDOWN", "HISTORY_BUTTONS"],
  INLINE_STYLE_BUTTONS: INLINE_STYLE_BUTTONS,
  BLOCK_ALIGNMENT_BUTTONS: BLOCK_ALIGNMENT_BUTTONS,
  BLOCK_TYPE_DROPDOWN: BLOCK_TYPE_DROPDOWN,
  BLOCK_TYPE_BUTTONS: BLOCK_TYPE_BUTTONS
};
var RichText = /*#__PURE__*/function (_React$Component) {
  function RichText(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      editorValue: null,
      mode: "rich"
    };
    _this.RichTextEditor = null;
    return _this;
  }
  _inheritsLoose(RichText, _React$Component);
  var _proto = RichText.prototype;
  _proto.componentDidMount = function componentDidMount() {
    this.RichTextEditor = require("@dock365/react-rte")["default"];
    this.setState({
      plainValue: this.props.value,
      editorValue: this.RichTextEditor.createValueFromString(this.props.value, "html")
    });
  };
  _proto.onChange = function onChange(editorValue) {
    var onChange = this.props.onChange;
    this.setState({
      editorValue: editorValue
    }, function () {
      if (onChange) onChange(editorValue.toString("html"));
    });
  };
  _proto.updatePlainValue = function updatePlainValue(plainValue) {
    var onChange = this.props.onChange;
    this.setState({
      plainValue: plainValue,
      editorValue: this.RichTextEditor.createValueFromString(plainValue, "html")
    }, function () {
      if (onChange) onChange(plainValue);
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      _this$props$label = _this$props.label,
      label = _this$props$label === void 0 ? "Text" : _this$props$label,
      _this$props$placehold = _this$props.placeholder,
      placeholder = _this$props$placehold === void 0 ? "" : _this$props$placehold,
      toolbarConfig = _this$props.toolbarConfig,
      editorClassName = _this$props.editorClassName;
    var _this$state = this.state,
      editorValue = _this$state.editorValue,
      plainValue = _this$state.plainValue,
      mode = _this$state.mode;
    var RichTextEditor = this.RichTextEditor;
    var activeStyle = {
      marginRight: 0,
      backgroundColor: "#000",
      color: "#fff",
      padding: "0.25rem 0.5rem"
    };
    var inactiveStyle = {
      marginRight: 0,
      backgroundColor: "#fff",
      color: "#000",
      padding: "0.25rem 0.5rem"
    };
    var tbConfig = TOOLBAR_CONFIG;
    if (toolbarConfig) {
      tbConfig = Object.assign(Object.assign({}, TOOLBAR_CONFIG), toolbarConfig);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, mode === "rich" && /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), RichTextEditor && /*#__PURE__*/React.createElement(RichTextEditor, {
      editorClassName: editorClassName,
      value: editorValue,
      onChange: function onChange(v) {
        return _this2.onChange(v);
      },
      toolbarConfig: tbConfig
    })), mode === "html" && /*#__PURE__*/React.createElement(TextArea$2, {
      label: label,
      placeholder: placeholder,
      value: plainValue,
      onChange: function onChange(v) {
        return _this2.updatePlainValue(v);
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        marginBottom: "14px",
        marginTop: "-14px"
      }
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      sm: true,
      onClick: function onClick() {
        return _this2.setState({
          mode: "rich"
        });
      },
      style: mode === "rich" ? activeStyle : inactiveStyle
    }, "Rich"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      sm: true,
      onClick: function onClick() {
        return _this2.setState({
          mode: "html"
        });
      },
      style: mode === "html" ? activeStyle : inactiveStyle
    }, "HTML")));
  };
  return RichText;
}(React.Component);
var toolbarConfig = {
  BLOCK_TYPE_DROPDOWN: [{
    label: "Normal",
    style: "unstyled"
  }, {
    label: "H1",
    style: "header-one"
  }, {
    label: "H2",
    style: "header-two"
  }, {
    label: "H3",
    style: "header-three"
  }, {
    label: "Code Block",
    style: "code-block"
  }]
};
var RTE = function RTE(props) {
  return /*#__PURE__*/React.createElement(RaketaUIProvider, null, /*#__PURE__*/React.createElement(RichText, _extends({
    toolbarConfig: toolbarConfig,
    editorClassName: "rich-editor-preview"
  }, props)));
};
var Row = function Row(_ref) {
  var text = _ref.text,
    title = _ref.title;
  var _React$useState = React.useState(false),
    isOpen = _React$useState[0],
    setIsOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "accordion-row " + (isOpen ? "row-show" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-row-visible",
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-11"
  }, /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, title))), /*#__PURE__*/React.createElement("div", {
    className: "col-1 col-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-minus"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "accordion-row-hidden",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};
var Widget = function Widget(_ref2) {
  var list = _ref2.list,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "accordion"
  }, list.map(function (row, idx) {
    return /*#__PURE__*/React.createElement(Row, {
      key: idx,
      title: row.title,
      text: row.text
    });
  })))));
};
var Config = {
  title: "Accordion",
  category: "Text"
};
var Defaults = {
  list: [{
    title: "Row Title",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestiae iste hic in dignissimos numquam rem. Sequi voluptatem amet asperiores autem error, repellat facilis, vitae perspiciatis maiores incidunt saepe provident corporis."
  }, {
    title: "Row Title",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestiae iste hic in dignissimos numquam rem. Sequi voluptatem amet asperiores autem error, repellat facilis, vitae perspiciatis maiores incidunt saepe provident corporis."
  }, {
    title: "Row Title",
    text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestiae iste hic in dignissimos numquam rem. Sequi voluptatem amet asperiores autem error, repellat facilis, vitae perspiciatis maiores incidunt saepe provident corporis."
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var RowField = function RowField(_ref3) {
  var _ref3$settings = _ref3.settings,
    settings = _ref3$settings === void 0 ? {} : _ref3$settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Text",
    value: settings.text,
    onChange: function onChange(value) {
      return onChangeItem("text", value);
    }
  }));
};
var Admin = function Admin(items, onChange) {
  return /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(RowField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items,
    template: {
      title: "Row Title",
      text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestiae iste hic in dignissimos numquam rem. Sequi voluptatem amet asperiores autem error, repellat facilis, vitae perspiciatis maiores incidunt saepe provident corporis."
    },
    primaryField: "title"
  });
};
var AccordionWidget = {
  __proto__: null,
  Widget: Widget,
  Admin: Admin,
  Config: Config,
  Defaults: Defaults
};
var A = function (props) {
  return /*#__PURE__*/React.createElement("a", props);
};
var _excluded = ["children"];
var Slider = function Slider(_ref) {
  var children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Swiper, props, children);
};
var Query = function (props) {
  var _useQuery = useQuery(props.query, {
      variables: props.variables
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  return props.children({
    error: error,
    loading: loading,
    data: data || {}
  });
};
var _templateObject;
var ImageEntry = gql(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  fragment ImageEntry on Image {\n    image_library {\n      id\n      name\n    }\n    id\n    name\n    credits\n    width\n    height\n    url\n    thumb_url\n    urls {\n      original\n      thumb\n      gallery_masonry_horizontal\n      gallery_masonry_horizontal_wide\n      gallery_masonry_vertical\n      simple_image_slider\n      articles_2_columns\n      full_width_image\n      magazine_spotlight\n      single_image_horizontal\n      full_width_original\n      mobile_square\n    }\n  }\n"])));
var _templateObject$1;
var VIDEOS = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  query ($input: VideosInput) {\n    videos(input: $input) {\n      list {\n        id\n        title\n        asset_mp4_url\n        credits\n        cover {\n          ...ImageEntry\n        }\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$2;
var VIDEO = gql(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  query($input: IdInput!) {\n    video(input: $input) {\n      id\n      title\n      asset_mp4_url\n      credits\n      cover {\n        ...ImageEntry\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$3;
var PODCASTS = gql(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  query {\n    podcasts {\n      list {\n        id\n        title\n      }\n    }\n  }\n"])));
var _templateObject$4;
var PODCAST = gql(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  query($input: IdInput!) {\n    podcast(input: $input) {\n        source\n        episode_no\n        title\n        summary\n        publish_date\n        more_url\n        transcription\n        htmlID\n      }\n    }\n"])));
var _templateObject$5;
var PODCAST_FEED = gql(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  query($input: LimitInput) {\n    podcasts(input: $input) {\n      list {\n        source\n        episode_no\n        publish_date\n        title\n        summary\n        more_url\n        image {\n          ...ImageEntry\n        }\n        transcription\n        htmlID\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$6;
var MagazineCategoryEntry = gql(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  fragment MagazineCategoryEntry on MagazineCategory {\n    id\n    slug\n    name\n    url\n  }\n"])));
var _templateObject$7;
var ARTICLES = gql(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  query($input: ArticlesInput) {\n    articles(input: $input) {\n      list {\n        id\n        slug\n        title\n        description\n        publish_on\n        url\n        magazine_category {\n          ...MagazineCategoryEntry\n        }\n        image {\n          ...ImageEntry\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"])), ImageEntry, MagazineCategoryEntry);
var _templateObject$8;
var TAGS = gql(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  query {\n    tags {\n      list {\n        id\n        slug\n        name\n      }\n    }\n  }\n"])));
var _templateObject$9;
var PRODUCTS = gql(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  query {\n    products {\n      list {\n        id\n        slug\n        name\n      }\n    }\n  }\n"])));
var _templateObject$a;
var MAGAZINE_CATEGORIES = gql(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n  query {\n    magazineCategories {\n      list {\n        ...MagazineCategoryEntry\n      }\n    }\n  }\n  ", "\n"])), MagazineCategoryEntry);
var _templateObject$b;
var EVENTS = gql(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  query {\n    events {\n      list {\n        id\n        title\n        start_on\n      }\n    }\n  }\n"])));
var _templateObject$c;
var EVENT = gql(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  query($input: IdInput!) {\n    event(input: $input) {\n      id\n      title\n      event_days {\n        id\n        title\n        default_day\n        identifier\n        timeslots {\n          id\n          start_time\n          end_time\n          duration\n          title\n          description\n          tags {\n            id\n            name\n            color\n          }\n          speakers {\n            id\n            first_name\n            last_name\n            company\n            company_website\n            position\n            bio\n            image {\n              ...ImageEntry\n            }\n          }\n          image {\n            ...ImageEntry\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$d;
var POPULAR_TAGS = gql(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  query($input: TagsInput) {\n    tags(input: $input) {\n      list {\n        id\n        name\n        color\n      }\n    }\n  }\n"])));
var _templateObject$e;
var COUNTRIES_ADN_GROUPS = gql(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  query {\n    countriesAndGroups {\n      countries {\n        list {\n          code\n          name\n        }\n      }\n      groups {\n        list {\n          id\n          name\n          countries\n        }\n      }\n    }\n  }\n"])));
var _templateObject$f;
var TESTIMONIALS = gql(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  query($input: TestimonialsInput) {\n    testimonials(input: $input) {\n      list {\n        id\n        name\n        company\n        position\n        content\n        image {\n          ...ImageEntry\n        }\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$g;
var PAGE_COLLECTIONS = gql(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n  query {\n    pageCollections {\n      list {\n        id\n        name\n        items {\n          id\n          title\n          description\n          anchor\n          page_slug\n          page_url\n          image {\n            ...ImageEntry\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$h;
var PAGE_COLLECTION = gql(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  query($input: PageCollectionInput!) {\n    pageCollection(input: $input) {\n      id\n      name\n      items {\n        id\n        title\n        description\n        anchor\n        page_slug\n        page_url\n        image {\n          ...ImageEntry\n        }\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$i;
var COUNTRIES = gql(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n  query {\n    countries {\n      list {\n        code\n        name\n      }\n    }\n  }\n"])));
var _templateObject$j;
var GALLERIES_MINIMAL = gql(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n  query($input: GalleriesInput) {\n    galleries(input: $input) {\n      list {\n        id\n        name\n      }\n    }\n  }\n"])));
var _templateObject$k;
var GALLERIES = gql(_templateObject$k || (_templateObject$k = _taggedTemplateLiteralLoose(["\n  query($input: GalleriesInput) {\n    galleries(input: $input) {\n      list {\n        id\n        name\n        slug\n        visible\n        status\n        url\n        image {\n          image_library {\n            id\n            name\n          }\n          id\n          name\n          width\n          height\n          url\n          credits\n          thumb_url\n          urls {\n            original\n            thumb\n            gallery_masonry_horizontal\n            gallery_masonry_horizontal_wide\n            gallery_masonry_vertical\n            simple_image_slider\n            articles_2_columns\n            full_width_image\n            magazine_spotlight\n            single_image_horizontal\n            full_width_original\n            mobile_square\n          }\n        }\n        author {\n          id\n          name\n        }\n        industry {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
var _templateObject$l;
var GALLERY = gql(_templateObject$l || (_templateObject$l = _taggedTemplateLiteralLoose(["\n  query($input: IdInput!) {\n    gallery(input: $input) {\n      id\n      name\n      slug\n      visible\n      status\n      url\n      image {\n        image_library {\n          id\n          name\n        }\n        id\n        name\n        width\n        height\n        url\n        thumb_url\n        urls {\n          original\n          thumb\n          gallery_masonry_horizontal\n          gallery_masonry_horizontal_wide\n          gallery_masonry_vertical\n          simple_image_slider\n          articles_2_columns\n          full_width_image\n          magazine_spotlight\n          single_image_horizontal\n          full_width_original\n          mobile_square\n        }\n      }\n      author {\n        id\n        name\n      }\n      industry {\n        id\n        name\n      }\n    }\n  }\n"])));
var _templateObject$m;
var TESTIMONIAL = gql(_templateObject$m || (_templateObject$m = _taggedTemplateLiteralLoose(["\n  query($input: IdInput!) {\n    testimonial(input: $input) {\n      id\n      name\n      company\n      position\n      content\n      image {\n        ...ImageEntry\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$n;
var CountryEntry = gql(_templateObject$n || (_templateObject$n = _taggedTemplateLiteralLoose(["\n  fragment CountryEntry on Country {\n    code\n    name\n  }\n"])));
var _templateObject$o;
var ProductEntry = gql(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose(["\n  fragment ProductEntry on Product {\n    id\n    slug\n    name\n    store_link\n  }\n"])));
var _templateObject$p;
var MENTORS = gql(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose(["\n  query {\n    mentors {\n      list {\n        id\n        name\n        image {\n          ...ImageEntry\n        }\n        country {\n          ...CountryEntry\n        }\n        city\n        description\n        email\n        phone\n        website\n        product {\n          ...ProductEntry\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"])), ImageEntry, CountryEntry, ProductEntry);
var _templateObject$q;
var TRAINING_PRODUCTS = gql(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose(["\n  query($input: TrainingProductsInput) {\n    trainingProducts(input: $input) {\n      list {\n        id\n        name\n        slug\n        productRef\n        prices\n        addon_prices\n      }\n    }\n  }\n"])));
var _templateObject$r;
var PackagePricingCardEntry = gql(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose(["\n  fragment PackagePricingCardEntry on PackagePricingCard {\n    id\n    name\n    title\n    sub_title\n    description\n    unit\n    button\n    prices\n    promo_prices\n    promo_title\n    promo_active\n    ratePlanDetails\n    quantity\n    type\n    bubbleText\n    vatDisclaimer\n  }\n"])));
var _templateObject$s;
var PACKAGE_PRICING_CARDS = gql(_templateObject$s || (_templateObject$s = _taggedTemplateLiteralLoose(["\n  query ($input: PackagePricingCardsInput) {\n    packagePricingCards(input: $input) {\n      list {\n        ...PackagePricingCardEntry\n      }\n    }\n  }\n  ", "\n"])), PackagePricingCardEntry);
var _templateObject$t;
var MINI_PACKAGE_PRICING_CARDS = gql(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose(["\n  query {\n    packagePricingCards {\n      list {\n        id\n        name\n        title\n      }\n    }\n  }\n"])));
var _templateObject$u;
var PACKAGE_PRICING_TABS = gql(_templateObject$u || (_templateObject$u = _taggedTemplateLiteralLoose(["\n  query ($input: PackagePricingTabsInput) {\n    packagePricingTabs(input: $input) {\n      list {\n        id\n        name\n        tabCards {\n          id\n          ord\n          ribbonText\n          card {\n            ...PackagePricingCardEntry\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), PackagePricingCardEntry);
var _templateObject$v;
var MINI_PACKAGE_PRICING_TABS = gql(_templateObject$v || (_templateObject$v = _taggedTemplateLiteralLoose(["\n  query {\n    miniPackagePricingTabs {\n      list {\n        id\n        name\n      }\n    }\n  }\n"])));
var _templateObject$w;
var FORMS = gql(_templateObject$w || (_templateObject$w = _taggedTemplateLiteralLoose(["\n  query {\n    forms {\n      list {\n        id\n        name\n      }\n    }\n  }\n"])));
var _templateObject$x;
var FORM = gql(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose(["\n  query ($input: IdInput!) {\n    form(input: $input) {\n      id\n      name\n      form_url\n      submit_button\n      fields\n      show_captcha\n      alwaysShowCaptcha\n      show_privacy\n      show_subscribe\n      active\n      disclaimer\n      submissionType\n    }\n  }\n"])));
var _templateObject$y;
var PRICELISTS = gql(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose(["\n  query {\n    pricelists {\n      list {\n        id\n        name\n        slug\n        active\n        items {\n          id\n          pricingType\n          pricingTypeLabel\n          minQuantity\n          pricingType\n          prices\n          promoPrices\n          product {\n            ...ProductEntry\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), ProductEntry);
var _templateObject$z;
var PRICELIST = gql(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n  query($input: IdInput!) {\n    pricelist(input: $input) {\n      id\n      name\n      slug\n      active\n      items {\n        id\n        pricingType\n        pricingTypeLabel\n        minQuantity\n        pricingType\n        prices\n        promoPrices\n        product {\n          ...ProductEntry\n        }\n      }\n    }\n  }\n  ", "\n"])), ProductEntry);
var _templateObject$A;
var FEATURED_PRICING_TABS = gql(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n  query ($input: FeaturedPricingTabsInput) {\n    featuredPricingTabs(input: $input) {\n      list {\n        id\n        name\n        title\n        items {\n          id\n          title\n          description\n          link\n          image {\n            ...ImageEntry\n          }\n        }\n        tabCards {\n          id\n          card {\n            id\n            name\n            title\n            subTitle\n            infoTitle\n            features\n            vatDisclaimer\n            additionalDisclaimer\n            hideSwitch\n            items {\n              id\n              default\n              title\n              pricingType\n              priceDisplayType\n              priceLabel\n              priceDescription\n              pricePromoDescription\n              description\n              ribbon\n              ribbonTheme\n              discountNote\n              promoNote\n              ratePlanDetails\n              button\n              buttonDescription\n              prices\n            }\n          }\n        }\n      }\n    }\n  }\n  ", "\n"])), ImageEntry);
var _templateObject$B;
var MINI_FEATURED_PRICING_TABS = gql(_templateObject$B || (_templateObject$B = _taggedTemplateLiteralLoose(["\n  query {\n    miniFeaturedPricingTabs {\n      list {\n        id\n        name\n        title\n      }\n    }\n  }\n"])));
var _templateObject$C;
var MINI_PACKAGE_PRICES = gql(_templateObject$C || (_templateObject$C = _taggedTemplateLiteralLoose(["\n  query {\n    miniPackagePrices {\n      list {\n        id\n        name\n      }\n    }\n  }\n"])));
var _templateObject$D;
var MINI_FEATURED_PRICING_CARDS = gql(_templateObject$D || (_templateObject$D = _taggedTemplateLiteralLoose(["\n  query {\n    miniFeaturedPricingCards {\n      list {\n        id\n        name\n        title\n        items {\n          id\n          title\n        }\n      }\n    }\n  }\n"])));
var _templateObject$E;
var PACKAGE_PRICES = gql(_templateObject$E || (_templateObject$E = _taggedTemplateLiteralLoose(["\n  query ($input: PackagePricesInput) {\n    packagePrices(input: $input) {\n      list {\n        id\n        name\n        prices\n        promo_prices\n        promo_title\n        promo_active\n        quantity\n        ratePlanDetails\n      }\n    }\n  }\n"])));
var _templateObject$F;
var FEATURED_PRICING_CARDS = gql(_templateObject$F || (_templateObject$F = _taggedTemplateLiteralLoose(["\n  query ($input: FeaturedPricingCardsInput) {\n    featuredPricingCards(input: $input) {\n      list {\n        id\n        name\n        title\n        infoTitle\n        items {\n          id\n          default\n          title\n          pricingType\n          priceDisplayType\n          priceLabel\n          priceDescription\n          pricePromoDescription\n          description\n          ribbon\n          ribbonTheme\n          discountNote\n          promoNote\n          button\n          prices\n          buttonDescription\n          ratePlanDetails\n        }\n      }\n    }\n  }\n"])));
var _templateObject$G;
var UPSELL_CAMPAIGN = gql(_templateObject$G || (_templateObject$G = _taggedTemplateLiteralLoose(["\n  query ($input: UpsellCampaignInput!) {\n    upsellCampaign(input: $input) {\n      id\n      closeable\n      name\n      ratePlanId\n      ratePlanDetails\n      upsellDetails\n      crossSellDetails\n    }\n  }\n"])));
var _templateObject$H, _templateObject2;
var PRICING = gql(_templateObject$H || (_templateObject$H = _taggedTemplateLiteralLoose(["\n  query ($input: PricingInput!) {\n    pricing(input: $input) {\n      list\n      disclaimer\n      additionalDisclaimer\n    }\n  }\n"])));
var DOUBLE_PRICING = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  query ($input1: PricingInput!, $input2: PricingInput!) {\n    page1: pricing(input: $input1) {\n      list\n      disclaimer\n      additionalDisclaimer\n    }\n\n    page2: pricing(input: $input2) {\n      list\n      disclaimer\n      additionalDisclaimer\n    }\n  }\n"])));
var _templateObject$I;
var GALLERY$1 = gql(_templateObject$I || (_templateObject$I = _taggedTemplateLiteralLoose(["\n  query ($input: SlugInput!) {\n    screensGallery(input: $input) {\n      navigation {\n        previous {\n          id\n          slug\n          name\n        }\n        next {\n          id\n          slug\n          name\n        }\n      }\n      related_galleries {\n        id\n        name\n        description\n        slug\n        visible\n        status\n        url\n        author {\n          id\n          name\n          slug\n        }\n        industry {\n          id\n          name\n          slug\n        }\n        image {\n          ...ImageEntry\n        }\n      }\n      gallery {\n        id\n        name\n        description\n        slug\n        visible\n        status\n        url\n        author {\n          id\n          name\n          slug\n        }\n        industry {\n          id\n          name\n          slug\n        }\n        image {\n          ...ImageEntry\n        }\n        gallery_images {\n          id\n          alt\n          video_url\n          urls {\n            original\n            thumb\n            gallery_masonry_horizontal\n            gallery_masonry_horizontal_wide\n            gallery_masonry_vertical\n            gallery_image\n          }\n        }\n        products {\n          ...ProductEntry\n        }\n      }\n    }\n  }\n  ", "\n  ", "\n"])), ImageEntry, ProductEntry);
var Checkbox = function Checkbox(_ref) {
  var name = _ref.name,
    isChecked = _ref.isChecked,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("label", {
    style: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      marginBottom: "0.5em"
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    onChange: function onChange(e) {
      return _onChange(e.target.checked);
    },
    checked: isChecked,
    style: {
      marginRight: "0.5em"
    }
  }), /*#__PURE__*/React.createElement("span", {
    style: {
      color: "#000"
    }
  }, name));
};
var _labelStyles;
var checkboxesHeader = {
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center"
};
var labelStyles = (_labelStyles = {
  padding: 0,
  margin: 0,
  boxSizing: "border-box",
  fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  fontSize: "16px",
  lineHeight: "1.5",
  color: "#000",
  fontWeight: "normal",
  backgroundColor: "transparent",
  display: "block",
  marginBottom: "1.6px",
  textTransform: "uppercase"
}, _labelStyles["fontWeight"] = "bold", _labelStyles["fontSize"] = "12px", _labelStyles.cursor = "pointer", _labelStyles["color"] = "#000", _labelStyles);
var actionButton = {
  fontSize: "16px",
  cursor: "pointer",
  marginLeft: "0.5em",
  color: "rgb(0,102,221)",
  backgroundColor: "transparent",
  border: "none"
};
var checkboxesListWrapper = {
  maxHeight: "200px",
  overflowY: "auto",
  padding: "0.5em",
  border: "solid 1px #ddd",
  borderRadius: 3
};
var GroupCheckboxHeader = function GroupCheckboxHeader(_ref) {
  var label = _ref.label,
    onSelectAll = _ref.onSelectAll,
    onSelectNone = _ref.onSelectNone;
  return /*#__PURE__*/React.createElement("div", {
    style: checkboxesHeader
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "",
    style: labelStyles
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "actions"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onSelectAll();
    },
    style: actionButton
  }, "All"), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onSelectNone();
    },
    style: actionButton
  }, "None")));
};
var GroupCheckbox = /*#__PURE__*/function (_React$Component) {
  function GroupCheckbox(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.selectAll = function () {
      var _this$props = _this.props,
        checkboxes = _this$props.checkboxes,
        onChange = _this$props.onChange;
      var newCheckboxes = checkboxes.map(function (checkbox) {
        return checkbox[0];
      });
      _this.setState({
        selectedCheckboxes: newCheckboxes
      }, function () {
        var selectedCheckboxes = _this.state.selectedCheckboxes;
        onChange(selectedCheckboxes);
      });
    };
    _this.selectNone = function () {
      _this.setState({
        selectedCheckboxes: []
      }, function () {
        _this.props.onChange([]);
      });
    };
    _this.state = {
      selectedCheckboxes: _this.props.value || []
    };
    return _this;
  }
  _inheritsLoose(GroupCheckbox, _React$Component);
  var _proto = GroupCheckbox.prototype;
  _proto.addValue = function addValue(id) {
    var _this2 = this;
    var _this$props2 = this.props,
      checkboxes = _this$props2.checkboxes,
      onChange = _this$props2.onChange;
    var selectedCheckboxes = this.state.selectedCheckboxes;
    var selectedCheckbox = checkboxes.find(function (checkbox) {
      return checkbox[0] === id;
    })[0];
    var newCheckboxes = [].concat(selectedCheckboxes, [selectedCheckbox]);
    this.setState({
      selectedCheckboxes: newCheckboxes
    }, function () {
      var selectedCheckboxes = _this2.state.selectedCheckboxes;
      onChange(selectedCheckboxes);
    });
  };
  _proto.removeValue = function removeValue(id) {
    var _this3 = this;
    var selectedCheckboxes = this.state.selectedCheckboxes;
    var newCheckboxes = selectedCheckboxes.filter(function (checkbox) {
      return checkbox !== id;
    });
    this.setState({
      selectedCheckboxes: newCheckboxes
    }, function () {
      var selectedCheckboxes = _this3.state.selectedCheckboxes;
      _this3.props.onChange(selectedCheckboxes);
    });
  };
  _proto.isChecked = function isChecked(id) {
    var selectedCheckboxes = this.state.selectedCheckboxes;
    var isChecked = selectedCheckboxes.find(function (checkbox) {
      return checkbox === id;
    });
    return isChecked ? true : false;
  };
  _proto.handleChange = function handleChange(value, id) {
    value ? this.addValue(id) : this.removeValue(id);
  };
  _proto.renderCheckboxes = function renderCheckboxes() {
    var _this4 = this;
    return this.props.checkboxes.map(function (checkbox) {
      return /*#__PURE__*/React.createElement(Checkbox, {
        key: checkbox[0],
        id: checkbox[0],
        name: checkbox[1],
        onChange: function onChange(value) {
          return _this4.handleChange(value, checkbox[0]);
        },
        isChecked: _this4.isChecked(checkbox[0])
      });
    });
  };
  _proto.render = function render() {
    var label = this.props.label;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupCheckboxHeader, {
      label: label,
      onSelectAll: this.selectAll,
      onSelectNone: this.selectNone
    }), /*#__PURE__*/React.createElement("div", {
      style: checkboxesListWrapper
    }, this.renderCheckboxes()));
  };
  return GroupCheckbox;
}(React.Component);
var GeoIpPicker = /*#__PURE__*/function (_React$Component) {
  function GeoIpPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    if (props.value) {
      _this.state = {
        active: _this.props.value.active === true,
        activeCountries: _this.props.value.activeCountries,
        activeGroups: _this.props.value.activeGroups
      };
    } else {
      _this.state = {
        active: false,
        activeCountries: [],
        activeGroups: []
      };
    }
    return _this;
  }
  _inheritsLoose(GeoIpPicker, _React$Component);
  var _proto = GeoIpPicker.prototype;
  _proto.handleChange = function handleChange(field, value) {
    var _this$setState,
      _this2 = this;
    this.setState((_this$setState = {}, _this$setState[field] = value, _this$setState), function () {
      return _this2.props.onChange(_this2.state);
    });
  };
  _proto.handleActiveChange = function handleActiveChange(value) {
    var _this3 = this;
    this.setState({
      active: value
    }, function () {
      return _this3.props.onChange(_this3.state);
    });
  };
  _proto.render = function render() {
    var _this4 = this;
    var _this$state = this.state,
      activeCountries = _this$state.activeCountries,
      activeGroups = _this$state.activeGroups,
      active = _this$state.active;
    return /*#__PURE__*/React.createElement(Query, {
      query: COUNTRIES_ADN_GROUPS
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var _data$countriesAndGro = data.countriesAndGroups,
        countries = _data$countriesAndGro.countries,
        groups = _data$countriesAndGro.groups;
      var countriesOptions = countries.list.map(function (e) {
        return [e.code, e.name];
      });
      var groupsOptions = groups.list.map(function (e) {
        return [e.id, e.name];
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Checkbox, {
        name: "Display by geolocation",
        onChange: function onChange(value) {
          return _this4.handleActiveChange(value);
        },
        isChecked: active
      }), active && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupCheckbox, {
        checkboxes: countriesOptions,
        label: "Display in these countries",
        onChange: function onChange(value) {
          return _this4.handleChange("activeCountries", value);
        },
        value: activeCountries
      }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(GroupCheckbox, {
        checkboxes: groupsOptions,
        label: "Display in these groups",
        onChange: function onChange(value) {
          return _this4.handleChange("activeGroups", value);
        },
        value: activeGroups
      })));
    });
  };
  return GeoIpPicker;
}(React.Component);
var buildClient = function buildClient(url) {
  return new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      uri: url,
      fetch: fetch$1
    })
  });
};
var GraphQLProvider = function GraphQLProvider(_ref) {
  var gqlHost = _ref.gqlHost,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(ApolloProvider, {
    client: buildClient(gqlHost)
  }, children);
};
var FormsContext = /*#__PURE__*/React.createContext();
var FormsProvider = function FormsProvider(_ref) {
  var children = _ref.children,
    formsContext = _ref.formsContext;
  return /*#__PURE__*/React.createElement(FormsContext.Provider, {
    value: formsContext
  }, children);
};
var FormsConsumer = FormsContext.Consumer;
var GeoIpContext = /*#__PURE__*/React.createContext();
var GeoIpProvider = function GeoIpProvider(_ref) {
  var children = _ref.children,
    country = _ref.country,
    allGroups = _ref.allGroups;
  return /*#__PURE__*/React.createElement(GeoIpContext.Provider, {
    value: {
      country: country,
      allGroups: allGroups
    }
  }, children);
};
var countriesForGroups = function countriesForGroups(allGroups, groupIds) {
  return allGroups.map(function (group) {
    return groupIds.includes(group.id) ? group.countries : [];
  }).reduce(function (acum, x) {
    return acum.concat(x);
  }, []);
};
var GeoIpFilter = function GeoIpFilter(_ref2) {
  var children = _ref2.children,
    _ref2$countries = _ref2.countries,
    countries = _ref2$countries === void 0 ? [] : _ref2$countries,
    _ref2$countryGroupIds = _ref2.countryGroupIds,
    countryGroupIds = _ref2$countryGroupIds === void 0 ? [] : _ref2$countryGroupIds,
    _ref2$active = _ref2.active,
    active = _ref2$active === void 0 ? true : _ref2$active;
  return /*#__PURE__*/React.createElement(GeoIpContext.Consumer, null, function (value) {
    if (!active) {
      return children;
    }
    var country = value.country,
      allGroups = value.allGroups;
    var allowedCountries = countries.concat(countriesForGroups(allGroups, countryGroupIds.map(function (x) {
      return parseInt(x, 10);
    })));
    if (allowedCountries.includes(country)) {
      return children;
    }
    return null;
  });
};
var useGeoIpFilterCheck = function useGeoIpFilterCheck(_ref3) {
  var _ref3$activeCountries = _ref3.activeCountries,
    activeCountries = _ref3$activeCountries === void 0 ? [] : _ref3$activeCountries,
    _ref3$countryGroupIds = _ref3.countryGroupIds,
    countryGroupIds = _ref3$countryGroupIds === void 0 ? [] : _ref3$countryGroupIds,
    _ref3$active = _ref3.active,
    active = _ref3$active === void 0 ? false : _ref3$active,
    localizationCountry = _ref3.localizationCountry;
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country,
    _React$useContext$all = _React$useContext.allGroups,
    allGroups = _React$useContext$all === void 0 ? [] : _React$useContext$all;
  if (!active) {
    return true;
  }
  var allowedCountries = activeCountries.concat(countriesForGroups(allGroups, countryGroupIds));
  var currentCountry = localizationCountry || country;
  if (allowedCountries.includes(currentCountry)) {
    return true;
  }
  return false;
};
var CurrencyContext = /*#__PURE__*/React.createContext();
var CurrencyProvider = function CurrencyProvider(_ref) {
  var children = _ref.children,
    currency = _ref.currency;
  return /*#__PURE__*/React.createElement(CurrencyContext.Provider, {
    value: currency
  }, /*#__PURE__*/React.createElement("div", {
    className: "currency-" + currency
  }, children));
};
var CountriesContext = /*#__PURE__*/React.createContext();
var CountriesProvider = function CountriesProvider(_ref) {
  var children = _ref.children,
    allCountries = _ref.allCountries;
  return /*#__PURE__*/React.createElement(CountriesContext.Provider, {
    value: allCountries
  }, children);
};
var CountriesConsumer = CountriesContext.Consumer;
var PageUrlContext = /*#__PURE__*/React.createContext();
var PageUrlProvider = function PageUrlProvider(_ref) {
  var children = _ref.children,
    url = _ref.url;
  return /*#__PURE__*/React.createElement(PageUrlContext.Provider, {
    value: url
  }, children);
};
var PageUrlConsumer = PageUrlContext.Consumer;
var CaptchaContext = /*#__PURE__*/React.createContext();
var CaptchaProvider = function CaptchaProvider(_ref) {
  var children = _ref.children,
    captchaContext = _ref.captchaContext;
  return /*#__PURE__*/React.createElement(CaptchaContext.Provider, {
    value: captchaContext
  }, children);
};
var CaptchaConsumer = CaptchaContext.Consumer;
var AdminUserContext = /*#__PURE__*/React.createContext();
var AdminUserProvider = function AdminUserProvider(_ref) {
  var children = _ref.children,
    isAdmin = _ref.isAdmin;
  return /*#__PURE__*/React.createElement(AdminUserContext.Provider, {
    value: isAdmin
  }, children);
};
var CartContext = /*#__PURE__*/React.createContext();
var CartProvider = function CartProvider(_ref) {
  var children = _ref.children,
    cart = _ref.cart;
  return /*#__PURE__*/React.createElement(CartContext.Provider, {
    value: cart
  }, children);
};
var LocaleContext = /*#__PURE__*/React.createContext();
var LocaleProvider = function LocaleProvider(_ref) {
  var children = _ref.children,
    locale = _ref.locale;
  return /*#__PURE__*/React.createElement(LocaleContext.Provider, {
    value: locale
  }, children);
};
var LocaleConsumer = LocaleContext.Consumer;
var HubSpotContext = /*#__PURE__*/React.createContext({
  api_domain: "",
  property: "",
  skipDomains: ["chaos.com"]
});
var ResellersContext = /*#__PURE__*/React.createContext({
  api_domain: ""
});
var LocalizationUrlContext = /*#__PURE__*/React.createContext("");
var Logo = function Logo(_ref) {
  var container_width = _ref.container_width,
    container_min_width = _ref.container_min_width,
    container_height = _ref.container_height,
    width = _ref.width,
    image = _ref.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "logo",
    style: {
      width: container_width,
      height: container_height,
      minWidth: container_min_width
    }
  }, /*#__PURE__*/React.createElement(Img, {
    src: image,
    variant: "image",
    className: "image",
    style: {
      width: width
    }
  }));
};
var LinkLogo = function LinkLogo(_ref2) {
  var container_width = _ref2.container_width,
    container_min_width = _ref2.container_min_width,
    container_height = _ref2.container_height,
    width = _ref2.width,
    image = _ref2.image,
    linkSettings = _ref2.linkSettings;
  var label = linkSettings.label,
    link = linkSettings.link,
    id = linkSettings.id,
    target = linkSettings.target,
    className = linkSettings.className,
    rel = linkSettings.rel;
  return /*#__PURE__*/React.createElement(A, {
    href: link,
    id: id ? id : "",
    target: target,
    rel: rel,
    title: label,
    className: "logo " + className,
    style: {
      width: container_width,
      height: container_height,
      minWidth: container_min_width
    }
  }, /*#__PURE__*/React.createElement(Img, {
    src: image,
    variant: "image",
    className: "image",
    style: {
      width: width
    }
  }));
};
var Item = function Item(_ref3) {
  var container_width = _ref3.container_width,
    container_min_width = _ref3.container_min_width,
    container_height = _ref3.container_height,
    width = _ref3.width,
    link = _ref3.link,
    image = _ref3.image;
  if (link.link) {
    return /*#__PURE__*/React.createElement(LinkLogo, {
      container_width: container_width,
      container_height: container_height,
      container_min_width: container_min_width,
      width: width,
      image: image,
      linkSettings: link
    });
  }
  return /*#__PURE__*/React.createElement(Logo, {
    container_width: container_width,
    container_height: container_height,
    container_min_width: container_min_width,
    width: width,
    image: image
  });
};
var Widget$1 = function Widget(_ref4) {
  var geoIp = _ref4.geoIp,
    container_width = _ref4.container_width,
    container_min_width = _ref4.container_min_width,
    container_height = _ref4.container_height,
    mobile_variant = _ref4.mobile_variant,
    list = _ref4.list,
    containerSettings = _ref4.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: (geoIp === null || geoIp === void 0 ? void 0 : geoIp.activeCountries) || [],
    countryGroupIds: (geoIp === null || geoIp === void 0 ? void 0 : geoIp.activeGroups) || [],
    active: (geoIp === null || geoIp === void 0 ? void 0 : geoIp.active) || false
  }, /*#__PURE__*/React.createElement("div", {
    className: "advanced-fluid-logos " + mobile_variant
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logos-inner"
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Item, _extends({
      key: idx,
      container_min_width: container_min_width,
      container_width: container_width,
      container_height: container_height
    }, item));
  })), mobile_variant === "one_row" && /*#__PURE__*/React.createElement("div", {
    className: "mobile-slider"
  }, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 30,
    paginationClickable: true,
    loop: true
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement(Item, _extends({
      key: idx,
      container_min_width: "100%",
      container_width: "100%",
      container_height: "100px"
    }, _extends({}, item, {
      width: "100%"
    }))));
  })))))));
};
var Config$1 = {
  title: "Logos (advanced)",
  category: "Logos"
};
var Defaults$1 = {
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  container_width: "25%",
  container_height: "200px",
  container_min_width: "250px",
  mobile_variant: "rows",
  list: [{
    id: 1,
    link: _extends({}, LinkSettings.defaults, {
      link: ""
    }),
    image: imagePlaceholder("400x300"),
    width: "50%"
  }, {
    id: 2,
    link: _extends({}, LinkSettings.defaults, {
      link: ""
    }),
    image: imagePlaceholder("300x300"),
    width: "50%"
  }, {
    id: 4,
    link: _extends({}, LinkSettings.defaults, {
      link: ""
    }),
    image: imagePlaceholder("400x400"),
    width: "50%"
  }, {
    id: 3,
    link: _extends({}, LinkSettings.defaults, {
      link: ""
    }),
    image: imagePlaceholder("400x400"),
    width: "50%"
  }],
  containerSettings: {
    spacing: "none"
  }
};
var ListItem = function ListItem(_ref5) {
  var settings = _ref5.settings,
    onChangeItem = _ref5.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    value: settings.link
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Width",
    onChange: function onChange(value) {
      return onChangeItem("width", value);
    },
    value: settings.width
  }));
};
var Admin$1 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GeoIpPicker, {
    onChange: function onChange(value) {
      return _onChange("geoIp", value);
    },
    value: settings.geoIp
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Container Width",
    onChange: function onChange(value) {
      return _onChange("container_width", value);
    },
    value: settings.container_width
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Container Minimum Width",
    onChange: function onChange(value) {
      return _onChange("container_min_width", value);
    },
    value: settings.container_min_width
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Container Height",
    onChange: function onChange(value) {
      return _onChange("container_height", value);
    },
    value: settings.container_height
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Mobile Variant",
    options: [["rows", "Default"], ["one_row", "Slider"]],
    value: settings.mobile_variant,
    onChange: function onChange(value) {
      return _onChange("mobile_variant", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    label: "Logos",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: items,
    template: {
      link: LinkSettings.defaults,
      image: imagePlaceholder("400x300"),
      width: "150px"
    },
    primaryField: "link.label",
    onChangeList: _onChange
  }));
};
var AdvancedFluidLogosWidget = {
  __proto__: null,
  Widget: Widget$1,
  Admin: Admin$1,
  Config: Config$1,
  Defaults: Defaults$1
};
var SimplePlaceholder = function SimplePlaceholder() {
  return /*#__PURE__*/React.createElement("p", null, "Loading...");
};
var DataLoader = function DataLoader(_ref) {
  var fetcher = _ref.fetcher,
    placeholder = _ref.placeholder,
    component = _ref.component,
    _ref$dryRun = _ref.dryRun,
    dryRun = _ref$dryRun === void 0 ? false : _ref$dryRun,
    _ref$useFetch = _ref.useFetch,
    useFetch = _ref$useFetch === void 0 ? false : _ref$useFetch;
  var _React$useState = React.useState({
      data: null,
      error: null
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  React.useEffect(function () {
    if (dryRun) return;
    if (useFetch) {
      fetcher().then(function (r) {
        return r.json();
      }).then(function (data) {
        return setState({
          data: data,
          error: null
        });
      })["catch"](function (error) {
        return setState({
          error: error,
          data: null
        });
      });
    } else {
      fetcher().then(function (data) {
        return setState({
          data: data,
          error: null
        });
      })["catch"](function (error) {
        return setState({
          error: error,
          data: null
        });
      });
    }
  }, [fetcher]);
  var data = state.data,
    error = state.error;
  var Placeholder = placeholder || SimplePlaceholder;
  if (!data && !error) {
    return /*#__PURE__*/React.createElement(Placeholder, null);
  }
  if (!data && error) {
    console.error(error);
    return /*#__PURE__*/React.createElement("p", null, "Error!");
  }
  if (data && !error) {
    return component({
      data: data
    });
  }
  throw "Should not get here...";
};
var RequiredMarkerContext = /*#__PURE__*/React.createContext({});
var _excluded$1 = ["label", "required"];
var Label = function Label(_ref) {
  var label = _ref.label,
    required = _ref.required,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var required_marker = React.useContext(RequiredMarkerContext);
  return /*#__PURE__*/React.createElement(FormsConsumer, null, function (value) {
    var i18n = value.i18n;
    if (required && required_marker === "star") {
      return /*#__PURE__*/React.createElement("label", props, label + " *");
    }
    if (!required && required_marker === "optional") {
      return /*#__PURE__*/React.createElement("label", props, label, " ", i18n.optional_label);
    }
    return /*#__PURE__*/React.createElement("label", props, label);
  });
};
var Input = function Input(_ref2) {
  var label = _ref2.label,
    placeholder = _ref2.placeholder,
    required = _ref2.required,
    name = _ref2.name,
    hidden = _ref2.hidden,
    defaultValue = _ref2.defaultValue,
    value = _ref2.value,
    onChange = _ref2.onChange;
  var inputOpts = {
    type: "text",
    placeholder: placeholder,
    className: "form-control",
    required: required,
    id: name,
    hidden: hidden,
    name: name
  };
  if (onChange) {
    inputOpts["value"] = value;
    inputOpts["onChange"] = function (e) {
      return onChange(e.target.value);
    };
  }
  if (defaultValue !== undefined) {
    inputOpts["defaultValue"] = defaultValue;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required,
    htmlFor: "form-country"
  }), /*#__PURE__*/React.createElement("input", inputOpts));
};
Input.defaultValue = function (defaultValue) {
  return defaultValue || "";
};
var Hidden = function Hidden(_ref3) {
  var required = _ref3.required,
    name = _ref3.name,
    hidden = _ref3.hidden,
    value = _ref3.value,
    onChange = _ref3.onChange,
    defaultValue = _ref3.defaultValue;
  var inputOpts = {
    type: "hidden",
    required: required,
    id: name,
    hidden: hidden,
    name: name
  };
  if (onChange) {
    inputOpts["value"] = value;
    inputOpts["onChange"] = function (e) {
      return onChange(e.target.value);
    };
  }
  if (defaultValue !== undefined) {
    inputOpts["defaultValue"] = defaultValue;
  }
  return /*#__PURE__*/React.createElement("input", inputOpts);
};
Hidden.defaultValue = function (defaultValue) {
  return defaultValue || "";
};
var Email = function Email(_ref4) {
  var label = _ref4.label,
    placeholder = _ref4.placeholder,
    required = _ref4.required,
    name = _ref4.name,
    hidden = _ref4.hidden,
    defaultValue = _ref4.defaultValue,
    value = _ref4.value,
    onChange = _ref4.onChange;
  var inputOpts = {
    type: "email",
    placeholder: placeholder,
    className: "form-control",
    name: name,
    required: required,
    id: name,
    hidden: hidden
  };
  if (onChange) {
    inputOpts["value"] = value;
    inputOpts["onChange"] = function (e) {
      return onChange(e.target.value);
    };
  }
  if (defaultValue !== undefined) {
    inputOpts["defaultValue"] = defaultValue;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required,
    htmlFor: "form-country"
  }), /*#__PURE__*/React.createElement("input", inputOpts));
};
Email.defaultValue = function (defaultValue) {
  return defaultValue || "";
};
var Checkbox$1 = function Checkbox(_ref5) {
  var label = _ref5.label,
    required = _ref5.required,
    hidden = _ref5.hidden,
    name = _ref5.name,
    defaultValue = _ref5.defaultValue,
    value = _ref5.value,
    onChange = _ref5.onChange;
  var inputOpts = {
    type: "checkbox",
    name: name,
    required: required,
    hidden: hidden
  };
  if (onChange) {
    inputOpts["checked"] = value;
    inputOpts["onChange"] = function (e) {
      return onChange(e.target.checked);
    };
  }
  if (defaultValue !== undefined) {
    inputOpts["defaultChecked"] = defaultValue;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper checkbox-wrapper " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("input", inputOpts), /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required
  })));
};
Checkbox$1.defaultValue = function (defaultValue) {
  return defaultValue || false;
};
var Select = function Select(_ref6) {
  var label = _ref6.label,
    _ref6$placeholder = _ref6.placeholder,
    placeholder = _ref6$placeholder === void 0 ? "Please select…" : _ref6$placeholder,
    required = _ref6.required,
    name = _ref6.name,
    hidden = _ref6.hidden,
    options = _ref6.options,
    defaultValue = _ref6.defaultValue,
    value = _ref6.value,
    onChange = _ref6.onChange;
  var inputOpts = {
    className: "form-control",
    name: name,
    required: required,
    id: name,
    hidden: hidden
  };
  if (onChange) {
    inputOpts["value"] = value;
    inputOpts["onChange"] = function (e) {
      return onChange(e.target.value);
    };
  }
  if (defaultValue !== undefined) {
    inputOpts["defaultValue"] = defaultValue;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required,
    htmlFor: "form-country"
  }), /*#__PURE__*/React.createElement("div", {
    className: "style-select"
  }, /*#__PURE__*/React.createElement("select", inputOpts, placeholder && /*#__PURE__*/React.createElement("option", {
    className: "placeholder",
    value: "",
    hidden: true
  }, placeholder), options.map(function (option, idx) {
    return /*#__PURE__*/React.createElement("option", {
      key: option.displayOrder + "-" + idx,
      value: option.value
    }, option.label);
  }))));
};
Select.defaultValue = function (defaultValue) {
  return defaultValue || "";
};
var TextArea = function TextArea(_ref7) {
  var label = _ref7.label,
    placeholder = _ref7.placeholder,
    required = _ref7.required,
    name = _ref7.name,
    hidden = _ref7.hidden,
    defaultValue = _ref7.defaultValue,
    value = _ref7.value,
    onChange = _ref7.onChange;
  var inputOpts = {
    name: name,
    placeholder: placeholder,
    required: required,
    id: name,
    hidden: hidden
  };
  if (onChange) {
    inputOpts["value"] = value;
    inputOpts["onChange"] = function (e) {
      return onChange(e.target.value);
    };
  }
  if (defaultValue !== undefined) {
    inputOpts["defaultValue"] = defaultValue;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required
  }), /*#__PURE__*/React.createElement("textarea", inputOpts));
};
TextArea.defaultValue = function (defaultValue) {
  return defaultValue || "";
};
var RadioButtons = function RadioButtons(_ref8) {
  var label = _ref8.label,
    required = _ref8.required,
    name = _ref8.name,
    options = _ref8.options,
    defaultValue = _ref8.defaultValue,
    value = _ref8.value,
    onChange = _ref8.onChange;
  var requiredInput = required && ((value === null || value === void 0 ? void 0 : value.length) || 0) === 0;
  var radioOpts = function radioOpts(radio) {
    var opts = {
      type: "radio",
      name: name,
      value: radio.value
    };
    if (onChange) {
      opts["checked"] = value.includes(radio.value);
      opts["onChange"] = function (e) {
        if (e.target.checked) {
          onChange([].concat(value, [radio.value]));
        } else {
          onChange(value.filter(function (val) {
            return val !== radio.value;
          }));
        }
      };
    }
    if (defaultValue !== undefined && !opts["value"]) {
      opts["defaultValue"] = defaultValue.includes(radio.value);
    }
    if (requiredInput) {
      opts["required"] = true;
    }
    return opts;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper radio-group " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required,
    htmlFor: name
  }), options.map(function (radio) {
    return /*#__PURE__*/React.createElement("label", {
      key: radio.value,
      className: "radio"
    }, /*#__PURE__*/React.createElement("input", radioOpts(radio)), radio.label);
  }));
};
RadioButtons.defaultValue = function (defaultValue) {
  if (!defaultValue) {
    return [];
  }
  if (Array.isArray(defaultValue)) {
    return defaultValue;
  }
  return [defaultValue];
};
var MultipleCheckboxes = function MultipleCheckboxes(_ref9) {
  var label = _ref9.label,
    required = _ref9.required,
    name = _ref9.name,
    options = _ref9.options,
    defaultValue = _ref9.defaultValue,
    value = _ref9.value,
    onChange = _ref9.onChange;
  var requiredInput = required && ((value === null || value === void 0 ? void 0 : value.length) || 0) === 0;
  var checkboxOpts = function checkboxOpts(checkbox) {
    var opts = {
      type: "checkbox",
      name: name,
      value: checkbox.value
    };
    if (onChange) {
      opts["checked"] = value.includes(checkbox.value);
      opts["onChange"] = function (e) {
        if (e.target.checked) {
          onChange([].concat(value, [checkbox.value]));
        } else {
          onChange(value.filter(function (val) {
            return val !== checkbox.value;
          }));
        }
      };
    }
    if (defaultValue !== undefined && !opts["value"]) {
      opts["defaultValue"] = defaultValue.includes(checkbox.value);
    }
    if (requiredInput) {
      opts["required"] = true;
    }
    return opts;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper checkbox-group " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required,
    htmlFor: name
  }), options.map(function (checkbox) {
    return /*#__PURE__*/React.createElement("label", {
      key: checkbox.value,
      className: "checkbox"
    }, /*#__PURE__*/React.createElement("input", checkboxOpts(checkbox)), checkbox.label);
  }));
};
MultipleCheckboxes.defaultValue = function (defaultValue) {
  if (!defaultValue) {
    return [];
  }
  if (Array.isArray(defaultValue)) {
    return defaultValue;
  }
  return [defaultValue];
};
var uploadFile = function uploadFile(domain, csrfToken, file, formId, name) {
  var formData = new FormData();
  formData.append("file[asset]", file);
  formData.append("authenticity_token", csrfToken);
  return fetch(domain + "/api/hubspot/forms/" + formId + "/files/" + name, {
    method: "POST",
    body: formData
  }).then(function (response) {
    return response.json();
  }).then(function (data) {
    return data.url;
  });
};
var File = function File(_ref10) {
  var label = _ref10.label,
    placeholder = _ref10.placeholder,
    required = _ref10.required,
    name = _ref10.name,
    allowMultipleFiles = _ref10.allowMultipleFiles,
    formId = _ref10.formId;
  var _React$useContext = React.useContext(HubSpotContext),
    api_domain = _React$useContext.api_domain,
    csrf_token = _React$useContext.csrf_token;
  var _React$useState = React.useState([]),
    fileUrls = _React$useState[0],
    setFileUrls = _React$useState[1];
  var _React$useState2 = React.useState(false),
    uploading = _React$useState2[0],
    setUploading = _React$useState2[1];
  var uploadFiles = function uploadFiles(event) {
    try {
      setUploading(true);
      var promises = [];
      for (var _iterator = _createForOfIteratorHelperLoose(event.target.files), _step; !(_step = _iterator()).done;) {
        var file = _step.value;
        promises.push(uploadFile(api_domain, csrf_token, file, formId, name));
      }
      return Promise.resolve(Promise.all(promises)).then(function (results) {
        setFileUrls([].concat(results));
        setUploading(false);
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper " + (required ? "required" : "")
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    required: required,
    htmlFor: "form-country"
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "file",
    placeholder: placeholder,
    className: "form-control",
    required: required,
    multiple: allowMultipleFiles,
    onChange: uploadFiles,
    disabled: uploading
  }), fileUrls.map(function (fileUrl) {
    return /*#__PURE__*/React.createElement("input", {
      key: fileUrl,
      type: "hidden",
      id: name,
      name: name,
      defaultValue: fileUrl,
      required: required
    });
  })));
};
File.defaultValue = function () {
  return "";
};
var CgCaptcha = /*#__PURE__*/function (_React$Component) {
  function CgCaptcha(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      captcha: {},
      verificationCode: "",
      isLoading: false,
      status: false,
      dirty: false
    };
    _this.setCaptcha();
    return _this;
  }
  _inheritsLoose(CgCaptcha, _React$Component);
  var _proto = CgCaptcha.prototype;
  _proto.setCaptcha = function setCaptcha() {
    var _this2 = this;
    var dirty = this.state.dirty;
    var wasDirty = dirty;
    jQuery.ajax({
      method: "GET",
      url: "/captcha/generate",
      dataType: "json",
      success: function success(captcha) {
        var status = false;
        var verificationCode = "";
        _this2.setState({
          captcha: captcha,
          status: status,
          verificationCode: verificationCode,
          dirty: false
        }, function () {
          if (wasDirty) _this2.props.verifyCallback(status, captcha.id, verificationCode);
        });
      }
    });
  };
  _proto.getInputProps = function getInputProps() {
    var i18n = this.props.i18n;
    var label = i18n.label;
    var success = i18n.success;
    var error = i18n.error;
    var _this$state = this.state,
      status = _this$state.status,
      dirty = _this$state.dirty;
    if (!dirty) {
      return {
        label: label,
        labelClass: "",
        inputClass: ""
      };
    }
    return {
      label: status ? success : error,
      labelClass: status ? "captcha-verified" : "captcha-invalid",
      inputClass: status ? "" : "input-error"
    };
  };
  _proto.validateCaptcha = function validateCaptcha(verificationCode) {
    var _this3 = this;
    var captcha = this.state.captcha;
    if (verificationCode.length === 6) {
      jQuery.ajax({
        method: "POST",
        beforeSend: function beforeSend(xhr) {
          xhr.setRequestHeader("X-CSRF-Token", jQuery('meta[name="csrf-token"]').attr("content"));
        },
        url: "/captcha/validate/" + captcha.id,
        data: {
          answer: verificationCode
        },
        dataType: "json",
        success: function success(verification) {
          var status = verification.status === "OK";
          _this3.setState({
            status: status,
            isLoading: false,
            dirty: true
          }, function () {
            _this3.props.verifyCallback(status, captcha.id, verificationCode);
          });
        }
      });
    } else {
      var status = false;
      this.setState({
        status: status,
        isLoading: false
      }, function () {
        _this3.props.verifyCallback(status, captcha.id, verificationCode);
      });
    }
  };
  _proto.handleChange = function handleChange(verificationCode) {
    var _this4 = this;
    this.setState({
      verificationCode: verificationCode
    }, function () {
      _this4.validateCaptcha(verificationCode);
    });
  };
  _proto.render = function render() {
    var _this5 = this;
    var _this$props = this.props,
      domain = _this$props.domain,
      i18n = _this$props.i18n;
    var _this$state2 = this.state,
      isLoading = _this$state2.isLoading,
      captcha = _this$state2.captcha,
      verificationCode = _this$state2.verificationCode;
    if (!captcha.image) return null;
    var _this$getInputProps = this.getInputProps(),
      label = _this$getInputProps.label,
      labelClass = _this$getInputProps.labelClass,
      inputClass = _this$getInputProps.inputClass;
    return /*#__PURE__*/React.createElement("div", {
      className: "cg-captcha"
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-wrapper"
    }, /*#__PURE__*/React.createElement("img", {
      src: "" + domain + captcha.image,
      alt: ""
    }), /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "btn-refresh",
      title: i18n.tooltip,
      onClick: function onClick() {
        return _this5.setCaptcha();
      }
    })), /*#__PURE__*/React.createElement("label", {
      className: labelClass
    }, label), /*#__PURE__*/React.createElement("div", {
      className: "form-compact"
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-field-wrapper"
    }, /*#__PURE__*/React.createElement("input", {
      type: "text",
      value: verificationCode,
      disabled: isLoading,
      maxLength: "6",
      className: inputClass,
      onChange: function onChange(e) {
        return _this5.handleChange(e.target.value);
      }
    }))));
  };
  return CgCaptcha;
}(React.Component);
var Captcha = function Captcha(_ref) {
  var _verifyCallback = _ref.verifyCallback;
  return /*#__PURE__*/React.createElement(CaptchaConsumer, null, function (value) {
    var locale = value.locale,
      recaptchaKey = value.recaptchaKey,
      domain = value.domain,
      i18n = value.i18n,
      country = value.country;
    return country === "CN" || country === "cn" ? /*#__PURE__*/React.createElement(CgCaptcha, {
      locale: locale,
      domain: domain,
      i18n: i18n,
      verifyCallback: function verifyCallback(status, captchaId, response) {
        return _verifyCallback(status, captchaId, response);
      }
    }) : /*#__PURE__*/React.createElement(Recaptcha, {
      sitekey: recaptchaKey,
      onChange: function onChange(response) {
        return _verifyCallback(response.length > 0, "google-recaptcha", response);
      }
    });
  });
};
var ExplicitConsent = function ExplicitConsent(_ref) {
  var options = _ref.options;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.communicationConsentText
    }
  }), options.communicationsCheckboxes.map(function (checkbox) {
    return /*#__PURE__*/React.createElement("label", {
      key: checkbox.subscriptionTypeId
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      required: checkbox.required,
      name: "LEGAL_CONSENT.subscription_type_" + checkbox.subscriptionTypeId
    }), " ", /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: checkbox.label
      }
    }));
  }), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.consentToProcessText
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom-sm"
  }, /*#__PURE__*/React.createElement("label", {
    className: "checkbox"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    required: true
  }), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.consentToProcessCheckboxLabel
    }
  }), "*")), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.privacyText
    }
  }));
};
var ImplicitConsent = function ImplicitConsent(_ref2) {
  var options = _ref2.options;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.communicationConsentText
    }
  }), options.communicationsCheckboxes.map(function (checkbox) {
    return /*#__PURE__*/React.createElement("label", {
      key: checkbox.subscriptionTypeId,
      className: "checkbox"
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      required: checkbox.required,
      name: "LEGAL_CONSENT.subscription_type_" + checkbox.subscriptionTypeId
    }), /*#__PURE__*/React.createElement("p", {
      dangerouslySetInnerHTML: {
        __html: checkbox.label
      }
    }));
  }), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.privacyText
    }
  }), /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.consentToProcessText
    }
  }));
};
var LegitimateInterest = function LegitimateInterest(_ref3) {
  var options = _ref3.options;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: options.privacyText
    }
  }));
};
var Consent = function Consent(_ref4) {
  var options = _ref4.options;
  if (options.type === "explicit_consent_to_process") return /*#__PURE__*/React.createElement(ExplicitConsent, {
    options: options
  });
  if (options.type === "implicit_consent_to_process") return /*#__PURE__*/React.createElement(ImplicitConsent, {
    options: options
  });
  if (options.type === "legitimate_interest") return /*#__PURE__*/React.createElement(LegitimateInterest, {
    options: options
  });
  return null;
};
var FormCaptcha = function FormCaptcha(_ref5) {
  var onChange = _ref5.onChange;
  var _React$useState = React.useState({
      captchaResult: "",
      requestId: ""
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "captcha-wrapper"
  }, /*#__PURE__*/React.createElement(Captcha, {
    verifyCallback: function verifyCallback(status, captchaId, response) {
      onChange(status);
      setState({
        captchaResult: response,
        requestId: captchaId
      });
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "g-req-id",
    value: state.requestId
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "g-recaptcha-response",
    value: state.captchaResult
  })));
};
var PrefilledFields = function PrefilledFields() {
  var _React$useContext = React.useContext(HubSpotContext),
    property = _React$useContext.property,
    http_referer = _React$useContext.http_referer;
  var _React$useContext2 = React.useContext(FormsContext),
    _React$useContext2$de = _React$useContext2.default_values,
    utm_campaign = _React$useContext2$de.utm_campaign,
    utm_medium = _React$useContext2$de.utm_medium,
    utm_source = _React$useContext2$de.utm_source,
    utm_content = _React$useContext2$de.utm_content;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "utm_campaign",
    defaultValue: utm_campaign
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "utm_medium",
    defaultValue: utm_medium
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "utm_source",
    defaultValue: utm_source
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "utm_content",
    defaultValue: utm_content
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "http_referer",
    defaultValue: http_referer
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "contact_origin",
    defaultValue: property
  }));
};
var FIELDS_MAPPING = {
  single_line_text: Input,
  email: Email,
  dropdown: Select,
  multi_line_text: TextArea,
  single_checkbox: Checkbox$1,
  multiple_checkboxes: MultipleCheckboxes,
  file: File,
  radio: RadioButtons
};
var getFieldComponent = function getFieldComponent(_ref6) {
  var fieldType = _ref6.fieldType,
    hidden = _ref6.hidden;
  var Component = hidden ? Hidden : FIELDS_MAPPING[fieldType] || Input;
  return Component;
};
var areValuesEqual = function areValuesEqual(values, value) {
  if (Array.isArray(value)) {
    return values.length === value.length && values.every(function (val) {
      return value.includes(val);
    });
  } else {
    return values.length === 1 && values.includes(value);
  }
};
var containsAny = function containsAny(values, value) {
  if (Array.isArray(value)) {
    return values.some(function (val) {
      return value.includes(val);
    });
  } else {
    return values.includes(value);
  }
};
var containsAll = function containsAll(values, value) {
  if (Array.isArray(value)) {
    return values.every(function (val) {
      return value.includes(val);
    });
  } else {
    return values.length === 1 && values[0] === value;
  }
};
var notContainsAll = function notContainsAll(values, value) {
  if (Array.isArray(value)) {
    return !values.every(function (val) {
      return value.includes(val);
    });
  } else {
    return !values.includes(value);
  }
};
var shouldShowDependentField = function shouldShowDependentField(_ref7, value) {
  var operator = _ref7.operator,
    values = _ref7.values;
  if (operator.toLowerCase() === "set_eq") {
    return areValuesEqual(values, value);
  }
  if (operator.toLowerCase() === "set_neq") {
    return !areValuesEqual(values, value);
  }
  if (operator.toLowerCase() === "is_not_empty") {
    if (Array.isArray(value)) {
      return value.length > 0 && value.some(Boolean);
    } else {
      return !!value;
    }
  }
  if (operator.toLowerCase() === "set_any") {
    return containsAny(values, value);
  }
  if (operator.toLowerCase() === "set_not_any") {
    return !containsAny(values, value);
  }
  if (operator.toLowerCase() === "set_all") {
    return containsAll(values, value);
  }
  if (operator.toLowerCase() === "set_not_all") {
    return notContainsAll(values, value);
  }
  console.warn("Unsupported operator operator: " + operator);
  return false;
};
var fieldDefault = function fieldDefault(component, name, defaults) {
  var data = defaults[name];
  return component.defaultValue(data === null || data === void 0 ? void 0 : data.value);
};
var Field = function Field(props) {
  var Component = getFieldComponent(props);
  var defaultValues = props.defaults;
  var _React$useState2 = React.useState(fieldDefault(Component, props.name, defaultValues)),
    value = _React$useState2[0],
    setValue = _React$useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Component, _extends({}, props, {
    value: value,
    onChange: function onChange(val) {
      return setValue(val);
    }
  })), props.dependentFields && props.dependentFields.length > 0 && props.dependentFields.map(function (dField) {
    if (shouldShowDependentField(dField.dependentCondition, value)) {
      var Comp = getFieldComponent(dField.dependentField);
      return /*#__PURE__*/React.createElement(Comp, _extends({
        key: dField.dependentField.name,
        formId: props.formId,
        defaultValue: fieldDefault(Comp, dField.dependentField.name, defaultValues)
      }, dField.dependentField));
    }
    return null;
  }));
};
function trackFormSubmit(formType, formId, formName) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null
  });
  window.dataLayer.push({
    event: "formSubmit",
    formType: formType,
    formId: formId,
    formName: formName
  });
}
function cumulativeTopOffset(element) {
  var top = 0;
  do {
    top += element.offsetTop || 0;
    element = element.offsetParent;
  } while (element);
  return top;
}
var FieldPlaceholder = function FieldPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("label", null, "Loading..."), /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control",
    disabled: true
  }));
};
var MultilineFieldPlaceholder = function MultilineFieldPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("label", null, "Loading..."), /*#__PURE__*/React.createElement("textarea", {
    className: "form-control",
    disabled: true
  }));
};
var SingleFieldPlaceholder = function SingleFieldPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-placeholder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "pulsate"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FieldPlaceholder, null)), /*#__PURE__*/React.createElement("div", {
    className: "text-left"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: "placeholder-text"
  }, "By submitting your information you are agreeing to receive marketing messages from Chaos. You can opt-out at any time. Privacy Policy."))), /*#__PURE__*/React.createElement("div", {
    className: "text-align-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "button-description-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-active-dark",
    disabled: true
  }, "Loading...")))));
};
var SimplePlaceholder$1 = function SimplePlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "form-placeholder"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title text-center spacing-bottom-sm"
  }, "Loading..."), /*#__PURE__*/React.createElement("div", {
    className: "pulsate"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FieldPlaceholder, null), /*#__PURE__*/React.createElement(FieldPlaceholder, null)), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FieldPlaceholder, null), /*#__PURE__*/React.createElement(FieldPlaceholder, null)), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(MultilineFieldPlaceholder, null)), /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom-sm text-left"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
    className: "placeholder-text"
  }, "Loading content that can be large paragaph of text, or not. Sometimes it's a consent text, sometimes it's a legal disclaimer, but most forms have some kind of prelude to the submit button..."))), /*#__PURE__*/React.createElement("div", {
    className: "text-align-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "button-description-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-active-dark",
    disabled: true
  }, "Loading...")))));
};
var buildFetcher = function buildFetcher(api_domain, formId, contactId) {
  if (contactId) {
    return Promise.all([fetch(api_domain + "/api/hubspot/forms/" + formId).then(function (r) {
      return r.json();
    }).then(function (d) {
      return d;
    }),, fetch(api_domain + "/api/hubspot/contacts/" + contactId).then(function (r) {
      return r.json();
    }).then(function (d) {
      return d;
    }),,]);
  } else {
    return fetch(api_domain + "/api/hubspot/forms/" + formId).then(function (r) {
      return r.json();
    }).then(function (d) {
      return d;
    });
  }
};
var buildLegalConsentOptions = function buildLegalConsentOptions(options, formData) {
  if ((options === null || options === void 0 ? void 0 : options.type) === "implicit_consent_to_process") {
    return {
      consent: {
        consentToProcess: true,
        text: options.communicationConsentText,
        communications: options.communicationsCheckboxes.map(function (checkbox) {
          return {
            value: formData.get("LEGAL_CONSENT.subscription_type_" + checkbox.subscriptionTypeId) === "on",
            subscriptionTypeId: checkbox.subscriptionTypeId,
            text: checkbox.label
          };
        })
      }
    };
  }
  if ((options === null || options === void 0 ? void 0 : options.type) === "explicit_consent_to_process") {
    return {
      consent: {
        consentToProcess: true,
        text: options.consentToProcessCheckboxLabel,
        communications: options.communicationsCheckboxes.map(function (checkbox) {
          return {
            value: formData.get("LEGAL_CONSENT.subscription_type_" + checkbox.subscriptionTypeId) === "on",
            subscriptionTypeId: checkbox.subscriptionTypeId,
            text: checkbox.label
          };
        })
      }
    };
  }
  if ((options === null || options === void 0 ? void 0 : options.type) === "legitimate_interest") {
    console.warn("legitimate_interest is not supported for the consent options...");
  }
  return {};
};
var HubspotForm = function HubspotForm(_ref) {
  var form_id = _ref.form_id,
    _ref$button_type = _ref.button_type,
    button_type = _ref$button_type === void 0 ? "btn-active-dark" : _ref$button_type,
    _ref$hideCaptcha = _ref.hideCaptcha,
    hideCaptcha = _ref$hideCaptcha === void 0 ? true : _ref$hideCaptcha,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? "default" : _ref$placeholder,
    scrollTarget = _ref.scrollTarget;
  var _React$useContext = React.useContext(HubSpotContext),
    api_domain = _React$useContext.api_domain,
    contact_id = _React$useContext.contact_id;
  var _React$useState = React.useState(""),
    message = _React$useState[0],
    setMessage = _React$useState[1];
  var _React$useState2 = React.useState(false),
    captchaSuccess = _React$useState2[0],
    setCaptchaSuccess = _React$useState2[1];
  var Placeholder = placeholder === "default" ? SimplePlaceholder$1 : SingleFieldPlaceholder;
  var handleSubmit = function handleSubmit(e, form_id, hubspotFormData) {
    e.preventDefault();
    var formData = new FormData(e.target);
    var body = {
      fields: []
    };
    for (var _iterator = _createForOfIteratorHelperLoose(formData.entries()), _step; !(_step = _iterator()).done;) {
      var pair = _step.value;
      if (!pair[0].startsWith("LEGAL_CONSENT.subscription_type_")) {
        body.fields = [].concat(body.fields, [{
          name: pair[0],
          value: pair[1]
        }]);
      }
    }
    body.legalConsentOptions = buildLegalConsentOptions(hubspotFormData.legalConsentOptions, formData);
    var requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(body)
    };
    trackFormSubmit("HubSpot", form_id, hubspotFormData.name);
    fetch(api_domain + "/api/hubspot/submits/" + form_id, requestOptions).then(function (response) {
      return response.json();
    }).then(function (data) {
      if (data.redirectUri) {
        window.location.href = data.redirectUri;
        return;
      }
      if (data.inlineMessage) {
        var _e$target;
        (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.reset();
        setMessage(data.inlineMessage);
      }
      if (data.errors || data.status === "error") {
        var _e$target2;
        console.error("Hubspot: ", data);
        (_e$target2 = e.target) === null || _e$target2 === void 0 ? void 0 : _e$target2.reset();
        setMessage("Something went wrong!");
      }
      if (scrollTarget) {
        var element = document.getElementById(scrollTarget);
        window.scrollTo({
          top: cumulativeTopOffset(element),
          left: 0,
          behavior: "smooth"
        });
      }
    });
  };
  if (message.length > 0) {
    return /*#__PURE__*/React.createElement("div", {
      id: "form-" + form_id,
      dangerouslySetInnerHTML: {
        __html: message
      }
    });
  }
  return /*#__PURE__*/React.createElement(DataLoader, {
    placeholder: Placeholder,
    fetcher: function fetcher() {
      return buildFetcher(api_domain, form_id, contact_id);
    },
    component: function component(_ref2) {
      var data = _ref2.data;
      var formData = null;
      var contactData = {};
      if (contact_id) {
        formData = data[0];
        if (data[2] && data[2]["is-contact"]) {
          contactData = data[2]["properties"] || {};
        }
      } else {
        formData = data;
      }
      if (formData.fieldGroups === undefined) return /*#__PURE__*/React.createElement("h3", null, "Please pick a form.");
      return /*#__PURE__*/React.createElement("form", {
        action: "",
        onSubmit: function onSubmit(e) {
          return handleSubmit(e, form_id, formData);
        }
      }, formData.fieldGroups.map(function (group, idx) {
        if (group.richText) {
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            dangerouslySetInnerHTML: {
              __html: group.richText
            }
          });
        }
        if (group.fields) {
          return /*#__PURE__*/React.createElement("div", {
            key: idx,
            className: "form-row"
          }, group.fields.map(function (field) {
            return /*#__PURE__*/React.createElement(Field, _extends({
              key: field.name,
              defaults: contactData,
              formId: form_id
            }, field));
          }));
        }
      }), /*#__PURE__*/React.createElement(Consent, {
        options: formData.legalConsentOptions
      }), hideCaptcha && /*#__PURE__*/React.createElement(FormCaptcha, {
        onChange: function onChange(captchaSuccess) {
          return setCaptchaSuccess(captchaSuccess);
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "text-align-center"
      }, /*#__PURE__*/React.createElement("span", {
        className: "button-description-wrapper"
      }, /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: button_type,
        disabled: !captchaSuccess && hideCaptcha
      }, formData.displayOptions.submitButtonText))), /*#__PURE__*/React.createElement(PrefilledFields, null));
    }
  });
};
var sortForms = function sortForms(a, b) {
  var nameA = a[1].toUpperCase();
  var nameB = b[1].toUpperCase();
  if (nameA < nameB) return -1;
  if (nameA > nameB) return 1;
  return 0;
};
var HubSpotFormPicker = function HubSpotFormPicker(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var _React$useContext = React.useContext(HubSpotContext),
    api_domain = _React$useContext.api_domain;
  return /*#__PURE__*/React.createElement(DataLoader, {
    fetcher: function fetcher() {
      return fetch(api_domain + "/api/hubspot/forms");
    },
    useFetch: true,
    component: function component(_ref2) {
      var data = _ref2.data;
      var options = data.results.map(function (f) {
        return [f.id, f.name];
      }).sort(sortForms);
      return /*#__PURE__*/React.createElement(SelectMenu, {
        label: "Hubspot form",
        options: options,
        value: value,
        onChange: function onChange(newValue) {
          return _onChange(newValue);
        }
      });
    }
  });
};
var Modal = /*#__PURE__*/function (_React$Component) {
  function Modal() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Modal, _React$Component);
  var _proto = Modal.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var _this = this;
    document.addEventListener("keydown", function (e) {
      if (_this.modal) {
        _this.handleEscKey(e);
      }
    }, false);
  };
  _proto.handleEscKey = function handleEscKey(e) {
    if (e.keyCode === 27) {
      this.props.onClose();
    }
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      title = _this$props.title,
      open = _this$props.open,
      onClose = _this$props.onClose,
      children = _this$props.children,
      className = _this$props.className,
      modalWrapperClass = _this$props.modalWrapperClass,
      titleAlign = _this$props.titleAlign,
      style = _this$props.style,
      _this$props$innerStyl = _this$props.innerStyle,
      innerStyle = _this$props$innerStyl === void 0 ? {} : _this$props$innerStyl;
    return /*#__PURE__*/React.createElement("div", {
      className: "cg-modal " + (modalWrapperClass ? modalWrapperClass : "") + " " + (open === true ? "modal-show" : ""),
      ref: function ref(modal) {
        _this2.modal = modal;
      },
      style: style ? style : {}
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-cnt " + (className !== "" ? className : ""),
      style: innerStyle
    }, title && /*#__PURE__*/React.createElement("div", {
      className: "modal-title-wrapper"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "modal-title " + (titleAlign === "left" ? "text-left" : "text-center")
    }, title)), /*#__PURE__*/React.createElement("button", {
      className: "icon-close close",
      onClick: function onClick() {
        return onClose();
      }
    }), children), /*#__PURE__*/React.createElement("div", {
      className: "modal-overlay",
      onClick: function onClick() {
        return onClose();
      }
    }));
  };
  return Modal;
}(React.Component);
Modal.defaultProps = {
  className: "",
  titleAlign: "center"
};
var ModalContent = function () {
  return /*#__PURE__*/React.createElement("div", {
    className: "markdown-cnt"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "modal-title"
  }, "Markdown Help"), /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, "Text format")), /*#__PURE__*/React.createElement("p", null, "**bold**", /*#__PURE__*/React.createElement("br", null), "*italic*"), /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, "Paragraph")), /*#__PURE__*/React.createElement("p", null, "Text on separate newline"), /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, "Lists")), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "List item"), /*#__PURE__*/React.createElement("li", null, "List item"), /*#__PURE__*/React.createElement("li", null, "List item")), /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, "Headings")), /*#__PURE__*/React.createElement("p", null, "# Heading 1", /*#__PURE__*/React.createElement("br", null), "## Heading 2", /*#__PURE__*/React.createElement("br", null), "### Heading 3", /*#__PURE__*/React.createElement("br", null), "#### Heading 4"), /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, "Link")), /*#__PURE__*/React.createElement("p", null, "[I'm an inline style link](https://www.google.com)"), /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, "Image")), "![alt text](/path/to/image.png)");
};
var MarkdownInput = function (_ref) {
  var value = _ref.value,
    label = _ref.label,
    _onChange = _ref.onChange;
  var _useState = useState(value),
    newValue = _useState[0],
    setValue = _useState[1];
  var _useState2 = useState(false),
    isModalVisible = _useState2[0],
    setModalVisibility = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "markdown-input"
  }, /*#__PURE__*/React.createElement(TextArea$2, {
    label: label,
    onChange: function onChange(value) {
      _onChange(value);
      setValue(value);
    },
    value: newValue
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setModalVisibility(true);
    },
    className: "modal-trigger"
  }), /*#__PURE__*/React.createElement(Modal, {
    open: isModalVisible,
    onClose: function onClose() {
      return setModalVisibility(false);
    },
    modalWrapperClass: "markdown-modal"
  }, /*#__PURE__*/React.createElement(ModalContent, null)));
};
var parser = new MarkdownIt({
  html: true,
  breaks: true
});
var parseMarkdown = function parseMarkdown(string, inline) {
  if (inline === void 0) {
    inline = false;
  }
  if (!string) return;
  if (inline) return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: parser.renderInline(string)
    }
  });
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: parser.render(string)
    }
  });
};
var backgroundImgSrc = function backgroundImgSrc(background) {
  if (background && background.urls && background.urls.original) {
    return background.urls.original;
  }
  if (background && !background.urls) {
    return background;
  }
  throw "Invalid Background Image!";
};
var BackgroundWrapper = function BackgroundWrapper(_ref) {
  var background = _ref.background,
    children = _ref.children;
  if (background) {
    var style = {
      backgroundImage: "url(" + backgroundImgSrc(background) + ")"
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "form-image-bg",
      style: style
    }, children);
  }
  return children;
};
var ContentField = function ContentField(_ref2) {
  var value = _ref2.value;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-box"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: value
    }
  })));
};
var underlayClass = function underlayClass(sidebarTheme) {
  return {
    black: "dark-bg",
    gray: "light-bg",
    white: "white-bg"
  }[sidebarTheme];
};
var ActiveForm = function ActiveForm(_ref3) {
  var formId = _ref3.formId,
    title = _ref3.title,
    sidebarTheme = _ref3.sidebarTheme,
    description = _ref3.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "lead-form-wrapper-panel " + underlayClass(sidebarTheme)
  }, /*#__PURE__*/React.createElement(FormTitle, {
    title: title
  }), /*#__PURE__*/React.createElement(DescriptionField, {
    description: description
  }), /*#__PURE__*/React.createElement(HubspotForm, {
    form_id: formId
  }));
};
var FormTitle = function FormTitle(_ref4) {
  var title = _ref4.title;
  return title && /*#__PURE__*/React.createElement("h4", {
    className: "form-title"
  }, title);
};
var DescriptionField = function DescriptionField(_ref5) {
  var description = _ref5.description;
  return description && parseMarkdown(description);
};
var AdvancedForm = function AdvancedForm(props) {
  var formId = props.formId,
    sidebarTheme = props.sidebarTheme,
    title = props.title,
    description = props.description,
    background = props.background,
    content = props.content;
  return /*#__PURE__*/React.createElement(BackgroundWrapper, {
    background: background
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(ContentField, {
    value: content
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(ActiveForm, {
    formId: formId,
    sidebarTheme: sidebarTheme,
    title: title,
    description: description
  })))));
};
var Widget$2 = function Widget(props) {
  var formId = props.formId,
    containerSettings = props.containerSettings,
    _props$required_marke = props.required_marker,
    required_marker = _props$required_marke === void 0 ? "star" : _props$required_marke;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "lead-capture-form form-vertical-space",
    settings: containerSettings
  }, formId ? /*#__PURE__*/React.createElement(RequiredMarkerContext.Provider, {
    value: required_marker
  }, /*#__PURE__*/React.createElement(AdvancedForm, props)) : /*#__PURE__*/React.createElement("h2", null, "Advanced From: Select a hubspot form"));
};
var Config$2 = {
  title: "Advanced Form",
  category: "Forms"
};
var Defaults$2 = {
  formId: "",
  required_marker: "star",
  containerSettings: {
    theme: "white",
    spacing: "none"
  },
  sidebarTheme: "white",
  title: "",
  description: "",
  background: imagePlaceholder("690x380"),
  content: ""
};
var Admin$2 = {
  formId: {
    type: "custom",
    component: HubSpotFormPicker,
    label: "Form Picker"
  },
  required_marker: {
    label: "Required fields indicator",
    type: "select",
    options: [["star", "Show stars next to labels"], ["optional", "Mark only optional fields"]]
  },
  sidebarTheme: {
    type: "select",
    options: [["white", "White"], ["gray", "Gray"], ["black", "Black"]]
  },
  title: {
    type: "text"
  },
  description: {
    type: "custom",
    component: MarkdownInput,
    label: "Description"
  },
  content: {
    type: "custom",
    component: RTE
  },
  background: {
    type: "custom",
    component: ImagePicker
  }
};
var AdvancedFormWidget = {
  __proto__: null,
  Widget: Widget$2,
  Admin: Admin$2,
  Config: Config$2,
  Defaults: Defaults$2
};
var InnerSubMenuInput = function InnerSubMenuInput(_ref) {
  var items = _ref.items,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Inner items",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(LinkSettings, {
        label: "Link",
        onChange: function onChange(value) {
          return onChangeItem("item", value);
        },
        value: settings.item
      });
    },
    onChangeList: onChange,
    items: items,
    template: {
      link: {}
    }
  });
};
var MenuItemField = function MenuItemField(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "URL",
    onChange: function onChange(value) {
      return onChangeItem("url", value);
    },
    value: settings.url
  }), /*#__PURE__*/React.createElement(InnerSubMenuInput, {
    items: settings.submenu,
    onChange: function onChange(_key, newItems) {
      onChangeItem("submenu", newItems);
    }
  }));
};
MenuItemField.defaultProps = {
  settings: {
    title: "",
    url: "",
    items: []
  }
};
var AdminFields = function AdminFields(_ref3) {
  var items = _ref3.items,
    _onChange = _ref3.onChange,
    settings = _ref3.settings;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show logo",
    options: [["on_scroll", "On Scroll"], ["permanent", "Always"]],
    value: settings.logo_variant,
    onChange: function onChange(value) {
      return _onChange("logo_variant", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show buttons",
    options: [["on_scroll", "On Scroll"], ["permanent", "Always"]],
    value: settings.show_buttons,
    onChange: function onChange(value) {
      return _onChange("show_buttons", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show logo (mobile)",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.logo_variant_mobile,
    onChange: function onChange(value) {
      return _onChange("logo_variant_mobile", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Logo Link optional",
    onChange: function onChange(value) {
      return _onChange("logo_anchor", value);
    },
    value: settings.logo_anchor
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show search",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.show_search,
    onChange: function onChange(value) {
      return _onChange("show_search", value);
    }
  }), settings.show_search === "yes" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Search URL",
    onChange: function onChange(value) {
      return _onChange("search_url", value);
    },
    value: settings.search_url
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Search placeholder",
    onChange: function onChange(value) {
      return _onChange("search_placeholder", value);
    },
    value: settings.search_placeholder
  })), /*#__PURE__*/React.createElement(List, {
    label: "Items",
    primaryField: "title",
    template: {
      title: "Item 1",
      url: "link"
    },
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(MenuItemField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ButtonSettings, {
    button_settings_title: "Button 1",
    value: settings.button_1,
    onChange: function onChange(values) {
      return _onChange("button_1", values);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    button_settings_title: "Button 2",
    value: settings.button_2,
    onChange: function onChange(values) {
      return _onChange("button_2", values);
    }
  }));
};
var extractCartInfo = function extractCartInfo(link, productInfo) {
  if (productInfo && productInfo.productCode) {
    return {
      productCode: productInfo.productCode,
      quantity: productInfo.quantity || 1,
      promoCode: productInfo.promoCode || "",
      currency: productInfo.currency,
      ratePlanDetails: productInfo.ratePlanDetails || null
    };
  }
  if (!link) {
    return {};
  }
  var match = link.match( /*#__PURE__*/_wrapRegExp(/#product\x2Dcode\x2D(.+)\x2Dqty\x2D(\d+)\x2Dpromo\x2D(\d+)/, {
    productCode: 1,
    quantity: 2,
    promo: 3
  }));
  if (!match) {
    match = link.match( /*#__PURE__*/_wrapRegExp(/#product\x2Dcode\x2D(.+)\x2Dqty\x2D(\d+)/, {
      productCode: 1,
      quantity: 2
    }));
  }
  if (match && match.groups && match.groups.productCode && match.groups.quantity) {
    return {
      productCode: match.groups.productCode,
      quantity: match.groups.quantity,
      promoCode: match.groups.promo || "",
      currency: ""
    };
  }
  return {};
};
var registerProductView = function registerProductView(ratePlanDetails) {
  if (!(ratePlanDetails !== null && ratePlanDetails !== void 0 && ratePlanDetails.id)) {
    return;
  }
  window.dataLayer = window.dataLayer || [];
  var eventForCurrentProduct = window.dataLayer.find(function (item) {
    var _item$ecommerce, _item$ecommerce$detai;
    return item.event === "eec.detail" && !!((item === null || item === void 0 ? void 0 : (_item$ecommerce = item.ecommerce) === null || _item$ecommerce === void 0 ? void 0 : (_item$ecommerce$detai = _item$ecommerce.detail) === null || _item$ecommerce$detai === void 0 ? void 0 : _item$ecommerce$detai.products) || []).find(function (product) {
      return product.id === ratePlanDetails.id;
    });
  });
  if (eventForCurrentProduct) {
    return;
  }
  window.dataLayer.push({
    event: "eec.detail",
    ecommerce: {
      detail: {
        actionField: {
          list: "Search Results"
        },
        products: [{
          id: ratePlanDetails.id,
          name: ratePlanDetails.name,
          category: ratePlanDetails.category,
          variant: ratePlanDetails.variant
        }]
      }
    }
  });
};
var registerAddToCart = function registerAddToCart(ratePlanDetails, currency, quantity) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "eec.add",
    ecommerce: {
      currencyCode: currency.toUpperCase(),
      add: {
        actionField: {
          list: "Shopping cart"
        },
        products: [{
          id: ratePlanDetails.id,
          name: ratePlanDetails.name,
          category: ratePlanDetails.category,
          variant: ratePlanDetails.variant,
          quantity: quantity
        }]
      }
    }
  });
};
function registerProductUpsellView(plans, promoType, campaignID) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null
  });
  window.dataLayer.push({
    event: "ga4.view_promotion",
    ecommerce: {
      creative_name: campaignID,
      promotion_name: promoType,
      items: [].concat(plans)
    }
  });
}
function registerProductUpsellClick(plans, promoType, campaignID) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null
  });
  window.dataLayer.push({
    event: "ga4.select_promotion",
    ecommerce: {
      creative_name: campaignID,
      promotion_name: promoType,
      items: [].concat(plans)
    }
  });
}
function registerAddToCartUpsell(plans, currency) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: null
  });
  window.dataLayer.push({
    event: "ga4.add_to_cart",
    ecommerce: {
      currency: currency,
      items: [].concat(plans)
    }
  });
}
var BUTTON_CLASS_MAP = {
  primary: "btn-active-dark",
  secondary: "btn-passive-light",
  "secondary-alt": "btn-passive",
  text: "btn-text"
};
var buttonClass = function buttonClass(type, className) {
  return [BUTTON_CLASS_MAP[type], className].filter(Boolean).join(" ");
};
var osIcons = function osIcons(label) {
  if (label.indexOf("{WINDOWS}") !== -1) return "" + label.replace("{WINDOWS}", '<i class="windows-icon"></i>');
  if (label.indexOf("{MAC}") !== -1) return "" + label.replace("{MAC}", '<i class="mac-icon"></i>');
  if (label.indexOf("{CART}") !== -1) return "" + label.replace("{CART}", '<i class="shopping-cart-icon"></i>');
  if (label.indexOf("{LINUX}") !== -1) return "" + label.replace("{LINUX}", '<i class="linux-icon"></i>');
  if (label.indexOf("{CHECK}") !== -1) return "" + label.replace("{CHECK}", '<i class="check-icon"></i>');
  return label;
};
var enhanceLabel = function enhanceLabel(label) {
  var processedLabel = osIcons(label);
  if (label === processedLabel) {
    return label;
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "button-icon-wrapper",
      dangerouslySetInnerHTML: {
        __html: processedLabel
      }
    });
  }
};
var ButtonPlaceholder = function ButtonPlaceholder(_ref) {
  var buttonClass = _ref.buttonClass;
  return /*#__PURE__*/React.createElement("button", {
    className: buttonClass + " btn-loader",
    type: "button"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeMiterlimit: "6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ButtonLoader = function ButtonLoader(_ref) {
  var type = _ref.type,
    className = _ref.className;
  var combinedClass = ["btn-upsell-campaign", buttonClass(type), className].filter(Boolean).join(" ");
  return /*#__PURE__*/React.createElement(ButtonPlaceholder, {
    buttonClass: combinedClass
  });
};
function buttonSettings(before, after, clicked) {
  if (clicked) {
    return {
      settings: after,
      disabled: true
    };
  }
  return {
    settings: before,
    disabled: false
  };
}
function pause(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
var AdvancedButton = function AdvancedButton(_ref2) {
  var before = _ref2.before,
    after = _ref2.after,
    type = _ref2.type,
    className = _ref2.className,
    _onClick = _ref2.onClick,
    onStart = _ref2.onStart,
    onEnd = _ref2.onEnd;
  var _React$useState = React.useState("pending"),
    state = _React$useState[0],
    setState = _React$useState[1];
  var _buttonSettings = buttonSettings(before, after, state === "finished"),
    _buttonSettings$setti = _buttonSettings.settings,
    label = _buttonSettings$setti.label,
    id = _buttonSettings$setti.id,
    disabled = _buttonSettings.disabled;
  if (state === "loading") {
    return /*#__PURE__*/React.createElement(ButtonLoader, {
      type: type,
      className: className
    });
  }
  var combinedClass = [disabled ? "btn-disabled" : "", "btn-upsell-campaign", buttonClass(type), className].filter(Boolean).join(" ");
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: id,
    className: combinedClass,
    disabled: disabled,
    onClick: function onClick() {
      try {
        setState("loading");
        onStart();
        return Promise.resolve(pause(500)).then(function () {
          setState("finished");
          return Promise.resolve(pause(500)).then(function () {
            _onClick();
            onEnd();
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }, enhanceLabel(label));
};
var Button = function Button(_ref3) {
  var label = _ref3.label,
    id = _ref3.id,
    type = _ref3.type,
    _ref3$disabled = _ref3.disabled,
    disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
    onClick = _ref3.onClick;
  var className = [disabled ? "btn-disabled" : "", "btn-upsell-campaign", buttonClass(type)].filter(Boolean).join(" ");
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: id,
    className: className,
    disabled: disabled,
    onClick: onClick
  }, enhanceLabel(label));
};
var symbol = function symbol(currency, country, skipLongSymbol) {
  if (skipLongSymbol === void 0) {
    skipLongSymbol = false;
  }
  if (skipLongSymbol) {
    return {
      eur: "€",
      usd: "$",
      gbp: "£",
      krw: "₩",
      cny: "¥",
      jpy: "¥",
      aud: "$"
    }[currency.toLowerCase()];
  }
  if (country === "US" && currency.toLowerCase() === "usd") {
    return "$";
  }
  return {
    eur: "€",
    usd: "US $",
    gbp: "£",
    krw: "₩",
    cny: "¥",
    jpy: "¥",
    aud: "AU $"
  }[currency.toLowerCase()];
};
var all = ["eur", "usd", "gbp", "krw", "cny", "jpy", "aud"];
var allInZuora = ["eur", "usd", "gbp", "krw", "jpy", "aud"];
var extractPrice = function extractPrice(prices, currency) {
  return prices[currency.toLowerCase()] || prices[currency.toUpperCase()];
};
var COMMA_CURRENCIES = ["jpy", "usd"];
var prettyPrint = function prettyPrint(value, currency, country, skipLongSymbol) {
  if (skipLongSymbol === void 0) {
    skipLongSymbol = false;
  }
  var _Number$toFixed$split = Number(value).toFixed(2).split("."),
    whole = _Number$toFixed$split[0],
    dec = _Number$toFixed$split[1];
  var separator = COMMA_CURRENCIES.includes(currency.toLowerCase()) ? "," : " ";
  if (whole.length > 3) {
    var remainder = whole.length % 3;
    return [symbol(currency, country, skipLongSymbol), remainder !== 0 ? "" + (whole.slice(0, remainder) + separator) : "", whole.slice(remainder).match(/\d{3}/g).join(separator), dec && dec !== "00" ? "." : "", dec && dec !== "00" ? dec : ""].join("");
  } else {
    return [symbol(currency, country, skipLongSymbol), whole, dec && dec !== "00" ? "." : "", dec && dec !== "00" ? dec : ""].join("");
  }
};
var split = function split(value) {
  return Number(value).toFixed(2).split(".");
};
var shouldSkipCents = function shouldSkipCents(currency) {
  return ["krw", "jpy", "cny"].includes(currency.toLowerCase());
};
var Currency = {
  all: all,
  allInZuora: allInZuora,
  symbol: symbol,
  extractPrice: extractPrice,
  prettyPrint: prettyPrint,
  split: split,
  shouldSkipCents: shouldSkipCents
};
var Price = function Price(_ref) {
  var currency = _ref.currency,
    value = _ref.value;
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  var _Currency$split = Currency.split(value),
    whole = _Currency$split[0],
    decimal = _Currency$split[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "major"
  }, Currency.prettyPrint(Number.parseInt(whole, 10), currency, country, true)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("div", {
    className: "minor"
  }, decimal))));
};
var SAVINGS_TOKENS = [{
  token: "{MONTHLY_DIFF}",
  type: "month"
}, {
  token: "{MONTHLY_DIFF_MOD}",
  type: "month_mod"
}, {
  token: "{ANNUAL_DIFF}",
  type: "year"
}, {
  token: "{ANNUAL_DIFF_MOD}",
  type: "year_mod"
}];
function extractPrice$1(prices, currency) {
  return Currency.extractPrice(prices, currency);
}
function perMonthPrice(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "Annual":
      return value / (opts.specificBillingPeriod || 12);
    case "Three_Years":
      return value / (opts.specificBillingPeriod || 36);
    default:
      return value;
  }
}
function perYearPrice(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "Month":
      return value * (opts.specificBillingPeriod || 12);
    case "Three_Years":
      return value / (opts.specificBillingPeriod || 3);
    default:
      return value;
  }
}
function parseCardTitle(content) {
  var result = {
    prefix: content,
    suffix: null,
    type: null
  };
  SAVINGS_TOKENS.forEach(function (info) {
    var _content$split = content.split(info.token),
      prefix = _content$split[0],
      suffix = _content$split[1];
    if (prefix && suffix) {
      result.prefix = prefix;
      result.suffix = suffix;
      result.type = info.type;
    }
    if (!prefix && suffix && content.startsWith(info.token)) {
      result.prefix = "";
      result.suffix = suffix;
      result.type = info.type;
    }
  });
  return result;
}
function extractSavingsValue(currentRatePlan, newRatePlan, currency, type) {
  if (!type) {
    console.warn("Failed to extact savings for UpsellCard: " + type);
    return null;
  }
  var currentPrice = extractPrice$1(currentRatePlan.prices, currency);
  var newPrice = extractPrice$1(newRatePlan.prices, currency);
  if (type === "year") {
    return perYearPrice(currentPrice, currentRatePlan.variant) - perYearPrice(newPrice, newRatePlan.variant);
  }
  if (type === "year_mod") {
    return Math.abs(perYearPrice(currentPrice, currentRatePlan.variant) - perYearPrice(newPrice, newRatePlan.variant));
  }
  if (type === "month") {
    return perMonthPrice(currentPrice, currentRatePlan.variant) - perMonthPrice(newPrice, newRatePlan.variant);
  }
  if (type === "month_mod") {
    return Math.abs(perMonthPrice(currentPrice, currentRatePlan.variant) - perMonthPrice(newPrice, newRatePlan.variant));
  }
}
function perMonthToken(desc, ratePlan, currency, country) {
  return desc.replace("{PER_MONTH}", Currency.prettyPrint(perMonthPrice(extractPrice$1(ratePlan.prices, currency), ratePlan.variant, ratePlan), currency, country));
}
function perYearToken(desc, ratePlan, currency, country) {
  return desc.replace("{PER_YEAR}", Currency.prettyPrint(perYearPrice(extractPrice$1(ratePlan.prices, currency), ratePlan.variant, ratePlan), currency, country));
}
function registerView(campaignID, promoType, plans) {
  registerProductUpsellView(plans.filter(Boolean).map(function (ratePlanDetails) {
    return {
      item_id: ratePlanDetails.id,
      item_name: ratePlanDetails.name,
      item_category: ratePlanDetails.category,
      item_variant: ratePlanDetails.variant
    };
  }), promoType, campaignID === null || campaignID === void 0 ? void 0 : campaignID.toString());
}
function registerPick(campaignID, promoType, plans) {
  registerProductUpsellClick(plans.filter(Boolean).map(function (ratePlanDetails) {
    return {
      item_id: ratePlanDetails.id,
      item_name: ratePlanDetails.name,
      item_category: ratePlanDetails.category,
      item_variant: ratePlanDetails.variant
    };
  }), promoType, campaignID === null || campaignID === void 0 ? void 0 : campaignID.toString());
}
function registerUpsellEnd(plans, currency) {
  registerAddToCartUpsell(plans.map(function (ratePlanDetails) {
    if (ratePlanDetails.listName || ratePlanDetails.campaignID) {
      var _ratePlanDetails$camp;
      return {
        item_id: ratePlanDetails.id,
        item_name: ratePlanDetails.name,
        item_category: ratePlanDetails.category,
        item_variant: ratePlanDetails.variant,
        item_list_name: ratePlanDetails.listName,
        item_list_id: (_ratePlanDetails$camp = ratePlanDetails.campaignID) === null || _ratePlanDetails$camp === void 0 ? void 0 : _ratePlanDetails$camp.toString()
      };
    } else {
      return {
        item_id: ratePlanDetails.id,
        item_name: ratePlanDetails.name,
        item_category: ratePlanDetails.category,
        item_variant: ratePlanDetails.variant
      };
    }
  }), currency);
}
var Benefits = function Benefits(_ref) {
  var title = _ref.title,
    list = _ref.list;
  return /*#__PURE__*/React.createElement("div", {
    className: "benefits"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("ul", null, list.map(function (item) {
    return /*#__PURE__*/React.createElement("li", {
      key: item.id,
      dangerouslySetInnerHTML: {
        __html: item.description
      }
    });
  })));
};
var PriceRowText = function PriceRowText(_ref2) {
  var content = _ref2.content;
  return content.split(/[{}]+/).filter(Boolean).filter(function (t) {
    return !t.match(/^\s$/);
  }).map(function (text, idx) {
    if (content.includes("{" + text + "}")) {
      return /*#__PURE__*/React.createElement("span", {
        key: idx,
        className: "accented"
      }, text);
    } else {
      return /*#__PURE__*/React.createElement("span", {
        key: idx,
        className: "main"
      }, text);
    }
  });
};
var PriceRow = function PriceRow(_ref3) {
  var currency = _ref3.currency,
    upsell = _ref3.upsell,
    originalPlan = _ref3.originalPlan;
  var data = parseCardTitle(upsell.card_title);
  var value = extractSavingsValue(originalPlan, upsell.rate_plan_details, currency, data.type);
  return /*#__PURE__*/React.createElement("div", {
    className: "price-wrapper"
  }, /*#__PURE__*/React.createElement(PriceRowText, {
    content: data.prefix || ""
  }), value && /*#__PURE__*/React.createElement(Price, {
    value: value,
    currency: currency
  }), /*#__PURE__*/React.createElement(PriceRowText, {
    content: data.suffix || ""
  }));
};
var UpsellCard = function UpsellCard(_ref4) {
  var campaign = _ref4.campaign,
    currency = _ref4.currency,
    upsell = _ref4.upsell,
    originalPlan = _ref4.originalPlan,
    onUpdate = _ref4.onUpdate;
  var _React$useState = React.useState(false),
    working = _React$useState[0],
    setWorking = _React$useState[1];
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  React.useEffect(function () {
    registerView(campaign.id, "Upsell", [upsell.rate_plan_details]);
  }, []);
  var disclaimer = [perYearToken, perMonthToken].reduce(function (memo, processor) {
    return processor(memo, upsell.rate_plan_details, currency, country);
  }, upsell.card_disclaimer);
  return /*#__PURE__*/React.createElement("div", {
    id: originalPlan.id + "-upsell"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-center"
  }, parseMarkdown(upsell.title, true)), /*#__PURE__*/React.createElement("div", {
    className: "upsell-card"
  }, /*#__PURE__*/React.createElement(PriceRow, {
    currency: currency,
    upsell: upsell,
    originalPlan: originalPlan
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, parseMarkdown(upsell.card_sub_title, true)), /*#__PURE__*/React.createElement(Benefits, {
    title: upsell.benefits_title,
    list: upsell.benefits
  }), /*#__PURE__*/React.createElement("div", {
    className: "discalimer",
    dangerouslySetInnerHTML: {
      __html: disclaimer
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "centered"
  }, /*#__PURE__*/React.createElement(AdvancedButton, {
    before: upsell.upsell_button,
    after: upsell.upsell_button_pressed,
    type: "primary",
    onStart: function onStart() {
      return setWorking(true);
    },
    onEnd: function onEnd() {
      return setWorking(false);
    },
    onClick: function onClick() {
      registerPick(campaign.id, "Upsell", [upsell.rate_plan_details]);
      onUpdate({
        type: "accept-upsell",
        data: {
          ratePlanId: upsell.rate_plan_id
        }
      });
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "centered"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    disabled: working,
    type: "secondary-alt"
  }, upsell.continue_button, {
    onClick: function onClick() {
      return onUpdate({
        type: "reject-upsell",
        data: {}
      });
    }
  }))));
};
var imgLoading = function imgLoading(value) {
  if (value === "lazy") {
    return "lazy";
  }
  return "eager";
};
var Image = function Image(_ref) {
  var src = _ref.src,
    loading = _ref.loading,
    variant = _ref.variant,
    className = _ref.className,
    _ref$showCredits = _ref.showCredits,
    showCredits = _ref$showCredits === void 0 ? true : _ref$showCredits;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: imgLoading(loading),
    src: src,
    variant: variant,
    className: className || ""
  }), showCredits && src.credits !== undefined && /*#__PURE__*/React.createElement("span", {
    className: "credits " + (src.credits_theme || "light")
  }, src.credits)));
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
const _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
var useLocalizationCountry = function useLocalizationCountry(defaultValue, onFetch) {
  var localizationUrl = React.useContext(LocalizationUrlContext);
  React.useEffect(function () {
    var fetchLocalization = function fetchLocalization() {
      try {
        var _temp = _catch(function () {
          return Promise.resolve(fetch(localizationUrl).then(function (r) {
            return r.json();
          }).then(function (d) {
            return d;
          })).then(function (localizationData) {
            var val = (localizationData === null || localizationData === void 0 ? void 0 : localizationData.countryCode) || defaultValue || "";
            onFetch(val);
          });
        }, function (e) {
          console.error(e);
          var val = defaultValue || "";
          onFetch(val);
        });
        return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    fetchLocalization();
  }, []);
};
var LocalizedDescription = function LocalizedDescription(_ref) {
  var item = _ref.item,
    country = _ref.country;
  var result = useGeoIpFilterCheck({
    active: item.geoip === "yes",
    activeCountries: item.countries || [],
    countryGroupIds: item.country_groups || [],
    localizationCountry: country
  });
  if (!item.description) {
    return null;
  }
  if (result) {
    return /*#__PURE__*/React.createElement("div", {
      className: "description"
    }, parseMarkdown(item.description, true));
  }
  return null;
};
var Card = function Card(_ref2) {
  var _product$rate_plan_de;
  var currency = _ref2.currency,
    country = _ref2.country,
    product = _ref2.product,
    updateWorking = _ref2.updateWorking,
    onUpdate = _ref2.onUpdate;
  return /*#__PURE__*/React.createElement("div", {
    className: "cross-sell-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-row"
  }, product.logo && /*#__PURE__*/React.createElement(Image, {
    src: product.logo,
    className: "product-logo",
    variant: "original"
  }), /*#__PURE__*/React.createElement("div", {
    className: "product-name"
  }, product.name)), product.description && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(product.description, true)), (product.secondary_descriptions || []).map(function (item, idx) {
    return /*#__PURE__*/React.createElement(LocalizedDescription, {
      key: idx,
      item: item,
      country: country
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "card-row space"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-row"
  }, /*#__PURE__*/React.createElement(Price, {
    currency: currency,
    value: extractPrice$1(((_product$rate_plan_de = product.rate_plan_details) === null || _product$rate_plan_de === void 0 ? void 0 : _product$rate_plan_de.prices) || {}, currency)
  }), product.price_label && /*#__PURE__*/React.createElement("span", {
    className: "price-label"
  }, product.price_label)), /*#__PURE__*/React.createElement(AdvancedButton, {
    before: product.button,
    after: product.button_added,
    className: "btn-small",
    type: "primary",
    onStart: function onStart() {
      return updateWorking(true);
    },
    onEnd: function onEnd() {
      return updateWorking(false);
    },
    onClick: onUpdate
  })));
};
var CrossSell = function CrossSell(_ref3) {
  var _data$continue_button, _data$product_3, _data$product_4, _data$product_5, _data$product_8;
  var currency = _ref3.currency,
    data = _ref3.data,
    fadeIn = _ref3.fadeIn,
    originalPlanId = _ref3.originalPlanId,
    _onUpdate = _ref3.onUpdate;
  var _React$useState = React.useState(false),
    working = _React$useState[0],
    setWorking = _React$useState[1];
  var _React$useState2 = React.useState(""),
    country = _React$useState2[0],
    setCountry = _React$useState2[1];
  React.useState(function () {
    var _data$product_, _data$product_2;
    registerView(data.id, "Cross sell", [(_data$product_ = data.product_1) === null || _data$product_ === void 0 ? void 0 : _data$product_.rate_plan_details, (_data$product_2 = data.product_2) === null || _data$product_2 === void 0 ? void 0 : _data$product_2.rate_plan_details]);
  }, []);
  useLocalizationCountry("", setCountry);
  var shortCircuit = !((_data$continue_button = data.continue_button) !== null && _data$continue_button !== void 0 && _data$continue_button.label);
  var unsetCrossSellHeight = [(_data$product_3 = data.product_1) === null || _data$product_3 === void 0 ? void 0 : _data$product_3.rate_plan_id, (_data$product_4 = data.product_2) === null || _data$product_4 === void 0 ? void 0 : _data$product_4.rate_plan_id].filter(Boolean).length === 1;
  return /*#__PURE__*/React.createElement("div", {
    className: fadeIn ? "fade-in-wrapper" : "",
    id: originalPlanId + "-cross-sell"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-center main-title"
  }, parseMarkdown(data.title, true)), data.sub_title && /*#__PURE__*/React.createElement("div", {
    className: "text-center sub-title"
  }, parseMarkdown(data.sub_title, true)), /*#__PURE__*/React.createElement("div", {
    className: "cross-sell",
    style: unsetCrossSellHeight ? {
      height: "unset"
    } : null
  }, (data === null || data === void 0 ? void 0 : (_data$product_5 = data.product_1) === null || _data$product_5 === void 0 ? void 0 : _data$product_5.rate_plan_id) && /*#__PURE__*/React.createElement(Card, {
    product: data.product_1,
    currency: currency,
    country: country,
    updateWorking: setWorking,
    onUpdate: function onUpdate() {
      var _data$product_6, _data$product_7;
      registerPick(data.id, "Cross sell", [(_data$product_6 = data.product_1) === null || _data$product_6 === void 0 ? void 0 : _data$product_6.rate_plan_details]);
      _onUpdate({
        type: shortCircuit ? "p1-end" : "p1-add",
        data: {
          ratePlanId: (_data$product_7 = data.product_1) === null || _data$product_7 === void 0 ? void 0 : _data$product_7.rate_plan_id
        }
      });
    }
  }), (data === null || data === void 0 ? void 0 : (_data$product_8 = data.product_2) === null || _data$product_8 === void 0 ? void 0 : _data$product_8.rate_plan_id) && /*#__PURE__*/React.createElement(Card, {
    product: data.product_2,
    currency: currency,
    country: country,
    updateWorking: setWorking,
    onUpdate: function onUpdate() {
      var _data$product_9, _data$product_10;
      registerPick(data.id, "Cross sell", [(_data$product_9 = data.product_2) === null || _data$product_9 === void 0 ? void 0 : _data$product_9.rate_plan_details]);
      _onUpdate({
        type: shortCircuit ? "p2-end" : "p2-add",
        data: {
          ratePlanId: (_data$product_10 = data.product_2) === null || _data$product_10 === void 0 ? void 0 : _data$product_10.rate_plan_id
        }
      });
    }
  })), !shortCircuit && /*#__PURE__*/React.createElement("div", {
    className: "centered"
  }, /*#__PURE__*/React.createElement(Button, _extends({
    type: "secondary-alt",
    disabled: working
  }, data.continue_button, {
    onClick: function onClick() {
      return _onUpdate({
        type: "cross-end",
        data: {}
      });
    }
  }))));
};
function reducer(state, action) {
  switch (action.type) {
    case "close":
      return _extends({}, state, {
        step: "end",
        crossP1: "",
        crossP2: ""
      });
    case "accept-upsell":
      return {
        step: "cross",
        upsell: action.data.ratePlanId,
        crossP1: "",
        crossP2: ""
      };
    case "reject-upsell":
      return {
        step: "cross",
        crossP1: "",
        crossP2: ""
      };
    case "p1-add":
      return _extends({}, state, {
        crossP1: action.data.ratePlanId
      });
    case "p1-end":
      return _extends({}, state, {
        crossP1: action.data.ratePlanId,
        step: "end"
      });
    case "p2-add":
      return _extends({}, state, {
        crossP2: action.data.ratePlanId
      });
    case "p2-end":
      return _extends({}, state, {
        crossP2: action.data.ratePlanId,
        step: "end"
      });
    case "cross-end":
      return _extends({}, state, {
        step: "end"
      });
  }
  throw Error("Unknown action: " + action.type);
}
function crossSellDetails(state, campaign) {
  if (state.upsell && campaign.upsellDetails.cross_sell_details) {
    return campaign.upsellDetails.cross_sell_details;
  }
  if (!state.upsell) {
    return campaign.crossSellDetails;
  }
  return null;
}
function buildInitialState(campaign) {
  if (campaign.upsellDetails.rate_plan_id) {
    return {
      step: "upsell",
      upsell: "",
      crossP1: "",
      crossP2: ""
    };
  } else {
    return {
      step: "cross",
      upsell: "",
      crossP1: "",
      crossP2: ""
    };
  }
}
function isCompleted(state, campaign) {
  var _crossDetails$product, _crossDetails$product2;
  if (state.step === "end") {
    return true;
  }
  var crossDetails = crossSellDetails(state, campaign);
  if (state.step === "cross" && [crossDetails === null || crossDetails === void 0 ? void 0 : (_crossDetails$product = crossDetails.product_1) === null || _crossDetails$product === void 0 ? void 0 : _crossDetails$product.rate_plan_id, crossDetails === null || crossDetails === void 0 ? void 0 : (_crossDetails$product2 = crossDetails.product_2) === null || _crossDetails$product2 === void 0 ? void 0 : _crossDetails$product2.rate_plan_id].filter(Boolean).length === [state.crossP1, state.crossP2].filter(Boolean).length) {
    return true;
  }
}
function collectProductsData(state, campaign) {
  var results = [];
  var trackingResults = [];
  var crossSell = crossSellDetails(state, campaign);
  if (state.upsell) {
    results.push({
      id: campaign.upsellDetails.rate_plan_details.id,
      qty: campaign.upsellDetails.rate_plan_details.min_qty || 1,
      details: campaign.upsellDetails.rate_plan_details
    });
    trackingResults.push(_extends({}, campaign.upsellDetails.rate_plan_details, {
      listName: "Upsell",
      campaignID: campaign.id
    }));
  } else {
    results.push({
      id: campaign.ratePlanDetails.id,
      qty: campaign.ratePlanDetails.min_qty || 1,
      details: campaign.ratePlanDetails
    });
    trackingResults.push(campaign.ratePlanDetails);
  }
  if (state.crossP1) {
    results.push({
      id: crossSell.product_1.rate_plan_details.id,
      qty: crossSell.product_1.rate_plan_details.min_qty || 1,
      details: crossSell.product_1.rate_plan_details
    });
    trackingResults.push(_extends({}, crossSell.product_1.rate_plan_details, {
      listName: "Cross sell",
      campaignID: crossSell.id
    }));
  }
  if (state.crossP2) {
    results.push({
      id: crossSell.product_2.rate_plan_details.id,
      qty: crossSell.product_2.rate_plan_details.min_qty || 1,
      details: crossSell.product_2.rate_plan_details
    });
    trackingResults.push(_extends({}, crossSell.product_2.rate_plan_details, {
      listName: "Cross sell",
      campaignID: crossSell.id
    }));
  }
  return [results, trackingResults];
}
var UpsellCampaign = function UpsellCampaign(_ref) {
  var _crossSell$product_, _crossSell$product_2;
  var currency = _ref.currency,
    campaign = _ref.campaign,
    addToCart = _ref.addToCart;
  var initialState = buildInitialState(campaign);
  var _React$useReducer = React.useReducer(reducer, initialState),
    state = _React$useReducer[0],
    dispatch = _React$useReducer[1];
  React.useEffect(function () {
    if (isCompleted(state, campaign)) {
      var _collectProductsData = collectProductsData(state, campaign),
        products = _collectProductsData[0],
        productsTracking = _collectProductsData[1];
      addToCart(products);
      registerUpsellEnd(productsTracking, currency);
    }
  }, [state]);
  var crossSell = crossSellDetails(state, campaign);
  if (isCompleted(state, campaign)) {
    return /*#__PURE__*/React.createElement("div", {
      className: "upsell-campaign"
    }, /*#__PURE__*/React.createElement("div", {
      className: "overlay"
    }));
  }
  var unsetCrossSellHeight = state.step === "cross" && [(_crossSell$product_ = crossSell.product_1) === null || _crossSell$product_ === void 0 ? void 0 : _crossSell$product_.rate_plan_id, (_crossSell$product_2 = crossSell.product_2) === null || _crossSell$product_2 === void 0 ? void 0 : _crossSell$product_2.rate_plan_id].filter(Boolean).length === 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "upsell-campaign",
    id: "upsell-campaign"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content",
    style: unsetCrossSellHeight ? {
      height: "unset"
    } : null
  }, campaign.closeable && /*#__PURE__*/React.createElement("button", {
    className: "icon-close",
    onClick: function onClick() {
      return dispatch({
        type: "close",
        data: {}
      });
    }
  }), state.step === "upsell" && /*#__PURE__*/React.createElement(UpsellCard, {
    campaign: campaign,
    currency: currency,
    upsell: campaign.upsellDetails,
    originalPlan: campaign.ratePlanDetails,
    onUpdate: dispatch
  }), state.step === "cross" && crossSell && /*#__PURE__*/React.createElement(CrossSell, {
    originalPlanId: state.upsell ? campaign.upsellDetails.rate_plan_id : campaign.ratePlanDetails.id,
    fadeIn: initialState.step === "upsell",
    currency: currency,
    data: crossSell,
    onUpdate: dispatch
  })));
};
var SimpleButton = function SimpleButton(_ref) {
  var settings = _ref.settings,
    buttonClass = _ref.buttonClass,
    productInfo = _ref.productInfo;
  var cart = React.useContext(CartContext);
  var id = settings.id,
    label = settings.label,
    link = settings.link,
    target = settings.target,
    follow_link = settings.follow_link;
  var _extractCartInfo = extractCartInfo(link, productInfo),
    productCode = _extractCartInfo.productCode,
    quantity = _extractCartInfo.quantity,
    promoCode = _extractCartInfo.promoCode,
    currency = _extractCartInfo.currency,
    ratePlanDetails = _extractCartInfo.ratePlanDetails;
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    className: buttonClass,
    id: id || "",
    target: target,
    rel: follow_link === "no-follow" ? "nofollow" : "",
    onClick: function onClick(e) {
      if (cart && cart.add && productCode && quantity) {
        e.preventDefault();
        cart.add(productCode, parseInt(quantity), promoCode);
        if (currency && ratePlanDetails) {
          registerAddToCart(ratePlanDetails, currency, parseInt(quantity));
        }
      }
    }
  }, enhanceLabel(label));
};
var _excluded$2 = ["settings", "className"];
function urlPath(url, locale) {
  var _u$pathname;
  if (!url) {
    return "";
  }
  var u = new URL(url);
  var path = ((_u$pathname = u.pathname) === null || _u$pathname === void 0 ? void 0 : _u$pathname.slice(1)) || "";
  if (path.startsWith(locale + "/")) {
    return path.slice(locale.length + 1);
  }
  return path;
}
var UpsellButton = function UpsellButton(_ref) {
  var settings = _ref.settings,
    buttonClass = _ref.buttonClass,
    ratePlanId = _ref.ratePlanId,
    currency = _ref.currency,
    productInfo = _ref.productInfo,
    promoCode = _ref.promoCode;
  var cart = React.useContext(CartContext);
  var id = settings.id,
    label = settings.label,
    link = settings.link,
    target = settings.target,
    follow_link = settings.follow_link;
  var currentSSRURL = React.useContext(PageUrlContext);
  var currentLocale = React.useContext(LocaleContext);
  return /*#__PURE__*/React.createElement(Query, {
    query: UPSELL_CAMPAIGN,
    variables: {
      input: {
        id: ratePlanId,
        page: urlPath(currentSSRURL, currentLocale)
      }
    }
  }, function (_ref2) {
    var _window, _window$sessionStorag, _window2, _window2$location;
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    var _React$useState = React.useState(false),
      open = _React$useState[0],
      setOpen = _React$useState[1];
    if (error) return "Error! " + error.message;
    if (loading) return /*#__PURE__*/React.createElement(ButtonPlaceholder, {
      buttonClass: buttonClass
    });
    var comingFromItl = !!((_window = window) !== null && _window !== void 0 && (_window$sessionStorag = _window.sessionStorage) !== null && _window$sessionStorag !== void 0 && _window$sessionStorag.getItem("itl-closed"));
    var urlParams = new URLSearchParams(((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$location = _window2.location) === null || _window2$location === void 0 ? void 0 : _window2$location.search) || "");
    var comingFromAbanondCart = urlParams.get("utm_campaign") === "abandoned-cart";
    if (!data.upsellCampaign || comingFromItl || comingFromAbanondCart) {
      return /*#__PURE__*/React.createElement(SimpleButton, {
        settings: settings,
        productInfo: productInfo,
        buttonClass: buttonClass
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
      href: link,
      className: buttonClass,
      id: id || "",
      target: target,
      rel: follow_link === "no-follow" ? "nofollow" : "",
      onClick: function onClick(e) {
        e.preventDefault();
        setOpen(true);
      }
    }, enhanceLabel(label)), open && /*#__PURE__*/React.createElement(UpsellCampaign, {
      currency: currency,
      campaign: data.upsellCampaign,
      addToCart: function addToCart(productsInfo) {
        try {
          var _temp3 = function _temp3() {
            setOpen(false);
          };
          var usePromoCode = promoCode && productsInfo.find(function (prod) {
            return prod.id === ratePlanId;
          });
          var _temp2 = function () {
            if (cart && cart.addMultiple) {
              var _temp = function () {
                if (usePromoCode) {
                  return Promise.resolve(cart.addMultiple(productsInfo.map(function (prod) {
                    return {
                      id: prod.id,
                      qty: prod.id === productInfo.productCode ? productInfo.quantity || prod.qty : prod.qty
                    };
                  }), promoCode)).then(function () {});
                } else {
                  return Promise.resolve(cart.addMultiple(productsInfo.map(function (prod) {
                    return {
                      id: prod.id,
                      qty: prod.id === productInfo.productCode ? productInfo.quantity || prod.qty : prod.qty
                    };
                  }))).then(function () {});
                }
              }();
              if (_temp && _temp.then) return _temp.then(function () {});
            }
          }();
          return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(_temp3) : _temp3(_temp2));
        } catch (e) {
          return Promise.reject(e);
        }
      }
    }));
  });
};
var ButtonWithDescription = function ButtonWithDescription(_ref3) {
  var settings = _ref3.settings,
    buttonClass = _ref3.buttonClass,
    productInfo = _ref3.productInfo,
    upsellEnabled = _ref3.upsellEnabled;
  var link = settings.link,
    description = settings.description;
  var _extractCartInfo = extractCartInfo(link, productInfo),
    productCode = _extractCartInfo.productCode,
    currency = _extractCartInfo.currency,
    promoCode = _extractCartInfo.promoCode;
  if (upsellEnabled && productCode) {
    return /*#__PURE__*/React.createElement("span", {
      className: "button-description-wrapper"
    }, /*#__PURE__*/React.createElement(UpsellButton, {
      settings: settings,
      buttonClass: buttonClass,
      ratePlanId: productCode,
      currency: currency,
      productInfo: productInfo,
      promoCode: promoCode
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
      className: "button-description"
    }, parseMarkdown(description, true)));
  }
  return /*#__PURE__*/React.createElement("span", {
    className: "button-description-wrapper"
  }, /*#__PURE__*/React.createElement(SimpleButton, {
    settings: settings,
    productInfo: productInfo,
    buttonClass: buttonClass
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "button-description"
  }, parseMarkdown(description, true)));
};
var ButtonWithoutDescription = function ButtonWithoutDescription(_ref4) {
  var settings = _ref4.settings,
    buttonClass = _ref4.buttonClass,
    productInfo = _ref4.productInfo,
    upsellEnabled = _ref4.upsellEnabled;
  var link = settings.link;
  var _extractCartInfo2 = extractCartInfo(link, productInfo),
    productCode = _extractCartInfo2.productCode,
    currency = _extractCartInfo2.currency,
    promoCode = _extractCartInfo2.promoCode;
  if (upsellEnabled && productCode) {
    return /*#__PURE__*/React.createElement(UpsellButton, {
      settings: settings,
      buttonClass: buttonClass,
      ratePlanId: productCode,
      currency: currency,
      productInfo: productInfo,
      promoCode: promoCode
    });
  }
  return /*#__PURE__*/React.createElement(SimpleButton, {
    settings: settings,
    productInfo: productInfo,
    buttonClass: buttonClass
  });
};
var Button$1 = function Button(_ref5) {
  var settings = _ref5.settings,
    className = _ref5.className,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded$2);
  var label = settings.label,
    link = settings.link,
    type = settings.type,
    description = settings.description;
  return /*#__PURE__*/React.createElement(React.Fragment, null, description && link && label && /*#__PURE__*/React.createElement(ButtonWithDescription, _extends({
    settings: settings,
    buttonClass: buttonClass(type, className)
  }, rest)), !description && link && label && /*#__PURE__*/React.createElement(ButtonWithoutDescription, _extends({
    settings: settings,
    buttonClass: buttonClass(type, className)
  }, rest)));
};
var ButtonsBar = function ButtonsBar(_ref) {
  var button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    show_buttons = _ref.show_buttons;
  return (button_1.label !== "" || button_2.label !== "") && /*#__PURE__*/React.createElement("div", {
    className: "menu-buttons " + (show_buttons === "permanent" ? "show-buttons" : "")
  }, button_1.label !== "" ? /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1,
    className: "btn-small"
  }) : "", button_2.label !== "" ? /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2,
    className: "btn-small"
  }) : "");
};
ButtonsBar.defaultProps = {
  button_2: {}
};
var throttle = function throttle(func, limit) {
  var inThrottle;
  return function () {
    var args = arguments;
    var context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(function () {
        return inThrottle = false;
      }, limit);
    }
  };
};
var getMenuElement = function getMenuElement(menuLinksElement) {
  return menuLinksElement.parentElement.parentElement;
};
var getTargetSections = function getTargetSections(anchorsList) {
  var nodes = [];
  anchorsList.map(function (anchor) {
    return anchor.slice(1);
  }).forEach(function (anchor) {
    var element = document.getElementById(anchor);
    if (anchor !== "top" && element !== null) {
      nodes.push({
        anchor: anchor,
        offset: element.offsetTop
      });
    }
  });
  nodes.sort(function (a, b) {
    if (a.offset > b.offset) {
      return 1;
    }
    if (a.offset === b.offset) {
      return 0;
    }
    if (a.offset < b.offset) {
      return -1;
    }
  });
  return nodes;
};
var setMenuActiveClass = function setMenuActiveClass(anchorId, markActiveSection, anchorsList) {
  var activeAnchor = anchorsList.find(function (item) {
    var itemAnchor = item.slice(1);
    if (anchorId === itemAnchor) return item;
  });
  markActiveSection(activeAnchor);
};
var handleSingleElement = function handleSingleElement(currentOffset, element) {
  if (currentOffset < element.offset) {
    return "";
  } else {
    return element.anchor;
  }
};
var handleMultipleElements = function handleMultipleElements(currentOffset, elements) {
  for (var i = 0; i < elements.length - 1; i++) {
    if (i === elements.length - 2 && currentOffset >= elements[i + 1].offset) {
      return elements[i + 1].anchor;
    }
    if (currentOffset >= elements[i].offset && currentOffset < elements[i + 1].offset) {
      return elements[i].anchor;
    }
  }
  return "";
};
var setActiveSectionEvent = function setActiveSectionEvent(anchorsList, markActiveSection, element) {
  var menuHeight = getMenuElement(element).offsetHeight;
  window.addEventListener("scroll", throttle(function (_event) {
    var targetSections = getTargetSections(anchorsList);
    var currentOffset = window.pageYOffset + 3 * menuHeight;
    if (targetSections.length === 0) {
      setMenuActiveClass("", markActiveSection, anchorsList);
    }
    if (targetSections.length === 1) {
      var result = handleSingleElement(currentOffset, targetSections[0]);
      setMenuActiveClass(result, markActiveSection, anchorsList);
    }
    if (targetSections.length > 1) {
      var _result = handleMultipleElements(currentOffset, targetSections);
      setMenuActiveClass(_result, markActiveSection, anchorsList);
    }
  }, 100));
};
var LogoMobile = function LogoMobile(_ref) {
  var logo_anchor = _ref.logo_anchor,
    image = _ref.image;
  return /*#__PURE__*/React.createElement("li", {
    className: "submenu-logo-wrapper mobile-link"
  }, /*#__PURE__*/React.createElement(A, {
    href: logo_anchor !== "" ? logo_anchor : "#top",
    className: "submenu-logo",
    style: {
      backgroundImage: "url(" + imageSrc(image, "original") + ")"
    }
  }));
};
var ButtonsBarMobile = function ButtonsBarMobile(_ref) {
  var button_1 = _ref.button_1,
    button_2 = _ref.button_2;
  return (button_1.label !== "" || button_2.label !== "") && /*#__PURE__*/React.createElement(React.Fragment, null, button_1.label && /*#__PURE__*/React.createElement("li", {
    className: "main-menu-link mobile-link"
  }, " ", /*#__PURE__*/React.createElement(A, {
    href: button_1.link
  }, button_1.label)), button_2.label && /*#__PURE__*/React.createElement("li", {
    className: "main-menu-link mobile-link"
  }, " ", /*#__PURE__*/React.createElement(A, {
    href: button_2.link
  }, button_2.label)));
};
var moveToElement = function moveToElement(elementId, menuLinksRef) {
  if (!elementId) {
    return;
  }
  var element = document.getElementById(elementId.replace("#", ""));
  if (!element) {
    return;
  }
  var menuHeight = getMenuElement(menuLinksRef).offsetHeight;
  window.scrollTo({
    left: 0,
    top: element.offsetTop - menuHeight
  });
  window.history.replaceState(null, null, elementId);
};
var MenuLinks = function MenuLinks(_ref) {
  var image = _ref.image,
    logo_variant_mobile = _ref.logo_variant_mobile,
    logo_anchor = _ref.logo_anchor,
    list = _ref.list,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    show_search = _ref.show_search,
    onSearchShow = _ref.onSearchShow;
  var _useState = useState(""),
    activeSection = _useState[0],
    setActiveSection = _useState[1];
  var anchorsList = list.filter(function (item) {
    return item.url.charAt(0) == "#";
  }).map(function (item) {
    return item.url;
  });
  var linksWrapperRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    setActiveSectionEvent(anchorsList, setActiveSection, linksWrapperRef.current);
  }, []);
  return /*#__PURE__*/React.createElement("ul", {
    className: "menu-cnt",
    ref: linksWrapperRef
  }, image !== "" && logo_variant_mobile === "yes" ? /*#__PURE__*/React.createElement(LogoMobile, {
    logo_anchor: logo_anchor,
    image: image
  }) : null, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx,
      className: "main-menu-link"
    }, item.url.startsWith("#") ? /*#__PURE__*/React.createElement(A, {
      href: item.url,
      className: activeSection === item.url ? "active" : "",
      onClick: function onClick(e) {
        e.preventDefault();
        moveToElement(item.url, linksWrapperRef.current);
        setActiveSection(item.url);
      }
    }, item.title) : /*#__PURE__*/React.createElement(A, {
      href: item.url
    }, item.title));
  }), /*#__PURE__*/React.createElement(ButtonsBarMobile, {
    button_1: button_1,
    button_2: button_2
  }), show_search === "yes" && /*#__PURE__*/React.createElement("li", {
    className: "main-menu-link desktop-search-trigger"
  }, /*#__PURE__*/React.createElement("span", {
    className: "search-trigger-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-search search-trigger",
    onClick: function onClick() {
      return onSearchShow(true);
    }
  }))));
};
var Logo$1 = function Logo(_ref) {
  var logo_anchor = _ref.logo_anchor,
    logo_variant = _ref.logo_variant,
    image = _ref.image;
  return image && /*#__PURE__*/React.createElement("a", {
    href: logo_anchor !== "" ? logo_anchor : "#top",
    className: "submenu-logo " + (logo_variant === "on_scroll" ? "logo-menu-sticky" : ""),
    style: {
      backgroundImage: "url(" + imageSrc(image, "original") + ")"
    }
  });
};
var setSmoothAnimation = function setSmoothAnimation(from, to, time, container) {
  var start = new Date().getTime();
  var timer = setInterval(function () {
    var step = Math.min(1, (new Date().getTime() - start) / time);
    var positionX = from + step * (to - from);
    container.scrollLeft = positionX;
    if (step == 1) clearInterval(timer);
  }, 25);
  container.scrollLeft = from;
};
var setArrowsNavigation = function setArrowsNavigation(menuContainer, setLeftAttowVisibility, setRightAttowVisibility) {
  var menuCnt = menuContainer.getElementsByClassName("menu-cnt").item(0);
  if (menuCnt.scrollWidth > window.innerWidth) setRightAttowVisibility(true);
  menuCnt.addEventListener("scroll", function () {
    if (menuCnt.scrollLeft > 0) setLeftAttowVisibility(true);
    if (menuCnt.scrollLeft === 0) setLeftAttowVisibility(false);
    if (menuCnt.scrollWidth - window.innerWidth === menuCnt.scrollLeft) {
      setRightAttowVisibility(false);
    } else {
      setRightAttowVisibility(true);
    }
  });
};
var setArrowClick = function setArrowClick(menuContainer, scrollPosition, onClick, direction) {
  var linksContainer = menuContainer.getElementsByClassName("menu-cnt").item(0);
  var newScrollPosition = scrollPosition;
  if (direction === "right") newScrollPosition += 100;
  if (direction === "left") newScrollPosition -= 100;
  onClick(newScrollPosition);
  setSmoothAnimation(linksContainer.scrollLeft, newScrollPosition, 300, linksContainer);
};
var SubMenuSearch = /*#__PURE__*/function (_React$Component) {
  function SubMenuSearch(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      articles: [],
      q: props.q || "",
      dirty: false
    };
    return _this;
  }
  _inheritsLoose(SubMenuSearch, _React$Component);
  var _proto = SubMenuSearch.prototype;
  _proto.handleProductSearch = function handleProductSearch(q) {
    var _this2 = this;
    var searchUrl = this.props.searchUrl;
    this.setState({
      q: q,
      articles: []
    }, function () {
      if (q.length < 3) {
        _this2.setState({
          dirty: false
        });
        return;
      }
      fetch(searchUrl + "?q=" + q, {
        headers: {
          Accept: "application/json"
        }
      }).then(function (r) {
        return r.json();
      }).then(function (articles) {
        _this2.setState({
          articles: articles
        });
        _this2.setState({
          dirty: true
        });
      });
    });
  };
  _proto.handleGoToArticle = function handleGoToArticle(articleName) {
    var _this$state = this.state,
      articles = _this$state.articles;
    var selectedArticle = articles.find(function (item) {
      return item.title === articleName;
    });
    if (typeof window !== "undefined") window.location.href = selectedArticle.url;
  };
  _proto.handleSubmit = function handleSubmit(e) {
    if (this.state.q === "") {
      e.preventDefault();
    }
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      searchUrl = _this$props.searchUrl,
      placeholder = _this$props.placeholder;
    var _this$state2 = this.state,
      q = _this$state2.q,
      articles = _this$state2.articles,
      dirty = _this$state2.dirty;
    var menuStyle = {
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
      background: "#fff",
      position: "absolute",
      top: "auto",
      overflow: "auto",
      left: "3em",
      right: "3em",
      color: "#000"
    };
    var itemsLimit = 6;
    var totalItems = articles.length;
    var itemsToRender = articles.slice(0, itemsLimit);
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: function onSubmit(e) {
        return _this3.handleSubmit(e);
      },
      method: "get",
      action: searchUrl
    }, /*#__PURE__*/React.createElement(Autocomplete, {
      getItemValue: function getItemValue(item) {
        return item.title;
      },
      items: itemsToRender,
      renderMenu: function renderMenu(items, value, style) {
        return /*#__PURE__*/React.createElement("div", {
          style: _extends({}, style, menuStyle)
        }, items, totalItems > itemsLimit && /*#__PURE__*/React.createElement("button", {
          type: "submit",
          className: "btn-text",
          style: {
            paddingLeft: "1em"
          }
        }, "See all results (", totalItems, ")"), totalItems === 0 && dirty === true && /*#__PURE__*/React.createElement("div", {
          style: {
            padding: "1em"
          }
        }, "No results found."));
      },
      renderItem: function renderItem(item, isHighlighted) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.id,
          style: {
            padding: "1em",
            cursor: "pointer",
            background: isHighlighted ? "lightgray" : "#fff"
          }
        }, item.title, " ", /*#__PURE__*/React.createElement("small", {
          className: "category-name",
          style: {
            color: "#aaaab3"
          }
        }, " ", "- ", item.category));
      },
      value: q,
      onChange: function onChange(e) {
        return _this3.handleProductSearch(e.target.value);
      },
      onSelect: function onSelect(articleName) {
        return _this3.handleGoToArticle(articleName);
      },
      inputProps: {
        placeholder: placeholder
      },
      wrapperStyle: {
        display: "inline-block",
        width: "100%"
      },
      menuStyle: menuStyle
    }), /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: "icon-search"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "q",
      value: q
    }));
  };
  return SubMenuSearch;
}(React.Component);
var Search = function Search(_ref) {
  var show_search = _ref.show_search,
    search_url = _ref.search_url,
    search_placeholder = _ref.search_placeholder,
    onSearchShow = _ref.onSearchShow,
    isSearchVisible = _ref.isSearchVisible;
  var searchRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    if (isSearchVisible) searchRef.current.querySelector(".search input").focus();
  });
  return show_search === "yes" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "search-trigger-wrapper mobile-search-trigger"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-search search-trigger",
    onClick: function onClick() {
      return onSearchShow(true);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "search-wrapper",
    ref: searchRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "search"
  }, /*#__PURE__*/React.createElement(SubMenuSearch, {
    searchUrl: search_url,
    q: "",
    placeholder: search_placeholder
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-close search-close",
    onClick: function onClick() {
      return onSearchShow(false);
    }
  }))));
};
var NavigationArrow = function NavigationArrow(_ref) {
  var _onClick = _ref.onClick,
    arrowPosition = _ref.arrowPosition,
    isVisible = _ref.isVisible;
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return _onClick();
    },
    className: "fade-" + arrowPosition + " icon-arrow-" + arrowPosition + " " + (isVisible ? 'show' : '')
  });
};
var setObserver = function setObserver(element) {
  if (typeof window.IntersectionObserver !== "function") {
    return;
  }
  new window.IntersectionObserver(function (entries, _observer) {
    for (var _i = 0; _i < entries.length; _i++) {
      var stickyHeader = entries[_i].target.nextSibling;
      stickyHeader.toggleAttribute("stuck", !entries[_i].isIntersecting);
    }
  }, {}).observe(element);
};
var Widget$3 = function Widget(_ref) {
  var image = _ref.image,
    logo_variant = _ref.logo_variant,
    list = _ref.list,
    _ref$button_ = _ref.button_1,
    button_1 = _ref$button_ === void 0 ? {} : _ref$button_,
    _ref$button_2 = _ref.button_2,
    button_2 = _ref$button_2 === void 0 ? {} : _ref$button_2,
    _ref$logo_anchor = _ref.logo_anchor,
    logo_anchor = _ref$logo_anchor === void 0 ? "" : _ref$logo_anchor,
    logo_variant_mobile = _ref.logo_variant_mobile,
    show_buttons = _ref.show_buttons,
    show_search = _ref.show_search,
    search_url = _ref.search_url,
    search_placeholder = _ref.search_placeholder,
    containerSettings = _ref.containerSettings;
  var _useState = useState(false),
    isLeftArrowVisible = _useState[0],
    setLeftAttowVisibility = _useState[1];
  var _useState2 = useState(false),
    isRightArrowVisible = _useState2[0],
    setRightAttowVisibility = _useState2[1];
  var _useState3 = useState(0),
    scrollPosition = _useState3[0],
    setScrollPosition = _useState3[1];
  var _useState4 = useState(false),
    isSearchVisible = _useState4[0],
    setSearchVisibe = _useState4[1];
  var menuRef = /*#__PURE__*/React.createRef();
  var markerRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    setArrowsNavigation(menuRef.current, setLeftAttowVisibility, setRightAttowVisibility);
    if (markerRef.current) {
      setObserver(markerRef.current);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: markerRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "menu-outer"
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    ref: menuRef,
    className: "menu sticky-menu " + (isSearchVisible ? "show-search" : "")
  }, /*#__PURE__*/React.createElement(Logo$1, {
    logo_anchor: logo_anchor,
    logo_variant: logo_variant,
    image: image
  }), /*#__PURE__*/React.createElement("nav", {
    className: "" + (list.length === 0 ? "menu-no-links" : "")
  }, /*#__PURE__*/React.createElement(NavigationArrow, {
    onClick: function onClick() {
      return setArrowClick(menuRef.current, scrollPosition, setScrollPosition, "left");
    },
    arrowPosition: "left",
    isVisible: isLeftArrowVisible
  }), /*#__PURE__*/React.createElement(MenuLinks, {
    image: image,
    logo_variant_mobile: logo_variant_mobile,
    logo_anchor: logo_anchor,
    list: list,
    button_1: button_1,
    button_2: button_2,
    show_search: show_search,
    isSearchVisible: isSearchVisible,
    onSearchShow: setSearchVisibe
  }), /*#__PURE__*/React.createElement(NavigationArrow, {
    onClick: function onClick() {
      return setArrowClick(menuRef.current, scrollPosition, setScrollPosition, "right");
    },
    arrowPosition: "right",
    isVisible: isRightArrowVisible
  }), /*#__PURE__*/React.createElement(ButtonsBar, {
    button_1: button_1,
    button_2: button_2,
    show_buttons: show_buttons
  }), /*#__PURE__*/React.createElement(Search, {
    show_search: show_search,
    search_url: search_url,
    search_placeholder: search_placeholder,
    isSearchVisible: isSearchVisible,
    onSearchShow: setSearchVisibe
  }))))));
};
var Config$3 = {
  title: "Sub Menu (advanced)",
  category: "Navigation"
};
var Defaults$3 = {
  image: imagePlaceholder("200x200"),
  logo_variant: "on_scroll",
  logo_variant_mobile: "yes",
  show_buttons: "on_scroll",
  show_search: "no",
  search_url: "",
  search_placeholder: "",
  list: [{
    id: 1,
    title: "Item 1",
    url: "link",
    items: []
  }, {
    id: 2,
    title: "Item 2",
    url: "link",
    items: []
  }, {
    id: 3,
    title: "Item 3",
    url: "link",
    items: []
  }, {
    id: 4,
    title: "Item 4",
    url: "link",
    items: []
  }],
  button_1: {},
  button_2: {},
  logo_anchor: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$3 = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(AdminFields, {
    items: items,
    onChange: onChange,
    settings: settings
  });
};
var AdvancedSubMenuWidget = {
  __proto__: null,
  Widget: Widget$3,
  Admin: Admin$3,
  Config: Config$3,
  Defaults: Defaults$3
};
var menuStyle = {
  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
  background: "#fff",
  position: "absolute",
  top: "auto",
  overflow: "auto",
  left: "0",
  zIndex: "5"
};
var Search$1 = function Search(_ref) {
  var searchUrl = _ref.searchUrl,
    placeholder = _ref.placeholder,
    q = _ref.q,
    allResults = _ref.allResults;
  var _React$useState = React.useState(q),
    term = _React$useState[0],
    setTerm = _React$useState[1];
  var _React$useState2 = React.useState([]),
    results = _React$useState2[0],
    setResults = _React$useState2[1];
  var handleSearch = function handleSearch(newTerm) {
    setTerm(newTerm);
    if (newTerm.length < 3) return;
    fetch(searchUrl + "?q=" + newTerm, {
      headers: {
        Accept: "application/json"
      }
    }).then(function (r) {
      return r.json();
    }).then(function (data) {
      return setResults(data);
    });
  };
  var handleGoToItem = function handleGoToItem(itemName) {
    var selectedItem = results.find(function (item) {
      return item.title === itemName;
    });
    if (typeof window !== "undefined") window.location.href = selectedItem.url;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "search-wrapper"
  }, /*#__PURE__*/React.createElement("form", {
    method: "get",
    action: searchUrl
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    getItemValue: function getItemValue(item) {
      return item.title;
    },
    items: results,
    renderMenu: function renderMenu(items, _value, style) {
      return /*#__PURE__*/React.createElement("div", {
        style: _extends({}, style, menuStyle)
      }, items.slice(0, 6), items.length > 6 && /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "see-all"
      }, allResults.replace("{RESULTS_COUNT}", items.length)));
    },
    renderItem: function renderItem(item, isHighlighted) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          padding: "1em",
          cursor: "pointer",
          background: isHighlighted ? "lightgray" : "white"
        },
        key: item.id
      }, item.title, " ", item.faq_category && /*#__PURE__*/React.createElement("small", {
        className: "category-name"
      }, " ", "- ", item.faq_category.name), item.category && /*#__PURE__*/React.createElement("small", {
        className: "category-name"
      }, " - ", item.category));
    },
    value: term,
    onChange: function onChange(e) {
      return handleSearch(e.target.value);
    },
    onSelect: function onSelect(itemName) {
      return handleGoToItem(itemName);
    },
    inputProps: {
      placeholder: placeholder
    },
    wrapperStyle: {
      display: "inline-block",
      width: "100%"
    },
    menuStyle: menuStyle
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "icon-search"
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "q",
    value: term
  })));
};
var Widget$4 = function Widget(_ref) {
  var placeholder = _ref.placeholder,
    searchUrl = _ref.searchUrl,
    allResults = _ref.allResults,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "autocomplete-widget",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-shift-3"
  }, /*#__PURE__*/React.createElement(Search$1, {
    placeholder: placeholder,
    searchUrl: searchUrl,
    q: "",
    allResults: allResults
  }))));
};
var Config$4 = {
  title: "Autocomplete",
  category: "Forms"
};
var Defaults$4 = {
  placeholder: "Search Chaos Group FAQ",
  searchUrl: "/support/faq/search",
  allResults: "See all results ({RESULTS_COUNT})",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$4 = {
  placeholder: {
    type: "text"
  },
  searchUrl: {
    type: "text"
  },
  allResults: {
    type: "text",
    hint: "Replaces the {RESULTS_COUNT} token with the number of results found."
  }
};
var AutocompleteWidget = {
  __proto__: null,
  Widget: Widget$4,
  Admin: Admin$4,
  Config: Config$4,
  Defaults: Defaults$4
};
var Widget$5 = /*#__PURE__*/function (_React$Component) {
  function Widget() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(Widget, _React$Component);
  var _proto = Widget.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      variant = _this$props.variant,
      _this$props$credits = _this$props.credits,
      credits = _this$props$credits === void 0 ? "" : _this$props$credits,
      before_image = _this$props.before_image,
      after_image = _this$props.after_image,
      containerSettings = _this$props.containerSettings;
    return /*#__PURE__*/React.createElement(Container$1, {
      settings: containerSettings
    }, /*#__PURE__*/React.createElement("div", {
      className: variant === "medium" || variant === "small" ? "container" : ""
    }, /*#__PURE__*/React.createElement("div", {
      className: variant === "small" ? "col-shift-2" : ""
    }, /*#__PURE__*/React.createElement("div", {
      className: "slider-before-after"
    }, /*#__PURE__*/React.createElement(ReactCompareImage, {
      leftImage: imageSrc(before_image, "full_width_original"),
      rightImage: imageSrc(after_image, "full_width_original")
    }), credits !== "" ? /*#__PURE__*/React.createElement("span", {
      className: "credits"
    }, credits) : ""))));
  };
  return Widget;
}(React.Component);
var Config$5 = {
  title: "Before/After Slider",
  category: "Sliders"
};
var Defaults$5 = {
  variant: "full_width",
  credits: "",
  before_image: imagePlaceholder("1920x1070"),
  after_image: imagePlaceholder("1920x1070"),
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$5 = {
  variant: {
    type: "select",
    options: [["full_width", "Full Width"], ["medium", "Medium"], ["small", "Small"]]
  },
  credits: {
    type: "text"
  },
  before_image: {
    type: "custom",
    component: ImagePicker
  },
  after_image: {
    type: "custom",
    component: ImagePicker
  }
};
var BeforeAfterSliderWidget = {
  __proto__: null,
  Widget: Widget$5,
  Admin: Admin$5,
  Config: Config$5,
  Defaults: Defaults$5
};
var Widget$6 = function Widget(_ref) {
  var variant = _ref.variant,
    list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "icons-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "items-wrapper " + (variant === "two_columns" ? "icons-2" : "icons-3")
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "item-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "item-icon"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: item.image,
      variant: "original"
    })), /*#__PURE__*/React.createElement("h5", {
      className: "item-title"
    }, item.title), parseMarkdown(item.description));
  })))));
};
var Config$6 = {
  title: "Benefits with Icons",
  category: "Image + Text"
};
var Defaults$6 = {
  variant: "two_columns",
  list: [{
    image: imagePlaceholder("200x200"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam officiis unde voluptatem iusto repudiandae eum distinctio assumenda modi magni dolorem!"
  }, {
    image: imagePlaceholder("200x200"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam officiis unde voluptatem iusto repudiandae eum distinctio assumenda modi magni dolorem!"
  }],
  containerSettings: {
    theme: "white",
    spacing: "both"
  }
};
var IconField = function IconField(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }));
};
IconField.defaultProps = {
  settings: {}
};
var Admin$6 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["two_columns", "Two Columns"], ["three_columns", "Three Columns"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(IconField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      image: imagePlaceholder("200x200"),
      title: "Item title",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam officiis unde voluptatem iusto repudiandae eum distinctio assumenda modi magni dolorem!"
    },
    primaryField: "title"
  }));
};
var BenefitsWithIconsWidget = {
  __proto__: null,
  Widget: Widget$6,
  Admin: Admin$6,
  Config: Config$6,
  Defaults: Defaults$6
};
function formatInitialValue(value) {
  if (!value) {
    return [];
  }
  if (typeof value === "string") {
    return [value];
  }
  return Array.from(value).filter(Boolean);
}
var TagsPicker = function TagsPicker(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var _React$useState = React.useState(formatInitialValue(value)),
    state = _React$useState[0],
    setState = _React$useState[1];
  return /*#__PURE__*/React.createElement(Query, {
    query: TAGS
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var tags = data.tags;
    var options = tags.list.map(function (e) {
      return [e.id, e.name];
    });
    return /*#__PURE__*/React.createElement(GroupCheckbox, {
      checkboxes: options,
      label: "Tags",
      onChange: function onChange(newValue) {
        setState(newValue);
        _onChange(newValue);
      },
      value: state
    });
  });
};
var ProductsPicker = /*#__PURE__*/function (_React$Component) {
  function ProductsPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      product: _this.props.value
    };
    return _this;
  }
  _inheritsLoose(ProductsPicker, _React$Component);
  var _proto = ProductsPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    var newValue = value;
    this.props.onChange(newValue);
    this.setState({
      product: newValue
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var product = this.state.product;
    return /*#__PURE__*/React.createElement(Query, {
      query: PRODUCTS
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var products = data.products;
      var options = products.list.map(function (e) {
        return [e.id, e.name];
      });
      return /*#__PURE__*/React.createElement(SelectMenu, {
        label: "products",
        options: options,
        value: product,
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        }
      });
    });
  };
  return ProductsPicker;
}(React.Component);
var MagazineCategoriesPicker = /*#__PURE__*/function (_React$Component) {
  function MagazineCategoriesPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }
  _inheritsLoose(MagazineCategoriesPicker, _React$Component);
  var _proto = MagazineCategoriesPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    this.setState({
      value: value
    });
    this.props.onChange(value);
  };
  _proto.render = function render() {
    var _this2 = this;
    var value = this.state.value;
    return /*#__PURE__*/React.createElement(Query, {
      query: MAGAZINE_CATEGORIES
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var magazineCategories = data.magazineCategories;
      var options = magazineCategories.list.map(function (e) {
        return [e.id, e.name];
      });
      return /*#__PURE__*/React.createElement(GroupCheckbox, {
        checkboxes: options,
        label: "Categories",
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        },
        value: value
      });
    });
  };
  return MagazineCategoriesPicker;
}(React.Component);
var formatSimpleDate = function formatSimpleDate(date) {
  return [date.getFullYear(), (date.getMonth() + 1).toString().padStart(2, "0"), date.getDate().toString().padStart(2, "0")].join("-");
};
var formatDate = function formatDate(dateString, format) {
  if (format === void 0) {
    format = false;
  }
  if (format) {
    return moment(new Date(dateString)).utc().format(format);
  } else {
    return moment(new Date(dateString)).utc().format();
  }
};
var formatDateTime = function formatDateTime(dateTimeString, timezone, format) {
  if (format === void 0) {
    format = false;
  }
  if (format) {
    return moment(new Date(dateTimeString)).tz(timezone).format(format);
  } else {
    return moment(new Date(dateTimeString)).tz(timezone).format();
  }
};
var podcastTimeFormatter = function podcastTimeFormatter(seconds) {
  return moment("2015-01-01").startOf("day").seconds(seconds).format("H:mm:ss");
};
var thumbsClass = {
  "2_columns": "previews-2",
  "3_columns": "previews-3",
  "4_columns": "previews-4"
};
var FeedArticle = function FeedArticle(_ref) {
  var url = _ref.url,
    image = _ref.image,
    publishOn = _ref.publishOn,
    magazineCategory = _ref.magazineCategory,
    title = _ref.title,
    variant = _ref.variant,
    description = _ref.description,
    show_meta = _ref.show_meta;
  return /*#__PURE__*/React.createElement("article", {
    className: "article-preview " + thumbsClass[variant]
  }, image && /*#__PURE__*/React.createElement("div", {
    className: "article-image"
  }, /*#__PURE__*/React.createElement(A, {
    href: url
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: image,
    variant: "articles_2_columns"
  }))), show_meta === "yes" && /*#__PURE__*/React.createElement("p", {
    className: "article-meta"
  }, /*#__PURE__*/React.createElement(A, {
    href: magazineCategory.url,
    className: "category"
  }, magazineCategory.name), /*#__PURE__*/React.createElement("time", {
    dateTime: formatDate(publishOn)
  }, formatDate(publishOn, "ll"))), /*#__PURE__*/React.createElement("h4", {
    className: "article-title"
  }, /*#__PURE__*/React.createElement(A, {
    href: url
  }, title)), /*#__PURE__*/React.createElement("p", {
    className: "article-short-desc"
  }, description));
};
var Placeholder = function Placeholder(_ref) {
  var realComponent = _ref.realComponent,
    placeholderComponent = _ref.placeholderComponent,
    ready = _ref.ready,
    data = _ref.data;
  var PlaceholderComponent = placeholderComponent;
  var customPlaceholderData = data || {};
  var RealComponent = realComponent;
  return /*#__PURE__*/React.createElement("div", {
    className: "show-loading-animation"
  }, /*#__PURE__*/React.createElement(ReactPlaceholder, {
    ready: !ready,
    customPlaceholder: /*#__PURE__*/React.createElement(PlaceholderComponent, customPlaceholderData),
    showLoadingAnimation: true
  }, ready === false && /*#__PURE__*/React.createElement(RealComponent, null)));
};
var colors = {
  lightBlue: "#f1f5f9",
  darkGray: "#555555"
};
var thumbsClass$1 = {
  "2_columns": "previews-2",
  "3_columns": "previews-3",
  "4_columns": "previews-4"
};
var thumbsHeight = {
  "2_columns": 380,
  "3_columns": 250,
  "4_columns": 180
};
var numToArray = function numToArray(num) {
  return Array.from(Array(num).keys());
};
var ThumbsWhithText = function ThumbsWhithText(_ref) {
  var variant = _ref.variant,
    lines = _ref.lines;
  return /*#__PURE__*/React.createElement(React.Fragment, null, numToArray(lines).map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: thumbsClass$1[variant],
      style: {
        marginBottom: "2em"
      }
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: "100%",
        height: thumbsHeight[variant]
      }
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
      rows: 3,
      color: colors.lightBlue
    }));
  }));
};
var ThumbsWhithTextPlaceholder = function ThumbsWhithTextPlaceholder(_ref2) {
  var realComponent = _ref2.realComponent,
    ready = _ref2.ready,
    variant = _ref2.variant,
    _ref2$lines = _ref2.lines,
    lines = _ref2$lines === void 0 ? 8 : _ref2$lines;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    data: {
      variant: variant,
      lines: lines
    },
    placeholderComponent: ThumbsWhithText,
    realComponent: realComponent
  });
};
var FeedArticleSlide = function FeedArticleSlide(_ref) {
  var url = _ref.url,
    image = _ref.image,
    publishOn = _ref.publishOn,
    magazineCategory = _ref.magazineCategory,
    title = _ref.title,
    description = _ref.description,
    show_meta = _ref.show_meta;
  return /*#__PURE__*/React.createElement("article", {
    className: "swiper-slide"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-preview"
  }, image && /*#__PURE__*/React.createElement("div", {
    className: "article-image"
  }, /*#__PURE__*/React.createElement(A, {
    href: url
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: image,
    variant: "articles_2_columns"
  }))), show_meta === "yes" && /*#__PURE__*/React.createElement("p", {
    className: "article-meta"
  }, /*#__PURE__*/React.createElement(A, {
    href: magazineCategory.url,
    className: "category"
  }, magazineCategory.name), /*#__PURE__*/React.createElement("time", {
    dateTime: formatDate(publishOn)
  }, formatDate(publishOn, "ll"))), /*#__PURE__*/React.createElement("h4", {
    className: "article-title"
  }, /*#__PURE__*/React.createElement(A, {
    href: url
  }, title)), /*#__PURE__*/React.createElement("p", {
    className: "article-short-desc"
  }, description)));
};
var thumbsClass$2 = {
  "2_columns": 2,
  "3_columns": 3,
  "4_columns": 4
};
var FeedArticleSlider = function FeedArticleSlider(_ref) {
  var articles = _ref.articles,
    variant = _ref.variant,
    show_meta = _ref.show_meta;
  var _React$useState = React.useState(),
    swiper = _React$useState[0],
    setSwiper = _React$useState[1];
  var handlePrevious = function handlePrevious() {
    return swiper && swiper.slidePrev();
  };
  var handleNext = function handleNext() {
    return swiper && swiper.slideNext();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "feed-article-wrapper"
  }, /*#__PURE__*/React.createElement(Slider, {
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    paginationClickable: true,
    loop: true,
    speed: 500,
    breakpoints: {
      599: {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 30
      },
      600: {
        slidesPerView: thumbsClass$2[variant],
        slidesPerGroup: 4,
        spaceBetween: 30
      }
    },
    getSwiper: setSwiper
  }, articles.list.map(function (article) {
    return /*#__PURE__*/React.createElement(FeedArticleSlide, {
      key: article.id,
      id: article.id,
      url: article.url,
      image: article.image,
      title: article.title,
      description: article.description,
      publishOn: article.publish_on,
      magazineCategory: article.magazine_category,
      show_meta: show_meta
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "custom-swiper-button-prev icon-arrow-left",
    onClick: handlePrevious
  }), /*#__PURE__*/React.createElement("div", {
    className: "custom-swiper-button-next icon-arrow-right",
    onClick: handleNext
  }));
};
var thumbsClass$3 = {
  "2_columns": "previews-2",
  "3_columns": "previews-3",
  "4_columns": "previews-4"
};
var thumbsHeight$1 = {
  "2_columns": 380,
  "3_columns": 250,
  "4_columns": 180
};
var ThumbsWhithText$1 = function ThumbsWhithText(_ref) {
  var variant = _ref.variant;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "3em"
    }
  }, [1, 2, 3, 4].map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      className: thumbsClass$3[variant],
      style: {
        width: "25%"
      }
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: "100%",
        height: thumbsHeight$1[variant]
      }
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
      rows: 3,
      color: colors.lightBlue
    }));
  })));
};
var CarouselPlaceholder = function CarouselPlaceholder(_ref2) {
  var realComponent = _ref2.realComponent,
    ready = _ref2.ready,
    variant = _ref2.variant;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    data: {
      variant: variant
    },
    placeholderComponent: ThumbsWhithText$1,
    realComponent: realComponent
  });
};
var FeedPreview = function FeedPreview(_ref) {
  var variant = _ref.variant,
    limit = _ref.limit,
    offset = _ref.offset,
    tags = _ref.tags,
    product = _ref.product,
    categories = _ref.categories,
    carousel = _ref.carousel,
    show_meta = _ref.show_meta;
  return /*#__PURE__*/React.createElement(Query, {
    query: ARTICLES,
    variables: {
      input: {
        limit: parseInt(limit, 10),
        offset: parseInt(offset, 10),
        filters: {
          tags: tags,
          product: product,
          categories: categories
        }
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var articles = data.articles;
    return carousel === "yes" ? /*#__PURE__*/React.createElement(CarouselPlaceholder, {
      ready: loading,
      variant: variant,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(FeedArticleSlider, {
          articles: articles,
          variant: variant,
          show_meta: show_meta
        });
      }
    }) : /*#__PURE__*/React.createElement(ThumbsWhithTextPlaceholder, {
      ready: loading,
      variant: variant,
      realComponent: function realComponent() {
        return articles.list.map(function (article) {
          return /*#__PURE__*/React.createElement(FeedArticle, {
            key: article.id,
            id: article.id,
            url: article.url,
            image: article.image,
            title: article.title,
            description: article.description,
            publishOn: article.publish_on,
            magazineCategory: article.magazine_category,
            variant: variant,
            show_meta: show_meta
          });
        });
      }
    });
  });
};
function formatTags(tag) {
  if (!tag) {
    return [];
  }
  if (Array.isArray(tag)) {
    return tag.filter(Boolean);
  }
  return [tag];
}
var Widget$7 = function Widget(_ref) {
  var variant = _ref.variant,
    _ref$carousel = _ref.carousel,
    carousel = _ref$carousel === void 0 ? "no" : _ref$carousel,
    _ref$show_meta = _ref.show_meta,
    show_meta = _ref$show_meta === void 0 ? "yes" : _ref$show_meta,
    offset = _ref.offset,
    limit = _ref.limit,
    tag = _ref.tag,
    product = _ref.product,
    categories = _ref.categories,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-feed articles-preview-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, categories ? /*#__PURE__*/React.createElement(FeedPreview, {
    offset: offset,
    limit: limit,
    tags: formatTags(tag),
    product: product,
    categories: categories,
    variant: variant,
    carousel: carousel,
    show_meta: show_meta
  }) : /*#__PURE__*/React.createElement("h2", null, "Blog Feed: select articles"))));
};
var Config$7 = {
  title: "Blog Feed",
  category: "Feed"
};
var Defaults$7 = {
  variant: "2_columns",
  carousel: "no",
  show_meta: "yes",
  offset: 0,
  limit: 10,
  tag: "",
  product: "",
  categories: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$7 = {
  show_meta: {
    type: "select",
    options: [["yes", "Yes"], ["no", "No"]]
  },
  variant: {
    type: "select",
    options: [["2_columns", "2 Columns"], ["3_columns", "3 Columns"], ["4_columns", "4 Columns"]]
  },
  carousel: {
    type: "select",
    options: [["yes", "Yes"], ["no", "No"]]
  },
  limit: {
    type: "text"
  },
  offset: {
    type: "text"
  },
  tag: {
    type: "custom",
    component: TagsPicker
  },
  product: {
    type: "custom",
    component: ProductsPicker
  },
  categories: {
    type: "custom",
    component: MagazineCategoriesPicker
  }
};
var BlogFeedWidget = {
  __proto__: null,
  Widget: Widget$7,
  Admin: Admin$7,
  Config: Config$7,
  Defaults: Defaults$7
};
var Widget$8 = function Widget(_ref) {
  var title = _ref.title,
    list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "booth-presentations",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "section-title"
  }, title))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, list.map(function (presentation) {
    return /*#__PURE__*/React.createElement("div", {
      key: presentation.id,
      className: "col-3"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "presentation-title"
    }, presentation.title), parseMarkdown(presentation.description));
  }))));
};
var Config$8 = {
  title: "Booth Presentations",
  category: "Lists"
};
var Defaults$8 = {
  title: "Booth Presentations",
  list: [{
    id: 0,
    title: "Presentation Title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex animi minus atque aut, facere est nesciunt placeat sint harum inventore!"
  }, {
    id: 1,
    title: "Presentation Title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex animi minus atque aut, facere est nesciunt placeat sint harum inventore!"
  }, {
    id: 2,
    title: "Presentation Title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex animi minus atque aut, facere est nesciunt placeat sint harum inventore!"
  }, {
    id: 3,
    title: "Presentation Title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex animi minus atque aut, facere est nesciunt placeat sint harum inventore!"
  }],
  containerSettings: {
    theme: "light",
    spacing: "both"
  }
};
var PresentationField = function PresentationField(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }));
};
PresentationField.defaultProps = {
  settings: {}
};
var Admin$8 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return _onChange("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(PresentationField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: [{
      title: "Presentation Title",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ex animi minus atque aut, facere est nesciunt placeat sint harum inventore!"
    }],
    primaryField: "title"
  }));
};
var BoothPresentationsWidget = {
  __proto__: null,
  Widget: Widget$8,
  Admin: Admin$8,
  Config: Config$8,
  Defaults: Defaults$8
};
var Widget$9 = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    variant = _ref.variant,
    list = _ref.list;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "breadcrumbs-widget",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: variant === "edge" ? "edge-to-edge" : "container"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "breadcrumbs-navigation"
  }, list.map(function (item, index) {
    if (index === list.length - 1) {
      return /*#__PURE__*/React.createElement("span", {
        className: "current",
        key: item.id
      }, item.link.label);
    }
    return /*#__PURE__*/React.createElement(A, {
      key: item.id,
      href: item.link.link,
      id: item.link.id ? item.link.id : "",
      target: item.link.target,
      rel: item.link.rel,
      title: item.link.label,
      className: "link " + item.link.className
    }, item.link.label);
  }))));
};
var Config$9 = {
  title: "Breadcrumbs",
  category: "Navigation"
};
var Defaults$9 = {
  list: [{
    id: 1,
    link: _extends({}, LinkSettings.defaults, {
      label: "Home",
      link: "/"
    })
  }, {
    id: 2,
    link: LinkSettings.defaults
  }, {
    id: 3,
    link: LinkSettings.defaults
  }],
  containerSettings: {
    spacing: "none"
  }
};
var ListItem$1 = function ListItem(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    value: settings.link
  }));
};
var Admin$9 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["default", "Default"], ["edge", "Edge to edge"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    label: "Breadcrumbs",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$1, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: items,
    template: {
      link: LinkSettings.defaults
    },
    primaryField: "link.label",
    onChangeList: _onChange
  }));
};
var BreadcrumbsWidget = {
  __proto__: null,
  Widget: Widget$9,
  Admin: Admin$9,
  Config: Config$9,
  Defaults: Defaults$9
};
var ButtonSettingsWithDescription = /*#__PURE__*/function (_React$Component) {
  function ButtonSettingsWithDescription(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      settings: _this.props.value
    };
    return _this;
  }
  _inheritsLoose(ButtonSettingsWithDescription, _React$Component);
  var _proto = ButtonSettingsWithDescription.prototype;
  _proto.updateButtonSettings = function updateButtonSettings(value) {
    var _this2 = this;
    this.setState({
      settings: value
    }, function () {
      var onChange = _this2.props.onChange;
      var settings = _this2.state.settings;
      onChange(settings);
    });
  };
  _proto.updateDescription = function updateDescription(value) {
    var _this3 = this;
    var settings = this.state.settings;
    var newSettings = Object.assign({}, settings, {
      description: value
    });
    this.setState({
      settings: newSettings
    }, function () {
      var onChange = _this3.props.onChange;
      var settings = _this3.state.settings;
      onChange(settings);
    });
  };
  _proto.handleChange = function handleChange(type, value) {
    type === "buttonSettings" && this.updateButtonSettings(value);
    type === "description" && this.updateDescription(value);
  };
  _proto.render = function render() {
    var _this4 = this;
    var label = this.props.label;
    var settings = this.state.settings;
    return /*#__PURE__*/React.createElement("div", {
      className: "btn-settings-description"
    }, /*#__PURE__*/React.createElement(ButtonSettings, {
      value: settings,
      label: label,
      onChange: function onChange(settings) {
        return _this4.handleChange("buttonSettings", settings);
      }
    }), /*#__PURE__*/React.createElement(TextArea$2, {
      label: "Description",
      onChange: function onChange(description) {
        return _this4.handleChange("description", description);
      },
      value: settings.description
    }));
  };
  return ButtonSettingsWithDescription;
}(React.Component);
var DEFAULTS = {
  label: "Button",
  link: "#",
  id: "",
  type: "primary",
  target: "_self",
  rel: "follow",
  sub_line: ""
};
ButtonSettingsWithDescription.defaultProps = {
  label: "Button",
  value: DEFAULTS
};
ButtonSettingsWithDescription.defaults = DEFAULTS;
var Widget$a = function Widget(_ref) {
  var button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "call-to-action",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1
  }), button_2.label && button_2.link && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2
  })));
};
var Config$a = {
  title: "CTA Button",
  category: "CTA"
};
var Defaults$a = {
  button_1: ButtonSettingsWithDescription.defaults,
  button_2: {},
  containerSettings: {
    theme: "white",
    spacing: "top"
  }
};
var Admin$a = {
  button_1: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button 1"
  },
  button_2: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button 2"
  }
};
var CallToActionWidget = {
  __proto__: null,
  Widget: Widget$a,
  Admin: Admin$a,
  Config: Config$a,
  Defaults: Defaults$a
};
var pickCardClass = function pickCardClass(list, idx, variant) {
  if (variant !== "col-6") {
    return variant;
  }
  if (list.length === 1) {
    return "centered-card";
  }
  return idx % 2 === 0 ? "card-one" : "card-two";
};
var Widget$b = function Widget(_ref) {
  var geoIp = _ref.geoIp,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? "col-6" : _ref$variant,
    list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: (geoIp === null || geoIp === void 0 ? void 0 : geoIp.activeCountries) || [],
    countryGroupIds: (geoIp === null || geoIp === void 0 ? void 0 : geoIp.activeGroups) || [],
    active: (geoIp === null || geoIp === void 0 ? void 0 : geoIp.active) || false
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "products-for-automotive"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, list.map(function (card, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: pickCardClass(list, idx, variant)
    }, /*#__PURE__*/React.createElement("div", {
      className: "product-card"
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-wrapper"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: card.image,
      variant: "original"
    }), parseMarkdown(card.description)), /*#__PURE__*/React.createElement("div", {
      className: "btn-wrapper"
    }, /*#__PURE__*/React.createElement(Button$1, {
      className: "btn-card",
      settings: card.button
    }), (card === null || card === void 0 ? void 0 : card.button_2) && /*#__PURE__*/React.createElement(Button$1, {
      className: "btn-card",
      settings: card.button_2
    }))));
  }))))));
};
var Config$b = {
  title: "Cards",
  category: "Image + Text"
};
var Defaults$b = {
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  variant: "col-6",
  list: [{
    image: imagePlaceholder("200x200"),
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam temporibus aut possimus alias ea, dolores libero at totam iure ex!",
    button: ButtonSettingsWithDescription.defaults,
    button_2: ButtonSettingsWithDescription.defaults
  }, {
    image: imagePlaceholder("200x200"),
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam temporibus aut possimus alias ea, dolores libero at totam iure ex!",
    button: ButtonSettingsWithDescription.defaults,
    button_2: ButtonSettingsWithDescription.defaults
  }],
  containerSettings: {
    theme: "white",
    spacing: "bottom"
  }
};
var CardField = function CardField(_ref2) {
  var _ref2$settings = _ref2.settings,
    settings = _ref2$settings === void 0 ? {} : _ref2$settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(ButtonSettingsWithDescription, {
    label: "Button",
    value: settings.button,
    onChange: function onChange(values) {
      return onChangeItem("button", values);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettingsWithDescription, {
    label: "Button",
    value: settings.button_2,
    onChange: function onChange(values) {
      return onChangeItem("button_2", values);
    }
  }));
};
var Admin$b = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GeoIpPicker, {
    onChange: function onChange(value) {
      return _onChange("geoIp", value);
    },
    value: settings.geoIp
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["col-6", "2 columns"], ["col-4", "3 columns"], ["col-3", "4 columns"]],
    value: settings.variant || "",
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CardField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    primaryField: "button.label",
    template: {
      image: imagePlaceholder("200x200"),
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ullam temporibus aut possimus alias ea, dolores libero at totam iure ex!",
      button: ButtonSettingsWithDescription.defaults
    }
  }));
};
var CardsWidget = {
  __proto__: null,
  Widget: Widget$b,
  Admin: Admin$b,
  Config: Config$b,
  Defaults: Defaults$b
};
var Widget$c = function Widget(_ref) {
  var list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings,
    className: "cards-with-icons-widget"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards-with-icon-wrapper"
  }, list.map(function (card, idx) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card",
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-wrapper"
    }, /*#__PURE__*/React.createElement("span", {
      className: "card-icon",
      style: {
        backgroundImage: "url(" + imageSrc(card.image, "original") + ")"
      }
    }), /*#__PURE__*/React.createElement("h5", {
      className: "title"
    }, card.title), /*#__PURE__*/React.createElement("div", {
      className: "description"
    }, parseMarkdown(card.description))), /*#__PURE__*/React.createElement(Button$1, {
      settings: card.button
    }));
  })));
};
var Config$c = {
  title: "Cards with Icons",
  category: "Events"
};
var Defaults$c = {
  list: [{
    title: "Americas",
    description: "##### Description line 1\n###### Description line 2",
    image: imagePlaceholder("50x50"),
    button: ButtonSettings.defaults
  }, {
    title: "Europe",
    description: "##### Description line 1\n###### Description line 2",
    image: imagePlaceholder("50x50"),
    button: ButtonSettings.defaults
  }, {
    title: "Asia & Pacific",
    description: "##### Description line 1\n###### Description line 2",
    image: imagePlaceholder("50x50"),
    button: ButtonSettings.defaults
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var CardField$1 = function CardField(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    button_settings_title: "Button",
    value: settings.button,
    onChange: function onChange(values) {
      return onChangeItem("button", values);
    }
  }));
};
var Admin$c = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CardField$1, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items,
    template: {
      title: "Americas",
      description: "##### Description line 1\n###### Description line 2",
      image: imagePlaceholder("50x50"),
      button: {
        button_label: "REGISTER NOW",
        button_sub_line: "",
        button_link: "#",
        button_id: "",
        button_type: "accented",
        button_target: "_self",
        follow_link: "follow"
      }
    },
    primaryField: "title"
  });
};
var CardsWithIconsWidget = {
  __proto__: null,
  Widget: Widget$c,
  Admin: Admin$c,
  Config: Config$c,
  Defaults: Defaults$c
};
var Widget$d = function Widget(_ref) {
  var autoRotate = _ref.autoRotate,
    list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "articles-slider"
  }, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    paginationClickable: true,
    navigation: {
      nextEl: ".swiper-button-next.icon-arrow-right",
      prevEl: ".swiper-button-prev.icon-arrow-left"
    },
    loop: true,
    autoplay: autoRotate === "off" ? false : {
      delay: autoRotate
    },
    speed: 500,
    breakpoints: {
      599: {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 30
      },
      600: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 30
      }
    }
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slide-inner"
    }, item.link !== "" ? /*#__PURE__*/React.createElement(A, {
      href: item.link,
      target: item.target
    }, /*#__PURE__*/React.createElement(Img, {
      src: item.image,
      variant: "articles_2_columns"
    })) : /*#__PURE__*/React.createElement(Img, {
      src: item.image,
      variant: "articles_2_columns"
    }), /*#__PURE__*/React.createElement("h6", {
      className: "title"
    }, item.link !== "" ? /*#__PURE__*/React.createElement(A, {
      href: item.link,
      target: item.target
    }, item.title) : item.title), /*#__PURE__*/React.createElement("p", null, item.description)));
  }))));
};
var Config$d = {
  title: "Carousel With Thumbs",
  category: "Sliders"
};
var Defaults$d = {
  autoRotate: "off",
  list: [{
    image: imagePlaceholder("690x380"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam voluptates nostrum optio maiores repudiandae soluta.",
    link: "#",
    target: "_self"
  }, {
    image: imagePlaceholder("690x380"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam voluptates nostrum optio maiores repudiandae soluta.",
    link: "#",
    target: "_self"
  }, {
    image: imagePlaceholder("690x380"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam voluptates nostrum optio maiores repudiandae soluta.",
    link: "#",
    target: "_self"
  }, {
    image: imagePlaceholder("690x380"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam voluptates nostrum optio maiores repudiandae soluta.",
    link: "",
    target: "_self"
  }, {
    image: imagePlaceholder("690x380"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam voluptates nostrum optio maiores repudiandae soluta.",
    link: "#",
    target: "_self"
  }, {
    image: imagePlaceholder("690x380"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam voluptates nostrum optio maiores repudiandae soluta.",
    link: "#",
    target: "_self"
  }, {
    image: imagePlaceholder("690x380"),
    title: "Item title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quibusdam voluptates nostrum optio maiores repudiandae soluta.",
    link: "#",
    target: "_self"
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ThumbField = function ThumbField(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Link",
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    value: settings.link
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Target",
    options: [["_self", "Self"], ["_blank", "Blank"]],
    value: settings.target,
    onChange: function onChange(value) {
      return onChangeItem("target", value);
    }
  }));
};
ThumbField.defaultProps = {
  settings: {}
};
var Admin$d = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Autoplay",
    options: [["off", "Off"], ["3000", "3s"], ["4000", "4s"], ["5000", "5s"]],
    value: settings.autoRotate,
    onChange: function onChange(value) {
      return _onChange("autoRotate", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ThumbField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      image: imagePlaceholder("690x380"),
      title: "Item title",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. ",
      link: "#",
      target: "_self"
    },
    primaryField: "title"
  }));
};
var CarouselWithThumbsWidget = {
  __proto__: null,
  Widget: Widget$d,
  Admin: Admin$d,
  Config: Config$d,
  Defaults: Defaults$d
};
var Link = function Link(_ref) {
  var settings = _ref.settings,
    children = _ref.children,
    className = _ref.className;
  var label = settings.label,
    link = settings.link,
    id = settings.id,
    target = settings.target,
    rel = settings.rel;
  return /*#__PURE__*/React.createElement(A, {
    href: link,
    className: [settings.className, className].join(" "),
    id: id ? id : "",
    target: target,
    rel: rel,
    title: label
  }, children);
};
var ListItem$2 = function ListItem(_ref2) {
  var title = _ref2.title,
    moreLink = _ref2.moreLink,
    items = _ref2.items;
  return /*#__PURE__*/React.createElement("div", {
    className: "previews-3"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title), items.length > 0 && /*#__PURE__*/React.createElement("ul", null, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx
    }, /*#__PURE__*/React.createElement(Link, {
      settings: item.link
    }, item.link.label));
  })), /*#__PURE__*/React.createElement(Link, {
    className: "btn-text",
    settings: moreLink
  }, moreLink.label));
};
var Widget$e = function Widget(_ref3) {
  var list = _ref3.list,
    containerSettings = _ref3.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "categories-list-widget"
  }, list.length > 0 && list.map(function (listItem, idx) {
    return /*#__PURE__*/React.createElement(ListItem$2, _extends({
      key: idx
    }, listItem));
  }), list.length === 0 && /*#__PURE__*/React.createElement("h1", null, "Categories List"))));
};
var Config$e = {
  title: "Categories List",
  category: "Misc"
};
var Defaults$e = {
  list: [],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var InnerItemsInput = function InnerItemsInput(_ref4) {
  var items = _ref4.items,
    onChange = _ref4.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Items",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(LinkSettings, {
        label: "Link",
        onChange: function onChange(value) {
          return onChangeItem("link", value);
        },
        value: settings.link
      });
    },
    primaryField: "link.label",
    onChangeList: onChange,
    items: items,
    template: {
      link: LinkSettings.defaults
    }
  });
};
var ListItemInput = function ListItemInput(_ref5) {
  var settings = _ref5.settings,
    onChangeItem = _ref5.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(InnerItemsInput, {
    items: settings.items,
    onChange: function onChange(_key, newItems) {
      onChangeItem("items", newItems);
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "More Link",
    onChange: function onChange(value) {
      return onChangeItem("moreLink", value);
    },
    value: settings.moreLink
  }));
};
var Admin$e = function Admin(items, onChange) {
  return /*#__PURE__*/React.createElement(List, {
    label: "Categories",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItemInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items,
    primaryField: "title",
    template: {
      title: "Title",
      items: [],
      moreLink: {}
    }
  });
};
var CategoriesListWidget = {
  __proto__: null,
  Widget: Widget$e,
  Admin: Admin$e,
  Config: Config$e,
  Defaults: Defaults$e
};
var CardsPicker = /*#__PURE__*/function (_React$Component) {
  function CardsPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var value = props.value;
    _this.state = {
      card: value
    };
    return _this;
  }
  _inheritsLoose(CardsPicker, _React$Component);
  var _proto = CardsPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    var onChange = this.props.onChange;
    var newValue = value;
    onChange(newValue);
    this.setState({
      card: newValue
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var card = this.state.card;
    return /*#__PURE__*/React.createElement(Query, {
      query: MINI_PACKAGE_PRICING_CARDS
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var packagePricingCards = data.packagePricingCards;
      var options = packagePricingCards.list.map(function (e) {
        return [e.id, e.name];
      });
      return /*#__PURE__*/React.createElement(SelectMenu, {
        label: "Cards Picker",
        options: options,
        value: card,
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        }
      });
    });
  };
  return CardsPicker;
}(React.Component);
var _labelStyles$1;
var labelStyles$1 = (_labelStyles$1 = {
  padding: 0,
  margin: 0,
  boxSizing: "border-box",
  fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  fontSize: "16px",
  lineHeight: "1.5",
  color: "#000",
  fontWeight: "normal",
  backgroundColor: "transparent",
  display: "block",
  marginBottom: "10px",
  textTransform: "uppercase"
}, _labelStyles$1["fontWeight"] = "bold", _labelStyles$1["fontSize"] = "12px", _labelStyles$1.cursor = "pointer", _labelStyles$1["color"] = "#000", _labelStyles$1);
var colors$1 = ["red", "blue", "green"];
var ColorPicker = function ColorPicker(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var _useState = useState(value),
    selectedColor = _useState[0],
    setColor = _useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "color-picker"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "",
    style: labelStyles$1
  }, "Inline Theme"), colors$1.map(function (color) {
    return /*#__PURE__*/React.createElement("div", {
      key: color,
      className: "option " + color + " " + (selectedColor === color ? "selected" : ""),
      onClick: function onClick() {
        setColor(color);
        onChange(color);
      }
    });
  }));
};
var PricingErrorMessage = function PricingErrorMessage() {
  return /*#__PURE__*/React.createElement("p", {
    className: "pricing-error-message"
  }, "We are experiencing difficulties loading products. Please check", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://status.chaos.com/"
  }, "https://status.chaos.com/"), " and try again in a minute.");
};
var PlacehodlerComponent = function PlacehodlerComponent(_ref) {
  var showMessage = _ref.showMessage;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative"
    }
  }, showMessage && /*#__PURE__*/React.createElement(PricingErrorMessage, null), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 900,
      margin: "0 auto",
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 100,
      height: "1em"
    }
  })))));
};
var CloudPricingPlaceholder = function CloudPricingPlaceholder(_ref2) {
  var realComponent = _ref2.realComponent,
    ready = _ref2.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: PlacehodlerComponent,
    realComponent: realComponent
  });
};
var Headings = function (_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle;
  return /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("h5", {
    className: "sub-title"
  }, subTitle));
};
var useInViewPort = function useInViewPort(ref, onVisible, onChange) {
  var inViewCallback = function inViewCallback(entries, _obs) {
    var entry = entries[0];
    if (onChange) onChange(entry.isIntersecting);
    if (entry.isIntersecting && onVisible) {
      onVisible();
    }
  };
  React.useEffect(function () {
    var observer = null;
    if (ref.current) {
      var options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5
      };
      observer = new IntersectionObserver(inViewCallback, options);
      observer.observe(ref.current);
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [ref, inViewCallback]);
  return null;
};
var RegularCard = function (_ref) {
  var title = _ref.title,
    sub_title = _ref.sub_title,
    button = _ref.button,
    quantity = _ref.quantity,
    unit = _ref.unit,
    currency = _ref.currency,
    prices = _ref.prices,
    ribbonText = _ref.ribbonText,
    bubbleText = _ref.bubbleText,
    inlineTheme = _ref.inlineTheme,
    ratePlanDetails = _ref.ratePlanDetails;
  var cardRef = React.useRef(null);
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  useInViewPort(cardRef, function () {
    return registerProductView(ratePlanDetails);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "card " + inlineTheme,
    ref: cardRef
  }, ribbonText && /*#__PURE__*/React.createElement("div", {
    className: "ribbon regular"
  }, ribbonText), /*#__PURE__*/React.createElement("div", {
    className: "top-bar"
  }, /*#__PURE__*/React.createElement(Headings, {
    title: title,
    subTitle: sub_title
  }), /*#__PURE__*/React.createElement("div", {
    className: "" + (bubbleText ? "colored-note" : "note")
  }, /*#__PURE__*/React.createElement("div", null, Currency.prettyPrint(prices[currency] / quantity, currency, country)), /*#__PURE__*/React.createElement("div", {
    className: "per"
  }, unit))), bubbleText && /*#__PURE__*/React.createElement("div", {
    className: "bubble-text-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bubble-text"
  }, bubbleText)), /*#__PURE__*/React.createElement("div", {
    className: "bottom-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, Currency.prettyPrint(prices[currency], currency, country)), /*#__PURE__*/React.createElement(Button$1, {
    settings: button,
    productInfo: {
      productCode: ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.id,
      quantity: (ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.min_qty) || 1,
      promoCode: "",
      currency: currency,
      ratePlanDetails: ratePlanDetails
    }
  })));
};
var PromoCard = function (_ref) {
  var currency = _ref.currency,
    title = _ref.title,
    sub_title = _ref.sub_title,
    unit = _ref.unit,
    button = _ref.button,
    prices = _ref.prices,
    promo_prices = _ref.promo_prices,
    promo_title = _ref.promo_title,
    quantity = _ref.quantity,
    inlineTheme = _ref.inlineTheme,
    ratePlanDetails = _ref.ratePlanDetails;
  var cardRef = React.useRef(null);
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  useInViewPort(cardRef, function () {
    return registerProductView(ratePlanDetails);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "package-promo-card card " + inlineTheme,
    ref: cardRef
  }, promo_title && /*#__PURE__*/React.createElement("div", {
    className: "ribbon promo"
  }, promo_title), /*#__PURE__*/React.createElement("div", {
    className: "top-bar"
  }, /*#__PURE__*/React.createElement(Headings, {
    title: title,
    subTitle: sub_title
  }), /*#__PURE__*/React.createElement("div", {
    className: "note"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
    className: "old-price"
  }, Currency.prettyPrint(prices[currency] / quantity, currency, country)), "\xA0 / \xA0", /*#__PURE__*/React.createElement("span", {
    className: "new-price"
  }, Currency.prettyPrint(promo_prices[currency] / quantity, currency, country))), /*#__PURE__*/React.createElement("div", {
    className: "per"
  }, unit))), /*#__PURE__*/React.createElement("div", {
    className: "bottom-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "promo-price"
  }, Currency.prettyPrint(promo_prices[currency], currency, country)), /*#__PURE__*/React.createElement("div", {
    className: "price old-price"
  }, Currency.prettyPrint(prices[currency], currency, country)), /*#__PURE__*/React.createElement(Button$1, {
    settings: button,
    productInfo: {
      productCode: ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.id,
      quantity: (ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.min_qty) || 1,
      promoCode: ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.code,
      currency: currency,
      ratePlanDetails: ratePlanDetails
    }
  })));
};
var TeaserCard = function (_ref) {
  var title = _ref.title,
    sub_title = _ref.sub_title,
    description = _ref.description,
    unit = _ref.unit,
    button = _ref.button,
    prices = _ref.prices,
    quantity = _ref.quantity,
    currency = _ref.currency,
    ratePlanDetails = _ref.ratePlanDetails;
  var cardRef = React.useRef(null);
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  useInViewPort(cardRef, function () {
    return registerProductView(ratePlanDetails);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "card",
    ref: cardRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "top-bar"
  }, /*#__PURE__*/React.createElement(Headings, {
    title: title,
    subTitle: sub_title
  }), /*#__PURE__*/React.createElement("div", {
    className: "note"
  }, /*#__PURE__*/React.createElement("div", null, description.indexOf("{PER_CREDIT}") !== -1 && /*#__PURE__*/React.createElement(React.Fragment, null, description.replace("{PER_CREDIT}", "" + Currency.prettyPrint(prices[currency] / quantity, currency, country))), description.indexOf("{PER_CREDIT}") === -1 && /*#__PURE__*/React.createElement(React.Fragment, null, description)), /*#__PURE__*/React.createElement("div", {
    className: "per"
  }, unit))), /*#__PURE__*/React.createElement("div", {
    className: "bottom-bar"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: button,
    productInfo: {
      productCode: ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.id,
      quantity: (ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.min_qty) || 1,
      promoCode: ratePlanDetails === null || ratePlanDetails === void 0 ? void 0 : ratePlanDetails.code,
      currency: currency,
      ratePlanDetails: ratePlanDetails
    }
  })));
};
var cardType = {
  regular: RegularCard,
  promo: PromoCard,
  teaser: TeaserCard
};
var Card$1 = function Card(_ref) {
  var card = _ref.card,
    currency = _ref.currency,
    ribbonText = _ref.ribbonText,
    inlineTheme = _ref.inlineTheme;
  var Component = cardType[card.type];
  return /*#__PURE__*/React.createElement(Component, _extends({}, card, {
    currency: currency,
    ribbonText: ribbonText,
    inlineTheme: inlineTheme
  }));
};
var extractPromoCode = function extractPromoCode(pageUrl, defaultPromoCode) {
  var code = defaultPromoCode || "";
  if (!pageUrl) {
    return code;
  }
  try {
    var url = new URL(pageUrl);
    return url.searchParams.get("promo") || code;
  } catch (e) {
    return code;
  }
};
var useLocalizationCurrency = function useLocalizationCurrency(defaultValue, onFetch) {
  var localizationUrl = React.useContext(LocalizationUrlContext);
  React.useEffect(function () {
    var fetchLocalization = function fetchLocalization() {
      try {
        var _temp = _catch(function () {
          return Promise.resolve(fetch(localizationUrl).then(function (r) {
            return r.json();
          }).then(function (d) {
            return d;
          })).then(function (localizationData) {
            var val = ((localizationData === null || localizationData === void 0 ? void 0 : localizationData.currencyCode) || defaultValue || "").toLowerCase();
            onFetch(val);
          });
        }, function (e) {
          console.error(e);
          var val = (defaultValue || "").toLowerCase();
          onFetch(val);
        });
        return Promise.resolve(_temp && _temp.then ? _temp.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    fetchLocalization();
  }, []);
};
var onHorizontalScroll = function onHorizontalScroll(node, setVisible) {
  if (node.scrollWidth > node.parentElement.offsetWidth) {
    setVisible(true);
  } else {
    setVisible(false);
  }
};
var VatDisclaimer = function VatDisclaimer(_ref) {
  var cards = _ref.cards;
  var message = cards[0] && cards[0] && cards[0].vatDisclaimer || "";
  if (!message) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, message)));
};
var PricingWrapper = function PricingWrapper(_ref2) {
  var children = _ref2.children,
    onCurrencyChange = _ref2.onCurrencyChange,
    currency = _ref2.currency,
    cards = _ref2.cards;
  var _useState = useState(false),
    isIconVisible = _useState[0],
    setIconVisible = _useState[1];
  var pricing = useRef(null);
  useLayoutEffect(function () {
    var node = pricing.current;
    onHorizontalScroll(node, function (isVisible) {
      return setIconVisible(isVisible);
    });
    window.addEventListener("resize", function () {
      return onHorizontalScroll(node, function (isVisible) {
        return setIconVisible(isVisible);
      });
    });
  });
  return /*#__PURE__*/React.createElement(AdminUserContext.Consumer, null, function (value) {
    var isAdmin = !!value;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "package-pricing-wrapper " + (isIconVisible ? "horizontal-scroll" : "")
    }, isAdmin && /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("select", {
      value: currency,
      onChange: function onChange(e) {
        return onCurrencyChange(e.target.value);
      }
    }, Currency.all.map(function (c) {
      return /*#__PURE__*/React.createElement("option", {
        key: c,
        value: c
      }, c.toUpperCase());
    }))), /*#__PURE__*/React.createElement("div", {
      ref: pricing,
      className: "package-pricing"
    }, children), isIconVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
      className: "arrow icon-arrow-left"
    }), /*#__PURE__*/React.createElement("i", {
      className: "arrow icon-arrow-right"
    })), /*#__PURE__*/React.createElement(VatDisclaimer, {
      cards: cards
    })));
  });
};
var isZuoraDataInvalid = function isZuoraDataInvalid(data) {
  var valid = data.every(function (card) {
    if (!card.ratePlanDetails) {
      return true;
    }
    if (card.ratePlanDetails.id) {
      return !!card.ratePlanDetails.name;
    } else {
      return true;
    }
  });
  if (!valid) {
    console.error({
      data: data
    });
  }
  return !valid;
};
var Widget$f = function Widget(_ref3) {
  var list = _ref3.list,
    _ref3$inlineTheme = _ref3.inlineTheme,
    inlineTheme = _ref3$inlineTheme === void 0 ? "red" : _ref3$inlineTheme,
    promoCode = _ref3.promoCode,
    containerSettings = _ref3.containerSettings;
  var _useState2 = useState(null),
    curentCurrency = _useState2[0],
    setCurrentCurrency = _useState2[1];
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrentCurrency);
  var pickedPromoCode = extractPromoCode(React.useContext(PageUrlContext), promoCode);
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, list.length > 0 ? /*#__PURE__*/React.createElement(Query, {
    query: PACKAGE_PRICING_CARDS,
    variables: {
      input: {
        filters: {
          ids: list.map(function (item) {
            return item.cardId;
          }).filter(function (id) {
            return Boolean(id);
          })
        },
        promoCode: pickedPromoCode
      }
    }
  }, function (_ref4) {
    var error = _ref4.error,
      loading = _ref4.loading,
      data = _ref4.data;
    if (error) return "Error! " + error.message;
    var packagePricingCards = data.packagePricingCards;
    return /*#__PURE__*/React.createElement(CloudPricingPlaceholder, {
      ready: loading || !curentCurrency,
      realComponent: function realComponent() {
        if (isZuoraDataInvalid(packagePricingCards.list)) {
          return /*#__PURE__*/React.createElement(PlacehodlerComponent, {
            showMessage: true
          });
        }
        return /*#__PURE__*/React.createElement(PricingWrapper, {
          cards: packagePricingCards.list,
          currency: curentCurrency,
          onCurrencyChange: function onCurrencyChange(newCurrency) {
            return setCurrentCurrency(newCurrency);
          }
        }, packagePricingCards.list.map(function (card, idx) {
          return /*#__PURE__*/React.createElement(Card$1, {
            key: idx,
            card: card,
            inlineTheme: inlineTheme,
            ribbonText: list[idx].ribbonText,
            currency: curentCurrency
          });
        }));
      }
    });
  }) : /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", null, "No cards")));
};
var Config$f = {
  title: "Package Pricing Standalone",
  category: "Pricing"
};
var Defaults$f = {
  inlineTheme: "red",
  promoCode: "",
  list: [],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var CardField$2 = function CardField(_ref5) {
  var _ref5$settings = _ref5.settings,
    settings = _ref5$settings === void 0 ? {} : _ref5$settings,
    onChangeItem = _ref5.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CardsPicker, {
    onChange: function onChange(value) {
      return onChangeItem("cardId", value);
    },
    value: settings.cardId
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Ribbon text",
    onChange: function onChange(value) {
      return onChangeItem("ribbonText", value);
    },
    value: settings.ribbonText
  }));
};
var Admin$f = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Promo code",
    value: settings.promoCode,
    onChange: function onChange(value) {
      return _onChange("promoCode", value);
    }
  }), /*#__PURE__*/React.createElement(ColorPicker, {
    value: settings.inlineTheme,
    onChange: function onChange(value) {
      return _onChange("inlineTheme", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CardField$2, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    primaryField: "title",
    template: {
      cardId: ""
    }
  }));
};
var CloudPricingWidget = {
  __proto__: null,
  Widget: Widget$f,
  Admin: Admin$f,
  Config: Config$f,
  Defaults: Defaults$f
};
var Widget$g = function Widget(_ref) {
  var code = _ref.code,
    language = _ref.language,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-shift-3"
  }, /*#__PURE__*/React.createElement(SyntaxHighlighter, {
    language: language,
    style: docco
  }, code))));
};
var Config$g = {
  title: "Code Highlight",
  category: "Misc"
};
var Defaults$g = {
  code: "<div>Test</div>",
  language: "htmlbars",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$g = {
  code: {
    type: "textarea"
  },
  language: {
    type: "select",
    options: [["oneC (1c)", "oneC (1c)"], ["abnf", "abnf"], ["accesslog", "accesslog"], ["actionscript", "actionscript"], ["ada", "ada"], ["apache", "apache"], ["applescript", "applescript"], ["arduino", "arduino"], ["armasm", "armasm"], ["asciidoc", "asciidoc"], ["aspectj", "aspectj"], ["autohotkey", "autohotkey"], ["autoit", "autoit"], ["avrasm", "avrasm"], ["awk", "awk"], ["axapta", "axapta"], ["bash", "bash"], ["basic", "basic"], ["bnf", "bnf"], ["brainfuck", "brainfuck"], ["cal", "cal"], ["capnproto", "capnproto"], ["ceylon", "ceylon"], ["clean", "clean"], ["clojureRepl (clojure-repl)", "clojureRepl (clojure-repl)"], ["clojure", "clojure"], ["cmake", "cmake"], ["coffeescript", "coffeescript"], ["coq", "coq"], ["cos", "cos"], ["cpp", "cpp"], ["crmsh", "crmsh"], ["crystal", "crystal"], ["cs", "cs"], ["csp", "csp"], ["css", "css"], ["d", "d"], ["dart", "dart"], ["delphi", "delphi"], ["diff", "diff"], ["django", "django"], ["dns", "dns"], ["dockerfile", "dockerfile"], ["dos", "dos"], ["dsconfig", "dsconfig"], ["dts", "dts"], ["dust", "dust"], ["ebnf", "ebnf"], ["elixir", "elixir"], ["elm", "elm"], ["erb", "erb"], ["erlangRepl (erlang-repl)", "erlangRepl (erlang-repl)"], ["erlang", "erlang"], ["excel", "excel"], ["fix", "fix"], ["flix", "flix"], ["fortran", "fortran"], ["fsharp", "fsharp"], ["gams", "gams"], ["gauss", "gauss"], ["gcode", "gcode"], ["gherkin", "gherkin"], ["glsl", "glsl"], ["go", "go"], ["golo", "golo"], ["gradle", "gradle"], ["groovy", "groovy"], ["haml", "haml"], ["handlebars", "handlebars"], ["haskell", "haskell"], ["haxe", "haxe"], ["hsp", "hsp"], ["htmlbars", "htmlbars"], ["http", "http"], ["hy", "hy"], ["inform7", "inform7"], ["ini", "ini"], ["irpf90", "irpf90"], ["java", "java"], ["javascript", "javascript"], ["jbossCli (jboss-cli)", "jbossCli (jboss-cli)"], ["json", "json"], ["juliaRepl (julia-repl)", "juliaRepl (julia-repl)"], ["julia", "julia"], ["kotlin", "kotlin"], ["lasso", "lasso"], ["ldif", "ldif"], ["leaf", "leaf"], ["less", "less"], ["lisp", "lisp"], ["livecodeserver", "livecodeserver"], ["livescript", "livescript"], ["llvm", "llvm"], ["lsl", "lsl"], ["lua", "lua"], ["makefile", "makefile"], ["markdown", "markdown"], ["mathematica", "mathematica"], ["matlab", "matlab"], ["maxima", "maxima"], ["mel", "mel"], ["mercury", "mercury"], ["mipsasm", "mipsasm"], ["mizar", "mizar"], ["mojolicious", "mojolicious"], ["monkey", "monkey"], ["moonscript", "moonscript"], ["n1ql", "n1ql"], ["nginx", "nginx"], ["nimrod", "nimrod"], ["nix", "nix"], ["nsis", "nsis"], ["objectivec", "objectivec"], ["ocaml", "ocaml"], ["openscad", "openscad"], ["oxygene", "oxygene"], ["parser3", "parser3"], ["perl", "perl"], ["pf", "pf"], ["php", "php"], ["pony", "pony"], ["powershell", "powershell"], ["processing", "processing"], ["profile", "profile"], ["prolog", "prolog"], ["protobuf", "protobuf"], ["puppet", "puppet"], ["purebasic", "purebasic"], ["python", "python"], ["q", "q"], ["qml", "qml"], ["r", "r"], ["rib", "rib"], ["roboconf", "roboconf"], ["routeros", "routeros"], ["rsl", "rsl"], ["ruby", "ruby"], ["ruleslanguage", "ruleslanguage"], ["rust", "rust"], ["scala", "scala"], ["scheme", "scheme"], ["scilab", "scilab"], ["scss", "scss"], ["shell", "shell"], ["smali", "smali"], ["smalltalk", "smalltalk"], ["sml", "sml"], ["sqf", "sqf"], ["sql", "sql"], ["stan", "stan"], ["stata", "stata"], ["step21", "step21"], ["stylus", "stylus"], ["subunit", "subunit"], ["swift", "swift"], ["taggerscript", "taggerscript"], ["tap", "tap"], ["tcl", "tcl"], ["tex", "tex"], ["thrift", "thrift"], ["tp", "tp"], ["twig", "twig"], ["typescript", "typescript"], ["vala", "vala"], ["vbnet", "vbnet"], ["vbscriptHtml (vbscript-html)", "vbscriptHtml (vbscript-html)"], ["vbscript", "vbscript"], ["verilog", "verilog"], ["vhdl", "vhdl"], ["vim", "vim"], ["x86asm", "x86asm"], ["xl", "xl"], ["xml", "xml"], ["xquery", "xquery"], ["yaml", "yaml"], ["zephir", "zephir"]]
  }
};
var CodeHighlightWidget = {
  __proto__: null,
  Widget: Widget$g,
  Admin: Admin$g,
  Config: Config$g,
  Defaults: Defaults$g
};
var addLeadingZeros = function addLeadingZeros(value) {
  value = String(value);
  while (value.length < 2) {
    value = "0" + value;
  }
  return value;
};
var calculateCountdown = function calculateCountdown(endDate) {
  var diff = (Date.parse(new Date(endDate)) - Date.parse(new Date())) / 1000;
  if (diff <= 0) return false;
  var timeLeft = {
    years: 0,
    days: 0,
    hours: 0,
    min: 0,
    sec: 0
  };
  if (diff >= 365.25 * 86400) {
    timeLeft.years = Math.floor(diff / (365.25 * 86400));
    diff -= timeLeft.years * 365.25 * 86400;
  }
  if (diff >= 86400) {
    timeLeft.days = Math.floor(diff / 86400);
    diff -= timeLeft.days * 86400;
  }
  if (diff >= 3600) {
    timeLeft.hours = Math.floor(diff / 3600);
    diff -= timeLeft.hours * 3600;
  }
  if (diff >= 60) {
    timeLeft.min = Math.floor(diff / 60);
    diff -= timeLeft.min * 60;
  }
  timeLeft.sec = diff;
  return timeLeft;
};
var buildInitialTime = function buildInitialTime(date) {
  var initialTime = calculateCountdown(date);
  if (initialTime) {
    return initialTime;
  } else {
    return {
      years: 0,
      days: 0,
      hours: 0,
      min: 0,
      sec: 0
    };
  }
};
var Countdown = function Countdown(_ref) {
  var date = _ref.date,
    days = _ref.days,
    hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds,
    onEnd = _ref.onEnd;
  var _React$useState = React.useState(buildInitialTime(date)),
    state = _React$useState[0],
    setState = _React$useState[1];
  React.useEffect(function () {
    var interval = setInterval(function () {
      var timeLeft = calculateCountdown(date);
      if (timeLeft) {
        setState(timeLeft);
      } else {
        clearInterval(interval);
        onEnd();
      }
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [date]);
  return /*#__PURE__*/React.createElement("div", {
    className: "countdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "countdown-element"
  }, /*#__PURE__*/React.createElement("strong", null, addLeadingZeros(state.days)), /*#__PURE__*/React.createElement("label", null, days)), /*#__PURE__*/React.createElement("div", {
    className: "countdown-element"
  }, /*#__PURE__*/React.createElement("strong", null, addLeadingZeros(state.hours)), /*#__PURE__*/React.createElement("label", null, hours)), /*#__PURE__*/React.createElement("div", {
    className: "countdown-element"
  }, /*#__PURE__*/React.createElement("strong", null, addLeadingZeros(state.min)), /*#__PURE__*/React.createElement("label", null, minutes)), /*#__PURE__*/React.createElement("div", {
    className: "countdown-element"
  }, /*#__PURE__*/React.createElement("strong", null, addLeadingZeros(state.sec)), /*#__PURE__*/React.createElement("label", null, seconds)));
};
var isPastDate = function isPastDate(date) {
  var now = new Date();
  var target = new Date(date);
  return now.getTime() >= target.getTime();
};
var Widget$h = function Widget(_ref) {
  var geoIp = _ref.geoIp,
    date = _ref.date,
    days = _ref.days,
    hours = _ref.hours,
    minutes = _ref.minutes,
    seconds = _ref.seconds,
    text = _ref.text,
    containerSettings = _ref.containerSettings;
  var _React$useState = React.useState(!isPastDate(date)),
    shouldCount = _React$useState[0],
    setShouldCount = _React$useState[1];
  React.useEffect(function () {
    setShouldCount(!isPastDate(date));
  }, [date]);
  return /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: geoIp && geoIp.activeCountries || [],
    countryGroupIds: geoIp && geoIp.activeGroups || [],
    active: geoIp && geoIp.active || false
  }, /*#__PURE__*/React.createElement(Container$1, {
    className: "cowntdown-wrapper",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, !shouldCount && /*#__PURE__*/React.createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), shouldCount && /*#__PURE__*/React.createElement(Countdown, {
    date: date,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    onEnd: function onEnd() {
      return setShouldCount(false);
    }
  }))));
};
var Config$h = {
  title: "Countdown",
  category: "Misc"
};
var Defaults$h = {
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  date: "2021-09-23T03:20:42Z",
  days: "Days",
  hours: "Hours",
  minutes: "Min",
  seconds: "Sec",
  text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Necessitatibus.",
  containerSettings: {}
};
var Admin$h = {
  geoIp: {
    type: "custom",
    component: GeoIpPicker
  },
  date: {
    type: "text",
    hint: "Date should be in UTC in order to display correct time remaining in different time zones."
  },
  days: {
    type: "text"
  },
  hours: {
    type: "text"
  },
  minutes: {
    type: "text"
  },
  seconds: {
    type: "text"
  },
  text: {
    type: "custom",
    component: RTE,
    label: "Message after expiration"
  }
};
var CountdownWidget = {
  __proto__: null,
  Widget: Widget$h,
  Admin: Admin$h,
  Config: Config$h,
  Defaults: Defaults$h
};
var Button$2 = function Button(_ref) {
  var settings = _ref.settings,
    className = _ref.className;
  var id = settings.id,
    label = settings.label,
    link = settings.link,
    target = settings.target,
    type = settings.type,
    follow_link = settings.follow_link,
    sub_line = settings.sub_line;
  if (!link && !label) return null;
  var buttonClass;
  if (type === "primary") buttonClass = "btn-active-dark";
  if (type === "secondary") buttonClass = "btn-passive-light";
  if (type === "text") buttonClass = "btn-text";
  if (className) buttonClass = buttonClass + " " + className;
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    className: buttonClass,
    id: id || "",
    target: target,
    rel: follow_link === "no-follow" ? "nofollow" : ""
  }, sub_line ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, parseMarkdown(label)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, sub_line)) : label);
};
var ButtonSettingsWithSubLine = /*#__PURE__*/function (_React$Component) {
  function ButtonSettingsWithSubLine(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      settings: props.value
    };
    return _this;
  }
  _inheritsLoose(ButtonSettingsWithSubLine, _React$Component);
  var _proto = ButtonSettingsWithSubLine.prototype;
  _proto.updateButtonSettings = function updateButtonSettings(value) {
    var _this2 = this;
    this.setState({
      settings: value
    }, function () {
      var onChange = _this2.props.onChange;
      var settings = _this2.state.settings;
      onChange(settings);
    });
  };
  _proto.updateSubline = function updateSubline(value) {
    var _this3 = this;
    var settings = this.state.settings;
    var newSettings = Object.assign({}, settings, {
      sub_line: value
    });
    this.setState({
      settings: newSettings
    }, function () {
      var onChange = _this3.props.onChange;
      var settings = _this3.state.settings;
      onChange(settings);
    });
  };
  _proto.render = function render() {
    var _this4 = this;
    var label = this.props.label;
    var settings = this.state.settings;
    return /*#__PURE__*/React.createElement("div", {
      className: "btn-settings-description"
    }, /*#__PURE__*/React.createElement(ButtonSettings, {
      value: settings,
      label: label,
      onChange: function onChange(settings) {
        return _this4.updateButtonSettings(settings);
      }
    }), /*#__PURE__*/React.createElement(MarkdownInput, {
      label: "Sub Line",
      onChange: function onChange(sub_line) {
        return _this4.updateSubline(sub_line);
      },
      value: settings.sub_line
    }));
  };
  return ButtonSettingsWithSubLine;
}(React.Component);
var DEFAULTS$1 = {
  label: "Button",
  link: "#",
  id: "",
  type: "primary",
  target: "_self",
  rel: "follow",
  sub_line: ""
};
ButtonSettingsWithSubLine.defaultProps = {
  label: "Button",
  value: DEFAULTS$1
};
ButtonSettingsWithSubLine.defaults = DEFAULTS$1;
var callToActionVariant = function callToActionVariant(variant) {
  var newVariant = "";
  if (variant === "yes") newVariant = "both";
  if (variant === "no") newVariant = "bottom";
  switch (newVariant) {
    case "top":
      return "no-padding-bottom";
    case "bottom":
      return "no-padding-top";
    case "none":
      return "no-padding";
    case "both":
      return "";
    default:
      return "";
  }
};
var AdvancedButton$1 = function AdvancedButton(_ref) {
  var button = _ref.button,
    text_below_button = _ref.text_below_button;
  return /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper"
  }, /*#__PURE__*/React.createElement(Button$2, {
    settings: button,
    className: "btn-advanced"
  }), text_below_button && /*#__PURE__*/React.createElement("div", {
    className: "benefits"
  }, parseMarkdown(text_below_button)));
};
var Widget$i = function Widget(_ref2) {
  var button_1 = _ref2.button_1,
    text_below_button_1 = _ref2.text_below_button_1,
    button_2 = _ref2.button_2,
    text_below_button_2 = _ref2.text_below_button_2,
    variant = _ref2.variant,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "advanced-call-to-action call-to-action " + callToActionVariant(variant),
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "buttons-wrapper"
  }, /*#__PURE__*/React.createElement(AdvancedButton$1, {
    button: button_1,
    text_below_button: text_below_button_1
  }), button_2.label && button_2.link && /*#__PURE__*/React.createElement(AdvancedButton$1, {
    button: button_2,
    text_below_button: text_below_button_2
  }))));
};
var Config$i = {
  title: "Advanced CTA Button",
  category: "CTA"
};
var Defaults$i = {
  button_1: ButtonSettingsWithSubLine.defaults,
  button_2: {},
  text_below_button_1: "",
  text_below_button_2: "",
  variant: "none",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$i = {
  variant: {
    type: "select",
    options: [["none", "None"], ["top", "Top"], ["bottom", "Bottom"], ["both", "Both"]],
    label: "Spacing"
  },
  button_1: {
    type: "custom",
    component: ButtonSettingsWithSubLine,
    label: "Button 1"
  },
  text_below_button_1: {
    type: "custom",
    component: RTE
  },
  button_2: {
    type: "custom",
    component: ButtonSettingsWithSubLine,
    label: "Button 2"
  },
  text_below_button_2: {
    type: "custom",
    component: RTE
  }
};
var CtaButtonAdvancedWidget = {
  __proto__: null,
  Widget: Widget$i,
  Admin: Admin$i,
  Config: Config$i,
  Defaults: Defaults$i
};
var base = 14;
var fraction = 1.25;
var small = base / fraction;
var tiny = small / fraction;
var medium = base * fraction;
var large = medium * fraction;
var xlarge = large * fraction;
var xxlarge = xlarge * fraction;
var huge = xxlarge * fraction;
var theme = {
  font: {
    tiny: tiny + "px",
    small: small + "px",
    base: base + "px",
    medium: medium + "px",
    large: large + "px",
    xlarge: xlarge + "px",
    xxlarge: xxlarge + "px",
    huge: huge + "px",
    line: 1.5
  },
  colors: {
    trueBlack: '#000',
    black: '#2C2C2C',
    darkerGray: '#4B4B4B',
    darkGray: '#6E6E6E',
    gray: '#B3B3B3',
    lightGray: '#E1E1E1',
    lighterGray: '#F5F5F5',
    white: '#FAFAFA',
    trueWhite: '#fff',
    primaryDarker: '#095aba',
    primaryDark: '#0d66d0',
    primary: '#1473e6',
    primaryRGB06: 'rgba(20, 115, 230, 0.6)',
    primaryLight: '#2680eb',
    successDarker: '#107154',
    successDark: '#12805c',
    success: '#268e6c',
    successLight: '#2d9d78',
    dangerDarker: '#bb121a',
    dangerDark: '#c9252d',
    danger: '#d7373f',
    dangerLight: '#e34850'
  }
};
function _taggedTemplateLiteralLoose$1(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}
function _templateObject$J() {
  var data = _taggedTemplateLiteralLoose$1(["\n  box-sizing: border-box;\n  color: ", ";\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,\n    Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n  font-size: ", ";\n  line-height: ", ";\n"]);
  _templateObject$J = function _templateObject() {
    return data;
  };
  return data;
}
var reset = css(_templateObject$J(), theme.colors.black, theme.font.base, theme.font.line);
function _templateObject$1$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  background: none;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n"]);
  _templateObject$1$1 = function _templateObject() {
    return data;
  };
  return data;
}
var buttonReset = css(_templateObject$1$1(), reset);
function _templateObject$2$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  margin: 0;\n  padding: 0;\n  font-size: ", ";\n  padding-bottom: 0.5em;\n"]);
  _templateObject$2$1 = function _templateObject() {
    return data;
  };
  return data;
}
var H = styled.div(_templateObject$2$1(), reset, function (props) {
  return props.theme.font[props.size];
});
function _templateObject$3$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  margin: 0;\n  padding: 0;\n  padding-bottom: 1em;\n"]);
  _templateObject$3$1 = function _templateObject() {
    return data;
  };
  return data;
}
var P = styled.p(_templateObject$3$1(), reset);
function _templateObject$4$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  padding: 0.5em 1em;\n  margin-right: 0.25em;\n  border: 2px solid ", ";\n  border-radius: 48px;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: 1;\n  transition: 0.2s ease-in-out all;\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  &:hover {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:active {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n  }\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n"]);
  _templateObject$4$1 = function _templateObject() {
    return data;
  };
  return data;
}
var variants = {
  primary: {
    border: 'primary',
    background: 'primary',
    color: 'white',
    hoverBorder: 'primaryDark',
    hoverBackground: 'primaryDark',
    hoverColor: 'white',
    activeBorder: 'primaryDarker',
    activeBackground: 'primaryDarker',
    activeColor: 'white'
  },
  secondary: {
    border: 'darkerGray',
    background: 'white',
    color: 'darkerGray',
    hoverBorder: 'darkGray',
    hoverBackground: 'darkGray',
    hoverColor: 'white',
    activeBorder: 'darkerGray',
    activeBackground: 'darkerGray',
    activeColor: 'white'
  },
  success: {
    border: 'success',
    background: 'success',
    color: 'white',
    hoverBorder: 'successDark',
    hoverBackground: 'successDark',
    hoverColor: 'white',
    activeBorder: 'successDarker',
    activeBackground: 'successDarker',
    activeColor: 'white'
  },
  danger: {
    border: 'danger',
    background: 'danger',
    color: 'white',
    hoverBorder: 'dangerDark',
    hoverBackground: 'dangerDark',
    hoverColor: 'white',
    activeBorder: 'dangerDarker',
    activeBackground: 'dangerDarker',
    activeColor: 'white'
  }
};
var sizes = {
  sm: theme.font.small,
  md: theme.font.base,
  lg: theme.font.medium
};
var getColor = function getColor(props, variant, key) {
  return props.theme.colors[variants[variant][key]];
};
var Button$3 = styled.button(_templateObject$4$1(), buttonReset, function (props) {
  return getColor(props, props.variant, 'border');
}, function (props) {
  return getColor(props, props.variant, 'background');
}, function (props) {
  return getColor(props, props.variant, 'color');
}, function (props) {
  return sizes[props.size || 'md'];
}, function (props) {
  return getColor(props, props.variant, 'activeBorder');
}, function (props) {
  return getColor(props, props.variant, 'hoverBorder');
}, function (props) {
  return getColor(props, props.variant, 'hoverBackground');
}, function (props) {
  return getColor(props, props.variant, 'hoverColor');
}, function (props) {
  return getColor(props, props.variant, 'activeBorder');
}, function (props) {
  return getColor(props, props.variant, 'activeBackground');
}, function (props) {
  return getColor(props, props.variant, 'activeColor');
});
Button$3.defaultProps = {
  type: 'button',
  variant: 'primary'
};
function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: relative;\n  top: 3px;\n  margin-right: 2em;\n  padding: 0 0 0.5em 0;\n  border-bottom: 3px solid\n    ", ";\n  color: ", ";\n  font-weight: 500;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:last-of-type {\n    margin-right: 4em;\n  }\n"]);
  _templateObject2$1 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$5$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  display: inline-flex;\n  margin-bottom: 1em;\n  border-bottom: 3px solid ", ";\n"]);
  _templateObject$5$1 = function _templateObject() {
    return data;
  };
  return data;
}
var TabsWrapper = styled.div(_templateObject$5$1(), reset, function (props) {
  return props.theme.colors.lightGray;
});
var Tab = styled.button(_templateObject2$1(), buttonReset, function (props) {
  return props.active ? props.theme.colors.black : 'transparent';
}, function (props) {
  return props.active ? props.theme.colors.black : props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.black;
});
function _templateObject$6$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  border: 0;\n  outline: 0;\n  border-radius: 4px;\n  border: 0;\n  width: 100%;\n  padding: 0.5em 0.75em;\n  border: 1px solid ", ";\n  background-color: ", ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"]);
  _templateObject$6$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Input$1 = styled.input(_templateObject$6$1(), reset, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.primary;
});
function _templateObject$7$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  border: 0;\n  outline: 0;\n  border-radius: 4px;\n  border: 0;\n  width: 100%;\n  height: 100px;\n  padding: 0.5em 0.75em;\n  border: 1px solid ", ";\n  background-color: ", ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"]);
  _templateObject$7$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Textarea = styled.textarea(_templateObject$7$1(), reset, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.primary;
});
function _templateObject$8$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  border: 0;\n  outline: 0;\n  border-radius: 4px;\n  border: 0;\n  width: 100%;\n  padding: 0.5em 0.75em;\n  border: 1px solid ", ";\n  background-size: 16px;\n  background-repeat: no-repeat;\n  background-position: center right 0.25em;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLWNoZXZyb24tZG93biI+PHBvbHlsaW5lIHBvaW50cz0iNiA5IDEyIDE1IDE4IDkiPjwvcG9seWxpbmU+PC9zdmc+);\n  background-color: ", ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    border-color: ", ";\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"]);
  _templateObject$8$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Select$1 = styled.select(_templateObject$8$1(), reset, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.darkGray;
}, function (props) {
  return props.theme.colors.primary;
});
function _templateObject$9$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  width: 100%;\n  margin-bottom: 1em;\n"]);
  _templateObject$9$1 = function _templateObject() {
    return data;
  };
  return data;
}
var FormGroup = styled.div(_templateObject$9$1(), reset);
function _templateObject$a$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  display: block;\n  margin-bottom: 0.25em;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 600;\n  cursor: pointer;\n"]);
  _templateObject$a$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Label$1 = styled.label(_templateObject$a$1(), reset, function (props) {
  return props.theme.colors.darkerGray;
}, function (props) {
  return props.theme.font.small;
});
function _templateObject$b$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  font-size: ", ";\n  opacity: 0.7;\n  color: ", ";\n"]);
  _templateObject$b$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Hint = styled.div(_templateObject$b$1(), reset, function (props) {
  return props.theme.font.small;
}, function (props) {
  return props.type === 'error' && props.theme.colors.danger;
});
function _templateObject$c$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  display: flex;\n  align-items: center;\n  gap: 0.5em;\n  margin-bottom: ", ";\n"]);
  _templateObject$c$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Toolbar = styled.div(_templateObject$c$1(), reset, function (props) {
  return props.mb || 0;
});
function _templateObject$d$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  display: flex;\n  justify-content: ", ";\n  align-items: ", ";\n  gap: ", ";\n"]);
  _templateObject$d$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Stack = styled.div(_templateObject$d$1(), function (props) {
  return props.h;
}, function (props) {
  return props.v;
}, function (props) {
  return props.g;
});
function _templateObject$e$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  width: 100%;\n  padding: 0 calc(1em / 2);\n\n  padding-top: ", ";\n  padding-bottom: ", ";\n\n  @media (min-width: 1184px) {\n    width: 98%;\n    margin: 0 auto;\n  }\n"]);
  _templateObject$e$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Container = styled.div(_templateObject$e$1(), reset, function (props) {
  return props.top && '1em';
}, function (props) {
  return props.bottom && '1em';
});
function _templateObject3() {
  var data = _taggedTemplateLiteralLoose$1(["\n  padding: 1em;\n"]);
  _templateObject3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$1$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0.25em 0.25em 0.25em;\n  border-bottom: 1px solid #ddd;\n  background-color: ", ";\n  font-weight: 700;\n"]);
  _templateObject2$1$1 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$f$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  margin-bottom: 0.5em;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  background-color: #fff;\n\n  &.sortable-selected {\n    background-color: #0a0a;\n  }\n"]);
  _templateObject$f$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Panel = styled.div(_templateObject$f$1(), reset);
var PanelTitle = styled.div(_templateObject2$1$1(), reset, function (props) {
  return props.theme.colors.lighterGray;
});
var PanelContent = styled.div(_templateObject3());
function _templateObject$g$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  width: 2em;\n  height: 2em;\n  background-size: 50%;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLW1vcmUtdmVydGljYWwiPjxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjEiPjwvY2lyY2xlPjxjaXJjbGUgY3g9IjEyIiBjeT0iNSIgcj0iMSI+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSIxOSIgcj0iMSI+PC9jaXJjbGU+PC9zdmc+);\n  cursor: grabbing;\n  filter: invert(", ");\n"]);
  _templateObject$g$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Handle = styled.div(_templateObject$g$1(), function (props) {
  return props.active ? 1 : 0;
});
function _templateObject7() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  padding: 0.5em 1em 1em 1em;\n"]);
  _templateObject7 = function _templateObject7() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: relative;\n  right: -4px;\n  z-index: 13;\n  width: 2em;\n  height: 2em;\n  margin: 0;\n  padding: 0;\n  background-repeat: no-repeat;\n  background-size: 80%;\n  background-position: center;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMwMDAiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLXgiPjxsaW5lIHgxPSIxOCIgeTE9IjYiIHgyPSI2IiB5Mj0iMTgiPjwvbGluZT48bGluZSB4MT0iNiIgeTE9IjYiIHgyPSIxOCIgeTI9IjE4Ij48L2xpbmU+PC9zdmc+);\n  font-size: 1em;\n  overflow: hidden;\n  text-indent: -9999px;\n"]);
  _templateObject6 = function _templateObject6() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  font-size: 1.25em;\n  font-weight: 500;\n"]);
  _templateObject5 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1em;\n  border-bottom: 2px solid ", ";\n"]);
  _templateObject4 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  width: 80%;\n  border-radius: 5px;\n  background-color: ", ";\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);\n  pointer-events: all;\n"]);
  _templateObject3$1 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 12;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none;\n"]);
  _templateObject2$2 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$h$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 11;\n  background-color: rgba(0, 0, 0, 0.6);\n  cursor: pointer;\n"]);
  _templateObject$h$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Overlay = styled.div(_templateObject$h$1(), reset);
var Wrapper = styled.div(_templateObject2$2(), reset);
var Inner = styled.div(_templateObject3$1(), reset, function (props) {
  return props.theme.colors.lighterGray;
});
var TitleBar = styled.div(_templateObject4(), reset, function (props) {
  return props.theme.colors.lightGray;
});
var Title = styled.div(_templateObject5(), reset);
var CloseButton = styled.button(_templateObject6(), buttonReset);
var Content = styled.div(_templateObject7(), reset);
function _templateObject$i$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", "\n\n  table {\n    border-collapse: collapse;\n    width: 100%;\n    margin-bottom: 1em;\n\n    th,\n    td {\n      padding: 0.5em;\n      text-align: left;\n    }\n\n    tr {\n      border-bottom: 1px solid ", ";\n      transition: all 0.3s ease-in-out;\n    }\n\n    a {\n      color: ", ";\n    }\n\n    tbody {\n      tr {\n        &:hover {\n          border-color: ", ";\n\n          td {\n            background-color: ", ";\n          }\n        }\n      }\n    }\n\n    .actions {\n      width: 50px;\n      white-space: nowrap;\n\n      div:first-of-type {\n        display: flex;\n        align-items: center;\n      }\n\n      a,\n      button {\n        margin-left: 0.5em;\n      }\n    }\n  }\n"]);
  _templateObject$i$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Wrapper$1 = styled.div(_templateObject$i$1(), reset, function (props) {
  return props.theme.colors.lightGray;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.gray;
}, function (props) {
  return props.theme.colors.lighterGray;
});
function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  grid-column: ", ";\n"]);
  _templateObject3$2 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  grid-column: span ", ";\n"]);
  _templateObject2$3 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$j$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  @media (min-width: 1184px) {\n    display: grid;\n    grid-template-columns: repeat(12, 1fr);\n    grid-column-gap: ", ";\n    grid-row-gap: ", ";\n    margin: 0;\n  }\n"]);
  _templateObject$j$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Row$1 = styled.div(_templateObject$j$1(), reset, function (props) {
  return props.gutter || '1em';
}, function (props) {
  return props.gutter || '1em';
});
var Col = styled.div(_templateObject2$3(), reset, function (props) {
  return props.s || 12;
});
var getShift = function getShift(s) {
  var SHIFTS = {
    1: '2 / span 10',
    2: '3 / span 8',
    3: '4 / span 6'
  };
  return SHIFTS[s];
};
var Shift = styled.div(_templateObject3$2(), reset, function (props) {
  return getShift(props.s);
});
function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  width: 48px;\n  height: 48px;\n  border-radius: 4px;\n  background-color: ", ";\n  transition: all 0.2s ease-in-out;\n\n  &:hover {\n    background-color: ", ";\n  }\n\n  a,\n  button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n"]);
  _templateObject2$4 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$k$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  gap: 8px;\n  flex-direction: column;\n  align-items: center;\n  width: 64px;\n  padding: 8px 0;\n  background-color: ", ";\n"]);
  _templateObject$k$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Navigation = styled.div(_templateObject$k$1(), reset, function (props) {
  return props.theme.colors.black;
});
var NavItem = styled.div(_templateObject2$4(), reset, function (props) {
  return props.active ? props.theme.colors.darkerGray : 'transparent';
}, function (props) {
  return props.theme.colors.darkerGray;
});
function _templateObject$l$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n\n  margin: 1em 0;\n"]);
  _templateObject$l$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Wrapper$2 = styled.div(_templateObject$l$1(), reset);
function _templateObject$m$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", "\n\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.25em;\n  padding: 1em 0 1em 0;\n\n  a,\n  span {\n    display: block;\n    min-width: 1.25em;\n    padding: 0.5em 0.75em;\n    font-weight: 500;\n    text-align: center;\n  }\n\n  a {\n    color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    transition: all 0.2s ease-in-out;\n\n    &:hover {\n      border-color: ", ";\n      background-color: ", ";\n      color: ", ";\n    }\n  }\n"]);
  _templateObject$m$1 = function _templateObject() {
    return data;
  };
  return data;
}
var Wrapper$3 = styled.div(_templateObject$m$1(), reset, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.lightGray;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.white;
});
function _templateObject5$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: relative;\n  z-index: 10;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  background-color: ", ";\n  text-transform: uppercase;\n  cursor: pointer;\n"]);
  _templateObject5$1 = function _templateObject5() {
    return data;
  };
  return data;
}
function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: relative;\n  width: 48px;\n  height: 48px;\n  background-color: ", ";\n  text-transform: uppercase;\n\n  span {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    opacity: 0.6;\n\n    color: ", ";\n    font-weight: 500;\n    text-decoration: none;\n  }\n\n  a {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    z-index: 3;\n\n    color: ", ";\n    font-weight: 700;\n    text-decoration: none;\n\n    :hover {\n      background-color: ", ";\n    }\n  }\n"]);
  _templateObject4$1 = function _templateObject4() {
    return data;
  };
  return data;
}
function _templateObject3$3() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 48px;\n  height: 48px;\n  background-color: ", ";\n  text-transform: uppercase;\n\n  a {\n    color: ", ";\n    font-weight: 500;\n    text-decoration: none;\n\n    :hover {\n      background-color: ", ";\n    }\n  }\n"]);
  _templateObject3$3 = function _templateObject3() {
    return data;
  };
  return data;
}
function _templateObject2$5() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: absolute;\n  z-index: 9;\n  left: -1000px;\n  display: flex;\n  flex-wrap: nowrap;\n  height: 100%;\n  background-color: ", ";\n  opacity: 0;\n  transition: all ease-in-out 0.3s;\n"]);
  _templateObject2$5 = function _templateObject2() {
    return data;
  };
  return data;
}
function _templateObject$n$1() {
  var data = _taggedTemplateLiteralLoose$1(["\n  ", ";\n  position: relative;\n  display: flex;\n  flex-wrap: nowrap;\n  width: 100%;\n  height: 100%;\n  color: #fff;\n\n  &:hover {\n    [data-switcher] {\n      left: 48px;\n      opacity: 1;\n    }\n  }\n"]);
  _templateObject$n$1 = function _templateObject() {
    return data;
  };
  return data;
}
var LanguageSwitcherWrapper = styled.div(_templateObject$n$1(), reset);
var LanguageSwitcherMenu = styled.div(_templateObject2$5(), reset, function (props) {
  return props.theme.colors.trueBlack;
});
var LanguageSwitcherItem = styled.div(_templateObject3$3(), reset, function (props) {
  return props.theme.colors.trueBlack;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.primaryRGB06;
});
var LanguageSwitcherNewItem = styled.div(_templateObject4$1(), reset, function (props) {
  return props.theme.colors.trueBlack;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.trueWhite;
}, function (props) {
  return props.theme.colors.primaryRGB06;
});
var LanguageSwitcherCurrent = styled.div(_templateObject5$1(), reset, function (props) {
  return props.theme.colors.primary;
});
var checkHtml = function checkHtml(htmlString) {
  var parser = new DOMParser();
  var errorNode = parser.parseFromString("<div>" + htmlString + "</div>", "application/xml").querySelector("parsererror");
  if (errorNode) {
    var _errorNode$querySelec;
    console.warn("Custom HTML - Something went wrong: ", errorNode.innerHTML);
    return ((_errorNode$querySelec = errorNode.querySelector("div")) === null || _errorNode$querySelec === void 0 ? void 0 : _errorNode$querySelec.innerText) || "";
  }
  return null;
};
var formatError = function formatError(error) {
  if (!error) {
    return null;
  }
  if (error.includes("error on line 1 at")) {
    var regex = /error on line 1 at column (\d+).*/;
    var match = error.match(regex);
    if (match && match[1]) {
      var col = parseInt(match[1]) - 5;
      error = error.replace("column " + match[1], "column " + col);
    }
  }
  return error;
};
var HtmlInput = function HtmlInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var error = formatError(checkHtml(value));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Text",
    onChange: function onChange(newValue) {
      _onChange(newValue);
    },
    value: value
  }), error && /*#__PURE__*/React.createElement(Hint, {
    type: "error"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: error
    }
  })));
};
var Widget$j = function Widget(_ref2) {
  var text = _ref2.text,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text
    },
    className: "container"
  }));
};
var Config$j = {
  title: "Custom HTML",
  category: "Misc"
};
var Defaults$j = {
  text: "<h2>Custom HTML</h2>",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$j = {
  text: {
    type: "custom",
    component: HtmlInput
  }
};
var CustomHtmlWidget = {
  __proto__: null,
  Widget: Widget$j,
  Admin: Admin$j,
  Config: Config$j,
  Defaults: Defaults$j
};
var boolToNumber = function boolToNumber(bool) {
  return bool === "true" ? "1" : "0";
};
var VimeoEmbed = function VimeoEmbed(_ref) {
  var videoId = _ref.videoId,
    autoplay = _ref.autoplay,
    mute = _ref.mute,
    controls = _ref.controls,
    loop = _ref.loop;
  return /*#__PURE__*/React.createElement("iframe", {
    title: "Vimeo Embed",
    frameBorder: "0",
    allowFullScreen: "0",
    src: "https://player.vimeo.com/video/" + videoId + "?color=ffffff&title=0&byline=0&portrait=0&autoplay=" + boolToNumber(autoplay) + "&muted=" + boolToNumber(mute) + "&loop=" + boolToNumber(loop) + "&controls=" + boolToNumber(controls),
    className: "content",
    allow: "autoplay"
  });
};
var YoukuEmbed = function YoukuEmbed(_ref2) {
  var videoId = _ref2.videoId,
    autoplay = _ref2.autoplay,
    mute = _ref2.mute,
    controls = _ref2.controls,
    loop = _ref2.loop;
  return /*#__PURE__*/React.createElement("iframe", {
    title: "Youku Embed",
    height: "0",
    width: "0",
    src: "https://player.youku.com/embed/" + videoId + "?autoplay=" + boolToNumber(autoplay) + "&muted=" + boolToNumber(mute) + "&loop=" + boolToNumber(loop) + "&controls=" + boolToNumber(controls),
    frameBorder: "0",
    allowFullScreen: true,
    className: "content",
    allow: "autoplay"
  });
};
var YouTubeEmbed = function YouTubeEmbed(_ref3) {
  var videoId = _ref3.videoId,
    autoplay = _ref3.autoplay,
    mute = _ref3.mute,
    controls = _ref3.controls,
    loop = _ref3.loop;
  return /*#__PURE__*/React.createElement("iframe", {
    title: "Youtube embed",
    frameBorder: "0",
    allowFullScreen: true,
    src: "https://youtube.com/embed/" + videoId + "?autoplay=" + boolToNumber(autoplay) + "&mute=" + boolToNumber(mute) + "&controls=" + boolToNumber(controls) + "&loop=" + boolToNumber(loop),
    className: "content",
    allow: "autoplay"
  });
};
var YouTubeShortEmbed = function YouTubeShortEmbed(_ref4) {
  var videoId = _ref4.videoId,
    autoplay = _ref4.autoplay,
    mute = _ref4.mute,
    controls = _ref4.controls,
    loop = _ref4.loop;
  return /*#__PURE__*/React.createElement("iframe", {
    title: "Youtube short embed",
    frameBorder: "0",
    allowFullScreen: true,
    src: "https://youtube.com/embed/" + videoId + "?autoplay=" + boolToNumber(autoplay) + "&mute=" + boolToNumber(mute) + "&controls=" + boolToNumber(controls) + "&loop=" + boolToNumber(loop),
    allow: "autoplay",
    className: "shorts"
  });
};
var WistiaEmbed = function WistiaEmbed(_ref5) {
  var videoId = _ref5.videoId,
    autoplay = _ref5.autoplay,
    mute = _ref5.mute,
    controls = _ref5.controls,
    loop = _ref5.loop;
  return /*#__PURE__*/React.createElement("iframe", {
    title: "Wistia Embed",
    frameBorder: "0",
    allowFullScreen: true,
    src: "https://fast.wistia.net/embed/iframe/" + videoId + (autoplay ? "?autoPlay=true" : "") + (mute === true ? "&muted=true" : "") + (loop === true ? "&endVideoBehavior=loop" : "") + (controls === true ? "controlsVisibleOnLoad=true" : "controlsVisibleOnLoad=false"),
    className: "content",
    allow: "autoplay"
  });
};
var videoType = function videoType(url) {
  if (url.includes(".com/shorts/")) return "youtube-shorts";
  if (url.includes("youtu")) return "youtube";
  if (url.includes("vimeo")) return "vimeo";
  if (url.includes("youku")) return "youku";
  if (url.includes("wistia")) return "wistia";
};
var youtubeId = function youtubeId(url) {
  var _matches, _matches$groups;
  var matches = url.match(/(youtu\.be\/|youtube\.com\/(watch\?(.*&)?v=|(embed|v)\/))([^\?&"'>]+)/);
  if (matches && matches[5]) {
    return matches[5];
  }
  matches = url.match( /*#__PURE__*/_wrapRegExp(/youtu\.be\/|youtube\.com\/shorts\/(.*)(\?.*)?/, {
    id: 1
  }));
  return ((_matches = matches) === null || _matches === void 0 ? void 0 : (_matches$groups = _matches.groups) === null || _matches$groups === void 0 ? void 0 : _matches$groups.id) || "";
};
var vimeoId = function vimeoId(url) {
  var matches = url.match(/http(s?):\/\/(www\.)?vimeo\.com\/(\d+)($|\/)/);
  return matches !== "" && matches !== null ? matches[3] : "";
};
var youkuId = function youkuId(url) {
  var matches = url.match(/http(s?):\/\/v\.youku\.com\/v_show\/id_([A-Za-z0-9=]+)\.html/);
  return matches !== "" && matches !== null ? matches[2] : "";
};
var wistiaId = function wistiaId(url) {
  var matches = url.match(/http(s?):\/\/fast\.wistia\.net\/embed\/iframe\/(.*)($|\?)/);
  return matches !== "" && matches !== null ? matches[2] : "";
};
var videoId = function videoId(url) {
  if (videoType(url) === "youtube") return youtubeId(url);
  if (videoType(url) === "youtube-shorts") return youtubeId(url);
  if (videoType(url) === "vimeo") return vimeoId(url);
  if (videoType(url) === "youku") return youkuId(url);
  if (videoType(url) === "wistia") return wistiaId(url);
};
var VideoComponentType = function VideoComponentType(vType) {
  var components = {
    youtube: YouTubeEmbed,
    "youtube-shorts": YouTubeShortEmbed,
    vimeo: VimeoEmbed,
    youku: YoukuEmbed,
    wistia: WistiaEmbed
  };
  return components[vType];
};
var EmbeddedVideo = function EmbeddedVideo(_ref6) {
  var videoUrl = _ref6.videoUrl,
    _ref6$autoplay = _ref6.autoplay,
    autoplay = _ref6$autoplay === void 0 ? false : _ref6$autoplay,
    _ref6$mute = _ref6.mute,
    mute = _ref6$mute === void 0 ? false : _ref6$mute,
    _ref6$controls = _ref6.controls,
    controls = _ref6$controls === void 0 ? true : _ref6$controls,
    _ref6$loop = _ref6.loop,
    loop = _ref6$loop === void 0 ? false : _ref6$loop;
  var vType = videoType(videoUrl);
  var vId = videoId(videoUrl);
  var VideoComponent = VideoComponentType(vType);
  if (VideoComponent) {
    return /*#__PURE__*/React.createElement(VideoComponent, {
      videoId: vId,
      autoplay: autoplay,
      mute: mute || autoplay,
      controls: controls,
      loop: loop
    });
  }
  return null;
};
var Placeholder$1 = function Placeholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "full-image-anchor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      display: "block",
      width: "100%",
      objectFit: "cover",
      aspectRatio: "16/9"
    }
  })));
};
var HostedVideoPlaceholder = function HostedVideoPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "show-loading-animation"
  }, /*#__PURE__*/React.createElement(ReactPlaceholder, {
    ready: false,
    customPlaceholder: /*#__PURE__*/React.createElement(Placeholder$1, null),
    showLoadingAnimation: true
  }, /*#__PURE__*/React.createElement("p", null, "Loading...")));
};
var HostedVideo = function HostedVideo(_ref) {
  var videoId = _ref.videoId,
    _ref$autoPlay = _ref.autoPlay,
    autoPlay = _ref$autoPlay === void 0 ? true : _ref$autoPlay,
    _ref$mute = _ref.mute,
    mute = _ref$mute === void 0 ? false : _ref$mute,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? false : _ref$loop,
    _ref$controls = _ref.controls,
    controls = _ref$controls === void 0 ? true : _ref$controls;
  return /*#__PURE__*/React.createElement(Query, {
    query: VIDEO,
    variables: {
      input: {
        id: videoId
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    var videoRef = React.useRef(null);
    React.useEffect(function () {
      var videoEl = videoRef.current;
      if (!videoEl) return;
      videoEl.muted = mute;
      videoEl.defaultMuted = mute;
      return function () {};
    }, [loading]);
    if (error) return "Error! " + error.message;
    if (loading) return /*#__PURE__*/React.createElement(HostedVideoPlaceholder, null);
    return /*#__PURE__*/React.createElement("div", {
      style: {
        aspectRatio: "16/9",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("video", {
      ref: videoRef,
      autoPlay: autoPlay,
      controls: controls,
      muted: mute || autoPlay,
      loop: loop,
      playsInline: true,
      style: {
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("source", {
      src: data.video.asset_mp4_url,
      type: "video/mp4"
    }), "Your browser does not support HTML5 video."));
  });
};
var EmbeddedVideoWrapper = function EmbeddedVideoWrapper(_ref) {
  var videoUrl = _ref.videoUrl,
    videoId = _ref.videoId,
    autoplay = _ref.autoplay,
    controls = _ref.controls,
    loop = _ref.loop,
    mute = _ref.mute;
  return /*#__PURE__*/React.createElement("div", null, videoId ? /*#__PURE__*/React.createElement(HostedVideo, {
    videoId: videoId,
    autoplay: autoplay,
    controls: controls,
    loop: loop,
    mute: mute
  }) : /*#__PURE__*/React.createElement("div", {
    className: "full-image full-video",
    style: {
      display: "block"
    }
  }, /*#__PURE__*/React.createElement(EmbeddedVideo, {
    videoUrl: videoUrl,
    autoplay: autoplay,
    controls: controls,
    loop: loop,
    mute: mute,
    className: "content"
  })));
};
var VideoCover = function VideoCover(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "full-image-anchor",
    style: {
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-play-round"
  }), /*#__PURE__*/React.createElement("div", {
    className: "full-image full-video"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: "single_image_horizontal",
    className: "content"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: "gallery_masonry_horizontal",
    className: "content"
  })));
};
var VideoCoverNoButton = function VideoCoverNoButton(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "full-image-anchor"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image full-video"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: "single_image_horizontal",
    className: "content"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: "gallery_masonry_horizontal",
    className: "content"
  })));
};
var DirectEmbed = function DirectEmbed(_ref) {
  var image = _ref.image,
    videoUrl = _ref.videoUrl,
    videoId = _ref.videoId,
    controls = _ref.controls,
    autoplay = _ref.autoplay,
    loop = _ref.loop,
    mute = _ref.mute;
  var _useState = useState(false),
    play = _useState[0],
    setPlay = _useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, videoUrl || videoId ? /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setPlay(true);
    }
  }, play || !image ? /*#__PURE__*/React.createElement(EmbeddedVideoWrapper, {
    videoUrl: videoUrl,
    videoId: videoId,
    autoplay: play || autoplay,
    controls: controls,
    loop: loop,
    mute: mute
  }) : /*#__PURE__*/React.createElement(VideoCover, {
    image: image
  })) : /*#__PURE__*/React.createElement(VideoCoverNoButton, {
    image: image
  }));
};
var VideoModal = function VideoModal(_ref) {
  var isOpen = _ref.isOpen,
    url = _ref.url,
    onClose = _ref.onClose,
    videoId = _ref.videoId,
    controls = _ref.controls,
    autoplay = _ref.autoplay,
    loop = _ref.loop,
    mute = _ref.mute;
  return /*#__PURE__*/React.createElement(Modal, {
    className: "modal-video-wrapper " + (videoType(url) === "youtube-shorts" ? "short-basis" : ""),
    open: isOpen,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "video-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-video-inner"
  }, videoId ? /*#__PURE__*/React.createElement(HostedVideo, {
    videoId: videoId,
    controls: controls,
    autoplay: autoplay,
    loop: loop,
    mute: mute
  }) : /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper video-modal-embed"
  }, /*#__PURE__*/React.createElement(EmbeddedVideo, {
    videoUrl: url,
    autoplay: isOpen || autoplay,
    controls: controls,
    loop: loop,
    mute: mute
  })))));
};
var LightboxEmbed = /*#__PURE__*/function (_React$Component) {
  function LightboxEmbed(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleModalOpen = function (e) {
      e.preventDefault();
      _this.setState({
        isOpen: true
      });
    };
    _this.handleModalClose = function () {
      _this.setState({
        isOpen: false
      });
    };
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inheritsLoose(LightboxEmbed, _React$Component);
  var _proto = LightboxEmbed.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      image = _this$props.image,
      videoUrl = _this$props.videoUrl,
      videoId = _this$props.videoId,
      controls = _this$props.controls,
      autoplay = _this$props.autoplay,
      loop = _this$props.loop,
      mute = _this$props.mute;
    var isOpen = this.state.isOpen;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(A, {
      href: "#",
      className: "full-image-anchor",
      onClick: this.handleModalOpen
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-play-round"
    }), /*#__PURE__*/React.createElement("div", {
      className: "full-image full-video"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: image,
      variant: "single_image_horizontal",
      className: "content"
    }), /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: image,
      variant: "single_image_horizontal",
      className: "content"
    }))), isOpen && /*#__PURE__*/React.createElement(VideoModal, {
      isOpen: isOpen,
      url: videoUrl,
      videoId: videoId,
      onClose: this.handleModalClose,
      controls: controls,
      autoplay: autoplay,
      loop: loop,
      mute: mute
    }));
  };
  return LightboxEmbed;
}(React.Component);
var VideoPicker = /*#__PURE__*/function (_React$Component) {
  function VideoPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      video: _this.props.value
    };
    return _this;
  }
  _inheritsLoose(VideoPicker, _React$Component);
  var _proto = VideoPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    var newValue = value;
    this.props.onChange(newValue);
    this.setState({
      video: newValue
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var video = this.state.video;
    return /*#__PURE__*/React.createElement(Query, {
      query: VIDEOS
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var videos = data.videos;
      var options = videos.list.map(function (e) {
        return [e.id, e.title];
      });
      return /*#__PURE__*/React.createElement(SelectMenu, {
        label: "Video",
        options: options,
        value: video,
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        }
      });
    });
  };
  return VideoPicker;
}(React.Component);
var VideoContainerFullSize = function VideoContainerFullSize(_ref) {
  var image = _ref.image,
    videoUrl = _ref.videoUrl,
    variant = _ref.variant,
    videoId = _ref.videoId,
    controls = _ref.controls,
    autoplay = _ref.autoplay,
    loop = _ref.loop,
    mute = _ref.mute;
  return /*#__PURE__*/React.createElement("div", {
    className: "single-video embedded-video"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, variant === "direct_embed" ? /*#__PURE__*/React.createElement(DirectEmbed, {
    image: image,
    videoUrl: videoUrl,
    videoId: videoId,
    controls: controls,
    autoplay: autoplay,
    loop: loop,
    mute: mute
  }) : /*#__PURE__*/React.createElement(LightboxEmbed, {
    image: image,
    videoId: videoId,
    videoUrl: videoUrl,
    controls: controls,
    autoplay: autoplay,
    loop: loop,
    mute: mute
  })));
};
var VideoContainerShifted = function VideoContainerShifted(_ref2) {
  var image = _ref2.image,
    videoUrl = _ref2.videoUrl,
    variant = _ref2.variant,
    videoId = _ref2.videoId,
    controls = _ref2.controls,
    autoplay = _ref2.autoplay,
    loop = _ref2.loop,
    mute = _ref2.mute;
  return /*#__PURE__*/React.createElement("div", {
    className: "single-video embedded-video"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-shift-2"
  }, variant === "direct_embed" ? /*#__PURE__*/React.createElement(DirectEmbed, {
    image: image,
    videoUrl: videoUrl,
    videoId: videoId,
    controls: controls,
    autoplay: autoplay,
    loop: loop,
    mute: mute
  }) : /*#__PURE__*/React.createElement(LightboxEmbed, {
    image: image,
    videoUrl: videoUrl,
    videoId: videoId,
    controls: controls,
    autoplay: autoplay,
    loop: loop,
    mute: mute
  }))));
};
var Widget$k = function Widget(_ref3) {
  var image = _ref3.image,
    video_url = _ref3.video_url,
    video_id = _ref3.video_id,
    variant = _ref3.variant,
    video_width = _ref3.video_width,
    controls = _ref3.controls,
    autoplay = _ref3.autoplay,
    loop = _ref3.loop,
    mute = _ref3.mute,
    containerSettings = _ref3.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, video_width === "big_thimb" ? /*#__PURE__*/React.createElement(VideoContainerFullSize, {
    image: image,
    videoUrl: video_url,
    videoId: video_id,
    variant: variant,
    controls: controls === "yes",
    autoplay: autoplay === "yes",
    loop: loop === "yes",
    mute: mute === "yes"
  }) : /*#__PURE__*/React.createElement(VideoContainerShifted, {
    image: image,
    videoUrl: video_url,
    videoId: video_id,
    variant: variant,
    controls: controls === "yes",
    autoplay: autoplay === "yes",
    loop: loop === "yes",
    mute: mute === "yes"
  }));
};
var Config$k = {
  title: "Single Video",
  category: "Video"
};
var Defaults$k = {
  image: imagePlaceholder("1410x793"),
  video_url: "https://www.youtube.com/watch?v=xqB9KJsbIlU",
  variant: "direct_embed",
  video_width: "big_thimb",
  video_id: "",
  controls: "yes",
  autoplay: "no",
  loop: "no",
  mute: "no",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$k = {
  image: {
    type: "custom",
    component: ImagePicker
  },
  video_id: {
    type: "custom",
    component: VideoPicker
  },
  video_url: {
    type: "text"
  },
  variant: {
    type: "select",
    options: [["direct_embed", "Direct Embed"], ["lightbox", "Lightbox"]]
  },
  video_width: {
    type: "select",
    options: [["big_thimb", "Big Thumb"], ["small_thumb", "Small Thumb"]]
  },
  controls: {
    type: "select",
    options: [["yes", "Yes"], ["no", "No"]]
  },
  autoplay: {
    type: "select",
    options: [["yes", "Yes"], ["no", "No"]]
  },
  loop: {
    type: "select",
    options: [["yes", "Yes"], ["no", "No"]]
  },
  mute: {
    type: "select",
    options: [["yes", "Yes"], ["no", "No"]]
  }
};
var EmbeddedVideoWidget = {
  __proto__: null,
  Widget: Widget$k,
  Admin: Admin$k,
  Config: Config$k,
  Defaults: Defaults$k
};
var ListItem$3 = function ListItem(_ref) {
  var item = _ref.item;
  if (item.url !== "") return /*#__PURE__*/React.createElement(A, {
    href: item.url,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.image,
    variant: "original"
  }));
  return /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.image,
    variant: "original"
  });
};
var Widget$l = function Widget(_ref2) {
  var list = _ref2.list,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "partners",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logos"
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(ListItem$3, {
      key: idx,
      item: item
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "icon-arrow-right"
  }))));
};
var Config$l = {
  deprecated: true,
  title: "Partner Logos",
  category: "Logos"
};
var Defaults$l = {
  list: [{
    image: imagePlaceholder("200x200"),
    url: "#"
  }, {
    image: imagePlaceholder("200x200"),
    url: ""
  }, {
    image: imagePlaceholder("200x200"),
    url: "#"
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var PartnerField = function PartnerField(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "URL",
    onChange: function onChange(value) {
      return onChangeItem("url", value);
    },
    value: settings.url
  }));
};
PartnerField.defaultProps = {
  settings: {}
};
var Admin$l = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(PartnerField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items,
    template: [{
      image: imagePlaceholder("200x200"),
      url: "#"
    }],
    primaryField: "id"
  });
};
var EventsPartnersWidget = {
  __proto__: null,
  Widget: Widget$l,
  Admin: Admin$l,
  Config: Config$l,
  Defaults: Defaults$l
};
var Widget$m = function Widget(_ref) {
  var list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "speakers",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, list.map(function (speaker, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "speaker " + (list.length === 1 ? "single-speaker" : "")
    }, /*#__PURE__*/React.createElement("div", {
      className: "speaker-image"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: speaker.image,
      variant: "original"
    })), /*#__PURE__*/React.createElement("div", {
      className: "speaker-text"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "speaker-name"
    }, speaker.name), (speaker.position || speaker.company_link && speaker.company) && /*#__PURE__*/React.createElement("h6", {
      className: "speaker-meta"
    }, speaker.position, speaker.company_link && speaker.company && /*#__PURE__*/React.createElement(React.Fragment, null, speaker.position ? ", " : "", /*#__PURE__*/React.createElement(A, {
      href: speaker.company_link
    }, speaker.company))), parseMarkdown(speaker.biography)));
  })));
};
var Config$m = {
  title: "Speakers List",
  category: "Events"
};
var Defaults$m = {
  list: [{
    image: imagePlaceholder("200x200"),
    name: "John Doe",
    company: "Chaos Group",
    company_link: "#",
    position: "developer",
    biography: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minus ducimus sint libero iusto nam rerum ipsa quas praesentium eum consectetur!"
  }, {
    image: imagePlaceholder("200x200"),
    name: "John Doe",
    company: "Chaos Group",
    company_link: "#",
    position: "developer",
    biography: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minus ducimus sint libero iusto nam rerum ipsa quas praesentium eum consectetur!"
  }, {
    image: imagePlaceholder("200x200"),
    name: "John Doe",
    company: "Chaos Group",
    company_link: "#",
    position: "developer",
    biography: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minus ducimus sint libero iusto nam rerum ipsa quas praesentium eum consectetur!"
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var SpeakerField = function SpeakerField(_ref2) {
  var _ref2$settings = _ref2.settings,
    settings = _ref2$settings === void 0 ? {} : _ref2$settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Name",
    onChange: function onChange(value) {
      return onChangeItem("name", value);
    },
    value: settings.name
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Company",
    onChange: function onChange(value) {
      return onChangeItem("company", value);
    },
    value: settings.company
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Company Link",
    onChange: function onChange(value) {
      return onChangeItem("company_link", value);
    },
    value: settings.company_link
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Position",
    onChange: function onChange(value) {
      return onChangeItem("position", value);
    },
    value: settings.position
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Biography",
    onChange: function onChange(value) {
      return onChangeItem("biography", value);
    },
    value: settings.biography
  }));
};
var Admin$m = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(SpeakerField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items,
    template: {
      image: imagePlaceholder("200x200"),
      name: "John Doe",
      company: "Chaos Group",
      company_link: "#",
      position: "developer",
      biography: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minus ducimus sint libero iusto nam rerum ipsa quas praesentium eum consectetur!"
    },
    primaryField: "name"
  });
};
var EventsSpeakersWidget = {
  __proto__: null,
  Widget: Widget$m,
  Admin: Admin$m,
  Config: Config$m,
  Defaults: Defaults$m
};
var thumbClass = function thumbClass(variant) {
  switch (variant) {
    case "2_columns":
      return "previews-2";
    case "3_columns":
      return "previews-3";
    case "4_columns":
      return "previews-4";
    default:
      return "previews-2";
  }
};
var Widget$n = function Widget(_ref) {
  var variant = _ref.variant,
    list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "vray-days"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, list.map(function (vrayDay, idx) {
    return /*#__PURE__*/React.createElement("article", {
      key: idx,
      className: "article-preview " + thumbClass(variant)
    }, vrayDay.button.button_link !== "" ? /*#__PURE__*/React.createElement(A, {
      href: vrayDay.button.button_link
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: vrayDay.image,
      variant: "original"
    })) : /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: vrayDay.image,
      variant: "original"
    }), /*#__PURE__*/React.createElement("h6", {
      className: "article-title"
    }, vrayDay.title), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, vrayDay.time_and_place)), /*#__PURE__*/React.createElement("p", null, vrayDay.lecturer_and_position), /*#__PURE__*/React.createElement("p", {
      className: "article-short-desc"
    }, vrayDay.description), vrayDay.button.button_link !== "" ? /*#__PURE__*/React.createElement(Button$1, {
      settings: vrayDay.button
    }) : "");
  }))));
};
var Config$n = {
  title: "V-Ray Days",
  category: "Lists"
};
var Defaults$n = {
  variant: "2_columns",
  list: [{
    image: imagePlaceholder("200x200"),
    title: "Title",
    time_and_place: "21.09.2017, Sofia",
    lecturer_and_position: "John Doe, Software Engineer",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perferendis deserunt sed, cum? Quisquam, suscipit, quis.",
    button: {}
  }, {
    image: imagePlaceholder("200x200"),
    title: "Title",
    time_and_place: "21.09.2017, Sofia",
    lecturer_and_position: "John Doe, Software Engineer",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perferendis deserunt sed, cum? Quisquam, suscipit, quis.",
    button: {}
  }],
  containerSettings: {
    theme: "light",
    spacing: "none"
  }
};
var VrayDayField = function VrayDayField(_ref2) {
  var _ref2$settings = _ref2.settings,
    settings = _ref2$settings === void 0 ? {} : _ref2$settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Time and Place",
    onChange: function onChange(value) {
      return onChangeItem("time_and_place", value);
    },
    value: settings.time_and_place
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Lecturer and Position",
    onChange: function onChange(value) {
      return onChangeItem("lecturer_and_position", value);
    },
    value: settings.lecturer_and_position
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    button_settings_title: "Button",
    value: settings.button,
    onChange: function onChange(values) {
      return onChangeItem("button", values);
    }
  }));
};
var Admin$n = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["2_columns", "2 Columns"], ["3_columns", "3 Columns"], ["4_columns", "4 Columns"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(VrayDayField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      image: imagePlaceholder("200x200"),
      title: "Title",
      time_and_place: "21.09.2017, Sofia",
      lecturer_and_position: "John Doe, Software Engineer",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Perferendis deserunt sed, cum? Quisquam, suscipit, quis.",
      button: {}
    },
    primaryField: "title"
  }));
};
var EventsVrayDaysWidget = {
  __proto__: null,
  Widget: Widget$n,
  Admin: Admin$n,
  Config: Config$n,
  Defaults: Defaults$n
};
var Widget$o = function Widget(_props) {
  return null;
};
var Config$o = {
  title: "FAQ Categories Accordion",
  category: "Misc",
  deprecated: true
};
var Defaults$o = {
  list: [],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$o = function Admin(items, onChange) {};
var FaqCategoriesAccordionWidget = {
  __proto__: null,
  Widget: Widget$o,
  Admin: Admin$o,
  Config: Config$o,
  Defaults: Defaults$o
};
var Widget$p = function Widget(_props) {
  return null;
};
var Config$p = {
  title: "FAQ Categories Feed",
  category: "Misc",
  deprecated: true
};
var Defaults$p = {
  list: [],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$p = {};
var FaqCategoriesFeedWidget = {
  __proto__: null,
  Widget: Widget$p,
  Admin: Admin$p,
  Config: Config$p,
  Defaults: Defaults$p
};
var ListItem$4 = function ListItem(_ref) {
  var item = _ref.item;
  if (item.url !== "") return /*#__PURE__*/React.createElement(A, {
    href: item.url,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.image,
    variant: "original"
  }));
  return /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.image,
    variant: "original"
  });
};
var Widget$q = function Widget(_ref2) {
  var list = _ref2.list,
    mobileVariant = _ref2.mobileVariant,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "fluid-logos " + mobileVariant,
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logos"
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(ListItem$4, {
      key: idx,
      item: item
    });
  })), mobileVariant === "one_row" && /*#__PURE__*/React.createElement("div", {
    className: "mobile-slider"
  }, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 30,
    paginationClickable: true,
    loop: true
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement(ListItem$4, {
      item: item
    }));
  })))));
};
var Config$q = {
  title: "Fluid Logos",
  category: "Logos"
};
var TEMPLATE = {
  image: imagePlaceholder("200x200"),
  url: ""
};
var Defaults$q = {
  list: [_extends({
    id: 1
  }, TEMPLATE), _extends({
    id: 2
  }, TEMPLATE), _extends({
    id: 3
  }, TEMPLATE)],
  mobileVariant: "rows",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var PartnerField$1 = function PartnerField(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "URL",
    onChange: function onChange(value) {
      return onChangeItem("url", value);
    },
    value: settings.url
  }));
};
PartnerField$1.defaultProps = {
  settings: {}
};
var Admin$q = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Mobile Variant",
    options: [["rows", "Default"], ["one_row", "Slider"]],
    value: settings.mobileVariant,
    onChange: function onChange(value) {
      return _onChange("mobileVariant", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(PartnerField$1, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      image: imagePlaceholder("200x200"),
      url: "#"
    },
    primaryField: "id"
  }));
};
var FluidLogosWidget = {
  __proto__: null,
  Widget: Widget$q,
  Admin: Admin$q,
  Config: Config$q,
  Defaults: Defaults$q
};
var imageSize = function imageSize(height) {
  switch (height) {
    case "crop":
      return "full_width_image";
    case "full":
    case "original":
      return "full_width_original";
    default:
      return "full_width_image";
  }
};
var FullWidthImage = function FullWidthImage(_ref) {
  var height = _ref.height;
  return /*#__PURE__*/React.createElement("div", {
    className: "video-cover"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: height === "full" ? "100vh" : 600
    }
  })));
};
var FullWidthImagePlaceholder = function FullWidthImagePlaceholder(_ref2) {
  var realComponent = _ref2.realComponent,
    ready = _ref2.ready,
    height = _ref2.height;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: function placeholderComponent() {
      return /*#__PURE__*/React.createElement(FullWidthImage, {
        height: height
      });
    },
    realComponent: realComponent
  });
};
var VideoPreview = function VideoPreview(_ref) {
  var video = _ref.video,
    image = _ref.image,
    height = _ref.height;
  return /*#__PURE__*/React.createElement(Query, {
    query: VIDEO,
    variables: {
      input: {
        id: video
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var video = data.video;
    return /*#__PURE__*/React.createElement(FullWidthImagePlaceholder, {
      height: height,
      ready: loading || !video,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("video", {
          autoPlay: true,
          playsInline: true,
          loop: true,
          muted: true,
          width: "1920",
          height: "600"
        }, /*#__PURE__*/React.createElement("source", {
          src: data.video.asset_mp4_url,
          type: "video/mp4"
        }), "Your browser does not support HTML5 video."), video.credits && /*#__PURE__*/React.createElement("div", {
          className: "credits"
        }, video.credits), /*#__PURE__*/React.createElement(Img, {
          src: image || video.cover,
          variant: imageSize(height)
        }), /*#__PURE__*/React.createElement(Img, {
          src: image || video.cover,
          variant: "mobile_square"
        }));
      }
    });
  });
};
var Title$1 = function Title(_ref) {
  var title = _ref.title,
    titleSize = _ref.titleSize;
  switch (titleSize) {
    case "default":
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title"
      }, title);
    case "large":
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title large-title"
      }, title);
    case "medium":
      return /*#__PURE__*/React.createElement("h2", {
        className: "full-image-title medium-title"
      }, title);
    case "small":
      return /*#__PURE__*/React.createElement("h3", {
        className: "full-image-title small-title"
      }, title);
    default:
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title"
      }, title);
  }
};
var BouncingButton = function BouncingButton(_ref2) {
  var url = _ref2.url;
  return /*#__PURE__*/React.createElement("a", {
    href: url,
    className: "bouncing-button-link"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bouncing-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "outer-ring"
  }), /*#__PURE__*/React.createElement("div", {
    className: "outer-ring-2"
  })));
};
var Widget$r = function Widget(_ref3) {
  var geoIp = _ref3.geoIp,
    image = _ref3.image,
    logo = _ref3.logo,
    logo_position = _ref3.logo_position,
    overlay = _ref3.overlay,
    height = _ref3.height,
    title = _ref3.title,
    title_size = _ref3.title_size,
    sub_title = _ref3.sub_title,
    button_1 = _ref3.button_1,
    button_2 = _ref3.button_2,
    video = _ref3.video,
    bouncing_arrow_anchor = _ref3.bouncing_arrow_anchor,
    containerSettings = _ref3.containerSettings;
  return /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: geoIp && geoIp.activeCountries || [],
    countryGroupIds: geoIp && geoIp.activeGroups || [],
    active: geoIp && geoIp.active || false
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image-section image-container " + (video ? "video-cover" : "") + " height-" + height
  }, parseFloat(overlay, 10) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "cnt-overlay",
    style: {
      background: "rgba(0, 0, 0, " + overlay + ")"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "full-image " + height
  }, video && /*#__PURE__*/React.createElement(VideoPreview, {
    video: video,
    image: image,
    height: height
  }), !video && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: imageSize(height)
  }), /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "mobile_square"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, logo !== undefined && logo_position === "above" ? /*#__PURE__*/React.createElement(Image, {
    src: logo,
    variant: "mobile_square"
  }) : "", title && /*#__PURE__*/React.createElement(Title$1, {
    title: title,
    titleSize: title_size
  }), sub_title !== "" ? /*#__PURE__*/React.createElement("h5", {
    className: "full-image-sub-title"
  }, sub_title) : "", logo !== undefined && logo_position === "below" && /*#__PURE__*/React.createElement("div", {
    className: "logo-wrapper"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Image, {
    src: logo,
    variant: "mobile_square"
  }), /*#__PURE__*/React.createElement("br", null)), button_1.label && button_1.link && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1
  }), button_2.label && button_2.link && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2
  })))), (height === "full" || "original") && bouncing_arrow_anchor && /*#__PURE__*/React.createElement(BouncingButton, {
    url: bouncing_arrow_anchor
  })))));
};
var Config$r = {
  title: "Lead Image",
  category: "Image"
};
var Defaults$r = {
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  image: imagePlaceholder("1920x600"),
  logo: imagePlaceholder("40x40"),
  logo_position: "above",
  overlay: 0,
  height: "crop",
  title_size: "default",
  button_1: ButtonSettingsWithDescription.defaults,
  button_2: _extends({}, ButtonSettingsWithDescription.defaults, {
    link: ""
  }),
  title: "Title",
  sub_title: "",
  video: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  },
  bouncing_arrow_anchor: "#"
};
var Admin$r = {
  geoIp: {
    type: "custom",
    component: GeoIpPicker
  },
  image: {
    type: "custom",
    component: ImagePicker
  },
  logo: {
    type: "custom",
    component: ImagePicker
  },
  video: {
    type: "custom",
    component: VideoPicker
  },
  logo_position: {
    type: "select",
    options: [["above", "Above"], ["below", "Below"]]
  },
  overlay: {
    type: "select",
    options: [[0, "No Overlay"], [0.1, "10%"], [0.2, "20%"], [0.3, "30%"], [0.4, "40%"], [0.5, "50%"], [0.6, "60%"], [0.7, "70%"], [0.8, "80%"]]
  },
  height: {
    type: "select",
    options: [["crop", "Cropped"], ["full", "Full screen"], ["original", "Keep original height"]]
  },
  title: {
    type: "text"
  },
  title_size: {
    type: "select",
    options: [["large", "Larger"], ["default", "Default"], ["medium", "Medium"], ["small", "Small"]]
  },
  sub_title: {
    type: "text"
  },
  button_1: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button 1"
  },
  button_2: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button 2"
  },
  bouncing_arrow_anchor: {
    type: "text",
    hint: "The button is visible when this field is filled in and the 'height' setting is set to 'Full screen' or 'Keep original height'"
  }
};
var FullWidthImageWidget = {
  __proto__: null,
  Widget: Widget$r,
  Admin: Admin$r,
  Config: Config$r,
  Defaults: Defaults$r
};
var Title$2 = function Title(_ref) {
  var title = _ref.title,
    titleSize = _ref.titleSize;
  switch (titleSize) {
    case "default":
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title"
      }, title);
    case "large":
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title large-title"
      }, title);
    case "medium":
      return /*#__PURE__*/React.createElement("h2", {
        className: "full-image-title medium-title"
      }, title);
    case "small":
      return /*#__PURE__*/React.createElement("h3", {
        className: "full-image-title small-title"
      }, title);
    default:
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title"
      }, title);
  }
};
var imageSize$1 = function imageSize(height) {
  switch (height) {
    case "crop":
      return "full_width_image";
    case "original":
      return "full_width_original";
    default:
      return "full_width_image";
  }
};
var Widget$s = /*#__PURE__*/function (_React$Component) {
  function Widget(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleModalOpen = function (e) {
      e.preventDefault();
      _this.setState({
        isOpen: true
      });
    };
    _this.handleModalClose = function () {
      _this.setState({
        isOpen: false
      });
    };
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inheritsLoose(Widget, _React$Component);
  var _proto = Widget.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      title = _this$props.title,
      title_size = _this$props.title_size,
      sub_title = _this$props.sub_title,
      video_link = _this$props.video_link,
      overlay = _this$props.overlay,
      height = _this$props.height,
      image = _this$props.image,
      containerSettings = _this$props.containerSettings;
    var isOpen = this.state.isOpen;
    return /*#__PURE__*/React.createElement(Container$1, {
      settings: containerSettings
    }, /*#__PURE__*/React.createElement("div", {
      className: "full-image-section",
      ref: function ref(videoWrapper) {
        return _this2.videoWrapper = videoWrapper;
      }
    }, parseFloat(overlay, 10) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "cnt-overlay",
      style: {
        background: "rgba(0, 0, 0, " + overlay + ")"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "full-image-anchor"
    }, /*#__PURE__*/React.createElement("div", {
      className: "full-image " + height
    }, /*#__PURE__*/React.createElement(Image, {
      src: image,
      variant: imageSize$1(height)
    }), /*#__PURE__*/React.createElement(Image, {
      src: image,
      variant: "mobile_square"
    })), /*#__PURE__*/React.createElement("div", {
      className: "full-image-title-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "full-image-title-inner"
    }, /*#__PURE__*/React.createElement("div", {
      className: "headings"
    }, title && /*#__PURE__*/React.createElement(Title$2, {
      title: title,
      titleSize: title_size
    }), /*#__PURE__*/React.createElement("br", null), sub_title !== "" ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
      className: "full-image-sub-title"
    }, sub_title), /*#__PURE__*/React.createElement("br", null)) : "", video_link !== "" ? /*#__PURE__*/React.createElement(A, {
      href: "#",
      className: "icon-play-round",
      onClick: this.handleModalOpen
    }) : ""))))), isOpen && /*#__PURE__*/React.createElement(VideoModal, {
      isOpen: isOpen,
      url: video_link,
      onClose: this.handleModalClose
    })));
  };
  return Widget;
}(React.Component);
var Config$s = {
  title: "Lead Video",
  category: "Video"
};
var Defaults$s = {
  title: "Title",
  title_size: "default",
  sub_title: "",
  video_link: "https://www.youtube.com/watch?v=U9rgG2vPAvQ",
  overlay: 0,
  height: "crop",
  image: imagePlaceholder("1920x600"),
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$s = {
  image: {
    type: "custom",
    component: ImagePicker
  },
  overlay: {
    type: "select",
    options: [[0, "No Overlay"], [0.1, "10%"], [0.2, "20%"], [0.3, "30%"], [0.4, "40%"], [0.5, "50%"], [0.6, "60%"], [0.7, "70%"], [0.8, "80%"]]
  },
  height: {
    type: "select",
    options: [["crop", "Crop"], ["original", "Original"]]
  },
  video_link: {
    type: "text"
  },
  title: {
    type: "text",
    label: "title optional"
  },
  title_size: {
    type: "select",
    options: [["large", "Larger"], ["default", "Default"], ["medium", "Medium"], ["small", "Small"]]
  },
  sub_title: {
    type: "text",
    label: "sub title optional"
  }
};
var FullWidthVideoWidget = {
  __proto__: null,
  Widget: Widget$s,
  Admin: Admin$s,
  Config: Config$s,
  Defaults: Defaults$s
};
var GalleryPicker = /*#__PURE__*/function (_React$Component) {
  function GalleryPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    var value = props.value;
    _this.state = {
      gallery: value
    };
    return _this;
  }
  _inheritsLoose(GalleryPicker, _React$Component);
  var _proto = GalleryPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    var onChange = this.props.onChange;
    var newValue = value;
    onChange(newValue);
    this.setState({
      gallery: newValue
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var gallery = this.state.gallery;
    return /*#__PURE__*/React.createElement(Query, {
      query: GALLERIES_MINIMAL
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var galleries = data.galleries;
      var options = galleries.list.map(function (e) {
        return [e.id, e.name];
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
        label: "Gallery",
        options: options,
        value: gallery,
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        }
      }), gallery && /*#__PURE__*/React.createElement("a", {
        href: "/admin/galleries/" + gallery + "/gallery_images",
        target: "_blank"
      }, "Edit gallery images"));
    });
  };
  return GalleryPicker;
}(React.Component);
var RadioButton = function RadioButton(_ref) {
  var checked = _ref.checked,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("input", {
    type: "radio",
    checked: checked,
    onChange: onChange
  });
};
var wrapperStyles = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "space-between"
};
var buttonWrapper = {
  display: "block",
  width: "24%",
  textAlign: "center",
  marginBottom: "1em"
};
var imgStyles = {
  display: "block",
  width: "100%"
};
var labelStyles$2 = {
  padding: 0,
  margin: 0,
  boxSizing: "border-box",
  fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"',
  lineHeight: "1.5",
  color: "#000",
  backgroundColor: "transparent",
  display: "block",
  marginBottom: "1.6px",
  textTransform: "uppercase",
  fontWeight: "bold",
  fontSize: "12px",
  cursor: "pointer"
};
var LayoutPicker = /*#__PURE__*/function (_React$Component) {
  function LayoutPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      layout: props.value || 1
    };
    return _this;
  }
  _inheritsLoose(LayoutPicker, _React$Component);
  var _proto = LayoutPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    var onChange = this.props.onChange;
    this.setState({
      layout: value
    }, function () {
      return onChange(value);
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var layout = this.state.layout;
    var label = this.props.label;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
      htmlFor: "",
      style: labelStyles$2
    }, label), /*#__PURE__*/React.createElement("div", {
      style: wrapperStyles
    }, /*#__PURE__*/React.createElement("label", {
      className: "layout-wrapper",
      style: buttonWrapper
    }, /*#__PURE__*/React.createElement("img", {
      style: imgStyles,
      src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI0OTlweCIgaGVpZ2h0PSIyODFweCIgdmlld0JveD0iMCAwIDQ5OSAyODEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+R3JvdXAgMjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJnYWxsZXJ5LTEiPiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yIj4gICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzAwMDAwMCIgeD0iMCIgeT0iMCIgd2lkdGg9IjQ5OSIgaGVpZ2h0PSIyODEiPjwvcmVjdD4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIj4gICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iI0ZGN0JBMyIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2NSIgaGVpZ2h0PSIxODYiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSIxIiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9Ijc4IiB5PSI5OSI+MTwvdHNwYW4+ICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2Ny4wMDAwMDAsIDEuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRjdCQTMiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iMTg2Ij48L3JlY3Q+ICAgICAgICAgICAgICAgICAgICA8dGV4dCBpZD0iMiIgZm9udC1mYW1pbHk9IlJvYm90by1SZWd1bGFyLCBSb2JvdG8iIGZvbnQtc2l6ZT0iMTYiIGZvbnQtd2VpZ2h0PSJub3JtYWwiIGZpbGw9IiNGRkZGRkYiPiAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSI4MCIgeT0iOTkiPjI8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgPC90ZXh0PiAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC1Db3B5LTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMy4wMDAwMDAsIDEuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRkIyQTgiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iOTIiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSIzIiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjgwIiB5PSI1MiI+MzwvdHNwYW4+ICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLUNvcHktMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzMzLjAwMDAwMCwgOTQuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRkIyQTgiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iOTMiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSI0IiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjgwIiB5PSI1MyI+NDwvdHNwYW4+ICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLUNvcHktNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDE4OC4wMDAwMDApIj4gICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iI0ZGQjJBOCIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2NSIgaGVpZ2h0PSI5MiI+PC9yZWN0PiAgICAgICAgICAgICAgICAgICAgPHRleHQgaWQ9IjUiIGZvbnQtZmFtaWx5PSJSb2JvdG8tUmVndWxhciwgUm9ib3RvIiBmb250LXNpemU9IjE2IiBmb250LXdlaWdodD0ibm9ybWFsIiBmaWxsPSIjRkZGRkZGIj4gICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iODAiIHk9IjUyIj41PC90c3Bhbj4gICAgICAgICAgICAgICAgICAgIDwvdGV4dD4gICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtQ29weS01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjcuMDAwMDAwLCAxODguMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRjkzNUIiIHg9IjAiIHk9IjAiIHdpZHRoPSIzMzEiIGhlaWdodD0iOTIiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSI2IiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjE2MCIgeT0iNTIiPjY8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgPC90ZXh0PiAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgPC9nPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+",
      alt: "Layout 1"
    }), /*#__PURE__*/React.createElement(RadioButton, {
      checked: layout === 1,
      onChange: function onChange() {
        return _this2.handleChange(1);
      }
    })), /*#__PURE__*/React.createElement("label", {
      className: "layout-wrapper",
      style: buttonWrapper
    }, /*#__PURE__*/React.createElement("img", {
      style: imgStyles,
      src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI0OTlweCIgaGVpZ2h0PSIyODFweCIgdmlld0JveD0iMCAwIDQ5OSAyODEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+R3JvdXAgNDwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJnYWxsZXJ5LTIiPiAgICAgICAgICAgIDxnIGlkPSJHcm91cC00Ij4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTMiPiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLTIiPiAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUiIGZpbGw9IiMwMDAwMDAiIHg9IjAiIHk9IjAiIHdpZHRoPSI0OTkiIGhlaWdodD0iMjgxIj48L3JlY3Q+ICAgICAgICAgICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjcuMDAwMDAwLCAxLjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRjdCQTMiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iMTg2Ij48L3JlY3Q+ICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSIyIiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iNzgiIHk9Ijk5Ij4yPC90c3Bhbj4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtQ29weSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzMzLjAwMDAwMCwgOTQuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iI0ZGN0JBMyIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2NSIgaGVpZ2h0PSIxODYiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHQgaWQ9IjYiIGZvbnQtZmFtaWx5PSJSb2JvdG8tUmVndWxhciwgUm9ib3RvIiBmb250LXNpemU9IjE2IiBmb250LXdlaWdodD0ibm9ybWFsIiBmaWxsPSIjRkZGRkZGIj4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSI4MCIgeT0iOTkiPjY8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC1Db3B5LTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCA5NS4wMDAwMDApIj4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjRkZCMkE4IiB4PSIwIiB5PSIwIiB3aWR0aD0iMTY1IiBoZWlnaHQ9IjkyIj48L3JlY3Q+ICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSI0IiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iODAiIHk9IjUyIj40PC90c3Bhbj4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC90ZXh0PiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtQ29weS0zIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgzMzMuMDAwMDAwLCAxLjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRkIyQTgiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iOTIiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHQgaWQ9IjMiIGZvbnQtZmFtaWx5PSJSb2JvdG8tUmVndWxhciwgUm9ib3RvIiBmb250LXNpemU9IjE2IiBmb250LXdlaWdodD0ibm9ybWFsIiBmaWxsPSIjRkZGRkZGIj4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSI4MCIgeT0iNTIiPjM8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC1Db3B5LTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRkIyQTgiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iOTMiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRleHQgaWQ9IjEiIGZvbnQtZmFtaWx5PSJSb2JvdG8tUmVndWxhciwgUm9ib3RvIiBmb250LXNpemU9IjE2IiBmb250LXdlaWdodD0ibm9ybWFsIiBmaWxsPSIjRkZGRkZGIj4gICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSI4MCIgeT0iNTIiPjE8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC1Db3B5LTUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxODguMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iI0ZGOTM1QiIgeD0iMCIgeT0iMCIgd2lkdGg9IjMzMSIgaGVpZ2h0PSI5MiI+PC9yZWN0PiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8dGV4dCBpZD0iNSIgZm9udC1mYW1pbHk9IlJvYm90by1SZWd1bGFyLCBSb2JvdG8iIGZvbnQtc2l6ZT0iMTYiIGZvbnQtd2VpZ2h0PSJub3JtYWwiIGZpbGw9IiNGRkZGRkYiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjE2MCIgeT0iNTIiPjU8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgPC9nPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+",
      alt: "Layout 2"
    }), /*#__PURE__*/React.createElement(RadioButton, {
      checked: layout === 2,
      onChange: function onChange() {
        return _this2.handleChange(2);
      }
    })), /*#__PURE__*/React.createElement("label", {
      className: "layout-wrapper",
      style: buttonWrapper
    }, /*#__PURE__*/React.createElement("img", {
      style: imgStyles,
      src: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI0OTlweCIgaGVpZ2h0PSIyODFweCIgdmlld0JveD0iMCAwIDQ5OSAyODEiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+R3JvdXAgMjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJTeW1ib2xzIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJnYWxsZXJ5LTMiPiAgICAgICAgICAgIDxnIGlkPSJHcm91cC0yIj4gICAgICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZSIgZmlsbD0iIzAwMDAwMCIgeD0iMCIgeT0iMCIgd2lkdGg9IjQ5OSIgaGVpZ2h0PSIyODEiPjwvcmVjdD4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjAwMDAwMCwgMS4wMDAwMDApIj4gICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iI0ZGN0JBMyIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2NSIgaGVpZ2h0PSIxODYiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSIxIiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9Ijc4IiB5PSI5OSI+MTwvdHNwYW4+ICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLUNvcHkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMy4wMDAwMDAsIDEuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRjdCQTMiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iMTg2Ij48L3JlY3Q+ICAgICAgICAgICAgICAgICAgICA8dGV4dCBpZD0iMyIgZm9udC1mYW1pbHk9IlJvYm90by1SZWd1bGFyLCBSb2JvdG8iIGZvbnQtc2l6ZT0iMTYiIGZvbnQtd2VpZ2h0PSJub3JtYWwiIGZpbGw9IiNGRkZGRkYiPiAgICAgICAgICAgICAgICAgICAgICAgIDx0c3BhbiB4PSI4MCIgeT0iOTkiPjM8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgPC90ZXh0PiAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgICAgIDxnIGlkPSJHcm91cC1Db3B5LTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2Ny4wMDAwMDAsIDEuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRkIyQTgiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iOTIiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSIyIiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjgwIiB5PSI1MiI+MjwvdHNwYW4+ICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLUNvcHktMyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTY3LjAwMDAwMCwgOTQuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRkIyQTgiIHg9IjAiIHk9IjAiIHdpZHRoPSIxNjUiIGhlaWdodD0iOTMiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSI0IiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjgwIiB5PSI1MyI+NDwvdHNwYW4+ICAgICAgICAgICAgICAgICAgICA8L3RleHQ+ICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPGcgaWQ9Ikdyb3VwLUNvcHktNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDE4OC4wMDAwMDApIj4gICAgICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iI0ZGQjJBOCIgeD0iMCIgeT0iMCIgd2lkdGg9IjE2NSIgaGVpZ2h0PSI5MiI+PC9yZWN0PiAgICAgICAgICAgICAgICAgICAgPHRleHQgaWQ9IjUiIGZvbnQtZmFtaWx5PSJSb2JvdG8tUmVndWxhciwgUm9ib3RvIiBmb250LXNpemU9IjE2IiBmb250LXdlaWdodD0ibm9ybWFsIiBmaWxsPSIjRkZGRkZGIj4gICAgICAgICAgICAgICAgICAgICAgICA8dHNwYW4geD0iODAiIHk9IjUyIj41PC90c3Bhbj4gICAgICAgICAgICAgICAgICAgIDwvdGV4dD4gICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICA8ZyBpZD0iR3JvdXAtQ29weS01IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxNjcuMDAwMDAwLCAxODguMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiNGRjkzNUIiIHg9IjAiIHk9IjAiIHdpZHRoPSIzMzEiIGhlaWdodD0iOTIiPjwvcmVjdD4gICAgICAgICAgICAgICAgICAgIDx0ZXh0IGlkPSI2IiBmb250LWZhbWlseT0iUm9ib3RvLVJlZ3VsYXIsIFJvYm90byIgZm9udC1zaXplPSIxNiIgZm9udC13ZWlnaHQ9Im5vcm1hbCIgZmlsbD0iI0ZGRkZGRiI+ICAgICAgICAgICAgICAgICAgICAgICAgPHRzcGFuIHg9IjE2MCIgeT0iNTIiPjY8L3RzcGFuPiAgICAgICAgICAgICAgICAgICAgPC90ZXh0PiAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgPC9nPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+",
      alt: "Layout 3"
    }), /*#__PURE__*/React.createElement(RadioButton, {
      checked: layout === 3,
      onChange: function onChange() {
        return _this2.handleChange(3);
      }
    })), /*#__PURE__*/React.createElement("label", {
      className: "layout-wrapper",
      style: buttonWrapper
    }, /*#__PURE__*/React.createElement("img", {
      style: imgStyles,
      src: "data:image/svg+xml;base64,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",
      alt: "Layout 4"
    }), /*#__PURE__*/React.createElement(RadioButton, {
      checked: layout === 4,
      onChange: function onChange() {
        return _this2.handleChange(4);
      }
    }))));
  };
  return LayoutPicker;
}(React.Component);
var AdminFileds = function AdminFileds(_ref) {
  var _onChange = _ref.onChange,
    settings = _ref.settings;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      marginBottom: "1em"
    }
  }, /*#__PURE__*/React.createElement(LayoutPicker, {
    label: "Gallery Variant",
    onChange: function onChange(value) {
      return _onChange("galleryVariant", value);
    },
    value: settings.galleryVariant
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexWrap: "wrap"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "1em",
      marginBottom: "1em",
      width: "30%"
    }
  }, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image_0", value);
    },
    value: settings.image_0,
    label: "Image 1"
  }), /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(value) {
      return _onChange("gallery_0", value);
    },
    value: settings.gallery_0
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "1em",
      marginBottom: "1em",
      width: "30%"
    }
  }, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image_1", value);
    },
    value: settings.image_1,
    label: "Image 2"
  }), /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(value) {
      return _onChange("gallery_1", value);
    },
    value: settings.gallery_1
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "1em",
      marginBottom: "1em",
      width: "30%"
    }
  }, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image_2", value);
    },
    value: settings.image_2,
    label: "Image 3"
  }), /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(value) {
      return _onChange("gallery_2", value);
    },
    value: settings.gallery_2
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "1em",
      marginBottom: "1em",
      width: "30%"
    }
  }, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image_3", value);
    },
    value: settings.image_3,
    label: "Image 4"
  }), /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(value) {
      return _onChange("gallery_3", value);
    },
    value: settings.gallery_3
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "1em",
      marginBottom: "1em",
      width: "30%"
    }
  }, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image_4", value);
    },
    value: settings.image_4,
    label: "Image 5"
  }), /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(value) {
      return _onChange("gallery_4", value);
    },
    value: settings.gallery_4
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginRight: "1em",
      marginBottom: "1em",
      width: "30%"
    }
  }, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image_5", value);
    },
    value: settings.image_5,
    label: "Image 6"
  }), /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(value) {
      return _onChange("gallery_5", value);
    },
    value: settings.gallery_5
  }))));
};
var Thumbs = function Thumbs() {
  return /*#__PURE__*/React.createElement("div", {
    className: "dark-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gallery-masonry"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: "1000px"
    }
  })));
};
var GalleryPlaceholder = function GalleryPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: Thumbs,
    realComponent: realComponent
  });
};
var hostUrl = function hostUrl(url) {
  var newUrl = new URL(url);
  return newUrl.origin;
};
var galleryPath = function galleryPath(currentUrl, gallerySlug) {
  return [hostUrl(currentUrl).replace(new RegExp("[/]$"), ""), "gallery", gallerySlug.replace(new RegExp("^[/]"), "")].join("/");
};
var updateHistory = function updateHistory(currentUrl, slug) {
  return history.pushState(null, null, galleryPath(currentUrl, slug));
};
var RelatedGalleries = function (_ref) {
  var galleries = _ref.galleries,
    pagePath = _ref.pagePath,
    onGalleryChange = _ref.onGalleryChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "related-galleries"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "section-title"
  }, "Related projects"))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Slider, {
    containerClass: "related-projects swiper-container",
    rebuildOnUpdate: true,
    pagination: {
      clickable: false
    },
    navigation: {
      nextEl: ".swiper-button-next.icon-arrow-right",
      prevEl: ".swiper-button-prev.icon-arrow-left"
    },
    loop: true,
    breakpoints: {
      599: {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 30
      },
      600: {
        slidesPerView: 5,
        slidesPerGroup: 1,
        spaceBetween: 20
      }
    }
  }, galleries.map(function (gallery) {
    var _gallery$author, _gallery$industry;
    return /*#__PURE__*/React.createElement(A, {
      key: gallery.id,
      className: "gallery-thumb article-image",
      href: pagePath("gallery/" + gallery.slug),
      onClick: function onClick(event) {
        return onGalleryChange && onGalleryChange(event, gallery.slug);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-container"
    }, /*#__PURE__*/React.createElement(Image, {
      src: gallery.image,
      variant: "articles_2_columns"
    })), /*#__PURE__*/React.createElement("div", {
      className: "opacity-overlay"
    }, /*#__PURE__*/React.createElement("div", {
      className: "thumb-text"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "thumb-title"
    }, gallery.name), /*#__PURE__*/React.createElement("p", {
      className: "meta"
    }, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, (_gallery$author = gallery.author) === null || _gallery$author === void 0 ? void 0 : _gallery$author.name), /*#__PURE__*/React.createElement("span", {
      className: "category"
    }, (_gallery$industry = gallery.industry) === null || _gallery$industry === void 0 ? void 0 : _gallery$industry.name)))));
  }))));
};
var GalleryHeader = function (_ref) {
  var navigation = _ref.navigation,
    products = _ref.products,
    industry = _ref.industry,
    author = _ref.author,
    gallerySlug = _ref.gallerySlug,
    galleryName = _ref.galleryName,
    pagePath = _ref.pagePath,
    currentUrl = _ref.currentUrl,
    onGalleryChange = _ref.onGalleryChange,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement("header", {
    className: "header-gallery-article"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-article-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "previous-gallery"
  }, /*#__PURE__*/React.createElement(A, {
    href: pagePath("gallery/" + navigation.previous.slug),
    className: "gallery-tooltip-wrapper",
    onClick: function onClick(event) {
      return onGalleryChange && onGalleryChange(event, navigation.previous.slug);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-arrow-left"
  }), /*#__PURE__*/React.createElement("div", {
    className: "gallery-tooltip"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-uppercase"
  }, "Previous in", " " + industry.name), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h6", {
    className: "gallery-name"
  }, navigation.previous.name)))), /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-text"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "gallery-title"
  }, galleryName), /*#__PURE__*/React.createElement("p", {
    className: "gallery-meta"
  }, "by \xA0", /*#__PURE__*/React.createElement(A, {
    href: pagePath("gallery/profile/" + author.slug),
    className: "author"
  }, author.name), /*#__PURE__*/React.createElement(A, {
    href: pagePath("gallery/industry/" + industry.slug),
    className: "tag category"
  }, industry.name), products.map(function (product) {
    return /*#__PURE__*/React.createElement(A, {
      key: product.id,
      href: pagePath("gallery/product/" + product.slug),
      className: "tag"
    }, product.name);
  })))), /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-article-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-right-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "social-links"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://facebook.com/sharer/sharer.php?u=" + pagePath("gallery/" + gallerySlug),
    className: "icon-facebook",
    id: "news-share-fb",
    target: "_blank",
    rel: "noopener noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/intent/tweet?url=" + pagePath("gallery/" + gallerySlug),
    className: "x-icon white-logo",
    id: "news-share-tw",
    target: "_blank",
    rel: "noopener noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/shareArticle?mini=true&url=" + pagePath("gallery/" + gallerySlug),
    className: "icon-linkedin",
    id: "news-share-g",
    target: "_blank",
    rel: "noopener noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    href: "mailto:?subject=Studio&amp;body=" + pagePath("gallery/" + gallerySlug),
    className: "icon-mail",
    rel: "noopener noreferrer"
  })), /*#__PURE__*/React.createElement(A, {
    className: "icon-close lightbox-close",
    href: onClose ? currentUrl : pagePath("gallery"),
    onClick: function onClick(event) {
      return onClose && onClose(event);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "next-gallery"
  }, /*#__PURE__*/React.createElement(A, {
    href: pagePath("gallery/" + navigation.next.slug),
    className: "gallery-tooltip-wrapper",
    onClick: function onClick(event) {
      return onGalleryChange && onGalleryChange(event, navigation.next.slug);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-arrow-right"
  }), /*#__PURE__*/React.createElement("div", {
    className: "gallery-tooltip"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-uppercase"
  }, "Next in", " " + industry.name), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h6", {
    className: "gallery-name"
  }, navigation.next.name))))));
};
var OnVideoClick = function OnVideoClick(event, videoWrapper) {
  event.preventDefault();
  if (videoWrapper) {
    videoWrapper.classList.toggle("show-video");
  }
};
var GalleryVideo = function GalleryVideo(_ref) {
  var image = _ref.image;
  var _useState = useState(false),
    play = _useState[0],
    setPlay = _useState[1];
  var video = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: "embedded-video"
  }, /*#__PURE__*/React.createElement("div", {
    ref: video,
    className: "embedded-video-inner",
    onClick: function onClick(e) {
      setPlay(true);
      OnVideoClick(e, video.current);
    }
  }, /*#__PURE__*/React.createElement(A, {
    href: "#",
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    className: "full-image-anchor"
  }, /*#__PURE__*/React.createElement("span", {
    className: "play-btn icon-play"
  }), /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, /*#__PURE__*/React.createElement(Image, {
    src: image.urls.gallery_image,
    variant: "gallery_image",
    className: "content"
  }))), play && /*#__PURE__*/React.createElement("div", {
    className: "full-video full-image"
  }, /*#__PURE__*/React.createElement(EmbeddedVideo, {
    videoUrl: image.video_url,
    autoplay: play
  }))));
};
var _pagePath = function pagePath(hostUrl, locale, pageSlug) {
  return [hostUrl.replace(new RegExp("[/]$"), ""), locale === "en" ? "" : locale, pageSlug.replace(new RegExp("^[/]"), "")].filter(Boolean).join("/");
};
var GalleryContent = function GalleryContent(_ref) {
  var gallery = _ref.gallery,
    navigation = _ref.navigation,
    relatedGalleries = _ref.relatedGalleries,
    hostUrl = _ref.hostUrl,
    currentUrl = _ref.currentUrl,
    onGalleryChange = _ref.onGalleryChange,
    onClose = _ref.onClose;
  var locale = React.useContext(LocaleContext);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("article", {
    className: "gallery-details"
  }, /*#__PURE__*/React.createElement(GalleryHeader, {
    products: gallery.products,
    industry: gallery.industry,
    author: gallery.author,
    navigation: navigation,
    gallerySlug: gallery.slug,
    galleryName: gallery.name,
    pagePath: function pagePath(slug) {
      return _pagePath(hostUrl, locale, slug);
    },
    currentUrl: currentUrl,
    onGalleryChange: onGalleryChange,
    onClose: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("section", {
    className: "gallery-content"
  }, gallery.description && /*#__PURE__*/React.createElement("div", {
    className: "gallery-desc"
  }, /*#__PURE__*/React.createElement("p", null, gallery.description)), /*#__PURE__*/React.createElement("div", {
    className: "gallery-images " + (gallery.description ? "spacing-top" : "")
  }, gallery.gallery_images.map(function (image, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, image.video_url ? /*#__PURE__*/React.createElement(GalleryVideo, {
      image: image
    }) : /*#__PURE__*/React.createElement(Image, {
      src: image.urls.gallery_image,
      variant: "gallery_image"
    }));
  }))))), /*#__PURE__*/React.createElement(RelatedGalleries, {
    galleries: relatedGalleries,
    pagePath: function pagePath(slug) {
      return _pagePath(hostUrl, locale, slug);
    },
    onGalleryChange: onGalleryChange
  }));
};
var Gallery = function Gallery() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "gallery-details"
  }, /*#__PURE__*/React.createElement("header", {
    className: "header-gallery-article"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-article-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "previous-gallery"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gallery-tooltip-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-arrow-left"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-text"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.darkGray,
    style: {
      width: "160px",
      height: "18px",
      marginBottom: "0.5em"
    }
  }), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.darkGray,
    style: {
      width: "320px",
      height: "12px",
      marginBottom: "0.5em"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-article-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "header-gallery-right-bar"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.darkGray,
    style: {
      width: "240px",
      height: "36px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "next-gallery"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gallery-tooltip-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-arrow-right"
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gallery-content"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: "1000px"
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "related-galleries"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "section-title"
  }, "Related projects"))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "space-between"
    }
  }, [1, 2, 3, 4].map(function (num) {
    return /*#__PURE__*/React.createElement(RectShape, {
      key: num,
      color: colors.darkGray,
      style: {
        height: "180px"
      }
    });
  })))));
};
var GalleryPlaceholder$1 = function GalleryPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: Gallery,
    realComponent: realComponent
  });
};
var GalleryModal = function GalleryModal(_ref) {
  var slug = _ref.slug,
    currentUrl = _ref.currentUrl,
    _onClose = _ref.onClose,
    _onGalleryChange = _ref.onGalleryChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "gallery-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overlay",
    onClick: function onClick() {
      history.pushState(null, null, currentUrl);
      _onClose();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement(Query, {
    query: GALLERY$1,
    variables: {
      input: {
        slug: slug
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var screensGallery = data.screensGallery;
    return /*#__PURE__*/React.createElement(GalleryPlaceholder$1, {
      ready: loading,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(GalleryContent, {
          gallery: screensGallery.gallery,
          navigation: screensGallery.navigation,
          relatedGalleries: screensGallery.related_galleries,
          hostUrl: hostUrl(currentUrl),
          onGalleryChange: function onGalleryChange(event, slug) {
            event.preventDefault();
            updateHistory(currentUrl, slug);
            _onGalleryChange(slug);
          },
          currentUrl: currentUrl,
          onClose: function onClose(event) {
            event.preventDefault();
            history.pushState(null, null, currentUrl);
            _onClose();
          }
        });
      }
    });
  })));
};
var hostUrl$1 = function hostUrl(url) {
  var newUrl = new URL(url);
  return newUrl.origin;
};
var GalleryItem = function GalleryItem(_ref) {
  var imageSrc = _ref.imageSrc,
    imageVariant = _ref.imageVariant,
    gallery = _ref.gallery,
    onGalleryClick = _ref.onGalleryClick;
  return /*#__PURE__*/React.createElement(PageUrlConsumer, {
    key: gallery.id
  }, function (currentUrl) {
    var _gallery$author, _gallery$industry;
    return /*#__PURE__*/React.createElement(A, {
      href: hostUrl$1(currentUrl) + "/gallery/" + gallery.slug,
      className: "img-wrapper",
      onClick: function onClick(event) {
        event.preventDefault();
        onGalleryClick(gallery);
      }
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: imageSrc,
      variant: imageVariant
    }), /*#__PURE__*/React.createElement("div", {
      className: "opacity-overlay"
    }, /*#__PURE__*/React.createElement("div", {
      className: "thumb-text"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "thumb-title"
    }, gallery.name), /*#__PURE__*/React.createElement("p", {
      className: "meta"
    }, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, (_gallery$author = gallery.author) === null || _gallery$author === void 0 ? void 0 : _gallery$author.name), /*#__PURE__*/React.createElement("span", {
      className: "category"
    }, (_gallery$industry = gallery.industry) === null || _gallery$industry === void 0 ? void 0 : _gallery$industry.name)))));
  });
};
var GalleryVariantOne = function GalleryVariantOne(_ref) {
  var image_0 = _ref.image_0,
    image_1 = _ref.image_1,
    image_2 = _ref.image_2,
    image_3 = _ref.image_3,
    image_4 = _ref.image_4,
    image_5 = _ref.image_5,
    gallery_0 = _ref.gallery_0,
    gallery_1 = _ref.gallery_1,
    gallery_2 = _ref.gallery_2,
    gallery_3 = _ref.gallery_3,
    gallery_4 = _ref.gallery_4,
    gallery_5 = _ref.gallery_5,
    onGalleryClick = _ref.onGalleryClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "narrow-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_0,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_0,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_4,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_4,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "wide-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_1,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_1,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "inner-col two-images"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_2,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_2,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_3,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_3,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "full-width-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_5,
    imageVariant: "gallery_masonry_horizontal_wide",
    gallery: gallery_5,
    onGalleryClick: onGalleryClick
  }))));
};
var GalleryVariantTwo = function GalleryVariantTwo(_ref) {
  var image_0 = _ref.image_0,
    image_1 = _ref.image_1,
    image_2 = _ref.image_2,
    image_3 = _ref.image_3,
    image_4 = _ref.image_4,
    image_5 = _ref.image_5,
    gallery_0 = _ref.gallery_0,
    gallery_1 = _ref.gallery_1,
    gallery_2 = _ref.gallery_2,
    gallery_3 = _ref.gallery_3,
    gallery_4 = _ref.gallery_4,
    gallery_5 = _ref.gallery_5,
    onGalleryClick = _ref.onGalleryClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "wide-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-col two-images"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_0,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_0,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_3,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_3,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "inner-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_1,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_1,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "full-width-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_4,
    imageVariant: "gallery_masonry_horizontal_wide",
    gallery: gallery_4,
    onGalleryClick: onGalleryClick
  }))), /*#__PURE__*/React.createElement("div", {
    className: "narrow-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_2,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_2,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_5,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_5,
    onGalleryClick: onGalleryClick
  })));
};
var GalleryVariantThree = function GalleryVariantThree(_ref) {
  var image_0 = _ref.image_0,
    image_1 = _ref.image_1,
    image_2 = _ref.image_2,
    image_3 = _ref.image_3,
    image_4 = _ref.image_4,
    image_5 = _ref.image_5,
    gallery_0 = _ref.gallery_0,
    gallery_1 = _ref.gallery_1,
    gallery_2 = _ref.gallery_2,
    gallery_3 = _ref.gallery_3,
    gallery_4 = _ref.gallery_4,
    gallery_5 = _ref.gallery_5,
    onGalleryClick = _ref.onGalleryClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "narrow-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_0,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_0,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_4,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_4,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "wide-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-col two-images"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_1,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_1,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_3,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_3,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "inner-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_2,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_2,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "full-width-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_5,
    imageVariant: "gallery_masonry_horizontal_wide",
    gallery: gallery_5,
    onGalleryClick: onGalleryClick
  }))));
};
var GalleryVariantFour = function GalleryVariantFour(_ref) {
  var image_0 = _ref.image_0,
    image_1 = _ref.image_1,
    image_2 = _ref.image_2,
    image_3 = _ref.image_3,
    image_4 = _ref.image_4,
    image_5 = _ref.image_5,
    gallery_0 = _ref.gallery_0,
    gallery_1 = _ref.gallery_1,
    gallery_2 = _ref.gallery_2,
    gallery_3 = _ref.gallery_3,
    gallery_4 = _ref.gallery_4,
    gallery_5 = _ref.gallery_5,
    onGalleryClick = _ref.onGalleryClick;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "narrow-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_0,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_0,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_3,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_3,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "wide-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-col two-images"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_1,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_1,
    onGalleryClick: onGalleryClick
  }), /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_4,
    imageVariant: "gallery_masonry_horizontal",
    gallery: gallery_4,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "inner-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_2,
    imageVariant: "gallery_masonry_vertical",
    gallery: gallery_2,
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "full-width-col"
  }, /*#__PURE__*/React.createElement(GalleryItem, {
    imageSrc: image_5,
    imageVariant: "gallery_masonry_horizontal_wide",
    gallery: gallery_5,
    onGalleryClick: onGalleryClick
  }))));
};
var galleryType = {
  1: GalleryVariantOne,
  2: GalleryVariantTwo,
  3: GalleryVariantThree,
  4: GalleryVariantFour
};
var GalleryLayout = function GalleryLayout(_ref) {
  var variant = _ref.variant,
    image_0 = _ref.image_0,
    image_1 = _ref.image_1,
    image_2 = _ref.image_2,
    image_3 = _ref.image_3,
    image_4 = _ref.image_4,
    image_5 = _ref.image_5,
    gallery_0 = _ref.gallery_0,
    gallery_1 = _ref.gallery_1,
    gallery_2 = _ref.gallery_2,
    gallery_3 = _ref.gallery_3,
    gallery_4 = _ref.gallery_4,
    gallery_5 = _ref.gallery_5;
  var Component = galleryType[variant];
  var galleriesIds = [gallery_0, gallery_1, gallery_2, gallery_3, gallery_4, gallery_5];
  var currentSSRURL = React.useContext(PageUrlContext);
  var _useState = useState(false),
    modalOpen = _useState[0],
    setModalOpen = _useState[1];
  var _useState2 = useState(""),
    currentSlug = _useState2[0],
    setCurrentSlug = _useState2[1];
  var _useState3 = useState(currentSSRURL),
    currentUrl = _useState3[0],
    setCurrentUrl = _useState3[1];
  React.useEffect(function () {
    document.querySelector("body").classList.toggle("body-noscroll", modalOpen);
  }, [modalOpen]);
  return /*#__PURE__*/React.createElement(Query, {
    query: GALLERIES,
    variables: {
      input: {
        filters: {
          ids: galleriesIds
        }
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var galleries = data.galleries;
    return /*#__PURE__*/React.createElement(React.Fragment, null, modalOpen && /*#__PURE__*/React.createElement(GalleryModal, {
      slug: currentSlug,
      onClose: function onClose() {
        return setModalOpen(false);
      },
      onGalleryChange: function onGalleryChange(newSlug) {
        return setCurrentSlug(newSlug);
      },
      currentUrl: currentUrl
    }), /*#__PURE__*/React.createElement("div", {
      className: "gallery-masonry"
    }, /*#__PURE__*/React.createElement(GalleryPlaceholder, {
      ready: loading || !galleries,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(Component, {
          image_0: image_0,
          image_1: image_1,
          image_2: image_2,
          image_3: image_3,
          image_4: image_4,
          image_5: image_5,
          gallery_0: galleries.list.find(function (gallery) {
            return gallery.id === gallery_0;
          }),
          gallery_1: galleries.list.find(function (gallery) {
            return gallery.id === gallery_1;
          }),
          gallery_2: galleries.list.find(function (gallery) {
            return gallery.id === gallery_2;
          }),
          gallery_3: galleries.list.find(function (gallery) {
            return gallery.id === gallery_3;
          }),
          gallery_4: galleries.list.find(function (gallery) {
            return gallery.id === gallery_4;
          }),
          gallery_5: galleries.list.find(function (gallery) {
            return gallery.id === gallery_5;
          }),
          onGalleryClick: function onGalleryClick(gallery) {
            setCurrentSlug(gallery.slug);
            setCurrentUrl(window.location.href);
            history.pushState(null, null, galleryPath(currentUrl, gallery.slug));
            setModalOpen(true);
          }
        });
      }
    })));
  });
};
var Widget$t = function Widget(_ref) {
  var image_0 = _ref.image_0,
    image_1 = _ref.image_1,
    image_2 = _ref.image_2,
    image_3 = _ref.image_3,
    image_4 = _ref.image_4,
    image_5 = _ref.image_5,
    gallery_0 = _ref.gallery_0,
    gallery_1 = _ref.gallery_1,
    gallery_2 = _ref.gallery_2,
    gallery_3 = _ref.gallery_3,
    gallery_4 = _ref.gallery_4,
    gallery_5 = _ref.gallery_5,
    galleryVariant = _ref.galleryVariant,
    containerSettings = _ref.containerSettings;
  var isGalleriesSelected = gallery_0 && gallery_1 && gallery_2 && gallery_3 && gallery_4 && gallery_5;
  containerSettings.theme = "dark";
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, isGalleriesSelected ? /*#__PURE__*/React.createElement(GalleryLayout, {
    variant: galleryVariant,
    image_0: image_0,
    image_1: image_1,
    image_2: image_2,
    image_3: image_3,
    image_4: image_4,
    image_5: image_5,
    gallery_0: gallery_0,
    gallery_1: gallery_1,
    gallery_2: gallery_2,
    gallery_3: gallery_3,
    gallery_4: gallery_4,
    gallery_5: gallery_5
  }) : /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", null, "No galleries")));
};
var Config$t = {
  title: "Gallery Feed Masonry",
  category: "Image"
};
var Defaults$t = {
  image_0: imagePlaceholder("636x716"),
  image_1: imagePlaceholder("636x716"),
  image_2: imagePlaceholder("636x358"),
  image_3: imagePlaceholder("636x358"),
  image_4: imagePlaceholder("636x358"),
  image_5: imagePlaceholder("1276x359"),
  gallery_0: "",
  gallery_1: "",
  gallery_2: "",
  gallery_3: "",
  gallery_4: "",
  gallery_5: "",
  galleryVariant: 1,
  containerSettings: {
    spacing: "none"
  }
};
var Admin$t = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(AdminFileds, {
    onChange: onChange,
    settings: settings
  });
};
var GalleryWidget = {
  __proto__: null,
  Widget: Widget$t,
  Admin: Admin$t,
  Config: Config$t,
  Defaults: Defaults$t
};
var generateList = function generateList(num) {
  var list = [];
  for (var i = 0; i < num; i++) {
    list.push(i);
  }
  return [].concat(list);
};
var Thumbs$1 = function Thumbs(_ref) {
  var thumbsCount = _ref.thumbsCount;
  return /*#__PURE__*/React.createElement("div", {
    className: "gallery-strip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, generateList(thumbsCount).map(function (num) {
    return /*#__PURE__*/React.createElement("div", {
      key: num,
      className: "col-3"
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.darkGray,
      style: {
        height: "250px"
      }
    }));
  })));
};
var ThumbsPlaceholder = function ThumbsPlaceholder(_ref2) {
  var thumbsCount = _ref2.thumbsCount,
    realComponent = _ref2.realComponent,
    ready = _ref2.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: function placeholderComponent() {
      return /*#__PURE__*/React.createElement(Thumbs$1, {
        thumbsCount: thumbsCount
      });
    },
    realComponent: realComponent
  });
};
var GalleriesStrip = function GalleriesStrip(_ref) {
  var galleries = _ref.galleries;
  var currentSSRURL = React.useContext(PageUrlContext);
  var _useState = useState(false),
    modalOpen = _useState[0],
    setModalOpen = _useState[1];
  var _useState2 = useState(""),
    currentSlug = _useState2[0],
    setCurrentSlug = _useState2[1];
  var _useState3 = useState(currentSSRURL),
    currentUrl = _useState3[0],
    setCurrentUrl = _useState3[1];
  React.useEffect(function () {
    document.querySelector("body").classList.toggle("body-noscroll", modalOpen);
  }, [modalOpen]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, modalOpen && /*#__PURE__*/React.createElement(GalleryModal, {
    slug: currentSlug,
    onClose: function onClose() {
      return setModalOpen(false);
    },
    onGalleryChange: function onGalleryChange(newSlug) {
      return setCurrentSlug(newSlug);
    },
    currentUrl: currentUrl
  }), /*#__PURE__*/React.createElement("div", {
    className: "gallery-strip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, galleries.map(function (gallery) {
    var _gallery$author, _gallery$industry;
    return gallery.status === "published" && /*#__PURE__*/React.createElement("div", {
      key: gallery.id,
      className: "col-3"
    }, /*#__PURE__*/React.createElement(A, {
      href: galleryPath(currentUrl, gallery.slug),
      className: "gallery-thumb",
      key: gallery.id,
      onClick: function onClick(event) {
        event.preventDefault();
        setCurrentSlug(gallery.slug);
        setCurrentUrl(window.location.href);
        history.pushState(null, null, galleryPath(currentUrl, gallery.slug));
        setModalOpen(true);
      }
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: gallery.image,
      variant: "articles_2_columns"
    }), /*#__PURE__*/React.createElement("div", {
      className: "opacity-overlay"
    }, /*#__PURE__*/React.createElement("div", {
      className: "thumb-text"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "thumb-title"
    }, gallery.name), /*#__PURE__*/React.createElement("p", {
      className: "meta"
    }, /*#__PURE__*/React.createElement("span", {
      className: "name"
    }, (_gallery$author = gallery.author) === null || _gallery$author === void 0 ? void 0 : _gallery$author.name), /*#__PURE__*/React.createElement("span", {
      className: "category"
    }, (_gallery$industry = gallery.industry) === null || _gallery$industry === void 0 ? void 0 : _gallery$industry.name))))));
  }))));
};
var GalleryPreview = function GalleryPreview(_ref2) {
  var galleriesList = _ref2.galleries;
  return /*#__PURE__*/React.createElement(Query, {
    query: GALLERIES,
    variables: {
      input: {
        filters: {
          ids: galleriesList.map(function (item) {
            return item.galleryId;
          })
        }
      }
    }
  }, function (_ref3) {
    var error = _ref3.error,
      loading = _ref3.loading,
      data = _ref3.data;
    if (error) return "Error! " + error.message;
    var galleries = data.galleries;
    return /*#__PURE__*/React.createElement(ThumbsPlaceholder, {
      thumbsCount: galleriesList.length,
      ready: loading || !galleries,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(GalleriesStrip, {
          galleries: galleries.list
        });
      }
    });
  });
};
var GalleryStipPlaceholder = ThumbsPlaceholder;
var Widget$u = function Widget(_ref) {
  var list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, list.length > 0 ? /*#__PURE__*/React.createElement(GalleryPreview, {
    galleries: list
  }) : /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", null, "No galleries")));
};
var Config$u = {
  title: "Gallery Strip",
  category: "Feed"
};
var Defaults$u = {
  list: [],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var GalleryField = function GalleryField(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(value) {
      return onChangeItem("galleryId", value);
    },
    value: settings.galleryId
  });
};
var Admin$u = function Admin(items, onChange) {
  return /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(GalleryField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items,
    primaryField: "name",
    template: {
      galleryId: ""
    }
  });
};
var GalleryStripWidget = {
  __proto__: null,
  Widget: Widget$u,
  Admin: Admin$u,
  Config: Config$u,
  Defaults: Defaults$u
};
var Card$2 = function Card(_ref) {
  var link = _ref.link,
    icon = _ref.icon,
    iconActive = _ref.iconActive,
    title = _ref.title,
    description = _ref.description,
    active = _ref.active;
  return /*#__PURE__*/React.createElement(A, {
    href: link.link,
    className: "card-icon " + (active === "yes" ? "active" : "")
  }, icon && /*#__PURE__*/React.createElement(Img, {
    src: active === "yes" ? iconActive : icon,
    variant: "original",
    loading: "lazy",
    className: "icon"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, title), description && /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description));
};
var Widget$v = function Widget(_ref2) {
  var list = _ref2.list,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards-icons"
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Card$2, _extends({
      key: idx
    }, item));
  })));
};
var Config$v = {
  title: "Icon Cards",
  category: "Navigation"
};
var Defaults$v = {
  list: [{
    id: 1,
    link: LinkSettings.defaults,
    icon: imagePlaceholder("32x32"),
    iconActive: imagePlaceholder("32x32"),
    title: "Tab title",
    description: "Short description",
    active: "yes"
  }, {
    id: 2,
    link: LinkSettings.defaults,
    icon: imagePlaceholder("32x32"),
    iconActive: imagePlaceholder("32x32"),
    title: "Tab title",
    description: "Short description",
    active: "no"
  }, {
    id: 3,
    link: LinkSettings.defaults,
    icon: imagePlaceholder("32x32"),
    iconActive: imagePlaceholder("32x32"),
    title: "Tab title",
    description: "Short description",
    active: "no"
  }],
  iconSize: "regular",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ListItem$5 = function ListItem(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    value: settings.link
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    },
    value: settings.icon
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon (active)",
    onChange: function onChange(value) {
      return onChangeItem("iconActive", value);
    },
    value: settings.iconActive
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Active",
    options: [["no", "No"], ["yes", "Yes"]],
    value: settings.active,
    onChange: function (_onChange) {
      function onChange(_x) {
        return _onChange.apply(this, arguments);
      }
      onChange.toString = function () {
        return _onChange.toString();
      };
      return onChange;
    }(function (value) {
      return onChange("active", value);
    })
  }));
};
var Admin$v = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$5, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items,
    primaryField: "title",
    template: {
      link: LinkSettings.defaults,
      icon: imagePlaceholder("32x32"),
      iconActive: imagePlaceholder("32x32"),
      title: "Tab title",
      description: "Short description",
      active: "no"
    }
  }));
};
var IconCardsWidget = {
  __proto__: null,
  Widget: Widget$v,
  Admin: Admin$v,
  Config: Config$v,
  Defaults: Defaults$v
};
var WidgetImage = function WidgetImage(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-5"
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: image,
    variant: "mobile_square"
  }));
};
var WidgetText = function WidgetText(_ref2) {
  var text = _ref2.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-7"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-box",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
};
var ImageAndTextFullSize = function ImageAndTextFullSize(_ref3) {
  var variant = _ref3.variant,
    image = _ref3.image,
    text = _ref3.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "image-and-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, variant === "image_on_left" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WidgetImage, {
    image: image
  }), /*#__PURE__*/React.createElement(WidgetText, {
    text: text
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WidgetText, {
    text: text
  }), /*#__PURE__*/React.createElement(WidgetImage, {
    image: image
  })))));
};
var ImageAndTextShifted = function ImageAndTextShifted(_ref4) {
  var variant = _ref4.variant,
    image = _ref4.image,
    text = _ref4.text;
  return /*#__PURE__*/React.createElement("div", {
    className: "image-and-text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-and-text-wrapper-small"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, variant === "image_on_left" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WidgetImage, {
    image: image
  }), /*#__PURE__*/React.createElement(WidgetText, {
    text: text
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(WidgetText, {
    text: text
  }), /*#__PURE__*/React.createElement(WidgetImage, {
    image: image
  }))))));
};
var Widget$w = function Widget(_ref5) {
  var variant = _ref5.variant,
    size = _ref5.size,
    image = _ref5.image,
    text = _ref5.text,
    containerSettings = _ref5.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, size === "full_width" ? /*#__PURE__*/React.createElement(ImageAndTextFullSize, {
    variant: variant,
    image: image,
    text: text
  }) : /*#__PURE__*/React.createElement(ImageAndTextShifted, {
    variant: variant,
    image: image,
    text: text
  }));
};
var Config$w = {
  title: "Image and Text",
  category: "Image + Text"
};
var Defaults$w = {
  variant: "image_on_left",
  size: "full_width",
  image: imagePlaceholder("200x200"),
  text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$w = {
  variant: {
    type: "select",
    options: [["image_on_left", "Image on left"], ["image_on_right", "Image on right"]]
  },
  size: {
    type: "select",
    options: [["full_width", "Full Width"], ["small", "Small"]]
  },
  image: {
    type: "custom",
    component: ImagePicker
  },
  text: {
    type: "custom",
    component: RTE
  }
};
var ImageAndTextWidget = {
  __proto__: null,
  Widget: Widget$w,
  Admin: Admin$w,
  Config: Config$w,
  Defaults: Defaults$w
};
var Title$3 = function Title(_ref) {
  var title = _ref.title,
    titleSize = _ref.titleSize;
  switch (titleSize) {
    case "default":
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title"
      }, title);
    case "large":
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title large-title"
      }, title);
    case "medium":
      return /*#__PURE__*/React.createElement("h2", {
        className: "full-image-title medium-title"
      }, title);
    case "small":
      return /*#__PURE__*/React.createElement("h3", {
        className: "full-image-title small-title"
      }, title);
    default:
      return /*#__PURE__*/React.createElement("h1", {
        className: "full-image-title"
      }, title);
  }
};
var swiperParams = function swiperParams(autoRotate) {
  return {
    rebuildOnUpdate: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    paginationClickable: true,
    navigation: {
      nextEl: ".swiper-button-next.icon-arrow-right",
      prevEl: ".swiper-button-prev.icon-arrow-left"
    },
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    autoplay: autoRotate === "off" ? false : {
      delay: parseInt(autoRotate, 10)
    },
    speed: 500
  };
};
var BouncingButton$1 = function BouncingButton(_ref2) {
  var url = _ref2.url;
  return /*#__PURE__*/React.createElement("a", {
    href: url,
    className: "bouncing-button-link"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bouncing-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "outer-ring"
  }), /*#__PURE__*/React.createElement("div", {
    className: "outer-ring-2"
  })));
};
var Widget$x = function Widget(_ref3) {
  var autoRotate = _ref3.autoRotate,
    list = _ref3.list,
    containerSettings = _ref3.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "lead-image-slider swiper-container simple-image-slider slider",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(Slider, swiperParams(autoRotate), list.map(function (slide, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide full-image-section height-" + slide.height
    }, slide.overlay > 0 ? /*#__PURE__*/React.createElement("div", {
      className: "cnt-overlay",
      style: {
        background: "rgba(0, 0, 0, " + slide.overlay + ")"
      }
    }) : "", /*#__PURE__*/React.createElement("div", {
      className: "full-image " + slide.height
    }, /*#__PURE__*/React.createElement(Image, {
      src: slide.image,
      variant: imageSize(slide.height)
    }), /*#__PURE__*/React.createElement(Image, {
      src: slide.image,
      variant: "mobile_square"
    })), /*#__PURE__*/React.createElement("div", {
      className: "full-image-title-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "full-image-title-inner"
    }, /*#__PURE__*/React.createElement("div", {
      className: "headings"
    }, slide.logo !== undefined && slide.logo_position === "above" && /*#__PURE__*/React.createElement(Image, {
      src: slide.logo,
      variant: "mobile_square",
      className: "inline-img"
    }), slide.title && /*#__PURE__*/React.createElement(Title$3, {
      title: slide.title,
      titleSize: slide.title_size
    }), slide.sub_title !== "" ? /*#__PURE__*/React.createElement("h5", {
      className: "full-image-sub-title"
    }, slide.sub_title) : null, slide.logo !== undefined && slide.logo_position === "below" && /*#__PURE__*/React.createElement("div", {
      className: "logo-wrapper"
    }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Image, {
      src: slide.logo,
      variant: "mobile_square",
      className: "inline-img"
    }), /*#__PURE__*/React.createElement("br", null)), slide.button && slide.button.label && slide.button.link && /*#__PURE__*/React.createElement(Button$1, {
      settings: slide.button
    }), slide.button_2 && slide.button_2.label && slide.button_2.link && /*#__PURE__*/React.createElement(Button$1, {
      settings: slide.button_2
    })))), (slide.height === "original" || slide.height === "full") && slide.bouncing_arrow_anchor && /*#__PURE__*/React.createElement(BouncingButton$1, {
      url: slide.bouncing_arrow_anchor
    })), slide.animated_arrow === "yes" ? /*#__PURE__*/React.createElement("div", {
      className: "arrow-hint"
    }) : null);
  })));
};
var Config$x = {
  title: "Lead Image Slider",
  category: "Sliders"
};
var Defaults$x = {
  autoRotate: "off",
  list: [{
    image: imagePlaceholder("1920x600"),
    logo: imagePlaceholder("40x40"),
    logo_position: "above",
    overlay: 0,
    animated_arrow: "no",
    height: "crop",
    title: "Title",
    title_size: "default",
    sub_title: "Sub Title",
    button: ButtonSettingsWithDescription.defaults,
    button_2: _extends({}, ButtonSettingsWithDescription.defaults, {
      link: ""
    }),
    bouncing_arrow_anchor: "#"
  }, {
    image: imagePlaceholder("1920x600"),
    logo: imagePlaceholder("40x40"),
    logo_position: "above",
    overlay: 0,
    animated_arrow: "no",
    height: "crop",
    title: "Title",
    title_size: "default",
    sub_title: "Sub Title",
    button: ButtonSettingsWithDescription.defaults,
    button_2: _extends({}, ButtonSettingsWithDescription.defaults, {
      link: ""
    }),
    bouncing_arrow_anchor: "#"
  }, {
    image: imagePlaceholder("1920x600"),
    logo: imagePlaceholder("40x40"),
    logo_position: "above",
    overlay: 0,
    animated_arrow: "no",
    height: "crop",
    title: "Title",
    title_size: "default",
    sub_title: "Sub Title",
    button: ButtonSettingsWithDescription.defaults,
    button_2: _extends({}, ButtonSettingsWithDescription.defaults, {
      link: ""
    }),
    bouncing_arrow_anchor: "#"
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var SlideField = function SlideField(_ref4) {
  var settings = _ref4.settings,
    onChangeItem = _ref4.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    },
    value: settings.logo
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Logo position",
    options: [["above", "Above"], ["below", "Below"]],
    value: settings.logo_position,
    onChange: function onChange(value) {
      return onChangeItem("logo_position", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Overlay",
    options: [[0, "No Overlay"], [0.1, "10%"], [0.2, "20%"], [0.3, "30%"], [0.4, "40%"], [0.5, "50%"], [0.6, "60%"], [0.7, "70%"], [0.8, "80%"]],
    value: settings.overlay,
    onChange: function onChange(value) {
      return onChangeItem("overlay", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show animated arrow (mobile)",
    options: [["no", "No"], ["yes", "Yes"]],
    value: settings.animated_arrow,
    onChange: function onChange(value) {
      return onChangeItem("animated_arrow", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Image Height",
    options: [["crop", "Cropped"], ["full", "Full screen"], ["original", "Keep original height"]],
    value: settings.height,
    onChange: function onChange(value) {
      return onChangeItem("height", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Title size",
    options: [["large", "Larger"], ["default", "Default"], ["medium", "Medium"], ["small", "Small"]],
    value: settings.title_size,
    onChange: function onChange(value) {
      return onChangeItem("title_size", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Sub Title",
    value: settings.sub_title,
    onChange: function onChange(value) {
      return onChangeItem("sub_title", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettingsWithDescription, {
    label: "Button 1",
    value: settings.button || {},
    onChange: function onChange(values) {
      return onChangeItem("button", values);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettingsWithDescription, {
    label: "Button 2",
    value: settings.button_2 || {},
    onChange: function onChange(values) {
      return onChangeItem("button_2", values);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Bouncing button link",
    value: settings.bouncing_arrow_anchor,
    onChange: function onChange(value) {
      return onChangeItem("bouncing_arrow_anchor", value);
    },
    hint: "The button is visible when this field is filled in and the 'height' setting is set to 'Keep original height'"
  }));
};
SlideField.defaultProps = {
  settings: {}
};
var Admin$x = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Autoplay",
    options: [["off", "Off"], ["3000", "3s"], ["4000", "4s"], ["5000", "5s"]],
    value: settings.autoRotate,
    onChange: function onChange(value) {
      return _onChange("autoRotate", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    label: "Slides",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(SlideField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      id: 1,
      image: imagePlaceholder("1920x600"),
      overlay: 0,
      animated_arrow: "no",
      height: "crop",
      title: "Title",
      title_size: "default",
      sub_title: "Sub Title",
      button: ButtonSettingsWithDescription.defaults,
      button_2: _extends({}, ButtonSettingsWithDescription.defaults, {
        link: ""
      }),
      bouncing_arrow_anchor: "#"
    },
    primaryField: "title"
  }));
};
var LeadImageSliderWidget = {
  __proto__: null,
  Widget: Widget$x,
  Admin: Admin$x,
  Config: Config$x,
  Defaults: Defaults$x
};
var Widget$y = function Widget(_ref) {
  var geoIp = _ref.geoIp,
    image = _ref.image,
    message = _ref.message,
    button_settings = _ref.button_settings,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: geoIp && geoIp.activeCountries || [],
    countryGroupIds: geoIp && geoIp.activeGroups || [],
    active: geoIp && geoIp.active || false
  }, /*#__PURE__*/React.createElement(Container$1, {
    className: "notification-bar",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "notification-bar-inner"
  }, image !== "" ? /*#__PURE__*/React.createElement("span", {
    className: "notification-icon"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: "mobile_square"
  })) : "", /*#__PURE__*/React.createElement("p", {
    className: "notification-message"
  }, message), /*#__PURE__*/React.createElement(Button$1, {
    settings: button_settings,
    className: "btn-small"
  }))));
};
var Config$y = {
  title: "CTA Bar",
  category: "CTA"
};
var Defaults$y = {
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  image: imagePlaceholder("200x200"),
  message: "Lorem ipsum dolor sit amet, consectetur adipisicing elit!",
  button_settings: ButtonSettingsWithDescription.defaults,
  containerSettings: {
    theme: "dark",
    spacing: "none"
  }
};
var Admin$y = {
  geoIp: {
    type: "custom",
    component: GeoIpPicker
  },
  image: {
    type: "custom",
    component: ImagePicker
  },
  message: {
    type: "textarea"
  },
  button_settings: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button"
  }
};
var NotificationBarWidget = {
  __proto__: null,
  Widget: Widget$y,
  Admin: Admin$y,
  Config: Config$y,
  Defaults: Defaults$y
};
var comparator = function comparator(a, b) {
  return a.name.localeCompare(b.name);
};
var Filter = function (_ref) {
  var countries = _ref.countries,
    onCountrySelect = _ref.onCountrySelect;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "style-select country-dropdown"
  }, /*#__PURE__*/React.createElement("select", {
    onChange: function onChange(e) {
      return onCountrySelect(e.target.value);
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Select country"), countries.sort(comparator).map(function (item, idx) {
    return /*#__PURE__*/React.createElement("option", {
      key: idx,
      value: item.code
    }, item.name);
  })))));
};
var removeDuplicates = function removeDuplicates(myArr, prop) {
  return myArr.filter(function (obj, pos, arr) {
    return arr.map(function (mapObj) {
      return mapObj[prop];
    }).indexOf(obj[prop]) === pos;
  });
};
var filterMentors = function filterMentors(list, country) {
  if (!country) {
    return [].concat(list);
  }
  return list.filter(function (item) {
    return country === item.country.code;
  });
};
var Mentors = function (_ref) {
  var mentorsList = _ref.mentorsList,
    overlayText = _ref.overlayText;
  var _useState = useState(false),
    isModalOpen = _useState[0],
    setModalVisibility = _useState[1];
  var _useState2 = useState(mentorsList[0]),
    currentMentor = _useState2[0],
    setCurrentMentor = _useState2[1];
  var _useState3 = useState(mentorsList),
    mentors = _useState3[0],
    setMentors = _useState3[1];
  var countries = removeDuplicates(mentorsList.map(function (item) {
    return item.country;
  }), "name");
  var handleOpenModal = function handleOpenModal(mentor) {
    setModalVisibility(true);
    setCurrentMentor(mentor);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "square-thumbs"
  }, /*#__PURE__*/React.createElement(Filter, {
    countries: countries,
    onCountrySelect: function onCountrySelect(country) {
      return setMentors(filterMentors(mentorsList, country));
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, mentors.map(function (mentor) {
    return /*#__PURE__*/React.createElement("div", {
      key: mentor.id,
      className: "previews-6"
    }, /*#__PURE__*/React.createElement("button", {
      className: "image-wrapper",
      type: "button",
      onClick: function onClick() {
        return handleOpenModal(mentor);
      }
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: mentor.image,
      variant: "mobile_square"
    }), /*#__PURE__*/React.createElement("div", {
      className: "overlay"
    }, overlayText || "View"), /*#__PURE__*/React.createElement("i", {
      className: "icon-zoom"
    })), /*#__PURE__*/React.createElement("div", {
      className: "square-thumb-text"
    }, /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, mentor.name)), /*#__PURE__*/React.createElement("div", {
      className: "description"
    }, /*#__PURE__*/React.createElement("p", null, mentor.country.name))));
  }), currentMentor && /*#__PURE__*/React.createElement(Modal, {
    title: "",
    open: isModalOpen,
    onClose: function onClose() {
      return setModalVisibility(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "square-thumb-modal"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: currentMentor.image,
    variant: "mobile_square"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "name"
  }, currentMentor.name), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: currentMentor.description
    }
  }))))));
};
var MentorsList = function MentorsList() {
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      margin: "0 auto 4em",
      width: 300,
      height: 56
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      flexWrap: "wrap"
    }
  }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      style: {
        marginBottom: "2em"
      }
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: 210,
        height: 210
      }
    }), /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        margin: "1em auto 0",
        width: "80%",
        height: 20
      }
    }), /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        margin: "1em auto 0",
        width: "60%",
        height: 20
      }
    }));
  })));
};
var MentorsPlaceholder = function MentorsPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: MentorsList,
    realComponent: realComponent
  });
};
var MentorsQuery = function MentorsQuery(_ref) {
  var overlayText = _ref.overlayText;
  return /*#__PURE__*/React.createElement(Query, {
    query: MENTORS
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var mentors = data.mentors;
    return /*#__PURE__*/React.createElement(MentorsPlaceholder, {
      ready: loading,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(Mentors, {
          overlayText: overlayText,
          mentorsList: mentors.list
        });
      }
    });
  });
};
var Widget$z = function Widget(_ref) {
  var overlay_text = _ref.overlay_text,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(MentorsQuery, {
    overlayText: overlay_text
  }));
};
var Defaults$z = {
  overlay_text: "View",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Config$z = {
  title: "Mentors",
  category: "Image + Text"
};
var Admin$z = {
  overlay_text: {
    type: "text"
  }
};
var MentorsWidget = {
  __proto__: null,
  Widget: Widget$z,
  Admin: Admin$z,
  Config: Config$z,
  Defaults: Defaults$z
};
var SelectedItem = function SelectedItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement("div", {
    className: "selected-items-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("h6", null, "Selected tab: ", /*#__PURE__*/React.createElement("strong", null, item.name)))));
};
var AutocompleteList = function AutocompleteList(_ref) {
  var results = _ref.results,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("ul", {
    className: "autocomplete-list"
  }, results.map(function (result) {
    return /*#__PURE__*/React.createElement("li", {
      key: result.id,
      onClick: function onClick() {
        return _onClick(result.id);
      },
      className: "autocomplete-list-item"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, result.name)));
  }));
};
var searchTabs = function searchTabs(tabs, f, setResult, setAutocompleteVisibility) {
  var filteredTabs = tabs.filter(function (tab) {
    return tab.name.toLowerCase().includes(f);
  });
  if (filteredTabs.length > 0) {
    setResult(filteredTabs);
    setAutocompleteVisibility(true);
  }
};
var PricingTabPicker = function (_ref) {
  var value = _ref.value,
    label = _ref.label,
    tabsQuery = _ref.tabsQuery,
    tabsKey = _ref.tabsKey,
    onChange = _ref.onChange;
  var _useState = useState([]),
    result = _useState[0],
    setResult = _useState[1];
  var _useState2 = useState(""),
    f = _useState2[0],
    setF = _useState2[1];
  var _useState3 = useState(value),
    selectedItemId = _useState3[0],
    setSelectedItemId = _useState3[1];
  var _useState4 = useState(false),
    showAutocomplete = _useState4[0],
    setAutocompleteVisibility = _useState4[1];
  return /*#__PURE__*/React.createElement(Query, {
    query: tabsQuery
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var tabs = data[tabsKey];
    var tabsList = tabs.list.map(function (e) {
      return {
        id: e.id,
        name: e.name
      };
    });
    var selectedItem = tabsList.find(function (tab) {
      return parseInt(tab.id) === parseInt(selectedItemId);
    });
    return /*#__PURE__*/React.createElement("div", {
      className: "new-cms-autocomplete-picker"
    }, /*#__PURE__*/React.createElement("div", {
      className: "autocomplete-wrapper"
    }, /*#__PURE__*/React.createElement(TextInput, {
      label: label,
      value: f,
      onChange: function onChange(value) {
        setF(value);
        f.length > 3 ? searchTabs(tabsList, value, function (result) {
          return setResult(result);
        }, function (showAutocomplete) {
          return setAutocompleteVisibility(showAutocomplete);
        }) : setResult([]);
        setF(value);
      }
    }), showAutocomplete && /*#__PURE__*/React.createElement(AutocompleteList, {
      results: result,
      onClick: function onClick(tab) {
        setSelectedItemId(tab);
        setAutocompleteVisibility(false);
        onChange(tab);
      }
    })), selectedItem && /*#__PURE__*/React.createElement(SelectedItem, {
      item: selectedItem
    }));
  });
};
var onHorizontalScroll$1 = function onHorizontalScroll(node, setVisible) {
  if (node.scrollWidth > node.parentElement.offsetWidth) {
    setVisible(true);
  } else {
    setVisible(false);
  }
};
var TabContent = function TabContent(_ref) {
  var tab = _ref.tab,
    currency = _ref.currency;
  var _useState = useState(false),
    isIconVisible = _useState[0],
    setIconVisible = _useState[1];
  var pricing = useRef(null);
  useLayoutEffect(function () {
    var node = pricing.current;
    onHorizontalScroll$1(node, function (isVisible) {
      return setIconVisible(isVisible);
    });
    window.addEventListener("resize", function () {
      return onHorizontalScroll$1(node, function (isVisible) {
        return setIconVisible(isVisible);
      });
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "package-pricing-wrapper " + (isIconVisible ? "horizontal-scroll" : "")
  }, /*#__PURE__*/React.createElement("div", {
    ref: pricing,
    className: "package-pricing"
  }, tab.tabCards && tab.tabCards.map(function (tabCard) {
    return /*#__PURE__*/React.createElement(Card$1, {
      key: tabCard.id,
      currency: currency,
      card: tabCard.card,
      ribbonText: tabCard.ribbonText,
      inlineTheme: tab.inlineTheme
    });
  })), isIconVisible && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("i", {
    className: "arrow icon-arrow-left"
  }), /*#__PURE__*/React.createElement("i", {
    className: "arrow icon-arrow-right"
  }))));
};
var getActiveTabIdx = function getActiveTabIdx(tabs) {
  var hash = window && window.location.hash && window.location.hash.substring(1);
  if (!hash) {
    return 0;
  }
  var idx = tabs.findIndex(function (tab) {
    return tab.htmlId === hash;
  });
  return idx === -1 ? 0 : idx;
};
var VatDisclaimer$1 = function VatDisclaimer(_ref) {
  var tabs = _ref.tabs;
  var message = tabs[0] && tabs[0].tabCards && tabs[0].tabCards[0] && tabs[0].tabCards[0].card && tabs[0].tabCards[0].card.vatDisclaimer || "";
  if (!message) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, message)));
};
var PackagePricing = function PackagePricing(_ref2) {
  var tabs = _ref2.tabs,
    availableCurrencies = _ref2.availableCurrencies,
    isAdmin = _ref2.isAdmin,
    initialCurrency = _ref2.currency;
  var _React$useState = React.useState(initialCurrency),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  useLocalizationCurrency(initialCurrency, setCurrency);
  return /*#__PURE__*/React.createElement("div", null, isAdmin && /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("select", {
    value: currency,
    onChange: function onChange(e) {
      return setCurrency(e.target.value);
    }
  }, availableCurrencies.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      key: c,
      value: c
    }, c.toUpperCase());
  }))), /*#__PURE__*/React.createElement(Tabs$1, {
    forceRenderTabPanel: true,
    defaultIndex: getActiveTabIdx(tabs)
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom"
  }, /*#__PURE__*/React.createElement(TabList, null, tabs.map(function (tab, idx) {
    return /*#__PURE__*/React.createElement(Tab$5, {
      key: idx
    }, tab.tabTitle);
  }))), tabs.map(function (tab, idx) {
    return /*#__PURE__*/React.createElement(TabPanel, {
      key: idx
    }, /*#__PURE__*/React.createElement(TabContent, {
      tab: tab,
      currency: currency
    }));
  })), /*#__PURE__*/React.createElement(VatDisclaimer$1, {
    tabs: tabs
  }));
};
var tabsFactory = function tabsFactory(tabs, adminTabs) {
  var newTabs = adminTabs.map(function (adminTab) {
    var tab = tabs.find(function (tab) {
      return tab.id === adminTab.tab;
    });
    if (!tab) {
      return false;
    }
    var newTab = Object.assign({}, tab);
    newTab.tabTitle = adminTab.tabTitle;
    newTab.inlineTheme = adminTab.inlineTheme;
    newTab.htmlId = adminTab.htmlId;
    return newTab;
  }).filter(function (tab) {
    return tab !== false;
  });
  return newTabs;
};
var PackagePricingWrapper = function PackagePricingWrapper(_ref) {
  var currency = _ref.currency,
    adminTabsList = _ref.adminTabsList,
    tabsList = _ref.tabsList;
  return /*#__PURE__*/React.createElement(GeoIpContext.Consumer, null, function (value) {
    var country = value.country,
      allGroups = value.allGroups;
    var tabs = tabsFactory(tabsList, adminTabsList);
    return /*#__PURE__*/React.createElement(AdminUserContext.Consumer, null, function (value) {
      var isAdmin = value ? true : false;
      return /*#__PURE__*/React.createElement(PackagePricing, {
        tabs: tabs,
        currency: currency,
        currentCountry: country,
        allCountryGroups: allGroups,
        availableCurrencies: Currency.all,
        isAdmin: isAdmin
      });
    });
  });
};
var PlacehodlerComponent$1 = function PlacehodlerComponent(_ref) {
  var showMessage = _ref.showMessage;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      position: "relative"
    }
  }, showMessage && /*#__PURE__*/React.createElement(PricingErrorMessage, null), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "4em"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 190,
      height: 70
    }
  }), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 190,
      height: 70
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      width: 900,
      margin: "0 auto",
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      margin: 0,
      padding: "2em",
      display: "block",
      width: "20%",
      height: 280,
      borderRight: "1px solid " + colors.darkGrey
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 3,
    color: colors.lightBlue
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 50
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 100,
      height: "1em"
    }
  })))));
};
var PackagePricingPlaceholder = function PackagePricingPlaceholder(_ref2) {
  var realComponent = _ref2.realComponent,
    ready = _ref2.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: PlacehodlerComponent$1,
    realComponent: realComponent
  });
};
var _excluded$3 = ["geoIp"];
var isZuoraDataInvalid$1 = function isZuoraDataInvalid(data) {
  var valid = data.every(function (tab) {
    return tab.tabCards.every(function (tabCard) {
      var item = tabCard.card;
      if (!item.ratePlanDetails) {
        return true;
      }
      if (item.ratePlanDetails.id) {
        return !!item.ratePlanDetails.name;
      } else {
        return true;
      }
    });
  });
  if (!valid) {
    console.error({
      data: data
    });
  }
  return !valid;
};
var Content$1 = function Content(_ref) {
  var list = _ref.list,
    promoCode = _ref.promoCode,
    containerSettings = _ref.containerSettings;
  var _React$useState = React.useState(null),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  var pickedPromoCode = extractPromoCode(React.useContext(PageUrlContext), promoCode);
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrency);
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, list.map(function (tab) {
    if (tab.htmlId) {
      return /*#__PURE__*/React.createElement("div", {
        key: tab.id,
        id: tab.htmlId
      });
    }
    return null;
  }), /*#__PURE__*/React.createElement(Query, {
    query: PACKAGE_PRICING_TABS,
    variables: {
      input: {
        filters: {
          ids: list.map(function (item) {
            return item.tab;
          })
        },
        promoCode: pickedPromoCode
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var packagePricingTabs = data.packagePricingTabs;
    return list.length > 0 ? /*#__PURE__*/React.createElement(PackagePricingPlaceholder, {
      ready: loading || !currency,
      realComponent: function realComponent() {
        if (isZuoraDataInvalid$1(packagePricingTabs.list)) {
          return /*#__PURE__*/React.createElement(PlacehodlerComponent$1, {
            showMessage: true
          });
        }
        return /*#__PURE__*/React.createElement(PackagePricingWrapper, {
          currency: currency,
          adminTabsList: list,
          tabsList: packagePricingTabs.list
        });
      }
    }) : /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("h2", null, "Package Pricing Tabs"));
  }));
};
var Widget$A = function Widget(_ref3) {
  var geoIp = _ref3.geoIp,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded$3);
  return /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: geoIp.activeCountries,
    countryGroupIds: geoIp.activeGroups,
    active: geoIp.active
  }, /*#__PURE__*/React.createElement(Content$1, rest));
};
var Config$A = {
  title: "Package Pricing",
  category: "Pricing"
};
var Defaults$A = {
  promoCode: "",
  list: [],
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var TabField = function TabField(_ref4) {
  var settings = _ref4.settings,
    onChangeItem = _ref4.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Tab Title",
    onChange: function onChange(value) {
      return onChangeItem("tabTitle", value);
    },
    value: settings.tabTitle
  }), /*#__PURE__*/React.createElement(ColorPicker, {
    value: settings.inlineTheme,
    onChange: function onChange(value) {
      return onChangeItem("inlineTheme", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: settings.htmlId,
    onChange: function onChange(value) {
      return onChangeItem("htmlId", value);
    }
  }), /*#__PURE__*/React.createElement(PricingTabPicker, {
    label: "Tab Picker",
    tabsQuery: MINI_PACKAGE_PRICING_TABS,
    tabsKey: "miniPackagePricingTabs",
    onChange: function onChange(value) {
      return onChangeItem("tab", value);
    },
    value: settings.tab
  }));
};
var Admin$A = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Promo code",
    value: settings.promoCode,
    onChange: function onChange(value) {
      return _onChange("promoCode", value);
    }
  }), /*#__PURE__*/React.createElement(GeoIpPicker, {
    onChange: function onChange(value) {
      return _onChange("geoIp", value);
    },
    value: settings.geoIp
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(TabField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      tabTitle: "",
      tab: "",
      inlineTheme: "blue"
    },
    primaryField: "tabTitle"
  }));
};
var PackagePricingWidget = {
  __proto__: null,
  Widget: Widget$A,
  Admin: Admin$A,
  Config: Config$A,
  Defaults: Defaults$A
};
var CollectionsPicker = /*#__PURE__*/function (_React$Component) {
  function CollectionsPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      pageCollectionId: _this.props.value
    };
    return _this;
  }
  _inheritsLoose(CollectionsPicker, _React$Component);
  var _proto = CollectionsPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    var newValue = value;
    this.props.onChange(newValue);
    this.setState({
      pageCollectionId: newValue
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var pageCollectionId = this.state.pageCollectionId;
    return /*#__PURE__*/React.createElement(Query, {
      query: PAGE_COLLECTIONS
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var pageCollections = data.pageCollections;
      var options = pageCollections.list.map(function (e) {
        return [e.id, e.name];
      });
      return /*#__PURE__*/React.createElement(SelectMenu, {
        label: "collections",
        options: options,
        value: pageCollectionId,
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        }
      });
    });
  };
  return CollectionsPicker;
}(React.Component);
var CollectionSlider = function CollectionSlider(_ref) {
  var collection = _ref.collection,
    autoRotate = _ref.autoRotate;
  return /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    paginationClickable: true,
    navigation: {
      nextEl: ".swiper-button-next.icon-arrow-right",
      prevEl: ".swiper-button-prev.icon-arrow-left"
    },
    spaceBetween: 30,
    autoplay: autoRotate === "off" ? false : {
      delay: autoRotate
    },
    speed: 500,
    breakpoints: {
      599: {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 30
      },
      600: {
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 30
      }
    }
  }, collection.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slide-inner"
    }, item.image && (item.page_url !== "" ? /*#__PURE__*/React.createElement(A, {
      href: item.page_url,
      target: item.target
    }, /*#__PURE__*/React.createElement(Img, {
      src: item.image,
      variant: "articles_2_columns"
    })) : /*#__PURE__*/React.createElement(Img, {
      src: item.image,
      variant: "articles_2_columns"
    })), /*#__PURE__*/React.createElement("h6", {
      className: "title"
    }, item.page_url !== "" ? /*#__PURE__*/React.createElement(A, {
      href: item.page_url,
      target: item.target
    }, item.title) : item.title), /*#__PURE__*/React.createElement("p", null, item.description)));
  }));
};
var CollectionList = function CollectionList() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      marginBottom: "2em"
    }
  }, [0, 1, 2, 3, 4].map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      style: {
        width: "calc(20% - 2em)",
        marginRight: item <= idx ? "2em" : 0
      }
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: "100%",
        height: 180,
        marginBottom: "2em"
      }
    }), /*#__PURE__*/React.createElement(TextBlock, {
      rows: 2,
      color: colors.lightBlue
    }));
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "40px",
      height: 2,
      marginRight: "10px"
    }
  }), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "40px",
      height: 2
    }
  })));
};
var PageCollectionPlaceholder = function PageCollectionPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: CollectionList,
    realComponent: realComponent
  });
};
var CollectionPreview = function CollectionPreview(_ref) {
  var pageCollectionId = _ref.pageCollectionId,
    autoRotate = _ref.autoRotate;
  return /*#__PURE__*/React.createElement(Query, {
    query: PAGE_COLLECTION,
    variables: {
      input: {
        id: pageCollectionId
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var pageCollection = data.pageCollection;
    return /*#__PURE__*/React.createElement(PageCollectionPlaceholder, {
      ready: loading || !pageCollection,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(CollectionSlider, {
          collection: pageCollection.items,
          autoRotate: autoRotate
        });
      }
    });
  });
};
var Widget$B = function Widget(_ref) {
  var autoRotate = _ref.autoRotate,
    pageCollectionId = _ref.pageCollectionId,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "articles-slider"
  }, pageCollectionId ? /*#__PURE__*/React.createElement(CollectionPreview, {
    pageCollectionId: pageCollectionId,
    autoRotate: autoRotate
  }) : /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", null, "Page Collections"))));
};
var Config$B = {
  title: "Page Collection",
  category: "Feed"
};
var Defaults$B = {
  autoRotate: "off",
  pageCollectionId: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$B = {
  pageCollectionId: {
    type: "custom",
    component: CollectionsPicker
  },
  autoRotate: {
    type: "select",
    options: [["off", "Off"], ["3000", "3s"], ["4000", "4s"], ["5000", "5s"]]
  }
};
var PageCollectionWidget = {
  __proto__: null,
  Widget: Widget$B,
  Admin: Admin$B,
  Config: Config$B,
  Defaults: Defaults$B
};
var Widget$C = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    originalName = _ref.originalName,
    originalSettings = _ref.originalSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("strong", null, originalName, ":"), " To be transferred.", /*#__PURE__*/React.createElement("pre", null, JSON.stringify(originalSettings, null, 2))));
};
var Config$C = {
  deprecated: true,
  title: "Placeholder (dev)",
  category: "Developer"
};
var Defaults$C = {
  originalName: "",
  containerSettings: {
    spacing: "none"
  }
};
var Admin$C = {};
var PlaceholderWidget = {
  __proto__: null,
  Widget: Widget$C,
  Admin: Admin$C,
  Config: Config$C,
  Defaults: Defaults$C
};
var PodcastPicker = /*#__PURE__*/function (_React$Component) {
  function PodcastPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      podcast: _this.props.value
    };
    return _this;
  }
  _inheritsLoose(PodcastPicker, _React$Component);
  var _proto = PodcastPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    var newValue = value;
    this.props.onChange(newValue);
    this.setState({
      podcast: newValue
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var podcast = this.state.podcast;
    return /*#__PURE__*/React.createElement(Query, {
      query: PODCASTS
    }, function (_ref) {
      var error = _ref.error,
        loading = _ref.loading,
        data = _ref.data;
      if (error) return "Error! " + error.message;
      if (loading) return "Loading...";
      var podcasts = data.podcasts;
      var options = podcasts.list.map(function (e) {
        return [e.id, e.title];
      });
      return /*#__PURE__*/React.createElement(SelectMenu, {
        label: "Podcast",
        options: options,
        value: podcast,
        onChange: function onChange(value) {
          return _this2.handleChange(value);
        }
      });
    });
  };
  return PodcastPicker;
}(React.Component);
var ModalContent$1 = function ModalContent() {
  return /*#__PURE__*/React.createElement("div", {
    className: "podcast-modal"
  }, /*#__PURE__*/React.createElement("p", {
    className: "modal-note"
  }, "Click below to subscribe for GG Garage Podcasts on your platform of choice."), /*#__PURE__*/React.createElement("div", {
    className: "subscribe-links"
  }, /*#__PURE__*/React.createElement(A, {
    href: "http://cglabs.libsyn.com/rss",
    className: "rss",
    target: "_blank"
  }), /*#__PURE__*/React.createElement(A, {
    href: "https://itunes.apple.com/us/podcast/cg-garage/id949248007?mt=2&uo=4",
    className: "apple",
    target: "_blank"
  }), /*#__PURE__*/React.createElement(A, {
    href: "https://overcast.fm/itunes949248007/cg-garage",
    className: "overcast",
    target: "_blank"
  }), /*#__PURE__*/React.createElement(A, {
    href: "http://pca.st/sOds",
    className: "pocketcasts",
    target: "_blank"
  }), /*#__PURE__*/React.createElement(A, {
    href: "https://open.spotify.com/show/7r06TsnJhAZfGAuQfskD0T",
    className: "spotify",
    target: "_blank"
  }), /*#__PURE__*/React.createElement(A, {
    href: "https://www.stitcher.com/podcast/chaos-group-labs/cg-garage",
    className: "stitcher",
    target: "_blank"
  }), /*#__PURE__*/React.createElement(A, {
    href: "https://www.iheart.com/podcast/cg-garage-27627365/",
    className: "iheartradio",
    target: "_blank"
  })));
};
var FullPlayer = /*#__PURE__*/function (_React$Component) {
  function FullPlayer(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inheritsLoose(FullPlayer, _React$Component);
  var _proto = FullPlayer.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      source = _this$props.source,
      publish_date = _this$props.publish_date,
      episode_no = _this$props.episode_no,
      title = _this$props.title,
      mute = _this$props.mute,
      playing = _this$props.playing,
      progress = _this$props.progress,
      currentTime = _this$props.currentTime,
      duration = _this$props.duration,
      summary = _this$props.summary,
      more_url = _this$props.more_url,
      playingStarted = _this$props.playingStarted,
      onPlay = _this$props.onPlay,
      onPause = _this$props.onPause,
      onMute = _this$props.onMute,
      onSeek = _this$props.onSeek,
      transcription = _this$props.transcription,
      htmlID = _this$props.htmlID;
    return /*#__PURE__*/React.createElement("div", {
      className: "podcast-player-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "podcast-player white-bg"
    }, /*#__PURE__*/React.createElement("div", {
      className: "podcast-info"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "podcast-meta"
    }, "#", episode_no, /*#__PURE__*/React.createElement("span", {
      className: "podcast-date"
    }, ": ", publish_date), " ", /*#__PURE__*/React.createElement("span", {
      className: "btn-text subscribe",
      onClick: function onClick() {
        return _this2.setState({
          isOpen: true
        });
      }
    }, "Subscribe")), /*#__PURE__*/React.createElement("h5", {
      className: "podcast-title"
    }, title)), /*#__PURE__*/React.createElement("div", {
      className: "podcast-actions"
    }, /*#__PURE__*/React.createElement(A, {
      href: source,
      className: "btn-text download",
      id: "gtm-audio-" + htmlID,
      rel: "noopener noreferrer",
      target: "_blank"
    }, "Download"), /*#__PURE__*/React.createElement("span", {
      className: "btn-text subscribe",
      onClick: function onClick() {
        return _this2.setState({
          isOpen: true
        });
      }
    }, "Subscribe"), transcription && /*#__PURE__*/React.createElement(A, {
      href: transcription,
      className: "btn-text transcript",
      rel: "noopener noreferrer",
      target: "_blank",
      id: "gtm-transcription-" + htmlID
    }, "Transcript")), /*#__PURE__*/React.createElement("div", {
      className: "volume-icon mute-button " + (mute ? "muted-icon" : ""),
      onClick: onMute
    }), /*#__PURE__*/React.createElement("div", {
      className: "audiojs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "play-pause"
    }, !playing && /*#__PURE__*/React.createElement("p", {
      className: "play",
      onClick: onPlay
    }), playing && /*#__PURE__*/React.createElement("p", {
      className: "pause",
      onClick: onPause
    }), /*#__PURE__*/React.createElement("p", {
      className: "loading"
    }), /*#__PURE__*/React.createElement("p", {
      className: "error"
    })), /*#__PURE__*/React.createElement("div", {
      className: "scrubber",
      onClick: function onClick(e) {
        return onSeek(e);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "progress",
      style: {
        width: progress + "%"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "loaded",
      style: {
        width: "0%"
      }
    })), playingStarted && /*#__PURE__*/React.createElement("div", {
      className: "time"
    }, /*#__PURE__*/React.createElement("span", {
      className: "played"
    }, podcastTimeFormatter(currentTime)), "/", /*#__PURE__*/React.createElement("strong", {
      className: "duration"
    }, podcastTimeFormatter(duration))), /*#__PURE__*/React.createElement("div", {
      className: "error-message"
    }))), /*#__PURE__*/React.createElement("div", {
      className: "podcast-description"
    }, /*#__PURE__*/React.createElement("p", null, summary), more_url && /*#__PURE__*/React.createElement(A, {
      className: "btn-passive",
      href: more_url
    }, "Read more")), /*#__PURE__*/React.createElement(Modal, {
      title: "SUBSCRIBE",
      open: this.state.isOpen,
      onClose: function onClose() {
        return _this2.setState({
          isOpen: false
        });
      }
    }, /*#__PURE__*/React.createElement(ModalContent$1, null)));
  };
  return FullPlayer;
}(React.Component);
var MiniPlayer = /*#__PURE__*/function (_React$Component) {
  function MiniPlayer(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inheritsLoose(MiniPlayer, _React$Component);
  var _proto = MiniPlayer.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      source = _this$props.source,
      publish_date = _this$props.publish_date,
      episode_no = _this$props.episode_no,
      mute = _this$props.mute,
      playing = _this$props.playing,
      progress = _this$props.progress,
      currentTime = _this$props.currentTime,
      duration = _this$props.duration,
      playingStarted = _this$props.playingStarted,
      onPlay = _this$props.onPlay,
      onPause = _this$props.onPause,
      onMute = _this$props.onMute,
      onSeek = _this$props.onSeek,
      transcription = _this$props.transcription,
      htmlID = _this$props.htmlID;
    return /*#__PURE__*/React.createElement("div", {
      className: "podcast-player white-bg"
    }, /*#__PURE__*/React.createElement("h6", {
      className: "podcast-widget-meta"
    }, "#", episode_no, /*#__PURE__*/React.createElement("span", {
      className: "podcast-date"
    }, ": ", publish_date), " ", /*#__PURE__*/React.createElement("span", {
      className: "btn-text subscribe",
      onClick: function onClick() {
        return _this2.setState({
          isOpen: true
        });
      }
    }, "Subscribe")), /*#__PURE__*/React.createElement("div", {
      className: "podcast-actions"
    }, /*#__PURE__*/React.createElement(A, {
      href: source,
      className: "btn-text download",
      id: "gtm-audio-" + htmlID,
      rel: "noopener noreferrer",
      target: "_blank"
    }, "Download"), /*#__PURE__*/React.createElement("span", {
      className: "btn-text subscribe",
      onClick: function onClick() {
        return _this2.setState({
          isOpen: true
        });
      }
    }, "Subscribe"), transcription && /*#__PURE__*/React.createElement(A, {
      href: transcription,
      className: "btn-text transcript",
      rel: "noopener noreferrer",
      target: "_blank",
      id: "gtm-transcription-" + htmlID
    }, "Transcript")), /*#__PURE__*/React.createElement("div", {
      className: "volume-icon mute-button " + (mute ? "muted-icon" : ""),
      onClick: onMute
    }), /*#__PURE__*/React.createElement("div", {
      className: "audiojs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "play-pause"
    }, !playing && /*#__PURE__*/React.createElement("p", {
      className: "play",
      onClick: onPlay
    }), playing && /*#__PURE__*/React.createElement("p", {
      className: "pause",
      onClick: onPause
    }), /*#__PURE__*/React.createElement("p", {
      className: "loading"
    }), /*#__PURE__*/React.createElement("p", {
      className: "error"
    })), /*#__PURE__*/React.createElement("div", {
      className: "scrubber",
      onClick: function onClick(e) {
        return onSeek(e);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "progress",
      style: {
        width: progress + "%"
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "loaded",
      style: {
        width: "0%"
      }
    })), playingStarted && /*#__PURE__*/React.createElement("div", {
      className: "time"
    }, /*#__PURE__*/React.createElement("span", {
      className: "played"
    }, podcastTimeFormatter(currentTime)), "/", /*#__PURE__*/React.createElement("strong", {
      className: "duration"
    }, podcastTimeFormatter(duration))), /*#__PURE__*/React.createElement("div", {
      className: "error-message"
    }), /*#__PURE__*/React.createElement(Modal, {
      title: "SUBSCRIBE",
      open: this.state.isOpen,
      onClose: function onClose() {
        return _this2.setState({
          isOpen: false
        });
      }
    }, /*#__PURE__*/React.createElement(ModalContent$1, null))));
  };
  return MiniPlayer;
}(React.Component);
var PodcastPlayer = /*#__PURE__*/function (_React$Component) {
  function PodcastPlayer(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      progress: 0,
      playing: false,
      currentTime: 0,
      duration: 0,
      loaded: 0,
      mute: false,
      playingStarted: false
    };
    var _this$props = _this.props,
      source = _this$props.source,
      autoplay = _this$props.autoplay;
    if (typeof document !== "undefined") {
      _this.audio = document.createElement("audio");
      _this.audio.src = source;
      _this.audio.preload = "metadata";
      _this.audio.autoplay = !!autoplay;
      _this.audio.addEventListener("timeupdate", function (e) {
        return _this.updateProgress();
      });
    }
    return _this;
  }
  _inheritsLoose(PodcastPlayer, _React$Component);
  var _proto = PodcastPlayer.prototype;
  _proto.updateProgress = function updateProgress() {
    var _this$audio = this.audio,
      duration = _this$audio.duration,
      currentTime = _this$audio.currentTime,
      buffered = _this$audio.buffered;
    var progress = currentTime * 100 / duration;
    var loaded = buffered.length;
    this.setState({
      progress: progress,
      currentTime: currentTime,
      duration: duration,
      loaded: loaded
    });
  };
  _proto.setProgress = function setProgress(e) {
    var target = e.target.nodeName === "SPAN" ? e.target.parentNode : e.target;
    var width = target.clientWidth;
    var rect = target.getBoundingClientRect();
    var offsetX = e.clientX - rect.left;
    var duration = this.audio.duration;
    var currentTime = duration * offsetX / width;
    var progress = currentTime * 100 / duration;
    this.audio.currentTime = currentTime;
    this.setState({
      progress: progress
    });
    this.play();
  };
  _proto.play = function play() {
    this.setState({
      playing: true,
      playingStarted: true
    });
    this.audio.play();
  };
  _proto.pause = function pause() {
    this.setState({
      playing: false
    });
    this.audio.pause();
  };
  _proto.toggleMute = function toggleMute() {
    var mute = this.state.mute;
    this.setState({
      mute: !mute
    });
    this.audio.volume = !!mute;
  };
  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;
    setTimeout(function () {
      return _this2.setState({
        duration: _this2.audio.duration
      });
    }, 3000);
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props2 = this.props,
      variant = _this$props2.variant,
      source = _this$props2.source,
      publish_date = _this$props2.publish_date,
      episode_no = _this$props2.episode_no,
      title = _this$props2.title,
      summary = _this$props2.summary,
      more_url = _this$props2.more_url,
      transcription = _this$props2.transcription,
      htmlID = _this$props2.htmlID;
    var _this$state = this.state,
      playing = _this$state.playing,
      mute = _this$state.mute,
      progress = _this$state.progress,
      currentTime = _this$state.currentTime,
      duration = _this$state.duration,
      playingStarted = _this$state.playingStarted;
    var Component = variant === "mini" ? MiniPlayer : FullPlayer;
    var playerProps = {
      source: source,
      publish_date: publish_date,
      episode_no: episode_no,
      title: title,
      mute: mute,
      playing: playing,
      progress: progress,
      currentTime: currentTime,
      duration: duration,
      summary: summary,
      more_url: more_url,
      playingStarted: playingStarted,
      transcription: transcription,
      htmlID: htmlID,
      onPlay: function onPlay() {
        return _this3.play();
      },
      onPause: function onPause() {
        return _this3.pause();
      },
      onMute: function onMute() {
        return _this3.toggleMute();
      },
      onSeek: function onSeek(e) {
        return _this3.setProgress(e);
      }
    };
    return /*#__PURE__*/React.createElement(Component, playerProps);
  };
  return PodcastPlayer;
}(React.Component);
PodcastPlayer.defaultProps = {
  variant: "full",
  autoplay: false
};
var Podcast = function Podcast() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 90,
      height: 90,
      marginRight: 25
    }
  }), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "calc(100% - 115px)",
      height: 90
    }
  })));
};
var PodcastPlaceholder = function PodcastPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: Podcast,
    realComponent: realComponent
  });
};
var PodcastPreview = function PodcastPreview(_ref) {
  var podcast = _ref.podcast;
  return /*#__PURE__*/React.createElement(Query, {
    query: PODCAST,
    variables: {
      input: {
        id: podcast
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var podcast = data.podcast;
    return /*#__PURE__*/React.createElement(PodcastPlaceholder, {
      ready: loading || !podcast,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(PodcastPlayer, {
          variant: "mini",
          source: podcast.source,
          episode_no: podcast.episode_no,
          publish_date: podcast.publish_date,
          title: podcast.title,
          summary: podcast.summary,
          more_url: podcast.more_url,
          transcription: podcast.transcription,
          htmlID: podcast.htmlID
        });
      }
    });
  });
};
var Widget$D = function Widget(_ref) {
  var podcast = _ref.podcast,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "podcast-widget",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-shift-2"
  }, podcast ? /*#__PURE__*/React.createElement(PodcastPreview, {
    podcast: podcast
  }) : /*#__PURE__*/React.createElement("h2", {
    className: "text-center"
  }, "No Podcast Selected"))));
};
var Config$D = {
  title: "Podcast",
  category: "Audio"
};
var Defaults$D = {
  podcast: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$D = {
  podcast: {
    type: "custom",
    component: PodcastPicker
  }
};
var PodcastWidget = {
  __proto__: null,
  Widget: Widget$D,
  Admin: Admin$D,
  Config: Config$D,
  Defaults: Defaults$D
};
var PodcastList = function PodcastList() {
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-shift-1"
  }, [0, 1, 2, 3, 4, 5].map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: item,
      style: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: item <= idx ? "1em" : 0
      }
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: 210,
        height: 210,
        marginRight: 25
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        width: "calc(100% - 235px)"
      }
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: 90,
        height: 90
      }
    }), /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: "calc(100% - 115px)",
        height: 90
      }
    }), /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: "100%",
        height: 20
      }
    }), /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: 150,
        height: 50
      }
    })));
  })));
};
var PodcastListPlaceholder = function PodcastListPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: PodcastList,
    realComponent: realComponent
  });
};
var PodcastFeedPreview = function PodcastFeedPreview(_ref) {
  var limit = _ref.limit;
  return /*#__PURE__*/React.createElement(Query, {
    query: PODCAST_FEED,
    variables: {
      input: {
        limit: parseInt(limit, 10)
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var podcasts = data.podcasts;
    return /*#__PURE__*/React.createElement(PodcastListPlaceholder, {
      ready: loading,
      realComponent: function realComponent() {
        return podcasts.list.map(function (podcast, idx) {
          return /*#__PURE__*/React.createElement("div", {
            className: "podcast-player-extended",
            key: idx
          }, /*#__PURE__*/React.createElement("div", {
            className: "container"
          }, /*#__PURE__*/React.createElement("div", {
            className: "col-shift-1 podcast-inner"
          }, /*#__PURE__*/React.createElement("div", {
            className: "podcast-player-img-wrapper"
          }, /*#__PURE__*/React.createElement(Img, {
            loading: "lazy",
            src: podcast.image,
            variant: "thumb"
          })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PodcastPlayer, {
            source: podcast.source,
            episode_no: podcast.episode_no,
            publish_date: podcast.publish_date,
            title: podcast.title,
            summary: podcast.summary,
            more_url: podcast.more_url,
            transcription: podcast.transcription,
            htmlID: podcast.htmlID
          })))));
        });
      }
    });
  });
};
var Widget$E = function Widget(_ref) {
  var limit = _ref.limit,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "podcast-feed",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(PodcastFeedPreview, {
    limit: limit
  }));
};
var Defaults$E = {
  limit: 10,
  containerSettings: {
    theme: "white"
  }
};
var Config$E = {
  title: "Podcast Feed",
  category: "Feed"
};
var Admin$E = {
  limit: {
    type: "text",
    spacing: "none"
  }
};
var PodcastFeedWidget = {
  __proto__: null,
  Widget: Widget$E,
  Admin: Admin$E,
  Config: Config$E,
  Defaults: Defaults$E
};
var priceTypeOptions = [["perpetual", "Perpetual"], ["monthly", "Monthly"], ["annual", "Annual"], ["upgrade", "Upgrade"]];
var pricelistItemsSelect = function pricelistItemsSelect(pricelists, pricelistId, priceType) {
  return pricelists.list.find(function (pl) {
    return pl.id === pricelistId;
  }).items.filter(function (item) {
    return item.pricingType === priceType && item.minQuantity === 1;
  }).map(function (item) {
    return [item.id, item.product.name];
  });
};
var ListItem$6 = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem,
    options = _ref.options;
  return /*#__PURE__*/React.createElement(SelectMenu, {
    label: "",
    options: options,
    value: settings.itemId,
    onChange: function onChange(newValue) {
      onChangeItem("itemId", newValue);
    }
  });
};
var ItemsInput = function ItemsInput(_ref2) {
  var items = _ref2.items,
    pricelists = _ref2.pricelists,
    pricelist = _ref2.pricelist,
    currentPriceType = _ref2.currentPriceType,
    onChange = _ref2.onChange;
  var options = pricelistItemsSelect(pricelists, pricelist, currentPriceType);
  var listItems = items.map(function (item) {
    return {
      id: item,
      itemId: item
    };
  });
  return /*#__PURE__*/React.createElement(List, {
    itemsAlwaysOpen: true,
    label: "Items in the left plane",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$6, {
        settings: settings,
        onChangeItem: onChangeItem,
        options: options
      });
    },
    items: listItems,
    template: {
      itemId: ""
    },
    primaryField: "label",
    onChangeList: function onChangeList(_, newItems) {
      onChange(newItems.map(function (item) {
        return item.itemId;
      }));
    }
  });
};
var PriceListPicker = function PriceListPicker(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange;
  var pricelistId = value.pricelistId,
    items = value.items,
    item = value.item,
    priceType = value.priceType;
  var _useState = useState(pricelistId),
    pricelist = _useState[0],
    setPricelist = _useState[1];
  var _useState2 = useState(items),
    pricelistItems = _useState2[0],
    setPricelistItems = _useState2[1];
  var _useState3 = useState(item),
    pricelistItem = _useState3[0],
    setPricelistItem = _useState3[1];
  var _useState4 = useState(priceType),
    currentPriceType = _useState4[0],
    setCurrentPriceType = _useState4[1];
  var updatePricelist = function updatePricelist(newValue) {
    setPricelist(newValue);
    setPricelistItem("");
    setPricelistItems([]);
    onChange({
      pricelistId: newValue,
      items: [],
      item: "",
      priceType: priceType
    });
  };
  var updateItems = function updateItems(newValue) {
    setPricelistItems(newValue);
    onChange({
      pricelistId: pricelist,
      items: newValue,
      item: pricelistItem,
      priceType: currentPriceType
    });
  };
  var updateItem = function updateItem(newValue) {
    setPricelistItem(newValue);
    onChange({
      pricelistId: pricelist,
      items: pricelistItems,
      item: newValue,
      priceType: currentPriceType
    });
  };
  var updatePriceType = function updatePriceType(newValue) {
    setCurrentPriceType(newValue);
    setPricelistItem("");
    setPricelistItems([]);
    onChange({
      pricelistId: pricelist,
      items: [],
      item: "",
      priceType: newValue
    });
  };
  return /*#__PURE__*/React.createElement(Query, {
    query: PRICELISTS
  }, function (_ref4) {
    var error = _ref4.error,
      loading = _ref4.loading,
      data = _ref4.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var pricelists = data.pricelists;
    var options = pricelists.list.map(function (e) {
      return [e.id, e.name];
    });
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Pricelist",
      options: options,
      value: pricelist,
      onChange: function onChange(newValue) {
        return updatePricelist(newValue);
      }
    }), /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Pricing type",
      options: priceTypeOptions,
      value: currentPriceType,
      onChange: function onChange(newValue) {
        return updatePriceType(newValue);
      }
    }), pricelist && currentPriceType && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Select the item on the right",
      options: pricelistItemsSelect(pricelists, pricelist, currentPriceType),
      value: pricelistItem,
      onChange: function onChange(newValue) {
        return updateItem(newValue);
      }
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ItemsInput, {
      pricelists: pricelists,
      pricelist: pricelist,
      currentPriceType: currentPriceType,
      onChange: updateItems,
      items: pricelistItems
    })));
  });
};
var pickListItems = function pickListItems(settings, items) {
  var apiItems = items.filter(function (item) {
    return settings.items.includes(item.id);
  });
  return settings.items.map(function (itemId) {
    return apiItems.find(function (apiItem) {
      return apiItem.id === itemId;
    });
  }).filter(function (item) {
    return !!item;
  });
};
var pickRightItem = function pickRightItem(settings, items) {
  return items.find(function (item) {
    return settings.item === item.id;
  });
};
var PromoText = function PromoText(_ref) {
  var text = _ref.text,
    savings = _ref.savings,
    currency = _ref.currency;
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  return /*#__PURE__*/React.createElement("div", {
    className: "promo-text"
  }, text.replace("{SAVINGS}", "" + Currency.prettyPrint(savings, currency, country)));
};
var SingleItem = function SingleItem(_ref2) {
  var item = _ref2.item,
    savings = _ref2.savings,
    title = _ref2.title,
    button = _ref2.button,
    currency = _ref2.currency,
    promo = _ref2.promo;
  var _React$useContext2 = React.useContext(GeoIpContext),
    country = _React$useContext2.country;
  return /*#__PURE__*/React.createElement("div", {
    className: "package-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "package-info"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "package-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "package-price"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "amount"
  }, Currency.prettyPrint(Currency.extractPrice(item.prices, currency), currency, country)), /*#__PURE__*/React.createElement("small", {
    className: "price-type"
  }, item.pricingTypeLabel)), /*#__PURE__*/React.createElement(PromoText, {
    text: promo,
    savings: savings,
    currency: currency
  })), /*#__PURE__*/React.createElement(Button$1, {
    settings: button
  }));
};
var ListItems = function ListItems(_ref3) {
  var items = _ref3.items,
    listTitle = _ref3.listTitle,
    listPrice = _ref3.listPrice,
    currency = _ref3.currency,
    total = _ref3.total,
    totalPrice = _ref3.totalPrice;
  var _React$useContext3 = React.useContext(GeoIpContext),
    country = _React$useContext3.country;
  return /*#__PURE__*/React.createElement("div", {
    className: "included-products-col"
  }, /*#__PURE__*/React.createElement("table", {
    className: "price-breakdown small-print"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, listTitle), /*#__PURE__*/React.createElement("th", {
    className: "number",
    style: {
      width: "105px"
    }
  }, listPrice))), /*#__PURE__*/React.createElement("tbody", null, items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("tr", {
      key: idx
    }, /*#__PURE__*/React.createElement("td", null, item.product.name), /*#__PURE__*/React.createElement("td", {
      className: "number",
      style: {
        width: "105px"
      }
    }, Currency.prettyPrint(Currency.extractPrice(item.prices, currency), currency, country)));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "totals number"
  }, /*#__PURE__*/React.createElement("span", {
    className: "total-label"
  }, total + " (" + items[0].pricingTypeLabel + "): "), /*#__PURE__*/React.createElement("span", {
    className: "total-price"
  }, Currency.prettyPrint(totalPrice, currency, country))));
};
var PriceComparison = function PriceComparison(_ref4) {
  var pricelistSettings = _ref4.pricelistSettings,
    pricelist = _ref4.pricelist,
    currency = _ref4.currency,
    title = _ref4.title,
    promo = _ref4.promo,
    listTitle = _ref4.listTitle,
    listPrice = _ref4.listPrice,
    total = _ref4.total,
    button = _ref4.button;
  var items = pickListItems(pricelistSettings, pricelist.items);
  var item = pickRightItem(pricelistSettings, pricelist.items);
  var totalPrice = items.reduce(function (sum, li) {
    return sum + Number(Currency.extractPrice(li.prices, currency));
  }, 0);
  var savings = totalPrice - Number(Currency.extractPrice(item.prices, currency));
  return /*#__PURE__*/React.createElement("div", {
    className: "price-comparison"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement(ListItems, {
    items: items,
    listTitle: listTitle,
    listPrice: listPrice,
    currency: currency,
    total: total,
    totalPrice: totalPrice
  }), /*#__PURE__*/React.createElement(SingleItem, {
    item: item,
    savings: savings,
    title: title,
    button: button,
    promo: promo,
    currency: currency
  }))));
};
var PriceComparison$1 = function PriceComparison() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "4em"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "50%",
      height: 200,
      marginRight: "1em"
    }
  }), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "50%",
      height: 200
    }
  })));
};
var PriceComparisonPlaceholder = function PriceComparisonPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: PriceComparison$1,
    realComponent: realComponent
  });
};
var comparisonShowable = function comparisonShowable(pricelistSettings) {
  return pricelistSettings && pricelistSettings.pricelistId && pricelistSettings.priceType && pricelistSettings.items && pricelistSettings.items.length > 0 && pricelistSettings.item;
};
var PriceComparisonWrapper = function PriceComparisonWrapper(_ref) {
  var loggedAdmin = _ref.loggedAdmin,
    pricelistSettings = _ref.pricelistSettings,
    title = _ref.title,
    promo = _ref.promo,
    listTitle = _ref.listTitle,
    listPrice = _ref.listPrice,
    total = _ref.total,
    button = _ref.button,
    containerSettings = _ref.containerSettings;
  var _React$useState = React.useState(null),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrency);
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, loggedAdmin && currency && /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("select", {
    value: currency,
    onChange: function onChange(e) {
      return setCurrency(e.target.value);
    }
  }, Currency.all.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      key: c,
      value: c
    }, c.toUpperCase());
  }))), !comparisonShowable(pricelistSettings) && /*#__PURE__*/React.createElement("h1", null, "Please configure the pricelist"), comparisonShowable(pricelistSettings) && /*#__PURE__*/React.createElement(Query, {
    query: PRICELIST,
    variables: {
      input: {
        id: pricelistSettings.pricelistId
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    return /*#__PURE__*/React.createElement(PriceComparisonPlaceholder, {
      ready: loading || !currency,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(PriceComparison, {
          pricelistSettings: pricelistSettings,
          pricelist: data.pricelist,
          currency: currency,
          title: title,
          promo: promo,
          listTitle: listTitle,
          listPrice: listPrice,
          total: total,
          button: button
        });
      }
    });
  }));
};
var Widget$F = function Widget(props) {
  return /*#__PURE__*/React.createElement(AdminUserContext.Consumer, null, function (loggedAdmin) {
    return /*#__PURE__*/React.createElement(PriceComparisonWrapper, _extends({
      loggedAdmin: loggedAdmin
    }, props));
  });
};
var Config$F = {
  title: "Price comparison",
  category: "Pricing"
};
var Defaults$F = {
  title: "V-Ray Edu Collection",
  promo: "Get the collection and save {SAVINGS}",
  listTitle: "The collection includes",
  listPrice: "Single price",
  total: "Total price if purchased separately",
  button: ButtonSettingsWithDescription.defaults,
  pricelistSettings: {
    pricelistId: "",
    items: [],
    item: "",
    priceType: ""
  },
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$F = function Admin(_items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return _onChange("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Promo",
    onChange: function onChange(value) {
      return _onChange("promo", value);
    },
    value: settings.promo,
    hint: "Replaces the {SAVINGS} token with the amount you save."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "List Title",
    onChange: function onChange(value) {
      return _onChange("listTitle", value);
    },
    value: settings.listTitle
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "List Price",
    onChange: function onChange(value) {
      return _onChange("listPrice", value);
    },
    value: settings.listPrice
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Total",
    onChange: function onChange(value) {
      return _onChange("total", value);
    },
    value: settings.total
  }), /*#__PURE__*/React.createElement(ButtonSettingsWithDescription, {
    label: "Button",
    onChange: function onChange(value) {
      return _onChange("button", value);
    },
    value: settings.button
  }), /*#__PURE__*/React.createElement(PriceListPicker, {
    value: settings.pricelistSettings,
    onChange: function onChange(value) {
      return _onChange("pricelistSettings", value);
    }
  }));
};
var PriceComparisonWidget = {
  __proto__: null,
  Widget: Widget$F,
  Admin: Admin$F,
  Config: Config$F,
  Defaults: Defaults$F
};
var Widget$G = function Widget(_ref) {
  var variant = _ref.variant,
    image = _ref.image,
    link = _ref.link,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "product-bar " + (variant === "slim" ? "product-bar-slim" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, link !== "" ? /*#__PURE__*/React.createElement(A, {
    href: link
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: "mobile_square"
  })) : /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: "mobile_square"
  }))));
};
var Config$G = {
  title: "Product Logo",
  category: "Logos"
};
var Defaults$G = {
  variant: "normal",
  link: "",
  image: imagePlaceholder("540x540"),
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$G = {
  variant: {
    type: "select",
    options: [["normal", "Normal"], ["slim", "Slim"]]
  },
  image: {
    type: "custom",
    component: ImagePicker
  },
  link: {
    type: "text"
  }
};
var ProductBarWidget = {
  __proto__: null,
  Widget: Widget$G,
  Admin: Admin$G,
  Config: Config$G,
  Defaults: Defaults$G
};
var Widget$H = function Widget(_ref) {
  var image = _ref.image,
    title = _ref.title,
    promo_text = _ref.promo_text,
    button_settings_1 = _ref.button_settings_1,
    design = _ref.design,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "cta-section  " + (design === "normal" ? "" : "cta-section-fw"),
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, image !== "" ? /*#__PURE__*/React.createElement("div", {
    className: "cta-icon-wrapper",
    style: {
      backgroundImage: "url(" + imageSrc(image, "thumb") + ")"
    }
  }) : "", /*#__PURE__*/React.createElement("div", {
    className: "cta-headings"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "cta-title"
  }, title), /*#__PURE__*/React.createElement("h5", {
    className: "cta-sub-title"
  }, promo_text)), /*#__PURE__*/React.createElement("div", {
    className: "cta-buttons"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: button_settings_1
  }))));
};
var Config$H = {
  title: "CTA Box",
  category: "CTA"
};
var Defaults$H = {
  image: imagePlaceholder("200x200"),
  title: "Lorem ipsum dolor.",
  promo_text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Qui a necessitatibus ratione nihil. Minus, praesentium.",
  button_settings_1: ButtonSettingsWithDescription.defaults,
  design: "normal",
  containerSettings: {
    theme: "white",
    spacing: "both"
  }
};
var Admin$H = {
  image: {
    type: "custom",
    component: ImagePicker
  },
  title: {
    type: "text"
  },
  promo_text: {
    type: "text"
  },
  design: {
    type: "select",
    options: [["normal", "Left-aligned"], ["full_width", "Centered"]]
  },
  button_settings_1: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button"
  }
};
var PromoBanerWidget = {
  __proto__: null,
  Widget: Widget$H,
  Admin: Admin$H,
  Config: Config$H,
  Defaults: Defaults$H
};
var Widget$I = function Widget(_ref) {
  var name = _ref.name,
    company = _ref.company,
    text = _ref.text,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "quote-section",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("blockquote", {
    cite: "",
    className: "quotation"
  }, /*#__PURE__*/React.createElement("div", {
    className: "quote-text"
  }, /*#__PURE__*/React.createElement("span", {
    className: "quote-sign icon-quote"
  }), parseMarkdown(text)), name && /*#__PURE__*/React.createElement("p", {
    className: "quote-author"
  }, /*#__PURE__*/React.createElement("strong", null, name), company && /*#__PURE__*/React.createElement(React.Fragment, null, ", ", company)))));
};
var Config$I = {
  title: "Quote Bar",
  category: "Text"
};
var Defaults$I = {
  name: "John Doe",
  company: "Chaos Group",
  text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. ",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$I = {
  name: {
    type: "text"
  },
  company: {
    type: "text"
  },
  text: {
    type: "textarea"
  }
};
var QuoteBarWidget = {
  __proto__: null,
  Widget: Widget$I,
  Admin: Admin$I,
  Config: Config$I,
  Defaults: Defaults$I
};
var EventPicker = function EventPicker(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var _useState = useState(value),
    event = _useState[0],
    setEvent = _useState[1];
  return /*#__PURE__*/React.createElement(Query, {
    query: EVENTS
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var events = data.events;
    var options = events.list.map(function (e) {
      return [e.id, e.title + " (" + e.start_on + ")"];
    });
    return /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Events",
      options: options,
      value: event,
      onChange: function onChange(value) {
        setEvent(value);
        _onChange(value);
      }
    });
  });
};
var Schedule = function Schedule() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-shift-3"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "2em"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 230,
      height: 50,
      marginRight: 25
    }
  }), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 230,
      height: 50
    }
  })), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 60,
      marginBottom: 30
    }
  }), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 200,
      height: 15,
      marginBottom: 20
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      marginBottom: "2em"
    }
  }, [1, 2, 3, 4, 5, 6, 7, 8].map(function (item) {
    return /*#__PURE__*/React.createElement(RectShape, {
      key: item,
      color: colors.lightBlue,
      style: {
        width: 60,
        height: 20,
        marginRight: 10
      }
    });
  })), [1, 2, 3, 4].map(function (item) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item
    }, /*#__PURE__*/React.createElement(RectShape, {
      color: colors.lightBlue,
      style: {
        width: 200,
        height: 15,
        marginBottom: 20
      }
    }), /*#__PURE__*/React.createElement(TextBlock, {
      rows: 2,
      color: colors.lightBlue
    }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        marginBottom: "2em"
      }
    }, [1, 2, 3, 4, 5, 6].map(function (item) {
      return /*#__PURE__*/React.createElement(RectShape, {
        key: item,
        color: colors.lightBlue,
        style: {
          width: 60,
          height: 20,
          marginRight: 10
        }
      });
    })));
  })));
};
var SchedulePlaceholder = function SchedulePlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: Schedule,
    realComponent: realComponent
  });
};
var isTagExist = function isTagExist(talk, tagId) {
  return talk.tags.find(function (tag) {
    return tag.id === tagId;
  }) ? true : false;
};
var handleFilterByTag = function handleFilterByTag(tag, eventDays, onChange) {
  var newEventDays = eventDays.map(function (eventDay) {
    return _extends({}, eventDay, {
      timeslots: eventDay.timeslots.filter(function (talk) {
        return isTagExist(talk, tag.id);
      })
    });
  });
  onChange(newEventDays, tag.name);
};
var TagsFilter = function TagsFilter(_ref) {
  var title = _ref.title,
    tags = _ref.tags,
    eventDays = _ref.eventDays,
    onChange = _ref.onChange;
  return tags.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "tags-filter-wrapper"
  }, title && /*#__PURE__*/React.createElement("h6", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "tags-wrapper"
  }, tags && tags.map(function (tag) {
    return /*#__PURE__*/React.createElement("button", {
      key: tag.id,
      className: "tag",
      style: {
        backgroundColor: tag.color
      },
      onClick: function onClick() {
        return handleFilterByTag(tag, eventDays, onChange);
      }
    }, tag.name);
  })));
};
var formatTime = function formatTime(time) {
  return formatDateTime(time, "Europe/Sofia", "HH:mm");
};
var addComma = function addComma(idx, speakersCount) {
  if (speakersCount <= 1) return "";
  if (idx + 1 === speakersCount) return "";
  return idx < speakersCount ? "," : "";
};
var speakerCompany = function speakerCompany(speaker) {
  return speaker.company ? " (" + speaker.company + ")" : "";
};
var Talk = function Talk(_ref) {
  var talk = _ref.talk,
    eventDays = _ref.eventDays,
    _onChange = _ref.onChange;
  var _useState = useState(false),
    isModalOpen = _useState[0],
    setOpenModal = _useState[1];
  var _useState2 = useState(talk.speakers[0]),
    currentSpeaker = _useState2[0],
    setSpeaker = _useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "talk"
  }, talk.image && /*#__PURE__*/React.createElement("div", {
    className: "talk-preview"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: talk.image,
    variant: "full_width_original"
  })), /*#__PURE__*/React.createElement("time", {
    className: "time"
  }, formatTime(talk.start_time), " - ", formatTime(talk.end_time)), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "title"
  }, talk.title), talk.speakers.length > 0 && /*#__PURE__*/React.createElement("h6", {
    className: "sub-title"
  }, talk.speakers.map(function (speaker, idx) {
    return /*#__PURE__*/React.createElement("span", {
      className: "speaker",
      key: idx,
      onClick: function onClick() {
        setOpenModal(true);
        setSpeaker(speaker);
      }
    }, speaker.first_name, " ", speaker.last_name, speakerCompany(speaker), addComma(idx, talk.speakers.length));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: talk.description
    }
  }), /*#__PURE__*/React.createElement(TagsFilter, {
    tags: talk.tags,
    eventDays: eventDays,
    onChange: function onChange(newEventDays, selectedTag) {
      return _onChange(newEventDays, selectedTag);
    }
  })), currentSpeaker && /*#__PURE__*/React.createElement(Modal, {
    title: "",
    open: isModalOpen,
    onClose: function onClose() {
      return setOpenModal(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "square-thumb-modal"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: currentSpeaker.image,
    variant: "mobile_square"
  }), /*#__PURE__*/React.createElement("div", {
    className: "modal-text"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "name"
  }, currentSpeaker.first_name, " ", currentSpeaker.last_name), currentSpeaker.position && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, currentSpeaker.position, ","), /*#__PURE__*/React.createElement("br", null)), currentSpeaker.company && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(A, {
    href: currentSpeaker.company_website,
    target: "_blank"
  }, currentSpeaker.company)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: currentSpeaker.bio
    }
  })))));
};
var Talks = function Talks(_ref) {
  var talks = _ref.talks,
    eventDays = _ref.eventDays,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-shift-1"
  }, talks.map(function (talk) {
    return /*#__PURE__*/React.createElement(Talk, {
      key: talk.id,
      talk: talk,
      eventDays: eventDays,
      onChange: onChange
    });
  }));
};
var DaySchedule = function DaySchedule(_ref) {
  var schedule = _ref.schedule,
    eventDays = _ref.eventDays,
    _onChange = _ref.onChange;
  var _useState = useState(schedule.timeslots),
    talks = _useState[0],
    setTalks = _useState[1];
  useEffect(function () {
    setTalks(schedule.timeslots);
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, talks.length > 0 ? /*#__PURE__*/React.createElement(Talks, {
    eventDays: eventDays,
    talks: talks,
    onChange: function onChange(newEventDays, selectedTag) {
      return _onChange(newEventDays, selectedTag);
    }
  }) : /*#__PURE__*/React.createElement("div", {
    className: "col-shift-3"
  }, /*#__PURE__*/React.createElement("h4", null, "No results found for this day.")));
};
var isStringExist = function isStringExist(string, value) {
  return string.toLowerCase().includes(value.toLowerCase());
};
var filterBySpeaker = function filterBySpeaker(speaker, value) {
  var firstName = isStringExist(speaker.first_name, value);
  var lastName = isStringExist(speaker.last_name, value);
  var company = isStringExist(speaker.company, value);
  return firstName || lastName || company;
};
var filterByValue = function filterByValue(timeslot, value) {
  var filteredByTitle = isStringExist(timeslot.title, value);
  var filteredByDescription = isStringExist(timeslot.description, value);
  var speakers = timeslot.speakers.length > 0 ? timeslot.speakers : false;
  var filteredBySpeaker = speakers ? speakers.find(function (speaker) {
    return filterBySpeaker(speaker, value);
  }) : false;
  return filteredByTitle || filteredByDescription || filteredBySpeaker ? true : false;
};
var handleChange = function handleChange(value, eventDays, onChange) {
  if (value.length < 3) {
    onChange(eventDays);
    return;
  }
  var filteredEventDays = eventDays.map(function (eventDay) {
    return _extends({}, eventDay, {
      timeslots: eventDay.timeslots.filter(function (timeslot) {
        return filterByValue(timeslot, value);
      })
    });
  });
  onChange(filteredEventDays);
};
var Search$2 = function Search(_ref) {
  var eventDays = _ref.eventDays,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: "Search presentations\u2026",
    onChange: function onChange(e) {
      return handleChange(e.target.value, eventDays, _onChange);
    }
  });
};
var TagsFilter$1 = function TagsFilter() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 200,
      height: 15,
      marginTop: 30,
      marginBottom: 20
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      marginBottom: "2em"
    }
  }, [1, 2, 3, 4, 5, 6, 7, 8].map(function (item) {
    return /*#__PURE__*/React.createElement(RectShape, {
      key: item,
      color: colors.lightBlue,
      style: {
        width: 60,
        height: 20,
        marginRight: 10
      }
    });
  })));
};
var TagsFilterPlaceholder = function TagsFilterPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: TagsFilter$1,
    realComponent: realComponent
  });
};
var PopularTagsFilter = function PopularTagsFilter(_ref) {
  var eventDays = _ref.eventDays,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(Query, {
    query: POPULAR_TAGS,
    variables: {
      input: {
        filters: {
          popular: true
        }
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var tags = data.tags;
    return /*#__PURE__*/React.createElement(TagsFilterPlaceholder, {
      ready: loading,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(TagsFilter, {
          tags: tags.list,
          title: "FILTER BY POPULAR TAGS",
          eventDays: eventDays,
          onChange: function onChange(newEventDays, selectedTag) {
            return _onChange(newEventDays, selectedTag);
          }
        });
      }
    });
  });
};
var Filters = function Filters(_ref) {
  var eventDays = _ref.eventDays,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-shift-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters-wrapper"
  }, /*#__PURE__*/React.createElement(Search$2, {
    eventDays: eventDays,
    onChange: function onChange(newEventDays) {
      return _onChange(newEventDays);
    }
  }), /*#__PURE__*/React.createElement(PopularTagsFilter, {
    eventDays: eventDays,
    onChange: function onChange(newEventDays, selectedTag) {
      return _onChange(newEventDays, selectedTag);
    }
  })));
};
var defaultTabIndex = function defaultTabIndex(tabs, urlAnchor) {
  var defaultTab = urlAnchor ? tabs.find(function (tabs) {
    return tabs.identifier === urlAnchor;
  }) : tabs.find(function (tabs) {
    return tabs.default_day;
  });
  return tabs.indexOf(defaultTab) || 0;
};
var getAnchor = function getAnchor() {
  var href = window.location.href;
  if (window.location.href.includes("#")) {
    return href.substring(href.indexOf("#") + 1);
  }
  return "";
};
var setAnchor = function setAnchor() {
  var anchor = getAnchor();
  if (window.location.href.includes("#")) {
    var targetTopScroll = document.querySelector("#" + anchor).getBoundingClientRect().top;
    window.scroll(0, targetTopScroll);
  }
};
var Schedule$1 = function (_ref) {
  var event = _ref.event;
  var _useState = useState(event.event_days),
    eventDays = _useState[0],
    setEventDays = _useState[1];
  var _useState2 = useState(""),
    selectedTag = _useState2[0],
    setTagName = _useState2[1];
  useEffect(function () {
    setAnchor();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "cf"
  }, /*#__PURE__*/React.createElement(Filters, {
    eventDays: event.event_days,
    onChange: function onChange(newEventDays, selectedTag) {
      setTagName(selectedTag);
      setEventDays(newEventDays);
    }
  }), selectedTag && /*#__PURE__*/React.createElement("div", {
    className: "col-shift-3 clear-filter"
  }, "Currently showing tags tagged in \xA0", /*#__PURE__*/React.createElement("strong", null, selectedTag), " \xA0", /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      setEventDays(event.event_days);
      setTagName("");
    }
  }, "clear this filter"))), eventDays.length === 1 ? /*#__PURE__*/React.createElement(DaySchedule, {
    schedule: eventDays[0]
  }) : /*#__PURE__*/React.createElement(Tabs$1, {
    defaultIndex: defaultTabIndex(eventDays, getAnchor()),
    forceRenderTabPanel: true
  }, /*#__PURE__*/React.createElement(TabList, null, eventDays.map(function (day) {
    return /*#__PURE__*/React.createElement(Tab$5, {
      key: day.id
    }, /*#__PURE__*/React.createElement("div", {
      id: day.identifier && day.identifier
    }, day.title));
  })), eventDays.map(function (day) {
    return /*#__PURE__*/React.createElement(TabPanel, {
      key: day.id
    }, /*#__PURE__*/React.createElement(DaySchedule, {
      schedule: day,
      eventDays: event.event_days,
      onChange: function onChange(newEventDays, selectedTag) {
        setTagName(selectedTag);
        setEventDays(newEventDays);
      }
    }));
  })));
};
var ScheduleWrapper = function ScheduleWrapper(_ref) {
  var event = _ref.event;
  return /*#__PURE__*/React.createElement(Query, {
    query: EVENT,
    variables: {
      input: {
        id: event
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var event = data.event;
    return /*#__PURE__*/React.createElement(SchedulePlaceholder, {
      ready: loading || !event,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(Schedule$1, {
          event: event
        });
      }
    });
  });
};
var Widget$J = function Widget(_ref) {
  var event = _ref.event,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "schedule-widget",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, event ? /*#__PURE__*/React.createElement(ScheduleWrapper, {
    event: event
  }) : /*#__PURE__*/React.createElement("h2", null, "Schedule: select event")));
};
var Config$J = {
  title: "Schedule",
  category: "Events"
};
var Defaults$J = {
  event: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$J = {
  event: {
    type: "custom",
    component: EventPicker
  }
};
var ScheduleWidget = {
  __proto__: null,
  Widget: Widget$J,
  Admin: Admin$J,
  Config: Config$J,
  Defaults: Defaults$J
};
var _excluded$4 = ["heading", "children"],
  _excluded2 = ["title_variant"];
var Heading = function Heading(_ref) {
  var heading = _ref.heading,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$4);
  var MAPPING = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
  };
  var Component = MAPPING[heading] || "h3";
  return /*#__PURE__*/React.createElement(Component, rest, children);
};
var SectionTitleMain = function SectionTitleMain(_ref2) {
  var title = _ref2.title,
    pre_title = _ref2.pre_title,
    _ref2$pre_title_marku = _ref2.pre_title_markup,
    pre_title_markup = _ref2$pre_title_marku === void 0 ? "h6" : _ref2$pre_title_marku,
    pre_title_color = _ref2.pre_title_color,
    sub_title = _ref2.sub_title,
    _ref2$title_markup = _ref2.title_markup,
    title_markup = _ref2$title_markup === void 0 ? "h3" : _ref2$title_markup,
    _ref2$sub_title_marku = _ref2.sub_title_markup,
    sub_title_markup = _ref2$sub_title_marku === void 0 ? "h5" : _ref2$sub_title_marku;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, pre_title && /*#__PURE__*/React.createElement(Heading, {
    heading: pre_title_markup,
    className: "section-pre-title",
    style: pre_title_color ? {
      color: "" + pre_title_color
    } : {}
  }, pre_title), /*#__PURE__*/React.createElement(Heading, {
    heading: title_markup,
    className: "section-title main"
  }, title), sub_title && /*#__PURE__*/React.createElement(Heading, {
    heading: sub_title_markup,
    className: "section-sub-title"
  }, sub_title));
};
var SectionTitleSecondary = function SectionTitleSecondary(_ref3) {
  var title = _ref3.title,
    pre_title = _ref3.pre_title,
    _ref3$pre_title_marku = _ref3.pre_title_markup,
    pre_title_markup = _ref3$pre_title_marku === void 0 ? "h6" : _ref3$pre_title_marku,
    pre_title_color = _ref3.pre_title_color,
    sub_title = _ref3.sub_title,
    _ref3$title_markup = _ref3.title_markup,
    title_markup = _ref3$title_markup === void 0 ? "h5" : _ref3$title_markup,
    _ref3$sub_title_marku = _ref3.sub_title_markup,
    sub_title_markup = _ref3$sub_title_marku === void 0 ? "h5" : _ref3$sub_title_marku;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, pre_title && /*#__PURE__*/React.createElement(Heading, {
    heading: pre_title_markup,
    className: "section-pre-title",
    style: pre_title_color ? {
      color: "" + pre_title_color
    } : {}
  }, pre_title), /*#__PURE__*/React.createElement(Heading, {
    heading: title_markup,
    style: {
      textTransform: "none"
    },
    className: "section-title secondary"
  }, /*#__PURE__*/React.createElement("strong", null, title)), sub_title && /*#__PURE__*/React.createElement(Heading, {
    heading: sub_title_markup,
    className: "section-sub-title"
  }, sub_title));
};
var SectionTitleMedium = function SectionTitleMedium(_ref4) {
  var title = _ref4.title,
    pre_title = _ref4.pre_title,
    _ref4$pre_title_marku = _ref4.pre_title_markup,
    pre_title_markup = _ref4$pre_title_marku === void 0 ? "h6" : _ref4$pre_title_marku,
    pre_title_color = _ref4.pre_title_color,
    sub_title = _ref4.sub_title,
    _ref4$title_markup = _ref4.title_markup,
    title_markup = _ref4$title_markup === void 0 ? "h3" : _ref4$title_markup,
    _ref4$sub_title_marku = _ref4.sub_title_markup,
    sub_title_markup = _ref4$sub_title_marku === void 0 ? "h5" : _ref4$sub_title_marku;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-inner"
  }, pre_title && /*#__PURE__*/React.createElement(Heading, {
    heading: pre_title_markup,
    className: "section-pre-title",
    style: pre_title_color ? {
      color: "" + pre_title_color
    } : {}
  }, pre_title), /*#__PURE__*/React.createElement(Heading, {
    heading: title_markup,
    className: "section-title medium",
    style: {
      textTransform: "none"
    }
  }, title), sub_title && /*#__PURE__*/React.createElement(Heading, {
    heading: sub_title_markup,
    className: "section-sub-title"
  }, sub_title)));
};
var TitleVariant = function TitleVariant(_ref5) {
  var title_variant = _ref5.title_variant,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);
  switch (title_variant) {
    case "main":
      return /*#__PURE__*/React.createElement(SectionTitleMain, rest);
    case "secondary":
      return /*#__PURE__*/React.createElement(SectionTitleSecondary, rest);
    case "medium":
      return /*#__PURE__*/React.createElement(SectionTitleMedium, rest);
    default:
      return /*#__PURE__*/React.createElement(SectionTitleMain, rest);
  }
};
TitleVariant.defaultProps = {
  sub_title: ""
};
var Widget$K = function Widget(_ref6) {
  var title = _ref6.title,
    pre_title = _ref6.pre_title,
    _ref6$pre_title_marku = _ref6.pre_title_markup,
    pre_title_markup = _ref6$pre_title_marku === void 0 ? "h6" : _ref6$pre_title_marku,
    pre_title_color = _ref6.pre_title_color,
    sub_title = _ref6.sub_title,
    title_variant = _ref6.title_variant,
    title_markup = _ref6.title_markup,
    _ref6$sub_title_marku = _ref6.sub_title_markup,
    sub_title_markup = _ref6$sub_title_marku === void 0 ? "h5" : _ref6$sub_title_marku,
    containerSettings = _ref6.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "section-title-wrapper",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(TitleVariant, {
    pre_title: pre_title,
    pre_title_markup: pre_title_markup,
    pre_title_color: pre_title_color,
    title_variant: title_variant,
    title: title,
    sub_title: sub_title,
    title_markup: title_markup,
    sub_title_markup: sub_title_markup
  }));
};
var Config$K = {
  title: "Section Title",
  category: "Text"
};
var Defaults$K = {
  title: "Headline",
  title_variant: "main",
  title_markup: "h3",
  pre_title: "",
  pre_title_markup: "h6",
  pre_title_color: "",
  sub_title: "",
  sub_title_markup: "h5",
  containerSettings: {
    theme: "white",
    spacing: "top"
  }
};
var Admin$K = {
  title_variant: {
    type: "select",
    options: [["main", "Main"], ["secondary", "Secondary"], ["medium", "Medium"]]
  },
  title_markup: {
    type: "select",
    options: [["h1", "H1"], ["h2", "H2"], ["h3", "H3"], ["h4", "H4"], ["h5", "H5"], ["h6", "H6"]]
  },
  title: {
    type: "text"
  },
  pre_title: {
    type: "text"
  },
  pre_title_markup: {
    type: "select",
    options: [["h1", "H1"], ["h2", "H2"], ["h3", "H3"], ["h4", "H4"], ["h5", "H5"], ["h6", "H6"]]
  },
  pre_title_color: {
    type: "text"
  },
  sub_title: {
    type: "text"
  },
  sub_title_markup: {
    type: "select",
    options: [["h1", "H1"], ["h2", "H2"], ["h3", "H3"], ["h4", "H4"], ["h5", "H5"], ["h6", "H6"]]
  }
};
var SectionTitleWidget = {
  __proto__: null,
  Widget: Widget$K,
  Admin: Admin$K,
  Config: Config$K,
  Defaults: Defaults$K
};
var Widget$L = function Widget(_ref) {
  var width = _ref.width,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "separator",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: width === "contained" ? "container" : ""
  }, /*#__PURE__*/React.createElement("hr", null)));
};
var Config$L = {
  title: "Separator",
  category: "Misc"
};
var Defaults$L = {
  width: "full_with",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$L = {
  width: {
    type: "select",
    options: [["full_with", "Full Width"], ["contained", "Contained"]]
  }
};
var SeparatorWidget = {
  __proto__: null,
  Widget: Widget$L,
  Admin: Admin$L,
  Config: Config$L,
  Defaults: Defaults$L
};
var FormPicker = function FormPicker(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var _useState = useState(value),
    form = _useState[0],
    setForm = _useState[1];
  return /*#__PURE__*/React.createElement(Query, {
    query: FORMS
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var forms = data.forms;
    var options = forms.list.map(function (e) {
      return [e.id, e.name];
    });
    return /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Forms",
      options: options,
      value: form,
      onChange: function onChange(value) {
        setForm(value);
        _onChange(value);
      }
    });
  });
};
var SimpleForm = function SimpleForm() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: 800,
      marginBottom: 30
    }
  }));
};
var SimpleFormPlaceholder = function SimpleFormPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: SimpleForm,
    realComponent: realComponent
  });
};
var shouldDecorate = function shouldDecorate(href) {
  if (href.startsWith("/")) {
    return false;
  }
  return true;
};
var decorateAnchors = function decorateAnchors(text, decorateAll) {
  if (decorateAll === void 0) {
    decorateAll = false;
  }
  var newText = text;
  var regExp = new RegExp(/<a href="(.+?)">/, "g");
  while (true) {
    var matchResult = regExp.exec(text);
    if (matchResult === null) {
      return newText;
    }
    var anchor = matchResult[0],
      url = matchResult[1];
    if (decorateAll || shouldDecorate(url)) {
      newText = newText.replace(anchor, anchor.replace("<a", "<a target=\"_blank\" "));
    }
  }
};
var DatePicker = function DatePicker(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange,
    field = _ref.field;
  var dateProps = {};
  if (value !== "") dateProps.selected = new Date(value);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ReactDatePicker, _extends({}, dateProps, {
    locale: "en",
    dateFormat: "dd/MM/yyyy",
    onChange: function onChange(date) {
      return _onChange(formatSimpleDate(date));
    },
    placeholderText: field.placeholder,
    required: field.required === "yes"
  })), /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint
  }));
};
var countrySelectOptions = function countrySelectOptions(collection) {
  return collection.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.id,
      value: item.id
    }, item.name);
  });
};
var CountryInput = function CountryInput(_ref2) {
  var field = _ref2.field,
    defaultValue = _ref2.defaultValue;
  return /*#__PURE__*/React.createElement(CountriesConsumer, null, function (value) {
    return /*#__PURE__*/React.createElement("div", {
      className: "style-select"
    }, /*#__PURE__*/React.createElement("select", {
      name: "data[country]",
      required: field.required === "yes",
      defaultValue: defaultValue,
      id: fieldId(field)
    }, /*#__PURE__*/React.createElement("option", {
      value: ""
    }, field.placeholder), countrySelectOptions(value)));
  });
};
var DateInput = function DateInput(_ref3) {
  var field = _ref3.field;
  var _useState = useState(""),
    date = _useState[0],
    setDate = _useState[1];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(DatePicker, {
    value: date,
    onChange: setDate,
    field: field
  }), /*#__PURE__*/React.createElement("input", {
    id: fieldId(field),
    type: "hidden",
    name: "data[" + field.name + "]",
    value: date,
    required: field.required === "yes"
  }));
};
var fieldId = function fieldId(field) {
  return "form-" + field.name;
};
var Input$2 = function Input(_ref4) {
  var field = _ref4.field,
    defaultValue = _ref4.defaultValue,
    lockable = _ref4.lockable,
    mandatoryLockable = _ref4.mandatoryLockable;
  var readonlyAndLock = !!defaultValue && lockable || mandatoryLockable;
  var displayCharactersLimit = !readonlyAndLock && !!field.character_limit;
  var _React$useState = React.useState(field.character_limit),
    charCount = _React$useState[0],
    setCharCount = _React$useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    id: fieldId(field),
    type: field.type,
    name: "data[" + field.name + "]",
    placeholder: field.placeholder,
    required: field.required === "yes",
    pattern: field.pattern || null,
    maxLength: field.character_limit,
    defaultValue: defaultValue || "",
    readOnly: readonlyAndLock,
    className: readonlyAndLock ? "lock" : "",
    onChange: function onChange(e) {
      if (displayCharactersLimit) {
        var value = e.target.value;
        var remainingCharacters = parseInt(field.character_limit) - (value ? value.length : 0);
        setCharCount(remainingCharacters);
      }
    }
  }), displayCharactersLimit && /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint,
    charsLimit: field.character_limit,
    charsCount: charCount
  }), !displayCharactersLimit && /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint
  }));
};
var EmailInput = function EmailInput(_ref5) {
  var field = _ref5.field,
    defaultValue = _ref5.defaultValue,
    lockable = _ref5.lockable,
    mandatoryLockable = _ref5.mandatoryLockable;
  var readonlyAndLock = !!defaultValue && lockable || mandatoryLockable;
  var displayCharactersLimit = !readonlyAndLock && !!field.character_limit;
  var _React$useState2 = React.useState(field.character_limit),
    charCount = _React$useState2[0],
    setCharCount = _React$useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    id: fieldId(field),
    type: field.type,
    name: "data[" + field.name + "]",
    placeholder: field.placeholder,
    required: field.required === "yes",
    pattern: field.pattern || null,
    maxLength: field.character_limit,
    defaultValue: defaultValue || "",
    readOnly: readonlyAndLock,
    className: readonlyAndLock ? "lock" : "",
    onChange: function onChange(e) {
      if (displayCharactersLimit) {
        var value = e.target.value;
        var remainingCharacters = parseInt(field.character_limit) - (value ? value.length : 0);
        setCharCount(remainingCharacters);
      }
    }
  }), displayCharactersLimit && /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint,
    charsLimit: field.character_limit,
    charsCount: charCount
  }), !displayCharactersLimit && /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint
  }));
};
var TextArea$1 = function TextArea(_ref6) {
  var field = _ref6.field,
    defaultValue = _ref6.defaultValue;
  var displayCharactersLimit = !!field.character_limit;
  var _React$useState3 = React.useState(field.character_limit),
    charCount = _React$useState3[0],
    setCharCount = _React$useState3[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", {
    id: fieldId(field),
    name: "data[" + field.name + "]",
    placeholder: field.placeholder,
    required: field.required === "yes",
    pattern: field.pattern || null,
    maxLength: field.character_limit,
    defaultValue: defaultValue || "",
    onChange: function onChange(e) {
      if (displayCharactersLimit) {
        var value = e.target.value;
        var remainingCharacters = parseInt(field.character_limit) - (value ? value.length : 0);
        setCharCount(remainingCharacters);
      }
    }
  }), displayCharactersLimit && /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint,
    charsLimit: field.character_limit,
    charsCount: charCount
  }), !displayCharactersLimit && /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint
  }));
};
var HiddenInput = function HiddenInput(_ref7) {
  var field = _ref7.field,
    defaultValue = _ref7.defaultValue;
  return /*#__PURE__*/React.createElement("input", {
    id: fieldId(field),
    type: "hidden",
    name: "data[" + field.name + "]",
    defaultValue: defaultValue || field.default_value,
    required: field.required === "yes"
  });
};
var renderOptions = function renderOptions(_ref8) {
  var options = _ref8.options;
  return options && options.selectOptions && options.selectOptions.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.id,
      value: item.value
    }, item.label);
  });
};
var SelectInput = function SelectInput(_ref9) {
  var field = _ref9.field;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "style-select"
  }, /*#__PURE__*/React.createElement("select", {
    name: "data[" + field.name + "]",
    required: field.required === "yes",
    id: fieldId(field)
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, field.placeholder), renderOptions(field))), /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint
  }));
};
var fancyLabel = function fancyLabel(string) {
  var data = parser.renderInline(string);
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: decorateAnchors(data, true)
    }
  });
};
var Checkbox$2 = function Checkbox(_ref10) {
  var value = _ref10.value,
    label = _ref10.label,
    _onChange2 = _ref10.onChange,
    required = _ref10.required;
  return /*#__PURE__*/React.createElement("label", {
    className: "checkbox-style",
    htmlFor: "checkbox-id-" + value
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "checkbox-id-" + value,
    required: required,
    onChange: function onChange(event) {
      return _onChange2(event.target.checked, value);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "label-checkbox"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label-text"
  }, fancyLabel(label))));
};
var checkboxesOptions = function checkboxesOptions(_ref11) {
  var options = _ref11.options;
  return options && options.selectOptions || [];
};
var checkboxesValueSeparator = function checkboxesValueSeparator(_ref12) {
  var options = _ref12.options;
  return options && options.itemsSeparator || ";";
};
var CheckBoxListInput = function CheckBoxListInput(_ref13) {
  var field = _ref13.field;
  var _useState2 = useState([]),
    checkedValues = _useState2[0],
    setCheckedValues = _useState2[1];
  var requiredInput = field.required === "yes" && checkedValues.length === 0;
  return /*#__PURE__*/React.createElement("div", {
    className: "checkbox-list"
  }, checkboxesOptions(field).map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Checkbox$2, {
      key: item.id,
      value: item.value,
      label: item.label,
      required: requiredInput,
      onChange: function onChange(checked, value) {
        if (checked) {
          setCheckedValues([].concat(checkedValues, [value]));
        } else {
          setCheckedValues(checkedValues.filter(function (cv) {
            return cv !== value;
          }));
        }
      }
    });
  }), /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint
  }), /*#__PURE__*/React.createElement("input", {
    id: fieldId(field),
    type: "hidden",
    name: "data[" + field.name + "]",
    value: checkedValues.length > 0 ? checkedValues.join(checkboxesValueSeparator(field)) : "",
    required: field.required === "yes"
  }));
};
var toBytes = function toBytes(mBytes) {
  return 1024.0 * 1024 * mBytes;
};
var maxFileSize = function maxFileSize(_ref14) {
  var options = _ref14.options;
  return options && options.maxFileSize && parseFloat(options.maxFileSize) || 0;
};
var fileExtensions = function fileExtensions(_ref15) {
  var options = _ref15.options;
  return options && options.types && options.types.map(function (type) {
    return type.extension;
  }) || [];
};
var validateFileInput = function validateFileInput(field, event) {
  var fileInput = event.target;
  var maxFileSizeMB = maxFileSize(field);
  var maxFileSizeInBytes = toBytes(maxFileSizeMB);
  var sizeMsg = [];
  var extensionMsg = "";
  fileInput.files.forEach(function (file) {
    if (file.size > maxFileSizeInBytes) {
      sizeMsg.push("File too large. Max size is " + maxFileSizeMB + " MB");
    }
    if (fileExtensions(field).some(function (extension) {
      return file.name.endsWith(extension);
    })) {
      extensionMsg = "Unsuporrted file type";
    }
  });
  var msg = [sizeMsg.join("; "), extensionMsg].filter(Boolean).join("; ");
  if (msg) {
    fileInput.setCustomValidity(msg);
  } else {
    fileInput.setCustomValidity("");
  }
};
var FileInput = function FileInput(_ref16) {
  var _field$options;
  var field = _ref16.field;
  var multi = ((_field$options = field.options) === null || _field$options === void 0 ? void 0 : _field$options.multiple) === "yes";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "file-field"
  }, /*#__PURE__*/React.createElement("input", {
    id: fieldId(field),
    className: "file-input",
    type: "file",
    name: multi ? "files[" + field.name + "][]" : "files[" + field.name + "]",
    required: field.required === "yes",
    onChange: function onChange(event) {
      return validateFileInput(field, event);
    },
    multiple: multi
  })), /*#__PURE__*/React.createElement(Hint$1, {
    hint: field.hint
  }));
};
var CgAtcFeeInput = function CgAtcFeeInput(_ref17) {
  var field = _ref17.field,
    defaultValue = _ref17.defaultValue;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h5", {
    className: "lead-form-section-title text-align-center"
  }, field.label + " " + defaultValue), /*#__PURE__*/React.createElement("input", {
    id: fieldId(field),
    type: "hidden",
    name: "data[" + field.name + "]",
    defaultValue: defaultValue,
    required: true
  }));
};
var LabelTag = function LabelTag(_ref18) {
  var field = _ref18.field;
  var required_marker = React.useContext(RequiredMarkerContext);
  return /*#__PURE__*/React.createElement(FormsConsumer, null, function (value) {
    var i18n = value.i18n;
    if (field.required === "yes" && required_marker === "star") {
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: fieldId(field)
      }, field.label + " *");
    }
    if (field.required !== "yes" && required_marker === "optional") {
      return /*#__PURE__*/React.createElement("label", {
        htmlFor: fieldId(field)
      }, field.label, " ", /*#__PURE__*/React.createElement("span", {
        className: "muted"
      }, " ", i18n.optional_label));
    }
    return /*#__PURE__*/React.createElement("label", {
      htmlFor: fieldId(field)
    }, field.label);
  });
};
var Hint$1 = function Hint(_ref19) {
  var hint = _ref19.hint,
    charsLimit = _ref19.charsLimit,
    charsCount = _ref19.charsCount;
  var result = hint || "";
  if (charsLimit) {
    if (result.indexOf("{CHARS_LIMIT}") !== -1) {
      result = result.replace("{CHARS_LIMIT}", charsLimit);
    }
    if (result.indexOf("{CHARS_COUNT}") !== -1) {
      result = result.replace("{CHARS_COUNT}", charsCount);
    }
  }
  return result && /*#__PURE__*/React.createElement("p", {
    className: "hint"
  }, result);
};
var InteractiveHint = function InteractiveHint(_ref20) {
  var field = _ref20.field;
  var _field$interactive_hi = field.interactive_hint,
    id = _field$interactive_hi.id,
    label = _field$interactive_hi.label,
    link = _field$interactive_hi.link,
    target = _field$interactive_hi.target,
    rel = _field$interactive_hi.rel,
    className = _field$interactive_hi.className;
  if (!link || !label) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    className: className,
    id: id || "",
    target: target,
    rel: rel
  }, label);
};
var Inputs = {
  textarea: TextArea$1,
  select: SelectInput,
  file: FileInput,
  date: DateInput,
  text: Input$2,
  email: EmailInput,
  url: Input$2,
  country: CountryInput,
  checkboxes: CheckBoxListInput
};
var InputTag = function InputTag(_ref21) {
  var field = _ref21.field,
    defaultValue = _ref21.defaultValue,
    lockable = _ref21.lockable,
    mandatoryLockable = _ref21.mandatoryLockable;
  var Component = Inputs[field.type];
  if (Component) {
    return /*#__PURE__*/React.createElement(Component, {
      field: field,
      defaultValue: defaultValue,
      lockable: lockable,
      mandatoryLockable: mandatoryLockable
    });
  }
  throw "Unknown field type: " + field.type;
};
var FormInput = function FormInput(_ref22) {
  var field = _ref22.field,
    defaultValue = _ref22.defaultValue,
    lockable = _ref22.lockable,
    mandatoryLockable = _ref22.mandatoryLockable;
  if (field.type === "hidden") {
    return /*#__PURE__*/React.createElement(HiddenInput, {
      field: field,
      defaultValue: defaultValue
    });
  } else if (field.type === "cg_atc_fee") {
    return /*#__PURE__*/React.createElement(CgAtcFeeInput, {
      field: field,
      defaultValue: defaultValue
    });
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-field-wrapper " + (field.required === "yes" ? "required" : "")
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        justifyContent: "space-between",
        flexWrap: "wrap"
      }
    }, /*#__PURE__*/React.createElement(LabelTag, {
      field: field
    }), field.interactive_hint && /*#__PURE__*/React.createElement(InteractiveHint, {
      field: field
    })), /*#__PURE__*/React.createElement(InputTag, {
      field: field,
      defaultValue: defaultValue,
      lockable: lockable,
      mandatoryLockable: mandatoryLockable
    }));
  }
};
var determineDisabledSubmit = function determineDisabledSubmit(form, captchaSuccess, defaults, mandatoryLockables) {
  var email = defaults.email;
  var disableSubmit = email ? form.alwaysShowCaptcha && !captchaSuccess : (form.show_captcha || form.alwaysShowCaptcha) && !captchaSuccess;
  var mandatoryLockablesMissing = form.fields.some(function (f) {
    if (!mandatoryLockables.includes(f.name)) {
      return false;
    }
    var defaultValue = defaults[f.name];
    return !defaultValue;
  });
  return disableSubmit || mandatoryLockablesMissing;
};
var shouldShowCaptcha = function shouldShowCaptcha(form, defaultValues) {
  return form.alwaysShowCaptcha || form.show_captcha && !defaultValues.email;
};
var InactiveForm = function InactiveForm() {
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-component"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-align-center"
  }, "This form is no longer active.")));
};
function formAction(form) {
  if (form.submissionType === "artwork") {
    return "/forms/" + form.id + "/artwork";
  }
  return "/forms/" + form.id + "/submit";
}
var ActiveForm$1 = function ActiveForm(_ref) {
  var form = _ref.form,
    country = _ref.country,
    fieldsDistribution = _ref.fieldsDistribution;
  var _useState = useState(false),
    captchaSuccess = _useState[0],
    setCaptchaSuccess = _useState[1];
  return /*#__PURE__*/React.createElement(FormsConsumer, null, function (value) {
    var default_values = value.default_values,
      default_privacy_html = value.default_privacy_html,
      lockables = value.lockables,
      mandatory_lockables = value.mandatory_lockables;
    var disableSubmit = determineDisabledSubmit(form, captchaSuccess, default_values, mandatory_lockables);
    return /*#__PURE__*/React.createElement("form", {
      method: "post",
      encType: "multipart/form-data",
      acceptCharset: "utf-8",
      id: "form-" + form.id,
      action: formAction(form),
      className: "form-validation lead-form",
      onSubmit: function onSubmit(_e) {
        trackFormSubmit("Raketa", form.id, form.name);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "lead-capture-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "lead-form-cols-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row-lead-form"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(FormFields, {
      form: form,
      defaultValues: default_values,
      fieldsDistribution: fieldsDistribution,
      lockables: lockables,
      mandatoryLockables: mandatory_lockables
    })))))), /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-align-center"
    }, /*#__PURE__*/React.createElement(SubscribeField, {
      form: form
    }), shouldShowCaptcha(form, default_values) && /*#__PURE__*/React.createElement(FormCaptcha$1, {
      onChange: function onChange(captchaSuccess) {
        return setCaptchaSuccess(captchaSuccess);
      }
    }), /*#__PURE__*/React.createElement(PrivacyField, {
      form: form,
      defaultHtml: default_privacy_html
    }), /*#__PURE__*/React.createElement(GeoIpCountryField, {
      country: country
    }), /*#__PURE__*/React.createElement(SubmitButton, {
      form: form,
      disableSubmit: disableSubmit
    }))));
  });
};
var FormFields = function FormFields(_ref2) {
  var form = _ref2.form,
    defaultValues = _ref2.defaultValues,
    lockables = _ref2.lockables,
    mandatoryLockables = _ref2.mandatoryLockables,
    fieldsDistribution = _ref2.fieldsDistribution;
  if (fieldsDistribution.length === 0) {
    return /*#__PURE__*/React.createElement(Fields, {
      form: form,
      defaultValues: defaultValues,
      lockables: lockables,
      mandatoryLockables: mandatoryLockables
    });
  } else {
    return /*#__PURE__*/React.createElement(DistributedFields, {
      form: form,
      defaultValues: defaultValues,
      fieldsDistribution: fieldsDistribution,
      lockables: lockables,
      mandatoryLockables: mandatoryLockables
    });
  }
};
var DistributedFields = function DistributedFields(_ref3) {
  var form = _ref3.form,
    defaultValues = _ref3.defaultValues,
    lockables = _ref3.lockables,
    mandatoryLockables = _ref3.mandatoryLockables,
    fieldsDistribution = _ref3.fieldsDistribution;
  return fieldsDistribution.map(function (distribution) {
    if (distribution.type === "1_field") {
      var field = form.fields.find(function (f) {
        return f.name === distribution.field_1;
      });
      return field && /*#__PURE__*/React.createElement("div", {
        key: field.id,
        className: "col-12"
      }, /*#__PURE__*/React.createElement(FormInput, {
        field: field,
        defaultValue: defaultValues[field.name],
        lockable: lockables.includes(field.name),
        mandatoryLockable: mandatoryLockables.includes(field.name)
      }));
    }
    if (distribution.type === "2_fields") {
      var fieldOne = form.fields.find(function (f) {
        return f.name === distribution.field_1;
      });
      var fieldTwo = form.fields.find(function (f) {
        return f.name === distribution.field_2;
      });
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: distribution.id
      }, fieldOne && /*#__PURE__*/React.createElement("div", {
        key: fieldOne.id,
        className: "col-6"
      }, /*#__PURE__*/React.createElement(FormInput, {
        field: fieldOne,
        defaultValue: defaultValues[fieldOne.name],
        lockable: lockables.includes(fieldOne.name),
        mandatoryLockable: mandatoryLockables.includes(fieldOne.name)
      })), fieldTwo && /*#__PURE__*/React.createElement("div", {
        key: fieldTwo.id,
        className: "col-6"
      }, /*#__PURE__*/React.createElement(FormInput, {
        field: fieldTwo,
        defaultValue: defaultValues[fieldTwo.name],
        lockable: lockables.includes(fieldTwo.name),
        mandatoryLockable: mandatoryLockables.includes(fieldTwo.name)
      })));
    }
    if (distribution.type === "section_title") {
      return /*#__PURE__*/React.createElement("div", {
        key: distribution.id,
        className: "col-12"
      }, /*#__PURE__*/React.createElement("h5", {
        className: "lead-form-section-title text-align-center"
      }, distribution.field_1));
    }
    if (distribution.type === "text_area") {
      return /*#__PURE__*/React.createElement("div", {
        key: distribution.id,
        className: "col-12"
      }, /*#__PURE__*/React.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: distribution.field_1
        }
      }));
    }
    if (distribution.type === "cookies_check") {
      if (navigator && !navigator.cookieEnabled) {
        return /*#__PURE__*/React.createElement("div", {
          key: distribution.id,
          className: "col-12"
        }, /*#__PURE__*/React.createElement("h5", {
          className: "lead-form-section-title text-align-center error"
        }, distribution.field_1));
      } else {
        return null;
      }
    }
    if (distribution.type === "lockables_warning") {
      var showWarning = mandatoryLockables.some(function (lockable) {
        var field = form.fields.find(function (f) {
          return f.name === lockable;
        });
        return !!field && !defaultValues[field.name];
      });
      if (showWarning) {
        return /*#__PURE__*/React.createElement("div", {
          key: distribution.id,
          className: "col-12"
        }, /*#__PURE__*/React.createElement("h5", {
          className: "lead-form-section-title text-align-center error"
        }, distribution.field_1));
      } else {
        return null;
      }
    }
    return null;
  });
};
var Fields = function Fields(_ref4) {
  var form = _ref4.form,
    defaultValues = _ref4.defaultValues,
    lockables = _ref4.lockables,
    mandatoryLockables = _ref4.mandatoryLockables;
  return form.fields.map(function (field, idx) {
    if (field.type === "hidden") {
      return /*#__PURE__*/React.createElement(FormInput, {
        key: idx,
        field: field,
        defaultValue: defaultValues[field.name],
        lockable: lockables.includes(field.name),
        mandatoryLockable: mandatoryLockables.includes(field.name)
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: field.type === "textarea" ? "col-12" : "col-6"
      }, /*#__PURE__*/React.createElement(FormInput, {
        field: field,
        defaultValue: defaultValues[field.name],
        lockable: lockables.includes(field.name),
        mandatoryLockable: mandatoryLockables.includes(field.name)
      }));
    }
  });
};
var SubscribeField = function SubscribeField(_ref5) {
  var form = _ref5.form;
  return form.show_subscribe && /*#__PURE__*/React.createElement("p", {
    className: "spacing-bottom-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "lead-form-cols-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    className: "checkbox-style"
  }, /*#__PURE__*/React.createElement("input", {
    id: "subscribe",
    name: "data[subscribe]",
    type: "checkbox",
    value: "1"
  }), /*#__PURE__*/React.createElement("span", {
    className: "label-checkbox"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label-text"
  }, "Send me exclusive offers and newsletters")))));
};
var FormCaptcha$1 = function FormCaptcha(_ref6) {
  var onChange = _ref6.onChange;
  var _useState2 = useState(""),
    captchaResult = _useState2[0],
    setCaptchaResult = _useState2[1];
  var _useState3 = useState(""),
    requestId = _useState3[0],
    setRequestId = _useState3[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom-sm",
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Captcha, {
    verifyCallback: function verifyCallback(status, captchaId, response) {
      onChange(status);
      setCaptchaResult(response);
      setRequestId(captchaId);
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "g-req-id",
    value: requestId
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "g-recaptcha-response",
    value: captchaResult
  }));
};
var PrivacyField = function PrivacyField(_ref7) {
  var form = _ref7.form,
    defaultHtml = _ref7.defaultHtml;
  if (!form.show_privacy) {
    return null;
  }
  if (form.disclaimer) {
    return /*#__PURE__*/React.createElement("div", {
      className: "spacing-bottom-sm"
    }, parseMarkdown(form.disclaimer));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "spacing-bottom-sm"
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: defaultHtml
      }
    }));
  }
};
var GeoIpCountryField = function GeoIpCountryField(_ref8) {
  var country = _ref8.country;
  return /*#__PURE__*/React.createElement("input", {
    id: "geoip_country",
    name: "data[geoip_country]",
    type: "hidden",
    value: country
  });
};
var buttonClass$1 = function buttonClass(_ref9) {
  var type = _ref9.type;
  return {
    primary: "btn-active-dark",
    secondary: "btn-passive-light",
    text: "btn-text"
  }[type];
};
var SubmitButton = function SubmitButton(_ref10) {
  var form = _ref10.form,
    disableSubmit = _ref10.disableSubmit;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-align-center"
  }, /*#__PURE__*/React.createElement("span", {
    className: "button-description-wrapper"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: disableSubmit,
    className: buttonClass$1(form.submit_button)
  }, form.submit_button.label), form.submit_button.description && /*#__PURE__*/React.createElement("span", {
    className: "button-description"
  }, /*#__PURE__*/React.createElement("br", null), form.submit_button.description)));
};
var SimpleForm$1 = function (props) {
  var form = props.form,
    fieldsDistribution = props.fieldsDistribution;
  return /*#__PURE__*/React.createElement(GeoIpContext.Consumer, null, function (value) {
    var country = value.country;
    return form.active ? /*#__PURE__*/React.createElement(ActiveForm$1, {
      form: form,
      country: country,
      fieldsDistribution: fieldsDistribution
    }) : /*#__PURE__*/React.createElement(InactiveForm, null);
  });
};
var SimpleFormWrapper = function SimpleFormWrapper(props) {
  var formId = props.formId;
  return /*#__PURE__*/React.createElement(Query, {
    query: FORM,
    variables: {
      input: {
        id: formId
      }
    }
  }, function (_ref) {
    var error = _ref.error,
      loading = _ref.loading,
      data = _ref.data;
    if (error) return "Error! " + error.message;
    var form = data.form;
    return /*#__PURE__*/React.createElement(SimpleFormPlaceholder, {
      ready: loading || !form,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(SimpleForm$1, _extends({
          form: form
        }, props));
      }
    });
  });
};
var roundBtn = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundSize: "40%",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  border: "none",
  borderRadius: "50%",
  width: "25px",
  height: "25px",
  color: "#fff"
};
var delBtn = _extends({
  backgroundImage: "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxNHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCAxNCAxNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT54LTI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIGlkPSJ4LTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cGF0aCBkPSJNMTIsMCBMMCwxMiIgaWQ9IlBhdGgiPjwvcGF0aD4gICAgICAgICAgICA8cGF0aCBkPSJNMCwwIEwxMiwxMiIgaWQ9IlBhdGgiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==)",
  backgroundColor: "#cc3333"
}, roundBtn);
var addRowBtn = {
  margin: 0,
  boxSizing: "border-box",
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  lineHeight: "1.5",
  fontWeight: "normal",
  border: "0",
  overflow: "visible",
  cursor: "pointer",
  color: "#fff",
  backgroundColor: "rgb(0, 187, 102)",
  display: "inline-block",
  fontSize: "12px",
  padding: "4.8px 11.2px",
  marginRight: "8px",
  borderRadius: "3px"
};
var TYPE_OPTIONS = [["1_field", "1 Column"], ["2_fields", "2 Columns"], ["section_title", "Section Title"], ["text_area", "Text Area"], ["cookies_check", "Cookies Check"], ["lockables_warning", "Mandatory locked fields warning - if any empty"]];
var randomNumber = function randomNumber() {
  return Math.floor(Math.random() * 1000000);
};
var rowFactory = function rowFactory() {
  return {
    id: randomNumber(),
    type: TYPE_OPTIONS[0][0],
    field_1: "",
    field_2: ""
  };
};
var FieldOne = function FieldOne(_ref) {
  var field = _ref.field,
    _onChange = _ref.onChange,
    formFieldsOptions = _ref.formFieldsOptions;
  return /*#__PURE__*/React.createElement(React.Fragment, null, (field.type === "section_title" || field.type === "cookies_check" || field.type === "lockables_warning") && /*#__PURE__*/React.createElement(TextInput, {
    label: "Section title",
    onChange: function onChange(value) {
      return _onChange("field_1", value);
    },
    value: field.field_1
  }), field.type === "text_area" && /*#__PURE__*/React.createElement(RTE, {
    label: "Text",
    onChange: function onChange(value) {
      return _onChange("field_1", value);
    },
    value: field.field_1
  }), (field.type === "2_fields" || field.type === "1_field") && /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Field 1",
    options: formFieldsOptions,
    value: field.field_1,
    onChange: function onChange(value) {
      return _onChange("field_1", value);
    }
  }));
};
var FieldTwo = function FieldTwo(_ref2) {
  var field = _ref2.field,
    _onChange2 = _ref2.onChange,
    formFieldsOptions = _ref2.formFieldsOptions;
  return /*#__PURE__*/React.createElement(React.Fragment, null, field.type === "2_fields" && /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Field 2",
    options: formFieldsOptions,
    value: field.field_2,
    onChange: function onChange(value) {
      return _onChange2("field_2", value);
    }
  }));
};
var TableRow = function TableRow(_ref3) {
  var field = _ref3.field,
    _onChange3 = _ref3.onChange,
    onDelete = _ref3.onDelete,
    formFieldsOptions = _ref3.formFieldsOptions;
  return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Type",
    options: TYPE_OPTIONS,
    value: field.type,
    onChange: function onChange(value) {
      return _onChange3("type", value);
    }
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FieldOne, {
    field: field,
    onChange: _onChange3,
    formFieldsOptions: formFieldsOptions
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FieldTwo, {
    field: field,
    onChange: _onChange3,
    formFieldsOptions: formFieldsOptions
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return onDelete();
    },
    style: delBtn
  })));
};
var FieldsDistributor = /*#__PURE__*/function (_React$Component) {
  function FieldsDistributor(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleAddRow = function () {
      var fields = _this.state.fields;
      var newField = rowFactory();
      var newFields = [].concat(fields, [newField]);
      _this.setState({
        fields: newFields
      }, function () {
        return _this.notifyChange();
      });
    };
    _this.handleRemoveRow = function (id) {
      var fields = _this.state.fields;
      var newFields = fields.filter(function (oldField) {
        return oldField.id !== id;
      });
      _this.setState({
        fields: newFields
      }, function () {
        return _this.notifyChange();
      });
    };
    _this.state = {
      fields: props.value
    };
    return _this;
  }
  _inheritsLoose(FieldsDistributor, _React$Component);
  var _proto = FieldsDistributor.prototype;
  _proto.notifyChange = function notifyChange() {
    var fields = this.state.fields;
    if (this.props.onChange) this.props.onChange(fields);
  };
  _proto.updateField = function updateField(key, value, id) {
    var _extends2,
      _this2 = this;
    var fields = this.state.fields;
    var field = fields.find(function (f) {
      return f.id === id;
    });
    var newField = _extends({}, field, (_extends2 = {}, _extends2[key] = value, _extends2));
    var newFields = fields.map(function (f) {
      return f.id === id ? newField : f;
    });
    this.setState({
      fields: newFields
    }, function () {
      return _this2.notifyChange();
    });
  };
  _proto.render = function render() {
    var _this3 = this;
    var fields = this.state.fields;
    var form = this.props.form;
    return /*#__PURE__*/React.createElement("div", {
      className: "fields-builder"
    }, /*#__PURE__*/React.createElement(Label$2, null, "Fields"), /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, fields.map(function (field) {
      return /*#__PURE__*/React.createElement(TableRow, {
        key: field.id,
        field: field,
        onChange: function onChange(key, value) {
          return _this3.updateField(key, value, field.id);
        },
        onDelete: function onDelete() {
          return _this3.handleRemoveRow(field.id);
        },
        formFieldsOptions: form.fields.map(function (field) {
          return [field.name, field.label];
        })
      });
    })), /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: this.handleAddRow,
      style: addRowBtn
    }, "Add row"))))));
  };
  return FieldsDistributor;
}(React.Component);
FieldsDistributor.defaultProps = {
  value: []
};
var FieldsBuilder = function FieldsBuilder(_ref4) {
  var formId = _ref4.formId,
    onChange = _ref4.onChange,
    value = _ref4.value;
  return /*#__PURE__*/React.createElement(Query, {
    query: FORM,
    variables: {
      input: {
        id: formId
      }
    }
  }, function (_ref5) {
    var error = _ref5.error,
      loading = _ref5.loading,
      data = _ref5.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var form = data.form;
    return /*#__PURE__*/React.createElement(FieldsDistributor, {
      form: form,
      value: value,
      onChange: onChange
    });
  });
};
var Widget$M = function Widget(props) {
  var formId = props.formId,
    containerSettings = props.containerSettings,
    _props$required_marke = props.required_marker,
    required_marker = _props$required_marke === void 0 ? "star" : _props$required_marke;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "lead-capture-form form-vertical-space",
    settings: containerSettings
  }, formId ? /*#__PURE__*/React.createElement(RequiredMarkerContext.Provider, {
    value: required_marker
  }, /*#__PURE__*/React.createElement(SimpleFormWrapper, props)) : /*#__PURE__*/React.createElement("h2", null, "Simple From: select a form"));
};
var Config$M = {
  title: "Simple Form",
  category: "Forms"
};
var Defaults$M = {
  formId: "",
  fieldsDistribution: [],
  required_marker: "star",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$M = function Admin(_, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormPicker, {
    value: settings.formId,
    onChange: function onChange(value) {
      return _onChange("formId", value);
    }
  }), settings.formId && /*#__PURE__*/React.createElement(FieldsBuilder, {
    value: settings.fieldsDistribution,
    onChange: function onChange(value) {
      return _onChange("fieldsDistribution", value);
    },
    formId: settings.formId
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Required fields indicator",
    options: [["star", "Show stars next to labels"], ["optional", "Mark only optional fields"]],
    value: settings.required_marker,
    onChange: function onChange(value) {
      return _onChange("required_marker", value);
    }
  }));
};
var SimpleFormWidget = {
  __proto__: null,
  Widget: Widget$M,
  Admin: Admin$M,
  Config: Config$M,
  Defaults: Defaults$M
};
var chooseImageVariant = function chooseImageVariant(imageVariant) {
  if (imageVariant === "original") {
    return "original";
  }
  return "simple_image_slider";
};
var getVariant = function getVariant(variant) {
  if (variant === "large_slider") return "col-12";
  if (variant === "small_slider") return "shift-2";
  return variant;
};
var Widget$N = function Widget(_ref) {
  var list = _ref.list,
    variant = _ref.variant,
    imageVariant = _ref.imageVariant,
    autoRotate = _ref.autoRotate,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "simple-gallery simple-image-slider"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: getVariant(variant)
  }, /*#__PURE__*/React.createElement(Slider, {
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next.icon-arrow-right",
      prevEl: ".swiper-button-prev.icon-arrow-left"
    },
    autoplay: autoRotate !== "off" ? {
      delay: autoRotate
    } : false,
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 0,
    paginationClickable: true,
    rebuildOnUpdate: true,
    loop: true
  }, list.map(function (_ref2) {
    var id = _ref2.id,
      image = _ref2.image,
      description = _ref2.description;
    return /*#__PURE__*/React.createElement("div", {
      key: id,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement("figure", null, /*#__PURE__*/React.createElement(Img, {
      src: image,
      variant: chooseImageVariant(imageVariant)
    }), /*#__PURE__*/React.createElement("figcaption", null, description)));
  })))))));
};
var Config$N = {
  title: "Simple Image Slider",
  category: "Sliders"
};
var Defaults$N = {
  list: [{
    id: 1,
    image: imagePlaceholder("1140x769"),
    description: "Lorem ipsum dolor"
  }, {
    id: 2,
    image: imagePlaceholder("1140x769"),
    description: "Lorem ipsum dolor"
  }],
  variant: "large_slider",
  imageVariant: "optimized",
  autoRotate: "off",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ThumbField$1 = function ThumbField(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }));
};
ThumbField$1.defaultProps = {
  settings: {}
};
var Admin$N = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["col-12", "Full width"], ["col-8", "8 columns"], ["col-10", "10 columns"], ["shift-1", "Shift 1"], ["shift-2", "Shift 2"], ["shift-3", "Shift 3"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Image Variant",
    options: [["optimized", "Optimized"], ["original", "Original"]],
    value: settings.imageVariant,
    onChange: function onChange(value) {
      return _onChange("imageVariant", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Autoplay",
    options: [["off", "Off"], ["3000", "3s"], ["4000", "4s"], ["5000", "5s"]],
    value: settings.autoRotate,
    onChange: function onChange(value) {
      return _onChange("autoRotate", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ThumbField$1, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    primaryField: "id",
    template: {
      image: imagePlaceholder("1140x769"),
      description: "Lorem ipsum dolor"
    }
  }));
};
var SimpleGalleryWidget = {
  __proto__: null,
  Widget: Widget$N,
  Admin: Admin$N,
  Config: Config$N,
  Defaults: Defaults$N
};
var signleImageVariant = {
  large_image: "",
  medium_image: "col-shift-1",
  small_image: "col-shift-2",
  extra_small_image: "col-shift-3"
};
var Widget$O = function Widget(_ref) {
  var image = _ref.image,
    variant = _ref.variant,
    _ref$image_size = _ref.image_size,
    image_size = _ref$image_size === void 0 ? "full_width_original" : _ref$image_size,
    author = _ref.author,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "" + signleImageVariant[variant]
  }, /*#__PURE__*/React.createElement("figure", {
    className: "image-caption"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: image_size
  }), author !== "" ? /*#__PURE__*/React.createElement("figcaption", null, author) : ""))));
};
var Config$O = {
  title: "Single Image",
  category: "Image"
};
var Defaults$O = {
  image: imagePlaceholder("1410x800"),
  variant: "large_image",
  image_size: "full_width_original",
  author: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$O = {
  image: {
    type: "custom",
    component: ImagePicker
  },
  image_size: {
    type: "select",
    options: [["full_width_original", "Full-width"], ["original", "Original"]]
  },
  variant: {
    type: "select",
    options: [["large_image", "Large Image (12 cols)"], ["medium_image", "Medium Image (10 cols - shift-1)"], ["small_image", "Small Image (8 cols - shift-2)"], ["extra_small_image", "Extra Small Image (6 cols - shift-3)"]]
  },
  author: {
    type: "text",
    label: "Credits"
  }
};
var SingleImageWidget = {
  __proto__: null,
  Widget: Widget$O,
  Admin: Admin$O,
  Config: Config$O,
  Defaults: Defaults$O
};
var IconsPicker = /*#__PURE__*/function (_React$Component) {
  function IconsPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      value: _this.props.value || []
    };
    return _this;
  }
  _inheritsLoose(IconsPicker, _React$Component);
  var _proto = IconsPicker.prototype;
  _proto.handleChange = function handleChange(value) {
    this.setState({
      value: value
    });
    this.props.onChange(value);
  };
  _proto.render = function render() {
    var _this2 = this;
    var value = this.state.value;
    return /*#__PURE__*/React.createElement(GroupCheckbox, {
      checkboxes: [["facebook", "Facebook"], ["linkedIn", "LinkedIn"], ["mail", "Mail"]],
      label: "Icons",
      onChange: function onChange(value) {
        return _this2.handleChange(value);
      },
      value: value
    });
  };
  return IconsPicker;
}(React.Component);
var Widget$P = function Widget(_ref) {
  var icons = _ref.icons,
    subject = _ref.subject,
    body = _ref.body,
    title = _ref.title,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "social-bar-widget text-center"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "title"
  }, /*#__PURE__*/React.createElement("strong", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "social-links"
  }, /*#__PURE__*/React.createElement(PageUrlConsumer, null, function (currentUrl) {
    return icons.map(function (icon, idx) {
      if (icon === "facebook") return /*#__PURE__*/React.createElement(A, {
        href: "https://facebook.com/sharer/sharer.php?u=" + currentUrl,
        className: "icon-facebook",
        target: "_blank",
        key: idx
      });
      if (icon === "twitter") return /*#__PURE__*/React.createElement(A, {
        href: "https://twitter.com/intent/tweet?url=" + currentUrl,
        className: "x-icon dark-logo no-hover",
        target: "_blank",
        key: idx
      });
      if (icon === "linkedIn") return /*#__PURE__*/React.createElement(A, {
        href: "https://www.linkedin.com/shareArticle?mini=true&url=" + currentUrl,
        className: "icon-linkedin",
        target: "_blank",
        key: idx
      });
      if (icon === "mail") return /*#__PURE__*/React.createElement(A, {
        href: "mailto:?subject=" + subject + "&body=" + body + "%0D%0A%0D%0A" + currentUrl,
        className: "icon-mail",
        key: idx
      });
    });
  }))));
};
var Config$P = {
  title: "Social Share Bar",
  category: "Misc"
};
var Defaults$P = {
  icons: ["facebook", "twitter", "linkedIn", "mail"],
  subject: "",
  body: "",
  title: "Share this page",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$P = {
  title: {
    type: "text"
  },
  icons: {
    type: "custom",
    component: IconsPicker
  },
  subject: {
    type: "text"
  },
  body: {
    type: "custom",
    component: RTE
  }
};
var SocialShareBarWidget = {
  __proto__: null,
  Widget: Widget$P,
  Admin: Admin$P,
  Config: Config$P,
  Defaults: Defaults$P
};
var Widget$Q = function Widget(_ref) {
  var containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "spacer",
    settings: containerSettings
  });
};
var Config$Q = {
  deprecated: true,
  title: "Spacing",
  category: "Simple"
};
var Defaults$Q = {
  containerSettings: {
    spacing: "none"
  }
};
var SpacingWidget = {
  __proto__: null,
  Widget: Widget$Q,
  Config: Config$Q,
  Defaults: Defaults$Q
};
var SpotlightNormalMeta = function SpotlightNormalMeta(_ref) {
  var tag_link = _ref.tag_link,
    tag_label = _ref.tag_label,
    date = _ref.date,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement("div", {
    className: "meta"
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: icon,
    variant: "original"
  })), !icon && /*#__PURE__*/React.createElement("p", {
    className: "meta"
  }, /*#__PURE__*/React.createElement(A, {
    href: tag_link,
    className: "category"
  }, tag_label), date !== "" ? /*#__PURE__*/React.createElement("time", {
    dateTime: date
  }, date) : ""));
};
var SpotlightNormal = function SpotlightNormal(_ref) {
  var variant = _ref.variant,
    image = _ref.image,
    icon = _ref.icon,
    title = _ref.title,
    sub_title = _ref.sub_title,
    tag_label = _ref.tag_label,
    tag_link = _ref.tag_link,
    date = _ref.date,
    description = _ref.description,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings,
    className: "spotlight " + (variant === "image_left" ? "spotlight-revesed" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spotlight-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spotlight-image"
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: image,
    variant: "magazine_spotlight"
  })), /*#__PURE__*/React.createElement("div", {
    className: "spotlight-desc-wrapper"
  }, tag_link !== "" || icon ? /*#__PURE__*/React.createElement(SpotlightNormalMeta, {
    tag_link: tag_link,
    tag_label: tag_label,
    date: date,
    icon: icon
  }) : "", /*#__PURE__*/React.createElement("h3", {
    className: "spotlight-title"
  }, title), /*#__PURE__*/React.createElement("h5", {
    className: "spotlight-sub-title"
  }, sub_title), /*#__PURE__*/React.createElement("div", {
    className: "spotlight-desc"
  }, parseMarkdown(description)), /*#__PURE__*/React.createElement("div", {
    className: "buttons-wrapper"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1
  }), button_2.label && button_2.link && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2
  }))))));
};
var SpotlightAccentMeta = function SpotlightAccentMeta(_ref) {
  var tag_link = _ref.tag_link,
    tag_label = _ref.tag_label,
    date = _ref.date,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement(React.Fragment, null, icon && /*#__PURE__*/React.createElement("div", {
    className: "meta"
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: icon,
    variant: "original"
  })), !icon && /*#__PURE__*/React.createElement("h6", {
    className: "meta meta-top"
  }, /*#__PURE__*/React.createElement(A, {
    href: tag_link,
    className: "category"
  }, tag_label), date !== "" ? /*#__PURE__*/React.createElement("time", null, date) : ""));
};
var SpotlightAccent = function SpotlightAccent(_ref) {
  var image = _ref.image,
    icon = _ref.icon,
    title = _ref.title,
    sub_title = _ref.sub_title,
    tag_link = _ref.tag_link,
    tag_label = _ref.tag_label,
    date = _ref.date,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "spotlight-full-width"
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: image,
    variant: "full_width_original"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spotlight-inner"
  }, tag_link !== "" || icon ? /*#__PURE__*/React.createElement(SpotlightAccentMeta, {
    tag_link: tag_link,
    tag_label: tag_label,
    date: date,
    icon: icon
  }) : "", /*#__PURE__*/React.createElement("h3", {
    className: "spotlight-title"
  }, title), /*#__PURE__*/React.createElement("h5", {
    className: "spotlight-sub-title"
  }, sub_title), /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1
  }), button_2.label !== "" && button_2.link !== "" ? /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2
  }) : null)));
};
var Widget$R = function Widget(_ref) {
  var image = _ref.image,
    icon = _ref.icon,
    variant = _ref.variant,
    design = _ref.design,
    title = _ref.title,
    sub_title = _ref.sub_title,
    description = _ref.description,
    tag_label = _ref.tag_label,
    tag_link = _ref.tag_link,
    date = _ref.date,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement("div", null, design === "normal" ? /*#__PURE__*/React.createElement(SpotlightNormal, {
    variant: variant,
    image: image,
    icon: icon,
    title: title,
    sub_title: sub_title,
    tag_label: tag_label,
    tag_link: tag_link,
    date: date,
    description: description,
    button_1: button_1,
    button_2: button_2,
    containerSettings: containerSettings
  }) : /*#__PURE__*/React.createElement(SpotlightAccent, {
    image: image,
    icon: icon,
    title: title,
    sub_title: sub_title,
    tag_link: tag_link,
    tag_label: tag_label,
    date: date,
    button_1: button_1,
    button_2: button_2,
    containerSettings: containerSettings
  }));
};
var Config$R = {
  title: "Spotlight Image",
  category: "Image + Text"
};
var Defaults$R = {
  image: imagePlaceholder("705x490"),
  icon: imagePlaceholder("40x40"),
  variant: "image_left",
  design: "normal",
  title: "Lorem ipsum dolor sit",
  sub_title: "Lorem ipsum dolor sit amet, consectetur",
  description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Aliquid perspiciatis quae, nemo odit quaerat, delectus sed sapiente repellendus nihil optio.",
  button_1: ButtonSettingsWithDescription.defaults,
  button_2: {},
  tag_label: "",
  tag_link: "",
  date: "",
  containerSettings: {
    theme: "dark",
    spacing: "none"
  }
};
var Admin$Q = {
  image: {
    type: "custom",
    component: ImagePicker
  },
  icon: {
    type: "custom",
    component: ImagePicker
  },
  variant: {
    type: "select",
    options: [["image_left", "Image to the left"], ["image_right", "Image to the right"]],
    label: "Position"
  },
  design: {
    type: "select",
    options: [["normal", "Regular"], ["accented", "Full-width"]]
  },
  title: {
    type: "text"
  },
  sub_title: {
    type: "text"
  },
  description: {
    type: "textarea"
  },
  tag_label: {
    type: "text",
    label: "Tag Label optional"
  },
  tag_link: {
    type: "text",
    label: "Tag Link optional"
  },
  date: {
    type: "text",
    label: "Date optional"
  },
  button_1: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button 1"
  },
  button_2: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button 2"
  }
};
var SpotlightImageWidget = {
  __proto__: null,
  Widget: Widget$R,
  Admin: Admin$Q,
  Config: Config$R,
  Defaults: Defaults$R
};
var thumbClass$1 = function thumbClass(variant) {
  switch (variant) {
    case "3_columns":
      return "previews-3";
    case "4_columns":
      return "previews-4";
    case "6_columns":
      return "previews-6";
    default:
      return "previews-3";
  }
};
var Widget$S = /*#__PURE__*/function (_React$Component) {
  function Widget(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isModalOpen: false,
      currentThumb: _this.props.list[0]
    };
    return _this;
  }
  _inheritsLoose(Widget, _React$Component);
  var _proto = Widget.prototype;
  _proto.handleOpenModal = function handleOpenModal(thumb) {
    this.setState({
      isModalOpen: true,
      currentThumb: thumb
    });
  };
  _proto.render = function render() {
    var _this2 = this;
    var _this$props = this.props,
      list = _this$props.list,
      variant = _this$props.variant,
      containerSettings = _this$props.containerSettings;
    var _this$state = this.state,
      isModalOpen = _this$state.isModalOpen,
      currentThumb = _this$state.currentThumb;
    return /*#__PURE__*/React.createElement(Container$1, {
      settings: containerSettings
    }, /*#__PURE__*/React.createElement("div", {
      className: "square-thumbs"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, list.map(function (thumb, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: thumbClass$1(variant)
      }, thumb.show_dialog === "yes" ? /*#__PURE__*/React.createElement("button", {
        className: "image-wrapper",
        type: "button",
        onClick: function onClick() {
          return _this2.handleOpenModal(thumb);
        }
      }, /*#__PURE__*/React.createElement(Image, {
        loading: "lazy",
        src: thumb.image,
        variant: "mobile_square"
      }), /*#__PURE__*/React.createElement("div", {
        className: "overlay"
      }, thumb.overlay_text ? thumb.overlay_text : "View"), /*#__PURE__*/React.createElement("i", {
        className: "icon-zoom"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "image-wrapper"
      }, /*#__PURE__*/React.createElement(Image, {
        loading: "lazy",
        src: thumb.image,
        variant: "mobile_square"
      })), /*#__PURE__*/React.createElement("div", {
        className: "square-thumb-text"
      }, /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, thumb.name)), /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, parseMarkdown(thumb.description))));
    }), /*#__PURE__*/React.createElement(Modal, {
      title: "",
      open: isModalOpen,
      onClose: function onClose() {
        return _this2.setState({
          isModalOpen: false
        });
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "square-thumb-modal"
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: currentThumb.image,
      variant: "mobile_square"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "name"
    }, currentThumb.name), /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: currentThumb.content
      }
    })))))));
  };
  return Widget;
}(React.Component);
var Defaults$S = {
  list: [{
    content: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    description: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>",
    image: imagePlaceholder("540x540"),
    name: "Thumb 1",
    show_dialog: "yes",
    overlay_text: "View"
  }, {
    content: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    description: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>",
    image: imagePlaceholder("540x540"),
    name: "Thumb 2",
    show_dialog: "yes",
    overlay_text: "View"
  }, {
    content: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
    description: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>",
    image: imagePlaceholder("540x540"),
    name: "Thumb 3",
    show_dialog: "yes",
    overlay_text: "View"
  }],
  variant: "3_columns",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Config$S = {
  title: "Square Thumbs",
  category: "Image + Text"
};
var SquareField = function SquareField(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Name",
    onChange: function onChange(value) {
      return onChangeItem("name", value);
    },
    value: settings.name
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Overlay text",
    onChange: function onChange(value) {
      return onChangeItem("overlay_text", value);
    },
    value: settings.overlay_text
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show Dialog",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.show_dialog,
    onChange: function onChange(value) {
      return onChangeItem("show_dialog", value);
    }
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Content",
    onChange: function onChange(value) {
      return onChangeItem("content", value);
    },
    value: settings.content
  }));
};
var Admin$R = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["3_columns", "3 Columns"], ["4_columns", "4 Columns"], ["6_columns", "6 Columns"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(SquareField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      content: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
      description: "<p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>",
      image: imagePlaceholder("540x540"),
      name: "Thumb 1",
      show_dialog: "yes"
    },
    primaryField: "name"
  }));
};
var SquareThumbsWidget = {
  __proto__: null,
  Widget: Widget$S,
  Admin: Admin$R,
  Config: Config$S,
  Defaults: Defaults$S
};
var MenuItemField$1 = function MenuItemField(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "URL",
    onChange: function onChange(value) {
      return onChangeItem("url", value);
    },
    value: settings.url
  }));
};
MenuItemField$1.defaultProps = {
  settings: {}
};
var AdminFields$1 = function AdminFields(_ref) {
  var items = _ref.items,
    _onChange = _ref.onChange,
    settings = _ref.settings;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return _onChange("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show logo",
    options: [["on_scroll", "On Scroll"], ["permanent", "Always"]],
    value: settings.logo_variant,
    onChange: function onChange(value) {
      return _onChange("logo_variant", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show buttons",
    options: [["on_scroll", "On Scroll"], ["permanent", "Always"]],
    value: settings.show_buttons,
    onChange: function onChange(value) {
      return _onChange("show_buttons", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show logo (mobile)",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.logo_variant_mobile,
    onChange: function onChange(value) {
      return _onChange("logo_variant_mobile", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Logo Link optional",
    onChange: function onChange(value) {
      return _onChange("logo_anchor", value);
    },
    value: settings.logo_anchor
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show search",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.show_search,
    onChange: function onChange(value) {
      return _onChange("show_search", value);
    }
  }), settings.show_search === "yes" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Search URL",
    onChange: function onChange(value) {
      return _onChange("search_url", value);
    },
    value: settings.search_url
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Search placeholder",
    onChange: function onChange(value) {
      return _onChange("search_placeholder", value);
    },
    value: settings.search_placeholder
  })), /*#__PURE__*/React.createElement(List, {
    primaryField: "title",
    template: {
      title: "Item 1",
      url: "link"
    },
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(MenuItemField$1, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(ButtonSettings, {
    button_settings_title: "Button 1",
    value: settings.button_1,
    onChange: function onChange(values) {
      return _onChange("button_1", values);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    button_settings_title: "Button 2",
    value: settings.button_2,
    onChange: function onChange(values) {
      return _onChange("button_2", values);
    }
  }));
};
var ButtonsBar$1 = function ButtonsBar(_ref) {
  var button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    show_buttons = _ref.show_buttons;
  return (button_1.label !== "" || button_2.label !== "") && /*#__PURE__*/React.createElement("div", {
    className: "menu-buttons " + (show_buttons === "permanent" ? "show-buttons" : "")
  }, button_1.label !== "" ? /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1,
    className: "btn-small"
  }) : "", button_2.label !== "" ? /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2,
    className: "btn-small"
  }) : "");
};
ButtonsBar$1.defaultProps = {
  button_2: {}
};
var throttle$1 = function throttle(func, limit) {
  var inThrottle;
  return function () {
    var args = arguments;
    var context = this;
    if (!inThrottle) {
      func.apply(context, args);
      inThrottle = true;
      setTimeout(function () {
        return inThrottle = false;
      }, limit);
    }
  };
};
var getMenuElement$1 = function getMenuElement(menuLinksElement) {
  return menuLinksElement.parentElement.parentElement;
};
var getTargetSections$1 = function getTargetSections(anchorsList) {
  var nodes = [];
  anchorsList.map(function (anchor) {
    return anchor.slice(1);
  }).forEach(function (anchor) {
    var element = document.getElementById(anchor);
    if (anchor !== "top" && element !== null) {
      nodes.push({
        anchor: anchor,
        offset: element.offsetTop
      });
    }
  });
  nodes.sort(function (a, b) {
    if (a.offset > b.offset) {
      return 1;
    }
    if (a.offset === b.offset) {
      return 0;
    }
    if (a.offset < b.offset) {
      return -1;
    }
  });
  return nodes;
};
var setMenuActiveClass$1 = function setMenuActiveClass(anchorId, markActiveSection, anchorsList) {
  var activeAnchor = anchorsList.find(function (item) {
    var itemAnchor = item.slice(1);
    if (anchorId === itemAnchor) return item;
  });
  markActiveSection(activeAnchor);
};
var handleSingleElement$1 = function handleSingleElement(currentOffset, element) {
  if (currentOffset < element.offset) {
    return "";
  } else {
    return element.anchor;
  }
};
var handleMultipleElements$1 = function handleMultipleElements(currentOffset, elements) {
  for (var i = 0; i < elements.length - 1; i++) {
    if (i === elements.length - 2 && currentOffset >= elements[i + 1].offset) {
      return elements[i + 1].anchor;
    }
    if (currentOffset >= elements[i].offset && currentOffset < elements[i + 1].offset) {
      return elements[i].anchor;
    }
  }
  return "";
};
var setActiveSectionEvent$1 = function setActiveSectionEvent(anchorsList, markActiveSection, element) {
  var menuHeight = getMenuElement$1(element).offsetHeight;
  window.addEventListener("scroll", throttle$1(function (_event) {
    var targetSections = getTargetSections$1(anchorsList);
    var currentOffset = window.pageYOffset + 3 * menuHeight;
    if (targetSections.length === 0) {
      setMenuActiveClass$1("", markActiveSection, anchorsList);
    }
    if (targetSections.length === 1) {
      var result = handleSingleElement$1(currentOffset, targetSections[0]);
      setMenuActiveClass$1(result, markActiveSection, anchorsList);
    }
    if (targetSections.length > 1) {
      var _result = handleMultipleElements$1(currentOffset, targetSections);
      setMenuActiveClass$1(_result, markActiveSection, anchorsList);
    }
  }, 100));
};
var LogoMobile$1 = function LogoMobile(_ref) {
  var logo_anchor = _ref.logo_anchor,
    image = _ref.image;
  return /*#__PURE__*/React.createElement("li", {
    className: "submenu-logo-wrapper mobile-link"
  }, /*#__PURE__*/React.createElement(A, {
    href: logo_anchor !== "" ? logo_anchor : "#top",
    className: "submenu-logo",
    style: {
      backgroundImage: "url(" + imageSrc(image, "original") + ")"
    }
  }));
};
var ButtonsBarMobile$1 = function ButtonsBarMobile(_ref) {
  var button_1 = _ref.button_1,
    button_2 = _ref.button_2;
  return (button_1.label !== "" || button_2.label !== "") && /*#__PURE__*/React.createElement(React.Fragment, null, button_1.label && /*#__PURE__*/React.createElement("li", {
    className: "main-menu-link mobile-link"
  }, " ", /*#__PURE__*/React.createElement(A, {
    href: button_1.link
  }, button_1.label)), button_2.label && /*#__PURE__*/React.createElement("li", {
    className: "main-menu-link mobile-link"
  }, " ", /*#__PURE__*/React.createElement(A, {
    href: button_2.link
  }, button_2.label)));
};
var moveToElement$1 = function moveToElement(elementId, menuLinksRef) {
  if (!elementId) {
    return;
  }
  var element = document.getElementById(elementId.replace("#", ""));
  if (!element) {
    return;
  }
  var menuHeight = getMenuElement$1(menuLinksRef).offsetHeight;
  window.scrollTo({
    left: 0,
    top: element.offsetTop - menuHeight
  });
  window.history.replaceState(null, null, elementId);
};
var MenuLinks$1 = function MenuLinks(_ref) {
  var image = _ref.image,
    logo_variant_mobile = _ref.logo_variant_mobile,
    logo_anchor = _ref.logo_anchor,
    list = _ref.list,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    show_search = _ref.show_search,
    onSearchShow = _ref.onSearchShow;
  var _useState = useState(""),
    activeSection = _useState[0],
    setActiveSection = _useState[1];
  var anchorsList = list.filter(function (item) {
    return item.url.charAt(0) == "#";
  }).map(function (item) {
    return item.url;
  });
  var linksWrapperRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    setActiveSectionEvent$1(anchorsList, setActiveSection, linksWrapperRef.current);
  }, []);
  return /*#__PURE__*/React.createElement("ul", {
    className: "menu-cnt",
    ref: linksWrapperRef
  }, image !== "" && logo_variant_mobile === "yes" ? /*#__PURE__*/React.createElement(LogoMobile$1, {
    logo_anchor: logo_anchor,
    image: image
  }) : null, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx,
      className: "main-menu-link"
    }, item.url.startsWith("#") ? /*#__PURE__*/React.createElement(A, {
      href: item.url,
      className: activeSection === item.url ? "active" : "",
      onClick: function onClick(e) {
        e.preventDefault();
        moveToElement$1(item.url, linksWrapperRef.current);
        setActiveSection(item.url);
      }
    }, item.title) : /*#__PURE__*/React.createElement(A, {
      href: item.url
    }, item.title));
  }), /*#__PURE__*/React.createElement(ButtonsBarMobile$1, {
    button_1: button_1,
    button_2: button_2
  }), show_search === "yes" && /*#__PURE__*/React.createElement("li", {
    className: "main-menu-link desktop-search-trigger"
  }, /*#__PURE__*/React.createElement("span", {
    className: "search-trigger-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-search search-trigger",
    onClick: function onClick() {
      return onSearchShow(true);
    }
  }))));
};
var Logo$2 = function Logo(_ref) {
  var logo_anchor = _ref.logo_anchor,
    logo_variant = _ref.logo_variant,
    image = _ref.image;
  return image && /*#__PURE__*/React.createElement("a", {
    href: logo_anchor !== "" ? logo_anchor : "#top",
    className: "submenu-logo " + (logo_variant === "on_scroll" ? "logo-menu-sticky" : ""),
    style: {
      backgroundImage: "url(" + imageSrc(image, "original") + ")"
    }
  });
};
var setSmoothAnimation$1 = function setSmoothAnimation(from, to, time, container) {
  var start = new Date().getTime();
  var timer = setInterval(function () {
    var step = Math.min(1, (new Date().getTime() - start) / time);
    var positionX = from + step * (to - from);
    container.scrollLeft = positionX;
    if (step == 1) clearInterval(timer);
  }, 25);
  container.scrollLeft = from;
};
var setArrowsNavigation$1 = function setArrowsNavigation(menuContainer, setLeftAttowVisibility, setRightAttowVisibility) {
  var menuCnt = menuContainer.getElementsByClassName("menu-cnt").item(0);
  if (menuCnt.scrollWidth > window.innerWidth) setRightAttowVisibility(true);
  menuCnt.addEventListener("scroll", function () {
    if (menuCnt.scrollLeft > 0) setLeftAttowVisibility(true);
    if (menuCnt.scrollLeft === 0) setLeftAttowVisibility(false);
    if (menuCnt.scrollWidth - window.innerWidth === menuCnt.scrollLeft) {
      setRightAttowVisibility(false);
    } else {
      setRightAttowVisibility(true);
    }
  });
};
var setArrowClick$1 = function setArrowClick(menuContainer, scrollPosition, onClick, direction) {
  var linksContainer = menuContainer.getElementsByClassName("menu-cnt").item(0);
  var newScrollPosition = scrollPosition;
  if (direction === "right") newScrollPosition += 100;
  if (direction === "left") newScrollPosition -= 100;
  onClick(newScrollPosition);
  setSmoothAnimation$1(linksContainer.scrollLeft, newScrollPosition, 300, linksContainer);
};
var SubMenuSearch$1 = /*#__PURE__*/function (_React$Component) {
  function SubMenuSearch(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      articles: [],
      q: props.q || "",
      dirty: false
    };
    return _this;
  }
  _inheritsLoose(SubMenuSearch, _React$Component);
  var _proto = SubMenuSearch.prototype;
  _proto.handleProductSearch = function handleProductSearch(q) {
    var _this2 = this;
    var search_url = this.props.search_url;
    this.setState({
      q: q,
      articles: []
    }, function () {
      if (q.length < 3) {
        _this2.setState({
          dirty: false
        });
        return;
      }
      jQuery.get(search_url, {
        q: q
      }, function (articles) {
        _this2.setState({
          articles: articles
        });
        _this2.setState({
          dirty: true
        });
      }, "json");
    });
  };
  _proto.handleGoToArticle = function handleGoToArticle(articleName) {
    var _this$state = this.state,
      articles = _this$state.articles;
    var selectedArticle = articles.find(function (item) {
      return item.title === articleName;
    });
    if (typeof window !== "undefined") window.location.href = selectedArticle.url;
  };
  _proto.handleSubmit = function handleSubmit(e) {
    if (this.state.q === "") {
      e.preventDefault();
    }
  };
  _proto.render = function render() {
    var _this3 = this;
    var _this$props = this.props,
      search_url = _this$props.search_url,
      placeholder = _this$props.placeholder;
    var _this$state2 = this.state,
      q = _this$state2.q,
      articles = _this$state2.articles,
      dirty = _this$state2.dirty;
    var menuStyle = {
      boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
      background: "#fff",
      position: "absolute",
      top: "auto",
      overflow: "auto",
      left: "3em",
      right: "3em",
      color: "#000"
    };
    var itemsLimit = 6;
    var totalItems = articles.length;
    var itemsToRender = articles.slice(0, itemsLimit);
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: function onSubmit(e) {
        return _this3.handleSubmit(e);
      },
      method: "get",
      action: search_url
    }, /*#__PURE__*/React.createElement(Autocomplete, {
      getItemValue: function getItemValue(item) {
        return item.title;
      },
      items: itemsToRender,
      renderMenu: function renderMenu(items, value, style) {
        return /*#__PURE__*/React.createElement("div", {
          style: _extends({}, style, menuStyle)
        }, items, totalItems > itemsLimit && /*#__PURE__*/React.createElement("button", {
          type: "submit",
          className: "btn-text",
          style: {
            paddingLeft: "1em"
          }
        }, "See all results (", totalItems, ")"), totalItems === 0 && dirty === true && /*#__PURE__*/React.createElement("div", {
          style: {
            padding: "1em"
          }
        }, "No results found."));
      },
      renderItem: function renderItem(item, isHighlighted) {
        return /*#__PURE__*/React.createElement("div", {
          key: item.id,
          style: {
            padding: "1em",
            cursor: "pointer",
            background: isHighlighted ? "lightgray" : "#fff"
          }
        }, item.title, " ", /*#__PURE__*/React.createElement("small", {
          className: "category-name",
          style: {
            color: "#aaaab3"
          }
        }, " ", "- ", item.category));
      },
      value: q,
      onChange: function onChange(e) {
        return _this3.handleProductSearch(e.target.value);
      },
      onSelect: function onSelect(articleName) {
        return _this3.handleGoToArticle(articleName);
      },
      inputProps: {
        placeholder: placeholder
      },
      wrapperStyle: {
        display: "inline-block",
        width: "100%"
      },
      menuStyle: menuStyle
    }), /*#__PURE__*/React.createElement("button", {
      type: "submit",
      className: "icon-search"
    }), /*#__PURE__*/React.createElement("input", {
      type: "hidden",
      name: "q",
      value: q
    }));
  };
  return SubMenuSearch;
}(React.Component);
var Search$3 = function Search(_ref) {
  var show_search = _ref.show_search,
    search_url = _ref.search_url,
    search_placeholder = _ref.search_placeholder,
    onSearchShow = _ref.onSearchShow,
    isSearchVisible = _ref.isSearchVisible;
  var searchRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    if (isSearchVisible) searchRef.current.querySelector(".search input").focus();
  });
  return show_search === "yes" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "search-trigger-wrapper mobile-search-trigger"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-search search-trigger",
    onClick: function onClick() {
      return onSearchShow(true);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "search-wrapper",
    ref: searchRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "search"
  }, /*#__PURE__*/React.createElement(SubMenuSearch$1, {
    search_url: search_url,
    q: "",
    placeholder: search_placeholder
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-close search-close",
    onClick: function onClick() {
      return onSearchShow(false);
    }
  }))));
};
var NavigationArrow$1 = function NavigationArrow(_ref) {
  var _onClick = _ref.onClick,
    arrowPosition = _ref.arrowPosition,
    isVisible = _ref.isVisible;
  return /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return _onClick();
    },
    className: "fade-" + arrowPosition + " icon-arrow-" + arrowPosition + " " + (isVisible ? "show" : "")
  });
};
var setObserver$1 = function setObserver(element) {
  if (typeof window.IntersectionObserver !== "function") {
    return;
  }
  new window.IntersectionObserver(function (entries, _observer) {
    for (var _i = 0; _i < entries.length; _i++) {
      var stickyHeader = entries[_i].target.nextSibling;
      stickyHeader.toggleAttribute("stuck", !entries[_i].isIntersecting);
    }
  }, {}).observe(element);
};
var Widget$T = function Widget(_ref) {
  var image = _ref.image,
    logo_variant = _ref.logo_variant,
    list = _ref.list,
    _ref$button_ = _ref.button_1,
    button_1 = _ref$button_ === void 0 ? {} : _ref$button_,
    _ref$button_2 = _ref.button_2,
    button_2 = _ref$button_2 === void 0 ? {} : _ref$button_2,
    _ref$logo_anchor = _ref.logo_anchor,
    logo_anchor = _ref$logo_anchor === void 0 ? "" : _ref$logo_anchor,
    logo_variant_mobile = _ref.logo_variant_mobile,
    show_buttons = _ref.show_buttons,
    show_search = _ref.show_search,
    search_url = _ref.search_url,
    search_placeholder = _ref.search_placeholder,
    containerSettings = _ref.containerSettings;
  var _useState = useState(false),
    isLeftArrowVisible = _useState[0],
    setLeftAttowVisibility = _useState[1];
  var _useState2 = useState(false),
    isRightArrowVisible = _useState2[0],
    setRightAttowVisibility = _useState2[1];
  var _useState3 = useState(0),
    scrollPosition = _useState3[0],
    setScrollPosition = _useState3[1];
  var _useState4 = useState(false),
    isSearchVisible = _useState4[0],
    setSearchVisibe = _useState4[1];
  var menuRef = /*#__PURE__*/React.createRef();
  var markerRef = /*#__PURE__*/React.createRef();
  useEffect(function () {
    setArrowsNavigation$1(menuRef.current, setLeftAttowVisibility, setRightAttowVisibility);
    if (markerRef.current) {
      setObserver$1(markerRef.current);
    }
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: markerRef
  }), /*#__PURE__*/React.createElement("div", {
    className: "menu-outer"
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    ref: menuRef,
    className: "menu sticky-menu " + (isSearchVisible ? "show-search" : "")
  }, /*#__PURE__*/React.createElement(Logo$2, {
    logo_anchor: logo_anchor,
    logo_variant: logo_variant,
    image: image
  }), /*#__PURE__*/React.createElement("nav", {
    className: "" + (list.length === 0 ? "menu-no-links" : "")
  }, /*#__PURE__*/React.createElement(NavigationArrow$1, {
    onClick: function onClick() {
      return setArrowClick$1(menuRef.current, scrollPosition, setScrollPosition, "left");
    },
    arrowPosition: "left",
    isVisible: isLeftArrowVisible
  }), /*#__PURE__*/React.createElement(MenuLinks$1, {
    image: image,
    logo_variant_mobile: logo_variant_mobile,
    logo_anchor: logo_anchor,
    list: list,
    button_1: button_1,
    button_2: button_2,
    show_search: show_search,
    isSearchVisible: isSearchVisible,
    onSearchShow: setSearchVisibe
  }), /*#__PURE__*/React.createElement(NavigationArrow$1, {
    onClick: function onClick() {
      return setArrowClick$1(menuRef.current, scrollPosition, setScrollPosition, "right");
    },
    arrowPosition: "right",
    isVisible: isRightArrowVisible
  }), /*#__PURE__*/React.createElement(ButtonsBar$1, {
    button_1: button_1,
    button_2: button_2,
    show_buttons: show_buttons
  }), /*#__PURE__*/React.createElement(Search$3, {
    show_search: show_search,
    search_url: search_url,
    search_placeholder: search_placeholder,
    isSearchVisible: isSearchVisible,
    onSearchShow: setSearchVisibe
  }))))));
};
var Config$T = {
  title: "Sub Menu",
  category: "Navigation"
};
var Defaults$T = {
  image: imagePlaceholder("200x200"),
  logo_variant: "on_scroll",
  logo_variant_mobile: "yes",
  show_buttons: "on_scroll",
  show_search: "no",
  search_url: "",
  search_placeholder: "",
  list: [{
    id: 1,
    title: "Item 1",
    url: "link"
  }, {
    id: 2,
    title: "Item 2",
    url: "link"
  }, {
    id: 3,
    title: "Item 3",
    url: "link"
  }, {
    id: 4,
    title: "Item 4",
    url: ""
  }],
  button_1: {},
  button_2: {},
  logo_anchor: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$S = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(AdminFields$1, {
    items: items,
    onChange: onChange,
    settings: settings
  });
};
var SubMenuWidget = {
  __proto__: null,
  Widget: Widget$T,
  Admin: Admin$S,
  Config: Config$T,
  Defaults: Defaults$T
};
var _addRowBtn;
var roundBtn$1 = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundSize: "40%",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center",
  border: "none",
  borderRadius: "50%",
  width: "25px",
  height: "25px",
  color: "#fff"
};
var delBtn$1 = _extends({
  backgroundImage: "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxNHB4IiBoZWlnaHQ9IjE0cHgiIHZpZXdCb3g9IjAgMCAxNCAxNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT54LTI8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGcgaWQ9IlBhZ2UtMSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIj4gICAgICAgIDxnIGlkPSJ4LTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEuMDAwMDAwLCAxLjAwMDAwMCkiIHN0cm9rZT0iI0ZGRkZGRiIgc3Ryb2tlLXdpZHRoPSIyIj4gICAgICAgICAgICA8cGF0aCBkPSJNMTIsMCBMMCwxMiIgaWQ9IlBhdGgiPjwvcGF0aD4gICAgICAgICAgICA8cGF0aCBkPSJNMCwwIEwxMiwxMiIgaWQ9IlBhdGgiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==)",
  backgroundColor: "#cc3333"
}, roundBtn$1);
var addBtn = _extends({
  backgroundImage: "url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxNnB4IiBoZWlnaHQ9IjE2cHgiIHZpZXdCb3g9IjAgMCAxNiAxNiIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5wbHVzPC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+ICAgICAgICA8ZyBpZD0icGx1cyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMS4wMDAwMDAsIDEuMDAwMDAwKSIgc3Ryb2tlPSIjRkZGRkZGIiBzdHJva2Utd2lkdGg9IjIiPiAgICAgICAgICAgIDxwYXRoIGQ9Ik03LDAgTDcsMTQiIGlkPSJQYXRoIj48L3BhdGg+ICAgICAgICAgICAgPHBhdGggZD0iTTAsNyBMMTQsNyIgaWQ9IlBhdGgiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==)",
  backgroundColor: "#21ad2e"
}, roundBtn$1);
var addRowBtn$1 = (_addRowBtn = {
  padding: 0,
  margin: 0,
  boxSizing: "border-box",
  fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
  lineHeight: "1.5",
  fontWeight: "normal",
  backgroundColor: "transparent",
  border: "0",
  overflow: "visible",
  cursor: "pointer",
  color: "#fff"
}, _addRowBtn["backgroundColor"] = "rgb(0, 187, 102)", _addRowBtn.display = "inline-block", _addRowBtn.fontSize = "12px", _addRowBtn["padding"] = "4.8px 11.2px", _addRowBtn.marginRight = "8px", _addRowBtn.borderRadius = "3px", _addRowBtn);
var TableBuilder = /*#__PURE__*/function (_React$Component) {
  function TableBuilder(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleAddCol = function () {
      var _this$state = _this.state,
        table = _this$state.table,
        columnsWidth = _this$state.columnsWidth;
      var newTable = table.map(function (row) {
        return [].concat(row, [""]);
      });
      var newcolumnsWidth = [].concat(columnsWidth, [""]);
      _this.setState({
        table: newTable,
        columnsWidth: newcolumnsWidth
      }, function () {
        return _this.notifyChange();
      });
    };
    _this.handleRemoveCol = function (cidx) {
      var table = _this.state.table;
      var newTable = table.map(function (row) {
        return [].concat(row.slice(0, cidx), row.slice(cidx + 1));
      });
      _this.setState({
        table: newTable
      }, function () {
        return _this.notifyChange();
      });
    };
    _this.handleAddRow = function () {
      var table = _this.state.table;
      var firstRow = table[0];
      var newRow = Array.from(Array(firstRow.length).keys()).map(function (_) {
        return "";
      });
      var newTable = [].concat(table, [newRow]);
      _this.setState({
        table: newTable
      }, function () {
        return _this.notifyChange();
      });
    };
    _this.handleRemoveRow = function (ridx) {
      var table = _this.state.table;
      var newTable = [].concat(table.slice(0, ridx), table.slice(ridx + 1));
      _this.setState({
        table: newTable
      }, function () {
        return _this.notifyChange();
      });
    };
    _this.state = {
      table: props.tableContent.table,
      columnsWidth: props.tableContent.columnsWidth
    };
    return _this;
  }
  _inheritsLoose(TableBuilder, _React$Component);
  var _proto = TableBuilder.prototype;
  _proto.handleChangeCell = function handleChangeCell(value, ridx, cidx) {
    var _this2 = this;
    var table = this.state.table;
    var newTable = table.map(function (row, rridx) {
      if (ridx !== rridx) return row;
      return [].concat(row.slice(0, cidx), [value], row.slice(cidx + 1));
    });
    this.setState({
      table: newTable
    }, function () {
      return _this2.notifyChange();
    });
  };
  _proto.hadnleColumnWidthChange = function hadnleColumnWidthChange(value, idx) {
    var _this3 = this;
    var columnsWidth = this.state.columnsWidth;
    var newColumnsWidth = [].concat(columnsWidth.slice(0, idx), [value], columnsWidth.slice(idx + 1));
    this.setState({
      columnsWidth: newColumnsWidth
    }, function () {
      return _this3.notifyChange();
    });
  };
  _proto.notifyChange = function notifyChange() {
    var _this$state2 = this.state,
      table = _this$state2.table,
      columnsWidth = _this$state2.columnsWidth;
    if (this.props.onChange) this.props.onChange({
      table: table,
      columnsWidth: columnsWidth
    });
  };
  _proto.render = function render() {
    var _this4 = this;
    var _this$state3 = this.state,
      table = _this$state3.table,
      columnsWidth = _this$state3.columnsWidth;
    var firstRow = table[0];
    return /*#__PURE__*/React.createElement("div", {
      className: "table-builder"
    }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, table[0].map(function (_, idx) {
      return /*#__PURE__*/React.createElement("td", {
        key: idx
      }, /*#__PURE__*/React.createElement(TextInput, {
        value: columnsWidth[idx],
        placeholder: "Column width...",
        onChange: function onChange(value) {
          return _this4.hadnleColumnWidthChange(value, idx);
        }
      }));
    }), /*#__PURE__*/React.createElement("td", null)), table.map(function (row, ridx) {
      return /*#__PURE__*/React.createElement("tr", {
        key: ridx,
        className: ridx === 0 ? "body-separator" : ""
      }, row.map(function (col, cidx) {
        return /*#__PURE__*/React.createElement("td", {
          key: cidx
        }, /*#__PURE__*/React.createElement(TextInput, {
          value: col,
          onChange: function onChange(value) {
            return _this4.handleChangeCell(value, ridx, cidx);
          }
        }));
      }), /*#__PURE__*/React.createElement("td", {
        style: {
          width: "50px"
        }
      }, ridx === 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: _this4.handleAddCol,
        style: addBtn
      }), ridx > 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this4.handleRemoveRow(ridx);
        },
        style: delBtn$1
      })));
    })), /*#__PURE__*/React.createElement("tfoot", null, /*#__PURE__*/React.createElement("tr", null, firstRow.map(function (_, cidx) {
      return /*#__PURE__*/React.createElement("td", {
        key: cidx
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this4.handleRemoveCol(cidx);
        },
        style: delBtn$1
      }));
    }), /*#__PURE__*/React.createElement("td", null, "\xA0")))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: this.handleAddRow,
      style: addRowBtn$1
    }, "Add row"));
  };
  return TableBuilder;
}(React.Component);
TableBuilder.defaultProps = {
  value: [["Col 1", "Col 2", "Col 3"]],
  columnsWidth: ["", "", ""]
};
var tableClass = {
  fullWidth: "",
  medium: "col-shift-1",
  small: "col-shift-2"
};
var Widget$U = function Widget(_ref) {
  var table = _ref.table,
    columsWidth = _ref.columsWidth,
    tableContent = _ref.tableContent,
    variant = _ref.variant,
    containerSettings = _ref.containerSettings;
  var currentTable = tableContent && tableContent.table || table;
  var currentColumnsWidth = tableContent && tableContent.columnsWidth || columsWidth || [];
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-widget"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: tableClass[variant]
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, currentTable[0].map(function (col, cidx) {
    return /*#__PURE__*/React.createElement("th", {
      key: cidx,
      style: {
        width: currentColumnsWidth[cidx]
      },
      dangerouslySetInnerHTML: {
        __html: col
      }
    });
  }))), /*#__PURE__*/React.createElement("tbody", null, currentTable.slice(1).map(function (row, ridx) {
    return /*#__PURE__*/React.createElement("tr", {
      key: ridx
    }, row.map(function (col, cidx) {
      return /*#__PURE__*/React.createElement("td", {
        key: cidx,
        dangerouslySetInnerHTML: {
          __html: col
        }
      });
    }));
  })))))));
};
var Config$U = {
  title: "Table",
  category: "General"
};
var Defaults$U = {
  variant: "small",
  tableContent: {
    table: [["Col 1", "Col 2", "Col 3"]],
    columnsWidth: ["200px", "", ""]
  },
  containerSettings: {
    spacing: "none"
  }
};
var Admin$T = function Admin(_, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["fullWidth", "Full Width"], ["medium", "Shift 1 Column"], ["small", "Shift 2 Columns"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(TableBuilder, {
    tableContent: settings.tableContent || {
      table: settings.table,
      columnsWidth: settings.columsWidth
    },
    onChange: function onChange(value) {
      return _onChange("tableContent", value);
    }
  }));
};
var TableWidget = {
  __proto__: null,
  Widget: Widget$U,
  Admin: Admin$T,
  Config: Config$U,
  Defaults: Defaults$U
};
var ContainedContent = function ContainedContent(_ref) {
  var size = _ref.size,
    children = _ref.children;
  if (size === "full_width") {
    return children;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, children));
};
var Widget$V = function Widget(_ref2) {
  var list = _ref2.list,
    size = _ref2.size,
    defaultTab = _ref2.defaultTab,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, /*#__PURE__*/React.createElement(Tabs$1, {
    forceRenderTabPanel: true,
    defaultIndex: parseInt(defaultTab, 10) || 0
  }, /*#__PURE__*/React.createElement(TabList, null, list.map(function (tab, idx) {
    return /*#__PURE__*/React.createElement(Tab$5, {
      key: idx
    }, tab.title);
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(ContainedContent, {
    size: size
  }, list.map(function (tab, idx) {
    return /*#__PURE__*/React.createElement(TabPanel, {
      key: idx
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-box tab-cnt",
      key: idx,
      dangerouslySetInnerHTML: {
        __html: tab.text
      }
    }));
  }))))));
};
var Config$V = {
  title: "Tabs",
  category: "Text"
};
var Defaults$V = {
  defaultTab: 0,
  size: "regular",
  list: [{
    title: "Tab 1",
    text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
  }, {
    title: "Tab 2",
    text: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using Content here, content here, making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for lorem ipsum will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes."
  }, {
    title: "Tab 3",
    text: "here are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isnt anything embarrassing."
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var TabField$1 = function TabField(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Text",
    onChange: function onChange(value) {
      return onChangeItem("text", value);
    },
    value: settings.text
  }));
};
TabField$1.defaultProps = {
  settings: {}
};
var Admin$U = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Size",
    options: [["regular", "Regular"], ["full_width", "Full Width"]],
    value: settings.size,
    onChange: function onChange(value) {
      return _onChange("size", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default Tab",
    options: items.map(function (item, idx) {
      return [idx, item.title];
    }),
    value: settings.defaultTab,
    onChange: function onChange(value) {
      return _onChange("defaultTab", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(TabField$1, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      title: "Tab",
      text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum."
    },
    primaryField: "title"
  }));
};
var TabsWidget = {
  __proto__: null,
  Widget: Widget$V,
  Admin: Admin$U,
  Config: Config$V,
  Defaults: Defaults$V
};
var SelectedItem$1 = function SelectedItem(_ref) {
  var item = _ref.item;
  return /*#__PURE__*/React.createElement("div", {
    className: "selected-items-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-wrapper"
  }, /*#__PURE__*/React.createElement("img", {
    src: item.image.thumb_url,
    alt: item.name || ""
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("h4", null, item.name), /*#__PURE__*/React.createElement("p", null, item.position, ", ", item.company))));
};
var AutocompleteList$1 = function AutocompleteList(_ref) {
  var results = _ref.results,
    _onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("ul", {
    className: "autocomplete-list"
  }, results.map(function (result) {
    return /*#__PURE__*/React.createElement("li", {
      key: result.id,
      onClick: function onClick() {
        return _onClick(result.id);
      },
      className: "autocomplete-list-item"
    }, /*#__PURE__*/React.createElement("img", {
      src: result.image.thumb_url,
      alt: result.name || ""
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("strong", null, result.name, ", ", result.company), ":", /*#__PURE__*/React.createElement("div", {
      className: "content",
      dangerouslySetInnerHTML: {
        __html: result.content
      }
    })));
  }));
};
var TestimonialPicker = /*#__PURE__*/function (_React$Component) {
  function TestimonialPicker(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      result: [],
      f: "",
      selectedItemId: _this.props.value,
      showAutocomplete: false
    };
    return _this;
  }
  _inheritsLoose(TestimonialPicker, _React$Component);
  var _proto = TestimonialPicker.prototype;
  _proto.searchTestimonials = function searchTestimonials(testimonials) {
    var f = this.state.f;
    var filteredTestimonials = testimonials.filter(function (testimonial) {
      return testimonial.name.toLowerCase().includes(f);
    });
    filteredTestimonials.length > 0 && this.setState({
      result: filteredTestimonials,
      showAutocomplete: true
    });
  };
  _proto.handleSearch = function handleSearch(inputValue, testimonials) {
    var _this2 = this;
    this.setState({
      f: inputValue
    }, function () {
      _this2.state.f.length > 3 ? _this2.searchTestimonials(testimonials) : _this2.setState({
        result: []
      });
    });
  };
  _proto.handleSelectItem = function handleSelectItem(testimonial) {
    var _this3 = this;
    this.setState({
      selectedItemId: testimonial
    }, function () {
      _this3.props.onChange(testimonial);
      _this3.setState({
        showAutocomplete: false
      });
    });
  };
  _proto.render = function render() {
    var _this4 = this;
    var _this$state = this.state,
      result = _this$state.result,
      f = _this$state.f,
      selectedItemId = _this$state.selectedItemId,
      showAutocomplete = _this$state.showAutocomplete;
    return /*#__PURE__*/React.createElement(Query, {
      query: TESTIMONIALS
    }, function (_ref) {
      var loading = _ref.loading,
        data = _ref.data,
        error = _ref.error;
      if (loading) return "Loading...";
      if (error) return "Error! " + error.message;
      var testimonials = data.testimonials;
      var testimonialsList = testimonials.list;
      var selectedItem = testimonialsList.find(function (testimonial) {
        return parseInt(testimonial.id) === parseInt(selectedItemId);
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "new-cms-autocomplete-picker"
      }, /*#__PURE__*/React.createElement("div", {
        className: "autocomplete-wrapper"
      }, /*#__PURE__*/React.createElement(TextInput, {
        label: _this4.props.label,
        value: f,
        onChange: function onChange(value) {
          return _this4.handleSearch(value, testimonialsList);
        }
      }), showAutocomplete && /*#__PURE__*/React.createElement(AutocompleteList$1, {
        results: result,
        onClick: function onClick(testimonial) {
          return _this4.handleSelectItem(testimonial, testimonialsList);
        }
      })), selectedItem && /*#__PURE__*/React.createElement(SelectedItem$1, {
        item: selectedItem
      }));
    });
  };
  return TestimonialPicker;
}(React.Component);
var Testimonial = function Testimonial() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "calc(30% - 2em)",
      height: 300,
      marginRight: "2em"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "calc(70% - 2em)"
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 4,
    color: colors.lightBlue,
    style: {
      marginBottom: "4em"
    }
  }), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue,
    style: {
      width: 200
    }
  }))));
};
var TestimonialPlaceholder = function TestimonialPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: Testimonial,
    realComponent: realComponent
  });
};
var Widget$W = function Widget(_ref) {
  var testimonialId = _ref.testimonialId,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial-slider-new"
  }, testimonialId ? /*#__PURE__*/React.createElement(Query, {
    query: TESTIMONIAL,
    variables: {
      input: {
        id: testimonialId
      }
    }
  }, function (_ref2) {
    var loading = _ref2.loading,
      testimonial = _ref2.data.testimonial;
    return /*#__PURE__*/React.createElement(TestimonialPlaceholder, {
      ready: loading,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement("div", {
          className: "container"
        }, /*#__PURE__*/React.createElement("div", {
          className: "content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "image-wrapper"
        }, /*#__PURE__*/React.createElement(Img, {
          loading: "lazy",
          src: testimonial.image,
          variant: "magazine_spotlight"
        })), /*#__PURE__*/React.createElement("blockquote", {
          cite: "",
          className: "text-content"
        }, /*#__PURE__*/React.createElement("div", {
          className: "text-wrapper"
        }, /*#__PURE__*/React.createElement("span", {
          className: "quote-sign icon-quote"
        }), /*#__PURE__*/React.createElement("div", {
          className: "quote-text",
          dangerouslySetInnerHTML: {
            __html: testimonial.content
          }
        })), /*#__PURE__*/React.createElement("p", {
          className: "quote-author"
        }, testimonial.name && /*#__PURE__*/React.createElement("strong", null, testimonial.name), testimonial.position && ", " + testimonial.position, testimonial.company && ", " + testimonial.company))));
      }
    });
  }) : /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", null, "No testimonial selected"))));
};
var Config$W = {
  title: "Testimonial",
  category: "Image + Text"
};
var Defaults$W = {
  testimonialId: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$V = {
  testimonialId: {
    type: "custom",
    component: TestimonialPicker,
    label: "testimonial"
  }
};
var TestimonialWidget = {
  __proto__: null,
  Widget: Widget$W,
  Admin: Admin$V,
  Config: Config$W,
  Defaults: Defaults$W
};
var TestimonialSlide = function TestimonialSlide(_ref) {
  var testimonial = _ref.testimonial;
  return /*#__PURE__*/React.createElement("div", {
    className: "slide swiper-slide"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-wrapper"
  }, /*#__PURE__*/React.createElement(Img, {
    src: testimonial.image,
    variant: "magazine_spotlight"
  })), /*#__PURE__*/React.createElement("blockquote", {
    cite: "",
    className: "text-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "quote-sign icon-quote"
  }), /*#__PURE__*/React.createElement("div", {
    className: "quote-text",
    dangerouslySetInnerHTML: {
      __html: testimonial.content
    }
  })), /*#__PURE__*/React.createElement("p", {
    className: "quote-author"
  }, testimonial.name && /*#__PURE__*/React.createElement("strong", null, testimonial.name), testimonial.position && ", " + testimonial.position, testimonial.company && ", " + testimonial.company)))));
};
var TestimonialSlider = function TestimonialSlider(_ref) {
  var testimonials = _ref.testimonials;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    speed: 500,
    slideNextClass: "next-slide",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    }
  }, testimonials.map(function (testimonial, idx) {
    return /*#__PURE__*/React.createElement(TestimonialSlide, {
      key: idx,
      testimonial: testimonial
    });
  })));
};
var Testimonial$1 = function Testimonial() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "calc(30% - 2em)",
      height: 300,
      marginRight: "2em"
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "calc(70% - 2em)"
    }
  }, /*#__PURE__*/React.createElement(TextBlock, {
    rows: 4,
    color: colors.lightBlue,
    style: {
      marginBottom: "4em"
    }
  }), /*#__PURE__*/React.createElement(TextBlock, {
    rows: 1,
    color: colors.lightBlue,
    style: {
      width: 200
    }
  }))));
};
var TestimonialPlaceholder$1 = function TestimonialPlaceholder(_ref) {
  var realComponent = _ref.realComponent,
    ready = _ref.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: Testimonial$1,
    realComponent: realComponent
  });
};
var Widget$X = function Widget(_ref) {
  var list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "testimonial-slider-new"
  }, list.length > 0 ? /*#__PURE__*/React.createElement(Query, {
    query: TESTIMONIALS,
    variables: {
      input: {
        filters: {
          ids: list.map(function (item) {
            return item.testimonialId;
          })
        }
      }
    }
  }, function (_ref2) {
    var loading = _ref2.loading,
      testimonials = _ref2.data.testimonials;
    return /*#__PURE__*/React.createElement(TestimonialPlaceholder$1, {
      ready: loading,
      realComponent: function realComponent() {
        return /*#__PURE__*/React.createElement(TestimonialSlider, {
          testimonials: testimonials.list
        });
      }
    });
  }) : /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", null, "No slides selected"))));
};
var Config$X = {
  title: "Testimonial Slider",
  category: "Sliders"
};
var Defaults$X = {
  list: [],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var TestimonialField = function TestimonialField(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TestimonialPicker, {
    label: "Testimonial Search",
    onChange: function onChange(value) {
      return onChangeItem("testimonialId", value);
    },
    value: settings.testimonialId
  }));
};
var Admin$W = function Admin(items, onChange, settings) {
  return /*#__PURE__*/React.createElement(List, {
    template: {
      testimonialId: ""
    },
    primaryField: "name",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(TestimonialField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: onChange,
    items: items
  });
};
var TestimonialSliderWidget = {
  __proto__: null,
  Widget: Widget$X,
  Admin: Admin$W,
  Config: Config$X,
  Defaults: Defaults$X
};
var OnVideoClick$1 = function OnVideoClick(event, videoWrapper) {
  event.preventDefault();
  videoWrapper.classList.toggle("show-video");
};
var VideoThumbBig = function VideoThumbBig(_ref) {
  var image = _ref.image,
    idx = _ref.idx,
    selectedImage = _ref.selectedImage,
    videoUrl = _ref.videoUrl,
    video = _ref.video,
    loop = _ref.loop,
    controls = _ref.controls,
    mute = _ref.mute,
    size = _ref.size,
    autoPlay = _ref.autoPlay;
  var _useState = useState(false),
    play = _useState[0],
    setPlay = _useState[1];
  var videoRef = useRef(null);
  return /*#__PURE__*/React.createElement("div", {
    className: "big-image " + (idx === selectedImage ? "show" : "")
  }, /*#__PURE__*/React.createElement("div", {
    ref: videoRef,
    className: "embedded-video-inner " + (autoPlay ? "show-video" : ""),
    onClick: function onClick(e) {
      setPlay(true);
      OnVideoClick$1(e, videoRef.current);
    }
  }, /*#__PURE__*/React.createElement(A, {
    href: "#",
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    className: "full-image-anchor"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-play-round"
  }), /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: size === "large_image" ? "single_image_horizontal" : "articles_2_columns",
    className: "content"
  }))), videoUrl && !video && /*#__PURE__*/React.createElement("div", {
    className: "full-video"
  }, /*#__PURE__*/React.createElement(EmbeddedVideo, {
    videoUrl: videoUrl,
    autoplay: idx === selectedImage && (play || autoPlay),
    mute: autoPlay || mute,
    controls: controls,
    loop: loop
  })), !videoUrl && video && /*#__PURE__*/React.createElement("div", {
    className: "hosted-video"
  }, /*#__PURE__*/React.createElement(HostedVideo, {
    autoPlay: idx === selectedImage && (play || autoPlay),
    videoId: video,
    mute: autoPlay || mute,
    loop: loop,
    controls: controls
  }))));
};
VideoThumbBig.defaultProps = {
  videoUrl: ""
};
var ThumbBig = function ThumbBig(_ref2) {
  var image = _ref2.image,
    idx = _ref2.idx,
    selectedImage = _ref2.selectedImage;
  return /*#__PURE__*/React.createElement("div", {
    className: "big-image " + (idx === selectedImage ? "show" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "single_image_horizontal",
    className: "content"
  })));
};
var ThumbsList = function ThumbsList(_ref3) {
  var list = _ref3.list,
    selectedImage = _ref3.selectedImage,
    onChangeImage = _ref3.onChangeImage;
  return /*#__PURE__*/React.createElement("div", {
    className: "thumbs"
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "thumb-wrapper " + (idx === selectedImage ? "selected" : ""),
      onClick: function onClick() {
        return onChangeImage(idx);
      }
    }, item.videoUrl !== "" || item.video ? /*#__PURE__*/React.createElement("div", {
      className: "video-thumb-icon icon-play-round"
    }) : "", /*#__PURE__*/React.createElement(Image, {
      src: item.image,
      variant: "magazine_spotlight"
    }));
  }));
};
var TextAndMediaFullWidth = /*#__PURE__*/function (_React$Component) {
  function TextAndMediaFullWidth(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      selectedImage: 0
    };
    return _this;
  }
  _inheritsLoose(TextAndMediaFullWidth, _React$Component);
  var _proto = TextAndMediaFullWidth.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var selectedImage = this.state.selectedImage;
    var _this$props = this.props,
      list = _this$props.list,
      text = _this$props.text,
      button = _this$props.button,
      size = _this$props.size,
      autoPlay = _this$props.autoPlay,
      loop = _this$props.loop,
      controls = _this$props.controls,
      mute = _this$props.mute;
    return /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, list.map(function (item, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx
      }, item.videoUrl !== "" || item.video ? /*#__PURE__*/React.createElement(VideoThumbBig, {
        image: item.image,
        videoUrl: item.videoUrl,
        video: item.video,
        idx: idx,
        selectedImage: selectedImage,
        size: size,
        autoPlay: autoPlay,
        loop: loop,
        controls: controls,
        mute: mute
      }) : /*#__PURE__*/React.createElement(ThumbBig, {
        image: item.image,
        idx: idx,
        selectedImage: selectedImage
      }));
    }), list.length > 1 ? /*#__PURE__*/React.createElement(ThumbsList, {
      list: list,
      selectedImage: selectedImage,
      onChangeImage: function onChangeImage(imageIdx) {
        return _this2.setState({
          selectedImage: imageIdx
        });
      }
    }) : "", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: "text-box",
      dangerouslySetInnerHTML: {
        __html: text
      }
    }), /*#__PURE__*/React.createElement(Button$1, {
      settings: button
    }));
  };
  return TextAndMediaFullWidth;
}(React.Component);
TextAndMediaFullWidth.defaultProps = {
  button: {}
};
var TextColumn = function TextColumn(_ref4) {
  var size = _ref4.size,
    text = _ref4.text,
    button = _ref4.button;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-column " + (size === "large_image" ? "col-4" : "col-8")
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-box",
    dangerouslySetInnerHTML: {
      __html: text
    }
  }), /*#__PURE__*/React.createElement(Button$1, {
    settings: button
  }));
};
TextColumn.defaultProps = {
  button: {}
};
var ThumbsColumn = /*#__PURE__*/function (_React$Component2) {
  function ThumbsColumn(props) {
    var _this3;
    _this3 = _React$Component2.call(this, props) || this;
    _this3.state = {
      selectedImage: 0
    };
    return _this3;
  }
  _inheritsLoose(ThumbsColumn, _React$Component2);
  var _proto2 = ThumbsColumn.prototype;
  _proto2.render = function render() {
    var _this4 = this;
    var selectedImage = this.state.selectedImage;
    var _this$props2 = this.props,
      list = _this$props2.list,
      size = _this$props2.size,
      autoPlay = _this$props2.autoPlay,
      mute = _this$props2.mute,
      loop = _this$props2.loop,
      controls = _this$props2.controls;
    return /*#__PURE__*/React.createElement("div", {
      className: "image-column " + (size === "large_image" ? "col-8" : "col-4")
    }, list.map(function (item, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "image-col"
      }, item.videoUrl !== "" || item.video ? /*#__PURE__*/React.createElement(VideoThumbBig, {
        image: item.image,
        videoUrl: item.videoUrl,
        video: item.video,
        idx: idx,
        selectedImage: selectedImage,
        size: size,
        autoPlay: autoPlay,
        loop: loop,
        mute: mute,
        controls: controls
      }) : /*#__PURE__*/React.createElement(ThumbBig, {
        image: item.image,
        idx: idx,
        selectedImage: selectedImage
      }));
    }), list.length > 1 ? /*#__PURE__*/React.createElement(ThumbsList, {
      list: list,
      selectedImage: selectedImage,
      onChangeImage: function onChangeImage(imageIdx) {
        return _this4.setState({
          selectedImage: imageIdx
        });
      }
    }) : "");
  };
  return ThumbsColumn;
}(React.Component);
var TextAndMediaColumns = function TextAndMediaColumns(_ref5) {
  var list = _ref5.list,
    text = _ref5.text,
    button = _ref5.button,
    size = _ref5.size,
    layout = _ref5.layout,
    autoPlay = _ref5.autoPlay,
    controls = _ref5.controls,
    mute = _ref5.mute,
    loop = _ref5.loop;
  switch (layout) {
    case "right":
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextColumn, {
        size: size,
        text: text,
        button: button
      }), /*#__PURE__*/React.createElement(ThumbsColumn, {
        list: list,
        size: size,
        autoPlay: autoPlay,
        loop: loop,
        controls: controls,
        mute: mute
      }));
    case "left":
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(ThumbsColumn, {
        list: list,
        size: size,
        autoPlay: autoPlay,
        loop: loop,
        controls: controls,
        mute: mute
      }), /*#__PURE__*/React.createElement(TextColumn, {
        size: size,
        text: text,
        button: button
      }));
    default:
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement(TextColumn, {
        size: size,
        text: text,
        button: button,
        loop: loop,
        controls: controls,
        mute: mute
      }), /*#__PURE__*/React.createElement(ThumbsColumn, {
        list: list,
        size: size,
        autoPlay: autoPlay
      }));
  }
};
TextAndMediaColumns.defaultProps = {
  button: {}
};
var Widget$Y = /*#__PURE__*/function (_React$Component3) {
  function Widget() {
    return _React$Component3.apply(this, arguments) || this;
  }
  _inheritsLoose(Widget, _React$Component3);
  var _proto3 = Widget.prototype;
  _proto3.componentDidMount = function componentDidMount() {
    this.iframeRemoveAutoPlay();
  };
  _proto3.iframeRemoveAutoPlay = function iframeRemoveAutoPlay() {
    var _this5 = this;
    var thumbs = Array.from(this.TextAndMedia.querySelectorAll(".thumb-wrapper"));
    thumbs.map(function (thumb, thumbIdx) {
      thumb.addEventListener("click", function (e) {
        thumbs.forEach(function (thumb) {
          return thumb.classList.remove("selected");
        });
        thumb.classList.add("selected");
        [].concat(_this5.TextAndMedia.querySelectorAll(".big-image")).forEach(function (bigImage, bigImageIdx) {
          bigImage.classList.remove("show");
          if (bigImage.getElementsByTagName("iframe").item(0)) {
            var iframe = bigImage.getElementsByTagName("iframe").item(0);
            iframe.src = iframe.src.replace("autoplay=1", "autoplay=0");
          }
          if (thumbIdx === bigImageIdx) bigImage.classList.add("show");
        });
      });
    });
  };
  _proto3.render = function render() {
    var _this6 = this;
    var _this$props3 = this.props,
      button = _this$props3.button,
      text = _this$props3.text,
      layout = _this$props3.layout,
      size = _this$props3.size,
      list = _this$props3.list,
      auto_play = _this$props3.auto_play,
      loop = _this$props3.loop,
      controls = _this$props3.controls,
      mute = _this$props3.mute,
      containerSettings = _this$props3.containerSettings;
    return /*#__PURE__*/React.createElement(Container$1, {
      className: "text-and-media " + layout,
      settings: containerSettings
    }, /*#__PURE__*/React.createElement("div", {
      className: "container",
      ref: function ref(el) {
        return _this6.TextAndMedia = el;
      }
    }, layout === "full-width" ? /*#__PURE__*/React.createElement(TextAndMediaFullWidth, {
      list: list,
      text: text,
      button: button,
      size: size,
      autoPlay: auto_play === "yes",
      controls: controls === "yes",
      mute: mute === "yes",
      loop: loop === "yes"
    }) : /*#__PURE__*/React.createElement(TextAndMediaColumns, {
      list: list,
      text: text,
      button: button,
      size: size,
      layout: layout,
      autoPlay: auto_play === "yes",
      controls: controls === "yes",
      mute: mute === "yes",
      loop: loop === "yes"
    })));
  };
  return Widget;
}(React.Component);
var Config$Y = {
  title: "Media and Text",
  category: "Image + Text"
};
var Defaults$Y = {
  button: ButtonSettings.defaults,
  text: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reprehenderit voluptas asperiores consequatur dolor facere unde ipsum corrupti ea dolore accusantium id delectus, pariatur esse, optio suscipit ad deleniti illo necessitatibus nobis alias a voluptatem natus aspernatur quaerat maxime. Eius, ea.",
  layout: "right",
  size: "large_image",
  auto_play: "no",
  loop: "no",
  controls: "yes",
  mute: "no",
  list: [{
    id: 1,
    image: imagePlaceholder("1410x793"),
    videoUrl: "https://www.youtube.com/watch?v=oAiUy4in7Zo",
    video: ""
  }, {
    id: 2,
    image: imagePlaceholder("1410x793"),
    videoUrl: "https://www.youtube.com/watch?v=oAiUy4in7Zo",
    video: ""
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ImageField = function ImageField(_ref6) {
  var settings = _ref6.settings,
    onChangeItem = _ref6.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Video URL",
    onChange: function onChange(value) {
      return onChangeItem("videoUrl", value);
    },
    value: settings.videoUrl
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Hosted video",
    onChange: function onChange(value) {
      return onChangeItem("video", value);
    },
    value: settings.video
  }));
};
ImageField.defaultProps = {
  settings: {}
};
var Admin$X = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Layout",
    options: [["right", "Right"], ["left", "Left"], ["full-width", "Full Width"]],
    value: settings.layout,
    onChange: function onChange(value) {
      return _onChange("layout", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Size",
    options: [["large_image", "Large Image"], ["large_text", "Large Text"]],
    value: settings.size,
    onChange: function onChange(value) {
      return _onChange("size", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Video auto play",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.auto_play,
    onChange: function onChange(value) {
      return _onChange("auto_play", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Loop Video",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.loop,
    onChange: function onChange(value) {
      return _onChange("loop", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Mute video",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.mute,
    onChange: function onChange(value) {
      return _onChange("mute", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show video controls",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.video_controls,
    onChange: function onChange(value) {
      return _onChange("video_controls", value);
    }
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Text",
    value: settings.text,
    onChange: function onChange(value) {
      return _onChange("text", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ImageField, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    primaryField: "id",
    template: {
      image: imagePlaceholder("1410x793"),
      videoUrl: "https://www.youtube.com/watch?v=oAiUy4in7Zo"
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    button_settings_title: "Button",
    value: settings.button,
    onChange: function onChange(values) {
      return _onChange("button", values);
    }
  }));
};
var TextAndMediaWidget = {
  __proto__: null,
  Widget: Widget$Y,
  Admin: Admin$X,
  Config: Config$Y,
  Defaults: Defaults$Y
};
var isOfficeOpen = function isOfficeOpen(officeTime) {
  var isWorkTime = officeTime.getHours() >= 9 && officeTime.getHours() < 18;
  var notWeekend = officeTime.getDay() !== 6 && officeTime.getDay() !== 0;
  return isWorkTime && notWeekend;
};
var withWorkTime = function withWorkTime(text) {
  var date = moment.utc().tz("Europe/Sofia").toDate();
  return text.replace("{OFFICE_TIME}", date.getHours() + ":" + date.getMinutes().toString().padStart(2, "0") + " \xB7 " + (isOfficeOpen(date) ? '<span class="text-success">Currently open</span>' : '<span class="text-error">Currently closed</span>'));
};
var TextBoxOneColumn = function TextBoxOneColumn(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-component-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 text-box",
    dangerouslySetInnerHTML: {
      __html: withWorkTime(content)
    }
  })));
};
var TextBoxTwoColumns = function TextBoxTwoColumns(_ref2) {
  var content = _ref2.content,
    content_2 = _ref2.content_2;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-component-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row text-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-6",
    dangerouslySetInnerHTML: {
      __html: withWorkTime(content)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-6",
    dangerouslySetInnerHTML: {
      __html: withWorkTime(content_2)
    }
  })));
};
var TextBoxThreeColumns = function TextBoxThreeColumns(_ref3) {
  var content = _ref3.content,
    content_2 = _ref3.content_2,
    content_3 = _ref3.content_3;
  return /*#__PURE__*/React.createElement("div", {
    className: "text-component-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row text-box"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-4",
    dangerouslySetInnerHTML: {
      __html: withWorkTime(content)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-4",
    dangerouslySetInnerHTML: {
      __html: withWorkTime(content_2)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-4",
    dangerouslySetInnerHTML: {
      __html: withWorkTime(content_3)
    }
  })));
};
var TextBoxVariant = function TextBoxVariant(_ref4) {
  var content = _ref4.content,
    content_2 = _ref4.content_2,
    content_3 = _ref4.content_3,
    variant = _ref4.variant;
  switch (variant) {
    case "1_column":
      return /*#__PURE__*/React.createElement(TextBoxOneColumn, {
        content: content
      });
    case "2_columns":
      return /*#__PURE__*/React.createElement(TextBoxTwoColumns, {
        content: content,
        content_2: content_2
      });
    case "3_columns":
      return /*#__PURE__*/React.createElement(TextBoxThreeColumns, {
        content: content,
        content_2: content_2,
        content_3: content_3
      });
    default:
      return /*#__PURE__*/React.createElement(TextBoxOneColumn, {
        content: content
      });
  }
};
var Widget$Z = function Widget(_ref5) {
  var geoIp = _ref5.geoIp,
    content = _ref5.content,
    _ref5$content_ = _ref5.content_2,
    content_2 = _ref5$content_ === void 0 ? "" : _ref5$content_,
    _ref5$content_2 = _ref5.content_3,
    content_3 = _ref5$content_2 === void 0 ? "" : _ref5$content_2,
    variant = _ref5.variant,
    aligment = _ref5.aligment,
    containerSettings = _ref5.containerSettings;
  return /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: geoIp && geoIp.activeCountries || [],
    countryGroupIds: geoIp && geoIp.activeGroups || [],
    active: geoIp && geoIp.active || false
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-block-widget " + (aligment === "center" ? "text-center" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(TextBoxVariant, {
    content: decorateAnchors(content),
    content_2: decorateAnchors(content_2),
    content_3: decorateAnchors(content_3),
    variant: variant
  })))));
};
var Config$Z = {
  title: "Text Block",
  category: "Text"
};
var Defaults$Z = {
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  variant: "1_column",
  content: "<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates est facere amet dolor consequatur quas asperiores ipsa odit ea beatae, maiores sunt suscipit repudiandae perspiciatis maxime. Tempora ex dolores voluptas, ipsam minima ut ipsa sed voluptatibus repudiandae inventore numquam saepe.</p>",
  content_2: "",
  content_3: "",
  aligment: "left",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$Y = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GeoIpPicker, {
    onChange: function onChange(value) {
      return _onChange("geoIp", value);
    },
    value: settings.geoIp
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["1_column", "1 Column"], ["2_columns", "2 Columns"], ["3_columns", "3 Columns"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange("variant", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Aligment",
    options: [["left", "Left"], ["center", "Center"]],
    value: settings.aligment,
    onChange: function onChange(value) {
      return _onChange("aligment", value);
    }
  }), /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h6", null, "Content links"), /*#__PURE__*/React.createElement("p", null, "If you want a link to open in new tab, use absolute URLs (e.g. https://www.chaos.com). Links to external websites will open in new tab by default. ", /*#__PURE__*/React.createElement("br", null), "If you want a link to open in the same tab, use relative URLs (e.g. /vray/3ds-max)")), /*#__PURE__*/React.createElement(RTE, {
    label: "Content",
    value: settings.content,
    onChange: function onChange(value) {
      return _onChange("content", value);
    }
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Content 2",
    value: settings.content_2,
    onChange: function onChange(value) {
      return _onChange("content_2", value);
    }
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Content 3",
    value: settings.content_3,
    onChange: function onChange(value) {
      return _onChange("content_3", value);
    }
  }));
};
var TextBoxWidget = {
  __proto__: null,
  Widget: Widget$Z,
  Admin: Admin$Y,
  Config: Config$Z,
  Defaults: Defaults$Z
};
var isVideo = function isVideo(url) {
  return url.includes("youtu") || url.includes("vimeo") || url.includes("youku");
};
var MediaLink = /*#__PURE__*/function (_React$Component) {
  function MediaLink(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleModalOpen = function (e) {
      e.preventDefault();
      _this.setState({
        isOpen: true
      });
    };
    _this.handleModalClose = function () {
      _this.setState({
        isOpen: false
      });
    };
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inheritsLoose(MediaLink, _React$Component);
  var _proto = MediaLink.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      content = _this$props.content,
      url = _this$props.url,
      id = _this$props.id,
      options = _this$props.options;
    var isOpen = this.state.isOpen;
    if (isVideo(url)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(A, {
        href: "#",
        className: options ? options.className : "",
        id: id,
        onClick: this.handleModalOpen
      }, content), isOpen && /*#__PURE__*/React.createElement(VideoModal, {
        isOpen: isOpen,
        url: url,
        onClose: this.handleModalClose
      }));
    }
    return /*#__PURE__*/React.createElement(A, {
      id: id,
      href: url,
      className: options ? options.className : ""
    }, content);
  };
  return MediaLink;
}(React.Component);
var imageClass = function imageClass(aspectRatio) {
  return aspectRatio == "3-2" ? "high-thumb" : "";
};
var IconWithLink = function IconWithLink(_ref) {
  var logo = _ref.logo,
    link = _ref.link;
  if (link.link) {
    return /*#__PURE__*/React.createElement(A, {
      key: link.id,
      href: link.link,
      id: link.id ? link.id : "",
      target: link.target,
      rel: link.rel,
      title: link.label,
      className: "item"
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: logo,
      variant: "original"
    }));
  }
  return /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    className: "item",
    src: logo,
    variant: "original"
  });
};
var ArticleIcons = function ArticleIcons(_ref2) {
  var _thumb$icons;
  var thumb = _ref2.thumb;
  return (thumb === null || thumb === void 0 ? void 0 : (_thumb$icons = thumb.icons) === null || _thumb$icons === void 0 ? void 0 : _thumb$icons.length) > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "article-icons"
  }, thumb.icons.map(function (icon) {
    return /*#__PURE__*/React.createElement(IconWithLink, _extends({
      key: icon.id
    }, icon));
  })) : null;
};
var ThumbWithLink = /*#__PURE__*/function (_React$Component) {
  function ThumbWithLink(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.handleModalOpen = function (e) {
      e.preventDefault();
      _this.setState({
        isOpen: true
      });
    };
    _this.handleModalClose = function () {
      _this.setState({
        isOpen: false
      });
    };
    _this.state = {
      isOpen: false
    };
    return _this;
  }
  _inheritsLoose(ThumbWithLink, _React$Component);
  var _proto = ThumbWithLink.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      thumb = _this$props.thumb,
      aspectRatio = _this$props.aspectRatio;
    var isOpen = this.state.isOpen;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isVideo(thumb.link) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(A, {
      href: "#",
      className: "article-image " + imageClass(aspectRatio),
      id: thumb.link_id + "-image",
      onClick: this.handleModalOpen
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: thumb.image,
      variant: "articles_2_columns"
    }), /*#__PURE__*/React.createElement("span", {
      className: "icon-play-round"
    })), isOpen && /*#__PURE__*/React.createElement(VideoModal, {
      isOpen: isOpen,
      url: thumb.link,
      onClose: this.handleModalClose
    })) : /*#__PURE__*/React.createElement(MediaLink, {
      content: /*#__PURE__*/React.createElement(Image, {
        loading: "lazy",
        src: thumb.image,
        variant: "articles_2_columns"
      }),
      url: thumb.link,
      options: {
        className: "article-image " + imageClass(aspectRatio)
      },
      id: thumb.link_id + "-image"
    }), /*#__PURE__*/React.createElement(ArticleIcons, {
      thumb: thumb
    }), /*#__PURE__*/React.createElement("h6", {
      className: "article-title"
    }, /*#__PURE__*/React.createElement(MediaLink, {
      content: thumb.title,
      url: thumb.link,
      id: thumb.link_id + "-title"
    })), /*#__PURE__*/React.createElement("div", {
      className: "article-short-desc"
    }, parseMarkdown(thumb.description)));
  };
  return ThumbWithLink;
}(React.Component);
var thumbClass$2 = function thumbClass(variant) {
  switch (variant) {
    case "2_columns":
      return "previews-2";
    case "3_columns":
      return "previews-3";
    case "4_columns":
      return "previews-4";
    default:
      return "previews-3";
  }
};
var ArticleThumb = function ArticleThumb(_ref) {
  var thumb = _ref.thumb,
    variant = _ref.variant,
    aspectRatio = _ref.aspectRatio;
  return /*#__PURE__*/React.createElement("article", {
    className: "article-preview " + thumbClass$2(variant)
  }, thumb.link !== "" ? /*#__PURE__*/React.createElement(ThumbWithLink, {
    thumb: thumb,
    aspectRatio: aspectRatio
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "article-image " + imageClass(aspectRatio)
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: thumb.image,
    variant: "articles_2_columns"
  })), /*#__PURE__*/React.createElement(ArticleIcons, {
    thumb: thumb
  }), /*#__PURE__*/React.createElement("h6", {
    className: "article-title"
  }, thumb.title), /*#__PURE__*/React.createElement("div", {
    className: "article-short-desc"
  }, parseMarkdown(thumb.description))));
};
var ShowHideButton = /*#__PURE__*/function (_React$Component) {
  function ShowHideButton(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isShowLess: false
    };
    return _this;
  }
  _inheritsLoose(ShowHideButton, _React$Component);
  var _proto = ShowHideButton.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var isShowLess = this.state.isShowLess;
    var _this$props = this.props,
      showMoreLabel = _this$props.showMoreLabel,
      showLessLabel = _this$props.showLessLabel,
      _onClick = _this$props.onClick;
    return /*#__PURE__*/React.createElement("div", {
      className: "centered-btn spacing-top"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement(A, {
      href: "#",
      className: "btn-show",
      onClick: function onClick(e) {
        _this2.setState({
          isShowLess: !isShowLess
        });
        e.preventDefault();
        _onClick();
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: isShowLess ? "text-show-less" : "text-show-more"
    }, /*#__PURE__*/React.createElement("span", {
      className: "btn-show-text"
    }, isShowLess ? showLessLabel : showMoreLabel)))));
  };
  return ShowHideButton;
}(React.Component);
var rowsToShowClass = function rowsToShowClass(rowsToShow) {
  switch (rowsToShow) {
    case "1":
      return "show-rows-1";
    case "2":
      return "show-rows-2";
    case "3":
      return "show-rows-3";
    default:
      return "show-rows-1";
  }
};
var Widget$_ = function Widget(_ref) {
  var variant = _ref.variant,
    hideRows = _ref.hideRows,
    rowsToShow = _ref.rowsToShow,
    list = _ref.list,
    _ref$showMoreLabel = _ref.showMoreLabel,
    showMoreLabel = _ref$showMoreLabel === void 0 ? "" : _ref$showMoreLabel,
    _ref$showLessLabel = _ref.showLessLabel,
    showLessLabel = _ref$showLessLabel === void 0 ? "" : _ref$showLessLabel,
    _ref$aspectRatio = _ref.aspectRatio,
    aspectRatio = _ref$aspectRatio === void 0 ? "16-9" : _ref$aspectRatio,
    containerSettings = _ref.containerSettings;
  var _React$useState = React.useState(false),
    rowsVisible = _React$useState[0],
    setRowsVisible = _React$useState[1];
  var thumbsRef = /*#__PURE__*/React.createRef();
  var toggleable = hideRows === "on";
  var rowsClass = !rowsVisible ? "hide-rows" : "";
  var handleToggle = function handleToggle() {
    var shouldScroll = rowsVisible === true;
    setRowsVisible(!rowsVisible);
    if (shouldScroll && thumbsRef.current) window.scroll(0, cumulativeTopOffset(thumbsRef.current));
  };
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "thumbs-with-text-wrapper new-tumbs-with-text " + (toggleable ? rowsToShowClass(rowsToShow) : "") + " ",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thumbs-with-text articles-preview-wrapper " + (toggleable ? rowsClass : ""),
    ref: thumbsRef
  }, /*#__PURE__*/React.createElement("div", null, list.map(function (thumb) {
    return /*#__PURE__*/React.createElement(ArticleThumb, {
      key: thumb.id,
      thumb: thumb,
      variant: variant,
      aspectRatio: aspectRatio
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, toggleable && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ShowHideButton, {
    onClick: handleToggle,
    showMoreLabel: showMoreLabel,
    showLessLabel: showLessLabel
  })))));
};
var Config$_ = {
  title: "Thumbs with Text",
  category: "Image + Text"
};
var Defaults$_ = {
  variant: "2_columns",
  hideRows: "off",
  rowsToShow: "2",
  list: [{
    id: 1,
    image: imagePlaceholder("690x380"),
    title: "Title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem ratione quam placeat earum est magnam.",
    link: "",
    link_id: ""
  }, {
    id: 2,
    image: imagePlaceholder("690x380"),
    title: "Title",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem ratione quam placeat earum est magnam.",
    link: "",
    link_id: ""
  }],
  showMoreLabel: "",
  showLessLabel: "",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ProductIconInput = function ProductIconInput(_ref2) {
  var settings = _ref2.settings,
    _onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    value: settings.logo,
    onChange: function onChange(value) {
      return _onChange("logo", value);
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    value: settings.link,
    onChange: function onChange(value) {
      return _onChange("link", value);
    }
  }));
};
var ThumbField$2 = function ThumbField(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Link",
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    value: settings.link
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Link ID",
    onChange: function onChange(value) {
      return onChangeItem("link_id", value);
    },
    value: settings.link_id
  }), /*#__PURE__*/React.createElement(List, {
    label: "Icons",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ProductIconInput, {
        settings: settings,
        onChange: onChangeItem
      });
    },
    onChangeList: function onChangeList(_key, newList) {
      return onChangeItem("icons", newList);
    },
    items: settings.icons,
    primaryField: "link.label",
    template: {
      image: imagePlaceholder("40x40"),
      link: LinkSettings.defaults
    }
  }));
};
var Admin$Z = function Admin(items, _onChange2, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["2_columns", "2 Columns"], ["3_columns", "3 Columns"], ["4_columns", "4 Columns"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange2("variant", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Hide Rows",
    options: [["off", "Off"], ["on", "On"]],
    value: settings.hideRows,
    onChange: function onChange(value) {
      return _onChange2("hideRows", value);
    }
  }), settings.hideRows === "on" ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Rows To Show",
    options: [["1", "1"], ["2", "2"], ["3", "3"]],
    value: settings.rowsToShow,
    onChange: function onChange(value) {
      return _onChange2("rowsToShow", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Show more label",
    onChange: function onChange(value) {
      return _onChange2("showMoreLabel", value);
    },
    value: settings.showMoreLabel
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Show less label",
    onChange: function onChange(value) {
      return _onChange2("showLessLabel", value);
    },
    value: settings.showLessLabel
  })) : null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Image variant",
    options: [["16-9", "16:9"], ["3-2", "3:2"]],
    value: settings.aspectRatio,
    onChange: function onChange(value) {
      return _onChange2("aspectRatio", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    label: "Thumbs",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ThumbField$2, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange2,
    items: items,
    primaryField: "title",
    template: {
      image: imagePlaceholder("690x380"),
      title: "Title",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quidem ratione quam placeat earum est magnam.",
      link: "",
      link_id: ""
    }
  }));
};
var ThumbsListWidget = {
  __proto__: null,
  Widget: Widget$_,
  Admin: Admin$Z,
  Config: Config$_,
  Defaults: Defaults$_
};
var Widget$$ = function Widget(_ref) {
  var containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("h2", null, "Magazine Feed"));
};
var Defaults$$ = {
  containerSettings: {
    spacing: "none"
  }
};
var Config$$ = {
  deprecated: true,
  title: "Magazine Feed",
  category: "Feeds"
};
var Admin$_ = {
  variant: {
    type: "select",
    options: [["2_columns", "2 Columns"], ["3_columns", "3 Columns"], ["4_columns", "4 Columns"]]
  },
  filter_category: {
    type: "select",
    options: [["", "All Categories"]]
  },
  filter_product: {
    type: "select",
    options: [["", "All Categories"]]
  },
  limit: {
    type: "text"
  },
  offsett: {
    type: "text"
  }
};
var MagazineArticlesWidget = {
  __proto__: null,
  Widget: Widget$$,
  Admin: Admin$_,
  Config: Config$$,
  Defaults: Defaults$$
};
var extractRegularPrice = function extractRegularPrice(item, currency) {
  var _item$prices;
  return item.prices && Currency.extractPrice((_item$prices = item.prices) === null || _item$prices === void 0 ? void 0 : _item$prices.regular, currency);
};
var extractPromoPrice = function extractPromoPrice(item, currency) {
  var _item$prices2;
  return item.prices && Currency.extractPrice((_item$prices2 = item.prices) === null || _item$prices2 === void 0 ? void 0 : _item$prices2.promo, currency);
};
var perMonthPrice$1 = function perMonthPrice(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "annual":
      return value / (opts.specificBillingPeriod || 12);
    case "triennial":
      return value / (opts.specificBillingPeriod || 36);
    default:
      return value;
  }
};
var perYearPrice$1 = function perYearPrice(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "monthly":
      return value * (opts.specificBillingPeriod || 12);
    case "triennial":
      return value / (opts.specificBillingPeriod || 3);
    default:
      return value;
  }
};
var perTriennialPrice = function perTriennialPrice(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "monthly":
      return value * (opts.specificBillingPeriod || 36);
    case "annual":
      return value * (opts.specificBillingPeriod || 3);
    default:
      return value;
  }
};
var preparePrice = function preparePrice(value, item) {
  var _item$ratePlanDetails;
  var specificBillingPeriod = (_item$ratePlanDetails = item.ratePlanDetails) === null || _item$ratePlanDetails === void 0 ? void 0 : _item$ratePlanDetails.specific_billing_preriod;
  if (item.priceDisplayType === "per_month") {
    return perMonthPrice$1(value, item.pricingType, {
      specificBillingPeriod: specificBillingPeriod
    });
  }
  return value;
};
var prepareCardPrice = function prepareCardPrice(card, currency, period) {
  var item = card.items.find(function (o) {
    return o.pricingType === period;
  });
  return item && extractRegularPrice(item, currency);
};
var perMonthToken$1 = function perMonthToken(desc, value, pricingType, currency, country, opts) {
  if (opts === void 0) {
    opts = {};
  }
  return desc.replace("{PER_MONTH}", Currency.prettyPrint(perMonthPrice$1(value, pricingType, opts), currency, country));
};
var perYearToken$1 = function perYearToken(desc, value, pricingType, currency, country, opts) {
  if (opts === void 0) {
    opts = {};
  }
  return desc.replace("{PER_YEAR}", Currency.prettyPrint(perYearPrice$1(value, pricingType, opts), currency, country));
};
var perTriennialToken = function perTriennialToken(desc, value, pricingType, currency, country, opts) {
  if (opts === void 0) {
    opts = {};
  }
  return desc.replace("{PER_TRIENNIAL}", Currency.prettyPrint(perTriennialPrice(value, pricingType, opts), currency, country));
};
var annualSavingsToken = function annualSavingsToken(desc, card, currency, country) {
  var annualPrice = prepareCardPrice(card, currency, "annual");
  var monthlyPrice = prepareCardPrice(card, currency, "monthly");
  return desc.replace("{ANNUAL_SAVINGS}", Currency.prettyPrint(monthlyPrice * 12 - annualPrice, currency, country));
};
var preparePriceDescription = function preparePriceDescription(value, item, currency, country, card) {
  var _item$ratePlanDetails2;
  var desc = item.priceDescription;
  var specificBillingPeriod = (_item$ratePlanDetails2 = item.ratePlanDetails) === null || _item$ratePlanDetails2 === void 0 ? void 0 : _item$ratePlanDetails2.specific_billing_preriod;
  desc = perMonthToken$1(desc, value, item.pricingType, currency, country, {
    specificBillingPeriod: specificBillingPeriod
  });
  desc = perYearToken$1(desc, value, item.pricingType, currency, country, {
    specificBillingPeriod: specificBillingPeriod
  });
  desc = annualSavingsToken(desc, card, currency);
  return perTriennialToken(desc, value, item.pricingType, currency, country);
};
var prepareDescription = function prepareDescription(value, item, currency, country, card) {
  var _item$ratePlanDetails3;
  var desc = item.description;
  var specificBillingPeriod = (_item$ratePlanDetails3 = item.ratePlanDetails) === null || _item$ratePlanDetails3 === void 0 ? void 0 : _item$ratePlanDetails3.specific_billing_preriod;
  desc = perMonthToken$1(desc, value, item.pricingType, currency, country, {
    specificBillingPeriod: specificBillingPeriod
  });
  desc = perYearToken$1(desc, value, item.pricingType, currency, country, {
    specificBillingPeriod: specificBillingPeriod
  });
  desc = annualSavingsToken(desc, card, currency, country);
  return perTriennialToken(desc, value, item.pricingType, currency, country);
};
var prepareDiscountNote = function prepareDiscountNote(item, currency, card, country) {
  return annualSavingsToken(item.discountNote, card, currency, country);
};
var preparePromoDescription = function preparePromoDescription(promoValue, regularValue, currency, text, country) {
  var desc = text || "";
  return desc.replace("{SAVINGS}", Currency.prettyPrint(regularValue - promoValue, currency, country));
};
function shouldFetchPricingDataFor(item) {
  var _item$package_price_s, _item$featured_pricin;
  return !!(item !== null && item !== void 0 && (_item$package_price_s = item.package_price_settings) !== null && _item$package_price_s !== void 0 && _item$package_price_s.package_price_id) || !!(item !== null && item !== void 0 && (_item$featured_pricin = item.featured_pricing_card_settings) !== null && _item$featured_pricin !== void 0 && _item$featured_pricin.card_id);
}
function isDataFechted(item, packagePrices, pricingCards) {
  var _item$package_price_s2, _item$featured_pricin2;
  if (!packagePrices && !pricingCards) {
    return false;
  }
  if (packagePrices && item !== null && item !== void 0 && (_item$package_price_s2 = item.package_price_settings) !== null && _item$package_price_s2 !== void 0 && _item$package_price_s2.package_price_id && packagePrices.find(function (pp) {
    var _item$package_price_s3;
    return pp.id == (item === null || item === void 0 ? void 0 : (_item$package_price_s3 = item.package_price_settings) === null || _item$package_price_s3 === void 0 ? void 0 : _item$package_price_s3.package_price_id);
  })) {
    return true;
  }
  if (pricingCards && item !== null && item !== void 0 && (_item$featured_pricin2 = item.featured_pricing_card_settings) !== null && _item$featured_pricin2 !== void 0 && _item$featured_pricin2.card_id && pricingCards.find(function (pc) {
    var _item$featured_pricin3;
    return pc.id === (item === null || item === void 0 ? void 0 : (_item$featured_pricin3 = item.featured_pricing_card_settings) === null || _item$featured_pricin3 === void 0 ? void 0 : _item$featured_pricin3.card_id);
  })) {
    return true;
  }
  return false;
}
function pricingDataForPackagePrices(item, packagePrices, currency) {
  var packagePrice = (packagePrices || []).find(function (pp) {
    var _item$package_price_s4;
    return pp.id === ((_item$package_price_s4 = item.package_price_settings) === null || _item$package_price_s4 === void 0 ? void 0 : _item$package_price_s4.package_price_id);
  });
  if (!packagePrice) {
    return null;
  }
  var value = 0;
  var promoValue = 0;
  if (item.package_price_settings.variant === "per-unit") {
    value = (packagePrice.prices[currency] || 0) / packagePrice.quantity;
    promoValue = (packagePrice.promo_prices[currency] || 0) / packagePrice.quantity;
  } else {
    value = packagePrice.prices[currency] || 0;
    promoValue = packagePrice.promo_prices[currency] || 0;
  }
  return {
    value: value,
    promoValue: promoValue,
    promo: packagePrice.promo_active,
    unit: item.package_price_settings.unit,
    currency: currency
  };
}
function pricingDataForPricingCard(item, pricingCards, currency) {
  var _cardItem$prices, _cardItem$prices2, _cardItem$prices3, _cardItem$prices4;
  var card = (pricingCards || []).find(function (pc) {
    var _item$featured_pricin4;
    return pc.id === ((_item$featured_pricin4 = item.featured_pricing_card_settings) === null || _item$featured_pricin4 === void 0 ? void 0 : _item$featured_pricin4.card_id);
  });
  if (!card) {
    return null;
  }
  var cardItem = card.items.find(function (i) {
    return i.id === item.featured_pricing_card_settings.card_item_id;
  });
  if (!cardItem) {
    return null;
  }
  var validCurrency = ((_cardItem$prices = cardItem.prices) === null || _cardItem$prices === void 0 ? void 0 : _cardItem$prices.override_currency) || currency;
  var defaultValue = Currency.extractPrice((_cardItem$prices2 = cardItem.prices) === null || _cardItem$prices2 === void 0 ? void 0 : _cardItem$prices2.regular, validCurrency) || 0;
  var promoDefaultValue = Currency.extractPrice((_cardItem$prices3 = cardItem.prices) === null || _cardItem$prices3 === void 0 ? void 0 : _cardItem$prices3.promo, validCurrency) || 0;
  return {
    value: preparePrice(defaultValue, cardItem),
    promoValue: preparePrice(promoDefaultValue, cardItem),
    promo: (_cardItem$prices4 = cardItem.prices) === null || _cardItem$prices4 === void 0 ? void 0 : _cardItem$prices4.has_promo,
    unit: cardItem.priceLabel,
    currency: validCurrency
  };
}
function pricingDataFor(item, packagePrices, pricingCards, currency) {
  var pd = pricingDataForPackagePrices(item, packagePrices, currency);
  if (pd) {
    return pd;
  }
  return pricingDataForPricingCard(item, pricingCards, currency);
}
var _excluded$5 = ["promo"];
var PromoPrice = function PromoPrice(_ref) {
  var value = _ref.value,
    promoValue = _ref.promoValue,
    currency = _ref.currency,
    unit = _ref.unit;
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  var _Currency$split = Currency.split(value),
    whole = _Currency$split[0],
    decimal = _Currency$split[1];
  var _Currency$split2 = Currency.split(promoValue),
    promoWhole = _Currency$split2[0],
    promoDecimal = _Currency$split2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "price promo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "old-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "old-major"
  }, Currency.prettyPrint(parseInt(whole), currency, country)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("div", {
    className: "old-minor"
  }, decimal)), /*#__PURE__*/React.createElement("div", {
    className: "major"
  }, Currency.prettyPrint(parseInt(promoWhole), currency, country)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("div", {
    className: "minor"
  }, promoDecimal)), /*#__PURE__*/React.createElement("span", {
    className: "meta"
  }, unit)));
};
var RegularPrice = function RegularPrice(_ref2) {
  var value = _ref2.value,
    currency = _ref2.currency,
    unit = _ref2.unit;
  var _React$useContext2 = React.useContext(GeoIpContext),
    country = _React$useContext2.country;
  var _Currency$split3 = Currency.split(value),
    whole = _Currency$split3[0],
    decimal = _Currency$split3[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "major"
  }, Currency.prettyPrint(parseInt(whole), currency, country)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("div", {
    className: "minor"
  }, decimal)), /*#__PURE__*/React.createElement("span", {
    className: "meta"
  }, unit)));
};
var Price$1 = function Price(_ref3) {
  var promo = _ref3.promo,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded$5);
  if (promo) {
    return /*#__PURE__*/React.createElement(PromoPrice, rest);
  }
  return /*#__PURE__*/React.createElement(RegularPrice, rest);
};
var PricePlaceholder = function PricePlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "price-placeholder"
  }, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, "Loading..."));
};
var Link$1 = function Link(_ref4) {
  var settings = _ref4.settings,
    children = _ref4.children;
  var label = settings.label,
    link = settings.link,
    id = settings.id,
    target = settings.target,
    rel = settings.rel,
    className = settings.className;
  return /*#__PURE__*/React.createElement(A, {
    href: link,
    className: className,
    id: id ? id : "",
    target: target,
    rel: rel,
    title: label
  }, children);
};
var Card$3 = function Card(_ref5) {
  var _item$logo_link;
  var item = _ref5.item,
    packagePrices = _ref5.packagePrices,
    pricingCards = _ref5.pricingCards,
    currency = _ref5.currency;
  return /*#__PURE__*/React.createElement("div", {
    className: "item " + item.theme
  }, /*#__PURE__*/React.createElement("div", null, item.image && /*#__PURE__*/React.createElement("figure", {
    className: "image"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.image,
    variant: "gallery_masonry_horizontal_wide"
  }), item.image.credits && /*#__PURE__*/React.createElement("figcaption", {
    className: "credits"
  }, item.image.credits)), (_item$logo_link = item.logo_link) !== null && _item$logo_link !== void 0 && _item$logo_link.link ? /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement(Link$1, {
    settings: item.logo_link
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.logo,
    variant: "original"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.logo,
    variant: "original"
  })), shouldFetchPricingDataFor(item) ? isDataFechted(item, packagePrices, pricingCards) ? /*#__PURE__*/React.createElement(Price$1, pricingDataFor(item, packagePrices, pricingCards, currency)) : /*#__PURE__*/React.createElement(PricePlaceholder, null) : /*#__PURE__*/React.createElement("div", {
    className: "spacer"
  }), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(item.description))), /*#__PURE__*/React.createElement("div", {
    className: "above-ribbon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: item.button_1
  }), /*#__PURE__*/React.createElement(Button$1, {
    settings: item.button_2
  })), item.icon && /*#__PURE__*/React.createElement("div", {
    className: "bottom-icon"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.icon,
    variant: "original"
  }))), item.ribbon_text && /*#__PURE__*/React.createElement("div", {
    className: "corner-ribbon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, item.ribbon_text)));
};
var PackagePricePicker = function (_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var _useState = useState(value),
    selectedItemId = _useState[0],
    setSelectedItemId = _useState[1];
  return /*#__PURE__*/React.createElement(Query, {
    query: MINI_PACKAGE_PRICES
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var packagePrices = data.miniPackagePrices;
    return /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Package price",
      options: packagePrices.list.map(function (e) {
        return [e.id, e.name];
      }),
      value: selectedItemId,
      onChange: function onChange(newPackagePriceId) {
        _onChange(newPackagePriceId);
        setSelectedItemId(newPackagePriceId);
      }
    });
  });
};
var PricingCardPicker = function (_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  var _useState = useState(value.card_id),
    cardId = _useState[0],
    setCardId = _useState[1];
  var _useState2 = useState(value.card_item_id),
    cardItemId = _useState2[0],
    setCardItemId = _useState2[1];
  return /*#__PURE__*/React.createElement(Query, {
    query: MINI_FEATURED_PRICING_CARDS
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    if (loading) return "Loading...";
    var cards = data.miniFeaturedPricingCards;
    var selectedItem = cards.list.find(function (card) {
      return parseInt(card.id) === parseInt(cardId);
    });
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Pricing card",
      options: cards.list.map(function (e) {
        return [e.id, e.name];
      }),
      value: cardId,
      onChange: function onChange(newCardId) {
        setCardId(newCardId);
        var newlySelected = cards.list.find(function (card) {
          return parseInt(card.id) === parseInt(newCardId);
        });
        var newItemId = null;
        if (newlySelected) {
          var _newlySelected$items$;
          newItemId = ((_newlySelected$items$ = newlySelected.items[0]) === null || _newlySelected$items$ === void 0 ? void 0 : _newlySelected$items$.id) || "";
        } else {
          newItemId = "";
        }
        setCardItemId(newItemId);
        _onChange(_extends({}, value, {
          card_id: newCardId,
          card_item_id: newItemId
        }));
      }
    }), selectedItem && /*#__PURE__*/React.createElement(SelectMenu, {
      label: "Pricing card item",
      options: selectedItem.items.map(function (item) {
        return [item.id, item.title];
      }),
      value: cardItemId,
      onChange: function onChange(newCardItemId) {
        setCardItemId(newCardItemId);
        _onChange(_extends({}, value, {
          card_item_id: newCardItemId
        }));
      }
    }));
  });
};
var TEMPLATE$1 = {
  icon: imagePlaceholder("40x40"),
  image: imagePlaceholder("1276x359"),
  logo: imagePlaceholder("100x60"),
  logo_link: LinkSettings.defaults,
  description: "Fast photoreal CPU & GPU rendering for artists and designers in architecture, games, VFX and VR",
  button_1: _extends({}, ButtonSettings.defaults, {
    type: "text"
  }),
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "text"
  }),
  ribbon_text: "",
  theme: "",
  double_size: "no",
  package_price_settings: {
    variant: "",
    unit: "",
    package_price_id: ""
  },
  featured_pricing_card_settings: {
    card_id: "",
    card_item_id: ""
  }
};
var Defaults$10 = {
  variant: "col-3",
  promo_code: "",
  list: [_extends({}, TEMPLATE$1, {
    id: 1
  }), _extends({}, TEMPLATE$1, {
    id: 2
  }), _extends({}, TEMPLATE$1, {
    id: 3
  }), _extends({}, TEMPLATE$1, {
    id: 4
  })],
  containerSettings: {
    theme: "white",
    spacing: ""
  }
};
var PackagePricingSettings = function PackagePricingSettings(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, /*#__PURE__*/React.createElement(H, null, "Package price settings"), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["total", "Total price"], ["per-unit", "Per unit"]],
    value: value.variant,
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        variant: newValue
      }));
    }
  }), /*#__PURE__*/React.createElement(Hint, null, "If both package price settings & pricing card settings are present. The package price settings will take precendence. Please pick ony 1!"), /*#__PURE__*/React.createElement(TextInput, {
    label: "Unit",
    value: value.unit,
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        unit: newValue
      }));
    }
  }), /*#__PURE__*/React.createElement(PackagePricePicker, {
    label: "Package price",
    value: value.package_price_id,
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        package_price_id: newValue
      }));
    }
  }));
};
var FeaturedPricingSettings = function FeaturedPricingSettings(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, /*#__PURE__*/React.createElement(H, null, "Pricing cards settings"), /*#__PURE__*/React.createElement(PricingCardPicker, {
    value: value,
    onChange: onChange
  }), /*#__PURE__*/React.createElement(Hint, null, "If both package price settings & pricing card settings are present. The package price settings will take precendence. Please pick ony 1!"));
};
var ListItem$7 = function ListItem(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    },
    value: settings.logo
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Logo link",
    onChange: function onChange(value) {
      return onChangeItem("logo_link", value);
    },
    value: settings.logo_link
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Ribbon",
    onChange: function onChange(value) {
      return onChangeItem("ribbon_text", value);
    },
    value: settings.ribbon_text
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Theme",
    options: [["", "No override"], ["white-bg", "White"], ["light-bg", "Light"], ["dark-bg", "Dark"]],
    value: settings.theme,
    onChange: function onChange(value) {
      return onChangeItem("theme", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Double size",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.double_size,
    onChange: function onChange(value) {
      return onChangeItem("double_size", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    },
    value: settings.icon
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 1",
    onChange: function onChange(value) {
      return onChangeItem("button_1", value);
    },
    value: settings.button_1
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 2",
    onChange: function onChange(value) {
      return onChangeItem("button_2", value);
    },
    value: settings.button_2
  }), /*#__PURE__*/React.createElement(PackagePricingSettings, {
    onChange: function onChange(value) {
      return onChangeItem("package_price_settings", value);
    },
    value: settings.package_price_settings || {}
  }), /*#__PURE__*/React.createElement(FeaturedPricingSettings, {
    onChange: function onChange(value) {
      return onChangeItem("featured_pricing_card_settings", value);
    },
    value: settings.featured_pricing_card_settings || {}
  }));
};
var Admin$$ = function Admin(items, _onChange2, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Variant",
    options: [["col-6", "2 Columns"], ["col-4", "3 Columns"], ["col-3", "4 Columns"]],
    value: settings.variant,
    onChange: function onChange(value) {
      return _onChange2("variant", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Promo code",
    value: settings.promo_code,
    onChange: function onChange(value) {
      return _onChange2("promo_code", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    label: "Cards",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$7, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange2,
    items: items,
    primaryField: "description",
    template: TEMPLATE$1
  }));
};
var Config$10 = {
  title: "Product cards",
  category: "Image + Text"
};
var useGraphQL = function useGraphQL(query, variables) {
  if (variables.input.filters.ids.length === 0) {
    return null;
  }
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache"
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var Widget$10 = function Widget(_ref) {
  var variant = _ref.variant,
    _ref$promo_code = _ref.promo_code,
    promo_code = _ref$promo_code === void 0 ? "" : _ref$promo_code,
    list = _ref.list,
    containerSettings = _ref.containerSettings;
  var _React$useState = React.useState(null),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  var pickedPromoCode = extractPromoCode(React.useContext(PageUrlContext), promo_code);
  var packagePricesData = useGraphQL(PACKAGE_PRICES, {
    input: {
      promoCode: pickedPromoCode,
      filters: {
        ids: list.map(function (li) {
          var _li$package_price_set;
          return (_li$package_price_set = li.package_price_settings) === null || _li$package_price_set === void 0 ? void 0 : _li$package_price_set.package_price_id;
        }).filter(Boolean)
      }
    }
  });
  var pricingCardsData = useGraphQL(FEATURED_PRICING_CARDS, {
    input: {
      promoCode: pickedPromoCode,
      filters: {
        ids: list.map(function (li) {
          var _li$featured_pricing_;
          return (_li$featured_pricing_ = li.featured_pricing_card_settings) === null || _li$featured_pricing_ === void 0 ? void 0 : _li$featured_pricing_.card_id;
        }).filter(Boolean)
      }
    }
  });
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrency);
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "product-cards",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, list.map(function (item) {
    var _packagePricesData$pa, _pricingCardsData$fea;
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: variant + " " + (item.double_size === "yes" ? "double" : "")
    }, /*#__PURE__*/React.createElement(Card$3, {
      item: item,
      packagePrices: packagePricesData === null || packagePricesData === void 0 ? void 0 : (_packagePricesData$pa = packagePricesData.packagePrices) === null || _packagePricesData$pa === void 0 ? void 0 : _packagePricesData$pa.list,
      pricingCards: pricingCardsData === null || pricingCardsData === void 0 ? void 0 : (_pricingCardsData$fea = pricingCardsData.featuredPricingCards) === null || _pricingCardsData$fea === void 0 ? void 0 : _pricingCardsData$fea.list,
      currency: currency
    }));
  }))));
};
var ProductCardsWidget = {
  __proto__: null,
  Widget: Widget$10,
  Admin: Admin$$,
  Config: Config$10,
  Defaults: Defaults$10
};
var Widget$11 = function Widget(_ref) {
  var title = _ref.title,
    description = _ref.description,
    included_label = _ref.included_label,
    button = _ref.button,
    list = _ref.list,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "single-trial",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom-sm text-center"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(description, true))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "trial-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "included"
  }, included_label), list.map(function (category) {
    return /*#__PURE__*/React.createElement("div", {
      key: category.id
    }, /*#__PURE__*/React.createElement("h5", {
      className: "title"
    }, category.title), category.items.map(function (product) {
      return /*#__PURE__*/React.createElement("div", {
        key: product.id,
        className: "product-line"
      }, /*#__PURE__*/React.createElement(Img, {
        src: product.icon,
        variant: "original"
      }), /*#__PURE__*/React.createElement("div", {
        className: "description"
      }, parseMarkdown(product.description, true)));
    }));
  }), button.label && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: button
  })))))));
};
var Config$11 = {
  title: "Single Trial",
  category: "Store"
};
var Defaults$11 = {
  title: "Get your fully functional trial",
  description: "Yours free for 30 days. Technical support is included.",
  included_label: "Included in your trial:",
  button: _extends({}, ButtonSettings.defaults, {
    label: "Start your trial"
  }),
  list: [{
    id: 1,
    title: "Category 1",
    items: [{
      id: 1,
      icon: imagePlaceholder("35"),
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
    }]
  }, {
    id: 2,
    title: "Category 2",
    items: [{
      id: 1,
      icon: imagePlaceholder("35"),
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
    }]
  }, {
    id: 3,
    title: "Category 3",
    items: [{
      id: 1,
      icon: imagePlaceholder("35"),
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
    }]
  }, {
    id: 4,
    title: "Category 4",
    items: [{
      id: 1,
      icon: imagePlaceholder("35"),
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
    }]
  }],
  containerSettings: {
    theme: "white",
    spacing: ""
  }
};
var InnerItem = function InnerItem(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    },
    value: settings.icon
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }));
};
var InnerList = function InnerList(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Products",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(InnerItem, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: function onChangeList(key, newItems) {
      return onChange(newItems);
    },
    items: value,
    primaryField: "description",
    template: {
      icon: imagePlaceholder("35"),
      description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
    }
  });
};
var ListItem$8 = function ListItem(_ref4) {
  var settings = _ref4.settings,
    onChangeItem = _ref4.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(InnerList, {
    value: settings.items,
    onChange: function onChange(value) {
      return onChangeItem("items", value);
    }
  }));
};
var Admin$10 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return _onChange("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return _onChange("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Included (label)",
    onChange: function onChange(value) {
      return _onChange("included_label", value);
    },
    value: settings.included_label
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    onChange: function onChange(value) {
      return _onChange("button", value);
    },
    value: settings.button
  }), /*#__PURE__*/React.createElement(List, {
    label: "Categories",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$8, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    primaryField: "title",
    template: {
      title: "Category",
      items: [{
        icon: imagePlaceholder("35"),
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
      }]
    }
  }));
};
var SingleTrialWidget = {
  __proto__: null,
  Widget: Widget$11,
  Admin: Admin$10,
  Config: Config$11,
  Defaults: Defaults$11
};
var Widget$12 = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    list = _ref.list,
    alignment = _ref.alignment;
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "links-with-icon",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("nav", {
    className: "links-icon-navigation " + alignment
  }, list.map(function (item) {
    return /*#__PURE__*/React.createElement(A, {
      key: item.id,
      href: item.link.link,
      id: item.link.id ? item.link.id : "",
      target: item.link.target,
      rel: item.link.rel,
      title: item.link.label,
      className: "link " + item.link.className
    }, /*#__PURE__*/React.createElement("span", {
      className: "link-icon"
    }, /*#__PURE__*/React.createElement(Img, {
      src: item.icon,
      variant: "thumb"
    })), item.link.label);
  }))));
};
var Config$12 = {
  title: "Links with icon",
  category: "Navigation"
};
var Defaults$12 = {
  list: [{
    id: 1,
    link: LinkSettings.defaults,
    icon: imagePlaceholder("24x24")
  }, {
    id: 2,
    link: LinkSettings.defaults,
    icon: imagePlaceholder("24x24")
  }, {
    id: 3,
    link: LinkSettings.defaults,
    icon: imagePlaceholder("24x24")
  }],
  alignment: "left",
  containerSettings: {
    spacing: "none"
  }
};
var ListItem$9 = function ListItem(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    value: settings.link
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    },
    value: settings.icon
  }));
};
var Admin$11 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Alignment",
    options: [["left", "Left"], ["center", "Center"], ["right", "Right"]],
    value: settings.alignment,
    onChange: function onChange(value) {
      return _onChange("alignment", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    label: "Links with icon",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$9, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: items,
    template: {
      icon: imagePlaceholder("24x24"),
      link: LinkSettings.defaults
    },
    primaryField: "link.label",
    onChangeList: _onChange
  }));
};
var LinksWithIconWidget = {
  __proto__: null,
  Widget: Widget$12,
  Admin: Admin$11,
  Config: Config$12,
  Defaults: Defaults$12
};
var buildDefaultItem = function buildDefaultItem(label, link) {
  if (link === void 0) {
    link = "#";
  }
  return _extends({}, SECTION_ITEM_DEFAULTS, {
    link: _extends({}, LinkSettings.defaults, {
      link: link,
      label: label
    })
  });
};
var SECTION_ITEM_DEFAULTS = {
  icon: imagePlaceholder("40x40"),
  link: _extends({}, LinkSettings.defaults, {
    label: "V-Ray for 3ds Max"
  }),
  prices: [],
  price_meta: "",
  tooltip: {
    title: "",
    description: "",
    icons: []
  },
  tag: "",
  ribbon: "",
  fake_ribbon: "no"
};
var LEFT_SECTION_DEFAULTS = {
  title: "Ecosystem",
  items: [_extends({}, buildDefaultItem("V-Ray Collection"), {
    prices: Currency.all.map(function (cur) {
      return {
        currency: cur,
        value: "629"
      };
    }),
    price_meta: "year",
    ribbon: "All in one",
    tooltip: {
      title: "What's included",
      description: "Get V-Ray, Phoenix, Chaos Vantage, Chaous Cloud & Chaos Scans in a single collection.",
      icons: [imagePlaceholder("40x40"), imagePlaceholder("40x40"), imagePlaceholder("40x40"), imagePlaceholder("40x40"), imagePlaceholder("40x40")]
    }
  }), _extends({}, buildDefaultItem("Chaos cloud credits"), {
    prices: Currency.all.map(function (cur) {
      return {
        currency: cur,
        value: "0.90"
      };
    }),
    price_meta: "credit"
  })]
};
var MIDDLE_SECTION_DEFAULTS = {
  title: "Commercial products",
  items_left: [_extends({}, buildDefaultItem("V-Ray for 3ds Max"), {
    fake_ribbon: "yes"
  }), buildDefaultItem("V-Ray for SketchUp", ""), buildDefaultItem("V-Ray for Maya", ""), buildDefaultItem("V-Ray for Rhino", ""), buildDefaultItem("V-Ray Render Node", ""), buildDefaultItem("V-Ray for Revit", ""), buildDefaultItem("V-Ray for Cinema 4D", ""), buildDefaultItem("V-Ray for Unreal", ""), buildDefaultItem("V-Ray for Houdini", ""), buildDefaultItem("V-Ray for Modo", ""), buildDefaultItem("V-Ray for Nuke", "")],
  items_right: [_extends({}, buildDefaultItem("Phoenix for 3ds Max"), {
    fake_ribbon: "yes"
  }), buildDefaultItem("Phoenix for 3ds Maya", ""), _extends({}, buildDefaultItem("Chaos Vantage", ""), {
    tag: "New"
  }), buildDefaultItem("Chaos Scans", ""), buildDefaultItem("Pdplayer", "")]
};
var RIGHT_SECTION_DEFAULTS = {
  title: "Educational products",
  items: [_extends({}, buildDefaultItem("V-Ray Edu Collection"), {
    prices: Currency.all.map(function (cur) {
      return {
        currency: cur,
        value: "134"
      };
    }),
    price_meta: "year",
    ribbon: "All in one",
    tooltip: {
      title: "What's included",
      description: "Get V-Ray, Phoenix, Chaos Vantage, Chaous Cloud & Chaos Scans in a single collection.",
      icons: [imagePlaceholder("40x40"), imagePlaceholder("40x40"), imagePlaceholder("40x40"), imagePlaceholder("40x40"), imagePlaceholder("40x40")]
    }
  }), buildDefaultItem("V-Ray for 3ds Max"), buildDefaultItem("V-Ray for SketchUp", ""), buildDefaultItem("V-Ray for Maya", ""), buildDefaultItem("V-Ray for Rhino", ""), buildDefaultItem("V-Ray Render Node", ""), buildDefaultItem("V-Ray for Revit", ""), buildDefaultItem("V-Ray for Cinema 4D", ""), buildDefaultItem("V-Ray for Unreal", ""), buildDefaultItem("V-Ray for Houdini", ""), buildDefaultItem("V-Ray for Modo", ""), buildDefaultItem("V-Ray for Nuke", ""), buildDefaultItem("Phoenix for 3ds Max", ""), buildDefaultItem("Phoenix for 3ds Maya", ""), buildDefaultItem("Chaos Vantage", ""), buildDefaultItem("Chaos Scans", ""), buildDefaultItem("Pdplayer", "")]
};
var Defaults$13 = {
  show_more_label: "Show all",
  show_less_label: "Show less",
  left: LEFT_SECTION_DEFAULTS,
  middle: MIDDLE_SECTION_DEFAULTS,
  right: RIGHT_SECTION_DEFAULTS,
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ToolTipIconsList = function ToolTipIconsList(_ref) {
  var icons = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Tooltip icons",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ImagePicker, {
        label: "Icon",
        value: settings.icon,
        onChange: function onChange(value) {
          return onChangeItem("icon", value);
        }
      });
    },
    onChangeList: function onChangeList(_key, listValue) {
      return onChange(listValue.map(function (lv) {
        return lv.icon;
      }));
    },
    items: icons.map(function (icon, idx) {
      return {
        id: idx,
        icon: icon
      };
    }),
    template: {
      icon: imagePlaceholder("40x40")
    },
    primaryField: "icon.name"
  });
};
var PricesListInput = function PricesListInput(_ref2) {
  var prices = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Prices",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
        label: "Currency",
        options: Currency.all.map(function (cur) {
          return [cur, cur];
        }),
        value: settings.currency,
        onChange: function onChange(value) {
          return onChangeItem("currency", value);
        }
      }), /*#__PURE__*/React.createElement(TextInput, {
        label: "Value",
        value: settings.value,
        onChange: function onChange(value) {
          return onChangeItem("value", value);
        }
      }));
    },
    onChangeList: function onChangeList(_key, listValue) {
      return onChange(listValue.map(function (lv) {
        return {
          currency: lv.currency,
          value: lv.value
        };
      }));
    },
    items: prices.map(function (price, idx) {
      return {
        id: idx,
        currency: price.currency,
        value: price.value
      };
    }),
    template: {
      price: {
        currency: "eur",
        value: ""
      }
    },
    primaryField: "currency"
  });
};
var TooltipInput = function TooltipInput(_ref3) {
  var tooltip = _ref3.value,
    _onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Tooltip title",
    value: tooltip.title,
    onChange: function onChange(value) {
      return _onChange(_extends({}, tooltip, {
        title: value
      }));
    }
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Tooltip description",
    value: tooltip.description,
    onChange: function onChange(value) {
      return _onChange(_extends({}, tooltip, {
        description: value
      }));
    }
  }), /*#__PURE__*/React.createElement(ToolTipIconsList, {
    value: tooltip.icons,
    onChange: function onChange(value) {
      return _onChange(_extends({}, tooltip, {
        icons: value
      }));
    }
  }));
};
var SectionItemInput = function SectionItemInput(_ref4) {
  var item = _ref4.value,
    _onChange2 = _ref4.onChange;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: item.icon,
    onChange: function onChange(value) {
      return _onChange2("icon", value);
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    value: item.link,
    onChange: function onChange(value) {
      return _onChange2("link", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Price meta",
    value: item.price_meta,
    onChange: function onChange(value) {
      return _onChange2("price_meta", value);
    }
  }), /*#__PURE__*/React.createElement(PricesListInput, {
    value: item.prices,
    onChange: function onChange(value) {
      return _onChange2("prices", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Tag",
    value: item.tag,
    onChange: function onChange(value) {
      return _onChange2("tag", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Ribbon",
    value: item.ribbon,
    onChange: function onChange(value) {
      return _onChange2("ribbon", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "White space above link/image",
    options: [["no", "No"], ["yes", "Yes"]],
    value: item.fake_ribbon,
    onChange: function onChange(value) {
      return _onChange2("fake_ribbon", value);
    }
  }), /*#__PURE__*/React.createElement(TooltipInput, {
    value: item.tooltip,
    onChange: function onChange(value) {
      return _onChange2("tooltip", value);
    }
  }));
};
var SectionItemsList = function SectionItemsList(_ref5) {
  var label = _ref5.label,
    items = _ref5.value,
    onChange = _ref5.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(SectionItemInput, {
        value: settings,
        onChange: onChangeItem
      });
    },
    onChangeList: function onChangeList(_key, listValue) {
      return onChange(listValue);
    },
    items: items,
    template: SECTION_ITEM_DEFAULTS,
    primaryField: "link.label"
  });
};
var MiddleSectionInput = function MiddleSectionInput(_ref6) {
  var label = _ref6.label,
    section = _ref6.value,
    _onChange3 = _ref6.onChange;
  return /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement("summary", null, label, " - ", section.title), /*#__PURE__*/React.createElement("div", {
    style: {
      border: "solid #555555 1px"
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: section.title,
    onChange: function onChange(value) {
      return _onChange3(_extends({}, section, {
        title: value
      }));
    }
  }), /*#__PURE__*/React.createElement(SectionItemsList, {
    label: "Items: left",
    value: section.items_left,
    onChange: function onChange(value) {
      return _onChange3(_extends({}, section, {
        items_left: value
      }));
    }
  }), /*#__PURE__*/React.createElement(SectionItemsList, {
    label: "Items: right",
    value: section.items_right,
    onChange: function onChange(value) {
      return _onChange3(_extends({}, section, {
        items_right: value
      }));
    }
  })));
};
var SectionInput = function SectionInput(_ref7) {
  var label = _ref7.label,
    section = _ref7.value,
    _onChange4 = _ref7.onChange;
  return /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement("summary", null, label, " - ", section.title), /*#__PURE__*/React.createElement("div", {
    style: {
      border: "solid #555555 1px"
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: section.title,
    onChange: function onChange(value) {
      return _onChange4(_extends({}, section, {
        title: value
      }));
    }
  }), /*#__PURE__*/React.createElement(SectionItemsList, {
    label: "Items",
    value: section.items,
    onChange: function onChange(value) {
      return _onChange4(_extends({}, section, {
        items: value
      }));
    }
  })));
};
var Admin$12 = function Admin(_items, _onChange5, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Show more label",
    value: settings.show_more_label,
    onChange: function onChange(value) {
      return _onChange5("show_more_label", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Show less label",
    value: settings.show_less_label,
    onChange: function onChange(value) {
      return _onChange5("show_less_label", value);
    }
  }), /*#__PURE__*/React.createElement(SectionInput, {
    label: "Left section",
    value: settings.left,
    onChange: function onChange(value) {
      return _onChange5("left", value);
    }
  }), /*#__PURE__*/React.createElement(MiddleSectionInput, {
    label: "Middle section",
    value: settings.middle,
    onChange: function onChange(value) {
      return _onChange5("middle", value);
    }
  }), /*#__PURE__*/React.createElement(SectionInput, {
    label: "Right section",
    value: settings.right,
    onChange: function onChange(value) {
      return _onChange5("right", value);
    }
  }));
};
var SectionTitle = function SectionTitle(_ref) {
  var className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    className: "section-header"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "title " + className
  }, title));
};
var LabelsWrapper = function LabelsWrapper(_ref2) {
  var link = _ref2.link,
    id = _ref2.id,
    target = _ref2.target,
    rel = _ref2.rel,
    className = _ref2.className,
    children = _ref2.children,
    showTooltip = _ref2.showTooltip;
  return /*#__PURE__*/React.createElement(React.Fragment, null, link && /*#__PURE__*/React.createElement(A, {
    onMouseEnter: function onMouseEnter() {
      return showTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      return showTooltip(false);
    },
    href: link,
    id: id,
    target: target,
    rel: rel,
    className: "product-link " + className
  }, children), !link && /*#__PURE__*/React.createElement("div", {
    style: {
      cursor: "default"
    },
    onMouseEnter: function onMouseEnter() {
      return showTooltip(true);
    },
    onMouseLeave: function onMouseLeave() {
      return showTooltip(false);
    },
    className: "product-link"
  }, children));
};
var shouldShowTooltip = function shouldShowTooltip(tooltip) {
  return tooltip && tooltip.title && tooltip.description;
};
var Tooltip = function Tooltip(_ref3) {
  var title = _ref3.title,
    description = _ref3.description,
    icons = _ref3.icons,
    className = _ref3.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "product-tooltip " + className
  }, /*#__PURE__*/React.createElement("h6", null, title), /*#__PURE__*/React.createElement("p", null, description), /*#__PURE__*/React.createElement("div", {
    className: "icons"
  }, icons.map(function (icon, idx) {
    return /*#__PURE__*/React.createElement(Image, {
      key: idx,
      src: icon,
      variant: "original"
    });
  })));
};
var Price$2 = function Price(_ref4) {
  var prices = _ref4.prices,
    priceMeta = _ref4.priceMeta,
    currency = _ref4.currency;
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  if (!priceMeta) {
    return null;
  }
  var price = prices.find(function (pr) {
    return pr.currency === currency;
  });
  if (!price) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, Currency.prettyPrint(price.value, price.currency, country), /*#__PURE__*/React.createElement("span", {
    className: "muted"
  }, " /", priceMeta));
};
var Product = function Product(_ref5) {
  var currency = _ref5.currency,
    icon = _ref5.icon,
    link = _ref5.link,
    prices = _ref5.prices,
    price_meta = _ref5.price_meta,
    tooltip = _ref5.tooltip,
    tag = _ref5.tag,
    ribbon = _ref5.ribbon,
    fake_ribbon = _ref5.fake_ribbon;
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "product"
  }, ribbon && /*#__PURE__*/React.createElement("span", {
    className: "ribbon"
  }, ribbon), fake_ribbon === "yes" && /*#__PURE__*/React.createElement("div", {
    className: "fake-ribbon"
  }), /*#__PURE__*/React.createElement(LabelsWrapper, _extends({
    showTooltip: setOpen
  }, link), /*#__PURE__*/React.createElement("div", {
    className: "labels"
  }, /*#__PURE__*/React.createElement(Image, {
    src: icon,
    variant: "original"
  }), /*#__PURE__*/React.createElement("span", {
    className: shouldShowTooltip(tooltip) ? "accented" : ""
  }, link.label), tag && /*#__PURE__*/React.createElement("span", {
    className: "tag"
  }, tag)), /*#__PURE__*/React.createElement(Price$2, {
    prices: prices,
    priceMeta: price_meta,
    currency: currency
  })), shouldShowTooltip(tooltip) && /*#__PURE__*/React.createElement(Tooltip, _extends({
    className: open ? "visible" : ""
  }, tooltip)));
};
var ProductsList = function ProductsList(_ref6) {
  var currency = _ref6.currency,
    items = _ref6.items,
    showMoreLabel = _ref6.showMoreLabel,
    showLessLabel = _ref6.showLessLabel,
    openThreshold = _ref6.openThreshold,
    open = _ref6.open,
    onOpen = _ref6.onOpen,
    onClose = _ref6.onClose;
  if (items.length > openThreshold && !open) {
    return items.slice(0, openThreshold - 1).map(function (item, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "product-wrapper " + (idx === 0 ? "first" : "")
      }, /*#__PURE__*/React.createElement(Product, _extends({
        currency: currency
      }, item)));
    }).concat([/*#__PURE__*/React.createElement("div", {
      className: "toggle-trigger",
      key: items.length
    }, /*#__PURE__*/React.createElement(A, {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        onOpen();
      }
    }, showMoreLabel))]);
  }
  if (items.length > openThreshold && open) {
    return items.map(function (item, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: "product-wrapper " + (idx === 0 ? "first" : "")
      }, /*#__PURE__*/React.createElement(Product, _extends({
        currency: currency
      }, item)), " ");
    }).concat([/*#__PURE__*/React.createElement("div", {
      className: "toggle-trigger",
      key: items.length
    }, /*#__PURE__*/React.createElement(A, {
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        onClose();
      }
    }, showLessLabel))]);
  }
  return items.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "product-wrapper " + (idx === 0 ? "first" : "")
    }, /*#__PURE__*/React.createElement(Product, _extends({
      currency: currency
    }, item)), " ");
  });
};
var DesktopVersion = function DesktopVersion(_ref7) {
  var currency = _ref7.currency,
    left = _ref7.left,
    middle = _ref7.middle,
    right = _ref7.right,
    show_more_label = _ref7.show_more_label,
    show_less_label = _ref7.show_less_label;
  var _React$useState2 = React.useState({
      left: false,
      middleLeft: false,
      middleRight: false,
      right: false
    }),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var openThreshold = 6;
  return /*#__PURE__*/React.createElement("div", {
    className: "desktop"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    className: "bottom-border",
    title: left.title
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-6 border-left"
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    className: "bottom-border",
    title: middle.title
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-3 border-left"
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    className: "bottom-border",
    title: right.title
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(ProductsList, {
    currency: currency,
    items: left.items,
    showMoreLabel: show_more_label,
    showLessLabel: show_less_label,
    openThreshold: openThreshold,
    open: open.left,
    onOpen: function onOpen() {
      return setOpen(_extends({}, open, {
        left: true
      }));
    },
    onClose: function onClose() {
      return setOpen(_extends({}, open, {
        left: false
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-3 border-left"
  }, /*#__PURE__*/React.createElement(ProductsList, {
    currency: currency,
    items: middle.items_left,
    showMoreLabel: show_more_label,
    showLessLabel: show_less_label,
    openThreshold: openThreshold,
    open: open.middleLeft,
    onOpen: function onOpen() {
      return setOpen(_extends({}, open, {
        middleLeft: true
      }));
    },
    onClose: function onClose() {
      return setOpen(_extends({}, open, {
        middleLeft: false
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(ProductsList, {
    currency: currency,
    items: middle.items_right,
    showMoreLabel: show_more_label,
    showLessLabel: show_less_label,
    openThreshold: openThreshold,
    open: open.middleRight,
    onOpen: function onOpen() {
      return setOpen(_extends({}, open, {
        middleRight: true
      }));
    },
    onClose: function onClose() {
      return setOpen(_extends({}, open, {
        middleRight: false
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-3 border-left"
  }, /*#__PURE__*/React.createElement(ProductsList, {
    currency: currency,
    items: right.items,
    showMoreLabel: show_more_label,
    showLessLabel: show_less_label,
    openThreshold: openThreshold,
    open: open.right,
    onOpen: function onOpen() {
      return setOpen(_extends({}, open, {
        right: true
      }));
    },
    onClose: function onClose() {
      return setOpen(_extends({}, open, {
        right: false
      }));
    }
  }))));
};
var MobileVersion = function MobileVersion(_ref8) {
  var currency = _ref8.currency,
    left = _ref8.left,
    middle = _ref8.middle,
    right = _ref8.right,
    show_more_label = _ref8.show_more_label,
    show_less_label = _ref8.show_less_label;
  var _React$useState3 = React.useState({
      left: false,
      middle: false,
      right: false
    }),
    open = _React$useState3[0],
    setOpen = _React$useState3[1];
  var openThreshold = 4;
  return /*#__PURE__*/React.createElement("div", {
    className: "mobile"
  }, /*#__PURE__*/React.createElement(SectionTitle, {
    title: left.title
  }), /*#__PURE__*/React.createElement(ProductsList, {
    currency: currency,
    items: left.items,
    showMoreLabel: show_more_label,
    showLessLabel: show_less_label,
    openThreshold: openThreshold,
    open: open.left,
    onOpen: function onOpen() {
      return setOpen(_extends({}, open, {
        left: true
      }));
    },
    onClose: function onClose() {
      return setOpen(_extends({}, open, {
        left: false
      }));
    }
  }), /*#__PURE__*/React.createElement(SectionTitle, {
    title: middle.title
  }), /*#__PURE__*/React.createElement(ProductsList, {
    currency: currency,
    items: middle.items_left.concat(middle.items_right),
    showMoreLabel: show_more_label,
    showLessLabel: show_less_label,
    openThreshold: openThreshold,
    open: open.middle,
    onOpen: function onOpen() {
      return setOpen(_extends({}, open, {
        middle: true
      }));
    },
    onClose: function onClose() {
      return setOpen(_extends({}, open, {
        middle: false
      }));
    }
  }), /*#__PURE__*/React.createElement(SectionTitle, {
    title: right.title
  }), /*#__PURE__*/React.createElement(ProductsList, {
    currency: currency,
    items: right.items,
    showMoreLabel: show_more_label,
    showLessLabel: show_less_label,
    openThreshold: openThreshold,
    open: open.right,
    onOpen: function onOpen() {
      return setOpen(_extends({}, open, {
        right: true
      }));
    },
    onClose: function onClose() {
      return setOpen(_extends({}, open, {
        right: false
      }));
    }
  }));
};
var Widget$13 = function Widget(_ref9) {
  var left = _ref9.left,
    right = _ref9.right,
    middle = _ref9.middle,
    show_more_label = _ref9.show_more_label,
    show_less_label = _ref9.show_less_label,
    containerSettings = _ref9.containerSettings;
  var isAdmin = React.useContext(AdminUserContext);
  var initialCurrency = React.useContext(CurrencyContext);
  var _React$useState4 = React.useState(initialCurrency),
    currency = _React$useState4[0],
    setCurrency = _React$useState4[1];
  useLocalizationCurrency(initialCurrency, setCurrency);
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "product-list",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, isAdmin && /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("select", {
    value: currency,
    onChange: function onChange(e) {
      return setCurrency(e.target.value);
    }
  }, Currency.all.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      key: c,
      value: c
    }, c.toUpperCase());
  }))), /*#__PURE__*/React.createElement(DesktopVersion, {
    currency: currency,
    left: left,
    right: right,
    middle: middle,
    show_more_label: show_more_label,
    show_less_label: show_less_label
  }), /*#__PURE__*/React.createElement(MobileVersion, {
    currency: currency,
    left: left,
    right: right,
    middle: middle,
    show_more_label: show_more_label,
    show_less_label: show_less_label
  })));
};
var Config$13 = {
  title: "Product list",
  category: "Image + Text"
};
var ProductListWidget = {
  __proto__: null,
  Widget: Widget$13,
  Admin: Admin$12,
  Defaults: Defaults$13,
  Config: Config$13
};
var Cards = function Cards(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards-wrapper"
  }, children));
};
var Ribbon = function Ribbon(_ref) {
  var item = _ref.item;
  return item.ribbon ? /*#__PURE__*/React.createElement("div", {
    className: "ribbon " + item.ribbonTheme
  }, item.ribbon) : /*#__PURE__*/React.createElement("div", {
    className: "ribbon blank"
  });
};
var PromoNote = function PromoNote(_ref) {
  var _item$prices;
  var item = _ref.item;
  if ((_item$prices = item.prices) !== null && _item$prices !== void 0 && _item$prices.has_promo && item.promoNote) {
    return /*#__PURE__*/React.createElement("div", {
      className: "promo-note"
    }, item.promoNote);
  }
  return null;
};
var Headings$1 = function (_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    item = _ref.item;
  return /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, /*#__PURE__*/React.createElement(PromoNote, {
    item: item
  }), /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "sub-title"
  }, subTitle));
};
var toggleWidth = function toggleWidth(items) {
  switch (items.length) {
    case 1:
      return 100;
    case 2:
      return 50;
    case 3:
      return 34;
    default:
      return Math.floor(100 / items.length);
  }
};
var Switch = function Switch(_ref) {
  var discountNoteTheme = _ref.discountNoteTheme,
    card = _ref.card,
    currentItem = _ref.currentItem,
    currency = _ref.currency,
    onChange = _ref.onChange;
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  var locale = React.useContext(LocaleContext);
  var hideSwitch = card.hideSwitch,
    items = card.items;
  var skipBorder = items.length === 1;
  if (hideSwitch && items.length === 1) {
    return null;
  }
  var width = toggleWidth(items);
  var translateX = 100 * items.findIndex(function (item) {
    return item.id === currentItem.id;
  });
  var discountNotes = {};
  items.forEach(function (item) {
    return discountNotes[item.id] = prepareDiscountNote(item, currency, card, country);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "switch " + (skipBorder ? "hidden-border" : "") + " locale-" + locale
  }, /*#__PURE__*/React.createElement("div", {
    className: "toggle",
    style: {
      width: width + "%",
      transform: "translateX(" + translateX + "%)"
    }
  }), items.map(function (item) {
    var _item$prices;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.id
    }, /*#__PURE__*/React.createElement("div", {
      className: item.id === currentItem.id ? "item active" : "item",
      onClick: function onClick() {
        return onChange(item.id);
      }
    }, item.title, /*#__PURE__*/React.createElement("span", {
      className: "item-tail"
    }, !((_item$prices = item.prices) !== null && _item$prices !== void 0 && _item$prices.has_promo) && item.discountNote && /*#__PURE__*/React.createElement("span", {
      className: "discount-note " + discountNoteTheme,
      style: {
        opacity: item.id === currentItem.id ? 1 : 0
      }
    }, discountNotes[item.id]))));
  }));
};
var RegularPrice$1 = function RegularPrice(_ref) {
  var item = _ref.item,
    currency = _ref.currency,
    card = _ref.card;
  var _React$useContext = React.useContext(GeoIpContext),
    country = _React$useContext.country;
  var defaultValue = extractRegularPrice(item, currency);
  var price = preparePrice(defaultValue, item);
  var _Currency$split = Currency.split(price),
    whole = _Currency$split[0],
    decimal = _Currency$split[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, card.infoTitle ? /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "major"
  }, card.infoTitle)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "major"
  }, Currency.prettyPrint(parseInt(whole), currency, country)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("div", {
    className: "minor"
  }, decimal)), /*#__PURE__*/React.createElement("span", {
    className: "meta"
  }, item.priceLabel))), /*#__PURE__*/React.createElement("div", {
    className: "descriptions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: preparePriceDescription(defaultValue, item, currency, country, card)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "promo-description",
    dangerouslySetInnerHTML: {
      __html: prepareDescription(defaultValue, item, currency, country, card)
    }
  })));
};
var PromoPrice$1 = function PromoPrice(_ref2) {
  var item = _ref2.item,
    currency = _ref2.currency,
    card = _ref2.card;
  var _React$useContext2 = React.useContext(GeoIpContext),
    country = _React$useContext2.country;
  var defaultRegularValue = extractRegularPrice(item, currency);
  var defaultPromoPrice = extractPromoPrice(item, currency);
  var regularPrice = preparePrice(defaultRegularValue, item);
  var promoPrice = preparePrice(defaultPromoPrice, item);
  var _Currency$split2 = Currency.split(regularPrice),
    whole = _Currency$split2[0],
    decimal = _Currency$split2[1];
  var _Currency$split3 = Currency.split(promoPrice),
    promoWhole = _Currency$split3[0],
    promoDecimal = _Currency$split3[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "price promo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, card.infoTitle ? /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "major"
  }, card.infoTitle)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "old-value"
  }, /*#__PURE__*/React.createElement("div", {
    className: "old-major"
  }, Currency.prettyPrint(parseInt(whole), currency, country)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("div", {
    className: "old-minor"
  }, decimal)), /*#__PURE__*/React.createElement("div", {
    className: "major"
  }, Currency.prettyPrint(parseInt(promoWhole), currency, country)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("div", {
    className: "minor"
  }, promoDecimal)), /*#__PURE__*/React.createElement("span", {
    className: "meta"
  }, item.priceLabel))), /*#__PURE__*/React.createElement("div", {
    className: "descriptions"
  }, /*#__PURE__*/React.createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: preparePriceDescription(defaultPromoPrice, item, currency, country, card)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "promo-description",
    dangerouslySetInnerHTML: {
      __html: preparePromoDescription(defaultPromoPrice, defaultRegularValue, currency, item.pricePromoDescription, country)
    }
  })));
};
var Price$3 = function Price(_ref3) {
  var _item$prices, _item$prices2, _item$prices3;
  var item = _ref3.item,
    currency = _ref3.currency,
    card = _ref3.card;
  var validCurrency = (_item$prices = item.prices) !== null && _item$prices !== void 0 && _item$prices.override_currency ? (_item$prices2 = item.prices) === null || _item$prices2 === void 0 ? void 0 : _item$prices2.override_currency : currency;
  if ((_item$prices3 = item.prices) !== null && _item$prices3 !== void 0 && _item$prices3.has_promo) {
    return /*#__PURE__*/React.createElement(PromoPrice$1, {
      item: item,
      currency: validCurrency,
      card: card
    });
  } else {
    return /*#__PURE__*/React.createElement(RegularPrice$1, {
      item: item,
      currency: validCurrency,
      card: card
    });
  }
};
var ButtonAndDescription = function ButtonAndDescription(_ref) {
  var _item$ratePlanDetails, _item$ratePlanDetails2, _item$prices, _item$ratePlanDetails3;
  var item = _ref.item,
    currency = _ref.currency,
    cardRef = _ref.cardRef;
  var _React$useState = React.useState(false),
    visible = _React$useState[0],
    setVisible = _React$useState[1];
  useInViewPort(cardRef, null, function (visibility) {
    return setVisible(visibility);
  });
  React.useEffect(function () {
    if (visible) {
      registerProductView(item.ratePlanDetails);
    }
  }, [item, visible]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "button-wrapper"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: item.button,
    productInfo: {
      productCode: (_item$ratePlanDetails = item.ratePlanDetails) === null || _item$ratePlanDetails === void 0 ? void 0 : _item$ratePlanDetails.id,
      quantity: ((_item$ratePlanDetails2 = item.ratePlanDetails) === null || _item$ratePlanDetails2 === void 0 ? void 0 : _item$ratePlanDetails2.min_qty) || 1,
      promoCode: (_item$prices = item.prices) !== null && _item$prices !== void 0 && _item$prices.has_promo ? (_item$ratePlanDetails3 = item.ratePlanDetails) === null || _item$ratePlanDetails3 === void 0 ? void 0 : _item$ratePlanDetails3.code : "",
      currency: currency,
      ratePlanDetails: item.ratePlanDetails
    },
    upsellEnabled: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "button-description",
    dangerouslySetInnerHTML: {
      __html: item.buttonDescription
    }
  }));
};
var ICONS = ["SketchUp.svg", "3dsMax.svg", "Maya.svg", "Revit.svg", "Rhino.png", "Cinema4D.png", "Houdini.svg", "Unreal.svg", "Nuke.svg"];
var TOOLTIP_ICON = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTggMTQuNjY2N0MxMS42ODE5IDE0LjY2NjcgMTQuNjY2NyAxMS42ODE5IDE0LjY2NjcgOC4wMDAwNEMxNC42NjY3IDQuMzE4MTQgMTEuNjgxOSAxLjMzMzM3IDggMS4zMzMzN0M0LjMxODEgMS4zMzMzNyAxLjMzMzM0IDQuMzE4MTQgMS4zMzMzNCA4LjAwMDA0QzEuMzMzMzQgMTEuNjgxOSA0LjMxODEgMTQuNjY2NyA4IDE0LjY2NjdaIiBzdHJva2U9IiM4MjgyODIiIHN0cm9rZS13aWR0aD0iMS4yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTYuNjY2NjcgNi42NjY3NUg4LjEyMTIyVjExLjMzMzRNOC4xMjEyMiAxMS4zMzM0SDYuNjY2NjdNOC4xMjEyMiAxMS4zMzM0SDkuMzMzMzQiIHN0cm9rZT0iIzgyODI4MiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik04IDQuNjY2NzVIOC4wMDY2NyIgc3Ryb2tlPSIjODI4MjgyIiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
var Tooltip$1 = function Tooltip(_ref) {
  var title = _ref.title,
    description = _ref.description,
    icon = _ref.icon,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: "feature-tooltip " + className
  }, /*#__PURE__*/React.createElement("div", {
    className: "feature-heading"
  }, icon && /*#__PURE__*/React.createElement(Image, {
    src: icon,
    variant: "original",
    showCredits: false
  }), /*#__PURE__*/React.createElement("h6", {
    dangerouslySetInnerHTML: {
      __html: title
    }
  })), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), !icon && /*#__PURE__*/React.createElement("div", {
    className: "icons"
  }, ICONS.map(function (icon, idx) {
    return /*#__PURE__*/React.createElement("img", {
      key: idx,
      src: "/images/" + icon
    });
  })));
};
var isTooltipPresent = function isTooltipPresent(feature) {
  return feature.tooltip_title || feature.custom_tooltip_title;
};
var Features = function Features(_ref2) {
  var features = _ref2.features;
  return /*#__PURE__*/React.createElement("ul", {
    className: "features"
  }, features.map(function (feature, idx) {
    var _React$useState = React.useState(false),
      open = _React$useState[0],
      setOpen = _React$useState[1];
    return /*#__PURE__*/React.createElement("li", {
      className: "feature",
      key: idx
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: feature.description
      }
    }), isTooltipPresent(feature) && /*#__PURE__*/React.createElement("img", {
      src: TOOLTIP_ICON,
      className: "tooltip-trigger",
      onMouseEnter: function onMouseEnter() {
        return setOpen(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setOpen(false);
      }
    })), isTooltipPresent(feature) && /*#__PURE__*/React.createElement(Tooltip$1, {
      className: open ? "visible" : "",
      title: feature.tooltip_title || feature.custom_tooltip_title,
      description: feature.tooltip_description || feature.custom_tooltip_description,
      icon: feature.custom_tooltip_icon
    }));
  }));
};
var Card$4 = function Card(_ref) {
  var tabCard = _ref.tabCard,
    currency = _ref.currency,
    focused = _ref.focused,
    applyFocus = _ref.applyFocus,
    discountNoteTheme = _ref.discountNoteTheme;
  var cardRef = React.useRef(null);
  var card = tabCard.card;
  var title = card.title,
    subTitle = card.subTitle;
  var defaultItem = card.items && card.items.find(function (i) {
    return i["default"];
  });
  var _React$useState = React.useState(card.items && (defaultItem && defaultItem.id || card.items[0] && card.items[0].id)),
    cardItemId = _React$useState[0],
    setCardItemId = _React$useState[1];
  var item = cardItemId ? card.items.find(function (i) {
    return i.id === cardItemId;
  }) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-wrapper currency-" + currency
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-top " + (focused ? "focused" : ""),
    ref: cardRef
  }, applyFocus && /*#__PURE__*/React.createElement("div", {
    className: "level-1 " + (focused ? "focused" : "")
  }), /*#__PURE__*/React.createElement("div", {
    className: "level-2"
  }, /*#__PURE__*/React.createElement(Ribbon, {
    item: item
  })), applyFocus && /*#__PURE__*/React.createElement("div", {
    className: "level-3 " + (focused ? "focused" : "")
  })), /*#__PURE__*/React.createElement("div", {
    className: "card " + (focused ? "focused" : "")
  }, /*#__PURE__*/React.createElement(Headings$1, {
    title: title,
    subTitle: subTitle,
    item: item
  }), /*#__PURE__*/React.createElement(Switch, {
    discountNoteTheme: discountNoteTheme,
    currentItem: item,
    card: card,
    currency: currency,
    onChange: function onChange(itemId) {
      if (itemId !== cardItemId) {
        setCardItemId(itemId);
      }
    }
  }), /*#__PURE__*/React.createElement(Price$3, {
    item: item,
    currency: currency,
    card: card
  }), /*#__PURE__*/React.createElement(ButtonAndDescription, {
    item: item,
    currency: currency,
    cardRef: cardRef
  }), /*#__PURE__*/React.createElement(Features, {
    features: card.features
  })));
};
var Link$2 = function Link(_ref) {
  var settings = _ref.settings,
    onSwitch = _ref.onSwitch;
  var link = settings.link;
  if (onSwitch && link && link.startsWith("#tab-link")) {
    var targetTabId = link.replace("#tab-link-", "");
    return /*#__PURE__*/React.createElement(A, {
      key: settings.id,
      href: "#",
      id: settings.id ? settings.id : "",
      target: settings.target,
      rel: settings.rel,
      title: settings.label,
      className: settings.className,
      onClick: function onClick(e) {
        e.preventDefault();
        onSwitch(targetTabId);
      }
    }, settings.label);
  } else {
    return /*#__PURE__*/React.createElement(A, {
      key: settings.id,
      href: settings.link,
      id: settings.id ? settings.id : "",
      target: settings.target,
      rel: settings.rel,
      title: settings.label,
      className: settings.className
    }, settings.label);
  }
};
var Item$1 = function Item(_ref2) {
  var item = _ref2.item,
    onSwitch = _ref2.onSwitch;
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-item"
  }, /*#__PURE__*/React.createElement(Image, {
    src: item.image,
    showCredits: false
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, item.title), /*#__PURE__*/React.createElement("div", {
    className: "description",
    dangerouslySetInnerHTML: {
      __html: item.description
    }
  }), /*#__PURE__*/React.createElement(Link$2, {
    settings: item.link,
    onSwitch: onSwitch
  })));
};
var TabContet = function TabContet(_ref3) {
  var tab = _ref3.tab,
    currency = _ref3.currency,
    discountNoteTheme = _ref3.discountNoteTheme,
    onSwitch = _ref3.onSwitch;
  var focusedCardIdx = tab.tabCards && tab.tabCards.length === 3 && 1;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Cards, null, tab.tabCards && tab.tabCards.map(function (tabCard, idx) {
    return /*#__PURE__*/React.createElement(Card$4, {
      key: tabCard.id,
      currency: currency,
      tabCard: tabCard,
      focused: focusedCardIdx === idx,
      applyFocus: !!focusedCardIdx,
      discountNoteTheme: discountNoteTheme
    });
  })), tab.items && tab.items.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab-items"
  }, tab.items.map(function (item) {
    return /*#__PURE__*/React.createElement(Item$1, {
      key: item.id,
      item: item,
      onSwitch: onSwitch
    });
  }))) : null);
};
var Headings$2 = function Headings(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, icon && /*#__PURE__*/React.createElement(Image, {
    src: icon,
    variant: "original",
    showCredits: false
  }), /*#__PURE__*/React.createElement("h3", null, title)), subTitle && /*#__PURE__*/React.createElement("h5", {
    className: "sub-title",
    dangerouslySetInnerHTML: {
      __html: parser.renderInline(subTitle)
    }
  })));
};
var VatDisclaimer$2 = function VatDisclaimer(_ref) {
  var tabs = _ref.tabs,
    showAdditionalDisclaimer = _ref.showAdditionalDisclaimer;
  var message = tabs[0] && tabs[0].tabCards && tabs[0].tabCards[0] && tabs[0].tabCards[0].card && tabs[0].tabCards[0].card.vatDisclaimer || "";
  var additionalMessage = tabs[0] && tabs[0].tabCards && tabs[0].tabCards[0] && tabs[0].tabCards[0].card && tabs[0].tabCards[0].card.additionalDisclaimer || "";
  if (!message && !additionalMessage) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, message && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, message), additionalMessage && showAdditionalDisclaimer === "yes" && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, additionalMessage)));
};
var EmptyLink = function EmptyLink() {
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "back-link"
  }));
};
var BackLink = function BackLink(_ref) {
  var selectedTabIdx = _ref.selectedTabIdx,
    state = _ref.state,
    tabs = _ref.tabs,
    onReturn = _ref.onReturn;
  var currentTab = selectedTabIdx ? state.list[selectedTabIdx] : null;
  if (!state.currentHiddenTabId || !state.currentVisibleTabId) {
    return /*#__PURE__*/React.createElement(EmptyLink, null);
  }
  if (selectedTabIdx && currentTab !== state.currentHiddenTabId) {
    return /*#__PURE__*/React.createElement(EmptyLink, null);
  }
  var message = tabs.find(function (tab) {
    return tab.id === state.currentVisibleTabId;
  }).backMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "back-link"
  }, /*#__PURE__*/React.createElement(A, {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      onReturn();
    }
  }, message)));
};
var CurrencyBar = function CurrencyBar(_ref) {
  var currency = _ref.currency,
    _onChange = _ref.onChange;
  var isAdmin = !!React.useContext(AdminUserContext);
  return isAdmin && /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("select", {
    value: currency,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, Currency.all.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      key: c,
      value: c
    }, c.toUpperCase());
  })));
};
var getActiveTabIdx$1 = function getActiveTabIdx(tabs) {
  var hash = window && window.location.hash && window.location.hash.substring(1);
  if (!hash) {
    return 0;
  }
  var idx = tabs.findIndex(function (tab) {
    return tab.htmlId === hash;
  });
  return idx === -1 ? 0 : idx;
};
var MultipleTabs = function MultipleTabs(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    icon = _ref.icon,
    tabs = _ref.tabs,
    initialCurrency = _ref.currency,
    showAdditionalDisclaimer = _ref.showAdditionalDisclaimer,
    discountNoteTheme = _ref.discountNoteTheme;
  var _React$useState = React.useState(initialCurrency),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  var _React$useState2 = React.useState({
      list: tabs.filter(function (tab) {
        return !tab.hidden;
      }).map(function (tab) {
        return tab.id;
      }),
      currentHiddenTabId: null,
      currentVisibleTabId: null
    }),
    state = _React$useState2[0],
    setState = _React$useState2[1];
  var pricingRef = React.useRef(null);
  var currentTabs = state.list.map(function (tabId) {
    return tabs.find(function (tab) {
      return tab.id === tabId;
    });
  });
  var _React$useState3 = React.useState(getActiveTabIdx$1(currentTabs)),
    selectedTabIdx = _React$useState3[0],
    setSelectedTabIdx = _React$useState3[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "featured-pricing",
    ref: pricingRef
  }, /*#__PURE__*/React.createElement(CurrencyBar, {
    currency: currency,
    onChange: setCurrency
  }), /*#__PURE__*/React.createElement(Headings$2, {
    title: title,
    subTitle: subTitle,
    icon: icon
  }), /*#__PURE__*/React.createElement(Tabs$1, {
    forceRenderTabPanel: true,
    defaultIndex: getActiveTabIdx$1(currentTabs),
    onSelect: function onSelect(index, _lastIndex, _event) {
      setSelectedTabIdx(index);
    }
  }, /*#__PURE__*/React.createElement(TabList, null, currentTabs.map(function (tab, idx) {
    return /*#__PURE__*/React.createElement(Tab$5, {
      key: idx
    }, tab.title);
  })), /*#__PURE__*/React.createElement(BackLink, {
    selectedTabIdx: selectedTabIdx,
    state: state,
    tabs: tabs,
    onReturn: function onReturn() {
      setState({
        list: state.list.map(function (tabId) {
          if (tabId === state.currentHiddenTabId) {
            return state.currentVisibleTabId;
          } else {
            return tabId;
          }
        }),
        currentHiddenTabId: null,
        currentVisibleTabId: null
      });
    }
  }), currentTabs.map(function (tab, idx) {
    return /*#__PURE__*/React.createElement(TabPanel, {
      key: idx
    }, /*#__PURE__*/React.createElement(TabContet, {
      tab: tab,
      currency: currency,
      discountNoteTheme: discountNoteTheme,
      onSwitch: function onSwitch(targetTabId) {
        setState({
          list: state.list.map(function (tabId) {
            if (tabId === tab.id) {
              return targetTabId;
            } else {
              return tabId;
            }
          }),
          currentHiddenTabId: targetTabId,
          currentVisibleTabId: tab.id
        });
        pricingRef && pricingRef.current && pricingRef.current.scrollIntoView();
      }
    }));
  })), /*#__PURE__*/React.createElement(VatDisclaimer$2, {
    tabs: tabs,
    showAdditionalDisclaimer: showAdditionalDisclaimer
  }));
};
var SingleTab = function SingleTab(_ref2) {
  var title = _ref2.title,
    subTitle = _ref2.subTitle,
    icon = _ref2.icon,
    tabs = _ref2.tabs,
    initialCurrency = _ref2.currency,
    showAdditionalDisclaimer = _ref2.showAdditionalDisclaimer,
    discountNoteTheme = _ref2.discountNoteTheme;
  var _React$useState4 = React.useState(initialCurrency),
    currency = _React$useState4[0],
    setCurrency = _React$useState4[1];
  var _React$useState5 = React.useState({
      tabId: tabs.find(function (tab) {
        return !tab.hidden;
      }).id,
      currentHiddenTabId: null,
      currentVisibleTabId: null
    }),
    state = _React$useState5[0],
    setState = _React$useState5[1];
  var pricingRef = React.useRef(null);
  var currentTab = tabs.find(function (tab) {
    return tab.id === state.tabId;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "featured-pricing",
    ref: pricingRef
  }, /*#__PURE__*/React.createElement(CurrencyBar, {
    currency: currency,
    onChange: setCurrency
  }), /*#__PURE__*/React.createElement(Headings$2, {
    title: title,
    subTitle: subTitle,
    icon: icon
  }), /*#__PURE__*/React.createElement(BackLink, {
    state: state,
    tabs: tabs,
    onReturn: function onReturn() {
      setState({
        tabId: state.tabId === state.currentHiddenTabId ? state.currentVisibleTabId : state.tabId,
        currentHiddenTabId: null,
        currentVisibleTabId: null
      });
    }
  }), /*#__PURE__*/React.createElement(TabContet, {
    tab: currentTab,
    currency: currency,
    discountNoteTheme: discountNoteTheme,
    onSwitch: function onSwitch(targetTabId) {
      setState({
        tabId: state.tabId === currentTab.id ? targetTabId : currentTab.id,
        currentHiddenTabId: targetTabId,
        currentVisibleTabId: currentTab.id
      });
      pricingRef && pricingRef.current && pricingRef.current.scrollIntoView();
    }
  }), /*#__PURE__*/React.createElement(VatDisclaimer$2, {
    tabs: tabs,
    showAdditionalDisclaimer: showAdditionalDisclaimer
  }));
};
var PricingTabs = function PricingTabs(props) {
  var tabs = props.tabs;
  if (tabs.filter(function (tab) {
    return !tab.hidden;
  }).length === 1) {
    return /*#__PURE__*/React.createElement(SingleTab, props);
  } else {
    return /*#__PURE__*/React.createElement(MultipleTabs, props);
  }
};
var tabsFactory$1 = function tabsFactory(tabs, adminTabs) {
  var newTabs = tabs.map(function (tab) {
    var newTab = Object.assign({}, tab);
    var adminTab = adminTabs.find(function (adminTab) {
      return adminTab.tab === tab.id;
    });
    if (adminTab) {
      newTab.hidden = adminTab.hidden === "yes";
      newTab.backMessage = adminTab.backMessage;
      newTab.htmlId = adminTab.htmlId;
    } else {
      newTab.hidden = false;
      newTab.backMessage = "";
    }
    return newTab;
  });
  return newTabs;
};
var Wrapper$4 = function Wrapper(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    icon = _ref.icon,
    adminTabsList = _ref.adminTabsList,
    tabsList = _ref.tabsList,
    showAdditionalDisclaimer = _ref.showAdditionalDisclaimer,
    discountNoteTheme = _ref.discountNoteTheme,
    currency = _ref.currency;
  var tabs = tabsFactory$1(tabsList, adminTabsList);
  return /*#__PURE__*/React.createElement(PricingTabs, {
    title: title,
    subTitle: subTitle,
    icon: icon,
    tabs: tabs,
    currency: currency,
    showAdditionalDisclaimer: showAdditionalDisclaimer,
    discountNoteTheme: discountNoteTheme
  });
};
var TabItem = function TabItem() {
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-item"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 40,
      height: 40
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "10em",
      height: "1em"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "10em",
      height: "4em"
    }
  })), /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "5em",
      height: "1em"
    }
  })));
};
var Card$5 = function Card() {
  return /*#__PURE__*/React.createElement("div", {
    className: "card-wrapper"
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "330px",
      height: "50vh"
    }
  }));
};
var PlacehodlerComponent$2 = function PlacehodlerComponent(_ref) {
  var showMessage = _ref.showMessage,
    list = _ref.list,
    showAdditionalDisclaimer = _ref.showAdditionalDisclaimer;
  var arr = Array.from(Array(list.length).keys());
  return /*#__PURE__*/React.createElement("div", {
    className: "featured-pricing"
  }, showMessage && /*#__PURE__*/React.createElement(PricingErrorMessage, null), arr.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "4em"
    }
  }, arr.map(function (i) {
    return /*#__PURE__*/React.createElement(RectShape, {
      key: i,
      color: colors.lightBlue,
      style: {
        width: 190,
        height: 70
      }
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards-wrapper"
  }, /*#__PURE__*/React.createElement(Card$5, null), /*#__PURE__*/React.createElement(Card$5, null), /*#__PURE__*/React.createElement(Card$5, null))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab-items"
  }, /*#__PURE__*/React.createElement(TabItem, null), /*#__PURE__*/React.createElement(TabItem, null))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column"
    }
  }, /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 100,
      height: "1em"
    }
  }), showAdditionalDisclaimer === "yes" && /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: 100,
      height: "1em"
    }
  })))));
};
var FeaturedPricingPlaceholder = function FeaturedPricingPlaceholder(_ref2) {
  var realComponent = _ref2.realComponent,
    list = _ref2.list,
    showAdditionalDisclaimer = _ref2.showAdditionalDisclaimer,
    ready = _ref2.ready;
  return /*#__PURE__*/React.createElement(Placeholder, {
    ready: ready,
    placeholderComponent: function placeholderComponent() {
      return /*#__PURE__*/React.createElement(PlacehodlerComponent$2, {
        list: list,
        showAdditionalDisclaimer: showAdditionalDisclaimer
      });
    },
    realComponent: realComponent
  });
};
var _excluded$6 = ["geoIp"];
var isZuoraDataInvalid$2 = function isZuoraDataInvalid(data) {
  var valid = data.every(function (tab) {
    return tab.tabCards.every(function (tabCard) {
      return tabCard.card.items.every(function (item) {
        if (!item.ratePlanDetails) {
          return true;
        }
        if (item.ratePlanDetails.id) {
          return !!item.ratePlanDetails.name;
        } else {
          return true;
        }
      });
    });
  });
  if (!valid) {
    console.error({
      data: data
    });
  }
  return !valid;
};
var WidgetContent = function WidgetContent(_ref) {
  var list = _ref.list,
    title = _ref.title,
    subTitle = _ref.subTitle,
    icon = _ref.icon,
    promoCode = _ref.promoCode,
    showAdditionalDisclaimer = _ref.showAdditionalDisclaimer,
    _ref$discountNoteThem = _ref.discountNoteTheme,
    discountNoteTheme = _ref$discountNoteThem === void 0 ? "default" : _ref$discountNoteThem,
    containerSettings = _ref.containerSettings;
  var pickedPromoCode = extractPromoCode(React.useContext(PageUrlContext), promoCode);
  var _React$useState = React.useState(null),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrency);
  return /*#__PURE__*/React.createElement("div", {
    className: "featured-pricing-wrapper"
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, list.map(function (tab) {
    if (tab.htmlId) {
      return /*#__PURE__*/React.createElement("div", {
        key: tab.id,
        id: tab.htmlId
      });
    }
    return null;
  }), /*#__PURE__*/React.createElement(Query, {
    query: FEATURED_PRICING_TABS,
    variables: {
      input: {
        filters: {
          ids: list.map(function (item) {
            return item.tab;
          })
        },
        promoCode: pickedPromoCode
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var featuredPricingTabs = data.featuredPricingTabs;
    return list.length > 0 ? /*#__PURE__*/React.createElement(FeaturedPricingPlaceholder, {
      ready: loading || !currency,
      list: list,
      showAdditionalDisclaimer: showAdditionalDisclaimer,
      realComponent: function realComponent() {
        if (isZuoraDataInvalid$2(featuredPricingTabs.list)) {
          return /*#__PURE__*/React.createElement(PlacehodlerComponent$2, {
            showMessage: true,
            list: list
          });
        }
        return /*#__PURE__*/React.createElement(Wrapper$4, {
          currency: currency,
          title: title,
          subTitle: subTitle,
          icon: icon,
          showAdditionalDisclaimer: showAdditionalDisclaimer,
          adminTabsList: list,
          tabsList: featuredPricingTabs.list,
          discountNoteTheme: discountNoteTheme
        });
      }
    }) : /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("h2", null, "Pricing"));
  })));
};
var Widget$14 = function Widget(_ref3) {
  var geoIp = _ref3.geoIp,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded$6);
  return /*#__PURE__*/React.createElement(GeoIpFilter, {
    countries: geoIp === null || geoIp === void 0 ? void 0 : geoIp.activeCountries,
    countryGroupIds: geoIp === null || geoIp === void 0 ? void 0 : geoIp.activeGroups,
    active: geoIp === null || geoIp === void 0 ? void 0 : geoIp.active
  }, /*#__PURE__*/React.createElement(WidgetContent, rest));
};
var Config$14 = {
  title: "Pricing",
  category: "Pricing"
};
var Defaults$14 = {
  discountNoteTheme: "default",
  promoCode: "",
  list: [],
  geoIp: {
    active: false,
    activeCountries: [],
    activeGroups: []
  },
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ListItem$a = function ListItem(_ref4) {
  var settings = _ref4.settings,
    onChangeItem = _ref4.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Hidden",
    options: [["yes", "Yes"], ["no", "no"]],
    value: settings.hidden,
    onChange: function onChange(value) {
      return onChangeItem("hidden", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Back message",
    value: settings.backMessage,
    onChange: function onChange(value) {
      return onChangeItem("backMessage", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: settings.htmlId,
    onChange: function onChange(value) {
      return onChangeItem("htmlId", value);
    }
  }), /*#__PURE__*/React.createElement(PricingTabPicker, {
    label: "Tab Picker",
    tabsQuery: MINI_FEATURED_PRICING_TABS,
    tabsKey: "miniFeaturedPricingTabs",
    onChange: function onChange(value) {
      return onChangeItem("tab", value);
    },
    value: settings.tab
  }));
};
var Admin$13 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(GeoIpPicker, {
    onChange: function onChange(value) {
      return _onChange("geoIp", value);
    },
    value: settings.geoIp
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return _onChange("title", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Sub Title",
    hint: "Supports markdown",
    value: settings.subTitle,
    onChange: function onChange(value) {
      return _onChange("subTitle", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    onChange: function onChange(value) {
      return _onChange("icon", value);
    },
    value: settings.icon
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Show additional disclaimer",
    options: [["yes", "Yes"], ["no", "no"]],
    value: settings.showAdditionalDisclaimer,
    onChange: function onChange(value) {
      return _onChange("showAdditionalDisclaimer", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Discount note theme",
    options: [["default", "Default"], ["accented", "Accented"]],
    value: settings.discountNoteTheme,
    onChange: function onChange(value) {
      return _onChange("discountNoteTheme", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Promo code",
    value: settings.promoCode,
    onChange: function onChange(value) {
      return _onChange("promoCode", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$a, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: {
      tab: "",
      hidden: "no",
      htmlId: ""
    },
    primaryField: "tab"
  }));
};
var FeaturedPricingWidget = {
  __proto__: null,
  Widget: Widget$14,
  Admin: Admin$13,
  Config: Config$14,
  Defaults: Defaults$14
};
var Item$2 = function Item(_ref) {
  var avatar = _ref.avatar,
    logo = _ref.logo,
    name = _ref.name,
    position = _ref.position,
    comapany_name = _ref.comapany_name,
    description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "testimonial-slide"
  }, /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "images"
  }, /*#__PURE__*/React.createElement(Img, {
    src: avatar,
    variant: "thumb",
    className: "avatar"
  }), /*#__PURE__*/React.createElement(Img, {
    src: logo,
    variant: "thumb",
    className: "logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "name"
  }, name), /*#__PURE__*/React.createElement("div", null, position), /*#__PURE__*/React.createElement("div", null, comapany_name))), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(description, true)));
};
var Widget$15 = function Widget(_ref2) {
  var list = _ref2.list,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "new-testimonial-slider"
  }, /*#__PURE__*/React.createElement(Slider, {
    slideNextClass: "next-slide",
    navigation: {
      nextEl: ".swiper-button-next.icon-arrow-right",
      prevEl: ".swiper-button-prev.icon-arrow-left"
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    loop: true,
    speed: 1000,
    spaceBetween: 60,
    slidesPerView: 1.2,
    breakpoints: {
      600: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 30
      }
    },
    initialSlide: 1,
    centeredSlides: true
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement(Item$2, item));
  }))));
};
var Config$15 = {
  title: "New Testimonial Slider",
  category: "Sliders"
};
var Defaults$15 = {
  list: [{
    id: 1,
    avatar: imagePlaceholder("48x48"),
    logo: imagePlaceholder("14x14"),
    name: "Name",
    position: "Position",
    comapany_name: "Company name",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores distinctio ea non? Quisquam enim blanditiis deserunt cumque earum."
  }, {
    id: 2,
    avatar: imagePlaceholder("48x48"),
    logo: imagePlaceholder("14x14"),
    name: "Name",
    position: "Position",
    comapany_name: "Company name",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores distinctio ea non? Quisquam enim blanditiis deserunt cumque earum."
  }, {
    id: 3,
    avatar: imagePlaceholder("64x64"),
    logo: imagePlaceholder("21x21"),
    name: "Name",
    position: "Position",
    comapany_name: "Company name",
    description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores distinctio ea non? Quisquam enim blanditiis deserunt cumque earum."
  }],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var ListItem$b = function ListItem(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Avatar",
    onChange: function onChange(value) {
      return onChangeItem("avatar", value);
    },
    value: settings.avatar
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    },
    value: settings.logo
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Name",
    onChange: function onChange(value) {
      return onChangeItem("name", value);
    },
    value: settings.name
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Position",
    onChange: function onChange(value) {
      return onChangeItem("position", value);
    },
    value: settings.position
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Company Name",
    onChange: function onChange(value) {
      return onChangeItem("comapany_name", value);
    },
    value: settings.comapany_name
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }));
};
var Admin$14 = function Admin(items, onChange) {
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$b, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: items,
    template: {
      avatar: imagePlaceholder("48x48"),
      logo: imagePlaceholder("14x14"),
      name: "Name",
      position: "Position",
      comapany_name: "Company name",
      description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Asperiores distinctio ea non? Quisquam enim blanditiis deserunt cumque earum."
    },
    primaryField: "name",
    onChangeList: onChange
  }));
};
var NewTestimonialSliderWidget = {
  __proto__: null,
  Widget: Widget$15,
  Admin: Admin$14,
  Config: Config$15,
  Defaults: Defaults$15
};
var formId = function formId(form_id) {
  return "form-" + form_id;
};
var Widget$16 = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    layout = _ref.layout,
    form_id = _ref.form_id,
    _ref$required_marker = _ref.required_marker,
    required_marker = _ref$required_marker === void 0 ? "star" : _ref$required_marker;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "hubspot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: layout
  }, /*#__PURE__*/React.createElement(RequiredMarkerContext.Provider, {
    value: required_marker
  }, /*#__PURE__*/React.createElement(HubspotForm, {
    form_id: form_id,
    scrollTarget: formId(form_id)
  })))))));
};
var Config$16 = {
  title: "Hubspot",
  category: "General"
};
var Defaults$16 = {
  layout: "shift-2",
  required_marker: "star",
  form_id: "",
  containerSettings: {}
};
var Admin$15 = {
  layout: {
    type: "select",
    options: [["col-12", "12 columns"], ["shift-1", "Shift 1"], ["shift-2", "Shift 2"], ["shift-3", "Shift 3"]]
  },
  required_marker: {
    label: "Required fields indicator",
    type: "select",
    options: [["star", "Show stars next to labels"], ["optional", "Mark only optional fields"]]
  },
  form_id: {
    type: "custom",
    component: HubSpotFormPicker
  }
};
var HubSpotWidget = {
  __proto__: null,
  Widget: Widget$16,
  Admin: Admin$15,
  Config: Config$16,
  Defaults: Defaults$16
};
var ListItem$c = function ListItem(_ref) {
  var item = _ref.item;
  if (item.url !== "") return /*#__PURE__*/React.createElement(A, {
    href: item.url,
    target: "_blank",
    className: "logo-container"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.image,
    variant: "original",
    className: "logo",
    alt: ""
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "logo-container"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: item.image,
    variant: "original",
    className: "logo",
    alt: ""
  }));
};
var DesktopSlides = function DesktopSlides(_ref2) {
  var list = _ref2.list,
    autoRotate = _ref2.autoRotate;
  var _React$useState = React.useState(null),
    swiper = _React$useState[0],
    setSwiper = _React$useState[1];
  var handlePrevious = function handlePrevious() {
    return swiper && swiper.slidePrev();
  };
  var handleNext = function handleNext() {
    return swiper && swiper.slideNext();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "desktop-slider"
  }, /*#__PURE__*/React.createElement("div", {
    className: "arrow-prev",
    onClick: handlePrevious
  }, /*#__PURE__*/React.createElement("svg", {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animate",
    width: "64",
    height: "64",
    rx: "32",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    className: "animate",
    d: "M37.25 42.5L26.75 32L37.25 21.5",
    stroke: "",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement(Slider, {
    getSwiper: setSwiper,
    autoplay: autoRotate === "off" ? false : {
      delay: autoRotate
    },
    speed: 500,
    slidesPerView: 5,
    slidesPerGroup: 5,
    spaceBetween: 30,
    loop: true
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement(ListItem$c, {
      item: item
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "arrow-next",
    onClick: handleNext
  }, /*#__PURE__*/React.createElement("svg", {
    width: "64",
    height: "64",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "animate",
    width: "64",
    height: "64",
    rx: "32",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("path", {
    className: "animate",
    d: "M26.75 42.5L37.25 32L26.75 21.5",
    stroke: "",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
var Widget$17 = function Widget(_ref3) {
  var autoRotate = _ref3.autoRotate,
    list = _ref3.list,
    containerSettings = _ref3.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "logos-slider"
  }, /*#__PURE__*/React.createElement(DesktopSlides, {
    list: list,
    autoRotate: autoRotate
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mobile-slider"
  }, /*#__PURE__*/React.createElement(Slider, {
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    autoplay: autoRotate === "off" ? false : {
      delay: autoRotate
    },
    speed: 500,
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 30,
    rebuildOnUpdate: true,
    paginationClickable: true,
    loop: true,
    navigation: false
  }, list.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement(ListItem$c, {
      item: item
    }));
  }))))));
};
var Config$17 = {
  title: "Logos (slider)",
  category: "Logos"
};
var TEMPLATE$2 = {
  image: imagePlaceholder("200x200"),
  url: ""
};
var Defaults$17 = {
  autoRotate: "off",
  list: [_extends({
    id: 1
  }, TEMPLATE$2), _extends({
    id: 2
  }, TEMPLATE$2), _extends({
    id: 3
  }, TEMPLATE$2), _extends({
    id: 4
  }, TEMPLATE$2), _extends({
    id: 5
  }, TEMPLATE$2), _extends({
    id: 6
  }, TEMPLATE$2)],
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var PartnerField$2 = function PartnerField(_ref4) {
  var settings = _ref4.settings,
    onChangeItem = _ref4.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "URL",
    onChange: function onChange(value) {
      return onChangeItem("url", value);
    },
    value: settings.url
  }));
};
PartnerField$2.defaultProps = {
  settings: {}
};
var Admin$16 = function Admin(items, _onChange, settings) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Autoplay",
    options: [["off", "Off"], ["3000", "3s"], ["4000", "4s"], ["5000", "5s"]],
    value: settings.autoRotate,
    onChange: function onChange(value) {
      return _onChange("autoRotate", value);
    }
  }), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(PartnerField$2, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    onChangeList: _onChange,
    items: items,
    template: TEMPLATE$2,
    primaryField: "id"
  }));
};
var LogosSliderWidget = {
  __proto__: null,
  Widget: Widget$17,
  Admin: Admin$16,
  Config: Config$17,
  Defaults: Defaults$17
};
var TEMPLATE$3 = {
  title: 'Video title',
  description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam labore amet esse a ipsum iusto, deserunt non, ipsa, vero explicabo voluptatum rem! Nemo, at doloremque. Quas iusto quaerat nemo ut!',
  preview: imagePlaceholder('800x600'),
  video_url: 'https://www.youtube.com/watch?v=xqB9KJsbIlU'
};
var ListItem$d = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Preview",
    onChange: function onChange(value) {
      return onChangeItem("preview", value);
    },
    value: settings.preview
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Video URL",
    onChange: function onChange(value) {
      return onChangeItem("video_url", value);
    },
    value: settings.video_url
  }));
};
var VideoLibraryListInput = function VideoLibraryListInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$d, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$3,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
VideoLibraryListInput.defaults = [_extends({
  id: 1
}, TEMPLATE$3), _extends({
  id: 2
}, TEMPLATE$3), _extends({
  id: 3
}, TEMPLATE$3), _extends({
  id: 4
}, TEMPLATE$3), _extends({
  id: 5
}, TEMPLATE$3), _extends({
  id: 6
}, TEMPLATE$3), _extends({
  id: 7
}, TEMPLATE$3)];
var TEMPLATE$4 = {
  label: 'Tab',
  videos: VideoLibraryListInput.defaults
};
var ListItem$e = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    },
    value: settings.label
  }), /*#__PURE__*/React.createElement(VideoLibraryListInput, {
    label: "Videos",
    onChange: function onChange(value) {
      return onChangeItem("videos", value);
    },
    value: settings.videos
  }));
};
var VideoLibraryTabsInput = function VideoLibraryTabsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$e, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$4,
    primaryField: "label",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
VideoLibraryTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$4), _extends({
  id: 2
}, TEMPLATE$4), _extends({
  id: 3
}, TEMPLATE$4), _extends({
  id: 4
}, TEMPLATE$4), _extends({
  id: 5
}, TEMPLATE$4), _extends({
  id: 6
}, TEMPLATE$4), _extends({
  id: 7
}, TEMPLATE$4)];
var PreviewVideo = function PreviewVideo(_ref) {
  var preview = _ref.preview,
    video_url = _ref.video_url,
    playing = _ref.playing,
    onPlay = _ref.onPlay;
  return /*#__PURE__*/React.createElement("div", {
    className: "main-video"
  }, !playing && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "thumb",
    onClick: onPlay
  }, /*#__PURE__*/React.createElement("div", {
    className: "play-icon"
  }), /*#__PURE__*/React.createElement(Image, {
    src: preview,
    variant: "single_image_horizontal"
  })), playing && /*#__PURE__*/React.createElement(EmbeddedVideo, {
    videoUrl: video_url,
    autoplay: playing
  }));
};
var Widget$18 = function Widget(_ref2) {
  var tabs = _ref2.tabs,
    containerSettings = _ref2.containerSettings;
  var _React$useState = React.useState(tabs[0]),
    tab = _React$useState[0],
    setTab = _React$useState[1];
  var _React$useState2 = React.useState(tabs[0].videos[0]),
    video = _React$useState2[0],
    setVideo = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    play = _React$useState3[0],
    setPlay = _React$useState3[1];
  var handleTabChange = function handleTabChange(tab) {
    setTab(tab);
    setVideo(tab.videos[0]);
    setPlay(false);
  };
  var handlePlay = function handlePlay() {
    return setPlay(true);
  };
  var handleChangeVideo = function handleChangeVideo(video) {
    setVideo(video);
    setPlay(false);
  };
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "video-library"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, tabs.map(function (t) {
    return /*#__PURE__*/React.createElement("button", {
      key: t.id,
      type: "button",
      className: "tab " + (t.id === tab.id ? "active" : ""),
      onClick: function onClick() {
        return handleTabChange(t);
      }
    }, t.label);
  })), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, video.title), parseMarkdown(video.description)), /*#__PURE__*/React.createElement("div", {
    className: "col-8"
  }, /*#__PURE__*/React.createElement(PreviewVideo, _extends({}, video, {
    playing: play,
    onPlay: handlePlay
  })), /*#__PURE__*/React.createElement("div", {
    className: "thumbs"
  }, tab.videos.map(function (v) {
    return /*#__PURE__*/React.createElement("button", {
      key: v.id,
      type: "button",
      className: "thumb " + (v.id === video.id ? "active" : ""),
      onClick: function onClick() {
        return handleChangeVideo(v);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "play-icon"
    }), /*#__PURE__*/React.createElement(Image, {
      src: v.preview,
      variant: "magazine_spotlight",
      loading: "lazy"
    }));
  })))))));
};
var Config$18 = {
  title: "Video Library",
  category: "Video"
};
var Defaults$18 = {
  tabs: VideoLibraryTabsInput.defaults,
  containerSettings: {}
};
var Admin$17 = {
  tabs: {
    type: "custom",
    component: VideoLibraryTabsInput
  }
};
var VideoLibraryWidget = {
  __proto__: null,
  Widget: Widget$18,
  Admin: Admin$17,
  Config: Config$18,
  Defaults: Defaults$18
};
var Media = function Media(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "single_image_horizontal",
    loading: "lazy"
  });
};
var Widget$19 = function Widget(_ref2) {
  var orientation = _ref2.orientation,
    image = _ref2.image,
    title = _ref2.title,
    description = _ref2.description,
    form_id = _ref2.form_id,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "subscription dark-bg"
  }, orientation === "left" && /*#__PURE__*/React.createElement(Media, {
    image: image
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "hubspot"
  }, /*#__PURE__*/React.createElement(HubspotForm, {
    hideCaptcha: false,
    form_id: form_id,
    button_type: "btn-passive-light",
    placeholder: "single_field"
  })))), orientation === "right" && /*#__PURE__*/React.createElement(Media, {
    image: image
  }))));
};
var Config$19 = {
  title: "Subscription",
  category: "Forms"
};
var Defaults$19 = {
  orientation: "left",
  image: imagePlaceholder("800x600"),
  title: "Example title",
  description: "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Possimus architecto doloribus sapiente itaque distinctio odit eius soluta cum quisquam perspiciatis. ",
  form_id: "",
  containerSettings: {}
};
var Admin$18 = {
  orientation: {
    type: "select",
    options: [["left", "Image (left)"], ["right", "Image (right)"]]
  },
  image: {
    type: "custom",
    component: ImagePicker
  },
  title: {
    type: "text"
  },
  description: {
    type: "textarea"
  },
  form_id: {
    type: "custom",
    component: HubSpotFormPicker
  }
};
var SubscriptionWidget = {
  __proto__: null,
  Widget: Widget$19,
  Admin: Admin$18,
  Config: Config$19,
  Defaults: Defaults$19
};
function formatTags$1(tag) {
  if (!tag) {
    return [];
  }
  if (Array.isArray(tag)) {
    return tag.filter(Boolean);
  }
  return [tag];
}
var Feed = function Feed(_ref) {
  var tags = _ref.tags,
    limit = _ref.limit,
    product = _ref.product,
    categories = _ref.categories;
  return /*#__PURE__*/React.createElement(Query, {
    query: ARTICLES,
    variables: {
      input: {
        limit: parseInt(limit, 10),
        filters: {
          tags: tags,
          product: product,
          categories: categories
        }
      }
    }
  }, function (_ref2) {
    var error = _ref2.error,
      loading = _ref2.loading,
      data = _ref2.data;
    if (error) return "Error! " + error.message;
    var articles = data.articles;
    return /*#__PURE__*/React.createElement(ThumbsWhithTextPlaceholder, {
      lines: parseInt(limit, 10),
      ready: loading,
      realComponent: function realComponent() {
        return articles.list.map(function (article) {
          return /*#__PURE__*/React.createElement("div", {
            className: "article"
          }, /*#__PURE__*/React.createElement(A, {
            href: article.url,
            className: "article-wrapper"
          }, /*#__PURE__*/React.createElement("time", {
            dateTime: formatDate(article.publish_on),
            className: "time"
          }, formatDate(article.publish_on, "ll")), /*#__PURE__*/React.createElement("div", {
            className: "text-wrapper"
          }, /*#__PURE__*/React.createElement(A, {
            href: article.url,
            className: "title"
          }, article.title), /*#__PURE__*/React.createElement("p", {
            className: "description"
          }, article.description))));
        });
      }
    });
  });
};
var Widget$1a = function Widget(_ref3) {
  var tag = _ref3.tag,
    limit = _ref3.limit,
    categories = _ref3.categories,
    product = _ref3.product,
    containerSettings = _ref3.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "simple-blog-feed"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, categories ? /*#__PURE__*/React.createElement(Feed, {
    tags: formatTags$1(tag),
    limit: limit,
    product: product,
    categories: categories
  }) : /*#__PURE__*/React.createElement("h2", null, "Blog Feed: select articles"))))));
};
var Config$1a = {
  title: "Simple Blog Feed",
  category: "Feed"
};
var Defaults$1a = {
  limit: 10,
  tag: "",
  product: "",
  categories: "",
  containerSettings: {}
};
var Admin$19 = {
  limit: {
    type: "text"
  },
  tag: {
    type: "custom",
    component: TagsPicker
  },
  product: {
    type: "custom",
    component: ProductsPicker
  },
  categories: {
    type: "custom",
    component: MagazineCategoriesPicker
  }
};
var SimpleBlogFeedWidget = {
  __proto__: null,
  Widget: Widget$1a,
  Admin: Admin$19,
  Config: Config$1a,
  Defaults: Defaults$1a
};
var Filter$1 = function Filter(_ref) {
  var country = _ref.country,
    tier = _ref.tier,
    resellers = _ref.resellers;
  var formRef = /*#__PURE__*/React.createRef();
  var locale = React.useContext(LocaleContext);
  var regionName = new Intl.DisplayNames([locale], {
    type: "region"
  });
  var countryCodes = resellers.reduce(function (acc, reseller) {
    acc.add(reseller.country);
    return acc;
  }, new Set());
  var countries = Array.from(countryCodes).map(function (cc) {
    return {
      code: cc,
      name: regionName.of(cc)
    };
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
  var allTiers = resellers.map(function (reseller) {
    return reseller.tier;
  });
  var tierCodes = allTiers.reduce(function (acc, t) {
    acc.add(t.code);
    return acc;
  }, new Set());
  var tiers = Array.from(tierCodes).map(function (tierCode) {
    var t = allTiers.find(function (t) {
      return t.code === tierCode;
    });
    return t;
  }).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  });
  return /*#__PURE__*/React.createElement("form", {
    ref: formRef,
    method: "GET",
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "dropdown-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "select-wrapper"
  }, /*#__PURE__*/React.createElement("select", {
    value: country,
    name: "country",
    className: "filter-select select-country",
    onChange: function onChange(_) {
      formRef.current.submit();
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "All countries or regions"), countries.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.code,
      value: item.code
    }, item.name);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "select-wrapper"
  }, /*#__PURE__*/React.createElement("select", {
    value: tier,
    name: "tier",
    className: "filter-select select-tier",
    onChange: function onChange(_) {
      formRef.current.submit();
    }
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "All types"), tiers.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.code,
      value: item.code
    }, item.name);
  })))));
};
var Trigger = function Trigger(_ref) {
  var children = _ref.children,
    onToggle = _ref.onToggle;
  return /*#__PURE__*/React.createElement("div", {
    className: "accordion-row-visible"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row-trigger",
    onClick: onToggle
  }), children);
};
var Content$2 = function Content(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "accordion-row-hidden"
  }, children);
};
var AccordionRow = function AccordionRow(_ref3) {
  var children = _ref3.children,
    id = _ref3.id,
    _ref3$alwaysOpen = _ref3.alwaysOpen,
    alwaysOpen = _ref3$alwaysOpen === void 0 ? false : _ref3$alwaysOpen,
    renderContent = _ref3.renderContent;
  var _React$useState = React.useState(alwaysOpen),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "accordion learning-accordion container"
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "accordion-row " + (open && "row-show")
  }, /*#__PURE__*/React.createElement(Trigger, {
    onToggle: function onToggle() {
      return setOpen(alwaysOpen || !open);
    }
  }, children), /*#__PURE__*/React.createElement(Content$2, null, renderContent())));
};
var LightBox = function LightBox(_ref) {
  var onClose = _ref.onClose,
    children = _ref.children,
    _ref$defaultCloseBtn = _ref.defaultCloseBtn,
    defaultCloseBtn = _ref$defaultCloseBtn === void 0 ? false : _ref$defaultCloseBtn;
  function handleClose() {
    onClose();
    document.body.style.overflow = "auto";
  }
  React.useEffect(function () {
    var buttonHandler = function buttonHandler(e) {
      if (e.keyCode === 27) {
        handleClose();
      }
    };
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", buttonHandler);
    return function () {
      return document.removeEventListener("keydown", buttonHandler);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "lightbox"
  }, defaultCloseBtn && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "default-close-btn",
    onClick: function onClick() {
      return handleClose();
    }
  }, "\xD7"), /*#__PURE__*/React.createElement("div", {
    className: "lb-overlay",
    onClick: function onClick() {
      return handleClose();
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "lb-content"
  }, children));
};
var FormCaptcha$2 = function FormCaptcha(_ref) {
  var onChange = _ref.onChange;
  var _React$useState = React.useState({
      captchaResult: "",
      requestId: ""
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom-xs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "captcha-wrapper"
  }, /*#__PURE__*/React.createElement(Captcha, {
    verifyCallback: function verifyCallback(status, captchaId, response) {
      onChange(status);
      setState({
        captchaResult: response,
        requestId: captchaId
      });
    }
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "g-req-id",
    value: state.requestId
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "g-recaptcha-response",
    value: state.captchaResult
  })));
};
var handleSubmit = function handleSubmit(event, reseller, apiDomain, onSuccess, onError) {
  event.preventDefault();
  var formData = new FormData(event.target);
  var body = {
    full_name: formData.get("full_name"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    message: formData.get("message"),
    company: formData.get("company"),
    office_id: formData.get("office_id"),
    reseller_id: reseller.id
  };
  fetch(apiDomain + "/api/resellers/contact", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  }).then(function (r) {
    if (r.ok) {
      onSuccess();
    } else {
      onError();
    }
  });
};
var FormField = function FormField(_ref2) {
  var label = _ref2.label,
    required = _ref2.required,
    type = _ref2.type,
    htmlFor = _ref2.htmlFor,
    id = _ref2.id,
    name = _ref2.name;
  if (type === "textarea") return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor,
    className: "control-label"
  }, label), /*#__PURE__*/React.createElement("textarea", {
    id: id,
    name: name,
    required: required
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor,
    className: "control-label"
  }, label, " ", !required && /*#__PURE__*/React.createElement("em", null, "(optional)")), /*#__PURE__*/React.createElement("input", {
    id: id,
    type: type,
    name: name,
    required: required
  }));
};
var Modal$1 = function Modal(_ref3) {
  var children = _ref3.children,
    onClose = _ref3.onClose;
  return /*#__PURE__*/React.createElement(LightBox, {
    onClose: onClose,
    defaultCloseBtn: false
  }, /*#__PURE__*/React.createElement("div", {
    className: "contact-form-modal"
  }, children));
};
var ContactForm = function ContactForm(_ref4) {
  var reseller = _ref4.reseller,
    i18n = _ref4.i18n,
    onClose = _ref4.onClose;
  var _React$useContext = React.useContext(ResellersContext),
    api_domain = _React$useContext.api_domain;
  var _React$useState2 = React.useState(true),
    disabled = _React$useState2[0],
    setDisabled = _React$useState2[1];
  var _React$useState3 = React.useState("pending"),
    status = _React$useState3[0],
    setStatus = _React$useState3[1];
  var successDescription = i18n.success.success_description.replace("{RESELLER}", reseller.name);
  var errorDescription = i18n.error.error_description.replace("{RESELLER}", reseller.name);
  if (status === "ok") {
    return /*#__PURE__*/React.createElement(Modal$1, {
      reseller: reseller,
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "form success-wrapper"
    }, /*#__PURE__*/React.createElement("img", {
      src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMzIiIGZpbGw9IiNFREVERUQiLz4KPHBhdGggZD0iTTIzLjU1MjUgMzMuMjA3NEwyOC4zODAxIDM4LjAzNUw0MC40NDkgMjUuOTY2MU00OS41IDMyQzQ5LjUgNDEuNjY1IDQxLjY2NSA0OS41IDMyIDQ5LjVDMjIuMzM1IDQ5LjUgMTQuNSA0MS42NjUgMTQuNSAzMkMxNC41IDIyLjMzNSAyMi4zMzUgMTQuNSAzMiAxNC41QzQxLjY2NSAxNC41IDQ5LjUgMjIuMzM1IDQ5LjUgMzJaIiBzdHJva2U9IiM3N0IyMkEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K",
      className: "success-icon"
    }), /*#__PURE__*/React.createElement("h5", {
      className: "success-title"
    }, i18n.success.success_title), /*#__PURE__*/React.createElement("div", {
      className: "success-description",
      dangerouslySetInnerHTML: {
        __html: successDescription
      }
    }), /*#__PURE__*/React.createElement(Button$1, {
      settings: i18n.success.success_cta
    })));
  }
  if (status === "nok") {
    return /*#__PURE__*/React.createElement(Modal$1, {
      reseller: reseller,
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", {
      className: "form error-wrapper"
    }, /*#__PURE__*/React.createElement("img", {
      src: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHZpZXdCb3g9IjAgMCA2NCA2NCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjY0IiBoZWlnaHQ9IjY0IiByeD0iMzIiIGZpbGw9IiNFREVERUQiLz4KPHBhdGggZD0iTTMyLjY3MDMgNDAuNzVDMzIuNjcwMyA0MS4xMjAyIDMyLjM3MDIgNDEuNDIwMyAzMiA0MS40MjAzQzMxLjYyOTggNDEuNDIwMyAzMS4zMjk3IDQxLjEyMDIgMzEuMzI5NyA0MC43NUMzMS4zMjk3IDQwLjM3OTggMzEuNjI5OCA0MC4wNzk3IDMyIDQwLjA3OTdDMzIuMzcwMiA0MC4wNzk3IDMyLjY3MDMgNDAuMzc5OCAzMi42NzAzIDQwLjc1WiIgZmlsbD0iI0UxMTYxQyIvPgo8cGF0aCBkPSJNMzMgMjMuMjVDMzMgMjIuNjk3NyAzMi41NTIzIDIyLjI1IDMyIDIyLjI1QzMxLjQ0NzcgMjIuMjUgMzEgMjIuNjk3NyAzMSAyMy4yNUgzM1pNMzEgMzUuNUMzMSAzNi4wNTIzIDMxLjQ0NzcgMzYuNSAzMiAzNi41QzMyLjU1MjMgMzYuNSAzMyAzNi4wNTIzIDMzIDM1LjVIMzFaTTQ4LjUgMzJDNDguNSA0MS4xMTI3IDQxLjExMjcgNDguNSAzMiA0OC41VjUwLjVDNDIuMjE3MyA1MC41IDUwLjUgNDIuMjE3MyA1MC41IDMySDQ4LjVaTTMyIDQ4LjVDMjIuODg3MyA0OC41IDE1LjUgNDEuMTEyNyAxNS41IDMySDEzLjVDMTMuNSA0Mi4yMTczIDIxLjc4MjcgNTAuNSAzMiA1MC41VjQ4LjVaTTE1LjUgMzJDMTUuNSAyMi44ODczIDIyLjg4NzMgMTUuNSAzMiAxNS41VjEzLjVDMjEuNzgyNyAxMy41IDEzLjUgMjEuNzgyNyAxMy41IDMySDE1LjVaTTMyIDE1LjVDNDEuMTEyNyAxNS41IDQ4LjUgMjIuODg3MyA0OC41IDMySDUwLjVDNTAuNSAyMS43ODI3IDQyLjIxNzMgMTMuNSAzMiAxMy41VjE1LjVaTTMxLjY3MDMgNDAuNzVDMzEuNjcwMyA0MC41Njc5IDMxLjgxNzkgNDAuNDIwMyAzMiA0MC40MjAzVjQyLjQyMDNDMzIuOTIyNSA0Mi40MjAzIDMzLjY3MDMgNDEuNjcyNSAzMy42NzAzIDQwLjc1SDMxLjY3MDNaTTMyIDQwLjQyMDNDMzIuMTgyMSA0MC40MjAzIDMyLjMyOTcgNDAuNTY3OSAzMi4zMjk3IDQwLjc1SDMwLjMyOTdDMzAuMzI5NyA0MS42NzI1IDMxLjA3NzUgNDIuNDIwMyAzMiA0Mi40MjAzVjQwLjQyMDNaTTMyLjMyOTcgNDAuNzVDMzIuMzI5NyA0MC45MzIxIDMyLjE4MjEgNDEuMDc5NyAzMiA0MS4wNzk3VjM5LjA3OTdDMzEuMDc3NSAzOS4wNzk3IDMwLjMyOTcgMzkuODI3NSAzMC4zMjk3IDQwLjc1SDMyLjMyOTdaTTMyIDQxLjA3OTdDMzEuODE3OSA0MS4wNzk3IDMxLjY3MDMgNDAuOTMyMSAzMS42NzAzIDQwLjc1SDMzLjY3MDNDMzMuNjcwMyAzOS44Mjc1IDMyLjkyMjUgMzkuMDc5NyAzMiAzOS4wNzk3VjQxLjA3OTdaTTMxIDIzLjI1VjM1LjVIMzNWMjMuMjVIMzFaIiBmaWxsPSIjRTExNjFDIi8+Cjwvc3ZnPgo=",
      className: "error-icon"
    }), /*#__PURE__*/React.createElement("h5", {
      className: "error-title"
    }, i18n.error.error_title), /*#__PURE__*/React.createElement("div", {
      className: "error-description",
      dangerouslySetInnerHTML: {
        __html: errorDescription
      }
    }), /*#__PURE__*/React.createElement(Button$1, {
      settings: i18n.error.error_cta
    })));
  }
  return /*#__PURE__*/React.createElement(Modal$1, {
    reseller: reseller,
    onClose: onClose
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      onClose();
      document.body.style.overflow = "auto";
    }
  }), /*#__PURE__*/React.createElement("h4", {
    className: "form-name"
  }, reseller.name), /*#__PURE__*/React.createElement("form", {
    className: "form",
    onSubmit: function onSubmit(e) {
      return handleSubmit(e, reseller, api_domain, function () {
        return setStatus("ok");
      }, function () {
        return setStatus("nok");
      });
    }
  }, reseller.offices.length <= 1 ? /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "office_id",
    value: reseller.offices[0].id
  })) : /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "office"
  }, "Partner office"), /*#__PURE__*/React.createElement("div", {
    className: "select-wrapper"
  }, /*#__PURE__*/React.createElement("select", {
    name: "office_id",
    id: "office",
    className: "filter-select select-country"
  }, reseller.offices.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.id,
      value: item.id
    }, item.city);
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FormField, {
    htmlFor: "full-name",
    label: "Full name",
    id: "full-name",
    type: "text",
    name: "full_name",
    required: true
  }), /*#__PURE__*/React.createElement(FormField, {
    htmlFor: "email",
    label: "Email",
    id: "email",
    type: "email",
    name: "email",
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FormField, {
    htmlFor: "company",
    label: "Company",
    id: "company",
    type: "text",
    name: "company",
    required: false
  }), /*#__PURE__*/React.createElement(FormField, {
    htmlFor: "phone",
    label: "Phone",
    id: "phone",
    type: "tel",
    name: "phone",
    required: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FormField, {
    htmlFor: "message",
    label: "Message",
    id: "message",
    type: "textarea",
    name: "message",
    required: true
  })), /*#__PURE__*/React.createElement(FormCaptcha$2, {
    onChange: function onChange(captchaStatus) {
      return setDisabled(!captchaStatus);
    }
  }), /*#__PURE__*/React.createElement("span", {
    className: "disclaimer"
  }, "By submitting this form, I accept the", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.chaos.com/privacy"
  }, "Privacy Policy"), ",", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.chaos.com/terms"
  }, "Terms of Use"), " and", " ", /*#__PURE__*/React.createElement("a", {
    href: "https://www.chaos.com/eula"
  }, "EULA")), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn-active",
    disabled: disabled
  }, "Contact this partner")));
};
var PrimaryOffice = function PrimaryOffice(_ref) {
  var offices = _ref.offices;
  if (!offices || offices.length === 0) {
    return null;
  }
  if (offices.find(function (office) {
    return office.primary === true;
  }) === undefined) {
    var _offices$ = offices[0],
      _address = _offices$.address,
      _phone = _offices$.phone;
    return /*#__PURE__*/React.createElement("div", {
      className: "office"
    }, /*#__PURE__*/React.createElement("span", {
      className: "address"
    }, _address), /*#__PURE__*/React.createElement("span", {
      className: "phone"
    }, _phone));
  }
  var getOffice = offices.find(function (office) {
    return office.primary === true;
  });
  var address = getOffice.address,
    phone = getOffice.phone;
  return /*#__PURE__*/React.createElement("div", {
    className: "primary-office"
  }, /*#__PURE__*/React.createElement("span", {
    className: "address"
  }, address), /*#__PURE__*/React.createElement("span", {
    className: "phone"
  }, phone));
};
var isEmpty = function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};
var Reseller = function Reseller(_ref2) {
  var reseller = _ref2.reseller,
    i18n = _ref2.i18n;
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  var locale = React.useContext(LocaleContext);
  var regionName = new Intl.DisplayNames([locale], {
    type: "region"
  });
  return /*#__PURE__*/React.createElement(AccordionRow, {
    renderContent: function renderContent() {
      var _reseller$parent, _reseller$website_lin;
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-7"
      }, /*#__PURE__*/React.createElement("div", {
        className: "inner-info-wrapper"
      }, (reseller === null || reseller === void 0 ? void 0 : (_reseller$parent = reseller.parent) === null || _reseller$parent === void 0 ? void 0 : _reseller$parent.name) && /*#__PURE__*/React.createElement("div", {
        className: "parent"
      }, "Partner of ", /*#__PURE__*/React.createElement("strong", null, reseller.parent.name)), /*#__PURE__*/React.createElement("div", {
        className: "reseller-desc",
        dangerouslySetInnerHTML: {
          __html: reseller.description
        }
      }), ((_reseller$website_lin = reseller.website_link) === null || _reseller$website_lin === void 0 ? void 0 : _reseller$website_lin.link) && /*#__PURE__*/React.createElement(A, {
        href: reseller.website_link.link,
        id: reseller.website_link.id ? reseller.website_link.id : "",
        target: reseller.website_link.target,
        rel: reseller.website_link.rel,
        title: reseller.website_link.label,
        className: "website " + reseller.website_link.className
      }, reseller.website_link.label), /*#__PURE__*/React.createElement(PrimaryOffice, {
        offices: reseller.offices
      }), reseller.offices.filter(function (office) {
        return office.primary === false;
      }).map(function (office, idx) {
        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: "reseller-contact-info"
        }, /*#__PURE__*/React.createElement("div", {
          className: "name-location"
        }, [reseller.name, office.city].join(" - ")), /*#__PURE__*/React.createElement("div", {
          className: "office"
        }, /*#__PURE__*/React.createElement("span", {
          className: "address"
        }, office.address), /*#__PURE__*/React.createElement("span", {
          className: "phone"
        }, office.phone)));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "col-2"
      }, (!isEmpty(reseller.logo) || !isEmpty(reseller.tier.logo)) && /*#__PURE__*/React.createElement(Image, {
        src: isEmpty(reseller.logo) ? reseller.tier.logo : reseller.logo,
        variant: "original"
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "outer-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reseller-location"
  }, /*#__PURE__*/React.createElement("span", {
    className: "city"
  }, reseller.offices.map(function (office) {
    return office.city;
  }).join(", ")), /*#__PURE__*/React.createElement("span", {
    className: "country"
  }, regionName.of(reseller.country)))), /*#__PURE__*/React.createElement("div", {
    className: "col-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "reseller-main-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "main-info-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "tier",
    style: {
      border: "1px solid " + reseller.tier.color,
      color: reseller.tier.color
    }
  }, reseller.tier.name), /*#__PURE__*/React.createElement("h6", {
    className: "reseller-name"
  }, reseller.name)), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-active",
    onClick: function onClick() {
      var primaryOffice = reseller.offices.find(function (office) {
        return office.primary;
      });
      if (primaryOffice && primaryOffice.has_email) {
        setOpen(true);
      } else {
        var _reseller$website_lin2;
        window.open((_reseller$website_lin2 = reseller.website_link) === null || _reseller$website_lin2 === void 0 ? void 0 : _reseller$website_lin2.link, "_blank");
      }
    }
  }, "Contact"))), /*#__PURE__*/React.createElement("div", {
    className: "col-1"
  }))), open && /*#__PURE__*/React.createElement(ContactForm, {
    i18n: i18n,
    reseller: reseller,
    onClose: function onClose() {
      return setOpen(false);
    }
  }));
};
var shouldPickReseller = function shouldPickReseller(r, country, tier) {
  if (!country && !tier) {
    return true;
  }
  if (country && tier && country === r.country && tier === r.tier.code) {
    return true;
  }
  if (!tier && country && country === r.country) {
    return true;
  }
  if (!country && tier && tier === r.tier.code) {
    return true;
  }
  return false;
};
var Widget$1b = function Widget(_ref) {
  var success_title = _ref.success_title,
    success_description = _ref.success_description,
    success_cta = _ref.success_cta,
    error_title = _ref.error_title,
    error_description = _ref.error_description,
    error_cta = _ref.error_cta,
    containerSettings = _ref.containerSettings;
  var _React$useState = React.useState([]),
    resellers = _React$useState[0],
    setResellers = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isLoading = _React$useState2[0],
    setIsLoading = _React$useState2[1];
  var _React$useContext = React.useContext(ResellersContext),
    api_domain = _React$useContext.api_domain,
    country = _React$useContext.country,
    tier = _React$useContext.tier;
  React.useEffect(function () {
    setIsLoading(true);
    fetch(api_domain + "/api/resellers").then(function (r) {
      return r.json();
    }).then(function (d) {
      setResellers(d);
      setIsLoading(false);
    });
  }, []);
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Container$1, {
      settings: containerSettings
    }, /*#__PURE__*/React.createElement("div", {
      className: "resellers-widget"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement(React.Fragment, null, Array.from(Array(10).keys()).map(function (item) {
      return /*#__PURE__*/React.createElement("div", {
        key: item,
        className: "col-12",
        style: {
          marginBottom: "0.5em",
          paddingBottom: "1em",
          borderBottom: "1px solid #e3e3e3"
        }
      }, /*#__PURE__*/React.createElement(RectShape, {
        color: colors.lightBlue,
        style: {
          width: "100%",
          height: "100px"
        }
      }));
    }))))));
  }
  var filteredResellers = resellers.filter(function (r) {
    return shouldPickReseller(r, country, tier);
  });
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "resellers-widget"
  }, /*#__PURE__*/React.createElement(Filter$1, {
    country: country,
    tier: tier,
    resellers: resellers
  }), filteredResellers.map(function (reseller) {
    return /*#__PURE__*/React.createElement(Reseller, {
      key: reseller.id,
      reseller: reseller,
      i18n: {
        success: {
          success_title: success_title,
          success_description: success_description,
          success_cta: success_cta
        },
        error: {
          error_title: error_title,
          error_description: error_description,
          error_cta: error_cta
        }
      }
    });
  })));
};
var Config$1b = {
  title: "Resellers",
  category: "Resellers"
};
var Defaults$1b = {
  success_title: "Thank you",
  success_description: "Your request has been sent to {RESELLER}. A confirmation has also been emailed to you. You are welcome to contact other Chaos Partners as well.",
  success_cta: _extends({}, ButtonSettings.defaults, {
    label: "Go to Chaos Partners",
    link: "/resellers"
  }),
  error_title: "Something went wrong",
  error_description: "Email was not sent to {RESELLER}.",
  error_cta: _extends({}, ButtonSettings.defaults, {
    label: "Got it",
    link: "/resellers",
    type: "secondary-alt"
  }),
  containerSettings: {}
};
var Admin$1a = {
  success_title: {
    type: "text"
  },
  success_description: {
    type: "custom",
    component: RTE
  },
  success_cta: {
    type: "custom",
    component: ButtonSettings
  },
  error_title: {
    type: "text"
  },
  error_description: {
    type: "custom",
    component: RTE
  },
  error_cta: {
    type: "custom",
    component: ButtonSettings
  }
};
var ResellersWidget = {
  __proto__: null,
  Widget: Widget$1b,
  Admin: Admin$1a,
  Config: Config$1b,
  Defaults: Defaults$1b
};
var _excluded$7 = ["label", "required", "type", "htmlFor", "id", "name", "hint", "options"];
var FormField$1 = function FormField(_ref) {
  var label = _ref.label,
    required = _ref.required,
    type = _ref.type,
    htmlFor = _ref.htmlFor,
    id = _ref.id,
    name = _ref.name,
    hint = _ref.hint,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  if (type === "select") return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor
  }, label, " ", required && "*"), /*#__PURE__*/React.createElement("div", {
    className: "style-select"
  }, /*#__PURE__*/React.createElement("select", _extends({
    name: name,
    id: id,
    className: "custom-select",
    required: required
  }, rest), /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Please select country..."), options.map(function (option) {
    return /*#__PURE__*/React.createElement("option", {
      key: option[0],
      value: option[0]
    }, option[1]);
  }))), hint && /*#__PURE__*/React.createElement("div", {
    className: "hint"
  }, hint));
  if (type === "checkbox_group") {
    var defaultChecked = [].concat(rest.defaultChecked);
    delete rest.defaultChecked;
    return /*#__PURE__*/React.createElement("div", {
      className: "form-field-wrapper"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: htmlFor,
      className: "control-label"
    }, label, " ", required && "*"), /*#__PURE__*/React.createElement("div", {
      className: "checkbox-group"
    }, options.map(function (o) {
      return /*#__PURE__*/React.createElement("label", {
        key: o[0]
      }, /*#__PURE__*/React.createElement("input", _extends({
        id: id,
        type: "checkbox",
        name: name,
        value: o[0],
        defaultChecked: defaultChecked.includes(o[0])
      }, rest)), " ", o[1]);
    })), hint && /*#__PURE__*/React.createElement("div", {
      className: "hint"
    }, hint));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor,
    className: "control-label"
  }, label, " ", required && "*"), /*#__PURE__*/React.createElement("input", _extends({
    id: id,
    type: type,
    name: name,
    required: required
  }, rest)), hint && /*#__PURE__*/React.createElement("div", {
    className: "hint"
  }, hint));
};
var Widget$1c = function Widget(_ref2) {
  var disclaimer = _ref2.disclaimer,
    thank_you_url = _ref2.thank_you_url,
    error_url = _ref2.error_url,
    containerSettings = _ref2.containerSettings;
  var _React$useContext = React.useContext(HubSpotContext),
    csrf_token = _React$useContext.csrf_token;
  var allCountries = React.useContext(CountriesContext);
  var _React$useContext2 = React.useContext(FormsContext),
    default_values = _React$useContext2.default_values;
  var handleSubmit = function handleSubmit(e) {
    var data = new FormData(e.target);
    var value = data.get("user[products_of_interest][]");
    var file = data.get("user[document]");
    if (!value) {
      e.preventDefault();
      alert("Please select at least one product.");
    }
    if (file && file.size > 4194304) {
      e.preventDefault();
      alert("Please use a file with a size up to 4MB.");
    }
    trackFormSubmit("Educators", "chaos-educators", "Educators form");
  };
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "educators-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("form", {
    action: "/educators/proof",
    className: "form",
    method: "POST",
    encType: "multipart/form-data",
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "products-of-interest",
    id: "products-of-interest",
    label: "What products are you interested in?",
    type: "checkbox_group",
    name: "user[products_of_interest][]",
    options: [["Chaos", "V-Ray Education"], ["Enscape", "Enscape Education"], ["Corona", "Corona Education"]],
    defaultChecked: (default_values === null || default_values === void 0 ? void 0 : default_values.products_of_interest) || [],
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "authenticity_token",
    defaultValue: csrf_token
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "success_url",
    defaultValue: thank_you_url
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "error_url",
    defaultValue: error_url
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "user[origin]",
    defaultValue: "chaos"
  }), /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "first-name",
    id: "first-name",
    label: "First name",
    type: "text",
    name: "user[first_name]",
    defaultValue: (default_values === null || default_values === void 0 ? void 0 : default_values.first_name) || "",
    className: "lock",
    required: true,
    readOnly: true
  }), /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "last-name",
    id: "last-name",
    label: "Last name",
    type: "text",
    name: "user[last_name]",
    defaultValue: (default_values === null || default_values === void 0 ? void 0 : default_values.last_name) || "",
    className: "lock",
    required: true,
    readOnly: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "email",
    id: "email",
    label: "Email",
    type: "email",
    name: "user[email]",
    defaultValue: (default_values === null || default_values === void 0 ? void 0 : default_values.email) || "",
    className: "lock",
    required: true,
    readOnly: true
  }), /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "institution-name",
    id: "institution-name",
    label: "Name of academic institution",
    type: "text",
    name: "user[institution_name]",
    required: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "institution-website",
    id: "institution-website",
    label: "Website of institution",
    type: "text",
    name: "user[institution_website]",
    required: true
  }), /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "institution-country",
    id: "institution-country",
    label: "Country of academic institution",
    type: "select",
    name: "user[institution_country]",
    required: true,
    options: allCountries.map(function (c) {
      return [c.id, c.name];
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-row"
  }, /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "course-name",
    id: "course-name",
    label: "Course / Program name",
    type: "text",
    name: "user[course_of_study]",
    required: true
  }), /*#__PURE__*/React.createElement(FormField$1, {
    htmlFor: "educator-id",
    id: "educator-id",
    label: "Proof of status",
    type: "file",
    name: "user[document]",
    required: true,
    accept: "image/jpeg, image/png, .pdf",
    hint: "Upload a valid educator ID which includes date, name and your photo (PNG, JPG, PDF and up to 4 MB in size)"
  })), /*#__PURE__*/React.createElement("div", {
    className: "terms"
  }, disclaimer && parseMarkdown(disclaimer, true)), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn-active-dark"
  }, "Submit")))))));
};
var Config$1c = {
  title: "Educators Form",
  category: "Forms"
};
var Defaults$1c = {
  disclaimer: "Lorem ipsum dolor sit amet consectetur adipisicing elit. ",
  thank_you_url: "/educators/thank-you",
  error_url: "/educators/error",
  containerSettings: {}
};
var Admin$1b = {
  disclaimer: {
    type: "textarea"
  },
  thank_you_url: {
    type: "text"
  },
  error_url: {
    type: "text"
  }
};
var EducatorsFormWidget = {
  __proto__: null,
  Widget: Widget$1c,
  Admin: Admin$1b,
  Config: Config$1c,
  Defaults: Defaults$1c
};
var Widget$1d = function Widget(_ref) {
  var form_url = _ref.form_url,
    search_query_name = _ref.search_query_name,
    placeholder = _ref.placeholder,
    submit_button_id = _ref.submit_button_id,
    submit_button_label = _ref.submit_button_label,
    additional_link = _ref.additional_link,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "search-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("form", {
    action: form_url,
    method: "get",
    className: "search-bar-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("input", {
    type: "search",
    name: search_query_name,
    placeholder: placeholder,
    className: "form-control"
  })), /*#__PURE__*/React.createElement("button", {
    id: submit_button_id,
    type: "submit",
    className: "btn-active"
  }, submit_button_label), additional_link.label && /*#__PURE__*/React.createElement(Button$1, {
    settings: additional_link,
    className: "additional-link"
  })))))));
};
var Config$1d = {
  title: "Search Bar",
  category: "General"
};
var Defaults$1d = {
  form_url: "https://www.chaos.com/search",
  search_query_name: "query",
  placeholder: "Placeholder text",
  submit_button_id: "",
  submit_button_label: "Submit",
  additional_link: _extends({}, ButtonSettings.defaults, {
    type: "text"
  }),
  containerSettings: {}
};
var Admin$1c = {
  form_url: {
    label: "Form URL",
    type: "text"
  },
  search_query_name: {
    type: "text",
    hint: "What will be the GET parameter name for triggering search"
  },
  placeholder: {
    type: "text"
  },
  submit_button_id: {
    type: "text"
  },
  submit_button_label: {
    type: "text"
  },
  additional_link: {
    type: "button"
  }
};
var SearchBarWidget = {
  __proto__: null,
  Widget: Widget$1d,
  Admin: Admin$1c,
  Config: Config$1d,
  Defaults: Defaults$1d
};
var RatingInput = function RatingInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Badge",
    value: value.badge,
    onChange: function onChange(badge) {
      return _onChange(_extends({}, value, {
        badge: badge
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Rating",
    value: value.rating,
    onChange: function onChange(rating) {
      return _onChange(_extends({}, value, {
        rating: rating
      }));
    }
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Rating Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange(_extends({}, value, {
        description: description
      }));
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "See More",
    value: value.see_more,
    onChange: function onChange(see_more) {
      return _onChange(_extends({}, value, {
        see_more: see_more
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Rating Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange(_extends({}, value, {
        logo: logo
      }));
    }
  }));
};
RatingInput.defaults = {
  badge: imagePlaceholder("40x60"),
  description: "Lorem ipsum dolor.",
  rating: 4.6,
  see_more: LinkSettings.defaults,
  logo: imagePlaceholder("180x50")
};
var ListItem$f = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Stat",
    value: settings.stat,
    onChange: function onChange(value) {
      return onChangeItem("stat", value);
    }
  }));
};
var StatsInput = function StatsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$f, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$5,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
var TEMPLATE$5 = {
  label: "Label",
  icon: imagePlaceholder("22"),
  stat: "Stat"
};
StatsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$5), _extends({
  id: 2
}, TEMPLATE$5), _extends({
  id: 3
}, TEMPLATE$5)];
var Rating = function Rating(_ref) {
  var settings = _ref.settings;
  return /*#__PURE__*/React.createElement("div", {
    className: "rating-logo-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rating-wrapper"
  }, /*#__PURE__*/React.createElement(Image, {
    src: settings.badge,
    variant: "original",
    className: "rating-badge"
  }), /*#__PURE__*/React.createElement("div", {
    className: "rating"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stars-rate"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "rating-number"
  }, settings.rating), /*#__PURE__*/React.createElement("div", {
    className: "stars",
    style: {
      "--rate": settings.rating
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "rating-description text-center body-s"
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: parser.renderInline(settings.description)
    }
  }), /*#__PURE__*/React.createElement(A, {
    settings: settings.see_more,
    className: "body-s"
  })))));
};
var StatsStack = function StatsStack(_ref) {
  var stats = _ref.stats;
  return /*#__PURE__*/React.createElement("div", {
    className: "stats-wrapper"
  }, stats.map(function (stat) {
    return /*#__PURE__*/React.createElement("div", {
      key: stat.id,
      className: "stat-wrapper"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "label"
    }, stat.label), /*#__PURE__*/React.createElement("div", {
      className: "stat-outer"
    }, /*#__PURE__*/React.createElement(Image, {
      src: stat.icon,
      variant: "original",
      className: "icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "stat body-s"
    }, stat.stat)));
  }));
};
var Widget$1e = function Widget(_ref) {
  var rating = _ref.rating,
    stats = _ref.stats,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "rating-stats"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rating-stats-wrapper"
  }, /*#__PURE__*/React.createElement(Rating, {
    settings: rating
  }), /*#__PURE__*/React.createElement(StatsStack, {
    stats: stats
  })))));
};
var Config$1e = {
  title: "Rating + Stats",
  category: "Media"
};
var Defaults$1e = {
  rating: RatingInput.defaults,
  stats: StatsInput.defaults,
  containerSettings: {}
};
var Admin$1d = {
  rating: {
    type: "custom",
    component: RatingInput
  },
  stats: {
    type: "custom",
    component: StatsInput
  }
};
var RatingStatsWidget = {
  __proto__: null,
  Widget: Widget$1e,
  Admin: Admin$1d,
  Config: Config$1e,
  Defaults: Defaults$1e
};
var ListItem$g = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Title size",
    options: [["default", "Default"], ["small", "Small"]],
    value: settings.title_size,
    onChange: function onChange(value) {
      return onChangeItem("title_size", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Content logo",
    value: settings.content_logo,
    onChange: function onChange(value) {
      return onChangeItem("content_logo", value);
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Content logo link",
    value: settings.content_logo_link || {},
    onChange: function onChange(value) {
      return onChangeItem("content_logo_link", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Content title",
    value: settings.content_title,
    onChange: function onChange(value) {
      return onChangeItem("content_title", value);
    }
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Content text",
    onChange: function onChange(value) {
      return onChangeItem("content_text", value);
    },
    value: settings.content_text
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Content image",
    value: settings.content_image,
    onChange: function onChange(value) {
      return onChangeItem("content_image", value);
    }
  }));
};
var ImageTextTabsInput = function ImageTextTabsInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Tabs" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$g, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$6,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$6 = {
  icon: imagePlaceholder("30x30"),
  title: "Tab",
  title_size: "fs-medium",
  content_logo: imagePlaceholder("100x65"),
  content_logo_link: LinkSettings.defaults,
  content_title: "Content title",
  content_text: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  content_image: imagePlaceholder("540x540")
};
ImageTextTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$6), _extends({
  id: 2
}, TEMPLATE$6), _extends({
  id: 3
}, TEMPLATE$6)];
function Splash(_ref) {
  var title = _ref.title,
    background = _ref.background;
  return /*#__PURE__*/React.createElement("div", {
    className: "splash"
  }, /*#__PURE__*/React.createElement(Image, {
    src: background,
    variant: "single_image_horizontal"
  }), title && /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title));
}
var LogoComponent = function LogoComponent(_ref) {
  var logo = _ref.logo,
    _ref$logoLink = _ref.logoLink,
    logoLink = _ref$logoLink === void 0 ? {} : _ref$logoLink;
  if (logoLink.link) {
    var label = logoLink.label,
      link = logoLink.link,
      id = logoLink.id,
      target = logoLink.target,
      className = logoLink.className,
      rel = logoLink.rel;
    return /*#__PURE__*/React.createElement(A, {
      href: link,
      id: id ? id : "",
      target: target,
      rel: rel,
      title: label || "",
      className: "logo-link " + className
    }, logo && /*#__PURE__*/React.createElement(Image, {
      src: logo,
      variant: "thumb"
    }));
  }
  return /*#__PURE__*/React.createElement(Image, {
    src: logo,
    variant: "thumb"
  });
};
function Text(_ref2) {
  var title = _ref2.title,
    text = _ref2.text,
    logo = _ref2.logo,
    logoLink = _ref2.logoLink;
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-text"
  }, logo && /*#__PURE__*/React.createElement(LogoComponent, {
    logo: logo,
    logoLink: logoLink
  }), title && /*#__PURE__*/React.createElement("h4", null, title), text && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: text
    }
  }));
}
function TabContent$1(_ref3) {
  var variant = _ref3.variant,
    content_logo = _ref3.content_logo,
    content_logo_link = _ref3.content_logo_link,
    content_title = _ref3.content_title,
    content_text = _ref3.content_text,
    content_image = _ref3.content_image;
  return /*#__PURE__*/React.createElement("div", {
    className: "tab"
  }, variant === "tabs-right" && /*#__PURE__*/React.createElement("div", {
    className: "tab-image"
  }, /*#__PURE__*/React.createElement(Image, {
    src: content_image,
    variant: "mobile_square"
  })), /*#__PURE__*/React.createElement(Text, {
    title: content_title,
    text: content_text,
    logo: content_logo,
    logoLink: content_logo_link
  }), variant === "tabs-left" && /*#__PURE__*/React.createElement("div", {
    className: "tab-image"
  }, /*#__PURE__*/React.createElement(Image, {
    src: content_image,
    variant: "mobile_square"
  })));
}
function Tab$1(_ref) {
  var icon = _ref.icon,
    title = _ref.title,
    _ref$title_size = _ref.title_size,
    title_size = _ref$title_size === void 0 ? "default" : _ref$title_size,
    active = _ref.active,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-trigger " + (active ? "active" : "") + " " + (title_size === "small" ? "small" : ""),
    onClick: onClick
  }, icon && /*#__PURE__*/React.createElement(Image, {
    src: icon,
    variant: "thumb"
  }), /*#__PURE__*/React.createElement("span", null, title));
}
function Tabs(_ref2) {
  var title = _ref2.title,
    buttons = _ref2.buttons,
    tabs = _ref2.tabs,
    currentTab = _ref2.currentTab,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-navigation"
  }, title && /*#__PURE__*/React.createElement("h3", null, title), /*#__PURE__*/React.createElement("div", {
    className: "tab-triggers"
  }, tabs.map(function (tab, idx) {
    return /*#__PURE__*/React.createElement(Tab$1, _extends({
      key: idx + "-" + tab.id,
      active: idx === currentTab,
      onClick: function onClick() {
        return onChange(idx);
      }
    }, tab));
  })), /*#__PURE__*/React.createElement("div", null, buttons.map(function (button, idx) {
    if (button !== null && button !== void 0 && button.label && button !== null && button !== void 0 && button.link) {
      return /*#__PURE__*/React.createElement(Button$1, {
        key: idx + "-" + button.id,
        settings: button
      });
    }
    return null;
  })));
}
var useInterval = function useInterval(callback, delay) {
  var intervalRef = React.useRef(null);
  var savedCallback = React.useRef(callback);
  React.useEffect(function () {
    savedCallback.current = callback;
  }, [callback]);
  React.useEffect(function () {
    var tick = function tick() {
      return savedCallback.current();
    };
    if (typeof delay === "number") {
      intervalRef.current = window.setInterval(tick, delay);
      return function () {
        return window.clearInterval(intervalRef.current);
      };
    }
  }, [delay]);
  return intervalRef;
};
function Content$3(_ref) {
  var tabIdx = _ref.tabIdx,
    tabs = _ref.tabs,
    hasSplash = _ref.hasSplash,
    splash_background = _ref.splash_background,
    splash_title = _ref.splash_title,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-8"
  }, tabIdx !== null && /*#__PURE__*/React.createElement(TabContent$1, _extends({
    variant: variant
  }, tabs.find(function (_tab, idx) {
    return idx === tabIdx;
  }))), tabIdx === null && hasSplash && /*#__PURE__*/React.createElement(Splash, {
    title: splash_title,
    background: splash_background
  }));
}
function Desktop(_ref2) {
  var title = _ref2.title,
    button_1 = _ref2.button_1,
    button_2 = _ref2.button_2,
    splash_title = _ref2.splash_title,
    splash_background = _ref2.splash_background,
    auto_rotate = _ref2.auto_rotate,
    tabs = _ref2.tabs,
    variant = _ref2.variant;
  var hasSplash = !!splash_background;
  var hasAutorotate = auto_rotate !== "off";
  var _React$useState = React.useState(hasSplash ? null : 0),
    tabIdx = _React$useState[0],
    setTabIdx = _React$useState[1];
  var _React$useState2 = React.useState(hasAutorotate && !hasSplash ? true : false),
    isPlaying = _React$useState2[0],
    setPlaying = _React$useState2[1];
  var getNextTab = function getNextTab() {
    var lastIdx = tabs.length - 1;
    if (tabIdx === lastIdx) return 0;
    return tabIdx + 1;
  };
  useInterval(function () {
    return setTabIdx(getNextTab());
  }, isPlaying ? parseInt(auto_rotate) : null);
  var handleTabChange = function handleTabChange(newTab) {
    setTabIdx(newTab);
    setPlaying(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "desktop-view"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, variant === "tabs-right" && /*#__PURE__*/React.createElement(Content$3, {
    tabIdx: tabIdx,
    tabs: tabs || [],
    hasSplash: hasSplash,
    splash_background: splash_background,
    splash_title: splash_title,
    variant: variant
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(Tabs, {
    title: title,
    buttons: [button_1, button_2],
    tabs: tabs || [],
    currentTab: tabIdx,
    onChange: handleTabChange
  })), variant === "tabs-left" && /*#__PURE__*/React.createElement(Content$3, {
    tabIdx: tabIdx,
    tabs: tabs || [],
    hasSplash: hasSplash,
    splash_background: splash_background,
    splash_title: splash_title,
    variant: variant
  })));
}
var _excluded$8 = ["icon", "title", "title_size", "active", "onOpen", "onClose"];
var LogoComponent$1 = function LogoComponent(_ref) {
  var logo = _ref.logo,
    _ref$logoLink = _ref.logoLink,
    logoLink = _ref$logoLink === void 0 ? {} : _ref$logoLink;
  if (logoLink.link) {
    var label = logoLink.label,
      link = logoLink.link,
      id = logoLink.id,
      target = logoLink.target,
      className = logoLink.className,
      rel = logoLink.rel;
    return /*#__PURE__*/React.createElement(A, {
      href: link,
      id: id ? id : "",
      target: target,
      rel: rel,
      title: label || "",
      className: "logo-link " + className
    }, logo && /*#__PURE__*/React.createElement(Image, {
      src: logo,
      variant: "thumb"
    }));
  }
  return /*#__PURE__*/React.createElement(Image, {
    src: logo,
    variant: "thumb"
  });
};
function CloseIcon(_ref2) {
  var props = _ref2.props;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.30023L14.7008 0L8 6.7062L1.29918 0L0 1.30023L6.70082 8.00642L0 14.7126L1.29918 16.0128L8 9.30665L14.7008 16.0128L16 14.7126L9.29918 8.00642L16 1.30023Z",
    fill: "#777777"
  }));
}
function TabContent$2(_ref3) {
  var content_logo = _ref3.content_logo,
    content_logo_link = _ref3.content_logo_link,
    content_title = _ref3.content_title,
    content_text = _ref3.content_text,
    content_image = _ref3.content_image,
    onClose = _ref3.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-content"
  }, /*#__PURE__*/React.createElement("button", {
    className: "tab-close",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(CloseIcon, null)), content_logo && /*#__PURE__*/React.createElement(LogoComponent$1, {
    logo: content_logo,
    logoLink: content_logo_link
  }), content_title && /*#__PURE__*/React.createElement("h4", null, content_title), content_text && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: content_text
    }
  }), content_image && /*#__PURE__*/React.createElement(Image, {
    src: content_image,
    variant: "magazine_spotlight",
    className: "content-image"
  }));
}
function Tab$2(_ref4) {
  var icon = _ref4.icon,
    title = _ref4.title,
    _ref4$title_size = _ref4.title_size,
    title_size = _ref4$title_size === void 0 ? "default" : _ref4$title_size,
    active = _ref4.active,
    onOpen = _ref4.onOpen,
    onClose = _ref4.onClose,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded$8);
  if (active) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tab-trigger active " + (title_size === "small" ? "small" : "")
    }, /*#__PURE__*/React.createElement(TabContent$2, _extends({
      onClose: onClose
    }, rest)));
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "tab-trigger",
    onClick: onOpen
  }, icon && /*#__PURE__*/React.createElement(Image, {
    src: icon,
    variant: "thumb"
  }), /*#__PURE__*/React.createElement("span", null, title)));
}
function Mobile(_ref5) {
  var title = _ref5.title,
    button_1 = _ref5.button_1,
    button_2 = _ref5.button_2,
    tabs = _ref5.tabs;
  var _React$useState = React.useState(null),
    tab = _React$useState[0],
    setTab = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "mobile-view"
  }, title && /*#__PURE__*/React.createElement("h3", null, title), tabs.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(Tab$2, _extends({
      key: idx,
      active: idx === tab,
      onOpen: function onOpen() {
        return setTab(idx);
      },
      onClose: function onClose() {
        return setTab(null);
      }
    }, item));
  }), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top-sm"
  }, [button_1, button_2].map(function (button, idx) {
    if (button !== null && button !== void 0 && button.label && button !== null && button !== void 0 && button.link) {
      return /*#__PURE__*/React.createElement(Button$1, {
        key: idx + "-" + button.id,
        settings: button
      });
    }
    return null;
  })));
}
var _excluded$9 = ["containerSettings"];
var Widget$1f = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-text-tabs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Desktop, rest), /*#__PURE__*/React.createElement(Mobile, rest))));
};
var Config$1f = {
  title: "Tabs + Image and text",
  category: "Image + Text"
};
var Defaults$1f = {
  variant: "tabs-left",
  title: "Create life with Chaos",
  button_1: ButtonSettings.defaults,
  button_2: ButtonSettings.defaults,
  splash_title: "The all-in-one solution for 3D visualization",
  splash_background: imagePlaceholder("1410x800"),
  auto_rotate: "off",
  tabs: ImageTextTabsInput.defaults,
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$1e = {
  variant: {
    type: "select",
    options: [["tabs-left", "Tabs left"], ["tabs-right", "Tabs right"]]
  },
  title: {
    type: "text"
  },
  button_1: {
    type: "custom",
    component: ButtonSettings
  },
  button_2: {
    type: "custom",
    component: ButtonSettings
  },
  splash_title: {
    type: "text"
  },
  splash_background: {
    type: "custom",
    component: ImagePicker
  },
  auto_rotate: {
    type: "select",
    options: [["off", "Off"], ["4000", "4 sec"], ["6000", "6 sec"], ["8000", "8 sec"]]
  },
  tabs: {
    type: "custom",
    component: ImageTextTabsInput
  }
};
var ImageAndTextTabsWidget = {
  __proto__: null,
  Widget: Widget$1f,
  Admin: Admin$1e,
  Config: Config$1f,
  Defaults: Defaults$1f
};
var Chevron = function Chevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.46967 18.5303C8.17678 18.2374 8.17678 17.7626 8.46967 17.4697L13.9393 12L8.46967 6.53033C8.17678 6.23744 8.17678 5.76256 8.46967 5.46967C8.76256 5.17678 9.23744 5.17678 9.53033 5.46967L15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L9.53033 18.5303C9.23744 18.8232 8.76256 18.8232 8.46967 18.5303Z",
    fill: "currentColor"
  }));
};
var Header = function Header(_ref) {
  var tab = _ref.tab,
    open = _ref.open,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    className: "tab-header",
    type: "button",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "info"
  }, /*#__PURE__*/React.createElement(Image, {
    src: tab.tab_icon,
    variant: "thumb"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "tab-title " + (open ? "open" : "")
  }, tab.tab_title)), /*#__PURE__*/React.createElement(Chevron, {
    className: "tab-chevron " + (open ? "open" : "")
  }));
};
var LinkWithImage = function LinkWithImage(_ref2) {
  var settings = _ref2.settings,
    image = _ref2.image;
  var link = settings.link,
    id = settings.id,
    target = settings.target,
    label = settings.label,
    follow_link = settings.follow_link;
  if (link) {
    return /*#__PURE__*/React.createElement(A, {
      href: link,
      id: id ? id : "",
      rel: follow_link === "no-follow" ? "nofollow" : "",
      target: target,
      title: label
    }, /*#__PURE__*/React.createElement(Image, {
      src: image,
      variant: "full_width_original"
    }));
  }
  return /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "full_width_original"
  });
};
var Content$4 = function Content(_ref3) {
  var tab = _ref3.tab,
    variant = _ref3.variant,
    open = _ref3.open,
    autoRotate = _ref3.autoRotate;
  var barRef = /*#__PURE__*/React.createRef(null);
  React.useEffect(function () {
    if (autoRotate !== "off" && open && barRef.current) {
      var duration = Number.parseInt(autoRotate, 10) / 1000;
      barRef.current.style.animation = "fillup linear " + duration + "s";
    }
  }, [autoRotate, open]);
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-content " + (open ? "open" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, autoRotate != "off" && open && /*#__PURE__*/React.createElement("div", {
    className: "progress-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-bar",
    ref: barRef
  })), variant === "image-left" && /*#__PURE__*/React.createElement("div", {
    className: "col-7 left-padding mobile-spacing-bottom"
  }, /*#__PURE__*/React.createElement(LinkWithImage, {
    settings: tab.button,
    image: tab.image
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-5 " + variant
  }, /*#__PURE__*/React.createElement("h4", null, tab.title), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(tab.description)), /*#__PURE__*/React.createElement(Button$1, {
    settings: tab.button
  })), variant === "image-right" && /*#__PURE__*/React.createElement("div", {
    className: "col-7 mobile-spacing-top"
  }, /*#__PURE__*/React.createElement(LinkWithImage, {
    settings: tab.button,
    image: tab.image
  }))));
};
function scrollToTarget(target) {
  window.scrollTo({
    top: cumulativeTopOffset(target),
    left: 0,
    behavior: "smooth"
  });
}
var Tab$3 = function Tab(_ref4) {
  var tab = _ref4.tab,
    open = _ref4.open,
    variant = _ref4.variant,
    autoRotate = _ref4.autoRotate,
    scrollOnOpen = _ref4.scrollOnOpen,
    _onClick = _ref4.onClick;
  var _React$useState = React.useState(false),
    manuallyOpened = _React$useState[0],
    setManuallyOpened = _React$useState[1];
  var tabRef = /*#__PURE__*/React.createRef(null);
  React.useEffect(function () {
    if (manuallyOpened && open && scrollOnOpen && tabRef.current) {
      scrollToTarget(tabRef.current);
    }
  }, [open]);
  return /*#__PURE__*/React.createElement("div", {
    className: "tab",
    ref: tabRef
  }, /*#__PURE__*/React.createElement(Header, {
    tab: tab,
    open: open,
    onClick: function onClick() {
      _onClick();
      setManuallyOpened(true);
    }
  }), /*#__PURE__*/React.createElement(Content$4, {
    tab: tab,
    variant: variant,
    open: open,
    autoRotate: autoRotate
  }));
};
function prepareDelay(autoRotate) {
  var parsed = Number.parseInt(autoRotate, 10);
  if (isNaN(parsed)) {
    return 0;
  }
  return parsed;
}
var useInterval$1 = function useInterval(onComplete, autoRotate, openedTab) {
  var intervalRef = React.useRef(null);
  var callbackRef = React.useRef(null);
  React.useEffect(function () {
    callbackRef.current = function () {
      onComplete();
    };
  }, [onComplete]);
  React.useEffect(function () {
    if (intervalRef.current) {
      window.clearInterval(intervalRef.current);
    }
    var timeout = prepareDelay(autoRotate);
    if (timeout > 0 && callbackRef.current) {
      intervalRef.current = window.setInterval(callbackRef.current, timeout);
    }
    return function () {
      if (intervalRef.current) {
        window.clearInterval(intervalRef.current);
      }
    };
  }, [autoRotate, openedTab]);
  return intervalRef;
};
var Desktop$1 = function Desktop(_ref) {
  var _tabs$;
  var auto_rotate = _ref.auto_rotate,
    variant = _ref.variant,
    tabs = _ref.tabs,
    containerSettings = _ref.containerSettings;
  var _React$useState = React.useState((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  useInterval$1(function () {
    setOpen(function (current) {
      var idx = tabs.findIndex(function (t) {
        return t.id === current;
      });
      if (idx >= tabs.length - 1) {
        var _tabs$2;
        return (_tabs$2 = tabs[0]) === null || _tabs$2 === void 0 ? void 0 : _tabs$2.id;
      } else {
        var _tabs;
        return (_tabs = tabs[idx + 1]) === null || _tabs === void 0 ? void 0 : _tabs.id;
      }
    });
  }, auto_rotate, open);
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "industry-tabs desktop",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(Tab$3, {
      key: tab.id,
      variant: variant,
      tab: tab,
      open: open === tab.id,
      autoRotate: auto_rotate,
      onClick: function onClick() {
        setOpen(tab.id);
      }
    });
  })));
};
var Mobile$1 = function Mobile(_ref2) {
  var _tabs$3;
  var variant = _ref2.variant,
    tabs = _ref2.tabs,
    containerSettings = _ref2.containerSettings;
  var _React$useState2 = React.useState((_tabs$3 = tabs[0]) === null || _tabs$3 === void 0 ? void 0 : _tabs$3.id),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "industry-tabs mobile",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(Tab$3, {
      key: tab.id,
      variant: variant,
      tab: tab,
      open: open === tab.id,
      autoRotate: "off",
      scrollOnOpen: true,
      onClick: function onClick() {
        setOpen(tab.id);
      }
    });
  })));
};
var Widget$1g = function Widget(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Desktop$1, props), /*#__PURE__*/React.createElement(Mobile$1, props));
};
var ListItem$h = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Tab Icon",
    value: settings.tab_icon,
    onChange: function onChange(value) {
      return onChangeItem("tab_icon", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Tab Title",
    value: settings.tab_title,
    onChange: function onChange(value) {
      return onChangeItem("tab_title", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: settings.button || {},
    onChange: function onChange(value) {
      return onChangeItem("button", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    value: settings.image,
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    }
  }), /*#__PURE__*/React.createElement(RTE, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }));
};
var IndistryTabsInput = function IndistryTabsInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Tabs",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$h, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$7,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$7 = {
  tab_icon: imagePlaceholder("30x30"),
  tab_title: "Tab title",
  title: "Tab",
  description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  button: ButtonSettings.defaults,
  image: imagePlaceholder("1920x760")
};
IndistryTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$7), _extends({
  id: 2
}, TEMPLATE$7), _extends({
  id: 3
}, TEMPLATE$7)];
var Admin$1f = {
  auto_rotate: {
    type: "select",
    options: [["off", "Off"], ["4000", "4 sec"], ["6000", "6 sec"], ["8000", "8 sec"]]
  },
  variant: {
    type: "select",
    options: [["image-left", "Image left"], ["image-right", "Image right"]]
  },
  tabs: {
    type: "custom",
    component: IndistryTabsInput
  }
};
var Defaults$1g = {
  auto_rotate: "off",
  variant: "image-right",
  tabs: IndistryTabsInput.defaults,
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Config$1g = {
  title: "Industry tabs",
  category: "Image + Text"
};
var IndustryTabsWidget = {
  __proto__: null,
  Widget: Widget$1g,
  Admin: Admin$1f,
  Config: Config$1g,
  Defaults: Defaults$1g
};
var ListItem$i = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(icon) {
      return onChangeItem("icon", icon);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Active Icon (when selected)",
    value: settings.active_icon,
    onChange: function onChange(active_icon) {
      return onChangeItem("active_icon", active_icon);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(title) {
      return onChangeItem("title", title);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Feature Title",
    onChange: function onChange(feature_title) {
      return onChangeItem("feature_title", feature_title);
    },
    value: settings.feature_title
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Feature Description",
    onChange: function onChange(feature_description) {
      return onChangeItem("feature_description", feature_description);
    },
    value: settings.feature_description
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Feature Background Image",
    value: settings.feature_background,
    onChange: function onChange(feature_background) {
      return onChangeItem("feature_background", feature_background);
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Background video",
    value: settings.feature_video_id,
    onChange: function onChange(feature_video_id) {
      return onChangeItem("feature_video_id", feature_video_id);
    }
  }));
};
var CoreProductFeaturesInput = function CoreProductFeaturesInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Core Product Features" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$i, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$8,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$8 = {
  icon: imagePlaceholder("28x28"),
  active_icon: imagePlaceholder("28x28"),
  title: "Core Product Feature",
  feature_title: "Core Product Feature",
  feature_description: "Facade elevation spatial design structural beam load-bearing masonry grid circulation plan module viewport skylight section profile cladding materiality. Open floor concept concrete slab.",
  feature_background: imagePlaceholder("1040x585"),
  feature_video_id: ""
};
CoreProductFeaturesInput.defaults = [_extends({
  id: 1
}, TEMPLATE$8), _extends({
  id: 2
}, TEMPLATE$8), _extends({
  id: 3
}, TEMPLATE$8)];
var ProductTagsCardInput = function ProductTagsCardInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Background",
    value: value.background,
    onChange: function onChange(background) {
      return _onChange(_extends({}, value, {
        background: background
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    },
    value: value.title,
    hint: "When this property is missing the card will not be visible!"
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Tags",
    onChange: function onChange(tags) {
      return _onChange(_extends({}, value, {
        tags: tags
      }));
    },
    value: value.tags
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Credits",
    onChange: function onChange(credits) {
      return _onChange(_extends({}, value, {
        credits: credits
      }));
    },
    value: value.credits
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Background video",
    value: value.video_id,
    onChange: function onChange(video_id) {
      return _onChange(_extends({}, value, {
        video_id: video_id
      }));
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    value: value.link,
    onChange: function onChange(link) {
      return _onChange(_extends({}, value, {
        link: link
      }));
    },
    hint: "The label is not used! Remove the link value if you don't wish the card to be a link"
  }));
};
ProductTagsCardInput.defaults = {
  background: imagePlaceholder("464x290"),
  title: "All you need is an architect",
  tags: "Interrior, Buildings, Landscape, MEP, BIM",
  credits: "Rendered by Liv-Iy",
  video_id: "",
  link: LinkSettings.defaults
};
var ListItem$j = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  var _React$useState = React.useState(false),
    secondaryProductsModalOpen = _React$useState[0],
    setSecondaryProductsModalOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setSecondaryProductsModalOpen(true);
    },
    style: {
      padding: "10px"
    }
  }, "Manage Product Card"), /*#__PURE__*/React.createElement(Modal, {
    title: "Secondary Products Card",
    open: secondaryProductsModalOpen,
    onClose: function onClose() {
      return setSecondaryProductsModalOpen(false);
    },
    style: {
      height: "80%",
      overflow: "scroll",
      margin: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: "20px",
      paddingRight: "20px"
    }
  }, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Video Preview",
    value: settings.video_preview,
    onChange: function onChange(video_preview) {
      return onChangeItem("video_preview", video_preview);
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Hosted video",
    onChange: function onChange(value) {
      return onChangeItem("video_id", value);
    },
    value: settings.video_id
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(logo) {
      return onChangeItem("logo", logo);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(title) {
      return onChangeItem("title", title);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    onChange: function onChange(description) {
      return onChangeItem("description", description);
    },
    value: settings.description
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 1",
    value: settings.button_1,
    onChange: function onChange(settings) {
      return onChangeItem("button_1", settings);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 2",
    value: settings.button_2,
    onChange: function onChange(settings) {
      return onChangeItem("button_2", settings);
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      padding: "5px 10px",
      marginBottom: "10px",
      marginTop: "10px"
    },
    onClick: function onClick() {
      return setSecondaryProductsModalOpen(false);
    }
  }, "OK"))));
};
var SecondaryProductsInput = function SecondaryProductsInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Secondary Products" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$j, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$9,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    },
    itemsAlwaysOpen: true
  });
};
var TEMPLATE$9 = {
  video_preview: imagePlaceholder("720x405"),
  video_id: "",
  logo: imagePlaceholder("130x40"),
  title: "Photorealistic renderings",
  description: "UV unwrap texture map smoothing render pass. PBR shading bake geometry rigging normal map keyframe animation viewport ",
  button_1: ButtonSettings.defaults,
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "secondary"
  })
};
SecondaryProductsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$9), _extends({
  id: 2
}, TEMPLATE$9)];
var ProductStatCardInput = function ProductStatCardInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(TextInput, {
    label: "Stat",
    onChange: function onChange(stat) {
      return _onChange(_extends({}, value, {
        stat: stat
      }));
    },
    value: value.stat,
    hint: "When this property is missing the card will not be visible!"
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    onChange: function onChange(label) {
      return _onChange(_extends({}, value, {
        label: label
      }));
    },
    value: value.label
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Disclaimer",
    onChange: function onChange(disclaimer) {
      return _onChange(_extends({}, value, {
        disclaimer: disclaimer
      }));
    },
    value: value.disclaimer
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Background",
    value: value.background,
    onChange: function onChange(background) {
      return _onChange(_extends({}, value, {
        background: background
      }));
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Background video",
    value: value.video_id,
    onChange: function onChange(video_id) {
      return _onChange(_extends({}, value, {
        video_id: video_id
      }));
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    value: value.link,
    onChange: function onChange(link) {
      return _onChange(_extends({}, value, {
        link: link
      }));
    },
    hint: "The label is not used! Remove the link value if you don't wish the card to be a link"
  }));
};
ProductStatCardInput.defaults = {
  stat: "3x",
  label: "faster design process",
  disclaimer: "according to our latest customer survey",
  background: imagePlaceholder("464x290"),
  video_id: "",
  link: LinkSettings.defaults
};
var ProductSimpleCardnput = function ProductSimpleCardnput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    },
    value: value.title,
    hint: "When this property is missing the card will not be visible!"
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Background",
    value: value.background,
    onChange: function onChange(background) {
      return _onChange(_extends({}, value, {
        background: background
      }));
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Background video",
    value: value.video_id,
    onChange: function onChange(video_id) {
      return _onChange(_extends({}, value, {
        video_id: video_id
      }));
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    value: value.link,
    onChange: function onChange(link) {
      return _onChange(_extends({}, value, {
        link: link
      }));
    },
    hint: "The label is not used! Remove the link value if you don't wish the card to be a link"
  }));
};
ProductSimpleCardnput.defaults = {
  title: "AI tools at your fingertips",
  background: imagePlaceholder("464x290"),
  video_id: "",
  link: LinkSettings.defaults
};
var CoreProductInput = function CoreProductInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  var _React$useState = React.useState(false),
    coreProductModalOpen = _React$useState[0],
    setCoreProductModalOpen = _React$useState[1];
  var _React$useState2 = React.useState(false),
    supportingProductsModalOpen = _React$useState2[0],
    setSupportingProductsModalOpen = _React$useState2[1];
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement("div", {
    className: "industry-tabs-button-container",
    style: {
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      alignItems: "flex-start"
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setCoreProductModalOpen(true);
    },
    style: {
      padding: "10px"
    }
  }, "Manage Core Product Card"), /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setSupportingProductsModalOpen(true);
    },
    style: {
      padding: "10px"
    }
  }, "Manage Supporting Products Card")), /*#__PURE__*/React.createElement(Modal, {
    title: "Core Product Card",
    open: coreProductModalOpen,
    onClose: function onClose() {
      return setCoreProductModalOpen(false);
    },
    style: {
      height: "80%",
      overflow: "scroll",
      margin: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: "20px",
      paddingRight: "20px"
    }
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Align",
    value: value.align,
    options: [["left", "Left"], ["right", "Right"]],
    onChange: function onChange(align) {
      return _onChange("align", align);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange("logo", logo);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Product color",
    onChange: function onChange(product_color) {
      return _onChange("product_color", product_color);
    },
    value: value.product_color
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Feature Background Image",
    onChange: function onChange(background) {
      return _onChange("background", background);
    },
    value: value.background
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Backgorund video",
    onChange: function onChange(value) {
      return _onChange("video_id", value);
    },
    value: value.video_id
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(title) {
      return _onChange("title", title);
    },
    value: value.title
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    onChange: function onChange(description) {
      return _onChange("description", description);
    },
    value: value.description
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 1",
    value: value.button_1,
    onChange: function onChange(settings) {
      return _onChange("button_1", settings);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 2",
    value: value.button_2,
    onChange: function onChange(settings) {
      return _onChange("button_2", settings);
    }
  }), /*#__PURE__*/React.createElement(CoreProductFeaturesInput, {
    label: "Core Product Features",
    value: value.features,
    onChange: function onChange(features) {
      return _onChange("features", features);
    }
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      padding: "5px 10px",
      marginBottom: "10px"
    },
    onClick: function onClick() {
      return setCoreProductModalOpen(false);
    }
  }, "OK"))), /*#__PURE__*/React.createElement(Modal, {
    title: "Supporting Products Card",
    open: supportingProductsModalOpen,
    onClose: function onClose() {
      return setSupportingProductsModalOpen(false);
    },
    style: {
      height: "80%",
      overflow: "scroll",
      margin: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: "20px",
      paddingRight: "20px",
      display: "flex",
      flexDirection: "column",
      gap: "20px"
    }
  }, /*#__PURE__*/React.createElement(Panel, {
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/React.createElement(ProductTagsCardInput, {
    label: "Product highlight with tags",
    value: value.product_highlight_1,
    onChange: function onChange(product_highlight_1) {
      return _onChange("product_highlight_1", product_highlight_1);
    }
  })), /*#__PURE__*/React.createElement(Panel, {
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/React.createElement(ProductStatCardInput, {
    label: "Product Stat",
    value: value.product_highlight_2,
    onChange: function onChange(product_highlight_2) {
      return _onChange("product_highlight_2", product_highlight_2);
    }
  })), /*#__PURE__*/React.createElement(Panel, {
    style: {
      padding: "10px"
    }
  }, /*#__PURE__*/React.createElement(ProductSimpleCardnput, {
    label: "Product highlight",
    value: value.product_highlight_3,
    onChange: function onChange(product_highlight_3) {
      return _onChange("product_highlight_3", product_highlight_3);
    }
  }))), /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      padding: "5px 10px",
      marginBottom: "10px",
      marginLeft: "20px"
    },
    onClick: function onClick() {
      return setSupportingProductsModalOpen(false);
    }
  }, "OK")), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Product Disclaimer",
    value: value.product_disclaimer,
    onChange: function onChange(product_disclaimer) {
      return _onChange("product_disclaimer", product_disclaimer);
    },
    hint: "Write raw HTML here!"
  }), /*#__PURE__*/React.createElement(SecondaryProductsInput, {
    label: "Secondary Products",
    value: value.secondary_products,
    onChange: function onChange(secondary_products) {
      return _onChange("secondary_products", secondary_products);
    }
  }));
};
CoreProductInput.defaults = {
  align: "left",
  logo: imagePlaceholder("130x40"),
  product_color: "orange",
  video_id: "",
  background: imagePlaceholder("1040x585"),
  title: "",
  description: "",
  button_1: ButtonSettings.defaults,
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "secondary"
  }),
  features: CoreProductFeaturesInput.defaults,
  product_highlight_1: ProductTagsCardInput.defaults,
  product_highlight_2: ProductStatCardInput.defaults,
  product_highlight_3: ProductSimpleCardnput.defaults,
  product_disclaimer: "",
  secondary_products: SecondaryProductsInput.defaults
};
var TEMPLATE$a = {
  label: "Tab label",
  title: "Tab title",
  sub_title: "tab sub title",
  core_products: [_extends({
    id: 1
  }, CoreProductInput.defaults)]
};
var CoreProductsInput = function CoreProductsInput(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Core Products",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CoreProductInput, {
        label: "Core Product",
        value: settings,
        onChange: onChangeItem
      });
    },
    onChangeList: function onChangeList(_key, updatedList) {
      return onChange(updatedList);
    },
    items: value,
    template: CoreProductInput.defaults,
    primaryField: "title"
  });
};
var NewIndustryTabInput = function NewIndustryTabInput(_ref2) {
  var settings = _ref2.settings,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    },
    hint: "Used for the tabs navigation"
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub Title",
    value: settings.sub_title,
    onChange: function onChange(value) {
      return onChangeItem("sub_title", value);
    }
  }), /*#__PURE__*/React.createElement(CoreProductsInput, {
    value: settings.core_products,
    onChange: function onChange(value) {
      return onChangeItem("core_products", value);
    }
  }));
};
var NewIndustryTabsInput = function NewIndustryTabsInput(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Tabs",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(NewIndustryTabInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$a,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
NewIndustryTabsInput.defaults = [_extends({}, TEMPLATE$a, {
  id: 1
}), _extends({}, TEMPLATE$a, {
  id: 2
}), _extends({}, TEMPLATE$a, {
  id: 3
})];
var MaybeLink = function MaybeLink(_ref) {
  var link = _ref.link,
    children = _ref.children;
  if (link !== null && link !== void 0 && link.link) {
    return /*#__PURE__*/React.createElement(Link$6, {
      settings: link
    }, children);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
var ProductStatCard = function ProductStatCard(_ref) {
  var stat = _ref.stat,
    label = _ref.label,
    disclaimer = _ref.disclaimer,
    background = _ref.background,
    link = _ref.link,
    _ref$lastOnMobile = _ref.lastOnMobile,
    lastOnMobile = _ref$lastOnMobile === void 0 ? false : _ref$lastOnMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: "small-card stat-card",
    "data-industry-card": lastOnMobile
  }, /*#__PURE__*/React.createElement(MaybeLink, {
    link: link
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: background,
    variant: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content column"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: "stat"
  }, stat), /*#__PURE__*/React.createElement("h4", {
    className: "stat-label"
  }, label)), /*#__PURE__*/React.createElement("p", {
    className: "disclaimer"
  }, disclaimer))));
};
var Tag = function Tag(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, label);
};
var ProductTagsCard = function ProductTagsCard(_ref2) {
  var background = _ref2.background,
    title = _ref2.title,
    tags = _ref2.tags,
    credits = _ref2.credits,
    link = _ref2.link,
    _ref2$lastOnMobile = _ref2.lastOnMobile,
    lastOnMobile = _ref2$lastOnMobile === void 0 ? false : _ref2$lastOnMobile;
  var formattedTags = React.useMemo(function () {
    return tags === null || tags === void 0 ? void 0 : tags.split(",").map(function (t) {
      return t.trim();
    });
  }, [tags]);
  return /*#__PURE__*/React.createElement("div", {
    className: "small-card tags-card",
    "data-industry-card": lastOnMobile
  }, /*#__PURE__*/React.createElement(MaybeLink, {
    link: link
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: background,
    variant: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, formattedTags.map(function (tag, idx) {
    return /*#__PURE__*/React.createElement(Tag, {
      key: idx,
      label: tag
    });
  }))), credits && /*#__PURE__*/React.createElement("div", {
    className: "credits"
  }, credits)));
};
var ProductSimpleCard = function ProductSimpleCard(_ref) {
  var background = _ref.background,
    title = _ref.title,
    link = _ref.link,
    _ref$lastOnMobile = _ref.lastOnMobile,
    lastOnMobile = _ref$lastOnMobile === void 0 ? false : _ref$lastOnMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: "small-card simple-card",
    "data-industry-card": lastOnMobile
  }, /*#__PURE__*/React.createElement(MaybeLink, {
    link: link
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: background,
    variant: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content column"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title))));
};
var HostedVideo$1 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video"
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "eager",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video with-effect",
    onMouseEnter: function onMouseEnter() {
      if (videoRef !== null && videoRef !== void 0 && videoRef.current) {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.current.play();
      }
    },
    onMouseLeave: function onMouseLeave() {
      if (videoRef !== null && videoRef !== void 0 && videoRef.current) {
        videoRef === null || videoRef === void 0 ? void 0 : videoRef.current.pause();
      }
    }
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "eager",
    src: cover,
    variant: "image"
  }), /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: false,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video."));
};
var SecondaryProductCard = function SecondaryProductCard(_ref) {
  var video_preview = _ref.video_preview,
    logo = _ref.logo,
    title = _ref.title,
    description = _ref.description,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    video_id = _ref.video_id,
    videos = _ref.videos,
    _ref$lastOnMobile = _ref.lastOnMobile,
    lastOnMobile = _ref$lastOnMobile === void 0 ? false : _ref$lastOnMobile;
  return /*#__PURE__*/React.createElement("div", {
    className: "medium-card",
    "data-industry-card": lastOnMobile
  }, /*#__PURE__*/React.createElement("div", {
    className: "media"
  }, /*#__PURE__*/React.createElement(HostedVideo$1, {
    video: videos.find(function (v) {
      return v.id === video_id;
    }),
    cover: video_preview
  })), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: logo,
    variant: "original",
    className: "logo"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description)), ((button_1 === null || button_1 === void 0 ? void 0 : button_1.label) || (button_2 === null || button_2 === void 0 ? void 0 : button_2.label)) && /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, (button_1 === null || button_1 === void 0 ? void 0 : button_1.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1,
    className: "btn-small"
  }), (button_2 === null || button_2 === void 0 ? void 0 : button_2.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2,
    className: "btn-small"
  }))));
};
var Feature = function Feature(_ref) {
  var id = _ref.id,
    icon = _ref.icon,
    title = _ref.title,
    productColor = _ref.productColor,
    onFeatureSelect = _ref.onFeatureSelect;
  return /*#__PURE__*/React.createElement("div", {
    className: "feature",
    style: {
      "--core-product-feature-custom-color": productColor
    },
    onClick: function onClick() {
      return onFeatureSelect(id);
    }
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "eager",
    src: icon,
    variant: "original"
  }), /*#__PURE__*/React.createElement("div", null, title));
};
var ActiveFeature = function ActiveFeature(_ref2) {
  var active_icon = _ref2.active_icon,
    title = _ref2.title,
    productColor = _ref2.productColor;
  return /*#__PURE__*/React.createElement("div", {
    className: "feature active",
    style: {
      borderColor: productColor,
      "--core-product-feature-custom-color": productColor
    }
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "eager",
    src: active_icon,
    variant: "original"
  }), /*#__PURE__*/React.createElement("div", null, title));
};
var DesktopMedia = function DesktopMedia(_ref3) {
  var video = _ref3.video,
    background = _ref3.background,
    features = _ref3.features,
    productColor = _ref3.productColor,
    currentFeature = _ref3.currentFeature,
    onFeatureSelect = _ref3.onFeatureSelect;
  var videoRef = React.useRef(null);
  React.useEffect(function () {
    if (!video) return;
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  return /*#__PURE__*/React.createElement("div", {
    className: "media"
  }, video ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    muted: true,
    playsInline: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : /*#__PURE__*/React.createElement(Image, {
    loading: "eager",
    src: background,
    variant: "original",
    className: "cover"
  }), (features === null || features === void 0 ? void 0 : features.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "features"
  }, features === null || features === void 0 ? void 0 : features.map(function (feature) {
    if (feature.id === (currentFeature === null || currentFeature === void 0 ? void 0 : currentFeature.id)) {
      return /*#__PURE__*/React.createElement(ActiveFeature, _extends({
        key: feature.id,
        productColor: productColor
      }, feature));
    }
    return /*#__PURE__*/React.createElement(Feature, _extends({
      key: feature.id,
      productColor: productColor,
      onFeatureSelect: onFeatureSelect
    }, feature));
  })));
};
var MobileMedia = function MobileMedia(_ref) {
  var video = _ref.video,
    background = _ref.background;
  var videoRef = React.useRef(null);
  React.useEffect(function () {
    if (!video) return;
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  return /*#__PURE__*/React.createElement("div", {
    className: "media"
  }, video ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    muted: true,
    playsInline: true,
    loop: true,
    style: {
      aspectRatio: "16/9",
      objectFit: "cover",
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : /*#__PURE__*/React.createElement(Image, {
    loading: "eager",
    src: background,
    variant: "image",
    className: "cover"
  }));
};
var CLASSES_MAP = {
  left: "content-left",
  right: "content-right"
};
var Content$5 = function Content(_ref) {
  var logo = _ref.logo,
    title = _ref.title,
    description = _ref.description,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2;
  return /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner-content"
  }, /*#__PURE__*/React.createElement("div", null, logo && /*#__PURE__*/React.createElement(Image, {
    loading: "eager",
    src: logo,
    variant: "original",
    className: "logo"
  }), /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(description))), /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, (button_1 === null || button_1 === void 0 ? void 0 : button_1.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1,
    className: "btn-small"
  }), (button_2 === null || button_2 === void 0 ? void 0 : button_2.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2,
    className: "btn-small"
  }))));
};
var CoreCardMobile = function CoreCardMobile(_ref2) {
  var logo = _ref2.logo,
    video_id = _ref2.video_id,
    background = _ref2.background,
    title = _ref2.title,
    description = _ref2.description,
    button_1 = _ref2.button_1,
    button_2 = _ref2.button_2,
    videos = _ref2.videos,
    _ref2$lastOnMobile = _ref2.lastOnMobile,
    lastOnMobile = _ref2$lastOnMobile === void 0 ? false : _ref2$lastOnMobile;
  var video = videos.find(function (v) {
    return v.id === video_id;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "core-card-mobile",
    "data-industry-card": lastOnMobile
  }, /*#__PURE__*/React.createElement(MobileMedia, {
    background: background,
    video: video
  }), /*#__PURE__*/React.createElement(Content$5, {
    logo: logo,
    title: title,
    description: description,
    button_1: button_1,
    button_2: button_2
  }));
};
var CoreCardDesktop = function CoreCardDesktop(_ref3) {
  var _features$;
  var _ref3$align = _ref3.align,
    align = _ref3$align === void 0 ? "left" : _ref3$align,
    logo = _ref3.logo,
    product_color = _ref3.product_color,
    video_id = _ref3.video_id,
    background = _ref3.background,
    title = _ref3.title,
    description = _ref3.description,
    button_1 = _ref3.button_1,
    button_2 = _ref3.button_2,
    features = _ref3.features,
    videos = _ref3.videos;
  var _React$useState = React.useState(features === null || features === void 0 ? void 0 : (_features$ = features[0]) === null || _features$ === void 0 ? void 0 : _features$.id),
    feature = _React$useState[0],
    setFeature = _React$useState[1];
  React.useEffect(function () {
    var _features$2;
    setFeature(features === null || features === void 0 ? void 0 : (_features$2 = features[0]) === null || _features$2 === void 0 ? void 0 : _features$2.id);
  }, [features]);
  var currentFeature = features === null || features === void 0 ? void 0 : features.find(function (f) {
    return f.id === feature;
  });
  var currentTitle = title;
  var currentDescription = description;
  var currentBackgroud = background;
  var currentVideoId = video_id;
  if (currentFeature) {
    currentVideoId = currentFeature.feature_video_id;
    currentBackgroud = currentFeature === null || currentFeature === void 0 ? void 0 : currentFeature.feature_background;
    currentDescription = currentFeature === null || currentFeature === void 0 ? void 0 : currentFeature.feature_description;
    currentTitle = currentFeature === null || currentFeature === void 0 ? void 0 : currentFeature.feature_title;
  }
  var currentVideo = videos.find(function (v) {
    return v.id === currentVideoId;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "core-card-desktop " + CLASSES_MAP[align]
  }, align === "left" && /*#__PURE__*/React.createElement(Content$5, {
    logo: logo,
    title: currentTitle,
    description: currentDescription,
    button_1: button_1,
    button_2: button_2
  }), /*#__PURE__*/React.createElement(DesktopMedia, {
    video: currentVideo,
    background: currentBackgroud,
    features: features,
    productColor: product_color,
    onFeatureSelect: function onFeatureSelect(featureId) {
      return setFeature(featureId);
    },
    currentFeature: currentFeature
  }), align === "right" && /*#__PURE__*/React.createElement(Content$5, {
    logo: logo,
    title: currentTitle,
    description: currentDescription,
    button_1: button_1,
    button_2: button_2
  }));
};
var CoreProductCard = function CoreProductCard(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CoreCardMobile, props), /*#__PURE__*/React.createElement(CoreCardDesktop, props));
};
var Headings$3 = function Headings(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle;
  return /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, parseMarkdown(title, true)), subTitle && /*#__PURE__*/React.createElement("h5", {
    className: "sub-title"
  }, parseMarkdown(subTitle, true)));
};
var Switcher = function Switcher(_ref) {
  var tabs = _ref.tabs,
    currentTab = _ref.currentTab,
    scrollTargetId = _ref.scrollTargetId,
    onSelect = _ref.onSelect;
  return /*#__PURE__*/React.createElement("div", {
    className: "switcher"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tab " + (currentTab === tab.id ? "active" : ""),
      key: tab.id,
      role: "button",
      onClick: function onClick() {
        onSelect(tab.id);
        var element = document.getElementById(scrollTargetId);
        window.scrollTo({
          top: cumulativeTopOffset(element),
          left: 0,
          behavior: "smooth"
        });
      }
    }, tab.label);
  })));
};
var useGraphQL$1 = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var Product$1 = function Product(_ref) {
  var videos = _ref.videos,
    align = _ref.align,
    logo = _ref.logo,
    product_color = _ref.product_color,
    video_id = _ref.video_id,
    background = _ref.background,
    title = _ref.title,
    description = _ref.description,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    features = _ref.features,
    product_highlight_1 = _ref.product_highlight_1,
    product_highlight_2 = _ref.product_highlight_2,
    product_highlight_3 = _ref.product_highlight_3,
    product_disclaimer = _ref.product_disclaimer,
    secondary_products = _ref.secondary_products,
    _ref$lastOnMobile = _ref.lastOnMobile,
    lastOnMobile = _ref$lastOnMobile === void 0 ? false : _ref$lastOnMobile;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(CoreProductCard, {
    videos: videos,
    align: align,
    logo: logo,
    product_color: product_color,
    video_id: video_id,
    background: background,
    title: title,
    description: description,
    button_1: button_1,
    button_2: button_2,
    features: features
  })), product_highlight_1.title && /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(ProductTagsCard, _extends({
    lastOnMobile: lastOnMobile && (secondary_products === null || secondary_products === void 0 ? void 0 : secondary_products.length) === 0 && !product_highlight_2.stat && !product_highlight_3.title && !product_disclaimer,
    videos: videos
  }, product_highlight_1))), product_highlight_2.stat && /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(ProductStatCard, _extends({
    lastOnMobile: lastOnMobile && (secondary_products === null || secondary_products === void 0 ? void 0 : secondary_products.length) === 0 && !product_highlight_3.title && !product_disclaimer,
    videos: videos
  }, product_highlight_2))), product_highlight_3.title && /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement(ProductSimpleCard, _extends({
    lastOnMobile: lastOnMobile && (secondary_products === null || secondary_products === void 0 ? void 0 : secondary_products.length) === 0 && !product_disclaimer,
    videos: videos
  }, product_highlight_3))), product_disclaimer && /*#__PURE__*/React.createElement("div", {
    className: "col-12",
    "data-industry-card": lastOnMobile && (secondary_products === null || secondary_products === void 0 ? void 0 : secondary_products.length) === 0
  }, /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: product_disclaimer
    }
  })), (secondary_products === null || secondary_products === void 0 ? void 0 : secondary_products.length) > 0 && secondary_products.map(function (sc, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: sc.id,
      className: "col-6"
    }, /*#__PURE__*/React.createElement(SecondaryProductCard, _extends({
      lastOnMobile: lastOnMobile && idx === secondary_products.length - 1,
      videos: videos
    }, sc)));
  }));
};
var Tab$4 = function Tab(_ref2) {
  var videos = _ref2.videos,
    title = _ref2.title,
    sub_title = _ref2.sub_title,
    core_products = _ref2.core_products;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "shift-3"
  }, /*#__PURE__*/React.createElement(Headings$3, {
    title: title,
    subTitle: sub_title
  })), core_products.map(function (coreProduct, idx) {
    return /*#__PURE__*/React.createElement(Product$1, _extends({
      key: coreProduct.id,
      lastOnMobile: idx === core_products.length - 1,
      videos: videos
    }, coreProduct));
  }));
};
function collectVideoIds(tabs) {
  var ids = new Set();
  tabs === null || tabs === void 0 ? void 0 : tabs.forEach(function (tab) {
    var _tab$core_products;
    (_tab$core_products = tab.core_products) === null || _tab$core_products === void 0 ? void 0 : _tab$core_products.forEach(function (cp) {
      var _cp$product_highlight, _cp$product_highlight2, _cp$product_highlight3, _cp$features, _cp$secondary_product;
      ids.add(cp.video_id);
      ids.add((_cp$product_highlight = cp.product_highlight_1) === null || _cp$product_highlight === void 0 ? void 0 : _cp$product_highlight.video_id);
      ids.add((_cp$product_highlight2 = cp.product_highlight_2) === null || _cp$product_highlight2 === void 0 ? void 0 : _cp$product_highlight2.video_id);
      ids.add((_cp$product_highlight3 = cp.product_highlight_3) === null || _cp$product_highlight3 === void 0 ? void 0 : _cp$product_highlight3.video_id);
      (_cp$features = cp.features) === null || _cp$features === void 0 ? void 0 : _cp$features.forEach(function (feature) {
        ids.add(feature.feature_video_id);
      });
      (_cp$secondary_product = cp.secondary_products) === null || _cp$secondary_product === void 0 ? void 0 : _cp$secondary_product.forEach(function (sp) {
        ids.add(sp.video_id);
      });
    });
  });
  return Array.from(ids).filter(Boolean);
}
var Widget$1h = function Widget(_ref3) {
  var _tabs$, _videosData$videos;
  var tabs = _ref3.tabs,
    containerSettings = _ref3.containerSettings;
  var _React$useState = React.useState(tabs === null || tabs === void 0 ? void 0 : (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id),
    tabId = _React$useState[0],
    setTabId = _React$useState[1];
  var _React$useState2 = React.useState(""),
    wId = _React$useState2[0],
    setWId = _React$useState2[1];
  React.useEffect(function () {
    if (!wId) {
      var generatedId = "w-id-" + (Math.random() * 10000).toFixed(0);
      setWId(generatedId);
    }
  });
  var currentTab = tabs.find(function (t) {
    return t.id === tabId;
  });
  var collectedIds = React.useMemo(function () {
    return collectVideoIds(tabs);
  }, [tabs]);
  var videosData = useGraphQL$1(VIDEOS, {
    input: {
      filters: {
        ids: collectedIds
      }
    }
  });
  var videos = (videosData === null || videosData === void 0 ? void 0 : (_videosData$videos = videosData.videos) === null || _videosData$videos === void 0 ? void 0 : _videosData$videos.list) || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "new-industry-tabs",
    id: wId
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings, {
      theme: "light"
    })
  }, /*#__PURE__*/React.createElement(Switcher, {
    currentTab: tabId,
    tabs: tabs,
    scrollTargetId: wId,
    onSelect: function onSelect(tabId) {
      setTabId(tabId);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, currentTab && /*#__PURE__*/React.createElement(Tab$4, _extends({
    videos: videos
  }, currentTab))))));
};
var Config$1h = {
  title: "Industry Tabs (New)",
  category: "Image + Text"
};
var Defaults$1h = {
  tabs: NewIndustryTabsInput.defaults
};
var Admin$1g = {
  tabs: {
    type: "custom",
    component: NewIndustryTabsInput
  }
};
var NewIndustryTabsWidget = {
  __proto__: null,
  Widget: Widget$1h,
  Admin: Admin$1g,
  Config: Config$1h,
  Defaults: Defaults$1h
};
var GalleryInput = function GalleryInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("details", null, /*#__PURE__*/React.createElement("summary", null, label), /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        image: newValue
      }));
    },
    value: value.image,
    label: "Image"
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        mobile_image: newValue
      }));
    },
    value: value.mobile_image,
    label: "Mobile Image"
  }), /*#__PURE__*/React.createElement(GalleryPicker, {
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        gallery: newValue
      }));
    },
    value: value.gallery
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        title: newValue
      }));
    },
    value: value.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Description",
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        description: newValue
      }));
    },
    value: value.description
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Author",
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        author: newValue
      }));
    },
    value: value.author
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "See more/all text",
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        see_all: newValue
      }));
    },
    value: value.see_all
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        icon: newValue
      }));
    },
    value: value.icon,
    label: "Icon"
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Icon text",
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        icon_text: newValue
      }));
    },
    value: value.icon_text
  }));
};
GalleryInput.defaults = {
  image: imagePlaceholder("540x540"),
  mobile_image: imagePlaceholder("540x540"),
  gallery: "",
  title: "Archipelago house",
  description: "See how Radek Ignaciuk created these amazing renders using Enscape for SketchUp and V-Ray.",
  author: "John Doe",
  see_all: "See all renders",
  icon: imagePlaceholder("20x20"),
  icon_text: "Rendered with V-Ray"
};
var Icon = function Icon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5 6H9.5M9.5 6L6 2.5M9.5 6L6 9.5",
    stroke: "currentColor",
    strokeWidth: "0.9375",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var MobileIcon = function MobileIcon() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "40",
    height: "41",
    viewBox: "0 0 40 41",
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_6523_2626)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 28.5C26.6274 28.5 32 23.1274 32 16.5C32 9.87258 26.6274 4.5 20 4.5C13.3726 4.5 8 9.87258 8 16.5C8 23.1274 13.3726 28.5 20 28.5ZM20.4549 10.7572C20.112 10.4143 19.556 10.4143 19.2131 10.7572C18.8702 11.1001 18.8702 11.656 19.2131 11.9989L22.8361 15.622H14.712C14.2271 15.622 13.834 16.0151 13.834 16.5C13.834 16.9849 14.2271 17.378 14.712 17.378H22.8361L19.2131 21.0011C18.8702 21.344 18.8702 21.8999 19.2131 22.2428C19.556 22.5857 20.112 22.5857 20.4549 22.2428L25.5768 17.1209C25.9197 16.778 25.9197 16.222 25.5768 15.8791L20.4549 10.7572Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: "0.6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2131 10.7572C19.556 10.4143 20.112 10.4143 20.4549 10.7572L25.5768 15.8791C25.9197 16.222 25.9197 16.778 25.5768 17.1209L20.4549 22.2428C20.112 22.5857 19.556 22.5857 19.2131 22.2428C18.8702 21.8999 18.8702 21.344 19.2131 21.0011L22.8361 17.378H14.712C14.2271 17.378 13.834 16.9849 13.834 16.5C13.834 16.0151 14.2271 15.622 14.712 15.622H22.8361L19.2131 11.9989C18.8702 11.656 18.8702 11.1001 19.2131 10.7572Z",
    fill: "transparent"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_6523_2626",
    x: "0",
    y: "0.5",
    width: "40",
    height: "40",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: "4"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.235294 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6523_2626"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.235294 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_6523_2626",
    result: "effect2_dropShadow_6523_2626"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_6523_2626",
    result: "shape"
  }))));
};
var hostUrl$2 = function hostUrl(url) {
  if (!url) {
    return "";
  }
  if (typeof url !== "string") {
    return "";
  }
  var match = url.match(/^(http|https):\/\/([^\/\?]+)/);
  return match ? match[1] + "://" + match[2] : null;
};
var Image$1 = function Image(_ref) {
  var image = _ref.image,
    mobileImage = _ref.mobileImage,
    variant = _ref.variant;
  return /*#__PURE__*/React.createElement("div", {
    className: "gallery-card-image"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: image,
    variant: variant,
    className: "non-phone"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: mobileImage,
    variant: "mobile_square",
    className: "phone"
  }));
};
var Item$3 = function Item(_ref2) {
  var className = _ref2.className,
    image = _ref2.image,
    mobile_image = _ref2.mobile_image,
    imageVariant = _ref2.imageVariant,
    galleryData = _ref2.galleryData,
    title = _ref2.title,
    description = _ref2.description,
    author = _ref2.author,
    see_all = _ref2.see_all,
    icon = _ref2.icon,
    icon_text = _ref2.icon_text,
    onGalleryClick = _ref2.onGalleryClick;
  var currentUrl = React.useContext(PageUrlContext);
  return /*#__PURE__*/React.createElement(A, {
    href: hostUrl$2(currentUrl) + "/gallery/" + (galleryData === null || galleryData === void 0 ? void 0 : galleryData.slug),
    className: ["gallery-card", className].join(" "),
    onClick: function onClick(event) {
      event.preventDefault();
      onGalleryClick(galleryData);
    }
  }, /*#__PURE__*/React.createElement(Image$1, {
    image: image,
    mobileImage: mobile_image,
    variant: imageVariant
  }), /*#__PURE__*/React.createElement("div", {
    className: "gallery-card-overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "gallery-card-content"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, title, " ", /*#__PURE__*/React.createElement(MobileIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "author"
  }, author), /*#__PURE__*/React.createElement("div", {
    className: "footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hint"
  }, see_all, /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: icon,
    variant: "original"
  }), /*#__PURE__*/React.createElement("div", null, icon_text)))));
};
var BaseLayout = function BaseLayout(_ref) {
  var gallery_1 = _ref.gallery_1,
    gallery_2 = _ref.gallery_2,
    gallery_3 = _ref.gallery_3,
    gallery_4 = _ref.gallery_4,
    gallery_5 = _ref.gallery_5,
    onGalleryClick = _ref.onGalleryClick;
  return /*#__PURE__*/React.createElement("div", {
    className: "row base-layout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-8 left-col"
  }, /*#__PURE__*/React.createElement(Item$3, _extends({}, gallery_1, {
    imageVariant: "full_width_original",
    className: "left-col-wide",
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement("div", {
    className: "left-col-top"
  }, /*#__PURE__*/React.createElement(Item$3, _extends({}, gallery_2, {
    imageVariant: "image",
    className: "left-col-square",
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement(Item$3, _extends({}, gallery_3, {
    imageVariant: "image",
    className: "left-col-square",
    onGalleryClick: onGalleryClick
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-4 right-col"
  }, /*#__PURE__*/React.createElement(Item$3, _extends({}, gallery_4, {
    imageVariant: "image",
    className: "right-col-top",
    onGalleryClick: onGalleryClick
  })), /*#__PURE__*/React.createElement(Item$3, _extends({}, gallery_5, {
    imageVariant: "image",
    className: "right-col-bottom",
    onGalleryClick: onGalleryClick
  }))));
};
var _excluded$a = ["containerSettings", "pre_title", "title", "sub_title", "button_1"];
function enhanceGalleryData(galleryInput, galleries) {
  return _extends({}, galleryInput, {
    galleryData: galleries.list.find(function (gallery) {
      return gallery.id === galleryInput.gallery;
    }) || {}
  });
}
function Content$6(props) {
  var gallery_1 = props.gallery_1,
    gallery_2 = props.gallery_2,
    gallery_3 = props.gallery_3,
    gallery_4 = props.gallery_4,
    gallery_5 = props.gallery_5;
  var galleriesIds = [gallery_1 === null || gallery_1 === void 0 ? void 0 : gallery_1.gallery, gallery_2 === null || gallery_2 === void 0 ? void 0 : gallery_2.gallery, gallery_3 === null || gallery_3 === void 0 ? void 0 : gallery_3.gallery, gallery_4 === null || gallery_4 === void 0 ? void 0 : gallery_4.gallery, gallery_5 === null || gallery_5 === void 0 ? void 0 : gallery_5.gallery].filter(Boolean);
  if (galleriesIds.length === 0) {
    return /*#__PURE__*/React.createElement("h2", {
      className: "main-title"
    }, "No galleries");
  }
  var currentSSRURL = React.useContext(PageUrlContext);
  var _React$useState = React.useState(false),
    modalOpen = _React$useState[0],
    setModalOpen = _React$useState[1];
  var _React$useState2 = React.useState(""),
    currentSlug = _React$useState2[0],
    setCurrentSlug = _React$useState2[1];
  var _React$useState3 = React.useState(currentSSRURL),
    currentUrl = _React$useState3[0],
    setCurrentUrl = _React$useState3[1];
  return /*#__PURE__*/React.createElement(Query, {
    query: GALLERIES,
    variables: {
      input: {
        filters: {
          ids: galleriesIds
        }
      }
    }
  }, function (_ref) {
    var error = _ref.error,
      loading = _ref.loading,
      data = _ref.data;
    if (error) return "Error! " + error.message;
    if (loading) {
      return /*#__PURE__*/React.createElement(BaseLayout, {
        gallery_1: enhanceGalleryData(gallery_1, {
          list: []
        }),
        gallery_2: enhanceGalleryData(gallery_2, {
          list: []
        }),
        gallery_3: enhanceGalleryData(gallery_3, {
          list: []
        }),
        gallery_4: enhanceGalleryData(gallery_4, {
          list: []
        }),
        gallery_5: enhanceGalleryData(gallery_5, {
          list: []
        }),
        onGalleryClick: function onGalleryClick(_gallery) {
          console.log("Loading...");
        }
      });
    }
    var galleries = data.galleries;
    return /*#__PURE__*/React.createElement(React.Fragment, null, modalOpen && /*#__PURE__*/React.createElement(GalleryModal, {
      slug: currentSlug,
      onClose: function onClose() {
        return setModalOpen(false);
      },
      onGalleryChange: function onGalleryChange(newSlug) {
        return setCurrentSlug(newSlug);
      },
      currentUrl: currentUrl
    }), /*#__PURE__*/React.createElement(BaseLayout, {
      gallery_1: enhanceGalleryData(gallery_1, galleries),
      gallery_2: enhanceGalleryData(gallery_2, galleries),
      gallery_3: enhanceGalleryData(gallery_3, galleries),
      gallery_4: enhanceGalleryData(gallery_4, galleries),
      gallery_5: enhanceGalleryData(gallery_5, galleries),
      onGalleryClick: function onGalleryClick(gallery) {
        setCurrentSlug(gallery.slug);
        setCurrentUrl(window.location.href);
        history.pushState(null, null, galleryPath(currentUrl, gallery.slug));
        setModalOpen(true);
      }
    }));
  });
}
var Widget$1i = function Widget(_ref2) {
  var containerSettings = _ref2.containerSettings,
    pre_title = _ref2.pre_title,
    title = _ref2.title,
    sub_title = _ref2.sub_title,
    button_1 = _ref2.button_1,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded$a);
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings, {
      theme: "none"
    }),
    className: "gallery-masonry-custom-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gallery-masonry-new"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom"
  }, pre_title && /*#__PURE__*/React.createElement("div", {
    className: "pre-title"
  }, pre_title), title && /*#__PURE__*/React.createElement("h2", {
    className: "main-title"
  }, title), sub_title && /*#__PURE__*/React.createElement("div", {
    className: "sub-title"
  }, sub_title)))), /*#__PURE__*/React.createElement(Content$6, rest), (button_1 === null || button_1 === void 0 ? void 0 : button_1.label) && (button_1 === null || button_1 === void 0 ? void 0 : button_1.link) && /*#__PURE__*/React.createElement("div", {
    className: "gallery-btn"
  }, /*#__PURE__*/React.createElement(Button$1, {
    className: "btn-small",
    settings: button_1
  })))));
};
var Config$1i = {
  title: "Gallery Feed Masonry (New)",
  category: "Image"
};
var Defaults$1i = {
  pre_title: "Gallery",
  title: "Discover what our clients created.",
  sub_title: "Placeholder text render anything — from massing models to photorealistic renders, animation, and real-time experiences.",
  gallery_1: _extends({}, GalleryInput.defaults, {
    image: imagePlaceholder("1920x1080")
  }),
  gallery_2: _extends({}, GalleryInput.defaults, {
    image: imagePlaceholder("960x960")
  }),
  gallery_3: _extends({}, GalleryInput.defaults, {
    image: imagePlaceholder("960x960")
  }),
  gallery_4: _extends({}, GalleryInput.defaults, {
    image: imagePlaceholder("960x1450")
  }),
  gallery_5: _extends({}, GalleryInput.defaults, {
    image: imagePlaceholder("960x600")
  }),
  button_1: _extends({}, ButtonSettingsWithDescription.defaults, {
    label: "Go to the Gallery"
  }),
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$1h = {
  pre_title: {
    type: "text"
  },
  title: {
    type: "text"
  },
  sub_title: {
    type: "textarea"
  },
  gallery_1: {
    type: "custom",
    component: GalleryInput,
    label: "Gallery 1"
  },
  gallery_2: {
    type: "custom",
    component: GalleryInput,
    label: "Gallery 2"
  },
  gallery_3: {
    type: "custom",
    component: GalleryInput,
    label: "Gallery 3"
  },
  gallery_4: {
    type: "custom",
    component: GalleryInput,
    label: "Gallery 4"
  },
  gallery_5: {
    type: "custom",
    component: GalleryInput,
    label: "Gallery 5"
  },
  button_1: {
    type: "custom",
    component: ButtonSettingsWithDescription,
    label: "Button 1"
  }
};
var GalleryMasonryWidget = {
  __proto__: null,
  Widget: Widget$1i,
  Admin: Admin$1h,
  Config: Config$1i,
  Defaults: Defaults$1i
};
var ListItem$k = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Quote",
    value: settings.quote,
    onChange: function onChange(quote) {
      return onChangeItem("quote", quote);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Avatar",
    value: settings.avatar,
    onChange: function onChange(avatar) {
      return onChangeItem("avatar", avatar);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Name",
    onChange: function onChange(name) {
      return onChangeItem("name", name);
    },
    value: settings.name
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Job position",
    onChange: function onChange(job_position) {
      return onChangeItem("job_position", job_position);
    },
    value: settings.job_position
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo 1",
    value: settings.logo_1,
    onChange: function onChange(logo_1) {
      return onChangeItem("logo_1", logo_1);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo 2",
    value: settings.logo_2,
    onChange: function onChange(logo_2) {
      return onChangeItem("logo_2", logo_2);
    }
  }));
};
var SocialProofTestimonialsInput = function SocialProofTestimonialsInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Social Proof Testimonials" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$k, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$b,
    primaryField: "name",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$b = {
  quote: "Good stuff",
  avatar: imagePlaceholder("540x540"),
  name: "John Doe",
  job_position: "CTO",
  logo_1: imagePlaceholder("84x32"),
  logo_2: imagePlaceholder("84x32")
};
SocialProofTestimonialsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$b), _extends({
  id: 2
}, TEMPLATE$b), _extends({
  id: 3
}, TEMPLATE$b)];
var ListItem$l = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Badge",
    value: settings.badge,
    onChange: function onChange(badge) {
      return onChangeItem("badge", badge);
    }
  }));
};
var ReviewBadgesInput = function ReviewBadgesInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Review Badges" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$l, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$c,
    primaryField: "badge.name",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$c = {
  badge: imagePlaceholder("226x145")
};
ReviewBadgesInput.defaults = [_extends({
  id: 1
}, TEMPLATE$c), _extends({
  id: 2
}, TEMPLATE$c)];
var ListItem$m = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(logo) {
      return onChangeItem("logo", logo);
    }
  }));
};
var LogosInput = function LogosInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Logos" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$m, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$d,
    primaryField: "logo.name",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$d = {
  logo: imagePlaceholder("84x32")
};
LogosInput.defaults = [_extends({
  id: 1
}, TEMPLATE$d), _extends({
  id: 2
}, TEMPLATE$d), _extends({
  id: 3
}, TEMPLATE$d), _extends({
  id: 4
}, TEMPLATE$d), _extends({
  id: 5
}, TEMPLATE$d)];
var Widget$1j = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    testimonials = _ref.testimonials,
    testimonials_background = _ref.testimonials_background,
    badges = _ref.badges,
    logos_title = _ref.logos_title,
    logos_line_1 = _ref.logos_line_1,
    logos_line_2 = _ref.logos_line_2;
  var _React$useState = React.useState(null),
    swiper = _React$useState[0],
    setSwiper = _React$useState[1];
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "social-proof container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-5",
    onMouseEnter: function onMouseEnter() {
      swiper && swiper.autoplay.stop();
    },
    onMouseLeave: function onMouseLeave() {
      swiper && swiper.autoplay.start();
    }
  }, /*#__PURE__*/React.createElement(Slider, {
    getSwiper: setSwiper,
    navigation: {
      nextEl: ".swiper-button-next.icon-arrow-right",
      prevEl: ".swiper-button-prev.icon-arrow-left"
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    speed: 500,
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true
  }, testimonials.map(function (item, idx) {
    var _testimonials_backgro;
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "swiper-slide full-height"
    }, /*#__PURE__*/React.createElement("div", {
      className: "testimonial full-height",
      style: testimonials_background !== null && testimonials_background !== void 0 && (_testimonials_backgro = testimonials_background.urls) !== null && _testimonials_backgro !== void 0 && _testimonials_backgro.gallery_masonry_vertical ? {
        background: "#000",
        backgroundImage: "url(" + testimonials_background.urls.gallery_masonry_vertical + ")",
        backgroundSize: "cover"
      } : {
        background: "#000",
        backgroundImage: "url(" + testimonials_background + ")",
        backgroundSize: "cover"
      }
    }, /*#__PURE__*/React.createElement("h5", null, item.quote), /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.avatar,
      variant: "mobile_square",
      className: "avatar",
      alt: ""
    }), /*#__PURE__*/React.createElement("div", {
      className: "name-position"
    }, /*#__PURE__*/React.createElement("h6", null, item.name), /*#__PURE__*/React.createElement("p", null, item.job_position)), /*#__PURE__*/React.createElement("div", {
      className: "logos"
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.logo_1,
      variant: "original",
      className: "logo",
      alt: ""
    }), /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.logo_2,
      variant: "original",
      className: "logo",
      alt: ""
    }))));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-5 col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "badges glossy"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gradient-bg rotate-gradient-1"
  }), badges.map(function (item) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.badge,
      variant: "image",
      className: "badge"
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "icons glossy"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gradient-bg rotate-gradient-2"
  }), /*#__PURE__*/React.createElement("h5", null, logos_title), /*#__PURE__*/React.createElement("div", {
    className: "scroller"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scroller__inner"
  }, logos_line_1.map(function (item) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.logo,
      variant: "original",
      className: "logo"
    });
  }), logos_line_1.map(function (item) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      "aria-hidden": "true",
      src: item.logo,
      variant: "original",
      className: "logo"
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "scroller",
    "data-direction": "right"
  }, /*#__PURE__*/React.createElement("div", {
    className: "scroller__inner"
  }, logos_line_2.map(function (item) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.logo,
      variant: "original",
      className: "logo"
    });
  }), logos_line_2.map(function (item) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      "aria-hidden": "true",
      src: item.logo,
      variant: "original",
      className: "logo"
    });
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-1"
  }))));
};
var Config$1j = {
  title: "Social Proof",
  category: "Image + Text"
};
var Defaults$1j = {
  testimonials: SocialProofTestimonialsInput.defaults,
  testimonials_background: imagePlaceholder("636x716"),
  badges: ReviewBadgesInput.defaults,
  logos_title: "Logo strips here",
  logos_line_1: LogosInput.defaults,
  logos_line_2: LogosInput.defaults
};
var Admin$1i = {
  testimonials: {
    type: "custom",
    component: SocialProofTestimonialsInput
  },
  testimonials_background: {
    type: "custom",
    component: ImagePicker
  },
  badges: {
    type: "custom",
    component: ReviewBadgesInput
  },
  logos_title: {
    type: "text"
  },
  logos_line_1: {
    type: "custom",
    component: LogosInput
  },
  logos_line_2: {
    type: "custom",
    component: LogosInput
  }
};
var SocialProofWidget = {
  __proto__: null,
  Widget: Widget$1j,
  Admin: Admin$1i,
  Config: Config$1j,
  Defaults: Defaults$1j
};
var VideoComponent = function VideoComponent(_ref) {
  var image_preview = _ref.image_preview,
    video_url = _ref.video_url;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "single-video embedded-video"
  }, /*#__PURE__*/React.createElement("div", {
    className: "video-container"
  }, /*#__PURE__*/React.createElement(DirectEmbed, {
    image: image_preview,
    videoUrl: video_url,
    videoId: null
  }))));
};
function Frontend(_ref2) {
  var _background$urls, _phone_background$url;
  var phone_background = _ref2.phone_background,
    background = _ref2.background,
    pre_title = _ref2.pre_title,
    section_title = _ref2.section_title,
    align = _ref2.align,
    image_preview = _ref2.image_preview,
    video_url = _ref2.video_url,
    logo = _ref2.logo,
    title = _ref2.title,
    description = _ref2.description,
    spotlight_features = _ref2.spotlight_features,
    button_1 = _ref2.button_1,
    button_2 = _ref2.button_2;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "desktop-background-image",
    style: background !== null && background !== void 0 && (_background$urls = background.urls) !== null && _background$urls !== void 0 && _background$urls.original ? {
      background: "#000",
      backgroundImage: "url(" + background.urls.original + ")",
      backgroundSize: "100% 720px",
      backgroundRepeat: "no-repeat"
    } : {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "phone-background-image",
    style: phone_background !== null && phone_background !== void 0 && (_phone_background$url = phone_background.urls) !== null && _phone_background$url !== void 0 && _phone_background$url.original ? {
      background: "#000",
      backgroundImage: "url(" + phone_background.urls.original + ")",
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat"
    } : {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "screen"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, pre_title && /*#__PURE__*/React.createElement("h5", {
    className: "section-pre-title"
  }, pre_title), /*#__PURE__*/React.createElement("h2", {
    className: "section-title main"
  }, section_title))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, align === "right" && /*#__PURE__*/React.createElement(VideoComponent, {
    image_preview: image_preview,
    video_url: video_url
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-description-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo-title"
  }, logo && /*#__PURE__*/React.createElement(Image, {
    src: logo,
    variant: "icon"
  }), /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("h5", {
    className: "description"
  }, parseMarkdown(description, true))), /*#__PURE__*/React.createElement("div", {
    className: "spotlight-features"
  }, spotlight_features.map(function (feature) {
    return /*#__PURE__*/React.createElement("div", {
      className: "feature",
      key: feature.id
    }, /*#__PURE__*/React.createElement(Image, {
      src: feature.icon,
      variant: "icon"
    }), /*#__PURE__*/React.createElement("div", {
      className: "feature-text"
    }, /*#__PURE__*/React.createElement("h5", {
      className: "title"
    }, feature.title), /*#__PURE__*/React.createElement("h5", {
      className: "description"
    }, feature.summary)));
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button$1, {
    className: "btn-small",
    settings: button_1
  }), /*#__PURE__*/React.createElement(Button$1, {
    className: "btn-small",
    settings: button_2
  })))), align === "left" && /*#__PURE__*/React.createElement(VideoComponent, {
    image_preview: image_preview,
    video_url: video_url
  })))));
}
var ListItem$n = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    },
    value: settings.icon
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    },
    value: settings.title
  }), /*#__PURE__*/React.createElement(TextArea$2, {
    label: "Summary",
    onChange: function onChange(value) {
      return onChangeItem("summary", value);
    },
    value: settings.summary
  }));
};
var SpotlightFeaturesInput = function SpotlightFeaturesInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Spotlight Features" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$n, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$e,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$e = {
  icon: imagePlaceholder("24x24"),
  title: "Great title",
  summary: "Great summary"
};
SpotlightFeaturesInput.defaults = [_extends({
  id: 1
}, TEMPLATE$e), _extends({
  id: 2
}, TEMPLATE$e), _extends({
  id: 3
}, TEMPLATE$e)];
var _excluded$b = ["containerSettings"];
var Widget$1k = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "spotlight-and-title",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(Frontend, rest));
};
var Config$1k = {
  title: "Spotlight + Title",
  category: "Image + Text"
};
var Defaults$1k = {
  phone_background: imagePlaceholder("599x337"),
  background: imagePlaceholder("1920x740"),
  pre_title: "see what's new",
  section_title: "Check our latest product releases",
  align: "right",
  image_preview: imagePlaceholder("930x523"),
  video_url: "",
  logo: imagePlaceholder("36x36"),
  title: "A very cool product",
  description: "A even cooler **description**",
  spotlight_features: SpotlightFeaturesInput.defaults,
  button_1: ButtonSettings.defaults,
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "secondary",
    label: ""
  }),
  containerSettings: {
    theme: "dark",
    spacing: "both-lg"
  }
};
var Admin$1j = {
  phone_background: {
    type: "custom",
    component: ImagePicker
  },
  background: {
    type: "custom",
    component: ImagePicker
  },
  pre_title: {
    type: "text"
  },
  section_title: {
    type: "text"
  },
  align: {
    type: "select",
    options: [["left", "Left"], ["right", "Right"]]
  },
  image_preview: {
    type: "custom",
    component: ImagePicker
  },
  video_url: {
    type: "text"
  },
  logo: {
    type: "custom",
    component: ImagePicker
  },
  title: {
    type: "text"
  },
  description: {
    type: "custom",
    component: MarkdownInput
  },
  spotlight_features: {
    type: "custom",
    component: SpotlightFeaturesInput
  },
  button_1: {
    type: "custom",
    component: ButtonSettings
  },
  button_2: {
    type: "custom",
    component: ButtonSettings
  }
};
var SpotlightAndTitle = {
  __proto__: null,
  Widget: Widget$1k,
  Admin: Admin$1j,
  Config: Config$1k,
  Defaults: Defaults$1k
};
function Frontend$1(_ref) {
  var productBarItems = _ref.productBarItems;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "outer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "inner"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "images"
  }, productBarItems.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, /*#__PURE__*/React.createElement("li", {
      className: "image-link desktop-logo"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "hover-name"
    }, item.name), /*#__PURE__*/React.createElement("div", {
      className: "pointer"
    }), /*#__PURE__*/React.createElement(Link$6, {
      settings: item.link
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.logo,
      variant: "original"
    }))), /*#__PURE__*/React.createElement("li", {
      className: "image-link phone-logo"
    }, /*#__PURE__*/React.createElement(Link$6, {
      settings: item.link
    }, /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: item.phone_logo,
      variant: "original"
    }))));
  })))));
}
var ListItem$o = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    },
    value: settings.logo
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Name",
    onChange: function onChange(value) {
      return onChangeItem("name", value);
    },
    value: settings.name
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Phone Logo",
    onChange: function onChange(value) {
      return onChangeItem("phone_logo", value);
    },
    value: settings.phone_logo
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "link",
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    value: settings.link
  }));
};
var ProductBarItemsInput = function ProductBarItemsInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Product Bar Items" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$o, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$f,
    primaryField: "name",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$f = {
  logo: imagePlaceholder("40x40"),
  name: "Product",
  phone_logo: imagePlaceholder("120x40"),
  link: LinkSettings.defaults
};
ProductBarItemsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$f), _extends({
  id: 2
}, TEMPLATE$f), _extends({
  id: 3
}, TEMPLATE$f), _extends({
  id: 4
}, TEMPLATE$f), _extends({
  id: 5
}, TEMPLATE$f), _extends({
  id: 6
}, TEMPLATE$f), _extends({
  id: 7
}, TEMPLATE$f), _extends({
  id: 8
}, TEMPLATE$f), _extends({
  id: 9
}, TEMPLATE$f), _extends({
  id: 10
}, TEMPLATE$f), _extends({
  id: 11
}, TEMPLATE$f), _extends({
  id: 12
}, TEMPLATE$f)];
var _excluded$c = ["containerSettings"];
var Widget$1l = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "products-bar",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(Frontend$1, rest));
};
var Config$1l = {
  title: "Products Bar",
  category: "Image + Text"
};
var Defaults$1l = {
  productBarItems: ProductBarItemsInput.defaults,
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$1k = {
  productBarItems: {
    type: "custom",
    component: ProductBarItemsInput
  }
};
var ProductsBarWidget = {
  __proto__: null,
  Widget: Widget$1l,
  Admin: Admin$1k,
  Config: Config$1l,
  Defaults: Defaults$1l
};
var ListItem$p = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: settings.button,
    onChange: function onChange(value) {
      return onChangeItem("button", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Disclaimer (optional)",
    value: settings.disclaimer,
    onChange: function onChange(value) {
      return onChangeItem("disclaimer", value);
    }
  }));
};
var IntegrationProductsInput = function IntegrationProductsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$p, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$g,
    primaryField: "",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
var TEMPLATE$g = {
  icon: imagePlaceholder("110x32"),
  button: _extends({}, ButtonSettings.defaults, {
    label: "Learn more",
    type: "secondary-alt"
  }),
  disclaimer: ""
};
IntegrationProductsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$g), _extends({
  id: 2
}, TEMPLATE$g), _extends({
  id: 3
}, TEMPLATE$g)];
var ListItem$q = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    options: [["products", "Expand product list"], ["link", "Open link"]],
    label: "Behaviour",
    value: settings.behaviour,
    onChange: function onChange(value) {
      return onChangeItem("behaviour", value);
    }
  }), settings.behaviour === "products" && /*#__PURE__*/React.createElement(IntegrationProductsInput, {
    label: "Products",
    value: settings.products,
    onChange: function onChange(value) {
      return onChangeItem("products", value);
    }
  }), settings.behaviour === "link" && /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    value: settings.link,
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    },
    hint: ""
  }));
};
var IntegrationsInput = function IntegrationsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$q, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$h,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
var TEMPLATE$h = {
  logo: imagePlaceholder("32x32"),
  title: "Integration",
  behaviour: "products",
  products: IntegrationProductsInput.defaults,
  link: LinkSettings.defaults
};
IntegrationsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$h), _extends({
  id: 2
}, TEMPLATE$h), _extends({
  id: 3
}, TEMPLATE$h), _extends({
  id: 4
}, TEMPLATE$h), _extends({
  id: 5
}, TEMPLATE$h), _extends({
  id: 6
}, TEMPLATE$h), _extends({
  id: 7
}, TEMPLATE$h), _extends({
  id: 8
}, TEMPLATE$h), _extends({
  id: 9
}, TEMPLATE$h), _extends({
  id: 10
}, TEMPLATE$h)];
var Link$3 = function Link(_ref) {
  var settings = _ref.settings,
    children = _ref.children,
    className = _ref.className;
  var label = settings.label,
    link = settings.link,
    id = settings.id,
    target = settings.target,
    rel = settings.rel;
  return /*#__PURE__*/React.createElement(A, {
    href: link,
    className: [settings.className, className].join(" "),
    id: id ? id : "",
    target: target,
    rel: rel,
    title: label
  }, children);
};
var Integration = function Integration(_ref2) {
  var _integration$products, _integration$link;
  var integration = _ref2.integration,
    idx = _ref2.idx,
    selectedIntegrationIndex = _ref2.selectedIntegrationIndex,
    handleIntegrationClick = _ref2.handleIntegrationClick;
  if ((integration === null || integration === void 0 ? void 0 : (_integration$products = integration.products) === null || _integration$products === void 0 ? void 0 : _integration$products.length) === 0 && (integration === null || integration === void 0 ? void 0 : integration.behaviour) === "products") return /*#__PURE__*/React.createElement("li", {
    className: "integration-logo-card not-clickable " + (selectedIntegrationIndex === idx ? "selected" : ""),
    id: "integration-" + idx
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: integration.logo,
    variant: "original"
  }));
  if ((integration === null || integration === void 0 ? void 0 : integration.behaviour) === "link" && integration !== null && integration !== void 0 && (_integration$link = integration.link) !== null && _integration$link !== void 0 && _integration$link.link) return /*#__PURE__*/React.createElement(Link$3, {
    settings: integration === null || integration === void 0 ? void 0 : integration.link
  }, /*#__PURE__*/React.createElement("li", {
    className: "integration-logo-card " + (selectedIntegrationIndex === idx ? "selected" : ""),
    id: "integration-" + idx
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: integration.logo,
    variant: "original"
  })));
  return /*#__PURE__*/React.createElement("li", {
    className: "integration-logo-card " + (selectedIntegrationIndex === idx ? "selected" : ""),
    onClick: function onClick() {
      return handleIntegrationClick(idx);
    },
    id: "integration-" + idx
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: integration.logo,
    variant: "original"
  }));
};
var IntegrationsList = function IntegrationsList(_ref3) {
  var icon = _ref3.icon,
    description = _ref3.description,
    integrations = _ref3.integrations,
    selectedIntegrationIndex = _ref3.selectedIntegrationIndex,
    handleIntegrationClick = _ref3.handleIntegrationClick,
    _ref3$startIndex = _ref3.startIndex,
    startIndex = _ref3$startIndex === void 0 ? 1 : _ref3$startIndex;
  return /*#__PURE__*/React.createElement("div", {
    className: "integrations-list-outer"
  }, (icon || description) && /*#__PURE__*/React.createElement("div", {
    className: "description-icon"
  }, icon && /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: icon,
    variant: "thumb"
  }), description && /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description)), /*#__PURE__*/React.createElement("ul", {
    className: "integrations-list"
  }, integrations.map(function (integration, idx) {
    return /*#__PURE__*/React.createElement(Integration, {
      key: idx,
      integration: integration,
      idx: idx + startIndex,
      selectedIntegrationIndex: selectedIntegrationIndex,
      handleIntegrationClick: handleIntegrationClick
    });
  })));
};
var CurrentIntegrationData = function CurrentIntegrationData(_ref4) {
  var integrations = _ref4.integrations,
    selectedIntegrationIndex = _ref4.selectedIntegrationIndex;
  return integrations.map(function (integration, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: integration.id,
      className: "current-integration-data " + (selectedIntegrationIndex === idx + 1 ? "active" : ""),
      id: "integration-data-" + integration.id
    }, /*#__PURE__*/React.createElement("h5", null, integration.title), /*#__PURE__*/React.createElement("div", {
      className: "product-row"
    }, integration.products.map(function (product) {
      return /*#__PURE__*/React.createElement("div", {
        className: "col",
        key: product.id
      }, /*#__PURE__*/React.createElement("div", {
        className: "product row"
      }, /*#__PURE__*/React.createElement(Image, {
        loading: "lazy",
        src: product.icon,
        variant: "original"
      }), /*#__PURE__*/React.createElement(Button$1, {
        className: "btn-small",
        settings: product.button
      })), product.disclaimer && /*#__PURE__*/React.createElement("p", null, product.disclaimer));
    })));
  });
};
var IntegrationsOneSubsection = function IntegrationsOneSubsection(_ref5) {
  var integrations = _ref5.integrations,
    icon_section = _ref5.icon_section,
    selectedIntegrationIndex = _ref5.selectedIntegrationIndex,
    handleIntegrationClick = _ref5.handleIntegrationClick,
    description = _ref5.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "integrations"
  }, /*#__PURE__*/React.createElement(IntegrationsList, {
    icon: icon_section,
    description: description,
    integrations: integrations,
    selectedIntegrationIndex: selectedIntegrationIndex,
    handleIntegrationClick: handleIntegrationClick
  }), selectedIntegrationIndex !== null && /*#__PURE__*/React.createElement("div", {
    className: "mobile-separator"
  }), /*#__PURE__*/React.createElement(CurrentIntegrationData, {
    integrations: integrations,
    selectedIntegrationIndex: selectedIntegrationIndex
  }));
};
var IntegrationsTwoSubsections = function IntegrationsTwoSubsections(_ref6) {
  var integrations = _ref6.integrations,
    integrations_2 = _ref6.integrations_2,
    icon_section = _ref6.icon_section,
    icon_section_2 = _ref6.icon_section_2,
    allIntegrations = _ref6.allIntegrations,
    selectedIntegrationIndex = _ref6.selectedIntegrationIndex,
    handleIntegrationClick = _ref6.handleIntegrationClick,
    description_section = _ref6.description_section,
    description_section_2 = _ref6.description_section_2;
  var secondListStartIndex = integrations.length + 1;
  return /*#__PURE__*/React.createElement("div", {
    className: "integrations"
  }, /*#__PURE__*/React.createElement("div", {
    className: "sections"
  }, /*#__PURE__*/React.createElement(IntegrationsList, {
    icon: icon_section,
    description: description_section,
    integrations: integrations,
    selectedIntegrationIndex: selectedIntegrationIndex,
    handleIntegrationClick: handleIntegrationClick
  }), /*#__PURE__*/React.createElement(IntegrationsList, {
    icon: icon_section_2,
    startIndex: secondListStartIndex,
    description: description_section_2,
    integrations: integrations_2,
    selectedIntegrationIndex: selectedIntegrationIndex,
    handleIntegrationClick: handleIntegrationClick
  })), selectedIntegrationIndex !== null && /*#__PURE__*/React.createElement("div", {
    className: "mobile-separator"
  }), /*#__PURE__*/React.createElement(CurrentIntegrationData, {
    integrations: allIntegrations,
    selectedIntegrationIndex: selectedIntegrationIndex
  }));
};
var Widget$1m = function Widget(_ref7) {
  var containerSettings = _ref7.containerSettings,
    pre_title = _ref7.pre_title,
    _ref7$pre_title_color = _ref7.pre_title_color,
    pre_title_color = _ref7$pre_title_color === void 0 ? "" : _ref7$pre_title_color,
    title = _ref7.title,
    sub_title = _ref7.sub_title,
    _ref7$integrations_su = _ref7.integrations_subsections,
    integrations_subsections = _ref7$integrations_su === void 0 ? "one" : _ref7$integrations_su,
    _ref7$selected_integr = _ref7.selected_integration_index,
    selected_integration_index = _ref7$selected_integr === void 0 ? "1" : _ref7$selected_integr,
    integrations = _ref7.integrations,
    integrations_2 = _ref7.integrations_2,
    icon_section = _ref7.icon_section,
    icon_section_2 = _ref7.icon_section_2,
    _ref7$description_sec = _ref7.description_section,
    description_section = _ref7$description_sec === void 0 ? "" : _ref7$description_sec,
    _ref7$description_sec2 = _ref7.description_section_2,
    description_section_2 = _ref7$description_sec2 === void 0 ? "" : _ref7$description_sec2;
  var allIntegrations = integrations.concat(integrations_2);
  var allIntegrationsLength = allIntegrations.length;
  var _React$useState = React.useState(Number(selected_integration_index) >= 1 && Number(selected_integration_index) <= allIntegrationsLength ? Number(selected_integration_index) : null),
    selectedIntegrationIndex = _React$useState[0],
    setSelectedIntegrationIndex = _React$useState[1];
  React.useEffect(function () {
    var toSet = Number(selected_integration_index) >= 1 && Number(selected_integration_index) <= allIntegrationsLength ? Number(selected_integration_index) : null;
    setSelectedIntegrationIndex(toSet);
  }, [selected_integration_index, allIntegrationsLength]);
  var handleIntegrationClick = function handleIntegrationClick(index) {
    setSelectedIntegrationIndex(index);
  };
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "integrations-bar container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card shift-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h5", {
    style: pre_title_color ? {
      color: "" + pre_title_color
    } : {}
  }, pre_title), /*#__PURE__*/React.createElement("h2", null, title), /*#__PURE__*/React.createElement("h6", null, sub_title)), integrations_subsections === "one" && /*#__PURE__*/React.createElement(IntegrationsOneSubsection, {
    integrations: integrations,
    selectedIntegrationIndex: selectedIntegrationIndex,
    handleIntegrationClick: handleIntegrationClick,
    description: description_section,
    icon_section: icon_section
  }), integrations_subsections === "two" && /*#__PURE__*/React.createElement(IntegrationsTwoSubsections, {
    integrations: integrations,
    integrations_2: integrations_2,
    icon_section: icon_section,
    icon_section_2: icon_section_2,
    allIntegrations: allIntegrations,
    selectedIntegrationIndex: selectedIntegrationIndex,
    handleIntegrationClick: handleIntegrationClick,
    description_section: description_section,
    description_section_2: description_section_2
  })))));
};
var Config$1m = {
  title: "Integrations Bar",
  category: "Image + Text"
};
var Defaults$1m = {
  pre_title: "integrations",
  pre_title_color: "",
  title: "See what’s available for your host-platform",
  sub_title: "Placeholder text about host-platform rendering",
  integrations_subsections: "one",
  selected_integration_index: "1",
  description_section: "",
  description_section_2: "",
  icon_section: imagePlaceholder("32x32"),
  icon_section_2: imagePlaceholder("32x32"),
  integrations: IntegrationsInput.defaults,
  integrations_2: []
};
var Admin$1l = {
  pre_title: {
    type: "text"
  },
  pre_title_color: {
    type: "text"
  },
  title: {
    type: "text"
  },
  sub_title: {
    type: "text"
  },
  integrations_subsections: {
    type: "select",
    options: [["one", "One"], ["two", "Two"]]
  },
  selected_integration_index: {
    type: "text"
  },
  description_section: {
    type: "text"
  },
  icon_section: {
    type: "custom",
    component: ImagePicker
  },
  integrations: {
    type: "custom",
    component: IntegrationsInput
  },
  description_section_2: {
    type: "text"
  },
  icon_section_2: {
    type: "custom",
    component: ImagePicker
  },
  integrations_2: {
    type: "custom",
    component: IntegrationsInput
  }
};
var IntegrationsBarWidget = {
  __proto__: null,
  Widget: Widget$1m,
  Admin: Admin$1l,
  Config: Config$1m,
  Defaults: Defaults$1m
};
var TabInfoInput = function TabInfoInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: value.icon,
    onChange: function onChange(icon) {
      return _onChange(_extends({}, value, {
        icon: icon
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: value.label,
    onChange: function onChange(label) {
      return _onChange(_extends({}, value, {
        label: label
      }));
    }
  }));
};
TabInfoInput.defaults = {
  icon: imagePlaceholder("48"),
  label: "Label"
};
var TEMPLATE$i = {
  image: imagePlaceholder("1920x1080")
};
var ListItem$r = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    value: settings.image,
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    }
  }));
};
var FeatureSliderInput = function FeatureSliderInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$r, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$i,
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
FeatureSliderInput.defaults = [_extends({
  id: 1
}, TEMPLATE$i), _extends({
  id: 2
}, TEMPLATE$i), _extends({
  id: 3
}, TEMPLATE$i)];
var FeatureSpotlightMediaInput = function FeatureSpotlightMediaInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Type",
    options: [["image", "Image"], ["video", "Video"], ["slider", "Slider"], ["iframe", "iframe"], ["compare", "Compare"]],
    value: value.type,
    onChange: function onChange(type) {
      return _onChange(_extends({}, value, {
        type: type
      }));
    }
  }), value.type === "image" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button (mobile)",
    value: value.button,
    onChange: function onChange(button) {
      return _onChange(_extends({}, value, {
        button: button
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    value: value.image,
    onChange: function onChange(image) {
      return _onChange(_extends({}, value, {
        image: image
      }));
    }
  })), value.type === "video" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Video Preview",
    value: value.video_preview,
    onChange: function onChange(video_preview) {
      return _onChange(_extends({}, value, {
        video_preview: video_preview
      }));
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Video",
    value: value.video,
    onChange: function onChange(video) {
      return _onChange(_extends({}, value, {
        video: video
      }));
    }
  })), value.type === "iframe" && /*#__PURE__*/React.createElement(TextInput, {
    label: "Iframe URL",
    value: value.iframe,
    onChange: function onChange(iframe) {
      return _onChange(_extends({}, value, {
        iframe: iframe
      }));
    }
  }), value.type === "slider" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FeatureSliderInput, {
    label: "Slide images",
    value: value.slides,
    onChange: function onChange(slides) {
      return _onChange(_extends({}, value, {
        slides: slides
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Left label",
    value: value.left_label,
    onChange: function onChange(left_label) {
      return _onChange(_extends({}, value, {
        left_label: left_label
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Right label",
    value: value.right_label,
    onChange: function onChange(right_label) {
      return _onChange(_extends({}, value, {
        right_label: right_label
      }));
    }
  })), value.type === "compare" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image 1",
    value: value.image_1,
    onChange: function onChange(image_1) {
      return _onChange(_extends({}, value, {
        image_1: image_1
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image 2",
    value: value.image_2,
    onChange: function onChange(image_2) {
      return _onChange(_extends({}, value, {
        image_2: image_2
      }));
    }
  })));
};
FeatureSpotlightMediaInput.defaults = {
  type: "image",
  button: ButtonSettings.defaults,
  image: imagePlaceholder("900x500"),
  video_preview: imagePlaceholder("900x500"),
  video: "",
  iframe: "",
  slides: FeatureSliderInput.defaults,
  left_label: "Left label",
  right_label: "Right label",
  image_1: imagePlaceholder("900x500"),
  image_2: imagePlaceholder("900x500")
};
var TEMPLATE$j = {
  tab_info: TabInfoInput.defaults,
  orientation: "left",
  media: FeatureSpotlightMediaInput.defaults,
  title: "Title",
  description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat hic possimus tempora earum provident at eum quidem, tempore in! Dolores distinctio accusantium modi voluptates, temporibus vitae aut omnis magnam facere?"
};
var ListItem$s = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TabInfoInput, {
    label: "Tab",
    value: settings.tab_info,
    onChange: function onChange(value) {
      return onChangeItem("tab_info", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    options: [["left", "Media on the left"], ["right", "Media on the right"]],
    label: "Orientation",
    value: settings.orientation,
    onChange: function onChange(value) {
      return onChangeItem("orientation", value);
    }
  }), /*#__PURE__*/React.createElement(FeatureSpotlightMediaInput, {
    label: "Media",
    value: settings.media,
    onChange: function onChange(value) {
      return onChangeItem("media", value);
    }
  }));
};
var FeatureSpotlightTabsInput = function FeatureSpotlightTabsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$s, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$j,
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
FeatureSpotlightTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$j), _extends({
  id: 2
}, TEMPLATE$j), _extends({
  id: 3
}, TEMPLATE$j)];
var HostedVideo$2 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  }), /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video."));
};
var useGraphQL$2 = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var ImageFeature = function ImageFeature(_ref) {
  var image = _ref.image,
    button = _ref.button;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-image"
  }, image && /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "simple_image_slider",
    className: "content-image"
  }), button.link && /*#__PURE__*/React.createElement(Button$4, {
    settings: button
  }));
};
var VideoFeature = function VideoFeature(_ref2) {
  var videos = _ref2.videos,
    video = _ref2.video,
    video_preview = _ref2.video_preview;
  var toPlay = videos.find(function (v) {
    return v.id === video;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-video"
  }, /*#__PURE__*/React.createElement(HostedVideo$2, {
    video: toPlay,
    cover: video_preview
  }));
};
var SliderFeature = function SliderFeature(_ref3) {
  var slides = _ref3.slides,
    left_label = _ref3.left_label,
    right_label = _ref3.right_label;
  var _React$useState = React.useState(0),
    slide = _React$useState[0],
    setSlide = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-slider"
  }, slides[slide].image && /*#__PURE__*/React.createElement(Image, {
    src: slides[slide].image,
    variant: "simple_image_slider",
    className: "content-image"
  }), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "0",
    max: slides.length - 1,
    className: "slide-control",
    value: slide,
    onChange: function onChange(e) {
      return setSlide(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "body-xs media-slider-labels"
  }, /*#__PURE__*/React.createElement("span", null, left_label), /*#__PURE__*/React.createElement("span", null, right_label)));
};
var IframeFeature = function IframeFeature(_ref4) {
  var iframe = _ref4.iframe;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-iframe"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: iframe,
    frameborder: "0"
  }));
};
var CompareFeature = function CompareFeature(_ref5) {
  var image_1 = _ref5.image_1,
    image_2 = _ref5.image_2;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-compare"
  }, /*#__PURE__*/React.createElement(ReactCompareImage, {
    leftImage: image_1.urls.original ? image_1.urls.original : image_1,
    rightImage: image_2.urls.original ? image_2.urls.original : image_2,
    sliderLineWidth: 4
  }));
};
var MEDIA = {
  image: ImageFeature,
  video: VideoFeature,
  slider: SliderFeature,
  iframe: IframeFeature,
  compare: CompareFeature
};
function collectVideoIds$1(tabs) {
  var ids = new Set();
  tabs === null || tabs === void 0 ? void 0 : tabs.forEach(function (tab) {
    ids.add(tab.media.video);
  });
  return Array.from(ids).filter(Boolean);
}
var Widget$1n = function Widget(_ref6) {
  var _videosData$videos;
  var tabs = _ref6.tabs,
    containerSettings = _ref6.containerSettings;
  var _React$useState2 = React.useState(tabs[0].id),
    tab = _React$useState2[0],
    setTab = _React$useState2[1];
  var activeTab = tabs.find(function (t) {
    return t.id === tab;
  });
  var collectedIds = React.useMemo(function () {
    return collectVideoIds$1(tabs);
  }, [tabs]);
  var MediaComponent = MEDIA[activeTab.media.type];
  var videosData = useGraphQL$2(VIDEOS, {
    input: {
      filters: {
        ids: collectedIds
      }
    }
  });
  var videos = (videosData === null || videosData === void 0 ? void 0 : (_videosData$videos = videosData.videos) === null || _videosData$videos === void 0 ? void 0 : _videosData$videos.list) || [];
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings)
  }, /*#__PURE__*/React.createElement("div", {
    className: "feature-spotlight-tabs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feature-tabs"
  }, tabs.map(function (_ref7) {
    var id = _ref7.id,
      _ref7$tab_info = _ref7.tab_info,
      icon = _ref7$tab_info.icon,
      label = _ref7$tab_info.label;
    return /*#__PURE__*/React.createElement("button", {
      key: id,
      type: "button",
      className: tab === id ? "btn-tab selected" : "btn-tab",
      onClick: function onClick() {
        return setTab(id);
      }
    }, icon && /*#__PURE__*/React.createElement(Image, {
      src: icon,
      variant: "simple_image_slider",
      className: "icon"
    }), label);
  })), /*#__PURE__*/React.createElement("div", {
    className: "media-tab " + activeTab.orientation
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "media-tab-inner"
  }, activeTab.orientation === "left" && /*#__PURE__*/React.createElement(MediaComponent, _extends({
    videos: videos
  }, activeTab.media)), /*#__PURE__*/React.createElement("div", {
    className: "media-tab-content"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "heading-4 title"
  }, activeTab.title), /*#__PURE__*/React.createElement("div", {
    className: "body-m text-secondary",
    dangerouslySetInnerHTML: {
      __html: activeTab.description
    }
  })), activeTab.orientation === "right" && /*#__PURE__*/React.createElement(MediaComponent, _extends({
    videos: videos
  }, activeTab.media)))))))));
};
var Config$1n = {
  title: "Feature spotlight (tabs)",
  category: "Media"
};
var Admin$1m = {
  tabs: {
    type: "custom",
    component: FeatureSpotlightTabsInput
  }
};
var Defaults$1n = {
  tabs: FeatureSpotlightTabsInput.defaults,
  containerSettings: {}
};
var FeatureSpotlightTabsWidget = {
  __proto__: null,
  Admin: Admin$1m,
  Config: Config$1n,
  Defaults: Defaults$1n,
  Widget: Widget$1n
};
var ListItem$t = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    },
    value: settings.label
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    },
    value: settings.image
  }));
};
var RendersInput = function RendersInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$t, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$k,
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
var TEMPLATE$k = {
  label: "Label",
  image: imagePlaceholder("750x400")
};
RendersInput.defaults = [_extends({
  id: 1
}, TEMPLATE$k), _extends({
  id: 2
}, TEMPLATE$k), _extends({
  id: 3
}, TEMPLATE$k)];
var ListItem$u = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Name",
    onChange: function onChange(value) {
      return onChangeItem("name", value);
    },
    value: settings.name
  }), /*#__PURE__*/React.createElement(RendersInput, {
    label: "Renders",
    onChange: function onChange(value) {
      return onChangeItem("renders", value);
    },
    value: settings.renders
  }));
};
var RenderPreviewsInput = function RenderPreviewsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$u, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$l,
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
var TEMPLATE$l = {
  name: "Form",
  renders: RendersInput.defaults
};
RenderPreviewsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$l), _extends({
  id: 2
}, TEMPLATE$l), _extends({
  id: 3
}, TEMPLATE$l)];
var HeadingInput = function HeadingInput(_ref) {
  var label = _ref.label,
    hint = _ref.hint,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? {} : _ref$value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Heading",
    options: [["h1", "H1"], ["h2", "H2"], ["h3", "H3"], ["h4", "H4"], ["h5", "H5"], ["h6", "H6"]],
    value: value.heading,
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        heading: newValue
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Text",
    onChange: function onChange(newValue) {
      return _onChange(_extends({}, value, {
        text: newValue
      }));
    },
    value: value.text
  }), hint && /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "0.85rem",
      opacity: 0.5
    }
  }, hint));
};
HeadingInput.defaults = {
  text: "heading text",
  heading: "h3"
};
var _excluded$d = ["heading", "children"];
var Heading$1 = function Heading(_ref) {
  var heading = _ref.heading,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var MAPPING = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
  };
  var Component = MAPPING[heading] || "h3";
  return /*#__PURE__*/React.createElement(Component, rest, children);
};
var RenderPreviews = function RenderPreviews(_ref) {
  var render_groups = _ref.render_groups;
  var _React$useState = React.useState(0),
    activeGroup = _React$useState[0],
    setActiveGroup = _React$useState[1];
  var _React$useState2 = React.useState(0),
    activeRender = _React$useState2[0],
    setActiveRender = _React$useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "spotlight-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-wrapper"
  }, render_groups.map(function (group, idx) {
    return /*#__PURE__*/React.createElement("button", {
      key: group.id + "-idx",
      type: "button",
      className: "filter-tag body-s " + (activeGroup === idx ? "selected" : ""),
      onClick: function onClick() {
        return setActiveGroup(idx);
      }
    }, group.name);
  })), /*#__PURE__*/React.createElement("div", {
    className: "filter-wrapper"
  }, render_groups[activeGroup].renders.map(function (render, idx) {
    return /*#__PURE__*/React.createElement("button", {
      key: render.id + "-" + idx,
      type: "button",
      className: "filter-tag body-s " + (activeRender === idx ? "selected" : ""),
      onClick: function onClick() {
        return setActiveRender(idx);
      }
    }, render.label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "feature"
  }, render_groups[activeGroup].renders.map(function (render, idx) {
    return activeRender === idx && render.image && /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      key: render.id + "-" + idx,
      src: render.image,
      variant: "image",
      className: "image"
    });
  })));
};
var Widget$1o = function Widget(_ref2) {
  var orientation = _ref2.orientation,
    render_groups = _ref2.render_groups,
    icon = _ref2.icon,
    title = _ref2.title,
    description = _ref2.description,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings)
  }, /*#__PURE__*/React.createElement("div", {
    className: "feature-spotlight-render-previews"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feature-spotlight render-previews"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, orientation === "left" && /*#__PURE__*/React.createElement("div", {
    className: "col-8"
  }, /*#__PURE__*/React.createElement(RenderPreviews, {
    render_groups: render_groups
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, icon && /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: icon,
    variant: "original",
    className: "icon"
  }), /*#__PURE__*/React.createElement(Heading$1, {
    heading: title.heading,
    className: "title heading-3"
  }, title.text), /*#__PURE__*/React.createElement("div", {
    className: "description body-l text-secondary",
    dangerouslySetInnerHTML: {
      __html: description
    }
  }))), orientation === "right" && /*#__PURE__*/React.createElement("div", {
    className: "col-8"
  }, /*#__PURE__*/React.createElement(RenderPreviews, {
    render_groups: render_groups
  })))))));
};
var Config$1o = {
  title: "Feature Spotlight (render previews)",
  category: "General"
};
var Defaults$1o = {
  orientation: "left",
  render_groups: RenderPreviewsInput.defaults,
  icon: imagePlaceholder("50"),
  title: HeadingInput.defaults,
  description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate ex est id quos! Reprehenderit sed excepturi, optio est architecto blanditiis tenetur nobis adipisci reiciendis, sit hic perspiciatis illo dignissimos. Quisquam.",
  containerSettings: {}
};
var Admin$1n = {
  orientation: {
    type: "select",
    options: [["left", "Left"], ["right", "Right"]]
  },
  render_groups: {
    type: "custom",
    component: RenderPreviewsInput
  },
  icon: {
    type: "custom",
    component: ImagePicker
  },
  title: {
    type: "custom",
    component: HeadingInput
  },
  description: {
    type: "custom",
    component: MarkdownInput
  }
};
var FeatureSpotlightRenderPreviewsWidget = {
  __proto__: null,
  Widget: Widget$1o,
  Admin: Admin$1n,
  Config: Config$1o,
  Defaults: Defaults$1o
};
function Frontend$2(_ref) {
  var title = _ref.title,
    description = _ref.description,
    image = _ref.image,
    button = _ref.button;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(description))), /*#__PURE__*/React.createElement(Button$1, {
    className: "btn-small",
    settings: button
  })), /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: image,
    variant: "original"
  })))));
}
var _excluded$e = ["containerSettings"];
var Widget$1p = function Widget(_ref) {
  var containerSettings = _ref.containerSettings,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  return /*#__PURE__*/React.createElement(Container$1, {
    className: "trial-card-widget",
    settings: containerSettings
  }, /*#__PURE__*/React.createElement(Frontend$2, rest));
};
var Config$1p = {
  title: "Trial card",
  category: "Image + Text"
};
var Defaults$1p = {
  title: "Try how our solutions integrate into your workflow.",
  description: "Test all features, with no limits",
  button: ButtonSettings.defaults,
  image: imagePlaceholder("540x540")
};
var Admin$1o = {
  title: {
    type: "text"
  },
  description: {
    type: "custom",
    component: MarkdownInput
  },
  image: {
    type: "custom",
    component: ImagePicker
  },
  button: {
    type: "custom",
    component: ButtonSettings
  }
};
var TrialCardWidget = {
  __proto__: null,
  Widget: Widget$1p,
  Admin: Admin$1o,
  Config: Config$1p,
  Defaults: Defaults$1p
};
var InputPopup = function InputPopup(_ref) {
  var label = _ref.label,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {
      padding: "20px 0"
    } : _ref$style,
    children = _ref.children;
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick() {
      return setOpen(true);
    },
    style: {
      padding: "10px",
      fontWeight: "bold"
    }
  }, label)), /*#__PURE__*/React.createElement(Modal, {
    title: label,
    open: open,
    onClose: function onClose() {
      return setOpen(false);
    },
    style: {
      height: "80%",
      overflow: "scroll",
      margin: "auto"
    },
    innerStyle: {
      width: "60vw"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: "20px",
      paddingRight: "20px"
    }
  }, children, /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: {
      padding: "5px 10px",
      marginBottom: "10px"
    },
    onClick: function onClick() {
      return setOpen(false);
    }
  }, "OK"))));
};
var InputSection = function InputSection(_ref) {
  var title = _ref.title,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(PanelTitle, null, title), /*#__PURE__*/React.createElement(PanelContent, null, children));
};
var TooltipInput$1 = function TooltipInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: value.icon,
    onChange: function onChange(icon) {
      return _onChange(_extends({}, value, {
        icon: icon
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    },
    hint: "Supports markdown"
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange(_extends({}, value, {
        description: description
      }));
    },
    hint: "Supports markdown"
  }));
};
TooltipInput$1.defaults = {
  icon: imagePlaceholder("40"),
  title: "Tooltip",
  description: "Lorem ipsum dolor sit amet"
};
var LabelsInput = function LabelsInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Labels"
  }, /*#__PURE__*/React.createElement(InputSection, {
    title: "License type switcher"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: value.license_type_switcher,
    onChange: function onChange(license_type_switcher) {
      return _onChange(_extends({}, value, {
        license_type_switcher: license_type_switcher
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "License type switcher - commercial label",
    value: value.license_type_switcher_commercial,
    onChange: function onChange(license_type_switcher_commercial) {
      return _onChange(_extends({}, value, {
        license_type_switcher_commercial: license_type_switcher_commercial
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "License type switcher - educational label",
    value: value.license_type_switcher_educational,
    onChange: function onChange(license_type_switcher_educational) {
      return _onChange(_extends({}, value, {
        license_type_switcher_educational: license_type_switcher_educational
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Tooltip"
  }, /*#__PURE__*/React.createElement(TooltipInput$1, {
    value: value.license_type_switcher_tooltip || {},
    onChange: function onChange(license_type_switcher_tooltip) {
      return _onChange(_extends({}, value, {
        license_type_switcher_tooltip: license_type_switcher_tooltip
      }));
    }
  }))), /*#__PURE__*/React.createElement(InputSection, {
    title: "Product switcher"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.change_product_title,
    onChange: function onChange(change_product_title) {
      return _onChange(_extends({}, value, {
        change_product_title: change_product_title
      }));
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "Plan/Billing period switcher"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.change_plan_title,
    onChange: function onChange(change_plan_title) {
      return _onChange(_extends({}, value, {
        change_plan_title: change_plan_title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Sub Title",
    value: value.change_plan_subtitle,
    onChange: function onChange(change_plan_subtitle) {
      return _onChange(_extends({}, value, {
        change_plan_subtitle: change_plan_subtitle
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Monthly label",
    value: value.billing_monthly,
    onChange: function onChange(billing_monthly) {
      return _onChange(_extends({}, value, {
        billing_monthly: billing_monthly
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Monthly billed timing details (singular)",
    value: value.billing_monthly_license,
    onChange: function onChange(billing_monthly_license) {
      return _onChange(_extends({}, value, {
        billing_monthly_license: billing_monthly_license
      }));
    },
    hint: "Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Monthly billed timing details (multiple)",
    value: value.billing_monthly_licenses,
    onChange: function onChange(billing_monthly_licenses) {
      return _onChange(_extends({}, value, {
        billing_monthly_licenses: billing_monthly_licenses
      }));
    },
    hint: "Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Billed monthly",
    value: value.billed_monthly,
    onChange: function onChange(billed_monthly) {
      return _onChange(_extends({}, value, {
        billed_monthly: billed_monthly
      }));
    },
    hint: "Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Annual label",
    value: value.billing_annual,
    onChange: function onChange(billing_annual) {
      return _onChange(_extends({}, value, {
        billing_annual: billing_annual
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Annual billed timing details (singular)",
    value: value.billing_anually_license,
    onChange: function onChange(billing_anually_license) {
      return _onChange(_extends({}, value, {
        billing_anually_license: billing_anually_license
      }));
    },
    hint: "Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Annual billed timing details (multiple)",
    value: value.billing_anually_licenses,
    onChange: function onChange(billing_anually_licenses) {
      return _onChange(_extends({}, value, {
        billing_anually_licenses: billing_anually_licenses
      }));
    },
    hint: "Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Billed anually",
    value: value.billed_annually,
    onChange: function onChange(billed_annually) {
      return _onChange(_extends({}, value, {
        billed_annually: billed_annually
      }));
    },
    hint: "Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "3 years label",
    value: value.billing_triennial,
    onChange: function onChange(billing_triennial) {
      return _onChange(_extends({}, value, {
        billing_triennial: billing_triennial
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "3 Year billed timing details (singular)",
    value: value.billing_triennial_license,
    onChange: function onChange(billing_triennial_license) {
      return _onChange(_extends({}, value, {
        billing_triennial_license: billing_triennial_license
      }));
    },
    hint: "Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "3 Year billed timing details (multiple)",
    value: value.billing_triennial_licenses,
    onChange: function onChange(billing_triennial_licenses) {
      return _onChange(_extends({}, value, {
        billing_triennial_licenses: billing_triennial_licenses
      }));
    },
    hint: "Use the token {{LICENSES_COUNT}} to replace the number of licenses. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Billed every 3 years",
    value: value.billed_triennially,
    onChange: function onChange(billed_triennially) {
      return _onChange(_extends({}, value, {
        billed_triennially: billed_triennially
      }));
    },
    hint: "Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "Licenses number picker"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.licenses_count_title,
    onChange: function onChange(licenses_count_title) {
      return _onChange(_extends({}, value, {
        licenses_count_title: licenses_count_title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Max licenses count message",
    value: value.licenses_count_max_message,
    onChange: function onChange(licenses_count_max_message) {
      return _onChange(_extends({}, value, {
        licenses_count_max_message: licenses_count_max_message
      }));
    },
    hint: "Supports markdown"
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "Main pricing card lables"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Main card button label for disabled state",
    value: value.main_card_disabled_button_label,
    onChange: function onChange(main_card_disabled_button_label) {
      return _onChange(_extends({}, value, {
        main_card_disabled_button_label: main_card_disabled_button_label
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Main card button label for disabled state (laptop screens)",
    value: value.main_card_disabled_button_laptop_label,
    onChange: function onChange(main_card_disabled_button_laptop_label) {
      return _onChange(_extends({}, value, {
        main_card_disabled_button_laptop_label: main_card_disabled_button_laptop_label
      }));
    }
  })));
};
LabelsInput.defaults = {
  license_type_switcher: "License type",
  license_type_switcher_commercial: "Commercial",
  license_type_switcher_educational: "Educational",
  license_type_switcher_tooltip: TooltipInput$1.defaults,
  licenses_count_title: "Number of licenses",
  licenses_count_max_message: "**Considering a larger license package?** Please _contact our sales experts_ for tailored solutions.",
  change_product_title: "Change Product",
  change_plan_title: "Plans",
  change_plan_subtitle: "Price for 1 monthly license, billed annually",
  billing_annual: "Annual",
  billing_monthly_license: "{{LICENSES_COUNT}} license – billed monthly",
  billing_monthly_licenses: "{{LICENSES_COUNT}} licenses – billed monthly",
  billed_monthly: "Billed monthly",
  billing_monthly: "Monthly",
  billing_anually_license: "{{LICENSES_COUNT}} license – billed annually",
  billing_anually_licenses: "{{LICENSES_COUNT}} licenses – billed annually",
  billed_annually: "Billed annually",
  billing_triennial: "3 Years",
  billing_triennial_license: "{{LICENSES_COUNT}} license – billed every 3 years",
  billing_triennial_licenses: "{{LICENSES_COUNT}} licenses – billed every 3 years",
  billed_triennially: "Billed every 3 years",
  main_card_disabled_button_label: "Not available in current selection"
};
var ImagesInput = function ImagesInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ImagePicker, {
        label: "Image",
        value: settings.image,
        onChange: function onChange(value) {
          return onChangeItem("image", value);
        }
      });
    },
    items: value.map(function (item, idx) {
      return {
        id: item.id || idx,
        image: item
      };
    }),
    template: {
      image: ""
    },
    primaryField: "image.name",
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList.map(function (item) {
        return item.image;
      }));
    }
  });
};
var FeaturesInput = function FeaturesInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputSection, {
    title: "Features"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(List, {
    label: "Items",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
        label: "Value",
        value: settings.value,
        onChange: function onChange(value) {
          return onChangeItem("value", value);
        }
      }), /*#__PURE__*/React.createElement(InputSection, {
        title: "Tooltip"
      }, /*#__PURE__*/React.createElement(TooltipInput$1, {
        value: settings.tooltip,
        onChange: function onChange(value) {
          return onChangeItem("tooltip", value);
        }
      })));
    },
    items: value.items,
    template: {
      value: "",
      tooltip: {}
    },
    primaryField: "value",
    onChangeList: function onChangeList(_list, newList) {
      return _onChange(_extends({}, value, {
        items: newList
      }));
    }
  }));
};
var DEFAULTS$2 = {
  rate_plan_id: "",
  old_prices_tooltip: TooltipInput$1.defaults,
  promo_code: "",
  price_display_type: "per_month",
  after_price: "/month",
  qty: 1,
  old_prices: [],
  disable_upsell: "no",
  billed_timing_details: ""
};
var OldPriceInput = function OldPriceInput(_ref) {
  var prices = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Old prices",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectMenu, {
        label: "Currency",
        options: Currency.allInZuora.map(function (cur) {
          return [cur, cur];
        }),
        value: settings.currency,
        onChange: function onChange(value) {
          return onChangeItem("currency", value);
        }
      }), /*#__PURE__*/React.createElement(TextInput, {
        label: "Value",
        value: settings.value,
        onChange: function onChange(value) {
          return onChangeItem("value", value);
        }
      }));
    },
    onChangeList: function onChangeList(_key, listValue) {
      return onChange(listValue.map(function (lv) {
        return {
          currency: lv.currency,
          value: lv.value
        };
      }));
    },
    items: prices.map(function (price, idx) {
      return {
        id: idx,
        currency: price.currency,
        value: price.value
      };
    }),
    template: {
      price: {
        currency: "eur",
        value: ""
      }
    },
    primaryField: "currency"
  });
};
var RatePlanInput = function RatePlanInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    _onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(InputSection, {
    title: label
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Rate Plan ID",
    value: value.rate_plan_id,
    onChange: function onChange(rate_plan_id) {
      return _onChange(_extends({}, value, {
        rate_plan_id: rate_plan_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Promo code",
    value: value.promo_code,
    onChange: function onChange(promo_code) {
      return _onChange(_extends({}, value, {
        promo_code: promo_code
      }));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Price display",
    options: [["per_month", "Per month"], ["per_year", "Per year"], ["per_triennial", "Per 3 years"]],
    value: value.price_display_type,
    onChange: function onChange(price_display_type) {
      return _onChange(_extends({}, value, {
        price_display_type: price_display_type
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "After price",
    value: value.after_price,
    onChange: function onChange(after_price) {
      return _onChange(_extends({}, value, {
        after_price: after_price
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Quantity",
    value: value.qty,
    onChange: function onChange(qty) {
      return _onChange(_extends({}, value, {
        qty: qty
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Billed timing details (override)",
    value: value.billed_timing_details,
    onChange: function onChange(billed_timing_details) {
      return _onChange(_extends({}, value, {
        billed_timing_details: billed_timing_details
      }));
    },
    hint: "Supports tokens {{LICENSES_COUNT}} - number of licenses, {{PER_UNIT}} - calcualtes price based on quantity. Supports also {{PER_MONTH}}, {{PER_YEAR}} and {{PER_TRIENNIAL}} tokens."
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Disable upsell/cross sell",
    options: [["yes", "Yes"], ["no", "No"]],
    value: value.disable_upsell,
    onChange: function onChange(disable_upsell) {
      return _onChange(_extends({}, value, {
        disable_upsell: disable_upsell
      }));
    }
  }), /*#__PURE__*/React.createElement(InputPopup, {
    label: "Old prices"
  }, /*#__PURE__*/React.createElement(OldPriceInput, {
    value: value.old_prices || [],
    onChange: function onChange(old_prices) {
      return _onChange(_extends({}, value, {
        old_prices: old_prices
      }));
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "Old Price Tooltip"
  }, /*#__PURE__*/React.createElement(TooltipInput$1, {
    label: "Old Price Tooltip",
    value: value.old_prices_tooltip || {},
    onChange: function onChange(old_prices_tooltip) {
      return _onChange(_extends({}, value, {
        old_prices_tooltip: old_prices_tooltip
      }));
    }
  })));
};
RatePlanInput.defaults = DEFAULTS$2;
var LICENSE_TEMPLATE = {
  license_type: "Fixed license",
  default_license: "no",
  tooltip: TooltipInput$1.defaults,
  monthly: _extends({}, RatePlanInput.defaults, {
    after_price: "/month"
  }),
  annual: _extends({}, RatePlanInput.defaults, {
    after_price: "/year"
  }),
  triennial: _extends({}, RatePlanInput.defaults, {
    after_price: "/3 years"
  })
};
var RatePlansInput = function RatePlansInput(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "License type",
    value: settings.license_type,
    onChange: function onChange(value) {
      return onChangeItem("license_type", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default license",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.default_license,
    onChange: function onChange(value) {
      return onChangeItem("default_license", value);
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Tooltip"
  }, /*#__PURE__*/React.createElement(TooltipInput$1, {
    value: settings.tooltip,
    onChange: function onChange(value) {
      return onChangeItem("tooltip", value);
    }
  })), /*#__PURE__*/React.createElement(RatePlanInput, {
    label: "Monthly rate plan ID",
    value: settings.monthly || {},
    onChange: function onChange(value) {
      return onChangeItem("monthly", value);
    }
  }), /*#__PURE__*/React.createElement(RatePlanInput, {
    label: "Annual rate plan ID",
    value: settings.annual || {},
    onChange: function onChange(value) {
      return onChangeItem("annual", value);
    }
  }), /*#__PURE__*/React.createElement(RatePlanInput, {
    label: "3 year rate plan ID",
    value: settings.triennial || {},
    onChange: function onChange(value) {
      return onChangeItem("triennial", value);
    }
  }));
};
var LicensesInput = function LicensesInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Rate plans",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(RatePlansInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: LICENSE_TEMPLATE,
    primaryField: "license_type",
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList);
    }
  });
};
var ComparisonLinksInput = function ComparisonLinksInput(_ref3) {
  var _comparisonData$integ, _comparisonData$integ2, _comparisonData$integ3, _comparisonData$integ4, _comparisonData$secti;
  var comparisonData = _ref3.comparisonData,
    value = _ref3.value,
    _onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(InputSection, {
    title: "Comparison links"
  }, /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Available Products",
    value: value.available_products || "",
    onChange: function onChange(available_products) {
      return _onChange(_extends({}, value, {
        available_products: available_products
      }));
    }
  }), (comparisonData === null || comparisonData === void 0 ? void 0 : (_comparisonData$integ = comparisonData.integrations) === null || _comparisonData$integ === void 0 ? void 0 : (_comparisonData$integ2 = _comparisonData$integ.os) === null || _comparisonData$integ2 === void 0 ? void 0 : _comparisonData$integ2.length) > 0 && /*#__PURE__*/React.createElement(GroupCheckbox, {
    checkboxes: comparisonData.integrations.os.map(function (item) {
      return [item.id, item.name];
    }) || [],
    label: "Operating systems",
    onChange: function onChange(os) {
      return _onChange(_extends({}, value, {
        os: os
      }));
    },
    value: value.os || []
  }), (comparisonData === null || comparisonData === void 0 ? void 0 : (_comparisonData$integ3 = comparisonData.integrations) === null || _comparisonData$integ3 === void 0 ? void 0 : (_comparisonData$integ4 = _comparisonData$integ3.cads) === null || _comparisonData$integ4 === void 0 ? void 0 : _comparisonData$integ4.length) > 0 && /*#__PURE__*/React.createElement(GroupCheckbox, {
    checkboxes: comparisonData.integrations.cads.map(function (item) {
      return [item.id, item.name];
    }) || [],
    label: "CAD systems",
    onChange: function onChange(cads) {
      return _onChange(_extends({}, value, {
        cads: cads
      }));
    },
    value: value.cads || []
  }), (comparisonData === null || comparisonData === void 0 ? void 0 : (_comparisonData$secti = comparisonData.sections) === null || _comparisonData$secti === void 0 ? void 0 : _comparisonData$secti.length) > 0 && comparisonData.sections.map(function (section) {
    var _section$rows;
    if (!section.title || ((_section$rows = section.rows) === null || _section$rows === void 0 ? void 0 : _section$rows.length) <= 0) {
      return null;
    }
    return /*#__PURE__*/React.createElement(GroupCheckbox, {
      checkboxes: section.rows.map(function (item) {
        return [item.id, item.label];
      }) || [],
      label: section.title,
      onChange: function onChange(checked) {
        var _extends2;
        return _onChange(_extends({}, value, {
          sections: _extends({}, value.sections, (_extends2 = {}, _extends2[section.id] = checked, _extends2))
        }));
      },
      value: (value.sections || {})[section.id] || []
    });
  }));
};
var CardInput = function CardInput(_ref4) {
  var comparisonData = _ref4.comparisonData,
    settings = _ref4.settings,
    onChangeItem = _ref4.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Hidden logos count",
    value: settings.hidden_logos_count,
    onChange: function onChange(value) {
      return onChangeItem("hidden_logos_count", value);
    }
  }), /*#__PURE__*/React.createElement(ImagesInput, {
    label: "Logos",
    value: settings.logos || [],
    onChange: function onChange(value) {
      return onChangeItem("logos", value);
    }
  }), /*#__PURE__*/React.createElement(ImagesInput, {
    label: "Disabled logos",
    value: settings.disabled_logos || [],
    onChange: function onChange(value) {
      return onChangeItem("disabled_logos", value);
    }
  }), /*#__PURE__*/React.createElement(FeaturesInput, {
    value: settings.features || {},
    onChange: function onChange(value) {
      return onChangeItem("features", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 1",
    value: settings.button_1 || [],
    onChange: function onChange(value) {
      return onChangeItem("button_1", value);
    },
    hint: "This button adds the product to the cart!"
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 2",
    value: settings.button_2 || [],
    onChange: function onChange(value) {
      return onChangeItem("button_2", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Execute special action on button 2 click",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.button_2_on_click,
    onChange: function onChange(value) {
      return onChangeItem("button_2_on_click", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Glow color (border & text)",
    value: settings.glow_border_color,
    onChange: function onChange(value) {
      return onChangeItem("glow_border_color", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Glow color (outline)",
    value: settings.glow_outline_color,
    onChange: function onChange(value) {
      return onChangeItem("glow_outline_color", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Glowing text",
    value: settings.glowing_text,
    onChange: function onChange(value) {
      return onChangeItem("glowing_text", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Action on missing rate plan ID",
    options: [["hide", "Hide"], ["disable", "Disable"]],
    value: settings.on_missing_rate_plan_id,
    onChange: function onChange(value) {
      return onChangeItem("on_missing_rate_plan_id", value);
    }
  }), /*#__PURE__*/React.createElement(ComparisonLinksInput, {
    comparisonData: comparisonData,
    value: settings.comparison_links || {},
    onChange: function onChange(value) {
      return onChangeItem("comparison_links", value);
    }
  }), /*#__PURE__*/React.createElement(LicensesInput, {
    value: settings.licenses || [],
    onChange: function onChange(value) {
      return onChangeItem("licenses", value);
    }
  }));
};
var CARD_TEMPLATE = {
  title: "V-Ray solo",
  description: "Award-winning photorealistic renders",
  hidden_logos_count: 0,
  logos: [imagePlaceholder("24"), imagePlaceholder("24"), imagePlaceholder("24")],
  disabled_logos: [imagePlaceholder("24"), imagePlaceholder("24")],
  features: {
    title: "Includes",
    items: [{
      id: 1,
      value: "Award-winning V-Ray rendering engine",
      tooltip: {
        id: 1,
        icon: imagePlaceholder("24"),
        title: "A tooltip!",
        description: "**Some** cool tooltip description here..."
      }
    }, {
      id: 2,
      value: "Award-winning V-Ray rendering engine",
      tooltip: {}
    }]
  },
  button_1: ButtonSettings.defaults,
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "text"
  }),
  button_2_on_click: "no",
  glow_border_color: "#3D7800",
  glow_outline_color: "#D5E7C0",
  glowing_text: "Up to 60% bundle savings",
  on_missing_rate_plan_id: "hide",
  licenses: [_extends({
    id: 1
  }, LICENSE_TEMPLATE, {
    license_type: "Fixed license"
  }), _extends({
    id: 2
  }, LICENSE_TEMPLATE, {
    license_type: "Floating license"
  })]
};
var MainCardsInput = function MainCardsInput(_ref5) {
  var comparisonData = _ref5.comparisonData,
    value = _ref5.value,
    onChange = _ref5.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Cards",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CardInput, {
        settings: settings,
        onChangeItem: onChangeItem,
        comparisonData: comparisonData
      });
    },
    items: value,
    template: CARD_TEMPLATE,
    primaryField: "title",
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList);
    }
  });
};
MainCardsInput.defaults = [_extends({
  id: 1
}, CARD_TEMPLATE), _extends({
  id: 2
}, CARD_TEMPLATE)];
var SmallCardInput = function SmallCardInput(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: settings.button,
    onChange: function onChange(value) {
      return onChangeItem("button", value);
    }
  }));
};
var SMALL_CARD_TEMPLATE = {
  title: "Enterprise pricing plans",
  description: "For teams with more than 10 licenses",
  button: _extends({}, ButtonSettings.defaults, {
    type: "secondary-alt"
  })
};
var SmallCardsInput = function SmallCardsInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Small cards",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(SmallCardInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: SMALL_CARD_TEMPLATE,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
SmallCardsInput.defaults = [_extends({
  id: 1
}, SMALL_CARD_TEMPLATE), _extends({
  id: 2
}, SMALL_CARD_TEMPLATE, {
  title: "Find a local reseller",
  description: "Find a local partner for further assistance your language & timezone"
})];
var SecondaryLongCardInput = function SecondaryLongCardInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange(_extends({}, value, {
        description: description
      }));
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: value.button,
    onChange: function onChange(button) {
      return _onChange(_extends({}, value, {
        button: button
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagesInput, {
    label: "Logos",
    value: value.logos || [],
    onChange: function onChange(logos) {
      return _onChange(_extends({}, value, {
        logos: logos
      }));
    }
  }));
};
SecondaryLongCardInput.defaults = {
  description: "Find out how you can automate your repetitive workflow tasks with the power of AI",
  button: ButtonSettings.defaults,
  logos: [imagePlaceholder("60x20"), imagePlaceholder("60x20"), imagePlaceholder("60x20")]
};
var LICENSE_TEMPLATE$1 = {
  license_type: "Fixed license",
  default_license: "no",
  tooltip: TooltipInput$1.defaults,
  default_period: "annual",
  monthly: _extends({}, RatePlanInput.defaults, {
    tooltip: TooltipInput$1.defaults,
    tag: ""
  }),
  annual: _extends({}, RatePlanInput.defaults, {
    tooltip: TooltipInput$1.defaults,
    tag: "50% OFF"
  }),
  triennial: _extends({}, RatePlanInput.defaults, {
    tooltip: TooltipInput$1.defaults,
    tag: ""
  })
};
var RatePlansInput$1 = function RatePlansInput(_ref) {
  var _settings$monthly, _settings$annual, _settings$triennial;
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "License type",
    value: settings.license_type,
    onChange: function onChange(value) {
      return onChangeItem("license_type", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default license",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.default_license,
    onChange: function onChange(value) {
      return onChangeItem("default_license", value);
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Tooltip"
  }, /*#__PURE__*/React.createElement(TooltipInput$1, {
    value: settings.tooltip,
    onChange: function onChange(value) {
      return onChangeItem("tooltip", value);
    }
  })), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default billing period",
    options: [["monthly", "Monthly"], ["annual", "Annual"], ["triennial", "3 Years"]],
    value: settings.default_period,
    onChange: function onChange(value) {
      return onChangeItem("default_period", value);
    }
  }), /*#__PURE__*/React.createElement(RatePlanInput, {
    label: "Monthly rate plan ID",
    value: settings.monthly || {},
    onChange: function onChange(value) {
      return onChangeItem("monthly", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Monthly rate plan ID tag",
    value: settings.monthly.tag,
    onChange: function onChange(value) {
      return onChangeItem("monthly", _extends({}, settings.monthly, {
        tag: value
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Monthly rate plan ID tooltip"
  }, /*#__PURE__*/React.createElement(TooltipInput$1, {
    value: ((_settings$monthly = settings.monthly) === null || _settings$monthly === void 0 ? void 0 : _settings$monthly.tooltip) || {},
    onChange: function onChange(value) {
      return onChangeItem("monthly", _extends({}, settings.monthly, {
        tooltip: value
      }));
    }
  })), /*#__PURE__*/React.createElement(RatePlanInput, {
    label: "Annual rate plan ID",
    value: settings.annual || {},
    onChange: function onChange(value) {
      return onChangeItem("annual", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Annual rate plan ID tag",
    value: settings.annual.tag,
    onChange: function onChange(value) {
      return onChangeItem("annual", _extends({}, settings.annual, {
        tag: value
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Annual rate plan ID tooltip"
  }, /*#__PURE__*/React.createElement(TooltipInput$1, {
    value: ((_settings$annual = settings.annual) === null || _settings$annual === void 0 ? void 0 : _settings$annual.tooltip) || {},
    onChange: function onChange(value) {
      return onChangeItem("annual", _extends({}, settings.annual, {
        tooltip: value
      }));
    }
  })), /*#__PURE__*/React.createElement(RatePlanInput, {
    label: "3 year rate plan ID",
    value: settings.triennial || {},
    onChange: function onChange(value) {
      return onChangeItem("triennial", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "3 year rate plan ID tag",
    value: settings.triennial.tag,
    onChange: function onChange(value) {
      return onChangeItem("triennial", _extends({}, settings.triennial, {
        tag: value
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "3 year rate plan ID meta"
  }, /*#__PURE__*/React.createElement(TooltipInput$1, {
    value: ((_settings$triennial = settings.triennial) === null || _settings$triennial === void 0 ? void 0 : _settings$triennial.tooltip) || {},
    onChange: function onChange(value) {
      return onChangeItem("triennial", _extends({}, settings.triennial, {
        tooltip: value
      }));
    }
  })));
};
var LicensesInput$1 = function LicensesInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Rate plans",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(RatePlansInput$1, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: LICENSE_TEMPLATE$1,
    primaryField: "license_type",
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList);
    }
  });
};
var CardInput$1 = function CardInput(_ref3) {
  var products = _ref3.products,
    settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Outline (border)"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Color",
    value: settings.outline_color,
    onChange: function onChange(value) {
      return onChangeItem("outline_color", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Inner Border Color",
    value: settings.outline_border_color,
    onChange: function onChange(value) {
      return onChangeItem("outline_border_color", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Text",
    value: settings.outline_text,
    onChange: function onChange(value) {
      return onChangeItem("outline_text", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Text Color",
    value: settings.outline_text_color,
    onChange: function onChange(value) {
      return onChangeItem("outline_text_color", value);
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "Ribbon"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Color",
    value: settings.ribbon_color,
    onChange: function onChange(value) {
      return onChangeItem("ribbon_color", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Text",
    value: settings.ribbon_text,
    onChange: function onChange(value) {
      return onChangeItem("ribbon_text", value);
    }
  })), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 1",
    value: settings.button_1 || [],
    onChange: function onChange(value) {
      return onChangeItem("button_1", value);
    },
    hint: "This button adds the product to the cart!"
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button 2",
    value: settings.button_2 || [],
    onChange: function onChange(value) {
      return onChangeItem("button_2", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Action on missing rate plan ID",
    options: [["hide", "Hide"], ["disable", "Disable"]],
    value: settings.on_missing_rate_plan_id,
    onChange: function onChange(value) {
      return onChangeItem("on_missing_rate_plan_id", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Card type",
    options: [["purchase", "Purchase"], ["info", "Info"]],
    value: settings.card_type,
    onChange: function onChange(value) {
      return onChangeItem("card_type", value);
    }
  }), settings.card_type === "info" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Main title",
    value: settings.main_title,
    onChange: function onChange(value) {
      return onChangeItem("main_title", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Main subtitle",
    value: settings.main_sub_title,
    onChange: function onChange(value) {
      return onChangeItem("main_sub_title", value);
    }
  })), settings.card_type !== "info" && /*#__PURE__*/React.createElement(LicensesInput$1, {
    value: settings.licenses || [],
    onChange: function onChange(value) {
      return onChangeItem("licenses", value);
    }
  }), (products === null || products === void 0 ? void 0 : products.length) > 1 && /*#__PURE__*/React.createElement(GroupCheckbox, {
    checkboxes: products.map(function (product) {
      return [product.id, product.label];
    }),
    label: "Skip for these products",
    onChange: function onChange(value) {
      return onChangeItem("skip_products", value);
    },
    value: settings.skip_products || []
  }));
};
var CARD_TEMPLATE$1 = {
  logo: imagePlaceholder("40"),
  title: "Vantage",
  description: "Create interactive experiences in real-time — in a 100% raytraced environment.",
  outline_color: "",
  outline_text: "20% off with promo code",
  outline_text_color: "",
  ribbon_color: "",
  ribbon_text: "New",
  button_1: ButtonSettings.defaults,
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "text"
  }),
  on_missing_rate_plan_id: "hide",
  card_type: "purchase",
  main_title: "Free",
  sub_main_title: "Available as part of Corona and V-Ray",
  licenses: [_extends({
    id: 1
  }, LICENSE_TEMPLATE$1, {
    license_type: "Fixed license"
  }), _extends({
    id: 2
  }, LICENSE_TEMPLATE$1, {
    license_type: "Floating license"
  })],
  skip_products: []
};
var SecondaryCardsInput = function SecondaryCardsInput(_ref4) {
  var products = _ref4.products,
    value = _ref4.value,
    onChange = _ref4.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Secondary cards",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CardInput$1, {
        products: products,
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: CARD_TEMPLATE$1,
    primaryField: "title",
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList);
    }
  });
};
SecondaryCardsInput.defaults = [_extends({
  id: 1
}, CARD_TEMPLATE$1), _extends({
  id: 2
}, CARD_TEMPLATE$1)];
var IntegrationsInput$1 = function IntegrationsInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange(_extends({}, value, {
        description: description
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagesInput, {
    label: "Operating systems",
    value: value.os || [],
    onChange: function onChange(os) {
      return _onChange(_extends({}, value, {
        os: os
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagesInput, {
    label: "CAD software",
    value: value.cads || [],
    onChange: function onChange(cads) {
      return _onChange(_extends({}, value, {
        cads: cads
      }));
    }
  }));
};
var AvailableProductsInput = function AvailableProductsInput(_ref2) {
  var value = _ref2.value,
    _onChange2 = _ref2.onChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange2(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange2(_extends({}, value, {
        description: description
      }));
    }
  }));
};
var RowsInput = function RowsInput(_ref3) {
  var value = _ref3.value,
    onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Row",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
        label: "Label",
        value: settings.label,
        onChange: function onChange(value) {
          return onChangeItem("label", value);
        }
      }), /*#__PURE__*/React.createElement(InputSection, {
        title: "Tooltip"
      }, /*#__PURE__*/React.createElement(TooltipInput$1, {
        value: settings.tooltip || {},
        onChange: function onChange(value) {
          return onChangeItem("tooltip", value);
        }
      })));
    },
    items: value,
    template: {
      label: "",
      tooltip: {}
    },
    primaryField: "label",
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList);
    }
  });
};
var ComparisonFeaturesInput = function ComparisonFeaturesInput(_ref4) {
  var value = _ref4.value,
    _onChange3 = _ref4.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Comparison settings"
  }, /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Enabled",
    options: [["yes", "Yes"], ["no", "No"]],
    value: value.enabled,
    onChange: function onChange(enabled) {
      return _onChange3(_extends({}, value, {
        enabled: enabled
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange3(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange3(_extends({}, value, {
        description: description
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Available Products"
  }, /*#__PURE__*/React.createElement(AvailableProductsInput, {
    value: (value === null || value === void 0 ? void 0 : value.available_products) || {},
    onChange: function onChange(available_products) {
      return _onChange3(_extends({}, value, {
        available_products: available_products
      }));
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "Integrations"
  }, /*#__PURE__*/React.createElement(IntegrationsInput$1, {
    value: (value === null || value === void 0 ? void 0 : value.integrations) || {},
    onChange: function onChange(integrations) {
      return _onChange3(_extends({}, value, {
        integrations: integrations
      }));
    }
  })), /*#__PURE__*/React.createElement(List, {
    label: "Table sections",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
        label: "Title",
        value: settings.title,
        onChange: function onChange(val) {
          return onChangeItem("title", val);
        }
      }), /*#__PURE__*/React.createElement(RowsInput, {
        value: settings.rows || [],
        onChange: function onChange(val) {
          return onChangeItem("rows", val);
        }
      }));
    },
    items: (value === null || value === void 0 ? void 0 : value.sections) || [],
    template: {
      title: "",
      sections: []
    },
    primaryField: "title",
    onChangeList: function onChangeList(_list, newList) {
      return _onChange3(_extends({}, value, {
        sections: newList
      }));
    }
  }));
};
ComparisonFeaturesInput.defaults = {
  enabled: "no",
  title: "Compare plans",
  description: "Find the plan that is right for you.",
  available_products: {
    title: "Available products",
    description: "See what products are available in each plan"
  },
  integrations: {
    title: "Available integrations",
    description: "Enscape is available for all your favorite CAD platforms",
    os: [],
    cads: []
  },
  sections: [{
    id: 1,
    title: "Core features",
    rows: [{
      id: 1,
      label: "Real-time speed",
      tooltip: TooltipInput$1.defaults
    }, {
      id: 2,
      label: "Bi-directional data flow",
      tooltip: TooltipInput$1.defaults
    }]
  }]
};
var ProductInput = function ProductInput(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputSection, {
    title: "Product switcher settings"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Color",
    value: settings.color,
    onChange: function onChange(value) {
      return onChangeItem("color", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default product",
    options: [["yes", "Yes"], ["no", "No"]],
    value: settings.default_product,
    onChange: function onChange(value) {
      return onChangeItem("default_product", value);
    },
    hint: "Make sure you have selected yes on only one product!"
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    },
    hint: "Used in the tab title!"
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "Plans switcher settings"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Monthly tag",
    value: settings.monthly_tag,
    onChange: function onChange(value) {
      return onChangeItem("monthly_tag", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Annual tag",
    value: settings.annual_tag,
    onChange: function onChange(value) {
      return onChangeItem("annual_tag", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "3 years tag",
    value: settings.triennial_tag,
    onChange: function onChange(value) {
      return onChangeItem("triennial_tag", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default period",
    options: [["monthly", "Monthly"], ["annual", "Annual"], ["triennial", "3 Years"]],
    value: settings.default_period,
    onChange: function onChange(value) {
      return onChangeItem("default_period", value);
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "General description"
  }, /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  })), /*#__PURE__*/React.createElement(ComparisonFeaturesInput, {
    value: settings.comparison_data || {},
    onChange: function onChange(value) {
      return onChangeItem("comparison_data", value);
    }
  }), /*#__PURE__*/React.createElement(InputPopup, {
    label: "Cards"
  }, /*#__PURE__*/React.createElement(MainCardsInput, {
    comparisonData: settings.comparison_data || {},
    value: settings.cards || [],
    onChange: function onChange(value) {
      return onChangeItem("cards", value);
    }
  })));
};
var PRODUCT_TEMPLATE = {
  label: "Corona",
  color: "orange",
  default_product: "no",
  icon: imagePlaceholder("14x14"),
  logo: imagePlaceholder("28x28"),
  monthly_tag: "",
  annual_tag: "Save 50% yearly.",
  triennial_tag: "",
  description: "",
  default_period: "",
  comparison_data: ComparisonFeaturesInput.defaults,
  cards: MainCardsInput.defaults
};
var ProductsInput = function ProductsInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Products",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ProductInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: PRODUCT_TEMPLATE,
    primaryField: "label",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var CommercialInput = function CommercialInput(_ref3) {
  var value = _ref3.value,
    _onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Commercial"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange(_extends({}, value, {
        logo: logo
      }));
    }
  }), /*#__PURE__*/React.createElement(ProductsInput, {
    value: value.products,
    onChange: function onChange(products) {
      return _onChange(_extends({}, value, {
        products: products
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "More products section"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "More products section title",
    value: value.secondary_title,
    onChange: function onChange(secondary_title) {
      return _onChange(_extends({}, value, {
        secondary_title: secondary_title
      }));
    }
  }), /*#__PURE__*/React.createElement(SecondaryCardsInput, {
    products: value.products,
    value: value.secondary_cards || [],
    onChange: function onChange(secondary_cards) {
      return _onChange(_extends({}, value, {
        secondary_cards: secondary_cards
      }));
    }
  }), /*#__PURE__*/React.createElement(SmallCardsInput, {
    value: value.small_cards || [],
    onChange: function onChange(small_cards) {
      return _onChange(_extends({}, value, {
        small_cards: small_cards
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Add on card"
  }, /*#__PURE__*/React.createElement(SecondaryLongCardInput, {
    value: value.add_on_card || {},
    onChange: function onChange(add_on_card) {
      return _onChange(_extends({}, value, {
        add_on_card: add_on_card
      }));
    }
  }))));
};
CommercialInput.defaults = {
  html_id: "",
  title: "Pricing",
  sub_title: "From individual creators to the biggest enterprises, we have a plan for you",
  logo: imagePlaceholder("28"),
  products: [_extends({
    id: 1
  }, PRODUCT_TEMPLATE, {
    label: "Corona",
    color: "orange"
  }), _extends({
    id: 2
  }, PRODUCT_TEMPLATE, {
    label: "V-Ray Solo",
    color: "blue"
  })],
  secondary_title: "More products for Architectural Design",
  small_cards: SmallCardsInput.defaults,
  secondary_cards: SecondaryCardsInput.defaults,
  add_on_card: SecondaryLongCardInput.defaults
};
var EducationalInput = function EducationalInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Educational"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange(_extends({}, value, {
        logo: logo
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Main products section"
  }, /*#__PURE__*/React.createElement(MainCardsInput, {
    value: value.cards || [],
    onChange: function onChange(cards) {
      return _onChange(_extends({}, value, {
        cards: cards
      }));
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "More products section"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "More products section title",
    value: value.secondary_title,
    onChange: function onChange(secondary_title) {
      return _onChange(_extends({}, value, {
        secondary_title: secondary_title
      }));
    }
  }), /*#__PURE__*/React.createElement(SecondaryCardsInput, {
    products: [],
    value: value.secondary_cards || [],
    onChange: function onChange(secondary_cards) {
      return _onChange(_extends({}, value, {
        secondary_cards: secondary_cards
      }));
    }
  }), /*#__PURE__*/React.createElement(SmallCardsInput, {
    value: value.small_cards || [],
    onChange: function onChange(small_cards) {
      return _onChange(_extends({}, value, {
        small_cards: small_cards
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Add on card"
  }, /*#__PURE__*/React.createElement(SecondaryLongCardInput, {
    value: value.add_on_card || {},
    onChange: function onChange(add_on_card) {
      return _onChange(_extends({}, value, {
        add_on_card: add_on_card
      }));
    }
  }))));
};
EducationalInput.defaults = {
  html_id: "",
  title: "Pricing",
  sub_title: "From individual creators to the biggest enterprises, we have a plan for you",
  logo: imagePlaceholder("28"),
  cards: MainCardsInput.defaults,
  secondary_title: "More products for Architectural Design",
  small_cards: SmallCardsInput.defaults,
  secondary_cards: SecondaryCardsInput.defaults,
  add_on_card: SecondaryLongCardInput.defaults
};
var IndustryTabInput = function IndustryTabInput(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "1rem"
    }
  }, /*#__PURE__*/React.createElement(CommercialInput, {
    value: settings.commercial || {},
    onChange: function onChange(value) {
      return onChangeItem("commercial", value);
    }
  }), /*#__PURE__*/React.createElement(EducationalInput, {
    value: settings.educational || {},
    onChange: function onChange(value) {
      return onChangeItem("educational", value);
    }
  })));
};
var IndustryTabsInput = function IndustryTabsInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Industry Tabs",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(IndustryTabInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$m,
    primaryField: "label",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$m = {
  label: "",
  commercial: {}
};
IndustryTabsInput.defaults = [{
  id: 1,
  label: "Architectural Design",
  commercial: CommercialInput.defaults,
  educational: EducationalInput.defaults
}, {
  id: 2,
  label: "Archviz",
  commercial: CommercialInput.defaults,
  educational: EducationalInput.defaults
}, {
  id: 3,
  label: "Media & Entertainment",
  commercial: CommercialInput.defaults,
  educational: EducationalInput.defaults
}, {
  id: 4,
  label: "Product & E-Commerce",
  commercial: CommercialInput.defaults,
  educational: EducationalInput.defaults
}];
var TagInput = function TagInput(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Color",
    value: settings.color,
    onChange: function onChange(value) {
      return onChangeItem("color", value);
    }
  }));
};
var TAG_TEMPLATE = {
  label: "Real-Time",
  color: "#589800"
};
var TagsInput = function TagsInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Tags",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(TagInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TAG_TEMPLATE,
    primaryField: "label",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
TagsInput.defaults = [_extends({
  id: 1
}, TAG_TEMPLATE), _extends({
  id: 2
}, TAG_TEMPLATE, {
  color: "#2857AF"
})];
var IconTooltipInput = function IconTooltipInput(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Text",
    value: settings.text,
    onChange: function onChange(value) {
      return onChangeItem("text", value);
    }
  }));
};
var TEMPLATE$n = {
  icon: imagePlaceholder("24"),
  text: "Some tooltip"
};
var IconTooltipsInput = function IconTooltipsInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Icon tooltips",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(IconTooltipInput, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$n,
    primaryField: "text",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
IconTooltipsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$n)];
var FilterInput = function FilterInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(TextInput, {
        label: "Value",
        value: settings.value,
        onChange: function onChange(newValue) {
          return onChangeItem("value", newValue);
        }
      });
    },
    items: value,
    template: {
      value: ""
    },
    primaryField: "value",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var CardInput$2 = function CardInput(_ref2) {
  var settings = _ref2.settings,
    industries = _ref2.industries,
    roles = _ref2.roles,
    integrations = _ref2.integrations,
    onChangeItem = _ref2.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Product name",
    value: settings.product_name,
    onChange: function onChange(value) {
      return onChangeItem("product_name", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    value: settings.button_1,
    onChange: function onChange(value) {
      return onChangeItem("button_1", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    value: settings.button_2,
    onChange: function onChange(value) {
      return onChangeItem("button_2", value);
    }
  }), /*#__PURE__*/React.createElement(TagsInput, {
    value: settings.tags || [],
    onChange: function onChange(value) {
      return onChangeItem("tags", value);
    }
  }), /*#__PURE__*/React.createElement(IconTooltipsInput, {
    value: settings.icon_tooltips || [],
    onChange: function onChange(value) {
      return onChangeItem("icon_tooltips", value);
    }
  }), (industries === null || industries === void 0 ? void 0 : industries.length) > 0 && /*#__PURE__*/React.createElement(GroupCheckbox, {
    checkboxes: industries.map(function (item) {
      return [item.id, item.value];
    }),
    label: "Industries",
    onChange: function onChange(value) {
      return onChangeItem("industries", value);
    },
    value: settings.industries || []
  }), (roles === null || roles === void 0 ? void 0 : roles.length) > 0 && /*#__PURE__*/React.createElement(GroupCheckbox, {
    checkboxes: roles.map(function (item) {
      return [item.id, item.value];
    }),
    label: "Roles",
    onChange: function onChange(value) {
      return onChangeItem("roles", value);
    },
    value: settings.roles || []
  }), (integrations === null || integrations === void 0 ? void 0 : integrations.length) > 0 && /*#__PURE__*/React.createElement(GroupCheckbox, {
    checkboxes: integrations.map(function (item) {
      return [item.id, item.value];
    }),
    label: "Integrations",
    onChange: function onChange(value) {
      return onChangeItem("integrations", value);
    },
    value: settings.integrations || []
  }));
};
var CARD_TEMPLATE$2 = {
  logo: imagePlaceholder("100x32"),
  product_name: "",
  description: "",
  button_1: _extends({}, ButtonSettings.defaults, {
    type: "secondary-alt"
  }),
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "text"
  }),
  industries: [],
  roles: [],
  integrations: []
};
var CardsInput = function CardsInput(_ref3) {
  var value = _ref3.value,
    industries = _ref3.industries,
    roles = _ref3.roles,
    integrations = _ref3.integrations,
    onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Cards",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CardInput$2, {
        settings: settings,
        industries: industries,
        roles: roles,
        integrations: integrations,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: CARD_TEMPLATE$2,
    primaryField: "description",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var CommercialInput$1 = function CommercialInput(_ref4) {
  var value = _ref4.value,
    _onChange = _ref4.onChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Sort title",
    value: value.sort_title,
    onChange: function onChange(sort_title) {
      return _onChange(_extends({}, value, {
        sort_title: sort_title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Sort relevance text",
    value: value.sort_relevance_text,
    onChange: function onChange(sort_relevance_text) {
      return _onChange(_extends({}, value, {
        sort_relevance_text: sort_relevance_text
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Sort A-Z text",
    value: value.sort_alphabetically_text,
    onChange: function onChange(sort_alphabetically_text) {
      return _onChange(_extends({}, value, {
        sort_alphabetically_text: sort_alphabetically_text
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Filter title",
    value: value.filter_title,
    onChange: function onChange(filter_title) {
      return _onChange(_extends({}, value, {
        filter_title: filter_title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Filter industry label",
    value: value.filter_industry_label,
    onChange: function onChange(filter_industry_label) {
      return _onChange(_extends({}, value, {
        filter_industry_label: filter_industry_label
      }));
    }
  }), /*#__PURE__*/React.createElement(FilterInput, {
    label: "Industries",
    value: value.industries || [],
    onChange: function onChange(industries) {
      return _onChange(_extends({}, value, {
        industries: industries
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Filter role label",
    value: value.filter_role_label,
    onChange: function onChange(filter_role_label) {
      return _onChange(_extends({}, value, {
        filter_role_label: filter_role_label
      }));
    }
  }), /*#__PURE__*/React.createElement(FilterInput, {
    label: "Roles",
    value: value.roles || [],
    onChange: function onChange(roles) {
      return _onChange(_extends({}, value, {
        roles: roles
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Filter integrations label",
    value: value.filter_integration_label,
    onChange: function onChange(filter_integration_label) {
      return _onChange(_extends({}, value, {
        filter_integration_label: filter_integration_label
      }));
    }
  }), /*#__PURE__*/React.createElement(FilterInput, {
    label: "Integrations",
    value: value.integrations || [],
    onChange: function onChange(integrations) {
      return _onChange(_extends({}, value, {
        integrations: integrations
      }));
    }
  }), /*#__PURE__*/React.createElement(CardsInput, {
    value: value.cards,
    industries: value.industries || [],
    integrations: value.integrations || [],
    roles: value.roles || [],
    onChange: function onChange(cards) {
      return _onChange(_extends({}, value, {
        cards: cards
      }));
    }
  }));
};
CommercialInput$1.defaults = {
  html_id: "",
  title: "All products",
  sub_title: "Find the solution that suits your needs and begin creating your best work.",
  sort_title: "Sort by",
  sort_relevance_text: "Relevance",
  sort_alphabetically_text: "Alphabetical order (A–Z)",
  filter_title: "Find your Product",
  filter_industry_label: "Industry",
  industries: [{
    id: 1,
    value: "Architectural design"
  }, {
    id: 2,
    value: "Architectural visualization"
  }, {
    id: 3,
    value: "Media & entertainment"
  }, {
    id: 4,
    value: "Product design"
  }],
  filter_role_label: "Role",
  roles: [{
    id: 1,
    value: "Architect"
  }, {
    id: 2,
    value: "Archviz specialist"
  }, {
    id: 3,
    value: "Interior designer"
  }, {
    id: 4,
    value: "BIM manager"
  }, {
    id: 5,
    value: "VFX artist"
  }, {
    id: 6,
    value: "Virtual production team"
  }, {
    id: 7,
    value: "Visualization specialist"
  }],
  filter_integration_label: "Integrations",
  integratios: [{
    id: 1,
    value: "SketchUp"
  }, {
    id: 2,
    value: "Revit"
  }, {
    id: 3,
    value: "Rhino"
  }, {
    id: 4,
    value: "Archicad"
  }, {
    id: 5,
    value: "Vectorworks"
  }, {
    id: 6,
    value: "3ds Max"
  }, {
    id: 7,
    value: "Maya"
  }, {
    id: 8,
    value: "Cinema 4D"
  }, {
    id: 9,
    value: "Houdini"
  }, {
    id: 10,
    value: "Unreal"
  }, {
    id: 11,
    value: "Blender"
  }],
  cards: [_extends({
    id: 1
  }, CARD_TEMPLATE$2), _extends({
    id: 2
  }, CARD_TEMPLATE$2), _extends({
    id: 3
  }, CARD_TEMPLATE$2), _extends({
    id: 4
  }, CARD_TEMPLATE$2), _extends({
    id: 5
  }, CARD_TEMPLATE$2), _extends({
    id: 6
  }, CARD_TEMPLATE$2), _extends({
    id: 7
  }, CARD_TEMPLATE$2)]
};
var CardInput$3 = function CardInput(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    value: settings.button_1,
    onChange: function onChange(value) {
      return onChangeItem("button_1", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    value: settings.button_2,
    onChange: function onChange(value) {
      return onChangeItem("button_2", value);
    }
  }), /*#__PURE__*/React.createElement(TagsInput, {
    value: settings.tags || [],
    onChange: function onChange(value) {
      return onChangeItem("tags", value);
    }
  }), /*#__PURE__*/React.createElement(IconTooltipsInput, {
    value: settings.icon_tooltips || [],
    onChange: function onChange(value) {
      return onChangeItem("icon_tooltips", value);
    }
  }));
};
var CARD_TEMPLATE$3 = {
  logo: imagePlaceholder("40x40"),
  description: "",
  button_1: _extends({}, ButtonSettings.defaults, {
    type: "secondary-alt"
  }),
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "text"
  }),
  tags: TagsInput.defaults,
  icon_tooltips: IconTooltipsInput.defaults
};
var CardsInput$1 = function CardsInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Cards",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(CardInput$3, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: CARD_TEMPLATE$3,
    primaryField: "description",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var EducationalInput$1 = function EducationalInput(_ref3) {
  var value = _ref3.value,
    _onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(CardsInput$1, {
    value: value.cards,
    onChange: function onChange(cards) {
      return _onChange(_extends({}, value, {
        cards: cards
      }));
    }
  }));
};
EducationalInput$1.defaults = {
  html_id: "",
  title: "All products",
  sub_title: "Find the solution that suits your needs and begin creating your best work.",
  cards: [_extends({
    id: 1
  }, CARD_TEMPLATE$3), _extends({
    id: 2
  }, CARD_TEMPLATE$3), _extends({
    id: 3
  }, CARD_TEMPLATE$3), _extends({
    id: 5
  }, CARD_TEMPLATE$3), _extends({
    id: 6
  }, CARD_TEMPLATE$3), _extends({
    id: 7
  }, CARD_TEMPLATE$3), _extends({
    id: 8
  }, CARD_TEMPLATE$3)]
};
var SummaryTabInput = function SummaryTabInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputSection, {
    title: "Summary tab"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: value.label,
    onChange: function onChange(label) {
      return _onChange(_extends({}, value, {
        label: label
      }));
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      gap: "1rem"
    }
  }, /*#__PURE__*/React.createElement(InputPopup, {
    label: "Commercial"
  }, /*#__PURE__*/React.createElement(CommercialInput$1, {
    value: value.commercial || {},
    onChange: function onChange(commercial) {
      return _onChange(_extends({}, value, {
        commercial: commercial
      }));
    }
  })), /*#__PURE__*/React.createElement(InputPopup, {
    label: "Educational"
  }, /*#__PURE__*/React.createElement(EducationalInput$1, {
    value: value.educational || {},
    onChange: function onChange(educational) {
      return _onChange(_extends({}, value, {
        educational: educational
      }));
    }
  }))));
};
SummaryTabInput.defaults = {
  label: "All products",
  commercial: CommercialInput$1.defaults,
  educational: EducationalInput$1.defaults
};
var Config$1q = {
  title: "Pricing (new)",
  category: "Pricing"
};
var Defaults$1q = {
  promo_code: "",
  show_disclaimer: "no",
  swiper_on_mobile: "no",
  labels: LabelsInput.defaults,
  industry_tabs: IndustryTabsInput.defaults,
  summary_tab: SummaryTabInput.defaults
};
var Admin$1p = {
  promo_code: {
    type: "text"
  },
  show_disclaimer: {
    label: "Show additional disclaimer",
    type: "select",
    options: [["yes", "Yes"], ["no", "no"]]
  },
  swiper_on_mobile: {
    label: "Main cards appear as a slider on mobile",
    type: "select",
    options: [["yes", "Yes"], ["no", "no"]]
  },
  labels: {
    type: "custom",
    component: LabelsInput
  },
  industry_tabs: {
    type: "custom",
    component: IndustryTabsInput
  },
  summary_tab: {
    type: "custom",
    component: SummaryTabInput
  }
};
var SmallInfoCard = function SmallInfoCard(_ref) {
  var title = _ref.title,
    description = _ref.description,
    button = _ref.button;
  return /*#__PURE__*/React.createElement("div", {
    className: "small-info-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-text"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description)), /*#__PURE__*/React.createElement(Button$1, {
    className: "info-card-button",
    settings: button
  }));
};
var _excluded$f = ["icon", "small"],
  _excluded2$1 = ["small"],
  _excluded3 = ["icon"];
function CustomIcon(_ref) {
  var icon = _ref.icon,
    small = _ref.small,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$f);
  var size = small ? "1em" : "16";
  return /*#__PURE__*/React.createElement("div", _extends({
    style: {
      width: size
    }
  }, rest), /*#__PURE__*/React.createElement(Image, {
    style: {
      width: size
    },
    loading: "lazy",
    src: icon,
    variant: "thumb"
  }));
}
function InfoIcon(_ref2) {
  var small = _ref2.small,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2$1);
  var size = small ? "1em" : "16";
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("title", null, "Info Icon"), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8102_39568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 10.6673V8.00065M7.9987 5.33398H8.00536M14.6654 8.00065C14.6654 11.6825 11.6806 14.6673 7.9987 14.6673C4.3168 14.6673 1.33203 11.6825 1.33203 8.00065C1.33203 4.31875 4.3168 1.33398 7.9987 1.33398C11.6806 1.33398 14.6654 4.31875 14.6654 8.00065Z",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8102_39568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    fill: "white"
  }))));
}
var PointySVG = /*#__PURE__*/React.createElement("svg", {
  width: "26",
  height: "11",
  viewBox: "0 0 26 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("title", null, "Pointy container"), /*#__PURE__*/React.createElement("path", {
  d: "M0.25 8C0.25 9.24264 1.25736 10.25 2.5 10.25H23.5C24.7426 10.25 25.75 9.24264 25.75 8C25.75 6.75736 24.7426 5.75 23.5 5.75H19.8735C18.6122 5.75 17.416 5.18975 16.6086 4.22078L13.6175 0.631467C13.3076 0.259579 12.7317 0.274333 12.4413 0.661605L9.9 4.05C9.09737 5.12017 7.83772 5.75 6.5 5.75H2.5C1.25736 5.75 0.25 6.75736 0.25 8Z",
  fill: "white",
  stroke: "white",
  strokeWidth: "0.5"
}));
var IconComponent = function IconComponent(_ref3) {
  var icon = _ref3.icon,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded3);
  if (!icon) {
    return /*#__PURE__*/React.createElement(InfoIcon, rest);
  }
  return /*#__PURE__*/React.createElement(CustomIcon, _extends({
    icon: icon
  }, rest));
};
var Tooltip$2 = function Tooltip(_ref4) {
  var icon = _ref4.icon,
    title = _ref4.title,
    description = _ref4.description,
    subtle = _ref4.subtle,
    _ref4$small = _ref4.small,
    small = _ref4$small === void 0 ? false : _ref4$small,
    _ref4$content_above = _ref4.content_above,
    content_above = _ref4$content_above === void 0 ? false : _ref4$content_above,
    _ref4$custmInfoIcon = _ref4.custmInfoIcon,
    custmInfoIcon = _ref4$custmInfoIcon === void 0 ? null : _ref4$custmInfoIcon;
  var _React$useState = React.useState({
      open: false,
      contentClass: ""
    }),
    state = _React$useState[0],
    setState = _React$useState[1];
  var triggerRef = /*#__PURE__*/React.createRef();
  if (!icon && !title && !description) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-tooltip-wrapper",
    ref: triggerRef
  }, /*#__PURE__*/React.createElement(IconComponent, {
    icon: custmInfoIcon,
    small: small,
    className: subtle ? "subtle" : "",
    onMouseEnter: function onMouseEnter() {
      var cClass = state.contentClass;
      if (triggerRef.current) {
        var _triggerRef$current$g = triggerRef.current.getBoundingClientRect(),
          x = _triggerRef$current$g.x;
        var width = window.innerWidth;
        if (x > width / 2) {
          cClass = "right";
        } else {
          cClass = "left";
        }
        if (Math.abs(x - width / 2) / width < 0.25) {
          cClass = "center";
        }
      }
      setState(function (current) {
        return _extends({}, current, {
          open: true,
          contentClass: cClass
        });
      });
    },
    onMouseLeave: function onMouseLeave() {
      return setState(function (current) {
        return _extends({}, current, {
          open: false
        });
      });
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "tooltip-content " + (state.open ? state.contentClass + " visible" : state.contentClass) + " " + (content_above ? "above" : "")
  }, !content_above && /*#__PURE__*/React.createElement("div", {
    className: "pointy-container"
  }, PointySVG), (title || icon) && /*#__PURE__*/React.createElement("div", {
    className: "tooltip-header"
  }, icon && /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: icon,
    variant: "thumb"
  }), title && /*#__PURE__*/React.createElement("h6", null, parseMarkdown(title, true))), description && /*#__PURE__*/React.createElement("div", {
    className: "tooltip-description"
  }, parseMarkdown(description))));
};
var Arrow = function Arrow() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6L8 10L12 6",
    stroke: "#1C1C22",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var EnabledDropdown = function EnabledDropdown(_ref) {
  var options = _ref.options,
    value = _ref.value,
    onChange = _ref.onChange;
  var dropdownRef = React.useRef(null);
  var _React$useState = React.useState(value || ""),
    selectedValue = _React$useState[0],
    setSelectedValue = _React$useState[1];
  var _React$useState2 = React.useState(false),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  React.useEffect(function () {
    setSelectedValue(value);
  }, [value]);
  React.useEffect(function () {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  var handleSelect = function handleSelect(option) {
    setSelectedValue(option);
    setOpen(false);
    onChange(option);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-select-container",
    ref: dropdownRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-select " + (open ? "open" : ""),
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "selected-value-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "selected-value"
  }, selectedValue.label), selectedValue.tag && /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, selectedValue.tag)), /*#__PURE__*/React.createElement(Arrow, null)), open && /*#__PURE__*/React.createElement("div", {
    className: "options-container"
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      key: option.id,
      className: "option " + (selectedValue.id === option.id ? "selected" : ""),
      onClick: function onClick() {
        return handleSelect(option);
      }
    }, option.label, option.tag && /*#__PURE__*/React.createElement("div", {
      className: "tag"
    }, option.tag));
  }))), /*#__PURE__*/React.createElement(Tooltip$2, selectedValue.tooltip || {}));
};
var DisabledDropdown = function DisabledDropdown(_ref2) {
  var option = _ref2.option;
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-select-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "custom-select disabled"
  }, /*#__PURE__*/React.createElement("div", {
    className: "selected-value-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "selected-value"
  }, option.label), option.tag && /*#__PURE__*/React.createElement("div", {
    className: "tag"
  }, option.tag)))), /*#__PURE__*/React.createElement(Tooltip$2, _extends({
    subtle: true
  }, option.tooltip || {})));
};
var Dropdown = function Dropdown(_ref3) {
  var _ref3$skipSingle = _ref3.skipSingle,
    skipSingle = _ref3$skipSingle === void 0 ? false : _ref3$skipSingle,
    options = _ref3.options,
    value = _ref3.value,
    onChange = _ref3.onChange;
  if (options.length > 1) {
    return /*#__PURE__*/React.createElement(EnabledDropdown, {
      options: options,
      value: value,
      onChange: onChange
    });
  }
  if (skipSingle) {
    return null;
  }
  if (options.length === 1) {
    return /*#__PURE__*/React.createElement(DisabledDropdown, {
      option: options[0]
    });
  }
  return null;
};
var PricingContext = /*#__PURE__*/React.createContext({});
var SINGLE_LICENSE_LABEL_MAP = {
  monthly: "billing_monthly_license",
  annual: "billing_anually_license",
  triennial: "billing_triennial_license"
};
var MULTI_LICENSE_LABEL_MAP = {
  monthly: "billing_monthly_licenses",
  annual: "billing_anually_licenses",
  triennial: "billing_triennial_licenses"
};
var STATIC_LABEL_MAP = {
  monthly: "billed_monthly",
  annual: "billed_annually",
  triennial: "billed_triennially"
};
var TOKENS_MAP = {
  "{{PER_MONTH}}": "per_month",
  "{{PER_YEAR}}": "per_year",
  "{{PER_TRIENNIAL}}": "per_triennial"
};
function priceForPeriodAndToken(token, rpPricingData, qty, currency, country, ratePlan, pickedPromoCode) {
  var price = priceForSpecificPeriod(rpPricingData, currency, TOKENS_MAP[token], ratePlan, pickedPromoCode);
  return Currency.prettyPrint(price.value * qty, currency, country);
}
function billingMethodLabel(licensesCount, billingPeriod, labels, rpPricingData, currency, country, ratePlan, pickedPromoCode) {
  var _labels$key;
  var key = "";
  if (licensesCount === 1) {
    key = SINGLE_LICENSE_LABEL_MAP[billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id];
  } else {
    key = MULTI_LICENSE_LABEL_MAP[billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id];
  }
  return (_labels$key = labels[key]) === null || _labels$key === void 0 ? void 0 : _labels$key.replace("{{LICENSES_COUNT}}", licensesCount).replace("{{PER_MONTH}}", priceForPeriodAndToken("{{PER_MONTH}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode)).replace("{{PER_YEAR}}", priceForPeriodAndToken("{{PER_YEAR}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode)).replace("{{PER_TRIENNIAL}}", priceForPeriodAndToken("{{PER_TRIENNIAL}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode));
}
function billingMethodStaticLabel(billingPeriod, labels, rpPricingData, currency, country, ratePlan, pickedPromoCode, licensesCount) {
  var _labels$key2;
  var key = STATIC_LABEL_MAP[billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id];
  return (_labels$key2 = labels[key]) === null || _labels$key2 === void 0 ? void 0 : _labels$key2.replace("{{PER_MONTH}}", priceForPeriodAndToken("{{PER_MONTH}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode)).replace("{{PER_YEAR}}", priceForPeriodAndToken("{{PER_YEAR}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode)).replace("{{PER_TRIENNIAL}}", priceForPeriodAndToken("{{PER_TRIENNIAL}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode));
}
function customBilledLabel(ratePlan, licensesCount, rpPricingData, currency, country, pickedPromoCode) {
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.billed_timing_details)) {
    return "";
  }
  var qty = Number.parseInt((ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.qty) || "1", 10);
  var price = priceForPeriod(rpPricingData, currency, ratePlan);
  return ratePlan.billed_timing_details.replace("{{LICENSES_COUNT}}", licensesCount).replace("{{PER_UNIT}}", Currency.prettyPrint(price.value / qty, currency, country)).replace("{{PER_MONTH}}", priceForPeriodAndToken("{{PER_MONTH}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode)).replace("{{PER_YEAR}}", priceForPeriodAndToken("{{PER_YEAR}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode)).replace("{{PER_TRIENNIAL}}", priceForPeriodAndToken("{{PER_TRIENNIAL}}", rpPricingData, licensesCount, currency, country, ratePlan, pickedPromoCode));
}
function pricingDataFor$1(ratePlan, pricingData) {
  var _pricingData$list, _rpiData$data, _rpiData$data$ratePla, _rpiData$data2, _rpiData$data2$ratePl, _rpiData$data3, _rpiData$data3$ratePl, _rpiData$data4, _rpiData$data4$ratePl, _rpiData$data5, _rpiData$data5$ratePl, _rpiData$data6, _rpiData$data6$ratePl, _rpiData$data7, _rpiData$data7$ratePl, _rpiData$data8, _rpiData$data9, _rpiData$data9$ratePl, _rpiData$data10, _rpiData$data10$rateP;
  if (!ratePlan) {
    return null;
  }
  var rpiData = pricingData === null || pricingData === void 0 ? void 0 : (_pricingData$list = pricingData.list) === null || _pricingData$list === void 0 ? void 0 : _pricingData$list.find(function (item) {
    return item.rate_plan_id === ratePlan.rate_plan_id;
  });
  if (!rpiData) {
    return null;
  }
  var minQty = ((_rpiData$data = rpiData.data) === null || _rpiData$data === void 0 ? void 0 : (_rpiData$data$ratePla = _rpiData$data.ratePlan) === null || _rpiData$data$ratePla === void 0 ? void 0 : _rpiData$data$ratePla.minAmt) || ratePlan.qty || 1;
  return {
    id: ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.rate_plan_id,
    name: rpiData === null || rpiData === void 0 ? void 0 : (_rpiData$data2 = rpiData.data) === null || _rpiData$data2 === void 0 ? void 0 : (_rpiData$data2$ratePl = _rpiData$data2.ratePlan) === null || _rpiData$data2$ratePl === void 0 ? void 0 : _rpiData$data2$ratePl.name,
    prices: ((_rpiData$data3 = rpiData.data) === null || _rpiData$data3 === void 0 ? void 0 : (_rpiData$data3$ratePl = _rpiData$data3.ratePlan) === null || _rpiData$data3$ratePl === void 0 ? void 0 : _rpiData$data3$ratePl.pricing) || [],
    discount: ((_rpiData$data4 = rpiData.data) === null || _rpiData$data4 === void 0 ? void 0 : (_rpiData$data4$ratePl = _rpiData$data4.ratePlan) === null || _rpiData$data4$ratePl === void 0 ? void 0 : _rpiData$data4$ratePl.discount) || [],
    code: rpiData === null || rpiData === void 0 ? void 0 : rpiData.promo_code,
    termType: (_rpiData$data5 = rpiData.data) === null || _rpiData$data5 === void 0 ? void 0 : (_rpiData$data5$ratePl = _rpiData$data5.ratePlan) === null || _rpiData$data5$ratePl === void 0 ? void 0 : _rpiData$data5$ratePl.termType,
    billingPeriod: (_rpiData$data6 = rpiData.data) === null || _rpiData$data6 === void 0 ? void 0 : (_rpiData$data6$ratePl = _rpiData$data6.ratePlan) === null || _rpiData$data6$ratePl === void 0 ? void 0 : _rpiData$data6$ratePl.billingPeriod,
    variant: (_rpiData$data7 = rpiData.data) === null || _rpiData$data7 === void 0 ? void 0 : (_rpiData$data7$ratePl = _rpiData$data7.ratePlan) === null || _rpiData$data7$ratePl === void 0 ? void 0 : _rpiData$data7$ratePl.billingPeriod,
    min_qty: Number.parseInt(minQty, 10),
    promoActive: (_rpiData$data8 = rpiData.data) === null || _rpiData$data8 === void 0 ? void 0 : _rpiData$data8.hasPromoCode,
    specific_billing_preriod: (_rpiData$data9 = rpiData.data) === null || _rpiData$data9 === void 0 ? void 0 : (_rpiData$data9$ratePl = _rpiData$data9.ratePlan) === null || _rpiData$data9$ratePl === void 0 ? void 0 : _rpiData$data9$ratePl.specificBillingPeriod,
    category: (_rpiData$data10 = rpiData.data) === null || _rpiData$data10 === void 0 ? void 0 : (_rpiData$data10$rateP = _rpiData$data10.ratePlan) === null || _rpiData$data10$rateP === void 0 ? void 0 : _rpiData$data10$rateP.licenseType
  };
}
function perMonth(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "annual":
      return value / (opts.specificBillingPeriod || 12);
    case "triennial":
      return value / (opts.specificBillingPeriod || 36);
    default:
      return value;
  }
}
function perYear(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "monthly":
      return value * (opts.specificBillingPeriod || 12);
    case "triennial":
      return value / (opts.specificBillingPeriod || 3);
    default:
      return value;
  }
}
function perTriennial(value, type, opts) {
  if (opts === void 0) {
    opts = {};
  }
  switch (type) {
    case "monthly":
      return value * (opts.specificBillingPeriod || 36);
    case "annual":
      return value * (opts.specificBillingPeriod || 3);
    default:
      return value;
  }
}
var BILLING_PERIOD_MAP = {
  Three_Years: "triennial",
  Annual: "annual",
  Month: "monthly"
};
function calculateForPeriod(value, rpPricingData, ratePlan) {
  var billingPeriod = BILLING_PERIOD_MAP[rpPricingData.billingPeriod];
  if (!billingPeriod) {
    console.warn("Pricing (new) - Unknown billing period from ZUORA: " + JSON.stringify(rpPricingData));
    return value;
  }
  switch (ratePlan.price_display_type) {
    case "per_month":
      return perMonth(value, billingPeriod);
    case "per_year":
      return perYear(value, billingPeriod);
    case "per_triennial":
      return perTriennial(value, billingPeriod);
  }
}
function isPromoActive(rpPricingData, ratePlan, pickedPromoCode) {
  if (!(rpPricingData !== null && rpPricingData !== void 0 && rpPricingData.promoActive)) {
    return false;
  }
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.promo_code) && !pickedPromoCode) {
    return false;
  }
  return true;
}
function applyDiscount(value, rpPricingData, currency, ratePlan, pickedPromoCode) {
  var _rpPricingData$discou;
  if (!isPromoActive(rpPricingData, ratePlan, pickedPromoCode)) return value;
  var discount = (_rpPricingData$discou = rpPricingData.discount) === null || _rpPricingData$discou === void 0 ? void 0 : _rpPricingData$discou.find(function (rpD) {
    return rpD.currency.toLowerCase() === currency;
  });
  if (!discount) {
    return value;
  }
  if (discount.percentage) {
    return value - value * Number.parseFloat(discount.percentage) / 100;
  }
  if (discount.amount) {
    return value - Number.parseFloat(discount.amount);
  }
  console.warn("Unknown discount type: ", discount, rpPricingData, currency);
  return value;
}
function priceForPeriod(rpPricingData, currency, ratePlan, pickedPromoCode) {
  var price = rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.prices.find(function (item) {
    var _item$currency;
    return ((_item$currency = item.currency) === null || _item$currency === void 0 ? void 0 : _item$currency.toLowerCase()) === (currency === null || currency === void 0 ? void 0 : currency.toLowerCase());
  });
  if (price !== null && price !== void 0 && price.price) {
    return {
      value: calculateForPeriod(applyDiscount(price.price, rpPricingData, currency, ratePlan, pickedPromoCode), rpPricingData, ratePlan),
      oldValue: calculateForPeriod(price.price, rpPricingData, ratePlan),
      promo: isPromoActive(rpPricingData, ratePlan, pickedPromoCode)
    };
  }
  return {
    value: 0,
    oldValue: 0,
    promo: false
  };
}
var PRICE_PER_PERIOD = {
  per_month: perMonth,
  per_year: perYear,
  per_triennial: perTriennial
};
function priceForSpecificPeriod(rpPricingData, currency, period, ratePlan, pickedPromoCode) {
  var price = rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.prices.find(function (item) {
    var _item$currency2;
    return ((_item$currency2 = item.currency) === null || _item$currency2 === void 0 ? void 0 : _item$currency2.toLowerCase()) === (currency === null || currency === void 0 ? void 0 : currency.toLowerCase());
  });
  var billingPeriod = BILLING_PERIOD_MAP[rpPricingData.billingPeriod];
  var func = PRICE_PER_PERIOD[period];
  if (price !== null && price !== void 0 && price.price) {
    return {
      value: func(applyDiscount(price.price, rpPricingData, currency, ratePlan, pickedPromoCode), billingPeriod),
      oldValue: func(price.price, billingPeriod),
      promo: rpPricingData.promoActive
    };
  }
  return {
    value: 0,
    oldValue: 0,
    promo: false
  };
}
function wholePart(num) {
  var _Number$toFixed$split = Number(num).toFixed(2).split("."),
    whole = _Number$toFixed$split[0];
  return whole;
}
function decimalPart(num) {
  var _Number$toFixed$split2 = Number(num).toFixed(2).split("."),
    dec = _Number$toFixed$split2[1];
  if (!dec) {
    return "00";
  }
  return dec.padEnd(2, "0");
}
var utils = {
  decimalPart: decimalPart,
  wholePart: wholePart,
  priceForPeriod: priceForPeriod,
  pricingDataFor: pricingDataFor$1,
  billingMethodStaticLabel: billingMethodStaticLabel,
  billingMethodLabel: billingMethodLabel,
  customBilledLabel: customBilledLabel,
  isPromoActive: isPromoActive
};
var boldInfoIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTEzOTBfMjMyNDMwKSI+CjxwYXRoIGQ9Ik0zLjk5OTM1IDUuMzMyNjhWMy45OTkzNU0zLjk5OTM1IDIuNjY2MDJINC4wMDI2OE03LjMzMjY4IDMuOTk5MzVDNy4zMzI2OCA1Ljg0MDMgNS44NDAzIDcuMzMyNjggMy45OTkzNSA3LjMzMjY4QzIuMTU4NCA3LjMzMjY4IDAuNjY2MDE2IDUuODQwMyAwLjY2NjAxNiAzLjk5OTM1QzAuNjY2MDE2IDIuMTU4NCAyLjE1ODQgMC42NjYwMTYgMy45OTkzNSAwLjY2NjAxNkM1Ljg0MDMgMC42NjYwMTYgNy4zMzI2OCAyLjE1ODQgNy4zMzI2OCAzLjk5OTM1WiIgc3Ryb2tlPSIjQUJBQkI2IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzExMzkwXzIzMjQzMCI+CjxyZWN0IHdpZHRoPSI4IiBoZWlnaHQ9IjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
function shouldBeGlowing(card) {
  return card.glow_border_color && card.glow_outline_color && card.glowing_text;
}
function currentLicense(card) {
  return card.licenses.find(function (lic) {
    return lic.default_license === "yes";
  }) || card.licenses[0];
}
function pickBillingPeriod(billingPeriod, license) {
  var _license$monthly, _license$annual, _license$triennial;
  if (billingPeriod) {
    return billingPeriod;
  }
  if ((_license$monthly = license.monthly) !== null && _license$monthly !== void 0 && _license$monthly.rate_plan_id) {
    return {
      id: "monthly"
    };
  }
  if ((_license$annual = license.annual) !== null && _license$annual !== void 0 && _license$annual.rate_plan_id) {
    return {
      id: "annual"
    };
  }
  if ((_license$triennial = license.triennial) !== null && _license$triennial !== void 0 && _license$triennial.rate_plan_id) {
    return {
      id: "triennial"
    };
  }
  return {};
}
function pickLicensesCount(licensesCount, rpPricingData) {
  var minQty = rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.min_qty;
  if (minQty < licensesCount) {
    return licensesCount;
  }
  return minQty;
}
var DisabledCard = function DisabledCard(_ref) {
  var _card$features, _card$disabled_logos, _card$features2, _card$button_;
  var card = _ref.card,
    license = _ref.license,
    labels = _ref.labels;
  var featuredItems = ((_card$features = card.features) === null || _card$features === void 0 ? void 0 : _card$features.items) || [];
  var hiddenLogosCount = Number.parseInt(card.hidden_logos_count || 0, 10);
  var isGlowing = shouldBeGlowing(card);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      outlineColor: isGlowing ? "var(--light-gray)" : "transparent"
    },
    className: "pricing-main-card disabled " + (isGlowing ? "savings-border" : "")
  }, isGlowing && /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--black)",
      background: isGlowing ? "var(--light-gray)" : "var(--white)"
    },
    className: "savings-text"
  }, card.glowing_text), /*#__PURE__*/React.createElement("div", {
    style: {
      borderColor: isGlowing ? "var(--dark-gray)" : "transparent"
    },
    className: "" + (isGlowing ? "inner-border" : "inner-no-border")
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "product-name"
  }, card.title), /*#__PURE__*/React.createElement("h4", {
    className: "product-info"
  }, parseMarkdown(card.description, true))), /*#__PURE__*/React.createElement("div", {
    className: "small-icons"
  }, (_card$disabled_logos = card.disabled_logos) === null || _card$disabled_logos === void 0 ? void 0 : _card$disabled_logos.map(function (logo, idx) {
    return /*#__PURE__*/React.createElement(Image, {
      key: idx + "-" + logo.id,
      src: logo,
      variant: "thumb"
    });
  }), hiddenLogosCount > 0 && /*#__PURE__*/React.createElement("div", {
    className: "more-icons"
  }, /*#__PURE__*/React.createElement("span", null, "+", hiddenLogosCount)))), /*#__PURE__*/React.createElement("div", {
    className: "price-section"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "price-per-month"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "main-price"
  }, "N/A")), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, "N/A")), /*#__PURE__*/React.createElement(Dropdown, {
    options: [{
      id: license === null || license === void 0 ? void 0 : license.license_type,
      label: license === null || license === void 0 ? void 0 : license.license_type,
      tag: "",
      tooltip: license === null || license === void 0 ? void 0 : license.tooltip
    }]
  }), /*#__PURE__*/React.createElement("div", {
    className: "non-laptop",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: _extends({}, card.button_1 || {}, {
      label: labels.main_card_disabled_button_label,
      link: "#"
    }),
    className: "price-btn"
  })), /*#__PURE__*/React.createElement("div", {
    className: "laptop",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: _extends({}, card.button_1 || {}, {
      label: labels.main_card_disabled_button_laptop_label,
      link: "#"
    }),
    className: "price-btn"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "more-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "description customized-ul"
  }, /*#__PURE__*/React.createElement("h6", null, (_card$features2 = card.features) === null || _card$features2 === void 0 ? void 0 : _card$features2.title), featuredItems.length > 0 && /*#__PURE__*/React.createElement("ul", {
    className: "features"
  }, featuredItems.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx + "-" + item.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner-feature"
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.value
      }
    }), /*#__PURE__*/React.createElement(Tooltip$2, _extends({
      small: true
    }, item.tooltip))));
  }))), (card === null || card === void 0 ? void 0 : (_card$button_ = card.button_2) === null || _card$button_ === void 0 ? void 0 : _card$button_.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: card.button_2
  }))));
};
var SecondButton = function SecondButton(_ref2) {
  var settings = _ref2.settings,
    _onClick = _ref2.onClick;
  if (!settings.label) {
    return null;
  }
  if (!_onClick) {
    return /*#__PURE__*/React.createElement(Button$1, {
      settings: settings
    });
  }
  return /*#__PURE__*/React.createElement("a", {
    href: settings.link,
    className: buttonClass(settings.type),
    id: settings.id || "",
    target: settings.target,
    rel: settings.follow_link === "no-follow" ? "nofollow" : "",
    onClick: function onClick(e) {
      e.preventDefault();
      _onClick();
    }
  }, settings.label);
};
var MainPricingCard = function MainPricingCard(_ref3) {
  var _card$features3, _ratePlan$old_prices, _ratePlan$old_prices$, _card$button_2, _card$features4;
  var product = _ref3.product,
    card = _ref3.card,
    billingPeriod = _ref3.billingPeriod,
    licensesCount = _ref3.licensesCount,
    labels = _ref3.labels,
    onSecondButtonClick = _ref3.onSecondButtonClick;
  React.useEffect(function () {
    var _license$billingPerio;
    if (!(billingPeriod !== null && billingPeriod !== void 0 && billingPeriod.id)) {
      return;
    }
    if ((_license$billingPerio = license[billingPeriod.id]) !== null && _license$billingPerio !== void 0 && _license$billingPerio.rate_plan_id) {
      return;
    }
    var newDropDownLicenses = card.licenses.filter(function (lic) {
      var _lic$billingPeriod$id;
      return !!((_lic$billingPeriod$id = lic[billingPeriod.id]) !== null && _lic$billingPeriod$id !== void 0 && _lic$billingPeriod$id.rate_plan_id);
    });
    if (newDropDownLicenses.length === 0) {
      return;
    }
    var newCurrentLicense = newDropDownLicenses.find(function (nLic) {
      return nLic === license.id;
    });
    if (newCurrentLicense) {
      return;
    }
    setLicense(currentLicense({
      licenses: newDropDownLicenses
    }));
  }, [billingPeriod]);
  React.useEffect(function () {
    var newLicense = currentLicense(card);
    setLicense(newLicense);
  }, [product, card]);
  var _React$useContext = React.useContext(PricingContext),
    currency = _React$useContext.currency,
    country = _React$useContext.country,
    pricingData = _React$useContext.pricingData,
    pickedPromoCode = _React$useContext.pickedPromoCode;
  var _React$useState = React.useState(currentLicense(card)),
    license = _React$useState[0],
    setLicense = _React$useState[1];
  var isGlowing = shouldBeGlowing(card);
  var localBillingPeriod = pickBillingPeriod(billingPeriod, license);
  var ratePlan = license[localBillingPeriod === null || localBillingPeriod === void 0 ? void 0 : localBillingPeriod.id];
  var featuredItems = ((_card$features3 = card.features) === null || _card$features3 === void 0 ? void 0 : _card$features3.items) || [];
  var cardRef = React.useRef(null);
  useInViewPort(cardRef, function () {
    return registerProductView(utils.pricingDataFor(ratePlan, pricingData) || {});
  });
  var hiddenLogosCount = Number.parseInt(card.hidden_logos_count || 0, 10);
  var visibleLogos = card.logos.slice(0, card.logos.length - hiddenLogosCount);
  var hiddenLogos = card.logos.slice(card.logos.length - hiddenLogosCount);
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "hide") {
    return null;
  }
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "disable") {
    return /*#__PURE__*/React.createElement(DisabledCard, {
      card: card,
      license: license,
      labels: labels
    });
  }
  var rpPricingData = utils.pricingDataFor(ratePlan, pricingData);
  var localLicensesCount = pickLicensesCount(licensesCount, rpPricingData);
  var price = utils.priceForPeriod(rpPricingData, currency, ratePlan, pickedPromoCode);
  var totalPrice = (localLicensesCount * price.value).toFixed(2).toString();
  var totalOldPrice = null;
  if (price.promo) {
    totalOldPrice = (localLicensesCount * price.oldValue).toFixed(2).toString();
  }
  var manualOldPrice = ratePlan === null || ratePlan === void 0 ? void 0 : (_ratePlan$old_prices = ratePlan.old_prices) === null || _ratePlan$old_prices === void 0 ? void 0 : (_ratePlan$old_prices$ = _ratePlan$old_prices.find(function (op) {
    return op.currency.toLowerCase() === currency;
  })) === null || _ratePlan$old_prices$ === void 0 ? void 0 : _ratePlan$old_prices$.value;
  var totalManualOldPrice = Number.parseFloat(manualOldPrice || "0") * localLicensesCount;
  var dropDownLicenses = card.licenses.filter(function (lic) {
    var _lic$localBillingPeri;
    return !!((_lic$localBillingPeri = lic[localBillingPeriod.id]) !== null && _lic$localBillingPeri !== void 0 && _lic$localBillingPeri.rate_plan_id);
  });
  return /*#__PURE__*/React.createElement("div", {
    ref: cardRef,
    style: {
      outlineColor: isGlowing ? card.glow_outline_color : "transparent"
    },
    className: "pricing-main-card " + (isGlowing ? "savings-border" : "")
  }, isGlowing && /*#__PURE__*/React.createElement("span", {
    style: {
      color: isGlowing ? card.glow_border_color : "var(--black)",
      background: isGlowing ? card.glow_outline_color : "var(--white)"
    },
    className: "savings-text"
  }, card.glowing_text), /*#__PURE__*/React.createElement("div", {
    style: {
      borderColor: isGlowing ? card.glow_border_color : "transparent"
    },
    className: "" + (isGlowing ? "inner-border" : "inner-no-border")
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h5", {
    style: {
      color: product.color
    },
    className: "product-name"
  }, card.title), /*#__PURE__*/React.createElement("h4", {
    className: "product-info"
  }, parseMarkdown(card.description, true))), /*#__PURE__*/React.createElement("div", {
    className: "small-icons"
  }, visibleLogos.map(function (logo) {
    return /*#__PURE__*/React.createElement(Image, {
      key: logo.id,
      src: logo,
      variant: "thumb"
    });
  }), hiddenLogos.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "additional-logos"
  }, /*#__PURE__*/React.createElement("div", {
    className: "more-icons"
  }, /*#__PURE__*/React.createElement("span", null, "+", hiddenLogos.length)), /*#__PURE__*/React.createElement("div", {
    className: "hidden-icons"
  }, hiddenLogos.map(function (logo) {
    return /*#__PURE__*/React.createElement(Image, {
      key: logo.id,
      src: logo,
      variant: "thumb"
    });
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "price-section"
  }, /*#__PURE__*/React.createElement("div", null, totalOldPrice || manualOldPrice ? /*#__PURE__*/React.createElement("div", {
    className: "old-price-tooltip"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "old-price"
  }, manualOldPrice ? Currency.symbol(currency, country) + " " + totalManualOldPrice : Currency.symbol(currency, country) + " " + totalOldPrice), ratePlan.old_prices_tooltip && /*#__PURE__*/React.createElement(Tooltip$2, _extends({
    custmInfoIcon: boldInfoIcon,
    small: true,
    content_above: true
  }, ratePlan.old_prices_tooltip))) : /*#__PURE__*/React.createElement("div", {
    className: "old-price"
  }), /*#__PURE__*/React.createElement("div", {
    className: "price-per-month"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "main-price " + (price.promo ? "promo" : "")
  }, Currency.symbol(currency, country), " ", utils.wholePart(totalPrice)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("h4", {
    className: "secondary-price " + (price.promo ? "promo" : "")
  }, utils.decimalPart(totalPrice)), /*#__PURE__*/React.createElement("span", null, ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.after_price)), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, utils.customBilledLabel(ratePlan, localLicensesCount, rpPricingData, currency, country, pickedPromoCode) || utils.billingMethodLabel(localLicensesCount, localBillingPeriod, labels, rpPricingData, currency, country, ratePlan, pickedPromoCode))), /*#__PURE__*/React.createElement(Dropdown, {
    options: dropDownLicenses.map(function (lic) {
      return {
        id: lic.license_type,
        label: lic.license_type,
        tag: "",
        tooltip: lic.tooltip
      };
    }),
    value: {
      id: license.license_type,
      label: license.license_type,
      tooltip: license.tooltip
    },
    onChange: function onChange(newValue) {
      var newLicense = card.licenses.find(function (lic) {
        return lic.license_type === newValue.id;
      });
      setLicense(newLicense);
    }
  }), (card === null || card === void 0 ? void 0 : (_card$button_2 = card.button_1) === null || _card$button_2 === void 0 ? void 0 : _card$button_2.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: card.button_1,
    className: "price-btn",
    productInfo: {
      productCode: rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.id,
      quantity: localLicensesCount,
      promoCode: utils.isPromoActive(rpPricingData, ratePlan, pickedPromoCode) ? rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.code : "",
      currency: currency,
      ratePlanDetails: rpPricingData || {}
    },
    upsellEnabled: (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.disable_upsell) !== "yes"
  })), /*#__PURE__*/React.createElement("div", {
    className: "more-info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "description customized-ul"
  }, /*#__PURE__*/React.createElement("h6", null, (_card$features4 = card.features) === null || _card$features4 === void 0 ? void 0 : _card$features4.title), featuredItems.length > 0 && /*#__PURE__*/React.createElement("ul", {
    className: "features"
  }, featuredItems.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx + "-" + item.id
    }, /*#__PURE__*/React.createElement("div", {
      className: "inner-feature"
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: item.value
      }
    }), /*#__PURE__*/React.createElement(Tooltip$2, _extends({
      small: true
    }, item.tooltip))));
  }))), /*#__PURE__*/React.createElement(SecondButton, {
    settings: card === null || card === void 0 ? void 0 : card.button_2,
    onClick: card.button_2_on_click === "yes" && onSecondButtonClick
  }))));
};
var TabHeader = function TabHeader(_ref) {
  var tab = _ref.tab,
    centered = _ref.centered;
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-section-header " + (centered ? "centered" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "main-title"
  }, tab.logo && /*#__PURE__*/React.createElement(Image, {
    src: tab.logo,
    variant: "thumb"
  }), /*#__PURE__*/React.createElement("h3", null, tab.title)), tab.sub_title && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(tab.sub_title || "")));
};
var LicenseTypeSwitcher = function LicenseTypeSwitcher(_ref) {
  var labels = _ref.labels,
    licenseType = _ref.licenseType,
    licenseTypes = _ref.licenseTypes,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "pricing-plan-switcher" : _ref$className,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "plan-switcher-licenses"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, licenseTypes.map(function (lt) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tab " + (licenseType.id === lt.id ? "active" : ""),
      key: lt.id,
      role: "button",
      onClick: function onClick() {
        onChange(lt);
      }
    }, lt.label);
  })), /*#__PURE__*/React.createElement(Tooltip$2, labels.license_type_switcher_tooltip)));
};
var PlusIcon = function PlusIcon(_ref) {
  var count = _ref.count,
    maxLicenses = _ref.maxLicenses;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "+"), /*#__PURE__*/React.createElement("path", {
    d: "M8.00065 3.33398V12.6673M3.33398 8.00065H12.6673",
    stroke: count >= maxLicenses ? "#DBDBE0" : "#1C1C1C",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var MinusIcon = function MinusIcon(_ref2) {
  var count = _ref2.count;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, "-"), /*#__PURE__*/React.createElement("path", {
    d: "M3.33398 8H12.6673",
    stroke: count <= 1 ? "#DBDBE0" : "#1C1C1C",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var LicensesCountSwitcher = function LicensesCountSwitcher(_ref3) {
  var count = _ref3.count,
    maxLicenses = _ref3.maxLicenses,
    labels = _ref3.labels,
    _onChange = _ref3.onChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "licenses-manage"
  }, /*#__PURE__*/React.createElement("span", null, labels.licenses_count_title), /*#__PURE__*/React.createElement("div", {
    className: "licenses-input"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: count <= 1,
    type: "button",
    className: "input-button",
    onClick: function onClick() {
      _onChange(count - 1);
    }
  }, /*#__PURE__*/React.createElement(MinusIcon, {
    count: count
  })), /*#__PURE__*/React.createElement("input", {
    type: "number",
    max: maxLicenses,
    value: count,
    onChange: function onChange(e) {
      e.preventDefault();
      _onChange(Number(e.target.value));
    }
  }), /*#__PURE__*/React.createElement("button", {
    disabled: count >= maxLicenses,
    type: "button",
    className: "input-button",
    onClick: function onClick() {
      _onChange(count + 1);
    }
  }, /*#__PURE__*/React.createElement(PlusIcon, {
    count: count,
    maxLicenses: maxLicenses
  })))), count >= 11 && /*#__PURE__*/React.createElement("p", {
    className: "max-licenses-text"
  }, parseMarkdown(labels.licenses_count_max_message)));
};
var PlanSwitcher = function PlanSwitcher(_ref4) {
  var labels = _ref4.labels,
    billingPeriod = _ref4.billingPeriod,
    billingPeriods = _ref4.billingPeriods,
    _ref4$licenseTypeSwit = _ref4.licenseTypeSwitcherClass,
    licenseTypeSwitcherClass = _ref4$licenseTypeSwit === void 0 ? "" : _ref4$licenseTypeSwit,
    licenseType = _ref4.licenseType,
    licenseTypes = _ref4.licenseTypes,
    licensesCount = _ref4.licensesCount,
    onLicensesCountChange = _ref4.onLicensesCountChange,
    onBillingPeriodChange = _ref4.onBillingPeriodChange,
    onLicenseTypeChange = _ref4.onLicenseTypeChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-plan-switcher"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, labels.change_plan_title && /*#__PURE__*/React.createElement("h4", null, labels.change_plan_title), labels.change_plan_subtitle && /*#__PURE__*/React.createElement("p", null, labels.change_plan_subtitle)), /*#__PURE__*/React.createElement(LicenseTypeSwitcher, {
    className: [licenseTypeSwitcherClass].filter(Boolean).join(""),
    labels: labels,
    licenseType: licenseType,
    licenseTypes: licenseTypes,
    onChange: onLicenseTypeChange
  }), /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, billingPeriods.map(function (bp) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tab " + ((billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id) === bp.id ? "active" : ""),
      key: bp.id,
      role: "button",
      onClick: function onClick() {
        onBillingPeriodChange(bp);
      }
    }, labels["billing_" + bp.id], /*#__PURE__*/React.createElement("span", {
      className: "plan-savings-text " + (bp.tag && (billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id) === bp.id ? "visible" : "")
    }, bp.tag));
  })), /*#__PURE__*/React.createElement(LicensesCountSwitcher, {
    count: licensesCount,
    maxLicenses: 50,
    labels: labels,
    onChange: onLicensesCountChange
  }));
};
function shouldBeGlowing$1(card) {
  return card.outline_color && card.outline_text && card.outline_text_color && card.outline_border_color;
}
function shouldHaveRibbon(card) {
  return card.ribbon_color && card.ribbon_text;
}
function prepareBillingPeriods(license, labels) {
  var _license$monthly, _license$annual, _license$triennial;
  var billingPeriods = [];
  if ((_license$monthly = license.monthly) !== null && _license$monthly !== void 0 && _license$monthly.rate_plan_id) {
    var _license$monthly2, _license$monthly3;
    billingPeriods.push({
      id: "monthly",
      label: labels.billing_monthly,
      tag: (_license$monthly2 = license.monthly) === null || _license$monthly2 === void 0 ? void 0 : _license$monthly2.tag,
      tooltip: (_license$monthly3 = license.monthly) === null || _license$monthly3 === void 0 ? void 0 : _license$monthly3.tooltip
    });
  }
  if ((_license$annual = license.annual) !== null && _license$annual !== void 0 && _license$annual.rate_plan_id) {
    var _license$annual2, _license$annual3;
    billingPeriods.push({
      id: "annual",
      label: labels.billing_annual,
      tag: (_license$annual2 = license.annual) === null || _license$annual2 === void 0 ? void 0 : _license$annual2.tag,
      tooltip: (_license$annual3 = license.annual) === null || _license$annual3 === void 0 ? void 0 : _license$annual3.tooltip
    });
  }
  if ((_license$triennial = license.triennial) !== null && _license$triennial !== void 0 && _license$triennial.rate_plan_id) {
    var _license$triennial2, _license$triennial3;
    billingPeriods.push({
      id: "triennial",
      label: labels.billing_triennial,
      tag: (_license$triennial2 = license.triennial) === null || _license$triennial2 === void 0 ? void 0 : _license$triennial2.tag,
      tooltip: (_license$triennial3 = license.triennial) === null || _license$triennial3 === void 0 ? void 0 : _license$triennial3.tooltip
    });
  }
  return billingPeriods;
}
function tagForLicense(license) {
  var billingPeriods = [license.annual, license.monthly, license.triennial].filter(function (item) {
    return !!item.rate_plan_id;
  });
  if (billingPeriods.length === 1) {
    return billingPeriods[0].tag;
  }
  return "";
}
function initialLicense(card) {
  var defaultLicense = card.licenses.find(function (lic) {
    return lic.default_license === "yes";
  });
  if (defaultLicense) {
    return defaultLicense;
  }
  return card.licenses[0];
}
var Buttons = function Buttons(_ref) {
  var ratePlan = _ref.ratePlan,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    fullButtonSection = _ref.fullButtonSection,
    rpPricingData = _ref.rpPricingData,
    currency = _ref.currency,
    pickedPromoCode = _ref.pickedPromoCode;
  if (fullButtonSection && (!button_1.label || !button_1.link) && button_2.link && button_2.label) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button$1, {
      settings: button_2
    }), /*#__PURE__*/React.createElement("div", {
      hidden: true,
      className: "fake-btn btn-active-dark"
    }, "fake"));
  }
  if (fullButtonSection && button_1.label && button_1.link && (!button_2.label || !button_2.link)) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button$1, {
      settings: button_1,
      productInfo: {
        productCode: rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.id,
        quantity: (rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.min_qty) || 1,
        promoCode: utils.isPromoActive(rpPricingData, ratePlan, pickedPromoCode) ? rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.code : "",
        currency: currency,
        ratePlanDetails: rpPricingData || {}
      },
      upsellEnabled: (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.disable_upsell) !== "yes"
    }), /*#__PURE__*/React.createElement("div", {
      hidden: true,
      className: "fake-btn btn-active-dark"
    }, "fake"));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, (button_1 === null || button_1 === void 0 ? void 0 : button_1.label) && (button_1 === null || button_1 === void 0 ? void 0 : button_1.link) && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1,
    productInfo: {
      productCode: rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.id,
      quantity: (rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.min_qty) || 1,
      promoCode: utils.isPromoActive(rpPricingData, ratePlan, pickedPromoCode) ? rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.code : "",
      currency: currency,
      ratePlanDetails: rpPricingData || {}
    },
    upsellEnabled: (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.disable_upsell) !== "yes"
  }), (button_2 === null || button_2 === void 0 ? void 0 : button_2.label) && (button_2 === null || button_2 === void 0 ? void 0 : button_2.link) && /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2
  }));
};
var AdditionalPricingCard = function AdditionalPricingCard(_ref2) {
  var _ratePlan$old_prices, _ratePlan$old_prices$, _license$billingPerio;
  var card = _ref2.card,
    labels = _ref2.labels,
    fullButtonSection = _ref2.fullButtonSection;
  React.useEffect(function () {
    var newLicense = initialLicense(card);
    setLicense(newLicense);
    var newBps = prepareBillingPeriods(newLicense, labels);
    setBillingPeriod(newBps.find(function (bp) {
      return bp.id === newLicense.default_period;
    }) || newBps[0]);
  }, [card]);
  var _React$useContext = React.useContext(PricingContext),
    currency = _React$useContext.currency,
    country = _React$useContext.country,
    pricingData = _React$useContext.pricingData,
    pickedPromoCode = _React$useContext.pickedPromoCode;
  var _React$useState = React.useState(initialLicense(card)),
    license = _React$useState[0],
    setLicense = _React$useState[1];
  var billingPeriods = prepareBillingPeriods(license, labels);
  var _React$useState2 = React.useState(billingPeriods.find(function (bp) {
      return bp.id === license.default_period;
    }) || billingPeriods[0]),
    billingPeriod = _React$useState2[0],
    setBillingPeriod = _React$useState2[1];
  var ratePlan = license[billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id];
  var cardRef = React.useRef(null);
  var isGlowing = shouldBeGlowing$1(card);
  var hasRibbon = shouldHaveRibbon(card);
  useInViewPort(cardRef, function () {
    return registerProductView(utils.pricingDataFor(ratePlan, pricingData) || {});
  });
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "hide") {
    return null;
  }
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "disable") {
    return /*#__PURE__*/React.createElement("p", null, "Disabled card");
  }
  var rpPricingData = utils.pricingDataFor(ratePlan, pricingData);
  var price = utils.priceForPeriod(rpPricingData, currency, ratePlan, pickedPromoCode);
  var totalOldPrice = null;
  if (price.promo) {
    var _price$oldValue;
    totalOldPrice = (_price$oldValue = price.oldValue) === null || _price$oldValue === void 0 ? void 0 : _price$oldValue.toFixed(2).toString();
  }
  var manualOldPrice = ratePlan === null || ratePlan === void 0 ? void 0 : (_ratePlan$old_prices = ratePlan.old_prices) === null || _ratePlan$old_prices === void 0 ? void 0 : (_ratePlan$old_prices$ = _ratePlan$old_prices.find(function (op) {
    return op.currency.toLowerCase() === currency;
  })) === null || _ratePlan$old_prices$ === void 0 ? void 0 : _ratePlan$old_prices$.value;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      outlineColor: isGlowing ? "" + card.outline_color : "transparent"
    },
    className: "additional-pricing-card " + (isGlowing ? "outline-border" : ""),
    ref: cardRef
  }, hasRibbon && /*#__PURE__*/React.createElement("div", {
    className: "ribbon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ribbon-container-inner"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      background: "" + card.ribbon_color
    },
    className: "ribbon"
  }, card.ribbon_text))), isGlowing && /*#__PURE__*/React.createElement("span", {
    style: {
      color: "" + card.outline_text_color,
      background: isGlowing ? "" + card.outline_color : "var(--white)"
    },
    className: "savings-text"
  }, card.outline_text), /*#__PURE__*/React.createElement("div", {
    style: {
      borderColor: isGlowing ? "" + card.outline_border_color : "transparent"
    },
    className: "" + (isGlowing ? "inner-border" : "inner-no-border")
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: card.logo,
    variant: "thumb"
  }), /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "product-name"
  }, card.title), card.description && /*#__PURE__*/React.createElement("h4", {
    className: "product-info"
  }, parseMarkdown(card.description, true))), card.card_type !== "info" && /*#__PURE__*/React.createElement("div", {
    className: "price-section"
  }, /*#__PURE__*/React.createElement("div", null, totalOldPrice || manualOldPrice ? /*#__PURE__*/React.createElement("h5", {
    className: "old-price"
  }, manualOldPrice ? Currency.symbol(currency, country) + " " + manualOldPrice : Currency.symbol(currency, country) + " " + totalOldPrice) : /*#__PURE__*/React.createElement("div", {
    className: "old-price"
  }), /*#__PURE__*/React.createElement("div", {
    className: "price-per-month"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "main-price " + (price.promo ? "promo" : "")
  }, Currency.symbol(currency, country), " ", utils.wholePart(price.value)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("h4", {
    className: "secondary-price " + (price.promo ? "promo" : "")
  }, utils.decimalPart(price.value)), /*#__PURE__*/React.createElement("span", null, ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.after_price)), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, utils.customBilledLabel(ratePlan, 1, rpPricingData, currency, country, pickedPromoCode) || utils.billingMethodStaticLabel(billingPeriod, labels, rpPricingData, currency, country, ratePlan, pickedPromoCode, 1)))), /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, card.card_type !== "info" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Dropdown, {
    skipSingle: true,
    options: billingPeriods,
    value: billingPeriod,
    onChange: setBillingPeriod
  }), /*#__PURE__*/React.createElement(Dropdown, {
    options: card.licenses.map(function (lic) {
      return {
        id: lic.license_type,
        label: lic.license_type,
        tag: tagForLicense(lic),
        tooltip: lic === null || lic === void 0 ? void 0 : lic.tooltip
      };
    }),
    value: {
      id: license.license_type,
      label: license.license_type,
      tooltip: license.tooltip,
      tag: (billingPeriods === null || billingPeriods === void 0 ? void 0 : billingPeriods.length) === 1 ? ((_license$billingPerio = license[billingPeriod.id]) === null || _license$billingPerio === void 0 ? void 0 : _license$billingPerio.tag) || "" : ""
    },
    onChange: function onChange(newOption) {
      var newLicense = card.licenses.find(function (lic) {
        return lic.license_type === newOption.id;
      });
      setLicense(newLicense);
      var newBps = prepareBillingPeriods(newLicense, labels);
      setBillingPeriod(newBps.find(function (bp) {
        return bp.id === newLicense.default_period;
      }) || newBps[0]);
    }
  })), /*#__PURE__*/React.createElement(Buttons, {
    ratePlan: ratePlan,
    button_1: card.button_1,
    button_2: card.button_2,
    fullButtonSection: fullButtonSection,
    rpPricingData: rpPricingData,
    currency: currency,
    pickedPromoCode: pickedPromoCode
  }))));
};
var ProductSwitch = function ProductSwitch(_ref) {
  var title = _ref.title,
    products = _ref.products,
    productId = _ref.productId,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "product-switcher"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "products"
  }, products.map(function (product) {
    var isActive = productId === product.id;
    return /*#__PURE__*/React.createElement("div", {
      key: product.id,
      className: "product " + (productId === product.id ? "active" : ""),
      style: {
        backgroundColor: isActive ? product.color : ""
      },
      role: "button",
      onClick: function onClick() {
        onChange(product.id);
      }
    }, product.icon && /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      src: product.icon,
      variant: "thumb"
    }), product.label);
  })));
};
var AddOnCard = function AddOnCard(_ref) {
  var logos = _ref.logos,
    description = _ref.description,
    button = _ref.button;
  if (!description && !(button !== null && button !== void 0 && button.label)) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "add-on-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icons"
  }, logos === null || logos === void 0 ? void 0 : logos.map(function (logo, idx) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      key: idx + "-" + logo.id,
      src: logo,
      variant: "thumb"
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-and-button"
  }, parseMarkdown(description), button.label && /*#__PURE__*/React.createElement(Button$1, {
    settings: button
  })));
};
var boldInfoIcon$1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTEzOTBfMjMyNDMwKSI+CjxwYXRoIGQ9Ik0zLjk5OTM1IDUuMzMyNjhWMy45OTkzNU0zLjk5OTM1IDIuNjY2MDJINC4wMDI2OE03LjMzMjY4IDMuOTk5MzVDNy4zMzI2OCA1Ljg0MDMgNS44NDAzIDcuMzMyNjggMy45OTkzNSA3LjMzMjY4QzIuMTU4NCA3LjMzMjY4IDAuNjY2MDE2IDUuODQwMyAwLjY2NjAxNiAzLjk5OTM1QzAuNjY2MDE2IDIuMTU4NCAyLjE1ODQgMC42NjYwMTYgMy45OTkzNSAwLjY2NjAxNkM1Ljg0MDMgMC42NjYwMTYgNy4zMzI2OCAyLjE1ODQgNy4zMzI2OCAzLjk5OTM1WiIgc3Ryb2tlPSIjQUJBQkI2IiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzExMzkwXzIzMjQzMCI+CjxyZWN0IHdpZHRoPSI4IiBoZWlnaHQ9IjgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
function currentLicense$1(card) {
  return card.licenses.find(function (lic) {
    return lic.default_license === "yes";
  }) || card.licenses[0];
}
function pickLicensesCount$1(licensesCount, rpPricingData) {
  var minQty = Number.parseInt((rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.qty) || "1", 10);
  if (minQty < licensesCount) {
    return licensesCount;
  }
  return minQty;
}
var DisabledCardMobile = function DisabledCardMobile(_ref) {
  var card = _ref.card;
  return /*#__PURE__*/React.createElement("div", {
    className: "bundle-card disabled"
  }, /*#__PURE__*/React.createElement("h5", null, card.title), /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-per-month"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "main-price"
  }, "N/A")), /*#__PURE__*/React.createElement(Button$1, {
    settings: _extends({}, card.button_1 || {}, {
      label: "{CART}",
      link: "#"
    }),
    className: "price-btn"
  })));
};
var BundleCardMobile = function BundleCardMobile(_ref2) {
  var _ratePlan$old_prices, _ratePlan$old_prices$, _card$button_;
  var card = _ref2.card,
    billingPeriod = _ref2.billingPeriod,
    licensesCount = _ref2.licensesCount;
  React.useEffect(function () {
    var _license$billingPerio;
    if (!(billingPeriod !== null && billingPeriod !== void 0 && billingPeriod.id)) {
      return;
    }
    if ((_license$billingPerio = license[billingPeriod.id]) !== null && _license$billingPerio !== void 0 && _license$billingPerio.rate_plan_id) {
      return;
    }
    var newDropDownLicenses = card.licenses.filter(function (lic) {
      var _lic$billingPeriod$id;
      return !!((_lic$billingPeriod$id = lic[billingPeriod.id]) !== null && _lic$billingPeriod$id !== void 0 && _lic$billingPeriod$id.rate_plan_id);
    });
    if (newDropDownLicenses.length === 0) {
      return;
    }
    var newCurrentLicense = newDropDownLicenses.find(function (nLic) {
      return nLic === license.id;
    });
    if (newCurrentLicense) {
      return;
    }
    setLicense(currentLicense$1({
      licenses: newDropDownLicenses
    }));
  }, [billingPeriod]);
  React.useEffect(function () {
    var newLicense = currentLicense$1(card);
    setLicense(newLicense);
  }, [card]);
  var _React$useContext = React.useContext(PricingContext),
    currency = _React$useContext.currency,
    country = _React$useContext.country,
    pricingData = _React$useContext.pricingData,
    pickedPromoCode = _React$useContext.pickedPromoCode;
  var _React$useState = React.useState(currentLicense$1(card)),
    license = _React$useState[0],
    setLicense = _React$useState[1];
  var ratePlan = license[billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id];
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "hide") {
    return null;
  }
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "disable") {
    return /*#__PURE__*/React.createElement(DisabledCardMobile, {
      card: card,
      license: license
    });
  }
  var rpPricingData = utils.pricingDataFor(ratePlan, pricingData);
  var localLicensesCount = pickLicensesCount$1(licensesCount, rpPricingData);
  var price = utils.priceForPeriod(rpPricingData, currency, ratePlan, pickedPromoCode);
  var totalPrice = (localLicensesCount * price.value).toFixed(2).toString();
  var totalOldPrice = null;
  if (price.promo) {
    totalOldPrice = (localLicensesCount * price.oldValue).toFixed(2).toString();
  }
  var manualOldPrice = ratePlan === null || ratePlan === void 0 ? void 0 : (_ratePlan$old_prices = ratePlan.old_prices) === null || _ratePlan$old_prices === void 0 ? void 0 : (_ratePlan$old_prices$ = _ratePlan$old_prices.find(function (op) {
    return op.currency.toLowerCase() === currency;
  })) === null || _ratePlan$old_prices$ === void 0 ? void 0 : _ratePlan$old_prices$.value;
  var totalManualOldPrice = Number.parseFloat(manualOldPrice || "0") * localLicensesCount;
  var dropDownLicenses = card.licenses.filter(function (lic) {
    var _lic$billingPeriod$id2;
    return !!((_lic$billingPeriod$id2 = lic[billingPeriod.id]) !== null && _lic$billingPeriod$id2 !== void 0 && _lic$billingPeriod$id2.rate_plan_id);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "bundle-card"
  }, /*#__PURE__*/React.createElement("h5", null, card.title), /*#__PURE__*/React.createElement(Dropdown, {
    options: dropDownLicenses.map(function (lic) {
      return {
        id: lic.license_type,
        label: lic.license_type,
        tag: "",
        tooltip: lic.tooltip
      };
    }),
    value: {
      id: license.license_type,
      label: license.license_type,
      tooltip: license.tooltip
    },
    onChange: function onChange(newValue) {
      var newLicense = card.licenses.find(function (lic) {
        return lic.license_type === newValue.id;
      });
      setLicense(newLicense);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, (totalOldPrice || manualOldPrice) && /*#__PURE__*/React.createElement("h5", {
    className: "old-price"
  }, manualOldPrice ? Currency.symbol(currency, country) + " " + totalManualOldPrice : Currency.symbol(currency, country) + " " + totalOldPrice), /*#__PURE__*/React.createElement("div", {
    className: "price-per-month"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "main-price " + (price.promo ? "promo" : "")
  }, Currency.symbol(currency, country), " ", utils.wholePart(totalPrice)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("h4", {
    className: "secondary-price " + (price.promo ? "promo" : "")
  }, utils.decimalPart(totalPrice)), /*#__PURE__*/React.createElement("span", null, ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.after_price)), (card === null || card === void 0 ? void 0 : (_card$button_ = card.button_1) === null || _card$button_ === void 0 ? void 0 : _card$button_.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: _extends({}, card === null || card === void 0 ? void 0 : card.button_1, {
      label: "{CART}"
    }),
    className: "price-btn",
    productInfo: {
      productCode: rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.id,
      quantity: localLicensesCount,
      promoCode: rpPricingData !== null && rpPricingData !== void 0 && rpPricingData.promoActive ? rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.code : "",
      currency: currency,
      ratePlanDetails: rpPricingData || {}
    },
    upsellEnabled: (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.disable_upsell) !== "yes"
  })));
};
var DisabledCardDesktop = function DisabledCardDesktop(_ref3) {
  var _card$disabled_logos;
  var card = _ref3.card,
    labels = _ref3.labels,
    license = _ref3.license;
  return /*#__PURE__*/React.createElement("div", {
    className: "bundle-card disabled"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price-per-month"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "main-price"
  }, "N/A"))), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-icons"
  }, /*#__PURE__*/React.createElement("h5", null, card.title), ((_card$disabled_logos = card.disabled_logos) === null || _card$disabled_logos === void 0 ? void 0 : _card$disabled_logos.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "icons"
  }, card.disabled_logos.map(function (logo) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      key: logo.id,
      src: logo,
      variant: "thumb"
    });
  }))), /*#__PURE__*/React.createElement(Dropdown, {
    options: [{
      id: license === null || license === void 0 ? void 0 : license.license_type,
      label: license === null || license === void 0 ? void 0 : license.license_type,
      tag: "",
      tooltip: license === null || license === void 0 ? void 0 : license.tooltip
    }]
  }), /*#__PURE__*/React.createElement(Button$1, {
    settings: _extends({}, card.button_1 || {}, {
      label: labels.main_card_disabled_button_label,
      link: "#"
    }),
    className: "price-btn"
  }));
};
var BundleCardDesktop = function BundleCardDesktop(_ref4) {
  var _ratePlan$old_prices2, _ratePlan$old_prices3, _card$logos, _card$button_2;
  var labels = _ref4.labels,
    card = _ref4.card,
    billingPeriod = _ref4.billingPeriod,
    licensesCount = _ref4.licensesCount;
  React.useEffect(function () {
    var _license$billingPerio2;
    if (!(billingPeriod !== null && billingPeriod !== void 0 && billingPeriod.id)) {
      return;
    }
    if ((_license$billingPerio2 = license[billingPeriod.id]) !== null && _license$billingPerio2 !== void 0 && _license$billingPerio2.rate_plan_id) {
      return;
    }
    var newDropDownLicenses = card.licenses.filter(function (lic) {
      var _lic$billingPeriod$id3;
      return !!((_lic$billingPeriod$id3 = lic[billingPeriod.id]) !== null && _lic$billingPeriod$id3 !== void 0 && _lic$billingPeriod$id3.rate_plan_id);
    });
    if (newDropDownLicenses.length === 0) {
      return;
    }
    var newCurrentLicense = newDropDownLicenses.find(function (nLic) {
      return nLic === license.id;
    });
    if (newCurrentLicense) {
      return;
    }
    setLicense(currentLicense$1({
      licenses: newDropDownLicenses
    }));
  }, [billingPeriod]);
  React.useEffect(function () {
    var newLicense = currentLicense$1(card);
    setLicense(newLicense);
  }, [card]);
  var _React$useContext2 = React.useContext(PricingContext),
    currency = _React$useContext2.currency,
    country = _React$useContext2.country,
    pricingData = _React$useContext2.pricingData,
    pickedPromoCode = _React$useContext2.pickedPromoCode;
  var _React$useState2 = React.useState(currentLicense$1(card)),
    license = _React$useState2[0],
    setLicense = _React$useState2[1];
  var ratePlan = license[billingPeriod === null || billingPeriod === void 0 ? void 0 : billingPeriod.id];
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "hide") {
    return null;
  }
  if (!(ratePlan !== null && ratePlan !== void 0 && ratePlan.rate_plan_id) && card.on_missing_rate_plan_id === "disable") {
    return /*#__PURE__*/React.createElement(DisabledCardDesktop, {
      card: card,
      labels: labels,
      license: license
    });
  }
  var rpPricingData = utils.pricingDataFor(ratePlan, pricingData);
  var localLicensesCount = pickLicensesCount$1(licensesCount, rpPricingData);
  var price = utils.priceForPeriod(rpPricingData, currency, ratePlan, pickedPromoCode);
  var totalPrice = (localLicensesCount * price.value).toFixed(2).toString();
  var totalOldPrice = null;
  if (price.promo) {
    totalOldPrice = (localLicensesCount * price.oldValue).toFixed(2).toString();
  }
  var manualOldPrice = ratePlan === null || ratePlan === void 0 ? void 0 : (_ratePlan$old_prices2 = ratePlan.old_prices) === null || _ratePlan$old_prices2 === void 0 ? void 0 : (_ratePlan$old_prices3 = _ratePlan$old_prices2.find(function (op) {
    return op.currency.toLowerCase() === currency;
  })) === null || _ratePlan$old_prices3 === void 0 ? void 0 : _ratePlan$old_prices3.value;
  var totalManualOldPrice = Number.parseFloat(manualOldPrice || "0") * localLicensesCount;
  var dropDownLicenses = card.licenses.filter(function (lic) {
    var _lic$billingPeriod$id4;
    return !!((_lic$billingPeriod$id4 = lic[billingPeriod.id]) !== null && _lic$billingPeriod$id4 !== void 0 && _lic$billingPeriod$id4.rate_plan_id);
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "bundle-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "price"
  }, (totalOldPrice || manualOldPrice) && /*#__PURE__*/React.createElement("div", {
    className: "old-price-tooltip"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "old-price"
  }, manualOldPrice ? Currency.symbol(currency, country) + " " + totalManualOldPrice : Currency.symbol(currency, country) + " " + totalOldPrice), ratePlan.old_prices_tooltip && /*#__PURE__*/React.createElement(Tooltip$2, _extends({
    custmInfoIcon: boldInfoIcon$1,
    small: true,
    content_above: true
  }, ratePlan.old_prices_tooltip))), /*#__PURE__*/React.createElement("div", {
    className: "price-per-month"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "main-price " + (price.promo ? "promo" : "")
  }, Currency.symbol(currency, country), " ", utils.wholePart(totalPrice)), !Currency.shouldSkipCents(currency) && /*#__PURE__*/React.createElement("h4", {
    className: "secondary-price " + (price.promo ? "promo" : "")
  }, utils.decimalPart(totalPrice)), /*#__PURE__*/React.createElement("span", null, ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.after_price))), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-icons"
  }, /*#__PURE__*/React.createElement("h5", null, card.title), ((_card$logos = card.logos) === null || _card$logos === void 0 ? void 0 : _card$logos.length) && /*#__PURE__*/React.createElement("div", {
    className: "icons"
  }, card.logos.map(function (logo) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      key: logo.id,
      src: logo,
      variant: "thumb"
    });
  }))), /*#__PURE__*/React.createElement(Dropdown, {
    options: dropDownLicenses.map(function (lic) {
      return {
        id: lic.license_type,
        label: lic.license_type,
        tag: "",
        tooltip: lic.tooltip
      };
    }),
    value: {
      id: license.license_type,
      label: license.license_type,
      tooltip: license.tooltip
    },
    onChange: function onChange(newValue) {
      var newLicense = card.licenses.find(function (lic) {
        return lic.license_type === newValue.id;
      });
      setLicense(newLicense);
    }
  }), (card === null || card === void 0 ? void 0 : (_card$button_2 = card.button_1) === null || _card$button_2 === void 0 ? void 0 : _card$button_2.label) && /*#__PURE__*/React.createElement(Button$1, {
    settings: card.button_1,
    className: "price-btn",
    productInfo: {
      productCode: rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.id,
      quantity: localLicensesCount,
      promoCode: utils.isPromoActive(rpPricingData, ratePlan, pickedPromoCode) ? rpPricingData === null || rpPricingData === void 0 ? void 0 : rpPricingData.code : "",
      currency: currency,
      ratePlanDetails: rpPricingData || {}
    },
    upsellEnabled: (ratePlan === null || ratePlan === void 0 ? void 0 : ratePlan.disable_upsell) !== "yes"
  }));
};
function calcColumnClass(collection) {
  if ((collection === null || collection === void 0 ? void 0 : collection.length) === 1) {
    return "main-col-1-3";
  }
  if ((collection === null || collection === void 0 ? void 0 : collection.length) === 2) {
    return "main-col-2-3";
  }
  return "main-col";
}
var IntegrationsMobile = function IntegrationsMobile(_ref) {
  var _integrations$os, _integrations$os2, _integrations$cads, _integrations$cads2;
  var title = _ref.title,
    description = _ref.description,
    integrations = _ref.integrations;
  return /*#__PURE__*/React.createElement("div", {
    className: "integrations"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h4", null, title), /*#__PURE__*/React.createElement("p", null, description)), /*#__PURE__*/React.createElement("div", {
    className: "icons"
  }, (_integrations$os = integrations.os) === null || _integrations$os === void 0 ? void 0 : _integrations$os.map(function (logo) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      key: "os-" + logo.id,
      src: logo,
      variant: "thumb"
    });
  }), ((_integrations$os2 = integrations.os) === null || _integrations$os2 === void 0 ? void 0 : _integrations$os2.length) > 0 && ((_integrations$cads = integrations.cads) === null || _integrations$cads === void 0 ? void 0 : _integrations$cads.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), (_integrations$cads2 = integrations.cads) === null || _integrations$cads2 === void 0 ? void 0 : _integrations$cads2.map(function (logo) {
    return /*#__PURE__*/React.createElement(Image, {
      loading: "lazy",
      key: "cad-" + logo.id,
      src: logo,
      variant: "thumb"
    });
  })));
};
var IntegrationsDesktop = function IntegrationsDesktop(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    integrations = _ref2.integrations;
  return /*#__PURE__*/React.createElement("div", {
    className: "integrations"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h4", null, title), /*#__PURE__*/React.createElement("p", null, description))), /*#__PURE__*/React.createElement("div", {
    className: calcColumnClass(integrations)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container full-height"
  }, integrations.map(function (integration, idx) {
    var _integration$os, _integration$cads;
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "icons"
    }, integration.os.map(function (logo) {
      return /*#__PURE__*/React.createElement(Image, {
        loading: "lazy",
        key: "os-" + logo.id,
        src: logo,
        variant: "thumb"
      });
    }), ((_integration$os = integration.os) === null || _integration$os === void 0 ? void 0 : _integration$os.length) > 0 && ((_integration$cads = integration.cads) === null || _integration$cads === void 0 ? void 0 : _integration$cads.length) > 0 && /*#__PURE__*/React.createElement("div", {
      className: "separator"
    }), integration.cads.map(function (logo) {
      return /*#__PURE__*/React.createElement(Image, {
        loading: "lazy",
        key: "cad-" + logo.id,
        src: logo,
        variant: "thumb"
      });
    }));
  })))));
};
var Check = function Check(_ref) {
  var ttile = _ref.ttile;
  return /*#__PURE__*/React.createElement("div", {
    className: "green-circle"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "10",
    height: "7",
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("title", null, ttile), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 0.75L3.25 6.25L0.75 3.75",
    stroke: "#FAFAFC",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var FeaturesMobile = function FeaturesMobile(_ref2) {
  var title = _ref2.title,
    features = _ref2.features;
  return /*#__PURE__*/React.createElement("div", {
    className: "features"
  }, /*#__PURE__*/React.createElement("h4", null, title), features.map(function (feature, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx + "-" + feature.id,
      className: "feature"
    }, /*#__PURE__*/React.createElement("div", {
      className: "name-and-tooltip"
    }, /*#__PURE__*/React.createElement(Tooltip$2, {
      icon: feature.tooltip.icon,
      title: feature.tooltip.title,
      description: feature.tooltip.description
    }), /*#__PURE__*/React.createElement("span", null, feature.label)), feature.ticks.map(function (tick, idx) {
      return tick.checked && /*#__PURE__*/React.createElement(Check, {
        key: idx,
        title: feature.label
      });
    }));
  }));
};
var FeaturesDesktop = function FeaturesDesktop(_ref3) {
  var title = _ref3.title,
    features = _ref3.features;
  return /*#__PURE__*/React.createElement("div", {
    className: "features"
  }, /*#__PURE__*/React.createElement("h4", null, title), features.map(function (feature, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx + "-" + feature.id,
      className: "row feature"
    }, /*#__PURE__*/React.createElement("div", {
      className: "side-col"
    }, /*#__PURE__*/React.createElement("div", {
      className: "name-and-tooltip"
    }, /*#__PURE__*/React.createElement("span", null, feature.label), /*#__PURE__*/React.createElement(Tooltip$2, {
      icon: feature.tooltip.icon,
      title: feature.tooltip.title,
      description: feature.tooltip.description
    }))), /*#__PURE__*/React.createElement("div", {
      className: calcColumnClass(feature.ticks)
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex-container"
    }, feature.ticks.map(function (tick, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx + "-" + tick.id,
        className: "tick"
      }, tick.checked && /*#__PURE__*/React.createElement(Check, {
        title: feature.label
      }));
    }))));
  }));
};
var AvailableProductsMobile = function AvailableProductsMobile(_ref) {
  var _card$comparison_link;
  var title = _ref.title,
    description = _ref.description,
    card = _ref.card;
  if (title) return /*#__PURE__*/React.createElement("div", {
    className: "integrations"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h4", null, title), /*#__PURE__*/React.createElement("p", null, description)), /*#__PURE__*/React.createElement("div", {
    className: "products"
  }, parseMarkdown((card === null || card === void 0 ? void 0 : (_card$comparison_link = card.comparison_links) === null || _card$comparison_link === void 0 ? void 0 : _card$comparison_link.available_products) || "", true)));
  return null;
};
var AvailableProductsDesktop = function AvailableProductsDesktop(_ref2) {
  var title = _ref2.title,
    description = _ref2.description,
    cards = _ref2.cards;
  if (title) return /*#__PURE__*/React.createElement("div", {
    className: "integrations"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h4", null, title), /*#__PURE__*/React.createElement("p", null, description))), /*#__PURE__*/React.createElement("div", {
    className: calcColumnClass(cards)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container full-height"
  }, cards.map(function (card, idx) {
    var _card$comparison_link2;
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "products"
    }, parseMarkdown((card === null || card === void 0 ? void 0 : (_card$comparison_link2 = card.comparison_links) === null || _card$comparison_link2 === void 0 ? void 0 : _card$comparison_link2.available_products) || "", true));
  })))));
  return null;
};
var CollapseIcon = function CollapseIcon(_ref) {
  var open = _ref.open;
  return /*#__PURE__*/React.createElement("div", {
    className: "collapse-div"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "" + (open ? "" : "rotated-right")
  }, /*#__PURE__*/React.createElement("title", null, "Collapse"), /*#__PURE__*/React.createElement("path", {
    d: "M18 15L12 9L6 15",
    stroke: "#1C1C1C",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
function buildIntegrationRow(integrations, cards) {
  var os = integrations.os || [];
  var cads = integrations.cads || [];
  var result = cards.map(function (card) {
    return {
      os: os.filter(function (o) {
        var _card$comparison_link, _card$comparison_link2;
        return (_card$comparison_link = card.comparison_links) === null || _card$comparison_link === void 0 ? void 0 : (_card$comparison_link2 = _card$comparison_link.os) === null || _card$comparison_link2 === void 0 ? void 0 : _card$comparison_link2.includes(o.id);
      }),
      cads: cads.filter(function (cad) {
        var _card$comparison_link3, _card$comparison_link4;
        return (_card$comparison_link3 = card.comparison_links) === null || _card$comparison_link3 === void 0 ? void 0 : (_card$comparison_link4 = _card$comparison_link3.cads) === null || _card$comparison_link4 === void 0 ? void 0 : _card$comparison_link4.includes(cad.id);
      })
    };
  });
  return result;
}
function buildIntegrationBox(integrations, card) {
  var os = integrations.os || [];
  var cads = integrations.cads || [];
  return {
    os: os.filter(function (o) {
      var _card$comparison_link5, _card$comparison_link6;
      return (_card$comparison_link5 = card.comparison_links) === null || _card$comparison_link5 === void 0 ? void 0 : (_card$comparison_link6 = _card$comparison_link5.os) === null || _card$comparison_link6 === void 0 ? void 0 : _card$comparison_link6.includes(o.id);
    }),
    cads: cads.filter(function (cad) {
      var _card$comparison_link7, _card$comparison_link8;
      return (_card$comparison_link7 = card.comparison_links) === null || _card$comparison_link7 === void 0 ? void 0 : (_card$comparison_link8 = _card$comparison_link7.cads) === null || _card$comparison_link8 === void 0 ? void 0 : _card$comparison_link8.includes(cad.id);
    })
  };
}
var ComparePlansPhone = function ComparePlansPhone(_ref2) {
  var open = _ref2.open,
    onToggle = _ref2.onToggle,
    title = _ref2.title,
    description = _ref2.description,
    labels = _ref2.labels,
    planSwitcher = _ref2.planSwitcher,
    product = _ref2.product;
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-plans"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collapse-and-titles"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(ev) {
      onToggle();
    }
  }, /*#__PURE__*/React.createElement(CollapseIcon, {
    open: open
  })), /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h4", null, title), /*#__PURE__*/React.createElement("p", null, description))), /*#__PURE__*/React.createElement("div", {
    className: "inner " + (open ? "non-collapsed" : "collapsed")
  }, /*#__PURE__*/React.createElement(PlanSwitcher, {
    labels: labels,
    billingPeriod: planSwitcher.currentBillingPeriod,
    billingPeriods: planSwitcher.billingPeriods,
    licenseTypeSwitcherClass: "hidden-desktop",
    licenseType: planSwitcher.licenseType,
    licenseTypes: planSwitcher.licenseTypes,
    licensesCount: planSwitcher.licensesCount,
    onLicensesCountChange: planSwitcher.onLicensesCountChange,
    onBillingPeriodChange: planSwitcher.onBillingPeriodChange,
    onLicenseTypeChange: planSwitcher.onLicenseTypeChange
  }), /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    slidesPerView: 1,
    spaceBetween: 30,
    paginationClickable: true
  }, product.cards.map(function (card, idx) {
    var _product$comparison_d, _product$comparison_d2, _product$comparison_d3, _product$comparison_d4, _product$comparison_d5, _product$comparison_d6, _product$comparison_d7, _product$comparison_d8, _product$comparison_d9, _product$comparison_d10, _product$comparison_d11;
    return /*#__PURE__*/React.createElement("div", {
      key: card.id,
      className: "swiper-slide"
    }, /*#__PURE__*/React.createElement(BundleCardMobile, {
      card: card,
      billingPeriod: planSwitcher.currentBillingPeriod,
      licensesCount: planSwitcher.licensesCount
    }), /*#__PURE__*/React.createElement("div", {
      className: "swiper-pagination"
    }), /*#__PURE__*/React.createElement(AvailableProductsMobile, {
      title: (_product$comparison_d = product.comparison_data) === null || _product$comparison_d === void 0 ? void 0 : (_product$comparison_d2 = _product$comparison_d.available_products) === null || _product$comparison_d2 === void 0 ? void 0 : _product$comparison_d2.title,
      description: (_product$comparison_d3 = product.comparison_data) === null || _product$comparison_d3 === void 0 ? void 0 : (_product$comparison_d4 = _product$comparison_d3.available_products) === null || _product$comparison_d4 === void 0 ? void 0 : _product$comparison_d4.description,
      card: card
    }), /*#__PURE__*/React.createElement(IntegrationsMobile, {
      title: (_product$comparison_d5 = product.comparison_data) === null || _product$comparison_d5 === void 0 ? void 0 : (_product$comparison_d6 = _product$comparison_d5.integrations) === null || _product$comparison_d6 === void 0 ? void 0 : _product$comparison_d6.title,
      description: (_product$comparison_d7 = product.comparison_data) === null || _product$comparison_d7 === void 0 ? void 0 : (_product$comparison_d8 = _product$comparison_d7.integrations) === null || _product$comparison_d8 === void 0 ? void 0 : _product$comparison_d8.description,
      integrations: buildIntegrationBox(((_product$comparison_d9 = product.comparison_data) === null || _product$comparison_d9 === void 0 ? void 0 : _product$comparison_d9.integrations) || {}, card)
    }), /*#__PURE__*/React.createElement("div", null, (_product$comparison_d10 = product.comparison_data) === null || _product$comparison_d10 === void 0 ? void 0 : (_product$comparison_d11 = _product$comparison_d10.sections) === null || _product$comparison_d11 === void 0 ? void 0 : _product$comparison_d11.map(function (section) {
      return /*#__PURE__*/React.createElement(FeaturesMobile, {
        key: section.id,
        title: section.title,
        features: section.rows.map(function (row) {
          var _card$comparison_link9, _card$comparison_link10;
          var cardSection = (_card$comparison_link9 = card.comparison_links) === null || _card$comparison_link9 === void 0 ? void 0 : (_card$comparison_link10 = _card$comparison_link9.sections) === null || _card$comparison_link10 === void 0 ? void 0 : _card$comparison_link10[section.id];
          var ticks = [{
            id: card.id,
            checked: cardSection === null || cardSection === void 0 ? void 0 : cardSection.includes(row.id)
          }];
          return _extends({}, row, {
            ticks: ticks
          });
        })
      });
    })), /*#__PURE__*/React.createElement("div", {
      className: "swiper-pagination"
    }));
  }))));
};
var ComparePlansDesktop = function ComparePlansDesktop(_ref3) {
  var _product$comparison_d12, _product$comparison_d13, _product$comparison_d14, _product$comparison_d15, _product$comparison_d16, _product$comparison_d17, _product$comparison_d18, _product$comparison_d19, _product$comparison_d20, _product$comparison_d21, _product$comparison_d22;
  var open = _ref3.open,
    onToggle = _ref3.onToggle,
    title = _ref3.title,
    description = _ref3.description,
    labels = _ref3.labels,
    planSwitcher = _ref3.planSwitcher,
    product = _ref3.product;
  return /*#__PURE__*/React.createElement("div", {
    className: "compare-plans"
  }, /*#__PURE__*/React.createElement("div", {
    className: "collapse-and-titles"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(ev) {
      onToggle();
    }
  }, /*#__PURE__*/React.createElement(CollapseIcon, {
    open: open
  })), /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h4", null, title), /*#__PURE__*/React.createElement("p", null, description))), /*#__PURE__*/React.createElement("div", {
    className: "inner " + (open ? "non-collapsed" : "collapsed")
  }, /*#__PURE__*/React.createElement("div", {
    className: "row sticky"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, /*#__PURE__*/React.createElement(PlanSwitcher, {
    labels: labels,
    billingPeriod: planSwitcher.currentBillingPeriod,
    billingPeriods: planSwitcher.billingPeriods,
    licenseTypeSwitcherClass: "hidden-desktop",
    licenseType: planSwitcher.licenseType,
    licenseTypes: planSwitcher.licenseTypes,
    licensesCount: planSwitcher.licensesCount,
    onLicensesCountChange: planSwitcher.onLicensesCountChange,
    onBillingPeriodChange: planSwitcher.onBillingPeriodChange,
    onLicenseTypeChange: planSwitcher.onLicenseTypeChange
  })), /*#__PURE__*/React.createElement("div", {
    className: calcColumnClass(product.cards)
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, product.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(BundleCardDesktop, {
      key: card.id,
      labels: labels,
      card: card,
      billingPeriod: planSwitcher.currentBillingPeriod,
      licensesCount: planSwitcher.licensesCount
    });
  })))), /*#__PURE__*/React.createElement(AvailableProductsDesktop, {
    title: (_product$comparison_d12 = product.comparison_data) === null || _product$comparison_d12 === void 0 ? void 0 : (_product$comparison_d13 = _product$comparison_d12.available_products) === null || _product$comparison_d13 === void 0 ? void 0 : _product$comparison_d13.title,
    description: (_product$comparison_d14 = product.comparison_data) === null || _product$comparison_d14 === void 0 ? void 0 : (_product$comparison_d15 = _product$comparison_d14.available_products) === null || _product$comparison_d15 === void 0 ? void 0 : _product$comparison_d15.description,
    cards: product.cards
  }), /*#__PURE__*/React.createElement(IntegrationsDesktop, {
    title: (_product$comparison_d16 = product.comparison_data) === null || _product$comparison_d16 === void 0 ? void 0 : (_product$comparison_d17 = _product$comparison_d16.integrations) === null || _product$comparison_d17 === void 0 ? void 0 : _product$comparison_d17.title,
    description: (_product$comparison_d18 = product.comparison_data) === null || _product$comparison_d18 === void 0 ? void 0 : (_product$comparison_d19 = _product$comparison_d18.integrations) === null || _product$comparison_d19 === void 0 ? void 0 : _product$comparison_d19.description,
    integrations: buildIntegrationRow(((_product$comparison_d20 = product.comparison_data) === null || _product$comparison_d20 === void 0 ? void 0 : _product$comparison_d20.integrations) || {}, product.cards || [])
  }), /*#__PURE__*/React.createElement("div", null, (_product$comparison_d21 = product.comparison_data) === null || _product$comparison_d21 === void 0 ? void 0 : (_product$comparison_d22 = _product$comparison_d21.sections) === null || _product$comparison_d22 === void 0 ? void 0 : _product$comparison_d22.map(function (section) {
    return /*#__PURE__*/React.createElement(FeaturesDesktop, {
      key: section.id,
      title: section.title,
      features: section.rows.map(function (row) {
        var ticks = product.cards.map(function (card) {
          var _card$comparison_link11, _card$comparison_link12;
          var cardSection = (_card$comparison_link11 = card.comparison_links) === null || _card$comparison_link11 === void 0 ? void 0 : (_card$comparison_link12 = _card$comparison_link11.sections) === null || _card$comparison_link12 === void 0 ? void 0 : _card$comparison_link12[section.id];
          return {
            id: card.id,
            checked: cardSection === null || cardSection === void 0 ? void 0 : cardSection.includes(row.id)
          };
        });
        return _extends({}, row, {
          ticks: ticks
        });
      })
    });
  }))));
};
var ComparePlans = function ComparePlans(_ref4) {
  var open = _ref4.open,
    onToggle = _ref4.onToggle,
    title = _ref4.title,
    description = _ref4.description,
    labels = _ref4.labels,
    planSwitcher = _ref4.planSwitcher,
    product = _ref4.product;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden-phone"
  }, /*#__PURE__*/React.createElement(ComparePlansDesktop, {
    open: open,
    onToggle: onToggle,
    title: title,
    description: description,
    labels: labels,
    planSwitcher: planSwitcher,
    product: product
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop"
  }, /*#__PURE__*/React.createElement(ComparePlansPhone, {
    open: open,
    onToggle: onToggle,
    title: title,
    description: description,
    labels: labels,
    planSwitcher: planSwitcher,
    product: product
  })));
};
var _excluded$g = ["tab", "licenseType"];
var BILLING_PERIOD_SORT_MAP = {
  monthly: 0,
  annual: 1,
  triennial: 2
};
function prepareBillingPeriods$1(product) {
  var _product$cards;
  var billingPeriodsSet = new Set();
  product === null || product === void 0 ? void 0 : (_product$cards = product.cards) === null || _product$cards === void 0 ? void 0 : _product$cards.forEach(function (card) {
    card.licenses.forEach(function (license) {
      if (license.annual.rate_plan_id) {
        billingPeriodsSet.add("annual");
      }
      if (license.monthly.rate_plan_id) {
        billingPeriodsSet.add("monthly");
      }
      if (license.triennial.rate_plan_id) {
        billingPeriodsSet.add("triennial");
      }
    });
  });
  var billingPeriods = Array.from(billingPeriodsSet).map(function (bp) {
    return {
      id: bp,
      tag: product[bp + "_tag"],
      "default": product.default_period === bp
    };
  }).sort(function (a, b) {
    return BILLING_PERIOD_SORT_MAP[a.id] - BILLING_PERIOD_SORT_MAP[b.id];
  });
  return billingPeriods;
}
function getInitialProduct(products) {
  return (products === null || products === void 0 ? void 0 : products.find(function (p) {
    return p.default_product === "yes";
  })) || (products === null || products === void 0 ? void 0 : products[0]);
}
function areCardsPresent(cards) {
  var _cards$filter;
  return (cards === null || cards === void 0 ? void 0 : (_cards$filter = cards.filter(function (card) {
    return card.licenses.some(function (license) {
      return !!license.monthly.rate_plan_id || !!license.annual.rate_plan_id || !!license.triennial.rate_plan_id || card.on_missing_rate_plan_id === "disable" || card.card_type === "info";
    });
  })) === null || _cards$filter === void 0 ? void 0 : _cards$filter.length) > 0;
}
function SecondaryCards(_ref) {
  var _tab$secondary_cards;
  var tab = _ref.tab,
    labels = _ref.labels,
    product = _ref.product,
    cardClass = _ref.cardClass;
  var visibleCards = (_tab$secondary_cards = tab.secondary_cards) === null || _tab$secondary_cards === void 0 ? void 0 : _tab$secondary_cards.filter(function (card) {
    return !(card.skip_products || []).find(function (sp) {
      return sp === (product === null || product === void 0 ? void 0 : product.id);
    });
  });
  if (!visibleCards) {
    return [];
  }
  var cardsHaveTwoButtons = visibleCards.filter(function (card) {
    return !!card.button_1.label && !!card.button_1.link && !!card.button_2.label && !!card.button_2.link;
  }).length > 0;
  return visibleCards.map(function (card, idx) {
    if (cardClass) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx + "-" + card.id,
        className: cardClass
      }, /*#__PURE__*/React.createElement(AdditionalPricingCard, {
        labels: labels,
        card: card,
        fullButtonSection: cardsHaveTwoButtons
      }));
    }
    return /*#__PURE__*/React.createElement(AdditionalPricingCard, {
      key: idx + "-" + card.id,
      labels: labels,
      card: card,
      fullButtonSection: cardsHaveTwoButtons
    });
  });
}
function shouldShowComparisonSection(product) {
  var _product$comparison_d;
  return ((_product$comparison_d = product.comparison_data) === null || _product$comparison_d === void 0 ? void 0 : _product$comparison_d.enabled) === "yes";
}
function goTo(element) {
  if (!element) {
    return null;
  }
  window.scrollTo({
    top: cumulativeTopOffset(element),
    left: 0,
    behavior: "smooth"
  });
}
function CommercialTab(_ref2) {
  var _getInitialProduct2, _tab$products, _tab$products2, _billingPeriods$find2, _billingPeriods$2, _tab$products3, _product$cards2, _product$cards3, _product$comparison_d2, _product$comparison_d3, _tab$small_cards, _tab$small_cards2, _tab$small_cards3;
  var tab = _ref2.tab,
    labels = _ref2.labels,
    licenseType = _ref2.licenseType,
    licenseTypes = _ref2.licenseTypes,
    showDisclaimer = _ref2.showDisclaimer,
    swiperOnMobile = _ref2.swiperOnMobile,
    onLicenseTypeChange = _ref2.onLicenseTypeChange;
  React.useEffect(function () {
    var _getInitialProduct, _billingPeriods$find, _billingPeriods$;
    setProductId((_getInitialProduct = getInitialProduct(tab.products)) === null || _getInitialProduct === void 0 ? void 0 : _getInitialProduct.id);
    var billingPeriods = prepareBillingPeriods$1(product);
    setBillingPeriodId(((_billingPeriods$find = billingPeriods.find(function (bp) {
      return bp["default"];
    })) === null || _billingPeriods$find === void 0 ? void 0 : _billingPeriods$find.id) || ((_billingPeriods$ = billingPeriods[0]) === null || _billingPeriods$ === void 0 ? void 0 : _billingPeriods$.id));
  }, [tab]);
  var comparisonRef = React.useRef(null);
  var _React$useContext = React.useContext(PricingContext),
    pricingData = _React$useContext.pricingData;
  var disclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.disclaimer;
  var additionalDisclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.additionalDisclaimer;
  var _React$useState = React.useState((_getInitialProduct2 = getInitialProduct(tab.products)) === null || _getInitialProduct2 === void 0 ? void 0 : _getInitialProduct2.id),
    productId = _React$useState[0],
    setProductId = _React$useState[1];
  var product = ((_tab$products = tab.products) === null || _tab$products === void 0 ? void 0 : _tab$products.find(function (p) {
    return p.id === productId;
  })) || ((_tab$products2 = tab.products) === null || _tab$products2 === void 0 ? void 0 : _tab$products2[0]);
  var billingPeriods = prepareBillingPeriods$1(product);
  var _React$useState2 = React.useState(1),
    licensesCount = _React$useState2[0],
    setLicensesCount = _React$useState2[1];
  var _React$useState3 = React.useState(((_billingPeriods$find2 = billingPeriods.find(function (bp) {
      return bp["default"];
    })) === null || _billingPeriods$find2 === void 0 ? void 0 : _billingPeriods$find2.id) || ((_billingPeriods$2 = billingPeriods[0]) === null || _billingPeriods$2 === void 0 ? void 0 : _billingPeriods$2.id)),
    billingPeriodId = _React$useState3[0],
    setBillingPeriodId = _React$useState3[1];
  var _React$useState4 = React.useState(false),
    comparisonOpen = _React$useState4[0],
    setComparisonOpen = _React$useState4[1];
  var currentBillingPeriod = billingPeriods.find(function (bp) {
    return bp.id === billingPeriodId;
  });
  if (!product) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pricing-light-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(TabHeader, {
    tab: {
      title: tab.title,
      sub_title: tab.sub_title,
      logo: product.logo || tab.logo
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "row flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, ((_tab$products3 = tab.products) === null || _tab$products3 === void 0 ? void 0 : _tab$products3.length) > 1 && /*#__PURE__*/React.createElement(ProductSwitch, {
    title: labels.change_product_title,
    products: tab.products || [],
    productId: productId,
    onChange: function onChange(newProductId) {
      var _billingPeriods$find3, _billingPeriods$3;
      setProductId(newProductId);
      var newProduct = tab.products.find(function (tp) {
        return tp.id === newProductId;
      });
      var billingPeriods = prepareBillingPeriods$1(newProduct);
      setBillingPeriodId(((_billingPeriods$find3 = billingPeriods.find(function (bp) {
        return bp["default"];
      })) === null || _billingPeriods$find3 === void 0 ? void 0 : _billingPeriods$find3.id) || ((_billingPeriods$3 = billingPeriods[0]) === null || _billingPeriods$3 === void 0 ? void 0 : _billingPeriods$3.id));
    }
  }), /*#__PURE__*/React.createElement(PlanSwitcher, {
    labels: labels,
    billingPeriod: currentBillingPeriod,
    billingPeriods: billingPeriods,
    licenseTypeSwitcherClass: "hidden-desktop",
    licenseType: licenseType,
    licenseTypes: licenseTypes,
    licensesCount: licensesCount,
    onLicensesCountChange: setLicensesCount,
    onBillingPeriodChange: function onBillingPeriodChange(bp) {
      return setBillingPeriodId(bp.id);
    },
    onLicenseTypeChange: onLicenseTypeChange
  }), product.description && /*#__PURE__*/React.createElement("div", {
    className: "tab-switcher-description customized-ul hidden-phone full-width"
  }, parseMarkdown(product.description))), /*#__PURE__*/React.createElement("div", {
    className: calcColumnClass(product.cards)
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-fit"
  }, ((_product$cards2 = product.cards) === null || _product$cards2 === void 0 ? void 0 : _product$cards2.length) === 1 && /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, product.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: product,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: licenseType,
      labels: labels,
      onSecondButtonClick: function onSecondButtonClick() {
        setComparisonOpen(true);
        goTo(comparisonRef.current);
      }
    });
  })), ((_product$cards3 = product.cards) === null || _product$cards3 === void 0 ? void 0 : _product$cards3.length) > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-container " + (swiperOnMobile === "yes" ? "hidden-phone" : "")
  }, product.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: product,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: licenseType,
      labels: labels,
      onSecondButtonClick: function onSecondButtonClick() {
        setComparisonOpen(true);
        goTo(comparisonRef.current);
      }
    });
  })), swiperOnMobile === "yes" && /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop"
  }, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    slidesPerView: 1,
    spaceBetween: 30,
    paginationClickable: true
  }, product.cards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id
    }, /*#__PURE__*/React.createElement(MainPricingCard, {
      product: product,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: licenseType,
      labels: labels,
      onSecondButtonClick: function onSecondButtonClick() {
        setComparisonOpen(true);
        goTo(comparisonRef.current);
      }
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm disclaimer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, disclaimer), showDisclaimer === "yes" && additionalDisclaimer && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, additionalDisclaimer)))), product.description && /*#__PURE__*/React.createElement("div", {
    className: "tab-switcher-description customized-ul hidden-desktop"
  }, parseMarkdown(product.description))))), shouldShowComparisonSection(product) && /*#__PURE__*/React.createElement("div", {
    className: "pricing-light-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container",
    ref: comparisonRef
  }, /*#__PURE__*/React.createElement(ComparePlans, {
    open: comparisonOpen,
    onToggle: function onToggle() {
      return setComparisonOpen(!comparisonOpen);
    },
    title: (_product$comparison_d2 = product.comparison_data) === null || _product$comparison_d2 === void 0 ? void 0 : _product$comparison_d2.title,
    description: (_product$comparison_d3 = product.comparison_data) === null || _product$comparison_d3 === void 0 ? void 0 : _product$comparison_d3.description,
    labels: labels,
    planSwitcher: {
      currentBillingPeriod: currentBillingPeriod,
      billingPeriods: billingPeriods,
      licenseType: licenseType,
      licenseTypes: licenseTypes,
      licensesCount: licensesCount,
      onLicensesCountChange: setLicensesCount,
      onBillingPeriodChange: function onBillingPeriodChange(bp) {
        return setBillingPeriodId(bp.id);
      },
      onLicenseTypeChange: onLicenseTypeChange
    },
    product: product
  }))), areCardsPresent(tab.secondary_cards) && /*#__PURE__*/React.createElement("div", {
    className: "pricing-dark-bg spacing-bottom-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(TabHeader, {
    tab: {
      title: tab.secondary_title
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, ((_tab$small_cards = tab.small_cards) === null || _tab$small_cards === void 0 ? void 0 : _tab$small_cards.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "main-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/React.createElement(SecondaryCards, {
    product: product,
    tab: tab,
    labels: labels
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden-phone full-width"
  }, /*#__PURE__*/React.createElement(AddOnCard, tab.add_on_card || {})))), /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-info-cards"
  }, (_tab$small_cards2 = tab.small_cards) === null || _tab$small_cards2 === void 0 ? void 0 : _tab$small_cards2.map(function (smallCard) {
    return /*#__PURE__*/React.createElement(SmallInfoCard, {
      key: smallCard.id,
      title: smallCard.title,
      description: smallCard.description,
      button: smallCard.button
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop"
  }, /*#__PURE__*/React.createElement(AddOnCard, tab.add_on_card || {})))), !((_tab$small_cards3 = tab.small_cards) !== null && _tab$small_cards3 !== void 0 && _tab$small_cards3.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "col-12 flex-container"
  }, /*#__PURE__*/React.createElement(SecondaryCards, {
    product: product,
    tab: tab,
    labels: labels
  })), /*#__PURE__*/React.createElement(AddOnCard, tab.add_on_card || {}))))));
}
function EducationalTab(_ref3) {
  var _tab$small_cards4, _tab$small_cards5, _tab$small_cards6;
  var tab = _ref3.tab,
    labels = _ref3.labels,
    licenseType = _ref3.licenseType,
    licenseTypes = _ref3.licenseTypes,
    showDisclaimer = _ref3.showDisclaimer,
    swiperOnMobile = _ref3.swiperOnMobile,
    onLicenseTypeChange = _ref3.onLicenseTypeChange;
  var _React$useContext2 = React.useContext(PricingContext),
    pricingData = _React$useContext2.pricingData;
  var disclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.disclaimer;
  var additionalDisclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.additionalDisclaimer;
  if (!tab) {
    return null;
  }
  var product = {
    cards: tab.cards,
    long_card: tab.long_card,
    secondary_title: tab.secondary_title,
    small_cards: tab.small_cards,
    secondary_cards: tab.secondary_cards,
    add_on_card: tab.add_on_card
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "pricing-light-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement(TabHeader, {
    tab: tab,
    centered: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container flex-center"
  }, /*#__PURE__*/React.createElement(LicenseTypeSwitcher, {
    labels: labels,
    licenseType: licenseType,
    licenseTypes: licenseTypes,
    onChange: onLicenseTypeChange
  }))), product.cards.length === 1 && /*#__PURE__*/React.createElement("div", {
    className: "flex-container flex-center"
  }, product.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: product,
      card: card,
      licensesCount: 1,
      licenseType: licenseType,
      labels: labels
    });
  })), product.cards.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-container flex-center " + (swiperOnMobile === "yes" ? "hidden-phone" : "")
  }, product.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: product,
      card: card,
      licensesCount: 1,
      licenseType: licenseType,
      labels: labels
    });
  })), swiperOnMobile === "yes" && /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop"
  }, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    slidesPerView: 1,
    spaceBetween: 30,
    paginationClickable: true,
    loop: true
  }, product.cards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id
    }, /*#__PURE__*/React.createElement(MainPricingCard, {
      product: product,
      card: card,
      licensesCount: 1,
      licenseType: licenseType,
      labels: labels
    }));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-12 disclaimer spacing-bottom-sm phone-spacing-top-sm tablet-spacing-top-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, disclaimer), showDisclaimer === "yes" && additionalDisclaimer && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, additionalDisclaimer))))), areCardsPresent(tab.secondary_cards) && /*#__PURE__*/React.createElement("div", {
    className: "pricing-dark-bg spacing-bottom-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(TabHeader, {
    tab: {
      title: tab.secondary_title
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, ((_tab$small_cards4 = tab.small_cards) === null || _tab$small_cards4 === void 0 ? void 0 : _tab$small_cards4.length) > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "main-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/React.createElement(SecondaryCards, {
    tab: tab,
    labels: labels
  }), /*#__PURE__*/React.createElement(AddOnCard, tab.add_on_card || {}))), /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "small-info-cards"
  }, (_tab$small_cards5 = tab.small_cards) === null || _tab$small_cards5 === void 0 ? void 0 : _tab$small_cards5.map(function (smallCard) {
    return /*#__PURE__*/React.createElement(SmallInfoCard, {
      key: smallCard.id,
      title: smallCard.title,
      description: smallCard.description,
      button: smallCard.button
    });
  })))), !((_tab$small_cards6 = tab.small_cards) !== null && _tab$small_cards6 !== void 0 && _tab$small_cards6.length) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, /*#__PURE__*/React.createElement(SecondaryCards, {
    tab: tab,
    labels: labels,
    cardClass: "col-3"
  })), /*#__PURE__*/React.createElement(AddOnCard, tab.add_on_card || {}))))));
}
function IndustryTab(_ref4) {
  var tab = _ref4.tab,
    licenseType = _ref4.licenseType,
    rest = _objectWithoutPropertiesLoose(_ref4, _excluded$g);
  if (licenseType.id === "commercial") {
    return /*#__PURE__*/React.createElement(CommercialTab, _extends({
      tab: tab.commercial,
      licenseType: licenseType
    }, rest));
  }
  if (licenseType.id === "educational") {
    return /*#__PURE__*/React.createElement(EducationalTab, _extends({
      tab: tab.educational,
      licenseType: licenseType
    }, rest));
  }
  return null;
}
var Tag$1 = function Tag(_ref) {
  var label = _ref.label,
    color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    className: "tag",
    style: {
      color: color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "background",
    style: {
      backgroundColor: color
    }
  }), label);
};
var SimpleInfoCard = function SimpleInfoCard(_ref2) {
  var logo = _ref2.logo,
    description = _ref2.description,
    button_1 = _ref2.button_1,
    button_2 = _ref2.button_2,
    tags = _ref2.tags,
    icon_tooltips = _ref2.icon_tooltips;
  return /*#__PURE__*/React.createElement("div", {
    className: "simple-info-card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, logo && /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: logo,
    variant: "thumb"
  }), /*#__PURE__*/React.createElement("div", {
    className: "icon-tooltips"
  }, (icon_tooltips === null || icon_tooltips === void 0 ? void 0 : icon_tooltips.length) > 0 && icon_tooltips.map(function (icon_tooltip) {
    return /*#__PURE__*/React.createElement(Tooltip$2, {
      key: icon_tooltip.id,
      custmInfoIcon: icon_tooltip.icon,
      title: icon_tooltip.text
    });
  }))), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description), /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, (tags === null || tags === void 0 ? void 0 : tags.length) > 0 && tags.map(function (tag) {
    return /*#__PURE__*/React.createElement(Tag$1, _extends({
      key: tag.id
    }, tag));
  })), /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/React.createElement(Button$1, {
    className: "button",
    settings: button_1
  }), /*#__PURE__*/React.createElement(Button$1, {
    className: "button",
    settings: button_2
  })));
};
var Chevron$1 = function Chevron(_ref) {
  var open = _ref.open;
  return /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "" + (open ? "" : "rotated-right")
  }, /*#__PURE__*/React.createElement("title", null, "arrow-down"), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.5L8 10.5L12 6.5",
    stroke: "#1C1C22",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var CheckboxesFilter = function CheckboxesFilter(_ref2) {
  var label = _ref2.label,
    options = _ref2.options,
    value = _ref2.value,
    _ref2$initialOpen = _ref2.initialOpen,
    initialOpen = _ref2$initialOpen === void 0 ? false : _ref2$initialOpen,
    _ref2$showQuantity = _ref2.showQuantity,
    showQuantity = _ref2$showQuantity === void 0 ? true : _ref2$showQuantity,
    _onChange = _ref2.onChange;
  var _React$useState = React.useState(initialOpen),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "all-products-filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "checkboxes-card " + (open ? "checkboxes-card-open" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-and-collapse",
    onClick: function onClick(_event) {
      setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement("h6", {
    className: "label"
  }, label), /*#__PURE__*/React.createElement(Chevron$1, {
    open: open
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      height: open ? "calc(" + options.length + " * 28px + var(--gutter))" : "0px"
    },
    className: "checkboxes " + (open ? "" : "checkboxes-hidden")
  }, options.map(function (option) {
    if (option.qty > 0) return /*#__PURE__*/React.createElement("div", {
      className: "checkbox-item",
      key: option.id
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      id: option.id,
      checked: value.includes(option.id),
      onChange: function onChange(event) {
        var target = event.target;
        if (target.checked) {
          _onChange([].concat(value, [option.id]));
        } else {
          _onChange(value.filter(function (v) {
            return v != option.id;
          }));
        }
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: option.id
    }, option.label, " ", showQuantity && option.qty > 1 && "(" + option.qty + ")"), option.tag && /*#__PURE__*/React.createElement("span", {
      className: "tag"
    }, option.tag));
  }))));
};
var _excluded$h = ["tab", "licenseType"];
function extractFilterValues(tab) {
  return {
    industries: tab.industries,
    roles: tab.roles,
    integrations: tab.integrations
  };
}
function filterCollection(items, filterIds) {
  if (filterIds.length === 0) {
    return true;
  }
  return filterIds.some(function (id) {
    return items.includes(id);
  });
}
function filterCards(cards, _ref) {
  var industries = _ref.industries,
    roles = _ref.roles,
    integrations = _ref.integrations;
  return cards.filter(function (card) {
    return filterCollection(card.industries, industries) && filterCollection(card.roles, roles) && filterCollection(card.integrations, integrations);
  });
}
function getLastFilter(_ref2) {
  var industries = _ref2.industries,
    roles = _ref2.roles,
    integrations = _ref2.integrations;
  if (integrations.length > 0) {
    return "integrations";
  }
  if (roles.length > 0) {
    return "roles";
  }
  if (industries.length > 0) {
    return "industries";
  }
  return "";
}
function countForOption(key, value, cards) {
  var count = 0;
  cards.forEach(function (card) {
    if (card[key].includes(value)) {
      count++;
    }
  });
  return count;
}
function CommercialTab$1(_ref3) {
  var tab = _ref3.tab,
    labels = _ref3.labels,
    licenseType = _ref3.licenseType,
    licenseTypes = _ref3.licenseTypes,
    onLicenseTypeChange = _ref3.onLicenseTypeChange;
  var sortOptions = [{
    slug: "relevance",
    name: tab.sort_relevance_text
  }, {
    slug: "alphabetical",
    name: tab.sort_alphabetically_text
  }];
  var _React$useState = React.useState(sortOptions[0].slug),
    sortOption = _React$useState[0],
    setSortOption = _React$useState[1];
  var _React$useState2 = React.useState([]),
    industries = _React$useState2[0],
    setIndustries = _React$useState2[1];
  var _React$useState3 = React.useState([]),
    roles = _React$useState3[0],
    setRoles = _React$useState3[1];
  var _React$useState4 = React.useState([]),
    integrations = _React$useState4[0],
    setIntegrations = _React$useState4[1];
  var filterOptions = extractFilterValues(tab);
  var filteredCards = filterCards(tab.cards, {
    industries: industries,
    roles: roles,
    integrations: integrations
  });
  var lastFilter = getLastFilter(filterOptions);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    tab: tab
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container flex-center"
  }, /*#__PURE__*/React.createElement(LicenseTypeSwitcher, {
    labels: labels,
    licenseType: licenseType,
    licenseTypes: licenseTypes,
    onChange: onLicenseTypeChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, /*#__PURE__*/React.createElement("h4", null, tab.filter_title), filterOptions.industries.length > 1 && /*#__PURE__*/React.createElement(CheckboxesFilter, {
    initialOpen: lastFilter === "industries",
    label: tab.filter_industry_label,
    options: filterOptions.industries.map(function (industry) {
      return {
        id: industry.id,
        label: industry.value,
        qty: countForOption("industries", industry.id, filteredCards)
      };
    }),
    value: industries,
    showQuantity: false,
    onChange: setIndustries
  }), filterOptions.roles.length > 1 && /*#__PURE__*/React.createElement(CheckboxesFilter, {
    initialOpen: lastFilter === "roles",
    label: tab.filter_role_label,
    options: filterOptions.roles.map(function (role) {
      return {
        id: role.id,
        label: role.value,
        qty: countForOption("roles", role.id, filteredCards)
      };
    }),
    value: roles,
    showQuantity: false,
    onChange: setRoles
  }), filterOptions.integrations.length > 1 && /*#__PURE__*/React.createElement(CheckboxesFilter, {
    initialOpen: lastFilter === "integrations",
    label: tab.filter_integration_label,
    options: filterOptions.integrations.map(function (integration) {
      return {
        id: integration.id,
        label: integration.value,
        qty: countForOption("integrations", integration.id, filteredCards)
      };
    }),
    value: integrations,
    onChange: setIntegrations
  })), /*#__PURE__*/React.createElement("div", {
    className: "main-col relative"
  }, tab.sort_title && tab.sort_relevance_text && tab.sort_alphabetically_text && /*#__PURE__*/React.createElement("div", {
    className: "all-products-sort"
  }, /*#__PURE__*/React.createElement("span", null, tab.sort_title), /*#__PURE__*/React.createElement("div", {
    "class": "select-wrapper"
  }, /*#__PURE__*/React.createElement("select", {
    defaultValue: sortOptions[0].slug,
    onChange: function onChange(ev) {
      return setSortOption(ev.target.value);
    }
  }, sortOptions.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("option", {
      key: idx,
      value: item.slug
    }, item.name);
  })), /*#__PURE__*/React.createElement("div", {
    "class": "select-arrow"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-container phone-spacing-bottom-sm"
  }, sortOption === "alphabetical" ? filteredCards.sort(function (a, b) {
    var _a$product_name;
    return a === null || a === void 0 ? void 0 : (_a$product_name = a.product_name) === null || _a$product_name === void 0 ? void 0 : _a$product_name.localeCompare(b === null || b === void 0 ? void 0 : b.product_name);
  }).map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id
    }, /*#__PURE__*/React.createElement(SimpleInfoCard, card));
  }) : filteredCards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id
    }, /*#__PURE__*/React.createElement(SimpleInfoCard, card));
  })))));
}
function EducationalTab$1(_ref4) {
  var tab = _ref4.tab,
    labels = _ref4.labels,
    licenseType = _ref4.licenseType,
    licenseTypes = _ref4.licenseTypes,
    onLicenseTypeChange = _ref4.onLicenseTypeChange;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TabHeader, {
    tab: tab
  }), /*#__PURE__*/React.createElement("div", {
    className: "hidden-desktop"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container flex-center"
  }, /*#__PURE__*/React.createElement(LicenseTypeSwitcher, {
    labels: labels,
    licenseType: licenseType,
    licenseTypes: licenseTypes,
    onChange: onLicenseTypeChange
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex-container phone-spacing-bottom-sm"
  }, tab.cards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id
    }, /*#__PURE__*/React.createElement(SimpleInfoCard, card));
  })));
}
function SummaryTab(_ref5) {
  var tab = _ref5.tab,
    licenseType = _ref5.licenseType,
    rest = _objectWithoutPropertiesLoose(_ref5, _excluded$h);
  if (licenseType.id === "commercial") {
    return /*#__PURE__*/React.createElement("div", {
      className: "pricing-light-bg desktop-spacing-bottom-sm"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement(CommercialTab$1, _extends({
      tab: tab.commercial,
      licenseType: licenseType
    }, rest))));
  }
  if (licenseType.id === "educational") {
    return /*#__PURE__*/React.createElement("div", {
      className: "pricing-light-bg desktop-spacing-bottom-sm"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement(EducationalTab$1, _extends({
      tab: tab.educational,
      licenseType: licenseType
    }, rest))));
  }
  return null;
}
function AllProductsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("title", null, "all products"), /*#__PURE__*/React.createElement("path", {
    d: "M4 2H2.66667C2.29848 2 2 2.29848 2 2.66667V4C2 4.36819 2.29848 4.66667 2.66667 4.66667H4C4.36819 4.66667 4.66667 4.36819 4.66667 4V2.66667C4.66667 2.29848 4.36819 2 4 2Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6.66667H2.66667C2.29848 6.66667 2 6.96514 2 7.33333V8.66667C2 9.03486 2.29848 9.33333 2.66667 9.33333H4C4.36819 9.33333 4.66667 9.03486 4.66667 8.66667V7.33333C4.66667 6.96514 4.36819 6.66667 4 6.66667Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 2H7.33333C6.96514 2 6.66667 2.29848 6.66667 2.66667V4C6.66667 4.36819 6.96514 4.66667 7.33333 4.66667H8.66667C9.03486 4.66667 9.33333 4.36819 9.33333 4V2.66667C9.33333 2.29848 9.03486 2 8.66667 2Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 6.66667H7.33333C6.96514 6.66667 6.66667 6.96514 6.66667 7.33333V8.66667C6.66667 9.03486 6.96514 9.33333 7.33333 9.33333H8.66667C9.03486 9.33333 9.33333 9.03486 9.33333 8.66667V7.33333C9.33333 6.96514 9.03486 6.66667 8.66667 6.66667Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2H12C11.6318 2 11.3333 2.29848 11.3333 2.66667V4C11.3333 4.36819 11.6318 4.66667 12 4.66667H13.3333C13.7015 4.66667 14 4.36819 14 4V2.66667C14 2.29848 13.7015 2 13.3333 2Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.66667H12C11.6318 6.66667 11.3333 6.96514 11.3333 7.33333V8.66667C11.3333 9.03486 11.6318 9.33333 12 9.33333H13.3333C13.7015 9.33333 14 9.03486 14 8.66667V7.33333C14 6.96514 13.7015 6.66667 13.3333 6.66667Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 11.3333H2.66667C2.29848 11.3333 2 11.6318 2 12V13.3333C2 13.7015 2.29848 14 2.66667 14H4C4.36819 14 4.66667 13.7015 4.66667 13.3333V12C4.66667 11.6318 4.36819 11.3333 4 11.3333Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 11.3333H7.33333C6.96514 11.3333 6.66667 11.6318 6.66667 12V13.3333C6.66667 13.7015 6.96514 14 7.33333 14H8.66667C9.03486 14 9.33333 13.7015 9.33333 13.3333V12C9.33333 11.6318 9.03486 11.3333 8.66667 11.3333Z",
    stroke: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 11.3333H12C11.6318 11.3333 11.3333 11.6318 11.3333 12V13.3333C11.3333 13.7015 11.6318 14 12 14H13.3333C13.7015 14 14 13.7015 14 13.3333V12C14 11.6318 13.7015 11.3333 13.3333 11.3333Z",
    stroke: "currentColor"
  }));
}
var TabSwitcher = function TabSwitcher(_ref) {
  var labels = _ref.labels,
    tabs = _ref.tabs,
    summaryTab = _ref.summaryTab,
    summaryTabSet = _ref.summaryTabSet,
    currentTabId = _ref.currentTabId,
    currentLicenseType = _ref.currentLicenseType,
    licenseTypes = _ref.licenseTypes,
    scrollTarget = _ref.scrollTarget,
    onLicenseTypeChange = _ref.onLicenseTypeChange,
    onTabChange = _ref.onTabChange,
    onSummaryTabChange = _ref.onSummaryTabChange;
  var scrollToTop = function scrollToTop() {
    if (scrollTarget.current) {
      window.scrollTo({
        top: cumulativeTopOffset(scrollTarget.current),
        left: 0,
        behavior: "smooth"
      });
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "tab-switcher-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab-switcher"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tab " + (currentTabId === tab.id ? "active" : ""),
      key: tab.id,
      role: "button",
      onClick: function onClick() {
        onTabChange(tab.id);
        scrollToTop();
      }
    }, tab.label);
  }), /*#__PURE__*/React.createElement("div", {
    className: "separator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "tab last-tab " + (summaryTabSet ? "active" : ""),
    key: "summary-tab",
    role: "button",
    onClick: function onClick() {
      onSummaryTabChange();
      scrollToTop();
    }
  }, /*#__PURE__*/React.createElement(AllProductsIcon, null), summaryTab.label)), /*#__PURE__*/React.createElement("div", {
    className: "licenses hidden-phone"
  }, /*#__PURE__*/React.createElement("span", null, labels.license_type_switcher), /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, licenseTypes.map(function (lt) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tab " + (currentLicenseType.id === lt.id ? "active" : ""),
      key: lt.id,
      role: "button",
      onClick: function onClick() {
        onLicenseTypeChange(lt);
        scrollToTop();
      }
    }, lt.label);
  })), /*#__PURE__*/React.createElement(Tooltip$2, labels.license_type_switcher_tooltip)))));
};
function collectRpiFromCard(card, rpis, promoCode) {
  var _card$licenses;
  card === null || card === void 0 ? void 0 : (_card$licenses = card.licenses) === null || _card$licenses === void 0 ? void 0 : _card$licenses.forEach(function (license) {
    var _license$monthly, _license$annual, _license$triennial;
    if ((_license$monthly = license.monthly) !== null && _license$monthly !== void 0 && _license$monthly.rate_plan_id) {
      var val = rpis.get(license.monthly.rate_plan_id);
      rpis.set(license.monthly.rate_plan_id, {
        id: license.monthly.rate_plan_id,
        promoCode: license.monthly.promo_code || promoCode || (val === null || val === void 0 ? void 0 : val.promoCode) || ""
      });
    }
    if ((_license$annual = license.annual) !== null && _license$annual !== void 0 && _license$annual.rate_plan_id) {
      var _val = rpis.get(license.annual.rate_plan_id);
      rpis.set(license.annual.rate_plan_id, {
        id: license.annual.rate_plan_id,
        promoCode: license.annual.promo_code || promoCode || (_val === null || _val === void 0 ? void 0 : _val.promoCode) || ""
      });
    }
    if ((_license$triennial = license.triennial) !== null && _license$triennial !== void 0 && _license$triennial.rate_plan_id) {
      var _val2 = rpis.get(license.triennial.rate_plan_id);
      rpis.set(license.triennial.rate_plan_id, {
        id: license.triennial.rate_plan_id,
        promoCode: license.triennial.promo_code || promoCode || (_val2 === null || _val2 === void 0 ? void 0 : _val2.promoCode) || ""
      });
    }
  });
}
function collectRatePlanIds(tabs, promoCode) {
  var rpis = new Map();
  tabs.forEach(function (tab) {
    var _tab$commercial, _tab$commercial$produ, _tab$commercial2, _tab$commercial2$seco, _tab$educational, _tab$educational$card, _tab$educational2, _tab$educational2$sec;
    (_tab$commercial = tab.commercial) === null || _tab$commercial === void 0 ? void 0 : (_tab$commercial$produ = _tab$commercial.products) === null || _tab$commercial$produ === void 0 ? void 0 : _tab$commercial$produ.forEach(function (product) {
      var _product$cards;
      (_product$cards = product.cards) === null || _product$cards === void 0 ? void 0 : _product$cards.forEach(function (card) {
        collectRpiFromCard(card, rpis, promoCode);
      });
    });
    (_tab$commercial2 = tab.commercial) === null || _tab$commercial2 === void 0 ? void 0 : (_tab$commercial2$seco = _tab$commercial2.secondary_cards) === null || _tab$commercial2$seco === void 0 ? void 0 : _tab$commercial2$seco.forEach(function (card) {
      collectRpiFromCard(card, rpis, promoCode);
    });
    (_tab$educational = tab.educational) === null || _tab$educational === void 0 ? void 0 : (_tab$educational$card = _tab$educational.cards) === null || _tab$educational$card === void 0 ? void 0 : _tab$educational$card.forEach(function (card) {
      collectRpiFromCard(card, rpis, promoCode);
    });
    (_tab$educational2 = tab.educational) === null || _tab$educational2 === void 0 ? void 0 : (_tab$educational2$sec = _tab$educational2.secondary_cards) === null || _tab$educational2$sec === void 0 ? void 0 : _tab$educational2$sec.forEach(function (card) {
      collectRpiFromCard(card, rpis, promoCode);
    });
  });
  var result = [];
  rpis.forEach(function (value, _key, _map) {
    result.push(value);
  });
  return result;
}
var PAGE_SIZE = 45;
var useGraphQL$3 = function useGraphQL(rpis) {
  if (rpis.length === 0) {
    return {};
  }
  var query = PRICING;
  var variables = {
    input: {
      rpi: rpis
    }
  };
  if (rpis.length > PAGE_SIZE) {
    query = DOUBLE_PRICING;
    variables = {
      input1: {
        rpi: rpis.slice(0, PAGE_SIZE)
      },
      input2: {
        rpi: rpis.slice(PAGE_SIZE)
      }
    };
  }
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache"
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  if (rpis.length > PAGE_SIZE) {
    return {
      pricing: {
        disclaimer: data.page1.disclaimer,
        additionalDisclaimer: data.page1.additionalDisclaimer,
        list: [].concat(data.page1.list, data.page2.list)
      }
    };
  }
  return data;
};
var usePricingData = function usePricingData(pickedPromoCode, tabs) {
  var data = useGraphQL$3(collectRatePlanIds(tabs, pickedPromoCode));
  var _React$useState = React.useState(""),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  var _React$useState2 = React.useState(""),
    country = _React$useState2[0],
    setCountry = _React$useState2[1];
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrency);
  useLocalizationCountry("", setCountry);
  return {
    data: data,
    currency: currency,
    country: country
  };
};
var MainCard = function MainCard() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "330px",
      height: "540px"
    }
  });
};
var TabSwitcher$1 = function TabSwitcher() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: "40px",
      marginBottom: "var(--gutter)"
    }
  });
};
var TabHeader$1 = function TabHeader() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "40%",
      height: "65px",
      marginBottom: "var(--gutter)"
    }
  });
};
var Disclaimer = function Disclaimer() {
  return /*#__PURE__*/React.createElement(TextBlock, {
    rows: 2,
    color: colors.lightBlue,
    style: {
      width: "25%",
      marginBottom: "var(--gutter)"
    }
  });
};
var SecondaryCard = function SecondaryCard() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "330px",
      height: "465px"
    }
  });
};
var SmallCard = function SmallCard() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "330px",
      height: "178px"
    }
  });
};
var AddOnCard$1 = function AddOnCard() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "100%",
      height: "126px"
    }
  });
};
var Placeholder$2 = function Placeholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "show-loading-animation spacing-both-xs"
  }, /*#__PURE__*/React.createElement(TabSwitcher$1, null), /*#__PURE__*/React.createElement(TabHeader$1, null), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Disclaimer, null)))), /*#__PURE__*/React.createElement(TabHeader$1, null), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(SecondaryCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(SecondaryCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(SecondaryCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom-xs"
  }, /*#__PURE__*/React.createElement(SmallCard, null)), /*#__PURE__*/React.createElement(SmallCard, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-9"
  }, /*#__PURE__*/React.createElement(AddOnCard$1, null))));
};
function prepareLicenseTypes(labels) {
  return ["commercial", "educational"].map(function (lt) {
    return {
      id: lt,
      label: labels["license_type_switcher_" + lt]
    };
  });
}
function findHash() {
  if (typeof window !== "undefined") {
    return window.location.hash && window.location.hash.substring(1);
  }
  return null;
}
function initialTab(tabs, summaryTab) {
  var hash = findHash();
  if (!hash) {
    return tabs[0];
  }
  var firstTab = tabs.find(function (tab) {
    return tab.commercial.html_id === hash || tab.educational.html_id === hash;
  });
  if (!firstTab && summaryTab.commercial.html_id !== hash && summaryTab.educational.html_id !== hash) {
    return tabs[0];
  }
  return firstTab;
}
function initialLicenseType(industryTabs, summaryTab) {
  var hash = findHash();
  if (!hash) {
    return "commercial";
  }
  if (summaryTab.commercial.html_id === hash || industryTabs.find(function (tab) {
    return tab.commercial.html_id === hash;
  })) {
    return "commercial";
  }
  if (summaryTab.educational.html_id === hash || industryTabs.find(function (tab) {
    return tab.educational.html_id === hash;
  })) {
    return "educational";
  }
  return "commercial";
}
function initialSummary(tab) {
  var hash = findHash();
  if (!hash) {
    return false;
  }
  if (tab.commercial.html_id === hash || tab.educational.html_id === hash) {
    return true;
  }
  return false;
}
var Content$7 = function Content(_ref) {
  var _initialTab2;
  var labels = _ref.labels,
    industry_tabs = _ref.industry_tabs,
    summary_tab = _ref.summary_tab,
    show_disclaimer = _ref.show_disclaimer,
    swiper_on_mobile = _ref.swiper_on_mobile,
    containerSettings = _ref.containerSettings,
    pricingData = _ref.pricingData;
  React.useEffect(function () {
    var _initialTab;
    setTabId((_initialTab = initialTab(industry_tabs, summary_tab)) === null || _initialTab === void 0 ? void 0 : _initialTab.id);
    setLicenseTypeId(initialLicenseType(industry_tabs, summary_tab));
    setSummary(initialSummary(summary_tab));
  }, [industry_tabs, summary_tab, labels]);
  var licenseTypes = prepareLicenseTypes(labels);
  var _React$useState = React.useState((_initialTab2 = initialTab(industry_tabs, summary_tab)) === null || _initialTab2 === void 0 ? void 0 : _initialTab2.id),
    tabId = _React$useState[0],
    setTabId = _React$useState[1];
  var _React$useState2 = React.useState(initialLicenseType(industry_tabs, summary_tab)),
    licenseTypeId = _React$useState2[0],
    setLicenseTypeId = _React$useState2[1];
  var _React$useState3 = React.useState(initialSummary(summary_tab)),
    summary = _React$useState3[0],
    setSummary = _React$useState3[1];
  var wrapperRef = /*#__PURE__*/React.createRef();
  var currentTab = industry_tabs.find(function (tab) {
    return tab.id === tabId;
  });
  var currentLicenseType = licenseTypes.find(function (lt) {
    return lt.id === licenseTypeId;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "new-pricing",
    ref: wrapperRef
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings, {
      theme: "none"
    })
  }, /*#__PURE__*/React.createElement(TabSwitcher, {
    labels: labels,
    tabs: industry_tabs,
    summaryTab: summary_tab,
    summaryTabSet: summary,
    scrollTarget: wrapperRef,
    currentTabId: tabId,
    currentLicenseType: currentLicenseType,
    licenseTypes: licenseTypes,
    onTabChange: function onTabChange(tabId) {
      setTabId(tabId);
      setSummary(false);
    },
    onLicenseTypeChange: function onLicenseTypeChange(lt) {
      return setLicenseTypeId(lt.id);
    },
    onSummaryTabChange: function onSummaryTabChange() {
      setTabId(null);
      setSummary(true);
    }
  }), currentTab && /*#__PURE__*/React.createElement(IndustryTab, {
    labels: labels,
    tab: currentTab,
    licenseType: currentLicenseType,
    licenseTypes: licenseTypes,
    showDisclaimer: show_disclaimer,
    swiperOnMobile: swiper_on_mobile,
    onLicenseTypeChange: function onLicenseTypeChange(lt) {
      return setLicenseTypeId(lt.id);
    }
  }), summary && /*#__PURE__*/React.createElement(SummaryTab, {
    pricingData: pricingData,
    licenseType: currentLicenseType,
    licenseTypes: licenseTypes,
    labels: labels,
    tab: summary_tab,
    onLicenseTypeChange: function onLicenseTypeChange(lt) {
      return setLicenseTypeId(lt.id);
    }
  })));
};
var Widget$1q = function Widget(props) {
  var industry_tabs = props.industry_tabs,
    promo_code = props.promo_code,
    summary_tab = props.summary_tab;
  var pickedPromoCode = extractPromoCode(React.useContext(PageUrlContext), promo_code);
  var _usePricingData = usePricingData(pickedPromoCode, industry_tabs),
    data = _usePricingData.data,
    currency = _usePricingData.currency,
    country = _usePricingData.country;
  if (!data) {
    var _summary_tab$commerci, _summary_tab$commerci2, _summary_tab$educatio, _summary_tab$educatio2;
    return /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, industry_tabs.map(function (tab) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: tab.id
      }, tab.commercial.html_id && /*#__PURE__*/React.createElement("div", {
        id: tab.commercial.html_id
      }), tab.educational.html_id && /*#__PURE__*/React.createElement("div", {
        id: tab.educational.html_id
      }));
    }), (summary_tab === null || summary_tab === void 0 ? void 0 : (_summary_tab$commerci = summary_tab.commercial) === null || _summary_tab$commerci === void 0 ? void 0 : _summary_tab$commerci.html_id) && /*#__PURE__*/React.createElement("div", {
      id: summary_tab === null || summary_tab === void 0 ? void 0 : (_summary_tab$commerci2 = summary_tab.commercial) === null || _summary_tab$commerci2 === void 0 ? void 0 : _summary_tab$commerci2.html_id
    }), (summary_tab === null || summary_tab === void 0 ? void 0 : (_summary_tab$educatio = summary_tab.educational) === null || _summary_tab$educatio === void 0 ? void 0 : _summary_tab$educatio.html_id) && /*#__PURE__*/React.createElement("div", {
      id: summary_tab === null || summary_tab === void 0 ? void 0 : (_summary_tab$educatio2 = summary_tab.educational) === null || _summary_tab$educatio2 === void 0 ? void 0 : _summary_tab$educatio2.html_id
    }), /*#__PURE__*/React.createElement(Placeholder$2, null));
  }
  return /*#__PURE__*/React.createElement(PricingContext.Provider, {
    value: {
      currency: currency,
      country: country,
      pickedPromoCode: pickedPromoCode,
      pricingData: data.pricing || {}
    }
  }, /*#__PURE__*/React.createElement(Content$7, props));
};
var PricingWidget = {
  __proto__: null,
  Widget: Widget$1q,
  Admin: Admin$1p,
  Config: Config$1q,
  Defaults: Defaults$1q
};
var Widget$1r = function Widget(_ref) {
  var title = _ref.title,
    image = _ref.image,
    _ref$image_size = _ref.image_size,
    image_size = _ref$image_size === void 0 ? "original" : _ref$image_size,
    containerSettings = _ref.containerSettings;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "simple-hero"
  }, /*#__PURE__*/React.createElement(Img, {
    className: "background-img",
    src: image,
    variant: image_size
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "title"
  }, title))));
};
var Config$1r = {
  title: "Simple Hero",
  category: "Image + Text"
};
var Defaults$1r = {
  title: "Create anything imaginable with Chaos",
  image: imagePlaceholder("1920x600"),
  image_size: "full_width_original",
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$1q = {
  title: {
    type: "text"
  },
  image: {
    type: "custom",
    component: ImagePicker
  },
  image_size: {
    type: "select",
    options: [["full_width_original", "Full-width"], ["original", "Original"]]
  }
};
var SimpleHeroWidget = {
  __proto__: null,
  Widget: Widget$1r,
  Admin: Admin$1q,
  Config: Config$1r,
  Defaults: Defaults$1r
};
var LOCALES_MAPPING = {
  en: "en-gb",
  de: "de-de",
  fr: "fr-fr",
  it: "it-it",
  "pt-br": "pt-br",
  es: "es-es",
  jp: "ja-jp",
  kr: "ko-kr"
};
function LocalDateFormatter(date, locale) {
  var pickedDate = new Date(date);
  var formattedDate = pickedDate.toLocaleDateString(LOCALES_MAPPING[locale] || "en-gb", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
  return formattedDate;
}
function LocalTimeFormatter(time, locale) {
  var pickedTime = new Date(time);
  var formattedTime = pickedTime.toLocaleTimeString(LOCALES_MAPPING[locale] || "en-gb", {
    hour: "numeric",
    minute: "numeric",
    timeZoneName: "short"
  });
  return formattedTime;
}
var _excluded$i = ["heading", "children"];
var Heading$2 = function Heading(_ref) {
  var heading = _ref.heading,
    children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  var MAPPING = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6"
  };
  var Component = MAPPING[heading] || "h3";
  return /*#__PURE__*/React.createElement(Component, rest, children);
};
var BlogArticleCard = function BlogArticleCard(_ref) {
  var _card$title, _card$title2, _card$author, _card$author2, _card$author3;
  var locale = _ref.locale,
    card = _ref.card;
  return /*#__PURE__*/React.createElement("div", {
    className: "article-card white blog-article"
  }, card.image && /*#__PURE__*/React.createElement("div", {
    className: "image-wrapper"
  }, /*#__PURE__*/React.createElement(Link$6, {
    settings: card.link
  }, /*#__PURE__*/React.createElement(Image, {
    src: card.image,
    variant: "image",
    className: "image"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "date body-s"
  }, LocalDateFormatter(card.date, locale))), /*#__PURE__*/React.createElement(Heading$2, {
    heading: (_card$title = card.title) === null || _card$title === void 0 ? void 0 : _card$title.heading,
    className: "title heading-4"
  }, /*#__PURE__*/React.createElement(Link$6, {
    settings: card.link
  }, (_card$title2 = card.title) === null || _card$title2 === void 0 ? void 0 : _card$title2.text)), /*#__PURE__*/React.createElement("div", {
    className: "author-wrapper body-s"
  }, ((_card$author = card.author) === null || _card$author === void 0 ? void 0 : _card$author.avatar) && /*#__PURE__*/React.createElement(Image, {
    src: (_card$author2 = card.author) === null || _card$author2 === void 0 ? void 0 : _card$author2.avatar,
    variant: "square",
    className: "avatar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "name"
  }, (_card$author3 = card.author) === null || _card$author3 === void 0 ? void 0 : _card$author3.name))), /*#__PURE__*/React.createElement(Link$6, {
    settings: card.link,
    className: "btn-text btn-text-theme"
  })));
};
var SuccessStoryCard = function SuccessStoryCard(_ref) {
  var card = _ref.card;
  return /*#__PURE__*/React.createElement("div", {
    className: "article-card white success-story"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-wrapper"
  }, card.image && /*#__PURE__*/React.createElement(Image, {
    src: card.image,
    variant: "image",
    className: "image"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "company-location body-s"
  }, /*#__PURE__*/React.createElement("span", {
    className: "company"
  }, card.company), card.location && /*#__PURE__*/React.createElement("span", {
    className: "location"
  }, card.location)), /*#__PURE__*/React.createElement(Heading$2, {
    heading: card.title.heading,
    className: "title heading-4"
  }, card.title.text)), /*#__PURE__*/React.createElement(Link$6, {
    settings: card.link,
    className: "btn-text btn-text-theme"
  })));
};
var WebinarCard = function WebinarCard(_ref) {
  var _card$author;
  var locale = _ref.locale,
    card = _ref.card;
  var now = new Date().getTime();
  var webinarDate = new Date(card.date).getTime();
  var checkIfPassed = webinarDate > now ? "upcoming" : "passed";
  return /*#__PURE__*/React.createElement("div", {
    className: "article-card white webinar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "image-wrapper"
  }, card.image && /*#__PURE__*/React.createElement(Image, {
    src: card.image,
    variant: "image",
    className: "image"
  }), card.overlay_logo && /*#__PURE__*/React.createElement(Image, {
    src: card.overlay_logo,
    variant: "image",
    className: "overlay-logo"
  })), /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "date-wrapper body-s " + checkIfPassed
  }, /*#__PURE__*/React.createElement("span", {
    className: "date"
  }, LocalDateFormatter(card.date, locale)), /*#__PURE__*/React.createElement("span", {
    className: "time"
  }, LocalTimeFormatter(card.date, locale))), /*#__PURE__*/React.createElement(Heading$2, {
    heading: card.title.heading,
    className: "title heading-4"
  }, card.title.text), /*#__PURE__*/React.createElement("div", {
    className: "description body-m text-secondary",
    dangerouslySetInnerHTML: {
      __html: parseMarkdown(card.description, true)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "author-wrapper body-s"
  }, ((_card$author = card.author) === null || _card$author === void 0 ? void 0 : _card$author.avatar) && /*#__PURE__*/React.createElement(Image, {
    src: card.author.avatar,
    variant: "square",
    className: "avatar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "name"
  }, card.author.name))), /*#__PURE__*/React.createElement(Link$6, {
    settings: card.link,
    className: "btn-text btn-text-theme"
  })));
};
var Card$6 = function Card(_ref) {
  var locale = _ref.locale,
    utm_source = _ref.utm_source,
    author = _ref.author,
    date = _ref.date,
    title = _ref.title,
    link = _ref.link,
    thumb = _ref.thumb,
    avatar = _ref.avatar,
    post_type = _ref.post_type;
  var CARD_MAPPING = {
    webinar: WebinarCard,
    success_story: SuccessStoryCard,
    blog: BlogArticleCard
  };
  var CardComponent = CARD_MAPPING[post_type];
  return /*#__PURE__*/React.createElement(CardComponent, {
    locale: locale,
    card: {
      link: {
        link: "" + link + (utm_source && "?utm_source=" + utm_source),
        label: "Read more"
      },
      image: thumb && decodeURI(thumb) || imagePlaceholder("350x200"),
      date: date,
      title: {
        heading: "h4",
        text: title
      },
      author: {
        avatar: avatar && decodeURI(avatar) || imagePlaceholder("50"),
        name: author
      },
      company: ""
    }
  });
};
var BlogFeed = function BlogFeed(_ref2) {
  var feed = _ref2.feed,
    locale = _ref2.locale,
    utm_source = _ref2.utm_source;
  return /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, feed.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "col-4"
    }, /*#__PURE__*/React.createElement(Card$6, _extends({}, item, {
      locale: locale,
      utm_source: utm_source
    })));
  }));
};
var fetchFeed = function fetchFeed(api_domain, _ref) {
  var blogIds = _ref.blogIds,
    customPosts = _ref.customPosts,
    limit = _ref.limit;
  try {
    var searchParams = new URLSearchParams("blog_ids=" + blogIds + "&custom_post_ids=" + customPosts + "&limit=" + limit);
    return Promise.resolve(fetch(api_domain + "/api/hubspot/feed?" + searchParams, {
      method: "GET"
    })).then(function (res) {
      return Promise.resolve(res.json());
    });
  } catch (e) {
    return Promise.reject(e);
  }
};
var Config$1s = {
  title: "Hubspot (feed)",
  category: "HubSpot"
};
var HubspotPostInput = function HubspotPostInput(_ref) {
  var apiDomain = _ref.apiDomain,
    label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  React.useEffect(function () {
    var fetchData = function fetchData() {
      try {
        if (!(value !== null && value !== void 0 && value.post_url)) return Promise.resolve();
        return Promise.resolve(fetch(apiDomain + "/api/hubspot/search?post_url=" + value.post_url, {
          method: "GET"
        })).then(function (res) {
          return Promise.resolve(res.json()).then(function (data) {
            _onChange(_extends({}, value, {
              post_id: (data === null || data === void 0 ? void 0 : data.hubspotPostId) || ""
            }));
          });
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    fetchData();
  }, [value.post_url]);
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(TextInput, {
    label: "post_url",
    value: value.post_url,
    onChange: function onChange(post_url) {
      return _onChange(_extends({}, value, {
        post_url: post_url
      }));
    }
  }));
};
HubspotPostInput.defaults = {
  post_url: "",
  post_id: ""
};
var ListItem$v = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  var _React$useContext = React.useContext(HubSpotContext),
    api_domain = _React$useContext.api_domain;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(HubspotPostInput, {
    apiDomain: api_domain,
    label: "Post",
    onChange: function onChange(value) {
      return onChangeItem("post", value);
    },
    value: settings.post
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Sort",
    onChange: function onChange(value) {
      return onChangeItem("sort", value);
    },
    value: settings.sort
  }));
};
var PostsSelectionInput = function PostsSelectionInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$v, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$o,
    primaryField: "post.post_url",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$o = {
  post: HubspotPostInput.defaults,
  sort: "1"
};
PostsSelectionInput.defaults = [];
var _CONTENT_GROUP_MAPPIN;
var ENSCAPE_BLOG = "26666518864";
var ENSCAPE_BLOG_SUCCESS_STORY = "37891582723";
var ENSCAPE_BLOG_WEBINAR = "71604288556";
var CONTENT_GROUP_MAPPING = (_CONTENT_GROUP_MAPPIN = {}, _CONTENT_GROUP_MAPPIN[ENSCAPE_BLOG] = "blog", _CONTENT_GROUP_MAPPIN[ENSCAPE_BLOG_SUCCESS_STORY] = "success_story", _CONTENT_GROUP_MAPPIN[ENSCAPE_BLOG_WEBINAR] = "webinar", _CONTENT_GROUP_MAPPIN);
var CHECKBOX_MAPPING = [[ENSCAPE_BLOG, "Blog"], [ENSCAPE_BLOG_SUCCESS_STORY, "Success Story"], [ENSCAPE_BLOG_WEBINAR, "Webinar"]];
var CheckboxMenu = function CheckboxMenu(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange;
  var _React$useState = React.useState(value),
    blogs = _React$useState[0],
    setBlogs = _React$useState[1];
  var ifChecked = function ifChecked(a, b) {
    if (a.includes(b)) return true;
    return false;
  };
  function updateValues(types) {
    setBlogs(types);
    onChange(types);
  }
  var handleChange = function handleChange(type) {
    if (blogs.includes(type)) {
      var filteredTypes = blogs.filter(function (item) {
        return item !== type;
      });
      updateValues(filteredTypes);
    } else {
      updateValues([].concat(blogs, [type]));
    }
  };
  return /*#__PURE__*/React.createElement(FormGroup$1, null, /*#__PURE__*/React.createElement(Label$2, null, label), CHECKBOX_MAPPING.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "checkbox"
    }, /*#__PURE__*/React.createElement(Label$2, {
      htmlFor: item[1],
      style: {
        display: "flex",
        gap: "0.5rem",
        fontSize: "0.8rem"
      }
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "form-control",
      id: item[1],
      value: item[0],
      checked: ifChecked(blogs, item[0]),
      onChange: function onChange() {
        return handleChange(item[0]);
      }
    }), item[1]));
  }));
};
var HubspotFeedFilterInput = function HubspotFeedFilterInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    _onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(TextInput, {
    label: "Limit",
    value: value.limit,
    onChange: function onChange(limit) {
      return _onChange(_extends({}, value, {
        limit: limit
      }));
    }
  }), /*#__PURE__*/React.createElement(CheckboxMenu, {
    label: "Blogs",
    value: value.blogs,
    onChange: function onChange(blogs) {
      return _onChange(_extends({}, value, {
        blogs: blogs
      }));
    }
  }), /*#__PURE__*/React.createElement(PostsSelectionInput, {
    label: "Custom Posts",
    value: value.custom_posts,
    onChange: function onChange(custom_posts) {
      return _onChange(_extends({}, value, {
        custom_posts: custom_posts
      }));
    }
  }));
};
HubspotFeedFilterInput.defaults = {
  limit: "3",
  blogs: [ENSCAPE_BLOG_SUCCESS_STORY, ENSCAPE_BLOG_WEBINAR],
  custom_posts: PostsSelectionInput.defaults
};
var Defaults$1s = {
  utm_source: "website_widget",
  filter: HubspotFeedFilterInput.defaults,
  containerSettings: {}
};
var Admin$1r = {
  utm_source: {
    type: "text"
  },
  filter: {
    type: "custom",
    component: HubspotFeedFilterInput
  }
};
var Widget$1s = function Widget(_ref) {
  var utm_source = _ref.utm_source,
    filter = _ref.filter;
  var _React$useState = React.useState([]),
    state = _React$useState[0],
    setState = _React$useState[1];
  var _React$useState2 = React.useState(false),
    isFetching = _React$useState2[0],
    setIsFetching = _React$useState2[1];
  var _React$useContext = React.useContext(HubSpotContext),
    api_domain = _React$useContext.api_domain;
  var locale = React.useContext(LocaleContext);
  React.useEffect(function () {
    var fetchData = function fetchData() {
      try {
        setState([]);
        setIsFetching(true);
        var blogIds = filter.blogs.join(",");
        var customPosts = filter.custom_posts.map(function (item) {
          return [item.post.post_id, item.sort].join(":");
        }).join(",");
        var formattedFilters = {
          blogIds: blogIds,
          customPosts: customPosts,
          limit: filter.limit
        };
        return Promise.resolve(fetchFeed(api_domain, formattedFilters)).then(function (data) {
          setState(data);
          setIsFetching(false);
        });
      } catch (e) {
        return Promise.reject(e);
      }
    };
    fetchData();
  }, [filter]);
  return /*#__PURE__*/React.createElement("div", {
    className: "hubspot-feed"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(BlogFeed, {
    feed: state,
    locale: locale,
    utm_source: utm_source
  }), isFetching && /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "216px",
      textALign: "center"
    }
  }, "Loading...")));
};
var HubspotFeedWidget = {
  __proto__: null,
  Admin: Admin$1r,
  Config: Config$1s,
  Defaults: Defaults$1s,
  Widget: Widget$1s
};
var TEMPLATE$p = {
  label: "Media",
  logo: imagePlaceholder("150x60"),
  title: "Explore & save \nwith our bundle offerings",
  sub_title: "",
  description: "Experience the ease and speed of real-time visualization \nat every stage of the design process",
  button: ButtonSettings.defaults,
  video_preview: imagePlaceholder("900x500"),
  video: ""
};
var ListItem$w = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: settings.logo,
    onChange: function onChange(value) {
      return onChangeItem("logo", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Subtitle",
    value: settings.sub_title,
    onChange: function onChange(value) {
      return onChangeItem("sub_title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: settings.button,
    onChange: function onChange(button) {
      return onChangeItem("button", button);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Video Preview",
    value: settings.video_preview,
    onChange: function onChange(video_preview) {
      return onChangeItem("video_preview", video_preview);
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Video",
    value: settings.video,
    onChange: function onChange(video) {
      return onChangeItem("video", video);
    }
  }));
};
var BundleTabsInput = function BundleTabsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$w, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$p,
    primaryField: "label",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
BundleTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$p), _extends({
  id: 2
}, TEMPLATE$p), _extends({
  id: 3
}, TEMPLATE$p)];
var HostedVideo$3 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  var _React$useState = React.useState(false),
    play = _React$useState[0],
    setPlay = _React$useState[1];
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video only-image"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video",
    onClick: function onClick() {
      return setPlay(true);
    }
  }, play || !cover ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "icon-play-round"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  })));
};
var useGraphQL$4 = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
function collectVideoIds$2(tabs) {
  var ids = new Set();
  for (var _iterator = _createForOfIteratorHelperLoose(tabs), _step; !(_step = _iterator()).done;) {
    var tab = _step.value;
    ids.add(tab.video);
  }
  return Array.from(ids).filter(Boolean);
}
var MediaComponent = function MediaComponent(_ref) {
  var videos = _ref.videos,
    video = _ref.video,
    video_preview = _ref.video_preview;
  var toPlay = videos.find(function (v) {
    return v.id === video;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-video"
  }, /*#__PURE__*/React.createElement(HostedVideo$3, {
    video: toPlay,
    cover: video_preview
  }));
};
function pickInitialTab(tabs, override_initial_index) {
  var _tabs$2;
  if (override_initial_index === void 0) {
    override_initial_index = -1;
  }
  var overrideIdx = Number.parseInt(override_initial_index, 10);
  var tabsLength = tabs.length;
  if (overrideIdx > 0 && overrideIdx <= tabsLength) {
    var _tabs;
    return (_tabs = tabs[overrideIdx - 1]) === null || _tabs === void 0 ? void 0 : _tabs.id;
  }
  if (typeof window === "undefined") {
    var _tabs$;
    return (_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id;
  }
  if (window.matchMedia("(max-width: 599px)").matches) {
    var _tabs2;
    return (_tabs2 = tabs[tabsLength - 1]) === null || _tabs2 === void 0 ? void 0 : _tabs2.id;
  }
  return (_tabs$2 = tabs[0]) === null || _tabs$2 === void 0 ? void 0 : _tabs$2.id;
}
var Widget$1t = function Widget(_ref2) {
  var _videosData$videos;
  var tabs = _ref2.tabs,
    _ref2$selected_tab_in = _ref2.selected_tab_index,
    selected_tab_index = _ref2$selected_tab_in === void 0 ? "1" : _ref2$selected_tab_in,
    _ref2$override_color = _ref2.override_color,
    override_color = _ref2$override_color === void 0 ? "" : _ref2$override_color,
    containerSettings = _ref2.containerSettings;
  var _React$useState = React.useState(pickInitialTab(tabs, selected_tab_index)),
    tab = _React$useState[0],
    setTab = _React$useState[1];
  var activeTab = tabs.find(function (t) {
    return t.id === tab;
  });
  var collectedIds = React.useMemo(function () {
    return collectVideoIds$2(tabs);
  }, [tabs]);
  React.useEffect(function () {
    setTab(pickInitialTab(tabs, selected_tab_index));
  }, [tabs, selected_tab_index]);
  var videosData = useGraphQL$4(VIDEOS, {
    input: {
      filters: {
        ids: collectedIds
      }
    }
  });
  var videos = (videosData === null || videosData === void 0 ? void 0 : (_videosData$videos = videosData.videos) === null || _videosData$videos === void 0 ? void 0 : _videosData$videos.list) || [];
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "bundle-tabs"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "phone-tabs-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, tabs.map(function (_ref3) {
    var id = _ref3.id,
      label = _ref3.label;
    return /*#__PURE__*/React.createElement("button", {
      key: id,
      type: "button",
      className: tab === id ? "tab active" : "tab",
      onClick: function onClick() {
        return setTab(id);
      }
    }, label);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "current-tab"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "current-tab-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "current-tab-content"
  }, activeTab.logo && /*#__PURE__*/React.createElement(Img, {
    src: activeTab.logo,
    variant: "thumb",
    className: "logo",
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-subtitle"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, parseMarkdown(activeTab.title)), /*#__PURE__*/React.createElement("h5", {
    className: "subtitle",
    style: override_color ? {
      color: "" + override_color
    } : {}
  }, activeTab.sub_title)), /*#__PURE__*/React.createElement("p", {
    className: "description customized-ul"
  }, parseMarkdown(activeTab.description))), /*#__PURE__*/React.createElement(Button$1, {
    settings: activeTab.button
  })), /*#__PURE__*/React.createElement(MediaComponent, {
    videos: videos,
    video: activeTab.video,
    video_preview: activeTab.video_preview
  }))))))));
};
var Config$1t = {
  title: "Bundle Tabs",
  category: "Image + Text"
};
var Defaults$1t = {
  override_color: "",
  tabs: BundleTabsInput.defaults,
  selected_tab_index: "1",
  containerSettings: {}
};
var Admin$1s = {
  override_color: {
    type: "text"
  },
  tabs: {
    type: "custom",
    component: BundleTabsInput
  },
  selected_tab_index: {
    type: "text"
  }
};
var BundleTabsWidget = {
  __proto__: null,
  Widget: Widget$1t,
  Admin: Admin$1s,
  Config: Config$1t,
  Defaults: Defaults$1t
};
var TEMPLATE$q = {
  icon: imagePlaceholder("32x32"),
  label: "label",
  title: "Title",
  description: "Experience the ease and speed of real-time visualization at every stage of the design process.",
  features: SpotlightFeaturesInput.defaults,
  orientation: "left",
  media: FeatureSpotlightMediaInput.defaults,
  button: _extends({}, ButtonSettings.defaults, {
    type: "secondary-alt"
  }),
  image: imagePlaceholder("800x600")
};
var ListItem$x = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }), /*#__PURE__*/React.createElement(SpotlightFeaturesInput, {
    label: "Features",
    value: settings.features,
    onChange: function onChange(value) {
      return onChangeItem("features", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    options: [["left", "Media on the left"], ["right", "Media on the right"]],
    label: "Orientation",
    value: settings.orientation,
    onChange: function onChange(value) {
      return onChangeItem("orientation", value);
    }
  }), /*#__PURE__*/React.createElement(FeatureSpotlightMediaInput, {
    label: "Media",
    value: settings.media,
    onChange: function onChange(value) {
      return onChangeItem("media", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: settings.button,
    onChange: function onChange(value) {
      return onChangeItem("button", value);
    }
  }));
};
var BenefitsTabsInput = function BenefitsTabsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$x, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    primaryField: "label",
    template: TEMPLATE$q,
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
BenefitsTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$q), _extends({
  id: 2
}, TEMPLATE$q), _extends({
  id: 3
}, TEMPLATE$q)];
var DirectEmbed$1 = function DirectEmbed(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  var _React$useState = React.useState(false),
    play = _React$useState[0],
    setPlay = _React$useState[1];
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video",
    onClick: function onClick() {
      return setPlay(true);
    }
  }, play || !cover ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "icon-play-round"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  })));
};
var useGraphQL$5 = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var ImageFeature$1 = function ImageFeature(_ref) {
  var className = _ref.className,
    image = _ref.image,
    button = _ref.button;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-image " + className
  }, image && /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "simple_image_slider",
    className: "content-image",
    loading: "lazy"
  }), button.link && /*#__PURE__*/React.createElement(Button$4, {
    settings: button
  }));
};
var VideoFeature$1 = function VideoFeature(_ref2) {
  var className = _ref2.className,
    videos = _ref2.videos,
    video = _ref2.video,
    video_preview = _ref2.video_preview;
  var toPlay = videos.find(function (v) {
    return v.id === video;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-video " + className
  }, /*#__PURE__*/React.createElement(DirectEmbed$1, {
    video: toPlay,
    cover: video_preview
  }));
};
var SliderFeature$1 = function SliderFeature(_ref3) {
  var className = _ref3.className,
    slides = _ref3.slides,
    left_label = _ref3.left_label,
    right_label = _ref3.right_label;
  var _React$useState = React.useState(0),
    slide = _React$useState[0],
    setSlide = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-slider " + className
  }, slides[slide].image && /*#__PURE__*/React.createElement(Image, {
    src: slides[slide].image,
    variant: "simple_image_slider",
    className: "content-image",
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "0",
    max: slides.length - 1,
    className: "slide-control",
    value: slide,
    onChange: function onChange(e) {
      return setSlide(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "body-xs media-slider-labels"
  }, /*#__PURE__*/React.createElement("span", null, left_label), /*#__PURE__*/React.createElement("span", null, right_label)));
};
var IframeFeature$1 = function IframeFeature(_ref4) {
  var className = _ref4.className,
    iframe = _ref4.iframe;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-iframe " + className
  }, /*#__PURE__*/React.createElement("iframe", {
    src: iframe,
    frameborder: "0"
  }));
};
var CompareFeature$1 = function CompareFeature(_ref5) {
  var className = _ref5.className,
    image_1 = _ref5.image_1,
    image_2 = _ref5.image_2;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-compare " + className
  }, /*#__PURE__*/React.createElement(ReactCompareImage, {
    leftImage: image_1.urls.original ? image_1.urls.original : image_1,
    rightImage: image_2.urls.original ? image_2.urls.original : image_2,
    sliderLineWidth: 4
  }));
};
var MEDIA$1 = {
  image: ImageFeature$1,
  video: VideoFeature$1,
  slider: SliderFeature$1,
  iframe: IframeFeature$1,
  compare: CompareFeature$1
};
function collectVideoIds$3(tabs) {
  var ids = new Set();
  tabs === null || tabs === void 0 ? void 0 : tabs.forEach(function (tab) {
    ids.add(tab.media.video);
  });
  return Array.from(ids).filter(Boolean);
}
var Widget$1u = function Widget(_ref6) {
  var _videosData$videos;
  var tabs = _ref6.tabs,
    _ref6$override_color = _ref6.override_color,
    override_color = _ref6$override_color === void 0 ? "" : _ref6$override_color,
    containerSettings = _ref6.containerSettings;
  var _React$useState2 = React.useState(tabs[0].id),
    tab = _React$useState2[0],
    setTab = _React$useState2[1];
  var activeTab = tabs.find(function (t) {
    return t.id === tab;
  });
  var collectedIds = React.useMemo(function () {
    return collectVideoIds$3(tabs);
  }, [tabs]);
  var MediaComponent = MEDIA$1[activeTab.media.type];
  var videosData = useGraphQL$5(VIDEOS, {
    input: {
      filters: {
        ids: collectedIds
      }
    }
  });
  var videos = (videosData === null || videosData === void 0 ? void 0 : (_videosData$videos = videosData.videos) === null || _videosData$videos === void 0 ? void 0 : _videosData$videos.list) || [];
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings)
  }, /*#__PURE__*/React.createElement("div", {
    className: "benefits-tabs",
    style: override_color ? {
      "--override-color": override_color
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "feature-tabs"
  }, tabs.map(function (_ref7) {
    var id = _ref7.id,
      icon = _ref7.icon,
      label = _ref7.label;
    return /*#__PURE__*/React.createElement("div", {
      className: "tab-div " + (tab === id ? "selected" : ""),
      key: id,
      onClick: function onClick() {
        return setTab(id);
      }
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: tab === id ? "btn-tab selected" : "btn-tab"
    }, icon && /*#__PURE__*/React.createElement(Image, {
      src: icon,
      variant: "thumb",
      className: "icon",
      loading: "lazy"
    })), /*#__PURE__*/React.createElement("span", {
      className: tab === id ? "btn-span selected" : "btn-span"
    }, label));
  })), /*#__PURE__*/React.createElement("div", {
    className: "media-tab " + activeTab.orientation
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "media-tab-inner"
  }, activeTab.orientation === "left" && /*#__PURE__*/React.createElement(MediaComponent, _extends({
    className: "left",
    videos: videos
  }, activeTab.media)), /*#__PURE__*/React.createElement("div", {
    className: "media-tab-content " + (activeTab.orientation === "left" ? "right" : "left")
  }, /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, activeTab.title), /*#__PURE__*/React.createElement("div", {
    className: "body-m text-secondary",
    dangerouslySetInnerHTML: {
      __html: activeTab.description
    }
  }), activeTab.features.map(function (feature) {
    return /*#__PURE__*/React.createElement("div", {
      className: "feature",
      key: feature.id
    }, /*#__PURE__*/React.createElement(Image, {
      showCredits: false,
      src: feature.icon,
      variant: "thumb",
      className: "icon",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("div", {
      className: "title-description"
    }, /*#__PURE__*/React.createElement("span", null, feature.title), /*#__PURE__*/React.createElement("p", null, feature.summary)));
  }), /*#__PURE__*/React.createElement(Button$1, {
    className: "btn-passive hidden-desktop",
    settings: activeTab.button
  })), activeTab.orientation === "right" && /*#__PURE__*/React.createElement(MediaComponent, _extends({
    className: "right",
    videos: videos
  }, activeTab.media)))))), /*#__PURE__*/React.createElement(Button$1, {
    className: "btn-passive hidden-phone",
    settings: activeTab.button
  }))));
};
var Config$1u = {
  title: "Benefits tabs",
  category: "Media"
};
var Admin$1t = {
  override_color: {
    type: "text"
  },
  tabs: {
    type: "custom",
    label: "Tabs",
    component: BenefitsTabsInput
  }
};
var Defaults$1u = {
  tabs: BenefitsTabsInput.defaults,
  override_color: "",
  containerSettings: {}
};
var BenefitsTabsWidget = {
  __proto__: null,
  Admin: Admin$1t,
  Config: Config$1u,
  Defaults: Defaults$1u,
  Widget: Widget$1u
};
var TEMPLATE$r = {
  image: imagePlaceholder("382x414"),
  icon: imagePlaceholder("24x24"),
  title: "Low Geometry Override",
  description: "- use case one\n- use case and benefit #1\n- use case and benefit #2"
};
var ListItem$y = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    value: settings.image,
    onChange: function onChange(value) {
      return onChangeItem("image", value);
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(value) {
      return onChangeItem("icon", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: settings.description,
    onChange: function onChange(value) {
      return onChangeItem("description", value);
    }
  }));
};
var SideBySideImagesInput = function SideBySideImagesInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$y, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$r,
    primaryField: "title",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
SideBySideImagesInput.defaults = [_extends({
  id: 1
}, TEMPLATE$r), _extends({
  id: 2
}, TEMPLATE$r), _extends({
  id: 3
}, TEMPLATE$r)];
var MediaTabsMediaInput = function MediaTabsMediaInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Type",
    options: [["image", "Image"], ["video", "Video"], ["slider", "Slider"], ["iframe", "iframe"], ["compare", "Compare"], ["side_by_side_images", "Side by side images"]],
    value: value.type,
    onChange: function onChange(type) {
      return _onChange(_extends({}, value, {
        type: type
      }));
    }
  }), value.type === "image" && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image",
    value: value.image,
    onChange: function onChange(image) {
      return _onChange(_extends({}, value, {
        image: image
      }));
    }
  })), value.type === "side_by_side_images" && /*#__PURE__*/React.createElement(SideBySideImagesInput, {
    label: "Side by side images",
    value: value.images,
    onChange: function onChange(images) {
      return _onChange(_extends({}, value, {
        images: images
      }));
    }
  }), value.type === "video" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Video Preview",
    value: value.video_preview,
    onChange: function onChange(video_preview) {
      return _onChange(_extends({}, value, {
        video_preview: video_preview
      }));
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Video",
    value: value.video,
    onChange: function onChange(video) {
      return _onChange(_extends({}, value, {
        video: video
      }));
    }
  })), value.type === "iframe" && /*#__PURE__*/React.createElement(TextInput, {
    label: "Iframe URL",
    value: value.iframe,
    onChange: function onChange(iframe) {
      return _onChange(_extends({}, value, {
        iframe: iframe
      }));
    }
  }), value.type === "slider" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FeatureSliderInput, {
    label: "Slide images",
    value: value.slides,
    onChange: function onChange(slides) {
      return _onChange(_extends({}, value, {
        slides: slides
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Left label",
    value: value.left_label,
    onChange: function onChange(left_label) {
      return _onChange(_extends({}, value, {
        left_label: left_label
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Right label",
    value: value.right_label,
    onChange: function onChange(right_label) {
      return _onChange(_extends({}, value, {
        right_label: right_label
      }));
    }
  })), value.type === "compare" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image 1",
    value: value.image_1,
    onChange: function onChange(image_1) {
      return _onChange(_extends({}, value, {
        image_1: image_1
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Image 2",
    value: value.image_2,
    onChange: function onChange(image_2) {
      return _onChange(_extends({}, value, {
        image_2: image_2
      }));
    }
  })));
};
MediaTabsMediaInput.defaults = {
  type: "image",
  image: imagePlaceholder("900x500"),
  video_preview: imagePlaceholder("900x500"),
  video: "",
  iframe: "",
  slides: FeatureSliderInput.defaults,
  images: SideBySideImagesInput.defaults,
  left_label: "Left label",
  right_label: "Right label",
  image_1: imagePlaceholder("900x500"),
  image_2: imagePlaceholder("900x500")
};
var TEMPLATE$s = {
  tab_info: TabInfoInput.defaults,
  media: MediaTabsMediaInput.defaults,
  text: "Some multiline text\nwhich people really like",
  button: _extends({}, ButtonSettings.defaults, {
    link: "",
    type: "secondary"
  })
};
var ListItem$z = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TabInfoInput, {
    label: "Tab",
    value: settings.tab_info,
    onChange: function onChange(value) {
      return onChangeItem("tab_info", value);
    }
  }), /*#__PURE__*/React.createElement(MediaTabsMediaInput, {
    label: "Media",
    value: settings.media,
    onChange: function onChange(value) {
      return onChangeItem("media", value);
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "text",
    value: settings.text,
    onChange: function onChange(value) {
      return onChangeItem("text", value);
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: settings.button,
    onChange: function onChange(value) {
      return onChangeItem("button", value);
    }
  }));
};
var MediaTabsInput = function MediaTabsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$z, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$s,
    primaryField: "tab_info.label",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
MediaTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$s), _extends({
  id: 2
}, TEMPLATE$s), _extends({
  id: 3
}, TEMPLATE$s)];
var HostedVideo$4 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  var _React$useState = React.useState(false),
    play = _React$useState[0],
    setPlay = _React$useState[1];
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video only-image"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video",
    onClick: function onClick() {
      return setPlay(true);
    }
  }, play || !cover ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "icon-play-round"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  })));
};
var useGraphQL$6 = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var ImageMedia = function ImageMedia(_ref) {
  var image = _ref.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-image"
  }, image && /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "simple_image_slider",
    className: "content-image",
    loading: "lazy"
  }));
};
var VideoMedia = function VideoMedia(_ref2) {
  var videos = _ref2.videos,
    video = _ref2.video,
    video_preview = _ref2.video_preview;
  var toPlay = videos.find(function (v) {
    return v.id === video;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-video"
  }, /*#__PURE__*/React.createElement(HostedVideo$4, {
    video: toPlay,
    cover: video_preview
  }));
};
var SliderMedia = function SliderMedia(_ref3) {
  var slides = _ref3.slides,
    left_label = _ref3.left_label,
    right_label = _ref3.right_label;
  var _React$useState = React.useState(0),
    slide = _React$useState[0],
    setSlide = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-slider"
  }, slides[slide].image && /*#__PURE__*/React.createElement(Image, {
    src: slides[slide].image,
    variant: "simple_image_slider",
    className: "content-image",
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("input", {
    type: "range",
    min: "0",
    max: slides.length - 1,
    className: "slide-control",
    value: slide,
    onChange: function onChange(e) {
      return setSlide(e.target.value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "body-xs media-slider-labels"
  }, /*#__PURE__*/React.createElement("span", null, left_label), /*#__PURE__*/React.createElement("span", null, right_label)));
};
var IframeMedia = function IframeMedia(_ref4) {
  var iframe = _ref4.iframe;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-iframe"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: iframe,
    frameborder: "0"
  }));
};
var CompareMedia = function CompareMedia(_ref5) {
  var image_1 = _ref5.image_1,
    image_2 = _ref5.image_2;
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-compare"
  }, /*#__PURE__*/React.createElement(ReactCompareImage, {
    leftImage: image_1.urls.original ? image_1.urls.original : image_1,
    rightImage: image_2.urls.original ? image_2.urls.original : image_2,
    sliderLineWidth: 4
  }));
};
var SideBySideImagesMedia = function SideBySideImagesMedia(_ref6) {
  var images = _ref6.images;
  var _React$useState2 = React.useState(images[0].id),
    image = _React$useState2[0],
    setImage = _React$useState2[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "media media-side-by-side-images"
  }, images.map(function (el) {
    return /*#__PURE__*/React.createElement("div", {
      key: el.id,
      className: "item " + (el.id === image ? "selected" : ""),
      onClick: function onClick() {
        return setImage(el.id);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "image-card"
    }, /*#__PURE__*/React.createElement(Image, {
      src: el.image,
      variant: "simple_image_slider",
      className: "content-image",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("div", {
      className: "text"
    }, /*#__PURE__*/React.createElement("h4", {
      className: "title"
    }, el.title), /*#__PURE__*/React.createElement("p", {
      className: "description"
    }, parseMarkdown(el.description)), /*#__PURE__*/React.createElement("div", {
      className: "icon"
    }, /*#__PURE__*/React.createElement(Image, {
      src: el.icon,
      variant: "thumb",
      loading: "lazy"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "logo-title"
    }, /*#__PURE__*/React.createElement(Image, {
      src: el.icon,
      variant: "thumb",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("h4", {
      className: "title"
    }, el.title)));
  }));
};
var MEDIA$2 = {
  image: ImageMedia,
  video: VideoMedia,
  slider: SliderMedia,
  iframe: IframeMedia,
  compare: CompareMedia,
  side_by_side_images: SideBySideImagesMedia
};
function collectVideoIds$4(tabs) {
  var ids = new Set();
  for (var _iterator = _createForOfIteratorHelperLoose(tabs), _step; !(_step = _iterator()).done;) {
    var tab = _step.value;
    ids.add(tab.media.video);
  }
  return Array.from(ids).filter(Boolean);
}
var Widget$1v = function Widget(_ref7) {
  var _videosData$videos, _activeTab$button;
  var _ref7$override_color = _ref7.override_color,
    override_color = _ref7$override_color === void 0 ? "" : _ref7$override_color,
    pre_title = _ref7.pre_title,
    title = _ref7.title,
    subtitle = _ref7.subtitle,
    tabs = _ref7.tabs,
    containerSettings = _ref7.containerSettings;
  var _React$useState3 = React.useState(tabs[0].id),
    tab = _React$useState3[0],
    setTab = _React$useState3[1];
  var activeTab = tabs.find(function (t) {
    return t.id === tab;
  });
  var collectedIds = React.useMemo(function () {
    return collectVideoIds$4(tabs);
  }, [tabs]);
  var MediaComponent = MEDIA$2[activeTab.media.type];
  var videosData = useGraphQL$6(VIDEOS, {
    input: {
      filters: {
        ids: collectedIds
      }
    }
  });
  var videos = (videosData === null || videosData === void 0 ? void 0 : (_videosData$videos = videosData.videos) === null || _videosData$videos === void 0 ? void 0 : _videosData$videos.list) || [];
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings)
  }, /*#__PURE__*/React.createElement("div", {
    className: "media-tabs",
    style: override_color ? {
      "--override-color": override_color
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "pretitle"
  }, pre_title), /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "subtitle",
    dangerouslySetInnerHTML: {
      __html: subtitle
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, tabs.map(function (_ref8) {
    var id = _ref8.id,
      _ref8$tab_info = _ref8.tab_info,
      icon = _ref8$tab_info.icon,
      label = _ref8$tab_info.label;
    return /*#__PURE__*/React.createElement("button", {
      key: id,
      type: "button",
      className: tab === id ? "btn-tab selected" : "btn-tab",
      onClick: function onClick() {
        return setTab(id);
      }
    }, icon && /*#__PURE__*/React.createElement(Image, {
      src: icon,
      variant: "simple_image_slider",
      className: "icon",
      loading: "lazy"
    }), /*#__PURE__*/React.createElement("p", {
      className: "label"
    }, label));
  })), /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "active-tab"
  }, /*#__PURE__*/React.createElement("div", {
    className: "active-tab-inner"
  }, /*#__PURE__*/React.createElement(MediaComponent, _extends({
    videos: videos
  }, activeTab.media)), (activeTab === null || activeTab === void 0 ? void 0 : activeTab.text) && /*#__PURE__*/React.createElement("p", {
    className: "text"
  }, parseMarkdown(activeTab.text)), (activeTab === null || activeTab === void 0 ? void 0 : (_activeTab$button = activeTab.button) === null || _activeTab$button === void 0 ? void 0 : _activeTab$button.link) && /*#__PURE__*/React.createElement(Button$1, {
    settings: activeTab.button
  }))))))));
};
var Config$1v = {
  title: "Media tabs",
  category: "Media"
};
var Admin$1u = {
  override_color: {
    type: "text"
  },
  pre_title: {
    type: "custom",
    component: MarkdownInput
  },
  title: {
    type: "custom",
    component: MarkdownInput
  },
  subtitle: {
    type: "custom",
    component: RTE
  },
  tabs: {
    type: "custom",
    component: MediaTabsInput
  }
};
var Defaults$1v = {
  override_color: "",
  pre_title: "Supercharge your workflows with",
  title: "AI with Enscape Premium",
  subtitle: "Our premium offering includes Enscape's native AI Image enhancer and ",
  tabs: MediaTabsInput.defaults,
  containerSettings: {
    theme: "dark"
  }
};
var MediaTabsWidget = {
  __proto__: null,
  Admin: Admin$1u,
  Config: Config$1v,
  Defaults: Defaults$1v,
  Widget: Widget$1v
};
var TEMPLATE$t = {
  label: "Media",
  link: LinkSettings.defaults,
  state: "inactive"
};
var ListItem$A = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Label",
    value: settings.label,
    onChange: function onChange(value) {
      return onChangeItem("label", value);
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Link",
    value: settings.link || {},
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    options: [["active", "Active"], ["inactive", "Inactive"]],
    label: "State",
    value: settings.state,
    onChange: function onChange(value) {
      return onChangeItem("state", value);
    }
  }));
};
var SimpleTabsInput = function SimpleTabsInput(_ref2) {
  var label = _ref2.label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$A, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$t,
    primaryField: "label",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  }));
};
SimpleTabsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$t), _extends({
  id: 2
}, TEMPLATE$t)];
var Link$4 = function Link(_ref) {
  var settings = _ref.settings,
    children = _ref.children,
    className = _ref.className;
  var label = settings.label,
    link = settings.link,
    id = settings.id,
    target = settings.target,
    rel = settings.rel;
  return /*#__PURE__*/React.createElement(A, {
    href: link,
    className: [settings.className, className].join(" "),
    id: id ? id : "",
    target: target,
    rel: rel,
    title: label
  }, children);
};
var Widget$1w = function Widget(_ref2) {
  var tabs = _ref2.tabs,
    containerSettings = _ref2.containerSettings;
  return /*#__PURE__*/React.createElement("div", {
    className: "simple-tabs"
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "phone-tabs-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(Link$4, {
      className: tab.state === "active" ? "tab active" : "tab",
      key: tab.id,
      settings: tab.link
    }, tab.label);
  }))))));
};
var Config$1w = {
  title: "Simple Tabs",
  category: "Navigation"
};
var Defaults$1w = {
  tabs: SimpleTabsInput.defaults,
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$1v = {
  tabs: {
    type: "custom",
    component: SimpleTabsInput
  }
};
var SimpleTabsWidget = {
  __proto__: null,
  Widget: Widget$1w,
  Admin: Admin$1v,
  Config: Config$1w,
  Defaults: Defaults$1w
};
var ListItem$B = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Icon",
    value: settings.icon,
    onChange: function onChange(icon) {
      return onChangeItem("icon", icon);
    }
  }));
};
var IconsInput = function IconsInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Icons" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$B, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$u,
    primaryField: "icon.name",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$u = {
  icon: imagePlaceholder("32x32")
};
IconsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$u), _extends({
  id: 2
}, TEMPLATE$u), _extends({
  id: 3
}, TEMPLATE$u)];
var MosaicIntegrationInput = function MosaicIntegrationInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(FormGroup$1, null, label && /*#__PURE__*/React.createElement(Label$2, null, label), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Subtitle",
    value: value.subtitle,
    onChange: function onChange(subtitle) {
      return _onChange(_extends({}, value, {
        subtitle: subtitle
      }));
    }
  }), /*#__PURE__*/React.createElement(ButtonSettings, {
    label: "Button",
    value: value.button,
    onChange: function onChange(button) {
      return _onChange(_extends({}, value, {
        button: button
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Background Image",
    value: value.background_image,
    onChange: function onChange(background_image) {
      return _onChange(_extends({}, value, {
        background_image: background_image
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Overlay effect Image",
    value: value.image,
    onChange: function onChange(image) {
      return _onChange(_extends({}, value, {
        image: image
      }));
    }
  }), /*#__PURE__*/React.createElement(IconsInput, {
    label: "Icons",
    value: value.icons_list,
    onChange: function onChange(icons_list) {
      return _onChange(_extends({}, value, {
        icons_list: icons_list
      }));
    }
  }));
};
MosaicIntegrationInput.defaults = {
  title: "Label",
  subtitle: "Label",
  button: ButtonSettings.defaults,
  background_image: imagePlaceholder("900x500"),
  image: imagePlaceholder("380x480"),
  icons_list: IconsInput.defaults
};
var ListItem$C = function ListItem(_ref) {
  var settings = _ref.settings,
    onChangeItem = _ref.onChangeItem;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Video Preview",
    value: settings.video_preview,
    onChange: function onChange(value) {
      return onChangeItem("video_preview", value);
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Text",
    value: settings.text,
    onChange: function onChange(value) {
      return onChangeItem("text", value);
    }
  }), /*#__PURE__*/React.createElement(VideoPicker, {
    label: "Video",
    value: settings.video,
    onChange: function onChange(value) {
      return onChangeItem("video", value);
    }
  }), /*#__PURE__*/React.createElement(LinkSettings, {
    label: "Video Link",
    value: settings.link || {},
    onChange: function onChange(value) {
      return onChangeItem("link", value);
    }
  }));
};
var VideoTextCardsInput = function VideoTextCardsInput(_ref2) {
  var _ref2$label = _ref2.label,
    label = _ref2$label === void 0 ? "Video Cards" : _ref2$label,
    value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$C, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    template: TEMPLATE$v,
    primaryField: "text",
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
var TEMPLATE$v = {
  video_preview: imagePlaceholder("900x500"),
  text: "Sample Scene",
  video: "",
  link: _extends({}, LinkSettings.defaults, {
    link: ""
  })
};
VideoTextCardsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$v), _extends({
  id: 2
}, TEMPLATE$v)];
var HostedVideo$5 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  var _React$useState = React.useState(false),
    play = _React$useState[0],
    setPlay = _React$useState[1];
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video only-image"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video",
    onClick: function onClick() {
      return setPlay(true);
    }
  }, play || !cover ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "icon-play-round"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  })));
};
var Link$5 = function Link(_ref) {
  var settings = _ref.settings,
    children = _ref.children,
    className = _ref.className;
  var label = settings.label,
    link = settings.link,
    id = settings.id,
    target = settings.target,
    rel = settings.rel;
  return /*#__PURE__*/React.createElement(A, {
    href: link,
    className: [settings.className, className].join(" "),
    id: id ? id : "",
    target: target,
    rel: rel,
    title: label
  }, children);
};
var useGraphQL$7 = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
function collectVideoIds$5(videos) {
  var ids = new Set();
  for (var _iterator = _createForOfIteratorHelperLoose(videos), _step; !(_step = _iterator()).done;) {
    var el = _step.value;
    ids.add(el.video);
  }
  return Array.from(ids).filter(Boolean);
}
var VideoComponent$1 = function VideoComponent(_ref2) {
  var videos = _ref2.videos,
    video = _ref2.video,
    _ref2$video_link = _ref2.video_link,
    video_link = _ref2$video_link === void 0 ? {} : _ref2$video_link,
    video_preview = _ref2.video_preview,
    text = _ref2.text;
  var toPlay = videos.find(function (v) {
    return v.id === video;
  });
  if (video_link !== null && video_link !== void 0 && video_link.link) {
    return /*#__PURE__*/React.createElement(Link$5, {
      settings: video_link,
      className: "video"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-play-round"
    }), /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: video_preview,
      variant: "image"
    }), /*#__PURE__*/React.createElement("h3", {
      className: "text"
    }, text));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "video"
  }, /*#__PURE__*/React.createElement(HostedVideo$5, {
    video: toPlay,
    cover: video_preview
  }), /*#__PURE__*/React.createElement("h3", {
    className: "text"
  }, text));
};
var Widget$1x = function Widget(_ref3) {
  var _videosData$videos;
  var override_color = _ref3.override_color,
    title = _ref3.title,
    colored_title = _ref3.colored_title,
    description = _ref3.description,
    subtitle = _ref3.subtitle,
    integration = _ref3.integration,
    videos = _ref3.videos,
    containerSettings = _ref3.containerSettings;
  var collectedIds = React.useMemo(function () {
    return collectVideoIds$5(videos);
  }, [videos]);
  var videosData = useGraphQL$7(VIDEOS, {
    input: {
      filters: {
        ids: collectedIds
      }
    }
  });
  var collected_videos = (videosData === null || videosData === void 0 ? void 0 : (_videosData$videos = videosData.videos) === null || _videosData$videos === void 0 ? void 0 : _videosData$videos.list) || [];
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "mosaic",
    style: override_color ? {
      "--override-color": override_color
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cards-outer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "titles-description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("h1", {
    className: "colored"
  }, colored_title)), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, description), /*#__PURE__*/React.createElement("span", {
    className: "subtitle"
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "cards"
  }, /*#__PURE__*/React.createElement("div", {
    className: "integration"
  }, /*#__PURE__*/React.createElement(Img, {
    className: "background-img",
    src: integration.background_image,
    variant: "single_image_horizontal",
    loading: "lazy"
  }), /*#__PURE__*/React.createElement(Img, {
    className: "effect-img",
    src: integration.image,
    variant: "gallery_masonry_vertical",
    loading: "lazy"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-and-button"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "colored"
  }, integration.title), /*#__PURE__*/React.createElement("h3", null, integration.subtitle), /*#__PURE__*/React.createElement(Button$1, {
    className: "integration-button",
    settings: integration.button
  })), /*#__PURE__*/React.createElement("div", {
    className: "icons"
  }, integration.icons_list.map(function (icon) {
    return /*#__PURE__*/React.createElement(Img, {
      key: icon.id,
      className: "icon",
      src: icon.icon,
      variant: "thumb",
      loading: "lazy"
    });
  }))), /*#__PURE__*/React.createElement("div", {
    className: "videos"
  }, videos.map(function (video) {
    return /*#__PURE__*/React.createElement(VideoComponent$1, {
      key: video.id,
      videos: collected_videos,
      video: video.video,
      video_link: (video === null || video === void 0 ? void 0 : video.link) || {},
      video_preview: video.video_preview,
      text: video.text
    });
  })))))))));
};
var Config$1x = {
  title: "Mosaic",
  category: "Image + Text"
};
var Defaults$1x = {
  override_color: "",
  title: "Get started",
  colored_title: "for free.",
  description: "Get a 14-day free trial and dive into the full range of features we offer. You will also get access to comprehensive training resources and dedicated customer support.",
  subtitle: "Start rendering for free in seconds.",
  integration: MosaicIntegrationInput.defaults,
  videos: VideoTextCardsInput.defaults,
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$1w = {
  override_color: {
    type: "text"
  },
  title: {
    type: "custom",
    component: MarkdownInput
  },
  colored_title: {
    type: "custom",
    component: MarkdownInput
  },
  description: {
    type: "custom",
    component: MarkdownInput
  },
  subtitle: {
    type: "custom",
    component: MarkdownInput
  },
  integration: {
    type: "custom",
    component: MosaicIntegrationInput
  },
  videos: {
    type: "custom",
    component: VideoTextCardsInput
  }
};
var MosaicWidget = {
  __proto__: null,
  Widget: Widget$1x,
  Admin: Admin$1w,
  Config: Config$1x,
  Defaults: Defaults$1x
};
var HostedVideo$6 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video background"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video background"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  }), /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video."));
};
var useGraphQL$8 = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var Title$4 = function Title(_ref) {
  var title = _ref.title,
    titleSize = _ref.titleSize;
  switch (titleSize) {
    case "default":
      return /*#__PURE__*/React.createElement("h1", {
        className: "title"
      }, title);
    case "large":
      return /*#__PURE__*/React.createElement("h1", {
        className: "title large-title"
      }, title);
    case "medium":
      return /*#__PURE__*/React.createElement("h2", {
        className: "title medium-title"
      }, title);
    case "small":
      return /*#__PURE__*/React.createElement("h3", {
        className: "title small-title"
      }, title);
    default:
      return /*#__PURE__*/React.createElement("h1", {
        className: "title"
      }, title);
  }
};
var Widget$1y = function Widget(_ref2) {
  var _videoData$videos;
  var title = _ref2.title,
    _ref2$title_size = _ref2.title_size,
    title_size = _ref2$title_size === void 0 ? "default" : _ref2$title_size,
    subtitle = _ref2.subtitle,
    logo = _ref2.logo,
    background_image = _ref2.background_image,
    background_video = _ref2.background_video,
    button_1 = _ref2.button_1,
    button_2 = _ref2.button_2,
    containerSettings = _ref2.containerSettings;
  var videoData = useGraphQL$8(VIDEOS, {
    input: {
      filters: {
        ids: background_video
      }
    }
  });
  var video = (videoData === null || videoData === void 0 ? void 0 : (_videoData$videos = videoData.videos) === null || _videoData$videos === void 0 ? void 0 : _videoData$videos.list[0]) || null;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "hero"
  }, /*#__PURE__*/React.createElement(HostedVideo$6, {
    video: video,
    cover: background_image
  }), /*#__PURE__*/React.createElement("div", {
    className: "gradient background"
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-inner"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: logo,
    variant: "thumb"
  }), /*#__PURE__*/React.createElement("div", {
    className: "title-description"
  }, title && /*#__PURE__*/React.createElement(Title$4, {
    title: title,
    titleSize: title_size
  }), /*#__PURE__*/React.createElement("p", {
    className: "subtitle"
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1
  }), /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2
  })))))));
};
var Config$1y = {
  title: "Hero (left aligned)",
  category: "Image + Text"
};
var Defaults$1y = {
  title: "Chaos Enscape. Your design companion for better decisions in real-time.",
  title_size: "default",
  subtitle: "Instant feedback, faster iterations, & smarter design—from concept to presentation, all within your favorite CAD tools.",
  logo: imagePlaceholder("136x40"),
  background_image: imagePlaceholder("1920x600"),
  background_video: "",
  button_1: ButtonSettings.defaults,
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "secondary"
  }),
  containerSettings: {
    theme: "white",
    spacing: "none"
  }
};
var Admin$1x = {
  title: {
    type: "text"
  },
  title_size: {
    type: "select",
    options: [["large", "Larger"], ["default", "Default"], ["medium", "Medium"], ["small", "Small"]]
  },
  subtitle: {
    type: "text"
  },
  logo: {
    type: "custom",
    component: ImagePicker
  },
  background_image: {
    type: "custom",
    component: ImagePicker
  },
  background_video: {
    type: "custom",
    component: VideoPicker
  },
  button_1: {
    type: "custom",
    component: ButtonSettings
  },
  button_2: {
    type: "custom",
    component: ButtonSettings
  }
};
var HeroWidget = {
  __proto__: null,
  Widget: Widget$1y,
  Admin: Admin$1x,
  Config: Config$1y,
  Defaults: Defaults$1y
};
var CommercialInput$2 = function CommercialInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Commercial"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange(_extends({}, value, {
        logo: logo
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Color",
    value: value.color,
    onChange: function onChange(color) {
      return _onChange(_extends({}, value, {
        color: color
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Plans switcher settings"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Monthly tag",
    value: value.monthly_tag,
    onChange: function onChange(monthly_tag) {
      return _onChange(_extends({}, value, {
        monthly_tag: monthly_tag
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Annual tag",
    value: value.annual_tag,
    onChange: function onChange(annual_tag) {
      return _onChange(_extends({}, value, {
        annual_tag: annual_tag
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "3 years tag",
    value: value.triennial_tag,
    onChange: function onChange(triennial_tag) {
      return _onChange(_extends({}, value, {
        triennial_tag: triennial_tag
      }));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default period",
    options: [["monthly", "Monthly"], ["annual", "Annual"], ["triennial", "3 Years"]],
    value: value.default_period,
    onChange: function onChange(default_period) {
      return _onChange(_extends({}, value, {
        default_period: default_period
      }));
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "General description"
  }, /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange(_extends({}, value, {
        description: description
      }));
    }
  })), /*#__PURE__*/React.createElement(InputPopup, {
    label: "Cards"
  }, /*#__PURE__*/React.createElement(MainCardsInput, {
    value: value.cards,
    onChange: function onChange(cards) {
      return _onChange(_extends({}, value, {
        cards: cards
      }));
    }
  })));
};
CommercialInput$2.defaults = {
  html_id: "",
  title: "Pricing",
  sub_title: "From individual creators to the biggest enterprises, we have a plan for you",
  logo: imagePlaceholder("28"),
  color: "orange",
  monthly_tag: "",
  annual_tag: "Save 50% yearly.",
  triennial_tag: "",
  description: "",
  default_period: "",
  cards: MainCardsInput.defaults
};
var EducationalInput$2 = function EducationalInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Educational"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange(_extends({}, value, {
        logo: logo
      }));
    }
  }), /*#__PURE__*/React.createElement(MainCardsInput, {
    value: value.cards || [],
    onChange: function onChange(cards) {
      return _onChange(_extends({}, value, {
        cards: cards
      }));
    }
  }));
};
EducationalInput$2.defaults = {
  html_id: "",
  title: "Pricing",
  sub_title: "From individual creators to the biggest enterprises, we have a plan for you",
  logo: imagePlaceholder("28"),
  cards: MainCardsInput.defaults
};
var Config$1z = {
  title: "Pricing standalone (new)",
  category: "Pricing"
};
var Defaults$1z = {
  promo_code: "",
  show_disclaimer: "no",
  swiper_on_mobile: "no",
  labels: LabelsInput.defaults,
  commercial: CommercialInput$2.defaults,
  educational: EducationalInput$2.defaults
};
var Admin$1y = {
  promo_code: {
    type: "text"
  },
  show_disclaimer: {
    label: "Show additional disclaimer",
    type: "select",
    options: [["yes", "Yes"], ["no", "no"]]
  },
  swiper_on_mobile: {
    label: "Cards appear as a slider on mobile",
    type: "select",
    options: [["yes", "Yes"], ["no", "no"]]
  },
  labels: {
    type: "custom",
    component: LabelsInput
  },
  commercial: {
    type: "custom",
    component: CommercialInput$2
  },
  educational: {
    type: "custom",
    component: EducationalInput$2
  }
};
var MainCard$1 = function MainCard() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "330px",
      height: "540px"
    }
  });
};
var TabHeader$2 = function TabHeader() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "40%",
      height: "65px",
      marginBottom: "var(--gutter)"
    }
  });
};
var Disclaimer$1 = function Disclaimer() {
  return /*#__PURE__*/React.createElement(TextBlock, {
    rows: 2,
    color: colors.lightBlue,
    style: {
      width: "25%",
      marginBottom: "var(--gutter)"
    }
  });
};
var Placeholder$3 = function Placeholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "show-loading-animation spacing-both-xs"
  }, /*#__PURE__*/React.createElement(TabHeader$2, null), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$1, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$1, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$1, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$1, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Disclaimer$1, null)))));
};
function prepareLicenseTypes$1(labels) {
  return ["commercial", "educational"].map(function (lt) {
    return {
      id: lt,
      label: labels["license_type_switcher_" + lt]
    };
  });
}
function findHash$1() {
  if (typeof window !== "undefined") {
    return window.location.hash && window.location.hash.substring(1);
  }
  return null;
}
function initialLicenseType$1(commercial, educational) {
  var hash = findHash$1();
  if (!hash) {
    return "commercial";
  }
  if (commercial.html_id === hash) {
    return "commercial";
  }
  if (educational.html_id === hash) {
    return "educational";
  }
  return "commercial";
}
var BILLING_PERIOD_SORT_MAP$1 = {
  monthly: 0,
  annual: 1,
  triennial: 2
};
function prepareBillingPeriods$2(product) {
  var _product$cards;
  var billingPeriodsSet = new Set();
  product === null || product === void 0 ? void 0 : (_product$cards = product.cards) === null || _product$cards === void 0 ? void 0 : _product$cards.forEach(function (card) {
    card.licenses.forEach(function (license) {
      if (license.annual.rate_plan_id) {
        billingPeriodsSet.add("annual");
      }
      if (license.monthly.rate_plan_id) {
        billingPeriodsSet.add("monthly");
      }
      if (license.triennial.rate_plan_id) {
        billingPeriodsSet.add("triennial");
      }
    });
  });
  var billingPeriods = Array.from(billingPeriodsSet).map(function (bp) {
    return {
      id: bp,
      tag: product[bp + "_tag"],
      "default": product.default_period === bp
    };
  }).sort(function (a, b) {
    return BILLING_PERIOD_SORT_MAP$1[a.id] - BILLING_PERIOD_SORT_MAP$1[b.id];
  });
  return billingPeriods;
}
function calcMainCardsColClass(cards) {
  if (cards.length === 1) {
    return "main-col-1-3";
  }
  if (cards.length === 2) {
    return "main-col-2-3";
  }
  return "main-col";
}
var Content$8 = function Content(_ref) {
  var _billingPeriods$find, _billingPeriods$, _content$cards, _content$cards2;
  var show_disclaimer = _ref.show_disclaimer,
    swiper_on_mobile = _ref.swiper_on_mobile,
    labels = _ref.labels,
    commercial = _ref.commercial,
    educational = _ref.educational,
    pricingData = _ref.pricingData,
    containerSettings = _ref.containerSettings;
  React.useEffect(function () {
    setLicenseTypeId(initialLicenseType$1(commercial, educational));
    setLicensesCount(1);
  }, [commercial, educational, labels]);
  var licenseTypes = prepareLicenseTypes$1(labels);
  var _React$useState = React.useState(initialLicenseType$1(commercial, educational)),
    licenseTypeId = _React$useState[0],
    setLicenseTypeId = _React$useState[1];
  var currentLicenseType = licenseTypes.find(function (lt) {
    return lt.id === licenseTypeId;
  });
  var content = currentLicenseType.id === "educational" ? educational : commercial;
  var disclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.disclaimer;
  var additionalDisclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.additionalDisclaimer;
  var billingPeriods = prepareBillingPeriods$2(content);
  var _React$useState2 = React.useState(1),
    licensesCount = _React$useState2[0],
    setLicensesCount = _React$useState2[1];
  var _React$useState3 = React.useState(((_billingPeriods$find = billingPeriods.find(function (bp) {
      return bp["default"];
    })) === null || _billingPeriods$find === void 0 ? void 0 : _billingPeriods$find.id) || ((_billingPeriods$ = billingPeriods[0]) === null || _billingPeriods$ === void 0 ? void 0 : _billingPeriods$.id)),
    billingPeriodId = _React$useState3[0],
    setBillingPeriodId = _React$useState3[1];
  var currentBillingPeriod = billingPeriods.find(function (bp) {
    return bp.id === billingPeriodId;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "pricing-standalone"
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: containerSettings
  }, /*#__PURE__*/React.createElement("div", {
    className: "container pricing-light-bg"
  }, /*#__PURE__*/React.createElement(TabHeader, {
    tab: content
  }), /*#__PURE__*/React.createElement("div", {
    className: "row flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, currentLicenseType.id === "commercial" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlanSwitcher, {
    labels: labels,
    billingPeriod: currentBillingPeriod,
    billingPeriods: billingPeriods,
    licenseType: currentLicenseType,
    licenseTypes: licenseTypes,
    licensesCount: licensesCount,
    onLicensesCountChange: setLicensesCount,
    onBillingPeriodChange: function onBillingPeriodChange(bp) {
      return setBillingPeriodId(bp.id);
    },
    onLicenseTypeChange: function onLicenseTypeChange(lt) {
      setLicenseTypeId(lt.id);
      setLicensesCount(1);
    }
  }), content.description && /*#__PURE__*/React.createElement("div", {
    className: "general-description customized-ul non-mobile-only"
  }, parseMarkdown(content.description))), currentLicenseType.id === "educational" && /*#__PURE__*/React.createElement(LicenseTypeSwitcher, {
    labels: labels,
    licenseType: currentLicenseType,
    licenseTypes: licenseTypes,
    onChange: function onChange(lt) {
      setLicenseTypeId(lt.id);
      setLicensesCount(1);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: calcMainCardsColClass(content.cards)
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-fit"
  }, ((_content$cards = content.cards) === null || _content$cards === void 0 ? void 0 : _content$cards.length) === 1 && /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, content.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: content,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: currentLicenseType,
      labels: labels
    });
  })), ((_content$cards2 = content.cards) === null || _content$cards2 === void 0 ? void 0 : _content$cards2.length) > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "flex-container " + (swiper_on_mobile === "yes" ? "non-mobile-only" : "")
  }, content.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: content,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: currentLicenseType,
      labels: labels
    });
  })), swiper_on_mobile === "yes" && /*#__PURE__*/React.createElement("div", {
    className: "mobile-only",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    slidesPerView: 1,
    spaceBetween: 30,
    paginationClickable: true
  }, content.cards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id
    }, /*#__PURE__*/React.createElement(MainPricingCard, {
      product: content,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: currentLicenseType,
      labels: labels
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm disclaimer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, disclaimer), show_disclaimer === "yes" && additionalDisclaimer && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, additionalDisclaimer)), content.description && /*#__PURE__*/React.createElement("div", {
    className: "mobile-only"
  }, /*#__PURE__*/React.createElement("div", {
    className: "general-description customized-ul flex-container"
  }, parseMarkdown(content.description)))))))));
};
function collectRpiFromCard$1(card, rpis, promoCode) {
  var _card$licenses;
  card === null || card === void 0 ? void 0 : (_card$licenses = card.licenses) === null || _card$licenses === void 0 ? void 0 : _card$licenses.forEach(function (license) {
    var _license$monthly, _license$annual, _license$triennial;
    if ((_license$monthly = license.monthly) !== null && _license$monthly !== void 0 && _license$monthly.rate_plan_id) {
      rpis.set(license.monthly.rate_plan_id, {
        id: license.monthly.rate_plan_id,
        promoCode: license.monthly.promo_code || promoCode
      });
    }
    if ((_license$annual = license.annual) !== null && _license$annual !== void 0 && _license$annual.rate_plan_id) {
      rpis.set(license.annual.rate_plan_id, {
        id: license.annual.rate_plan_id,
        promoCode: license.annual.promo_code || promoCode
      });
    }
    if ((_license$triennial = license.triennial) !== null && _license$triennial !== void 0 && _license$triennial.rate_plan_id) {
      rpis.set(license.triennial.rate_plan_id, {
        id: license.triennial.rate_plan_id,
        promoCode: license.triennial.promo_code || promoCode
      });
    }
  });
}
function collectRatePlanIds$1(commercial, educational, promoCode) {
  var _commercial$cards, _educational$cards;
  var rpis = new Map();
  commercial === null || commercial === void 0 ? void 0 : (_commercial$cards = commercial.cards) === null || _commercial$cards === void 0 ? void 0 : _commercial$cards.forEach(function (card) {
    collectRpiFromCard$1(card, rpis, promoCode);
  });
  educational === null || educational === void 0 ? void 0 : (_educational$cards = educational.cards) === null || _educational$cards === void 0 ? void 0 : _educational$cards.forEach(function (card) {
    collectRpiFromCard$1(card, rpis, promoCode);
  });
  var result = [];
  rpis.forEach(function (value, _key, _map) {
    result.push(value);
  });
  return result;
}
var useGraphQL$9 = function useGraphQL(rpis) {
  if (rpis.length === 0) {
    return {};
  }
  var _useQuery = useQuery(PRICING, {
      variables: {
        input: {
          rpi: rpis
        }
      },
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache"
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var Widget$1z = function Widget(props) {
  var commercial = props.commercial,
    educational = props.educational,
    promo_code = props.promo_code;
  var pickedPromoCode = extractPromoCode(React.useContext(PageUrlContext), promo_code);
  var _React$useState = React.useState(""),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  var _React$useState2 = React.useState(""),
    country = _React$useState2[0],
    setCountry = _React$useState2[1];
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrency);
  useLocalizationCountry("", setCountry);
  var data = useGraphQL$9(collectRatePlanIds$1(commercial, educational, pickedPromoCode));
  if (!data) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, (commercial === null || commercial === void 0 ? void 0 : commercial.html_id) && /*#__PURE__*/React.createElement("div", {
      id: commercial === null || commercial === void 0 ? void 0 : commercial.html_id
    }), (educational === null || educational === void 0 ? void 0 : educational.html_id) && /*#__PURE__*/React.createElement("div", {
      id: educational === null || educational === void 0 ? void 0 : educational.html_id
    }), /*#__PURE__*/React.createElement(Placeholder$3, null));
  }
  return /*#__PURE__*/React.createElement(PricingContext.Provider, {
    value: {
      currency: currency,
      pricingData: data.pricing || {},
      country: country
    }
  }, /*#__PURE__*/React.createElement(Content$8, _extends({
    pricingData: data.pricing || {}
  }, props)));
};
var PricingStandaloneWidget = {
  __proto__: null,
  Widget: Widget$1z,
  Admin: Admin$1y,
  Config: Config$1z,
  Defaults: Defaults$1z
};
var CommercialInput$3 = function CommercialInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Commercial"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange(_extends({}, value, {
        logo: logo
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Color",
    value: value.color,
    onChange: function onChange(color) {
      return _onChange(_extends({}, value, {
        color: color
      }));
    }
  }), /*#__PURE__*/React.createElement(InputSection, {
    title: "Plans switcher settings"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Monthly tag",
    value: value.monthly_tag,
    onChange: function onChange(monthly_tag) {
      return _onChange(_extends({}, value, {
        monthly_tag: monthly_tag
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Annual tag",
    value: value.annual_tag,
    onChange: function onChange(annual_tag) {
      return _onChange(_extends({}, value, {
        annual_tag: annual_tag
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "3 years tag",
    value: value.triennial_tag,
    onChange: function onChange(triennial_tag) {
      return _onChange(_extends({}, value, {
        triennial_tag: triennial_tag
      }));
    }
  }), /*#__PURE__*/React.createElement(SelectMenu, {
    label: "Default period",
    options: [["monthly", "Monthly"], ["annual", "Annual"], ["triennial", "3 Years"]],
    value: value.default_period,
    onChange: function onChange(default_period) {
      return _onChange(_extends({}, value, {
        default_period: default_period
      }));
    }
  })), /*#__PURE__*/React.createElement(InputSection, {
    title: "General description"
  }, /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Description",
    value: value.description,
    onChange: function onChange(description) {
      return _onChange(_extends({}, value, {
        description: description
      }));
    }
  })), /*#__PURE__*/React.createElement(InputPopup, {
    label: "Cards"
  }, /*#__PURE__*/React.createElement(MainCardsInput, {
    value: value.cards,
    onChange: function onChange(cards) {
      return _onChange(_extends({}, value, {
        cards: cards
      }));
    }
  })));
};
CommercialInput$3.defaults = {
  html_id: "",
  title: "Pricing",
  sub_title: "From individual creators to the biggest enterprises, we have a plan for you",
  logo: imagePlaceholder("28"),
  color: "orange",
  monthly_tag: "",
  annual_tag: "Save 50% yearly.",
  triennial_tag: "",
  description: "",
  default_period: "",
  cards: MainCardsInput.defaults
};
var EducationalInput$3 = function EducationalInput(_ref) {
  var value = _ref.value,
    _onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(InputPopup, {
    label: "Educational"
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "HTML ID",
    value: value.html_id,
    onChange: function onChange(html_id) {
      return _onChange(_extends({}, value, {
        html_id: html_id
      }));
    }
  }), /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: value.title,
    onChange: function onChange(title) {
      return _onChange(_extends({}, value, {
        title: title
      }));
    }
  }), /*#__PURE__*/React.createElement(MarkdownInput, {
    label: "Sub title",
    value: value.sub_title,
    onChange: function onChange(sub_title) {
      return _onChange(_extends({}, value, {
        sub_title: sub_title
      }));
    }
  }), /*#__PURE__*/React.createElement(ImagePicker, {
    label: "Logo",
    value: value.logo,
    onChange: function onChange(logo) {
      return _onChange(_extends({}, value, {
        logo: logo
      }));
    }
  }), /*#__PURE__*/React.createElement(MainCardsInput, {
    value: value.cards || [],
    onChange: function onChange(cards) {
      return _onChange(_extends({}, value, {
        cards: cards
      }));
    }
  }));
};
EducationalInput$3.defaults = {
  html_id: "",
  title: "Pricing",
  sub_title: "From individual creators to the biggest enterprises, we have a plan for you",
  logo: imagePlaceholder("28"),
  cards: MainCardsInput.defaults
};
var Config$1A = {
  title: "Pricing hero",
  category: "Pricing"
};
var Defaults$1A = {
  title: "Your design companion for better decisions in real-time",
  subtitle: "Subheadline about main benefits and USPs goes here.",
  logo: imagePlaceholder("136x40"),
  background_image: imagePlaceholder("1920x1024"),
  background_video: "",
  button_1: ButtonSettings.defaults,
  button_2: _extends({}, ButtonSettings.defaults, {
    type: "secondary",
    label: "",
    link: ""
  }),
  promo_code: "",
  show_disclaimer: "no",
  swiper_on_mobile: "no",
  labels: LabelsInput.defaults,
  commercial: CommercialInput$3.defaults,
  educational: EducationalInput$3.defaults
};
var Admin$1z = {
  title: {
    type: "text"
  },
  subtitle: {
    type: "text"
  },
  logo: {
    type: "custom",
    component: ImagePicker
  },
  background_image: {
    type: "custom",
    component: ImagePicker
  },
  background_video: {
    type: "custom",
    component: VideoPicker
  },
  button_1: {
    type: "custom",
    component: ButtonSettings
  },
  button_2: {
    type: "custom",
    component: ButtonSettings
  },
  promo_code: {
    type: "text"
  },
  show_disclaimer: {
    label: "Show additional disclaimer",
    type: "select",
    options: [["yes", "Yes"], ["no", "no"]]
  },
  swiper_on_mobile: {
    label: "Cards appear as a slider on mobile",
    type: "select",
    options: [["yes", "Yes"], ["no", "no"]]
  },
  labels: {
    type: "custom",
    component: LabelsInput
  },
  commercial: {
    type: "custom",
    component: CommercialInput$3
  },
  educational: {
    type: "custom",
    component: EducationalInput$3
  }
};
var MainCard$2 = function MainCard() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "330px",
      height: "540px"
    }
  });
};
var TabHeader$3 = function TabHeader() {
  return /*#__PURE__*/React.createElement(RectShape, {
    color: colors.lightBlue,
    style: {
      width: "40%",
      height: "65px",
      marginBottom: "var(--gutter)"
    }
  });
};
var Disclaimer$2 = function Disclaimer() {
  return /*#__PURE__*/React.createElement(TextBlock, {
    rows: 2,
    color: colors.lightBlue,
    style: {
      width: "25%",
      marginBottom: "var(--gutter)"
    }
  });
};
var Placeholder$4 = function Placeholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "show-loading-animation spacing-both-xs"
  }, /*#__PURE__*/React.createElement(TabHeader$3, null), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$2, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$2, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$2, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-3"
  }, /*#__PURE__*/React.createElement(MainCard$2, null)), /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center"
    }
  }, /*#__PURE__*/React.createElement(Disclaimer$2, null)))));
};
function prepareLicenseTypes$2(labels) {
  return ["commercial", "educational"].map(function (lt) {
    return {
      id: lt,
      label: labels["license_type_switcher_" + lt]
    };
  });
}
function findHash$2() {
  if (typeof window !== "undefined") {
    return window.location.hash && window.location.hash.substring(1);
  }
  return null;
}
function initialLicenseType$2(commercial, educational) {
  var hash = findHash$2();
  if (!hash) {
    return "commercial";
  }
  if (commercial.html_id === hash) {
    return "commercial";
  }
  if (educational.html_id === hash) {
    return "educational";
  }
  return "commercial";
}
var BILLING_PERIOD_SORT_MAP$2 = {
  monthly: 0,
  annual: 1,
  triennial: 2
};
function prepareBillingPeriods$3(product) {
  var _product$cards;
  var billingPeriodsSet = new Set();
  product === null || product === void 0 ? void 0 : (_product$cards = product.cards) === null || _product$cards === void 0 ? void 0 : _product$cards.forEach(function (card) {
    card.licenses.forEach(function (license) {
      if (license.annual.rate_plan_id) {
        billingPeriodsSet.add("annual");
      }
      if (license.monthly.rate_plan_id) {
        billingPeriodsSet.add("monthly");
      }
      if (license.triennial.rate_plan_id) {
        billingPeriodsSet.add("triennial");
      }
    });
  });
  var billingPeriods = Array.from(billingPeriodsSet).map(function (bp) {
    return {
      id: bp,
      tag: product[bp + "_tag"],
      "default": product.default_period === bp
    };
  }).sort(function (a, b) {
    return BILLING_PERIOD_SORT_MAP$2[a.id] - BILLING_PERIOD_SORT_MAP$2[b.id];
  });
  return billingPeriods;
}
function calcMainCardsColClass$1(cards) {
  if (cards.length === 1) {
    return "main-col-1-3";
  }
  if (cards.length === 2) {
    return "main-col-2-3";
  }
  return "main-col";
}
var Content$9 = function Content(_ref) {
  var _billingPeriods$find, _billingPeriods$, _content$cards, _content$cards2;
  var show_disclaimer = _ref.show_disclaimer,
    swiper_on_mobile = _ref.swiper_on_mobile,
    labels = _ref.labels,
    commercial = _ref.commercial,
    educational = _ref.educational,
    pricingData = _ref.pricingData;
  React.useEffect(function () {
    setLicenseTypeId(initialLicenseType$2(commercial, educational));
    setLicensesCount(1);
  }, [commercial, educational, labels]);
  var licenseTypes = prepareLicenseTypes$2(labels);
  var _React$useState = React.useState(initialLicenseType$2(commercial, educational)),
    licenseTypeId = _React$useState[0],
    setLicenseTypeId = _React$useState[1];
  var currentLicenseType = licenseTypes.find(function (lt) {
    return lt.id === licenseTypeId;
  });
  var content = currentLicenseType.id === "educational" ? educational : commercial;
  var disclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.disclaimer;
  var additionalDisclaimer = pricingData === null || pricingData === void 0 ? void 0 : pricingData.additionalDisclaimer;
  var billingPeriods = prepareBillingPeriods$3(content);
  var _React$useState2 = React.useState(1),
    licensesCount = _React$useState2[0],
    setLicensesCount = _React$useState2[1];
  var _React$useState3 = React.useState(((_billingPeriods$find = billingPeriods.find(function (bp) {
      return bp["default"];
    })) === null || _billingPeriods$find === void 0 ? void 0 : _billingPeriods$find.id) || ((_billingPeriods$ = billingPeriods[0]) === null || _billingPeriods$ === void 0 ? void 0 : _billingPeriods$.id)),
    billingPeriodId = _React$useState3[0],
    setBillingPeriodId = _React$useState3[1];
  var currentBillingPeriod = billingPeriods.find(function (bp) {
    return bp.id === billingPeriodId;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "container pricing-section"
  }, /*#__PURE__*/React.createElement(TabHeader, {
    tab: content
  }), /*#__PURE__*/React.createElement("div", {
    className: "row flex-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "side-col"
  }, currentLicenseType.id === "commercial" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PlanSwitcher, {
    labels: labels,
    billingPeriod: currentBillingPeriod,
    billingPeriods: billingPeriods,
    licenseType: currentLicenseType,
    licenseTypes: licenseTypes,
    licensesCount: licensesCount,
    onLicensesCountChange: setLicensesCount,
    onBillingPeriodChange: function onBillingPeriodChange(bp) {
      return setBillingPeriodId(bp.id);
    },
    onLicenseTypeChange: function onLicenseTypeChange(lt) {
      setLicenseTypeId(lt.id);
      setLicensesCount(1);
    }
  }), content.description && /*#__PURE__*/React.createElement("div", {
    className: "non-mobile-only"
  }, /*#__PURE__*/React.createElement("div", {
    className: "general-description customized-ul"
  }, parseMarkdown(content.description)))), currentLicenseType.id === "educational" && /*#__PURE__*/React.createElement(LicenseTypeSwitcher, {
    labels: labels,
    licenseType: currentLicenseType,
    licenseTypes: licenseTypes,
    onChange: function onChange(lt) {
      setLicenseTypeId(lt.id);
      setLicensesCount(1);
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: calcMainCardsColClass$1(content.cards)
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-fit"
  }, ((_content$cards = content.cards) === null || _content$cards === void 0 ? void 0 : _content$cards.length) === 1 && /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, content.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: content,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: currentLicenseType,
      labels: labels
    });
  })), ((_content$cards2 = content.cards) === null || _content$cards2 === void 0 ? void 0 : _content$cards2.length) > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: swiper_on_mobile === "yes" ? "non-mobile-only" : ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-container"
  }, content.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(MainPricingCard, {
      key: card.id,
      product: content,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: currentLicenseType,
      labels: labels
    });
  }))), swiper_on_mobile === "yes" && /*#__PURE__*/React.createElement("div", {
    className: "mobile-only",
    style: {
      width: "100%"
    }
  }, /*#__PURE__*/React.createElement(Slider, {
    rebuildOnUpdate: true,
    navigation: false,
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true
    },
    slidesPerView: 1,
    spaceBetween: 30,
    paginationClickable: true
  }, content.cards.map(function (card) {
    return /*#__PURE__*/React.createElement("div", {
      key: card.id
    }, /*#__PURE__*/React.createElement(MainPricingCard, {
      product: content,
      card: card,
      billingPeriod: currentBillingPeriod,
      licensesCount: licensesCount,
      licenseType: currentLicenseType,
      labels: labels
    }));
  })))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm disclaimer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, disclaimer), show_disclaimer === "yes" && additionalDisclaimer && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, additionalDisclaimer)), content.description && /*#__PURE__*/React.createElement("div", {
    className: "mobile-only"
  }, /*#__PURE__*/React.createElement("div", {
    className: "general-description customized-ul flex-container"
  }, parseMarkdown(content.description)))))));
};
var HostedVideo$7 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video background"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video background"
  }, /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  }), /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video."));
};
var _excluded$j = ["title", "subtitle", "logo", "background_image", "background_video", "button_1", "button_2", "containerSettings"];
var useVideoGraphQL = function useVideoGraphQL(variables) {
  var _useQuery = useQuery(VIDEOS, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache"
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
function collectRpiFromCard$2(card, rpis, promoCode) {
  var _card$licenses;
  card === null || card === void 0 ? void 0 : (_card$licenses = card.licenses) === null || _card$licenses === void 0 ? void 0 : _card$licenses.forEach(function (license) {
    var _license$monthly, _license$annual, _license$triennial;
    if ((_license$monthly = license.monthly) !== null && _license$monthly !== void 0 && _license$monthly.rate_plan_id) {
      rpis.set(license.monthly.rate_plan_id, {
        id: license.monthly.rate_plan_id,
        promoCode: license.monthly.promo_code || promoCode
      });
    }
    if ((_license$annual = license.annual) !== null && _license$annual !== void 0 && _license$annual.rate_plan_id) {
      rpis.set(license.annual.rate_plan_id, {
        id: license.annual.rate_plan_id,
        promoCode: license.annual.promo_code || promoCode
      });
    }
    if ((_license$triennial = license.triennial) !== null && _license$triennial !== void 0 && _license$triennial.rate_plan_id) {
      rpis.set(license.triennial.rate_plan_id, {
        id: license.triennial.rate_plan_id,
        promoCode: license.triennial.promo_code || promoCode
      });
    }
  });
}
function collectRatePlanIds$2(commercial, educational, promoCode) {
  var _commercial$cards, _educational$cards;
  var rpis = new Map();
  commercial === null || commercial === void 0 ? void 0 : (_commercial$cards = commercial.cards) === null || _commercial$cards === void 0 ? void 0 : _commercial$cards.forEach(function (card) {
    collectRpiFromCard$2(card, rpis, promoCode);
  });
  educational === null || educational === void 0 ? void 0 : (_educational$cards = educational.cards) === null || _educational$cards === void 0 ? void 0 : _educational$cards.forEach(function (card) {
    collectRpiFromCard$2(card, rpis, promoCode);
  });
  var result = [];
  rpis.forEach(function (value, _key, _map) {
    result.push(value);
  });
  return result;
}
var useGraphQL$a = function useGraphQL(rpis) {
  if (rpis.length === 0) {
    return {};
  }
  var _useQuery2 = useQuery(PRICING, {
      variables: {
        input: {
          rpi: rpis
        }
      },
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache"
    }),
    data = _useQuery2.data,
    loading = _useQuery2.loading,
    error = _useQuery2.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
var Pricing = function Pricing(props) {
  var commercial = props.commercial,
    educational = props.educational,
    promo_code = props.promo_code;
  var pickedPromoCode = extractPromoCode(React.useContext(PageUrlContext), promo_code);
  var _React$useState = React.useState(""),
    currency = _React$useState[0],
    setCurrency = _React$useState[1];
  var _React$useState2 = React.useState(""),
    country = _React$useState2[0],
    setCountry = _React$useState2[1];
  useLocalizationCurrency(React.useContext(CurrencyContext), setCurrency);
  useLocalizationCountry("", setCountry);
  var data = useGraphQL$a(collectRatePlanIds$2(commercial, educational, pickedPromoCode));
  if (!data) {
    return /*#__PURE__*/React.createElement("div", {
      className: "container pricing-section"
    }, (commercial === null || commercial === void 0 ? void 0 : commercial.html_id) && /*#__PURE__*/React.createElement("div", {
      id: commercial === null || commercial === void 0 ? void 0 : commercial.html_id
    }), (educational === null || educational === void 0 ? void 0 : educational.html_id) && /*#__PURE__*/React.createElement("div", {
      id: educational === null || educational === void 0 ? void 0 : educational.html_id
    }), /*#__PURE__*/React.createElement(Placeholder$4, null));
  }
  return /*#__PURE__*/React.createElement(PricingContext.Provider, {
    value: {
      currency: currency,
      pricingData: data.pricing || {},
      country: country
    }
  }, /*#__PURE__*/React.createElement(Content$9, _extends({
    pricingData: data.pricing || {}
  }, props)));
};
var Widget$1A = function Widget(_ref) {
  var _videoData$videos;
  var title = _ref.title,
    subtitle = _ref.subtitle,
    logo = _ref.logo,
    background_image = _ref.background_image,
    background_video = _ref.background_video,
    button_1 = _ref.button_1,
    button_2 = _ref.button_2,
    containerSettings = _ref.containerSettings,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$j);
  var videoData = useVideoGraphQL({
    input: {
      filters: {
        ids: background_video
      }
    }
  });
  var video = (videoData === null || videoData === void 0 ? void 0 : (_videoData$videos = videoData.videos) === null || _videoData$videos === void 0 ? void 0 : _videoData$videos.list[0]) || null;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings)
  }, /*#__PURE__*/React.createElement("div", {
    className: "pricing-hero"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hero-section"
  }, /*#__PURE__*/React.createElement(HostedVideo$7, {
    video: video,
    cover: background_image
  }), /*#__PURE__*/React.createElement("div", {
    className: "gradient background"
  }), /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, /*#__PURE__*/React.createElement(Image, {
    loading: "lazy",
    src: logo,
    variant: "thumb"
  })), /*#__PURE__*/React.createElement("div", {
    className: "title-description"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title"
  }, title), /*#__PURE__*/React.createElement("p", {
    className: "subtitle"
  }, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "buttons"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: button_1
  }), /*#__PURE__*/React.createElement(Button$1, {
    settings: button_2
  })))), /*#__PURE__*/React.createElement("div", {
    className: "non-mobile-only"
  }, /*#__PURE__*/React.createElement(Pricing, rest)))), /*#__PURE__*/React.createElement("div", {
    className: "mobile-only"
  }, /*#__PURE__*/React.createElement(Pricing, rest))));
};
var PricingHeroWidget = {
  __proto__: null,
  Widget: Widget$1A,
  Admin: Admin$1z,
  Config: Config$1A,
  Defaults: Defaults$1A
};
var ImagesInput$1 = function ImagesInput(_ref) {
  var label = _ref.label,
    value = _ref.value,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: label,
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ImagePicker, {
        label: "Image",
        value: settings.image,
        onChange: function onChange(value) {
          return onChangeItem("image", value);
        }
      });
    },
    items: value.map(function (item, idx) {
      return {
        id: item.id || idx,
        image: item
      };
    }),
    template: {
      image: ""
    },
    primaryField: "image.name",
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList.map(function (item) {
        return item.image;
      }));
    }
  });
};
var SlidesInput = function SlidesInput(_ref2) {
  var value = _ref2.value,
    onChange = _ref2.onChange;
  return /*#__PURE__*/React.createElement(List, {
    label: "Slides",
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ImagesInput$1, {
        label: "Logos",
        value: settings.logos,
        onChange: function onChange(value) {
          return onChangeItem("logos", value);
        }
      }), /*#__PURE__*/React.createElement(MarkdownInput, {
        label: "Title",
        value: settings.title,
        onChange: function onChange(value) {
          return onChangeItem("title", value);
        }
      }), /*#__PURE__*/React.createElement(MarkdownInput, {
        label: "Description",
        value: settings.description,
        onChange: function onChange(value) {
          return onChangeItem("description", value);
        }
      }), /*#__PURE__*/React.createElement(InputSection, {
        title: "Slide media"
      }, /*#__PURE__*/React.createElement(MediaTabsMediaInput, {
        label: "Media",
        value: settings.media,
        onChange: function onChange(value) {
          return onChangeItem("media", value);
        }
      })));
    },
    items: value,
    primaryField: "title",
    template: {
      media: MediaTabsMediaInput.defaults,
      title: "Build the foundation of your visual story",
      description: "Scene setup starts with context. Quickly build the scene from your CAD/ DCC model with ready-to-render assets from Cosmos and Anima for scale and realism.",
      logos: [imagePlaceholder("24"), imagePlaceholder("24"), imagePlaceholder("32"), imagePlaceholder("32")]
    },
    onChangeList: function onChangeList(_list, newList) {
      return onChange(newList);
    }
  });
};
var ListItem$D = function ListItem(_ref3) {
  var settings = _ref3.settings,
    onChangeItem = _ref3.onChangeItem;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextInput, {
    label: "Title",
    value: settings.title,
    onChange: function onChange(value) {
      return onChangeItem("title", value);
    }
  }), /*#__PURE__*/React.createElement(SlidesInput, {
    value: settings.slides || [],
    onChange: function onChange(value) {
      return onChangeItem("slides", value);
    }
  }));
};
var TEMPLATE$w = {
  title: "Scene assembly",
  slides: [{
    id: 1,
    media: MediaTabsMediaInput.defaults,
    title: "Build the foundation of your visual story",
    description: "Scene setup starts with context. Quickly build the scene from your CAD/ DCC model with ready-to-render assets from Cosmos and Anima for scale and realism.",
    logos: [imagePlaceholder("24"), imagePlaceholder("24"), imagePlaceholder("32"), imagePlaceholder("32")]
  }]
};
var SectionsInput = function SectionsInput(_ref4) {
  var value = _ref4.value,
    onChange = _ref4.onChange;
  return /*#__PURE__*/React.createElement(List, {
    listItem: function listItem(settings, onChangeItem) {
      return /*#__PURE__*/React.createElement(ListItem$D, {
        settings: settings,
        onChangeItem: onChangeItem
      });
    },
    items: value,
    primaryField: "title",
    template: TEMPLATE$w,
    onChangeList: function onChangeList(_list, value) {
      return onChange(value);
    }
  });
};
SectionsInput.defaults = [_extends({
  id: 1
}, TEMPLATE$w), _extends({
  id: 2
}, TEMPLATE$w), _extends({
  id: 3
}, TEMPLATE$w)];
var Config$1B = {
  title: "Workflow",
  category: "General"
};
var Defaults$1B = {
  title: "ArchViz Collection",
  sub_title: "Designed for visual storytelling - your companion for every phase of visualization",
  cta: ButtonSettings.defaults,
  primary_color: "#F7941D",
  light_color: "#FF8E4E",
  button_label: "Skip",
  sections: SectionsInput.defaults
};
var Admin$1A = {
  title: {
    type: "text",
    hint: "Supports markdown"
  },
  sub_title: {
    type: "text"
  },
  cta: {
    type: "custom",
    component: ButtonSettings
  },
  primary_color: {
    type: "text"
  },
  light_color: {
    type: "text"
  },
  button_label: {
    type: "text"
  },
  sections: {
    type: "custom",
    component: SectionsInput
  }
};
var Circle = function Circle(_ref) {
  var color = _ref.color,
    lightColor = _ref.lightColor;
  return /*#__PURE__*/React.createElement("svg", {
    width: "46",
    height: "45",
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "circle-icon"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10057_22263)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "22.5",
    r: "5.5",
    fill: color
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "23",
    cy: "22.5",
    r: "5",
    stroke: lightColor
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10057_22263",
    x: "0.6",
    y: "0.1",
    width: "44.8",
    height: "44.8",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: "8.45"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.443137 0 0 0 0 0.168627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10057_22263"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10057_22263",
    result: "shape"
  }))));
};
var HostedVideo$8 = function HostedVideo(_ref) {
  var video = _ref.video,
    cover = _ref.cover;
  var videoRef = React.useRef(null);
  var _React$useState = React.useState(false),
    play = _React$useState[0],
    setPlay = _React$useState[1];
  React.useEffect(function () {
    if (!video) {
      return;
    }
    var videoEl = videoRef.current;
    if (!videoEl) return;
    videoEl.muted = true;
    videoEl.defaultMuted = true;
    videoEl.src = video.asset_mp4_url;
    return function () {};
  }, [video]);
  if (!video) {
    return /*#__PURE__*/React.createElement("div", {
      className: "hosted-video only-image"
    }, /*#__PURE__*/React.createElement(Img, {
      loading: "lazy",
      src: cover,
      variant: "image"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "hosted-video",
    onClick: function onClick() {
      return setPlay(true);
    }
  }, play || !cover ? /*#__PURE__*/React.createElement("video", {
    ref: videoRef,
    autoPlay: true,
    playsInline: true,
    muted: true,
    loop: true
  }, /*#__PURE__*/React.createElement("source", {
    src: video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "icon-play-round"
  }), /*#__PURE__*/React.createElement(Img, {
    loading: "lazy",
    src: cover,
    variant: "image"
  })));
};
var NotSupported = function NotSupported(_ref) {
  var title = _ref.title;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      aspectRatio: "16/9"
    }
  }, /*#__PURE__*/React.createElement("h3", null, "\"", title, "\" not supported!"));
};
var ImageMedia$1 = function ImageMedia(_ref2) {
  var image = _ref2.image;
  return /*#__PURE__*/React.createElement("div", {
    className: "media-image"
  }, image && /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "simple_image_slider",
    className: "content-image",
    loading: "lazy"
  }));
};
var VideoMedia$1 = function VideoMedia(_ref3) {
  var videos = _ref3.videos,
    video = _ref3.video,
    video_preview = _ref3.video_preview;
  var toPlay = videos.find(function (v) {
    return v.id === video;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "media-video"
  }, /*#__PURE__*/React.createElement(HostedVideo$8, {
    video: toPlay,
    cover: video_preview
  }));
};
var SliderMedia$1 = function SliderMedia(_ref4) {
  var slides = _ref4.slides,
    left_label = _ref4.left_label,
    right_label = _ref4.right_label;
  console.warn({
    slides: slides,
    left_label: left_label,
    right_label: right_label
  });
  return /*#__PURE__*/React.createElement(NotSupported, {
    title: "Slider"
  });
};
var IframeMedia$1 = function IframeMedia(_ref5) {
  var iframe = _ref5.iframe;
  return /*#__PURE__*/React.createElement("div", {
    className: "media-iframe"
  }, /*#__PURE__*/React.createElement("iframe", {
    src: iframe,
    frameborder: "0"
  }));
};
var CompareMedia$1 = function CompareMedia(_ref6) {
  var image_1 = _ref6.image_1,
    image_2 = _ref6.image_2;
  return /*#__PURE__*/React.createElement("div", {
    className: "media-compare"
  }, /*#__PURE__*/React.createElement(ReactCompareImage, {
    leftImage: image_1.urls.original ? image_1.urls.original : image_1,
    rightImage: image_2.urls.original ? image_2.urls.original : image_2,
    sliderLineWidth: 4
  }));
};
var SideBySideImagesMedia$1 = function SideBySideImagesMedia(_ref7) {
  var images = _ref7.images;
  console.warn({
    images: images
  });
  return /*#__PURE__*/React.createElement(NotSupported, {
    title: "Side by side images"
  });
};
var MEDIA$3 = {
  image: ImageMedia$1,
  video: VideoMedia$1,
  slider: SliderMedia$1,
  iframe: IframeMedia$1,
  compare: CompareMedia$1,
  side_by_side_images: SideBySideImagesMedia$1
};
var Media$1 = function Media(_ref8) {
  var videos = _ref8.videos,
    media = _ref8.media;
  var MediaComponent = MEDIA$3[media.type];
  return /*#__PURE__*/React.createElement("div", {
    className: "media"
  }, /*#__PURE__*/React.createElement(MediaComponent, _extends({
    videos: videos
  }, media)));
};
function buildLineStyle(direction, color) {
  if (direction === "up") {
    return {
      background: "linear-gradient(to bottom, rgba(246, 246, 246, 0) 0%, " + color + " 100%)"
    };
  }
  if (direction === "down") {
    return {
      background: "linear-gradient(to top, rgba(246, 246, 246, 0) 0%, " + color + " 100%)"
    };
  }
  if (direction === "both") {
    return {
      background: "linear-gradient(to bottom, rgba(246, 246, 246, 0) 0%, " + color + " 50%, rgba(246, 246, 246, 0) 100%)"
    };
  }
  return {
    backgroundColor: color
  };
}
var Line = function Line(_ref) {
  var primaryColor = _ref.primaryColor,
    direction = _ref.direction;
  return /*#__PURE__*/React.createElement("div", {
    className: "timeline"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "line-wrap"
  }, /*#__PURE__*/React.createElement("div", {
    className: ["line", direction].filter(Boolean).join(" "),
    style: _extends({}, buildLineStyle(direction, primaryColor))
  }))))));
};
var Content$a = function Content(_ref) {
  var logos = _ref.logos,
    title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, logos.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "logos"
  }, logos === null || logos === void 0 ? void 0 : logos.map(function (logo, idx) {
    return /*#__PURE__*/React.createElement(Image, {
      key: idx + "-" + logo.id,
      src: logo,
      variant: "thumb"
    });
  })), /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, parseMarkdown(title, true)), description && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(description, true)));
};
var SimpleSection = function SimpleSection(_ref2) {
  var elementRef = _ref2.elementRef,
    index = _ref2.index,
    sectionsCount = _ref2.sectionsCount,
    title = _ref2.title,
    primaryColor = _ref2.primaryColor,
    lightColor = _ref2.lightColor,
    slide = _ref2.slide,
    stickyOffset = _ref2.stickyOffset,
    videos = _ref2.videos;
  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef,
    className: "simple-section",
    style: {
      height: "calc(100vh - " + stickyOffset + "px)"
    }
  }, /*#__PURE__*/React.createElement(Line, {
    primaryColor: primaryColor,
    direction: index === 0 ? "both" : "down"
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row outer-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-num"
  }, /*#__PURE__*/React.createElement("div", {
    className: "num",
    style: {
      color: primaryColor
    }
  }, index + 1), /*#__PURE__*/React.createElement("div", {
    className: "arrow-up",
    style: _extends({}, buildLineStyle("up", primaryColor))
  }), /*#__PURE__*/React.createElement(Circle, {
    color: primaryColor,
    lightColor: lightColor
  }), /*#__PURE__*/React.createElement("div", {
    className: "rectangle",
    style: _extends({}, buildLineStyle("none", primaryColor))
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-11"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "section-title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "row inner-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slide"
  }, /*#__PURE__*/React.createElement(Media$1, {
    media: slide.media,
    videos: videos
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col-6"
  }, /*#__PURE__*/React.createElement(Content$a, slide)))))), /*#__PURE__*/React.createElement(Line, {
    primaryColor: primaryColor,
    direction: index === sectionsCount - 1 ? "down" : ""
  }));
};
var Content$b = function Content(_ref) {
  var logos = _ref.logos,
    title = _ref.title,
    description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, logos.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "logos"
  }, logos === null || logos === void 0 ? void 0 : logos.map(function (logo, idx) {
    return /*#__PURE__*/React.createElement(Image, {
      key: idx + "-" + logo.id,
      src: logo,
      variant: "thumb"
    });
  })), /*#__PURE__*/React.createElement("h3", {
    className: "title"
  }, parseMarkdown(title, true)), description && /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(description, true)));
};
var Marker = function Marker(_ref2) {
  var onUpdate = _ref2.onUpdate;
  var elementRef = React.useRef(null);
  React.useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var percentage = Math.floor(entry.intersectionRatio * 100);
        onUpdate(percentage);
      });
    }, {
      threshold: Array.from({
        length: 101
      }, function (_, i) {
        return i / 100;
      })
    });
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
    return function () {
      if (observer && elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [elementRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef,
    style: {
      height: "100px"
    }
  });
};
function mapZindecies(current, slides) {
  var zIndexArray = slides.map(function (_, idx) {
    return idx;
  });
  for (var i = current; i < slides.length + current; i++) {
    zIndexArray[i % zIndexArray.length] = zIndexArray.length - (i - current);
  }
  return zIndexArray;
}
var Slides = function Slides(_ref3) {
  var elementRef = _ref3.elementRef,
    index = _ref3.index,
    sectionsCount = _ref3.sectionsCount,
    title = _ref3.title,
    primaryColor = _ref3.primaryColor,
    lightColor = _ref3.lightColor,
    slides = _ref3.slides,
    stickyOffset = _ref3.stickyOffset,
    videos = _ref3.videos;
  var state = React.useRef(slides.map(function (_, idx) {
    return {
      visibility: idx === 0 ? 100 : 0
    };
  }));
  var _React$useState = React.useState(0),
    current = _React$useState[0],
    setCurrent = _React$useState[1];
  var zIndexArray = mapZindecies(current, slides);
  var scrollHeight = "calc(calc(calc(" + slides.length + " * calc(100vh + 100px)) - 50vh) + 200px)";
  return /*#__PURE__*/React.createElement("div", {
    ref: elementRef,
    className: "slides-container",
    style: {
      height: scrollHeight,
      minHeight: "calc(100vh - " + stickyOffset + "px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "slides-wrapper",
    style: {
      top: stickyOffset + "px",
      height: "calc(100vh - " + stickyOffset + "px)"
    }
  }, slides.map(function (slide, slideIdx) {
    return /*#__PURE__*/React.createElement("div", {
      key: slideIdx,
      className: "magic-slide",
      style: {
        opacity: slideIdx === current ? 1 : 0,
        height: "calc(100vh - " + stickyOffset + "px)"
      }
    }, /*#__PURE__*/React.createElement(Line, {
      primaryColor: primaryColor,
      direction: index === 0 ? "both" : "down"
    }), /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "row outer-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "section-num"
    }, /*#__PURE__*/React.createElement("div", {
      className: "num",
      style: {
        color: primaryColor
      }
    }, index + 1), /*#__PURE__*/React.createElement("div", {
      className: "arrow-up",
      style: _extends({}, buildLineStyle("up", primaryColor))
    }), /*#__PURE__*/React.createElement(Circle, {
      color: primaryColor,
      lightColor: lightColor
    }), /*#__PURE__*/React.createElement("div", {
      className: "rectangle",
      style: _extends({}, buildLineStyle("none", primaryColor))
    }))), /*#__PURE__*/React.createElement("div", {
      className: "col-11"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "section-title"
    }, title), /*#__PURE__*/React.createElement("div", {
      className: "row inner-row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-6"
    }, /*#__PURE__*/React.createElement("div", {
      className: "slide"
    }, slides.map(function (innerSlide, slideInnerIdx) {
      var zIndex = zIndexArray[slideInnerIdx];
      var currentZindex = zIndexArray[current];
      var scale = 1 - (currentZindex - zIndex) / 10;
      var move = 1.5 * (1 - scale) * 100;
      return /*#__PURE__*/React.createElement("div", {
        key: slideInnerIdx,
        className: "inner",
        style: {
          transform: "scale(" + scale + ") translateY(-" + move + "%)",
          zIndex: zIndex
        }
      }, /*#__PURE__*/React.createElement(Media$1, {
        media: innerSlide.media,
        videos: videos
      }));
    }))), /*#__PURE__*/React.createElement("div", {
      className: "col-6"
    }, /*#__PURE__*/React.createElement(Content$b, slide)))))), /*#__PURE__*/React.createElement(Line, {
      primaryColor: primaryColor,
      direction: index === sectionsCount - 1 ? "down" : ""
    }));
  })), /*#__PURE__*/React.createElement("div", {
    className: "markers-container"
  }, slides.map(function (_slide, slideIdx) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Marker, {
      key: slideIdx,
      index: slideIdx,
      onUpdate: function onUpdate(percentage) {
        state.current = state.current.map(function (marker, stateIdx) {
          if (slideIdx === stateIdx) {
            return _extends({}, marker, {
              visibility: percentage
            });
          } else {
            return _extends({}, marker);
          }
        });
        setCurrent(function (oldValue) {
          if (percentage > 0 && slideIdx !== oldValue) {
            return slideIdx;
          }
          return oldValue;
        });
      }
    }), /*#__PURE__*/React.createElement("div", {
      style: {
        height: slideIdx === slides.length - 1 ? "50vh" : "100vh"
      }
    }));
  })));
};
var Section = function Section(_ref) {
  var title = _ref.title,
    slides = _ref.slides,
    index = _ref.index,
    sectionsCount = _ref.sectionsCount,
    primaryColor = _ref.primaryColor,
    lightColor = _ref.lightColor,
    stickyOffset = _ref.stickyOffset,
    videos = _ref.videos,
    onVisibilityUpdate = _ref.onVisibilityUpdate;
  var elementRef = React.useRef(null);
  React.useEffect(function () {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var percentage = Math.floor(entry.intersectionRatio * 100);
        onVisibilityUpdate(percentage, elementRef);
      });
    }, {
      threshold: Array.from({
        length: 101
      }, function (_, i) {
        return i / 100;
      })
    });
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }
    return function () {
      if (observer && elementRef.current) {
        observer.unobserve(elementRef.current);
      }
    };
  }, [elementRef]);
  if (!slides.length) {
    return null;
  }
  if (slides.length === 1) {
    return /*#__PURE__*/React.createElement(SimpleSection, {
      elementRef: elementRef,
      index: index,
      sectionsCount: sectionsCount,
      title: title,
      slide: slides[0],
      stickyOffset: stickyOffset,
      primaryColor: primaryColor,
      lightColor: lightColor,
      videos: videos
    });
  }
  return /*#__PURE__*/React.createElement(Slides, {
    elementRef: elementRef,
    title: title,
    slides: slides,
    stickyOffset: stickyOffset,
    index: index,
    sectionsCount: sectionsCount,
    primaryColor: primaryColor,
    lightColor: lightColor,
    videos: videos
  });
};
var Header$1 = function Header(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    color = _ref.color,
    cta = _ref.cta;
  return /*#__PURE__*/React.createElement("div", {
    className: "workflow-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "title",
    style: {
      color: color
    }
  }, parseMarkdown(title, true)), subTitle && /*#__PURE__*/React.createElement("h5", {
    className: "sub-title"
  }, parseMarkdown(subTitle, true)), (cta === null || cta === void 0 ? void 0 : cta.label) && /*#__PURE__*/React.createElement("div", {
    className: "cta-wrapper"
  }, /*#__PURE__*/React.createElement(Button$1, {
    settings: cta
  }))));
};
var useGraphQL$b = function useGraphQL(query, variables) {
  var _useQuery = useQuery(query, {
      variables: variables,
      fetchPolicy: "no-cache",
      nextFetchPolicy: "no-cache",
      skip: variables.input.filters.ids.length === 0
    }),
    data = _useQuery.data,
    loading = _useQuery.loading,
    error = _useQuery.error;
  if (loading) {
    return null;
  }
  if (error) {
    return null;
  }
  return data;
};
function collectVideoIds$6(items) {
  var ids = new Set();
  items.forEach(function (item) {
    var _item$media;
    ids.add(item === null || item === void 0 ? void 0 : (_item$media = item.media) === null || _item$media === void 0 ? void 0 : _item$media.video);
  });
  return Array.from(ids).filter(Boolean);
}
function findIndexForMaxValue(collection) {
  var max = collection[0].visibility;
  var idx = 0;
  for (var i = 0; i < collection.length; i++) {
    if (max < collection[i].visibility) {
      max = collection[i].visibility;
      idx = i;
    }
  }
  return idx;
}
var Arrow$1 = function Arrow() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9H14.25M14.25 9L9 3.75M14.25 9L9 14.25",
    stroke: "currentColor",
    strokeWidth: "1.66667",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
var Widget$1B = function Widget(_ref2) {
  var _videosData$videos;
  var title = _ref2.title,
    sub_title = _ref2.sub_title,
    cta = _ref2.cta,
    primary_color = _ref2.primary_color,
    light_color = _ref2.light_color,
    sections = _ref2.sections,
    button_label = _ref2.button_label,
    containerSettings = _ref2.containerSettings;
  var _React$useState = React.useState(0),
    current = _React$useState[0],
    setCurrent = _React$useState[1];
  var state = React.useRef(sections.map(function (_, idx) {
    return {
      visibility: idx === 0 ? 100 : 0,
      ref: null
    };
  }));
  var headerRef = React.useRef(null);
  var _React$useState2 = React.useState(0),
    stickyOffset = _React$useState2[0],
    setStickyOffset = _React$useState2[1];
  React.useEffect(function () {
    if (headerRef.current) {
      var headerOffset = 0;
      if (typeof window !== "undefined") {
        if (window.innerWidth < 1199) {
          headerOffset = 60;
        }
        if (window.innerWidth > 1184 && window.innerWidth < 1199) {
          headerOffset = 90;
        }
      }
      setStickyOffset(headerRef.current.getBoundingClientRect().height + headerOffset);
    }
  }, []);
  var collectedIds = React.useMemo(function () {
    return collectVideoIds$6(sections);
  }, [sections]);
  var videosData = useGraphQL$b(VIDEOS, {
    input: {
      filters: {
        ids: collectedIds
      }
    }
  });
  var videos = (videosData === null || videosData === void 0 ? void 0 : (_videosData$videos = videosData.videos) === null || _videosData$videos === void 0 ? void 0 : _videosData$videos.list) || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "workflow"
  }, /*#__PURE__*/React.createElement(Container$1, {
    settings: _extends({}, containerSettings, {
      theme: "none"
    }),
    className: "workflow-custom-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "workflow-header-wrapper",
    ref: headerRef
  }, /*#__PURE__*/React.createElement(Header$1, {
    title: title,
    subTitle: sub_title,
    color: primary_color,
    cta: cta
  })), /*#__PURE__*/React.createElement("div", {
    className: "sections"
  }, sections.map(function (section, idx) {
    return /*#__PURE__*/React.createElement(Section, _extends({
      key: section.id,
      stickyOffset: stickyOffset,
      index: idx,
      sectionsCount: sections.length,
      primaryColor: primary_color,
      lightColor: light_color,
      videos: videos,
      onVisibilityUpdate: function onVisibilityUpdate(percentage, ref) {
        state.current = state.current.map(function (section, stateIdx) {
          if (idx === stateIdx) {
            return _extends({}, section, {
              visibility: percentage,
              ref: ref
            });
          } else {
            return _extends({}, section);
          }
        });
        setCurrent(function (_oldValue) {
          var newCurrent = findIndexForMaxValue(state.current);
          return newCurrent;
        });
      }
    }, section));
  })), /*#__PURE__*/React.createElement("div", {
    className: "skip-btn-wrapper",
    style: {
      visibility: current === sections.length - 1 ? "hidden" : "visible"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: buttonClass("secondary", "skip-btn"),
    onClick: function onClick() {
      var _next$ref;
      var next = state.current[current + 1];
      if ((_next$ref = next.ref) !== null && _next$ref !== void 0 && _next$ref.current) {
        var _next$ref2;
        window.scrollTo({
          top: cumulativeTopOffset((_next$ref2 = next.ref) === null || _next$ref2 === void 0 ? void 0 : _next$ref2.current),
          left: 0,
          behavior: "smooth"
        });
      }
    }
  }, /*#__PURE__*/React.createElement("span", null, button_label || "Skip"), /*#__PURE__*/React.createElement(Arrow$1, null))))));
};
var WorkflowWidget = {
  __proto__: null,
  Widget: Widget$1B,
  Admin: Admin$1A,
  Config: Config$1B,
  Defaults: Defaults$1B
};
var index = {
  AccordionWidget: Widget,
  AdvancedFluidLogosWidget: Widget$1,
  AdvancedFormWidget: Widget$2,
  AdvancedSubMenuWidget: Widget$3,
  AutocompleteWidget: Widget$4,
  BeforeAfterSliderWidget: Widget$5,
  BenefitsWithIconsWidget: Widget$6,
  BlogFeedWidget: Widget$7,
  BoothPresentationsWidget: Widget$8,
  BreadcrumbsWidget: Widget$9,
  CallToActionWidget: Widget$a,
  CardsWidget: Widget$b,
  CardsWithIconsWidget: Widget$c,
  CarouselWithThumbsWidget: Widget$d,
  CategoriesListWidget: Widget$e,
  CloudPricingWidget: Widget$f,
  CodeHighlightWidget: Widget$g,
  CtaButtonAdvancedWidget: Widget$i,
  CustomHtmlWidget: Widget$j,
  EmbeddedVideoWidget: Widget$k,
  EventsPartnersWidget: Widget$l,
  EventsSpeakersWidget: Widget$m,
  EventsVrayDaysWidget: Widget$n,
  FaqCategoriesAccordionWidget: Widget$o,
  FaqCategoriesFeedWidget: Widget$p,
  FluidLogosWidget: Widget$q,
  FullWidthImageWidget: Widget$r,
  FullWidthVideoWidget: Widget$s,
  GalleryStripWidget: Widget$u,
  GalleryWidget: Widget$t,
  IconCardsWidget: Widget$v,
  ImageAndTextWidget: Widget$w,
  LeadImageSliderWidget: Widget$x,
  MentorsWidget: Widget$z,
  NotificationBarWidget: Widget$y,
  PackagePricingWidget: Widget$A,
  PageCollectionWidget: Widget$B,
  PlaceholderWidget: Widget$C,
  PodcastFeedWidget: Widget$E,
  PodcastWidget: Widget$D,
  PriceComparisonWidget: Widget$F,
  ProductBarWidget: Widget$G,
  PromoBanerWidget: Widget$H,
  QuoteBarWidget: Widget$I,
  ScheduleWidget: Widget$J,
  SectionTitleWidget: Widget$K,
  SeparatorWidget: Widget$L,
  SimpleFormWidget: Widget$M,
  SimpleGalleryWidget: Widget$N,
  SingleImageWidget: Widget$O,
  SocialShareBarWidget: Widget$P,
  SpacingWidget: Widget$Q,
  SpotlightImageWidget: Widget$R,
  SquareThumbsWidget: Widget$S,
  SubMenuWidget: Widget$T,
  TableWidget: Widget$U,
  TabsWidget: Widget$V,
  TestimonialSliderWidget: Widget$X,
  TestimonialWidget: Widget$W,
  TextAndMediaWidget: Widget$Y,
  TextBoxWidget: Widget$Z,
  ThumbsListWidget: Widget$_,
  MagazineArticlesWidget: Widget$$,
  CountdownWidget: Widget$h,
  ProductCardsWidget: Widget$10,
  SingleTrialWidget: Widget$11,
  LinksWithIconWidget: Widget$12,
  ProductListWidget: Widget$13,
  FeaturedPricingWidget: Widget$14,
  NewTestimonialSliderWidget: Widget$15,
  HubSpotWidget: Widget$16,
  LogosSliderWidget: Widget$17,
  VideoLibraryWidget: Widget$18,
  SubscriptionWidget: Widget$19,
  SimpleBlogFeedWidget: Widget$1a,
  ResellersWidget: Widget$1b,
  EducatorsFormWidget: Widget$1c,
  SearchBarWidget: Widget$1d,
  RatingStatsWidget: Widget$1e,
  ImageAndTextTabsWidget: Widget$1f,
  IndustryTabsWidget: Widget$1g,
  NewIndustryTabsWidget: Widget$1h,
  GalleryMasonryWidget: Widget$1i,
  SocialProofWidget: Widget$1j,
  SpotlightAndTitle: Widget$1k,
  ProductsBarWidget: Widget$1l,
  IntegrationsBarWidget: Widget$1m,
  FeatureSpotlightTabsWidget: Widget$1n,
  FeatureSpotlightRenderPreviewsWidget: Widget$1o,
  TrialCardWidget: Widget$1p,
  PricingWidget: Widget$1q,
  SimpleHeroWidget: Widget$1r,
  HubspotFeedWidget: Widget$1s,
  BundleTabsWidget: Widget$1t,
  BenefitsTabsWidget: Widget$1u,
  MediaTabsWidget: Widget$1v,
  SimpleTabsWidget: Widget$1w,
  MosaicWidget: Widget$1x,
  HeroWidget: Widget$1y,
  PricingStandaloneWidget: Widget$1z,
  PricingHeroWidget: Widget$1A,
  WorkflowWidget: Widget$1B
};
var ADMIN_LIBRARY = {
  AccordionWidget: AccordionWidget,
  AdvancedFluidLogosWidget: AdvancedFluidLogosWidget,
  AdvancedFormWidget: AdvancedFormWidget,
  AdvancedSubMenuWidget: AdvancedSubMenuWidget,
  AutocompleteWidget: AutocompleteWidget,
  BeforeAfterSliderWidget: BeforeAfterSliderWidget,
  BenefitsWithIconsWidget: BenefitsWithIconsWidget,
  BlogFeedWidget: BlogFeedWidget,
  BoothPresentationsWidget: BoothPresentationsWidget,
  BreadcrumbsWidget: BreadcrumbsWidget,
  CallToActionWidget: CallToActionWidget,
  CardsWidget: CardsWidget,
  CardsWithIconsWidget: CardsWithIconsWidget,
  CarouselWithThumbsWidget: CarouselWithThumbsWidget,
  CategoriesListWidget: CategoriesListWidget,
  CloudPricingWidget: CloudPricingWidget,
  CodeHighlightWidget: CodeHighlightWidget,
  CtaButtonAdvancedWidget: CtaButtonAdvancedWidget,
  CustomHtmlWidget: CustomHtmlWidget,
  EmbeddedVideoWidget: EmbeddedVideoWidget,
  EventsPartnersWidget: EventsPartnersWidget,
  EventsSpeakersWidget: EventsSpeakersWidget,
  EventsVrayDaysWidget: EventsVrayDaysWidget,
  FaqCategoriesAccordionWidget: FaqCategoriesAccordionWidget,
  FaqCategoriesFeedWidget: FaqCategoriesFeedWidget,
  FluidLogosWidget: FluidLogosWidget,
  FullWidthImageWidget: FullWidthImageWidget,
  FullWidthVideoWidget: FullWidthVideoWidget,
  GalleryStripWidget: GalleryStripWidget,
  GalleryWidget: GalleryWidget,
  IconCardsWidget: IconCardsWidget,
  ImageAndTextWidget: ImageAndTextWidget,
  LeadImageSliderWidget: LeadImageSliderWidget,
  MentorsWidget: MentorsWidget,
  NotificationBarWidget: NotificationBarWidget,
  PackagePricingWidget: PackagePricingWidget,
  PageCollectionWidget: PageCollectionWidget,
  PlaceholderWidget: PlaceholderWidget,
  PodcastFeedWidget: PodcastFeedWidget,
  PodcastWidget: PodcastWidget,
  PriceComparisonWidget: PriceComparisonWidget,
  ProductBarWidget: ProductBarWidget,
  PromoBanerWidget: PromoBanerWidget,
  QuoteBarWidget: QuoteBarWidget,
  ScheduleWidget: ScheduleWidget,
  SectionTitleWidget: SectionTitleWidget,
  SeparatorWidget: SeparatorWidget,
  SimpleFormWidget: SimpleFormWidget,
  SimpleGalleryWidget: SimpleGalleryWidget,
  SingleImageWidget: SingleImageWidget,
  SocialShareBarWidget: SocialShareBarWidget,
  SpacingWidget: SpacingWidget,
  SpotlightImageWidget: SpotlightImageWidget,
  SquareThumbsWidget: SquareThumbsWidget,
  SubMenuWidget: SubMenuWidget,
  TableWidget: TableWidget,
  TabsWidget: TabsWidget,
  TestimonialSliderWidget: TestimonialSliderWidget,
  TestimonialWidget: TestimonialWidget,
  TextAndMediaWidget: TextAndMediaWidget,
  TextBoxWidget: TextBoxWidget,
  ThumbsListWidget: ThumbsListWidget,
  MagazineArticlesWidget: MagazineArticlesWidget,
  CountdownWidget: CountdownWidget,
  ProductCardsWidget: ProductCardsWidget,
  SingleTrialWidget: SingleTrialWidget,
  LinksWithIconWidget: LinksWithIconWidget,
  ProductListWidget: ProductListWidget,
  FeaturedPricingWidget: FeaturedPricingWidget,
  NewTestimonialSliderWidget: NewTestimonialSliderWidget,
  HubSpotWidget: HubSpotWidget,
  LogosSliderWidget: LogosSliderWidget,
  VideoLibraryWidget: VideoLibraryWidget,
  SubscriptionWidget: SubscriptionWidget,
  SimpleBlogFeedWidget: SimpleBlogFeedWidget,
  ResellersWidget: ResellersWidget,
  EducatorsFormWidget: EducatorsFormWidget,
  SearchBarWidget: SearchBarWidget,
  RatingStatsWidget: RatingStatsWidget,
  ImageAndTextTabsWidget: ImageAndTextTabsWidget,
  IndustryTabsWidget: IndustryTabsWidget,
  NewIndustryTabsWidget: NewIndustryTabsWidget,
  GalleryMasonryWidget: GalleryMasonryWidget,
  SocialProofWidget: SocialProofWidget,
  SpotlightAndTitle: SpotlightAndTitle,
  ProductsBarWidget: ProductsBarWidget,
  IntegrationsBarWidget: IntegrationsBarWidget,
  FeatureSpotlightTabsWidget: FeatureSpotlightTabsWidget,
  FeatureSpotlightRenderPreviewsWidget: FeatureSpotlightRenderPreviewsWidget,
  TrialCardWidget: TrialCardWidget,
  PricingWidget: PricingWidget,
  SimpleHeroWidget: SimpleHeroWidget,
  HubspotFeedWidget: HubspotFeedWidget,
  BundleTabsWidget: BundleTabsWidget,
  BenefitsTabsWidget: BenefitsTabsWidget,
  MediaTabsWidget: MediaTabsWidget,
  SimpleTabsWidget: SimpleTabsWidget,
  MosaicWidget: MosaicWidget,
  HeroWidget: HeroWidget,
  PricingStandaloneWidget: PricingStandaloneWidget,
  PricingHeroWidget: PricingHeroWidget,
  WorkflowWidget: WorkflowWidget
};
var Captcha$1 = function Captcha(_ref) {
  var locale = _ref.locale,
    recaptchaKey = _ref.recaptchaKey,
    domain = _ref.domain,
    _verifyCallback = _ref.verifyCallback,
    i18n = _ref.i18n,
    country = _ref.country;
  return country === "CN" || country === "cn" ? /*#__PURE__*/React.createElement(CgCaptcha, {
    locale: locale,
    domain: domain,
    i18n: i18n,
    verifyCallback: function verifyCallback(status, captchaId, response) {
      return _verifyCallback(status, captchaId, response);
    }
  }) : /*#__PURE__*/React.createElement(Recaptcha, {
    sitekey: recaptchaKey,
    onChange: function onChange(response) {
      return _verifyCallback(response.length > 0, "google-recaptcha", response);
    }
  });
};
var Overlay$1 = function Overlay(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "overlay",
    onClick: onClose
  });
};
var Content$c = function Content(_ref2) {
  var children = _ref2.children,
    onClose = _ref2.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "content-inner"
  }, /*#__PURE__*/React.createElement("a", {
    className: "icon-close",
    onClick: function onClick(e) {
      e.preventDefault();
      onClose();
    }
  }), children));
};
var Modal$2 = function Modal(_ref3) {
  var children = _ref3.children,
    onClose = _ref3.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "language-modal"
  }, /*#__PURE__*/React.createElement(Overlay$1, {
    onClose: onClose
  }), /*#__PURE__*/React.createElement(Content$c, {
    onClose: onClose
  }, children));
};
var Content$d = function Content(_ref) {
  var title = _ref.title,
    subTitle = _ref.subTitle,
    buttonLabel = _ref.buttonLabel,
    linkLabel = _ref.linkLabel,
    onClose = _ref.onClose,
    onAccept = _ref.onAccept;
  return /*#__PURE__*/React.createElement(Modal$2, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement("div", {
    className: "language-popup"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon-sphere"
  })), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, title)), /*#__PURE__*/React.createElement("p", null, subTitle), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm"
  }, /*#__PURE__*/React.createElement(A, {
    href: "#",
    className: "btn-active-dark",
    onClick: function onClick(event) {
      event.preventDefault();
      onAccept();
    }
  }, buttonLabel)), /*#__PURE__*/React.createElement("div", {
    className: "seprarator"
  }), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm"
  }, /*#__PURE__*/React.createElement(A, {
    href: "#",
    onClick: function onClick(event) {
      event.preventDefault();
      onClose();
    }
  }, /*#__PURE__*/React.createElement("strong", null, linkLabel)))));
};
var Cookie = /*#__PURE__*/function () {
  function Cookie() {}
  Cookie.set = function set(name, value, days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    var expires = "; expires=" + date.toGMTString();
    document.cookie = name + "=" + value + expires + "; path=/";
  };
  Cookie.get = function get(name, defaultValue) {
    if (defaultValue === void 0) {
      defaultValue = null;
    }
    var nameEQ = name + "=";
    var cookiesArray = document.cookie.split(";");
    for (var i = 0; i < cookiesArray.length; i++) {
      var cookie = (cookiesArray[i] || "").trimStart();
      if (cookie.startsWith(nameEQ)) {
        return cookie.substring(nameEQ.length, cookie.length);
      }
    }
    return defaultValue;
  };
  Cookie["delete"] = function _delete(name) {
    document.cookie = name + "=" + "" + "" + "; path=/";
  };
  return Cookie;
}();
var TEN_YEARS = 10 * 365;
var Popup = function Popup(_ref) {
  var currentLocale = _ref.currentLocale,
    targetLocale = _ref.targetLocale,
    cookieName = _ref.cookieName,
    i18n = _ref.i18n,
    targetUrl = _ref.targetUrl;
  var cookieValue = Cookie.get(cookieName);
  var _React$useState = React.useState(!cookieValue),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  return open && /*#__PURE__*/React.createElement(Content$d, _extends({}, i18n, {
    onAccept: function onAccept() {
      Cookie.set(cookieName, targetLocale, TEN_YEARS);
      window.location.assign(targetUrl);
    },
    onClose: function onClose() {
      Cookie.set(cookieName, currentLocale, TEN_YEARS);
      setOpen(false);
    }
  }));
};
var renderText = function renderText(text) {
  return /*#__PURE__*/React.createElement("div", {
    className: "notification-message",
    dangerouslySetInnerHTML: {
      __html: parser.renderInline(text)
    }
  });
};
var GlobalNotice = function GlobalNotice(_ref) {
  var button = _ref.button,
    theme = _ref.theme,
    color = _ref.color,
    text = _ref.text,
    icon = _ref.icon;
  return /*#__PURE__*/React.createElement(Container$1, {
    settings: {
      theme: theme
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "notification-bar global-notice",
    style: {
      backgroundColor: color
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "notification-bar-inner"
  }, icon !== "" ? /*#__PURE__*/React.createElement("span", {
    className: "notification-icon"
  }, /*#__PURE__*/React.createElement(Image, {
    src: icon,
    variant: "mobile_square"
  })) : "", renderText(text), /*#__PURE__*/React.createElement(Button$1, {
    settings: button,
    className: "btn-active btn-small"
  })))));
};
var formatDate$1 = function formatDate(dateOrString) {
  var date = new Date(dateOrString);
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  return date.toLocaleDateString("en-US", options);
};
var Count = function Count(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl;
  return /*#__PURE__*/React.createElement(A, {
    href: "#disqus_thread",
    className: "comments"
  }, /*#__PURE__*/React.createElement(Disqus.CommentCount, {
    shortname: "vray",
    config: {
      url: currentUrl,
      identifier: article.id.toString()
    }
  }, "Comments"));
};
var Discussion = function Discussion(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl;
  if (article.layout === "press") {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-both",
    id: "disqus_thread"
  }), /*#__PURE__*/React.createElement(Disqus.DiscussionEmbed, {
    shortname: "vray",
    config: {
      url: currentUrl,
      identifier: article.id.toString()
    }
  }))));
};
var Comments = {
  Count: Count,
  Discussion: Discussion
};
var isBlogPost = function isBlogPost(article) {
  return article.layout === "post" || article.layout === "labs";
};
var MetaRow = function MetaRow(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl,
    i18n = _ref.i18n,
    _ref$showComments = _ref.showComments,
    showComments = _ref$showComments === void 0 ? true : _ref$showComments;
  return /*#__PURE__*/React.createElement("div", {
    className: "meta-row"
  }, article.author && /*#__PURE__*/React.createElement(React.Fragment, null, "by", " ", /*#__PURE__*/React.createElement("a", {
    href: article.author.path,
    className: "author"
  }, article.author.name), /*#__PURE__*/React.createElement("span", {
    className: "separator"
  }, "\xA0")), !isBlogPost(article) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "date"
  }, /*#__PURE__*/React.createElement("time", {
    dateTime: ""
  }, formatDate$1(article.publish_on))), /*#__PURE__*/React.createElement("span", {
    className: "separator"
  }, "\xA0")), /*#__PURE__*/React.createElement("span", {
    className: "mobile-row"
  }, /*#__PURE__*/React.createElement("a", {
    className: "category",
    href: article.magazine_category.path
  }, article.magazine_category.name), showComments && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "separator"
  }, "\xA0"), isBlogPost(article) ? i18n.article_read_time : /*#__PURE__*/React.createElement(Comments.Count, {
    article: article,
    currentUrl: currentUrl
  }))));
};
var BANNER = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iMTQxLjdweCIgaGVpZ2h0PSIxNDEuN3B4IiB2aWV3Qm94PSIwIDAgMTQxLjcgMTQxLjciIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDE0MS43IDE0MS43OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PHN0eWxlIHR5cGU9InRleHQvY3NzIj4uc3Qwe2ZpbGw6I0MwM0UyOTt9LnN0MXtmaWxsOiM3NjIwMEE7fS5zdDJ7ZmlsbDojRkZGRkZGO30uc3Qze2ZpbGw6IzgwODI4NTt9LnN0NHtmaWxsOiNCMDM4MjM7fS5zdDV7ZmlsbDojNjYxODAwO308L3N0eWxlPjxnPjxnPjxnPjxnPjxnPjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik04Ny4zLDY4LjVjLTEsMC0xLjgsMC44LTEuOCwxLjhjMCw3LTUuNywxMi43LTEyLjcsMTIuN2MtMy40LDAtNi42LTEuMy05LTMuN2MtMi40LTIuNC0zLjctNS42LTMuNy05VjQ0LjdjMC03LDUuNy0xMi43LDEyLjctMTIuN2M3LDAsMTIuNyw1LjcsMTIuNywxMi43YzAsMSwwLjgsMS44LDEuOCwxLjhjMSwwLDEuOC0wLjgsMS44LTEuOGMwLTguOS03LjMtMTYuMi0xNi4yLTE2LjJjLTguOSwwLTE2LjIsNy4zLTE2LjIsMTYuMnYyNS41YzAsOC45LDcuMywxNi4yLDE2LjIsMTYuMmM4LjksMCwxNi4yLTcuMywxNi4yLTE2LjJDODkuMSw2OS4zLDg4LjMsNjguNSw4Ny4zLDY4LjV6Ii8+PHBhdGggY2xhc3M9InN0MiIgZD0iTTcyLjksMzkuM2MzLjEsMCw1LjYsMi40LDUuNyw1LjVjMCwwLjksMC44LDEuNiwxLjcsMS42YzAsMCwwLDAsMC4xLDBjMC40LDAsMC44LTAuMiwxLjEtMC41YzAuMy0wLjMsMC40LTAuNywwLjQtMS4yYy0wLjItNC45LTQuMi04LjctOS04LjdjLTUsMC05LDQuMS05LDl2MjQuN2MwLDUsNC4xLDksOSw5YzUsMCw5LTQuMSw5LTlWNTkuNWMwLTAuOS0wLjctMS43LTEuNy0xLjdoLTUuNGMtMC4zLDAtMC41LDAuMS0wLjgsMC4yYy0wLjUsMC4zLTAuOSwwLjgtMC45LDEuNWMwLDAuNiwwLjMsMS4yLDAuOSwxLjVjMC4zLDAuMSwwLjUsMC4yLDAuOCwwLjJoMy44djguNmMwLDMuMi0yLjYsNS43LTUuNyw1LjdjLTMuMiwwLTUuNy0yLjYtNS43LTUuN1Y0NS4xQzY3LjIsNDEuOSw2OS43LDM5LjMsNzIuOSwzOS4zeiIvPjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik04Ny4yLDkwLjVjLTAuNS0wLjgtMS42LTEuMS0yLjQtMC42Yy0zLjEsMS45LTYuNiwzLTEwLjIsMy4zbC0wLjIsMHYtMi4zYzAtMC45LTAuNy0xLjYtMS42LTEuNmMtMC45LDAtMS42LDAuNy0xLjYsMS42djIuM2wtMC4yLDBjLTMuNi0wLjMtNy4xLTEuNC0xMC4xLTMuM2MtMC4zLTAuMi0wLjYtMC4zLTAuOS0wLjNjLTAuNiwwLTEuMiwwLjMtMS41LDAuOGMtMC4xLDAuMS0wLjEsMC4zLTAuMiwwLjVjLTAuMiwwLjcsMC4xLDEuNSwwLjgsMS45YzIsMS4yLDQuMiwyLjIsNi41LDIuOGMyLjQsMC43LDQuOCwxLDcuMywxYzIuMiwwLDQuNC0wLjMsNi42LTAuOWMyLjUtMC43LDQuOS0xLjcsNy4xLTNjMC42LTAuNCwwLjktMS4xLDAuOC0xLjhDODcuNCw5MC44LDg3LjMsOTAuNiw4Ny4yLDkwLjV6Ii8+PC9nPjwvZz48L2c+PGc+PHBhdGggY2xhc3M9InN0MiIgZD0iTTExMS44LDk2LjdjLTAuOCwwLTEuNCwwLjctMS40LDEuNWMwLDAuOC0wLjcsMi44LTIsMy45Yy0wLjcsMC42LTEuNSwwLjctMi40LDAuNGMtMC4xLDAtMC4zLTAuMS0wLjQtMC4ybC0wLjMtMC4xbDAuMy0wLjFjMS4yLTAuNywyLjItMS42LDIuNy0yLjhjMC44LTEuNywwLjctMy40LDAuMi00LjRjLTAuNS0xLjItMS44LTIuMS0zLjMtMi4yYy0xLjYtMC4xLTMuMSwwLjYtNCwyLjFjLTEuMSwxLjgtMS4zLDMuOS0wLjYsNS45YzAuNSwxLjQsMi4zLDMuMSwyLjYsMy43YzEsMi4yLTAuMiwzLjctMS42LDUuM2wtMC4yLDAuMmwtMS40LTMuOGwtMi40LTYuOGMtMC4xLTAuNC0wLjQtMC43LTAuOC0wLjljLTAuMy0wLjItMC43LTAuMi0xLjEsMGMtMC43LDAuMy0xLjEsMS4xLTAuOSwxLjhsMCwwLjJsLTAuMiwwYy0xLjEsMC4yLTIuMSwwLjYtMi44LDEuM2MtMC44LDAuNy0xLjcsMi0xLjcsNC4zYzAsMC45LDAuMSwxLjcsMC4yLDIuNGMwLjUsMi4xLTAuNCwzLjYtMS40LDMuOGMtMC42LDAuMS0xLjItMC4yLTEuMy0wLjhjLTAuNC0xLjUsMC02LjEsMC02LjFjMC0wLjgtMC42LTEuNi0xLjQtMS42Yy0wLjcsMC0xLjMsMC41LTEuNSwxLjJsMCwwLjJsLTAuMi0wLjFjLTEuMS0wLjYtMi4zLTAuNy0zLjQtMC4yYy0zLjksMS42LTMuOSw2LjEtMy45LDdjMCwwLjgsMCwxLjYtMC42LDIuM2MtMS44LDEuOC01LjYsMS44LTYuMi0xYy0wLjUtMi40LDEuOC0zLjksMS44LTMuOWMwLjEsMCwwLjEtMC4xLDEuOC0wLjFsMC4xLDBjMC44LDAsMS40LTAuNywxLjQtMS42YzAtMC45LTAuNy0xLjUtMS41LTEuNWwtNiwwLjFsMC4xLTAuMmMwLjEtMC40LDAuMy0yLTAuOC0yLjJjLTEuMi0wLjItMS44LDAuNC0yLjEsMi41Yy0wLjIsMS4zLTAuMywyLjMtMS40LDQuN2MtMS4xLDIuNi0yLjIsMi45LTMuMiwyLjdjLTAuNS0wLjEtMS41LTAuOC0xLjMtMS42YzAuNC0xLjUsMi45LTUuNywyLjktNS43YzAuNC0wLjcsMC4yLTEuNy0wLjUtMi4xYy0wLjYtMC40LTEuNC0wLjItMS45LDAuNGwtMC4xLDAuMmwtMC4xLTAuMmMtMC43LTEuMS0xLjctMS44LTMtMS45Yy00LjItMC41LTYuNiw0LjEtNi42LDQuMWMtMC4yLDAuNC0wLjQsMC44LTAuNSwxLjNsMCwwYy0xLDAuMy0yLjQsMC4yLTQuMy0wLjRsLTAuMi0wLjFsMC4yLTAuMmMxLjUtMS41LDIuMy0yLjcsMi4zLTIuN2MwLjQtMC41LDAuNi0xLjIsMC4zLTEuOGMtMC4yLTAuNi0wLjgtMC45LTEuNS0wLjljMCwwLDAsMCwwLDBjLTAuMSwwLTAuMSwwLTAuMiwwYy0xLjgsMC4xLTYuMy0wLjMtNi44LTIuOGMtMC4xLTAuNS0wLjEtMSwwLTEuNGwwLTAuMmwwLjIsMC4xYzMuNCwxLjcsOC4yLDMuNCwxMS4yLDIuM2MxLjMtMC41LDIuMi0xLjQsMi43LTIuN2MwLjctMS45LDAuMy0zLjktMS01LjRjLTEuOS0yLjItNS41LTIuOS04LjMtMi4xYy0xLjYsMC41LTQsMS41LTUuOCwzLjZsLTAuMSwwLjFMMzgsOTMuNGMtMC43LTAuNC0xLjQtMC44LTIuMS0xLjJjLTAuMy0wLjItMC43LTAuMy0xLjEtMC4yYy0wLjQsMC4xLTAuNywwLjMtMC45LDAuN2MtMC40LDAuNy0wLjIsMS43LDAuNSwyLjJjMC4zLDAuMiwxLDAuNiwyLDEuMmwwLjEsMC4xbDAsMC4xYy0wLjQsMS4xLTAuNSwyLjMtMC4zLDMuNWMwLjYsMy40LDMuNyw0LjcsNi4yLDUuMmwwLjMsMC4xbC0wLjIsMC4yYy0wLjQsMC40LTAuNywwLjctMS4xLDEuMWwtMC4xLDAuMWwtMC4xLDBjLTguNy00LjQtMTMuMi0wLjYtMTUuMiwyLjFjLTEuMywxLjctMS44LDMuNy0xLjEsNS44YzEuOSw1LjcsOC45LDQsMTEuNSwyLjVjMS45LTEuMSw0LjMtMy40LDYuMy02LjZsMC4xLTAuMWwwLjEsMGMyLDAuNyw0LDEuMyw2LjIsMS4xYzAsMC4xLDAsMC4yLDAsMC40YzAuMiwxLjQsMS4xLDIuNSwyLjQsMy4yYzEuMSwwLjYsMi4yLDAuOCwzLjMsMC40YzAuNS0wLjIsMS0wLjQsMS42LTAuOGwwLjEtMC4xbDAuMSwwLjFjMC43LDEuMywyLjksMi4zLDQuOSwxLjhjMi44LTAuNywzLjYtMi42LDQuMi00LjFjMC4zLTAuOCwxLjQtMy4xLDEuNC0zLjFsMS43LDBsLTAuMiwwLjRjLTAuNSwxLTAuOSwyLjItMC44LDMuN2MwLjEsMi4zLDIsNC42LDUuOSw0LjZjMy40LDAsNC44LTIuMyw0LjgtMi4zczAsMCwwLjIsMC4zYzAuOSwxLjMsMi4xLDEuOCwzLjUsMS44YzEuMiwwLDIuMi0wLjQsMy4xLTEuMmMwLjQtMC40LDAuNy0wLjksMS0xLjVsMC4xLTAuMmwwLjEsMC4xYzAuOSwwLjYsNS4yLDAuNCw2LTIuNWwwLjEtMC4ybDAuMiwwLjFjMC43LDAuNCwxLjQsMC42LDIuMiwwLjZjMC44LDAsMS41LTAuMiwyLjItMC41YzAuNS0wLjMsMC45LTAuNiwxLjQtMWwwLjItMC4xbDAuNCwxbC0wLjIsMC4yYy0wLjMsMC4zLTAuNiwwLjUtMC45LDAuN2MtMC4zLDAuMy0wLjYsMC41LTAuOSwwLjdsMCwwYy0xLjUsMS4yLTMuNCwyLjgtMy40LDYuM2MwLDEuNSwwLjksMy42LDIuNSw0LjdjMS40LDAuOSwzLjEsMC45LDQuOSwwYzQuMy0yLjMsMi41LTguOSwxLjUtMTEuNmwwLTAuMWwwLjEtMC4xYzIuMy0yLjMsMy41LTQuNiwzLjUtN2wwLTAuMmwwLjMsMGMwLjEsMCwwLjMsMCwwLjQsMGMxLjIsMCwyLjItMC40LDMuMi0xLjJjMi0xLjUsMy4yLTQuNSwzLjItNi4zQzExMy4yLDk3LjQsMTEyLjUsOTYuNywxMTEuOCw5Ni43eiBNNDEuMSw5NC44YzEuMi0xLjEsMi44LTEuNywzLjctMmMxLjctMC41LDQuMi0wLjEsNS4zLDEuMmMwLjYsMC42LDAuNywxLjMsMC40LDIuMmMtMC4yLDAuNS0wLjQsMC43LTAuOSwwLjljLTAuMywwLjEtMC42LDAuMi0xLDAuMmMtMi4yLDAuMS01LjUtMS4yLTcuNS0yLjFMNDAuOSw5NUw0MS4xLDk0Ljh6IE0zNS43LDExMy40Yy0yLjIsMS44LTYuNywyLjktNy45LDAuMWMtMS44LTQuMyw1LjEtOC44LDExLjgtNC41QzM5LjYsMTA5LjEsMzcuOCwxMTEuNywzNS43LDExMy40eiBNNTcuNCwxMDguOWMtMS4xLDIuNC0yLjUsMy4zLTMuNiwzLjNjLTAuMywwLTAuNiwwLTAuOC0wLjFjLTAuNS0wLjItMC44LTAuNS0xLTFjLTAuNC0xLjEsMC4zLTIuNiwwLjUtMi44YzAuMS0wLjEsMS40LTIuNCwzLjMtMi42YzAsMCwwLDAsMC4xLDBjMC44LDAsMS4zLDAuNCwxLjUsMC43QzU3LjcsMTA3LjEsNTcuOCwxMDguMSw1Ny40LDEwOC45eiBNODMuMSwxMTQuMWMtMC4zLDAuMi0wLjUsMC4zLTAuOCwwLjNjLTAuNSwwLjEtMC45LTAuMS0xLjMtMC40Yy0wLjgtMC44LTAuOS0yLjQtMC45LTIuN2MwLTAuMSwwLjEtMi41LDEuNy0zLjZjMCwwLDAsMCwwLjEsMGMwLjctMC40LDEuMy0wLjMsMS42LTAuMWMwLjcsMC40LDEuMiwxLjMsMS4yLDIuMUM4NC44LDExMi40LDg0LDExMy41LDgzLjEsMTE0LjF6IE05NS44LDEwOS4zYy0wLjEsMC4xLTAuNCwwLjEtMC43LDAuMWMtMC4zLDAtMC42LTAuMS0xLTAuM2MtMC43LTAuNS0xLjItMS43LTEuMi0zLjJjMC0xLjUsMC42LTIuMiwxLjEtMi40YzAuNy0wLjMsMS41LTAuMiwxLjksMC4xYzEuMiwxLDEuMiwyLjgsMS4yLDMuNEM5Ny4xLDEwOC4yLDk2LjcsMTA5LDk1LjgsMTA5LjN6IE05OS43LDEyMS45Yy0wLjUsMC4zLTEsMC40LTEuMywwLjRjLTAuNCwwLTAuNy0wLjItMC44LTAuMmMtMC44LTAuNS0xLjEtMS42LTEuMS0yLjFjMC0yLDAuOS0yLjcsMi4yLTMuOGMwLjQtMC4zLDAuNy0wLjYsMS0wLjlsMC4zLTAuMmwwLjEsMC4yQzEwMC42LDExNi45LDEwMS42LDEyMC45LDk5LjcsMTIxLjl6IE0xMDMuMyw5OS41Yy0wLjUtMC4zLTAuOC0xLjcsMC40LTMuM2MwLjktMS4yLDMuMS0wLjcsMi4xLDEuNUMxMDUuMSw5OS4xLDEwNCw5OS44LDEwMy4zLDk5LjV6Ii8+PC9nPjxnPjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik03Mi45LDIzLjhjLTEsMC0xLjgtMC44LTEuOC0xLjh2LTMuMmMwLTEsMC44LTEuOCwxLjgtMS44czEuOCwwLjgsMS44LDEuOFYyMkM3NC42LDIzLDczLjksMjMuOCw3Mi45LDIzLjh6Ii8+PHBhdGggY2xhc3M9InN0MiIgZD0iTTk4LjgsNDYuNWgtMy4yYy0xLDAtMS44LTAuOC0xLjgtMS44YzAtMSwwLjgtMS44LDEuOC0xLjhoMy4yYzEsMCwxLjgsMC44LDEuOCwxLjhDMTAwLjUsNDUuNyw5OS44LDQ2LjUsOTguOCw0Ni41eiIvPjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik01MC4xLDQ2LjVINDdjLTEsMC0xLjgtMC44LTEuOC0xLjhjMC0xLDAuOC0xLjgsMS44LTEuOGgzLjJjMSwwLDEuOCwwLjgsMS44LDEuOEM1MS45LDQ1LjcsNTEuMSw0Ni41LDUwLjEsNDYuNXoiLz48cGF0aCBjbGFzcz0ic3QyIiBkPSJNNDQuNCw2MC44Yy0wLjcsMC0xLjQtMC41LTEuNy0xLjJjLTAuMy0wLjksMC4yLTEuOSwxLjEtMi4ybDYuOS0yLjNjMC45LTAuMywxLjksMC4yLDIuMiwxLjFjMC4zLDAuOS0wLjIsMS45LTEuMSwyLjJMNDUsNjAuN0M0NC44LDYwLjgsNDQuNiw2MC44LDQ0LjQsNjAuOHoiLz48cGF0aCBjbGFzcz0ic3QyIiBkPSJNOTIuNywzNC42Yy0wLjYsMC0xLjMtMC40LTEuNi0xYy0wLjQtMC45LTAuMS0xLjksMC44LTIuNGw2LjktMy41YzAuOS0wLjQsMS45LTAuMSwyLjQsMC44YzAuNCwwLjksMC4xLDEuOS0wLjgsMi40bC02LjksMy41QzkzLjMsMzQuNSw5MywzNC42LDkyLjcsMzQuNnoiLz48cGF0aCBjbGFzcz0ic3QyIiBkPSJNNTMsMzQuNmMtMC4zLDAtMC41LTAuMS0wLjgtMC4ybC02LjktMy41Yy0wLjktMC40LTEuMi0xLjUtMC44LTIuNGMwLjQtMC45LDEuNS0xLjIsMi40LTAuOGw2LjksMy41YzAuOSwwLjQsMS4yLDEuNSwwLjgsMi40QzU0LjMsMzQuMiw1My43LDM0LjYsNTMsMzQuNnoiLz48cGF0aCBjbGFzcz0ic3QyIiBkPSJNMTAxLjQsNjAuOGMtMC4yLDAtMC40LDAtMC42LTAuMWwtNi45LTIuM2MtMC45LTAuMy0xLjQtMS4zLTEuMS0yLjJjMC4zLTAuOSwxLjMtMS40LDIuMi0xLjFsNi45LDIuM2MwLjksMC4zLDEuNCwxLjMsMS4xLDIuMkMxMDIuOCw2MC4zLDEwMi4xLDYwLjgsMTAxLjQsNjAuOHoiLz48cGF0aCBjbGFzcz0ic3QyIiBkPSJNNjAuOSwyNi43Yy0wLjYsMC0xLjMtMC40LTEuNi0xbC0zLjUtNi45Yy0wLjQtMC45LTAuMS0xLjksMC44LTIuNGMwLjktMC40LDEuOS0wLjEsMi40LDAuOGwzLjUsNi45YzAuNCwwLjksMC4xLDEuOS0wLjgsMi40QzYxLjUsMjYuNiw2MS4yLDI2LjcsNjAuOSwyNi43eiIvPjxwYXRoIGNsYXNzPSJzdDIiIGQ9Ik04NC44LDI2LjdjLTAuMywwLTAuNS0wLjEtMC44LTAuMmMtMC45LTAuNC0xLjItMS41LTAuOC0yLjRsMy41LTYuOWMwLjQtMC45LDEuNS0xLjIsMi40LTAuOGMwLjksMC40LDEuMiwxLjUsMC44LDIuNGwtMy41LDYuOUM4Ni4xLDI2LjMsODUuNSwyNi43LDg0LjgsMjYuN3oiLz48L2c+PC9nPjwvZz48L3N2Zz4=";
var PodcastHeader = function PodcastHeader(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "podcast-banner"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/cg-garage"
  }, /*#__PURE__*/React.createElement("img", {
    src: BANNER,
    alt: "podcast banner"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-post-title-wrapper"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "blog-post-title"
  }, article.title), article.subtitle && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", {
    className: ""
  }, article.subtitle)))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-post-meta"
  }, /*#__PURE__*/React.createElement(MetaRow, {
    article: article,
    currentUrl: currentUrl,
    i18n: i18n
  }))))));
};
var NewsHeader = function NewsHeader(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-post-title-wrapper"
  }, /*#__PURE__*/React.createElement("h1", null, article.title), article.description && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h4", {
    style: {
      lineHeight: "1.6"
    }
  }, article.description)))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-post-meta"
  }, /*#__PURE__*/React.createElement(MetaRow, {
    article: article,
    currentUrl: currentUrl,
    i18n: i18n
  }))))));
};
var SocialLinks = function SocialLinks(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    className: "icon-facebook",
    target: "_blank",
    href: "https://facebook.com/sharer/sharer.php?u=" + currentUrl,
    rel: "noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    className: "x-icon white-logo",
    target: "_blank",
    href: "https://twitter.com/intent/tweet/?text=&amp;url=" + currentUrl,
    rel: "noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    className: "icon-linkedin",
    target: "_blank",
    href: "https://www.linkedin.com/shareArticle?mini=true&url=" + currentUrl,
    rel: "noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    className: "icon-mail",
    href: "mailto:?subject=" + article.title + "&body=" + currentUrl
  }));
};
var SocialMetaRow = function SocialMetaRow(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl;
  return /*#__PURE__*/React.createElement("div", {
    className: "meta-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "social"
  }, /*#__PURE__*/React.createElement(SocialLinks, {
    article: article,
    currentUrl: currentUrl
  })));
};
var PostHeader = function PostHeader(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "full-image-section"
  }, article.featured_image_overlay > 0 && /*#__PURE__*/React.createElement("div", {
    className: "cnt-overlay",
    style: {
      background: "rgba(0, 0, 0, " + article.featured_image_overlay / 100
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, article.hosted_video ? /*#__PURE__*/React.createElement("video", {
    autoPlay: true,
    loop: true,
    muted: true,
    width: "1920",
    height: "600"
  }, /*#__PURE__*/React.createElement("source", {
    src: article.hosted_video.asset_mp4_url,
    type: "video/mp4"
  }), "Your browser does not support HTML5 video.") : article.featured_image && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Image, {
    src: article.featured_image,
    variant: "full_width_image"
  }), /*#__PURE__*/React.createElement(Image, {
    src: article.featured_image,
    variant: "mobile_square"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "full-image-title"
  }, article.title), article.subtitle && /*#__PURE__*/React.createElement("h5", {
    className: "full-image-sub-title"
  }, article.subtitle), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: "blog-post-meta"
  }, /*#__PURE__*/React.createElement(MetaRow, {
    article: article,
    currentUrl: currentUrl,
    i18n: i18n
  }), /*#__PURE__*/React.createElement(SocialMetaRow, {
    article: article,
    currentUrl: currentUrl
  }))))))));
};
var BANNER$1 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNS4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIzMDQuMjg5Mzk4MnB4IiBoZWlnaHQ9IjUwLjk1NjEwMDVweCIgdmlld0JveD0iMCAwIDMwNC4yODkzOTgyIDUwLjk1NjEwMDUiDQoJIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMwNC4yODkzOTgyIDUwLjk1NjEwMDUiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGZpbGw9IiNFMTE2MUMiIGQ9Ik0xNjkuNzQwNjkyMSwzMC4xNjYyMzY5Yy00LjA3ODA3OTItMC40NjE1OTkzLTcuNTI0OTE3Ni0yLjAxNzg3NzYtNy41MjQ5MTc2LTMuMzkzODk2MQ0KCQkJYzAtMi4xMjQ4NjA4LDIuMzAzMjY4NC0yLjQ0MTM4MzQsMy42Nzg3ODcyLTIuNDQxMzgzNGMxLjMwMDY0MzksMCw0LjMzMDU2NjQsMC4yOTYwMDcyLDQuMzMwNTY2NCwzLjAzNjM0MDcNCgkJCWMwLDAuMjM1OTM1MiwwLjE3MzIzMywwLjQyNjQzNTUsMC4zODQ2MTMsMC40MjY0MzU1aDguODcyNTI4MWMwLjIxMjg2MDEsMCwwLjM4NDU5NzgtMC4xOTA1MDAzLDAuMzg0NTk3OC0wLjQyNjQzNTUNCgkJCWMwLTYuNzE4OTMzMS01Ljc0NTY5Ny0xMS40MTEyMDI0LTEzLjk3MjMwNTMtMTEuNDExMjAyNGMtOC4wOTc0Mjc0LDAtMTMuOTc1MjY1NSw0LjY0OTc3MzYtMTMuOTc1MjY1NSwxMS4wNTM2MzU2DQoJCQljMCw1LjU0MDc0ODYsNi45MTcxNzUzLDkuMzM2MTcwMiwxMy40MjYyMzksMTAuMDkzNzg4MWMyLjg4MzExNzcsMC4zNjA0OTY1LDQuNjA4MDE3LDEuNzA4Njc1NCw0LjYwODAxNywyLjgwMDQxNQ0KCQkJYzAsMS43Mzk0NDQ3LTIuMDkxODg4NCwyLjY3NzMxMDktNC4wNTg5OTA1LDIuNjc3MzEwOWMtMC43NzUxMDA3LDAtNC42MzQ0NDUyLTAuMTQ2NTQxNi00LjYzNDQ0NTItMy4wMzQ4Nzc4DQoJCQljMC0wLjIzNzM4ODYtMC4xNzMyMTc4LTAuNDI3ODk4NC0wLjM4NjA3NzktMC40Mjc4OTg0aC04Ljk1MDMzMjZjLTAuMjEyODYwMSwwLTAuMzg0NjEzLDAuMTkwNTA5OC0wLjM4NDYxMywwLjQyNzg5ODQNCgkJCWMwLDcuNDkxMjEwOSw3LjIyMjUwMzcsMTEuNDA5NzMyOCwxNC4zNTU0Njg4LDExLjQwOTczMjhzMTQuMzU1NDUzNS0zLjkxODUyMTksMTQuMzU1NDUzNS0xMS40MDk3MzI4DQoJCQlDMTgwLjI1MDAxNTMsMzMuODQ0NDM2NiwxNzQuOTcxMTQ1NiwzMC43Mjc0OTcxLDE2OS43NDA2OTIxLDMwLjE2NjIzNjkiLz4NCgkJPHBhdGggZmlsbD0iI0UxMTYxQyIgZD0iTTU1LjAwOTk1MjUsMTUuODEyMTY2MmMtMi42MDE0NjMzLDAtNS4wMzcwMjU1LDAuODI3MDM1OS03LjA5NTI4NzMsMi40MDAxNTk4VjAuNDI4MjMxNA0KCQkJQzQ3LjkxNDY2NTIsMC4xOTEzMTMxLDQ3LjcyMzgxMjEsMCw0Ny40ODU5ODQ4LDBoLTguNjc3ODk0NmMtMC4yMzYzNjI1LDAtMC40Mjg2ODA0LDAuMTkxMzEzMS0wLjQyODY4MDQsMC40MjgyMzE0djQ5LjE0MzU0MzINCgkJCWMwLDAuMjM2OTIzMiwwLjE5MjMxOCwwLjQyODIzMDMsMC40Mjg2ODA0LDAuNDI4MjMwM2g4LjY3Nzg5NDZjMC4yMzc4MjczLDAsMC40Mjg2ODA0LTAuMTkxMzA3MSwwLjQyODY4MDQtMC40MjgyMzAzVjMzLjMyNTQ4NTINCgkJCWMwLTQuMjMyMjczMSwyLjE5MzMyODktOC41MDQyODAxLDcuMDk1Mjg3My04LjUwNDI4MDFzNy4wOTUyODczLDQuMzAxNDQ1LDcuMDk1Mjg3Myw4LjU2NDYxNzJ2MTYuMTg1OTUxMg0KCQkJYzAsMC4yMzY5MjMyLDAuMTkwODQ5MywwLjQyODIzMDMsMC40Mjg2ODQyLDAuNDI4MjMwM2g4LjY3OTM1NTZjMC4yMzQ4OTM4LDAsMC40MjcyMTU2LTAuMTkxMzA3MSwwLjQyNzIxNTYtMC40MjgyMzAzVjMzLjM4NTgyMjMNCgkJCUM3MS42NDA0OTUzLDIzLjM2NTgxMDQsNjQuNDkwODkwNSwxNS44MTIxNjYyLDU1LjAwOTk1MjUsMTUuODEyMTY2MiIvPg0KCQk8cGF0aCBmaWxsPSIjRTExNjFDIiBkPSJNMTAwLjk4NjQ4ODMsMzMuNDU1MzY4YzAsNC43MDI3MTY4LTMuNzAyMjc4MSw4LjUyOTA3OTQtOC4yNTE1NzE3LDguNTI5MDc5NA0KCQkJYy00LjU0OTMwMTEsMC04LjI1MTU3OTMtMy44MjYzNjI2LTguMjUxNTc5My04LjUyOTA3OTRzMy43MDIyNzgxLTguNTI5MDc5NCw4LjI1MTU3OTMtOC41MjkwNzk0DQoJCQlDOTcuMjg0MjEwMiwyNC45MjYyODg2LDEwMC45ODY0ODgzLDI4Ljc1MjY1MTIsMTAwLjk4NjQ4ODMsMzMuNDU1MzY4IE05Mi41NjAyMjY0LDE1Ljk1NDYzMTgNCgkJCWMtOS43MDkyODk2LDAtMTcuNjExNDczMSw3Ljg1MDU2NjktMTcuNjExNDczMSwxNy41MDA3MzYyYzAsOS42NDg3MDQ1LDcuOTAyMTgzNSwxNy40OTkyNjc2LDE3LjYxMTQ3MzEsMTcuNDk5MjY3Ng0KCQkJYzMuMjIyMjM2NiwwLDYuMzY2NjY4Ny0xLjY0Mjc5OTQsOC42MjE0OTgxLTQuNDUyMTE3OWwwLjAzNjY5NzQsMy4wNzYwMzQ1DQoJCQljMC4wMDI5MzczLDAuMjM0NDc4LDAuMTkzNzg2NiwwLjQyMjA2MTksMC40MjcxODUxLDAuNDIyMDYxOWg4LjEwMTg0NDhjMC4yMzQ4NzA5LDAsMC40MjU3MDUtMC4xOTE5Nzg1LDAuNDI1NzA1LTAuNDI2NDU2NQ0KCQkJVjMzLjQ1NTM2OEMxMTAuMTczMTU2NywyMy44MDUxOTg3LDEwMi4yNzM5MTA1LDE1Ljk1NDYzMTgsOTIuNTYwMjI2NCwxNS45NTQ2MzE4Ii8+DQoJCTxwYXRoIGZpbGw9IiNFMTE2MUMiIGQ9Ik0xMzkuMjkwMTQ1OSwzMy40NTUzNjA0YzAsNC43MDI3MTY4LTMuNjUwODk0Miw4LjUyOTA3OTQtOC4xMzcwNjk3LDguNTI5MDc5NA0KCQkJYy00LjQ4NjE4MzIsMC04LjEzNTU5NzItMy44MjYzNjI2LTguMTM1NTk3Mi04LjUyOTA3OTRzMy42NDk0MTQxLTguNTI5MDc5NCw4LjEzNTU5NzItOC41MjkwNzk0DQoJCQlDMTM1LjYzOTI1MTcsMjQuOTI2MjgxLDEzOS4yOTAxNDU5LDI4Ljc1MjY0MzYsMTM5LjI5MDE0NTksMzMuNDU1MzYwNCBNMTMxLjE1MzA3NjIsMTUuOTU0NjI0Mg0KCQkJYy05Ljc0MzA0MiwwLTE3LjY3MTY1MzcsNy44NTA1NjY5LTE3LjY3MTY1MzcsMTcuNTAwNzM2MmMwLDkuNjQ4NzA0NSw3LjkyODYxMTgsMTcuNDk5MjY3NiwxNy42NzE2NTM3LDE3LjQ5OTI2NzYNCgkJCXMxNy42NzE2NDYxLTcuODUwNTYzLDE3LjY3MTY0NjEtMTcuNDk5MjY3NkMxNDguODI0NzIyMywyMy44MDUxOTEsMTQwLjg5NjExODIsMTUuOTU0NjI0MiwxMzEuMTUzMDc2MiwxNS45NTQ2MjQyIi8+DQoJCTxwYXRoIGZpbGw9IiNFMTE2MUMiIGQ9Ik0yMC45MzYyNjIxLDQxLjI5ODMzOThDMTYuNDI5NzQyOCw0My4yNTQyLDExLjE2MTUyMSw0MS4wMzk1OTI3LDkuNDU4NTQzOCwzNi4zNTczNzk5DQoJCQljLTEuNDk0NDQ5MS00LjExNDA5NzYsMC40NDE2NzMzLTguNzc4OTUxNiw0LjQwODA0NjctMTAuNjQwODUwMWMyLjk2MjgzMTUtMS4zOTA2Mzg0LDYuMjkwNTg4NC0wLjk0MjUxNDQsOC43MzM1NDcyLDAuODUxNDQ4MQ0KCQkJYzAuMjMwMjQ5NCwwLjE2NzY4MDcsMC41MjcxMTExLDAuMjEzOTM1OSwwLjc4Nzc3MTIsMC4wOTgyOTlsNy4zMjMwOTM0LTMuMTc3MzczOQ0KCQkJYzAuNDc0OTc3NS0wLjIwNTI2ODksMC42MjI2ODQ1LTAuODEyNDA2NSwwLjI5NTQxMjEtMS4yMDg0OTYxQzI1Ljk1NTQxLDE2LjIwMTc3ODQsMTcuMTcxMTc1LDE0LjA1OTQ0OTIsOS42NDUzNDk1LDE3LjgyMjI2NTYNCgkJCUMxLjYxODQ3ODMsMjEuODM2NjE4NC0yLjA3OTk5MzcsMzEuNDQ5NjY4OSwxLjE4NDA0NTEsMzkuNzk2NDAyYzMuNjM2MjA0NSw5LjMwMDc5NjUsMTQuMjM3ODEzOSwxMy42NDYxODMsMjMuMzI0NzAxMyw5LjcwMjY2MzQNCgkJCWM3LjMyMDE5MjMtMy4xNzU5MTQ4LDExLjM2NDc2MTQtMTAuNzQyMDMxMSwxMC4zOTQ1MzEyLTE4LjI2NzY3OTJjLTAuMDY1MTYyNy0wLjUxMTcyNjQtMC42MDk2NTczLTAuODE2NzUxNS0xLjA4NjA4MjUtMC42MTE0NzEyDQoJCQlsLTcuMzIzMDg5NiwzLjE3ODgwNjNjLTAuMjYwNjYwMiwwLjExNDIwNDQtMC40MzE1Mzc2LDAuMzU5OTUxLTAuNDYzMzk2MSwwLjY0MzI4DQoJCQlDMjUuNjg2MDYsMzcuMzY3ODM5OCwyMy44MzgyNzIxLDQwLjAzNzgxMTMsMjAuOTM2MjYyMSw0MS4yOTgzMzk4Ii8+DQoJPC9nPg0KCTxnPg0KCQk8cGF0aCBmaWxsPSIjRkZGRkZGIiBkPSJNMTg5Ljc4MTg0NTEsNTAuMDM2MTU5NVY2LjAzNjE1MzNoNS4zODgwMTU3djQ0LjAwMDAwNzZIMTg5Ljc4MTg0NTF6Ii8+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yMzUuNTU4MTM2LDMzLjQ1NjA5NjZ2MTYuNTc4ODE1NWgtNS4xNTc2MjMzVjQ1LjU1Mjc4NA0KCQkJYy0zLjA3MDIwNTcsMy4zMTUyNDI4LTcuNDI5ODA5Niw1LjQwMzMxNjUtMTIuMzQxNzM1OCw1LjQwMzMxNjVjLTkuODI0NTA4NywwLTE3LjgwNzI4MTUtNy44NTk2MDM5LTE3LjgwNzI4MTUtMTcuNTAwMDAzOA0KCQkJczcuOTgyNzcyOC0xNy41LDE3LjgwNzI4MTUtMTcuNUMyMjcuNjk4NTMyMSwxNS45NTYwOTU3LDIzNS41NTgxMzYsMjMuODE1NzAwNSwyMzUuNTU4MTM2LDMzLjQ1NjA5NjZ6IE0yMzAuNDYyMDk3MiwzMy40NTYwOTY2DQoJCQljMC03LjA2MTU4NDUtNS41ODgwNzM3LTEyLjgzMzExNjUtMTIuNDAzMzIwMy0xMi44MzMxMTY1Yy02Ljg3NzQ3MTksMC0xMi40MDM5NjEyLDUuNzcxNTMyMS0xMi40MDM5NjEyLDEyLjgzMzExNjUNCgkJCWMwLDcuMTIyNTI0Myw1LjUyNjQ4OTMsMTIuODMzMTE4NCwxMi40MDM5NjEyLDEyLjgzMzExODRDMjI0Ljg3NDAyMzQsNDYuMjg5MjE1MSwyMzAuNDYyMDk3Miw0MC41Nzg2MjA5LDIzMC40NjIwOTcyLDMzLjQ1NjA5NjZ6DQoJCQkiLz4NCgkJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTI3Ni41MDMzMjY0LDMzLjQ1NDc0NjJjMCw5LjY0MDMzMTMtNy45ODI0ODI5LDE3LjQ5OTg4MTctMTcuODA2NTc5NiwxNy40OTk4ODE3DQoJCQljLTQuOTExNzQzMiwwLTkuMzMyNzQ4NC0yLjE0ODk5NDQtMTIuMzQxMjQ3Ni01LjUyNjQ1MTF2NC42MDUyNjY2aC01LjE1ODA2NThWNS45NTQ2MjI3aDUuNDAzNzQ3NnYxNC45NzM3MjA2DQoJCQljMy4xMzEwMTItMy4wNzAxNzksNy4zNjc5MTk5LTQuOTczNDgxMiwxMi4wOTU1NjU4LTQuOTczNDgxMg0KCQkJQzI2OC41MjA4NDM1LDE1Ljk1NDg2MTYsMjc2LjUwMzMyNjQsMjMuODE0NDEzMSwyNzYuNTAzMzI2NCwzMy40NTQ3NDYyeiBNMjcxLjEwMDIxOTcsMzMuNDU0NzQ2Mg0KCQkJYzAtNy4wNjE1Mzg3LTUuNTI2Mjc1Ni0xMi44MzMwMzI2LTEyLjQwMzQ3MjktMTIuODMzMDMyNmMtNi44NzY1NTY0LDAtMTIuNDAyODMyLDUuNzcxNDkzOS0xMi40MDI4MzIsMTIuODMzMDMyNg0KCQkJYzAsNy4xMjI0NzQ3LDUuNTI2Mjc1NiwxMi44MzMwMzA3LDEyLjQwMjgzMiwxMi44MzMwMzA3QzI2NS41NzM5NDQxLDQ2LjI4Nzc3NjksMjcxLjEwMDIxOTcsNDAuNTc3MjIwOSwyNzEuMTAwMjE5NywzMy40NTQ3NDYyeiINCgkJCS8+DQoJCTxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0yOTcuNTM1MTI1NywyNS42NTgwNzkxYy0wLjEyMjUyODEtMy4wNzAxOTgxLTIuMTQ5MDE3My01LjAzNTA5OS01LjY0OTAxNzMtNS4wMzUwOTkNCgkJCWMtMi44MjQ0OTM0LDAtNS4yODA3OTIyLDEuNzE5MjA1OS01LjI4MDc5MjIsNC4zNTk2MDM5czMuMzE1ODg3NSw0LjE3NTQ5NTEsNy45ODI3NTc2LDUuMzQxNzMwMQ0KCQkJYzUuNzcxNTQ1NCwxLjM1MDk5MDMsOS43MDEzNTUsNC41NDM3MTI2LDkuNzAxMzU1LDkuOTQ3Njc3NmMwLDUuODMzMTE4NC00Ljc4OTM5ODIsMTAuNjg0MTA4Ny0xMi4xNTc2MjMzLDEwLjY4NDEwODcNCgkJCWMtNi4zODYxMDg0LDAtMTEuNjY2OTAwNi0zLjQzODQxNTUtMTEuOTczNTEwNy0xMC40Mzg0MTU1aDUuNDAzMzIwM2MwLjMwNzI1MSwzLjY4NDEwODcsMy40Mzg0MTU1LDUuNzcxNTMwMiw2LjU3MDE5MDQsNS43NzE1MzAyDQoJCQljMy44MDY2NDA2LDAsNi43NTQzMDMtMi41MTcyMjM0LDYuNzU0MzAzLTUuNjQ5MDA5N2MwLTIuODI0NTA0OS0xLjU5NjY3OTctNC43Mjc4MTc1LTUuMTU3NjIzMy01LjU4NzQyMTQNCgkJCWMtNy43MzcwOTExLTEuOTAzOTY1LTEyLjUyNjQ4OTMtNC41NDQzNjExLTEyLjUyNjQ4OTMtOS45NDc2Nzc2YzAtNC45MTE5MjgyLDQuMDUyMzM3Ni05LjE0OTAxMDcsMTAuNjg0MTEyNS05LjE0OTAxMDcNCgkJCXMxMS4xMTM5MjIxLDMuOTI5ODAyOSwxMS4xMTM5MjIxLDkuNzAxOTgzNUgyOTcuNTM1MTI1N3oiLz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg==";
var LabsHeader = function LabsHeader(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement("div", {
    className: "labs-layout"
  }, /*#__PURE__*/React.createElement("div", {
    className: "product-bar cg-labs dark-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("a", {
    href: "/blog/category/cg-labs"
  }, /*#__PURE__*/React.createElement("img", {
    src: BANNER$1,
    alt: "image product-bar"
  })))), /*#__PURE__*/React.createElement(PostHeader, {
    article: article,
    currentUrl: currentUrl,
    i18n: i18n
  }));
};
var PodcastHeader$1 = function PodcastHeader(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-post-title-wrapper"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "blog-post-title"
  }, article.title), article.subtitle && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h5", {
    className: ""
  }, article.subtitle)))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "blog-post-meta"
  }, /*#__PURE__*/React.createElement(MetaRow, {
    article: article,
    currentUrl: currentUrl,
    i18n: i18n,
    showComments: false
  }))))));
};
var _excluded$k = ["article"];
var HEADERS = {
  podcast_episode: PodcastHeader,
  post: PostHeader,
  labs: LabsHeader,
  news: NewsHeader,
  press: PodcastHeader$1
};
var ArticleHeader = function ArticleHeader(_ref) {
  var article = _ref.article,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$k);
  var Component = HEADERS[article.layout];
  if (!Component) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Component, _extends({
    article: article
  }, rest));
};
var interpolateI18n = function interpolateI18n(str, obj) {
  var newStr = str || "";
  Object.keys(obj).forEach(function (key) {
    newStr = newStr.replace("%{" + key + "}", obj[key]);
  });
  return newStr;
};
var ArticleFooter = function ArticleFooter(_ref) {
  var article = _ref.article,
    currentUrl = _ref.currentUrl,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement("div", {
    className: "white-bg spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("footer", {
    className: "article-footer"
  }, article.author && article.show_author && /*#__PURE__*/React.createElement("div", {
    className: "about-the-author"
  }, /*#__PURE__*/React.createElement("a", {
    href: article.author.path
  }, article.author.image && /*#__PURE__*/React.createElement(Image, {
    src: article.author.image,
    variant: "thumb"
  })), /*#__PURE__*/React.createElement("div", {
    className: "about-the-author-info"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "about-the-author-title"
  }, i18n.author), /*#__PURE__*/React.createElement("h4", {
    className: "author"
  }, /*#__PURE__*/React.createElement("a", {
    href: article.author.path
  }, article.author.name)), parseMarkdown(article.author.bio))), /*#__PURE__*/React.createElement("div", {
    className: "article-meta"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "article-footer-heading"
  }, i18n.tags), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    href: article.magazine_category.path,
    className: "category"
  }, article.magazine_category.name), article.products.map(function (product) {
    return /*#__PURE__*/React.createElement("a", {
      key: product.id,
      href: product.path,
      className: "category"
    }, product.name);
  }), article.tags.map(function (tag) {
    return /*#__PURE__*/React.createElement("a", {
      key: tag.id,
      href: tag.path,
      className: "category"
    }, tag.name);
  })), /*#__PURE__*/React.createElement("div", {
    className: "social"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "article-footer-heading"
  }, i18n.social_links), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: "social-links"
  }, /*#__PURE__*/React.createElement(SocialLinks, {
    article: article,
    currentUrl: currentUrl
  }))), /*#__PURE__*/React.createElement("div", {
    className: "dates"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "article-footer-heading"
  }, i18n.published_title), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top-xs"
  }, interpolateI18n(i18n.published, {
    date: formatDate$1(article.publish_on)
  }), article.last_modified_at && " " + interpolateI18n(i18n.last_updated, {
    date: formatDate$1(article.last_modified_at)
  }))))));
};
var ArticleCard = function ArticleCard(_ref) {
  var article = _ref.article;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-preview"
  }, /*#__PURE__*/React.createElement("a", {
    href: article.path
  }, article.image && /*#__PURE__*/React.createElement(Image, {
    src: article.image,
    variant: "articles_2_columns",
    className: "preview-image"
  })), /*#__PURE__*/React.createElement("p", {
    className: "article-meta"
  }, /*#__PURE__*/React.createElement("a", {
    href: article.magazine_category.path,
    className: "category"
  }, article.magazine_category.name), /*#__PURE__*/React.createElement("time", null, formatDate$1(article.publish_on))), /*#__PURE__*/React.createElement("h6", {
    className: "article-title"
  }, /*#__PURE__*/React.createElement("a", {
    href: article.path
  }, article.title)), /*#__PURE__*/React.createElement("p", {
    className: "description"
  }, parseMarkdown(article.description))));
};
var RelatedArticles = function RelatedArticles(_ref) {
  var article = _ref.article,
    related_articles = _ref.related_articles,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement("div", {
    className: "magazine-feed related-articles light-bg spacing-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "section-title"
  }, i18n.section_title))), /*#__PURE__*/React.createElement("div", {
    className: "light-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, related_articles.map(function (ar) {
    return /*#__PURE__*/React.createElement(ArticleCard, {
      key: ar.id,
      article: ar
    });
  })))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "centered-btn"
  }, /*#__PURE__*/React.createElement("a", {
    href: article.magazine_category.path,
    className: "btn-passive"
  }, interpolateI18n(i18n.explore_link, {
    category: article.magazine_category.name
  })))));
};
var digReducer = function digReducer(previous, current) {
  if (previous) {
    return previous[current];
  }
  return undefined;
};
var dig = function dig(object, keys, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = undefined;
  }
  return keys.split(".").reduce(digReducer, object) || defaultValue;
};
var image = function image(article) {
  var img = article.featured_image || article.image;
  return {
    "@type": "ImageObject",
    url: dig(img, "urls.original") || ""
  };
};
var author = function author(article, organization) {
  if (!article.author) {
    return organization;
  }
  return {
    "@type": "Person",
    name: article.author.name
  };
};
var organization = {
  "@type": "Organization",
  name: "Chaos",
  logo: {
    "@type": "ImageObject",
    url: "https://www.chaos.com/chaos-logo.svg"
  }
};
var StructuredData = function StructuredData(_ref) {
  var article = _ref.article;
  var data = {
    "@context": "https://schema.org",
    "@type": "BlogPosting",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": "https://www.chaos.com"
    },
    image: image(article),
    datePublished: article.publish_on || "",
    dateModified: article.updated_at || "",
    headline: article.title,
    author: author(article, organization),
    publisher: organization,
    description: article.description || ""
  };
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "<script type=\"application/ld+json\">" + JSON.stringify(data) + "</script>"
    }
  });
};
var DesktopPopup = function DesktopPopup(_ref) {
  var _popup$button, _popup$button2, _popup$button3, _popup$button4, _popup$button5, _popup$button6, _popup$button7;
  var popup = _ref.popup,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "popup-wrapper-desktop"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: onClose
  }), popup.image && /*#__PURE__*/React.createElement(Image, {
    src: popup.image,
    variant: "articles_2_columns",
    className: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-wrapper"
  }, popup.icon && /*#__PURE__*/React.createElement(Image, {
    src: popup.icon,
    variant: "mobile_square",
    className: "icon"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, popup.title)), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(popup.description)), ((_popup$button = popup.button) === null || _popup$button === void 0 ? void 0 : _popup$button.link) && /*#__PURE__*/React.createElement("a", {
    href: (_popup$button2 = popup.button) === null || _popup$button2 === void 0 ? void 0 : _popup$button2.link,
    className: buttonClass((_popup$button3 = popup.button) === null || _popup$button3 === void 0 ? void 0 : _popup$button3.type, "btn-small"),
    id: ((_popup$button4 = popup.button) === null || _popup$button4 === void 0 ? void 0 : _popup$button4.id) || "",
    target: (_popup$button5 = popup.button) === null || _popup$button5 === void 0 ? void 0 : _popup$button5.target,
    rel: ((_popup$button6 = popup.button) === null || _popup$button6 === void 0 ? void 0 : _popup$button6.follow_link) === "no-follow" ? "nofollow" : "",
    onClick: onClose
  }, (_popup$button7 = popup.button) === null || _popup$button7 === void 0 ? void 0 : _popup$button7.label)));
};
var MobilePopup = function MobilePopup(_ref2) {
  var _popup$button8, _popup$button9, _popup$button10, _popup$button11, _popup$button12, _popup$button13, _popup$button14, _popup$mobile_close_b, _popup$mobile_close_b2, _popup$mobile_close_b3, _popup$mobile_close_b4, _popup$mobile_close_b5;
  var popup = _ref2.popup,
    onClose = _ref2.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "popup-wrapper-phone"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overlay"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content-wrapper"
  }, popup.image && /*#__PURE__*/React.createElement(Image, {
    src: popup.image,
    variant: "articles_2_columns",
    className: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title-wrapper"
  }, popup.icon && /*#__PURE__*/React.createElement(Image, {
    src: popup.icon,
    variant: "mobile_square",
    className: "icon"
  }), /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, popup.title)), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(popup.description)), /*#__PURE__*/React.createElement("div", {
    className: "popup-buttons"
  }, ((_popup$button8 = popup.button) === null || _popup$button8 === void 0 ? void 0 : _popup$button8.link) && /*#__PURE__*/React.createElement("a", {
    href: (_popup$button9 = popup.button) === null || _popup$button9 === void 0 ? void 0 : _popup$button9.link,
    className: buttonClass((_popup$button10 = popup.button) === null || _popup$button10 === void 0 ? void 0 : _popup$button10.type, "btn-small"),
    id: ((_popup$button11 = popup.button) === null || _popup$button11 === void 0 ? void 0 : _popup$button11.id) || "",
    target: (_popup$button12 = popup.button) === null || _popup$button12 === void 0 ? void 0 : _popup$button12.target,
    rel: ((_popup$button13 = popup.button) === null || _popup$button13 === void 0 ? void 0 : _popup$button13.follow_link) === "no-follow" ? "nofollow" : "",
    onClick: onClose
  }, (_popup$button14 = popup.button) === null || _popup$button14 === void 0 ? void 0 : _popup$button14.label), /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: buttonClass((_popup$mobile_close_b = popup.mobile_close_button) === null || _popup$mobile_close_b === void 0 ? void 0 : _popup$mobile_close_b.type, "btn-small"),
    id: ((_popup$mobile_close_b2 = popup.mobile_close_button) === null || _popup$mobile_close_b2 === void 0 ? void 0 : _popup$mobile_close_b2.id) || "",
    target: (_popup$mobile_close_b3 = popup.mobile_close_button) === null || _popup$mobile_close_b3 === void 0 ? void 0 : _popup$mobile_close_b3.target,
    rel: ((_popup$mobile_close_b4 = popup.mobile_close_button) === null || _popup$mobile_close_b4 === void 0 ? void 0 : _popup$mobile_close_b4.follow_link) === "no-follow" ? "nofollow" : "",
    onClick: function onClick(e) {
      e.preventDefault();
      onClose();
    }
  }, (_popup$mobile_close_b5 = popup.mobile_close_button) === null || _popup$mobile_close_b5 === void 0 ? void 0 : _popup$mobile_close_b5.label)))));
};
var HubSpotPopup = function HubSpotPopup(_ref3) {
  var popup = _ref3.popup,
    onClose = _ref3.onClose;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DesktopPopup, {
    popup: popup,
    onClose: onClose
  }), /*#__PURE__*/React.createElement(MobilePopup, {
    popup: popup,
    onClose: onClose
  }));
};
var Modal$3 = function Modal(_ref) {
  var children = _ref.children,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "cg-modal modal-show",
    id: "gtm-itc-modal"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modal-cnt"
  }, /*#__PURE__*/React.createElement("button", {
    id: "gtm-itc-close-minor",
    className: "itl-close",
    onClick: function onClick() {
      return onClose();
    }
  }), children), /*#__PURE__*/React.createElement("div", {
    className: "modal-overlay",
    onClick: function onClick() {
      return onClose();
    }
  }));
};
var Content$e = function Content(_ref2) {
  var _intentToLeave$button, _intentToLeave$button2, _intentToLeave$button3;
  var intentToLeave = _ref2.intentToLeave,
    onAccept = _ref2.onAccept;
  return /*#__PURE__*/React.createElement("div", {
    className: "intent-to-leave"
  }, intentToLeave.image && /*#__PURE__*/React.createElement(Image, {
    src: intentToLeave.image,
    variant: "articles_2_columns",
    className: "image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, intentToLeave.title), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, parseMarkdown(intentToLeave.description)), /*#__PURE__*/React.createElement("div", {
    className: "button-toolbar"
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    className: buttonClass((_intentToLeave$button = intentToLeave.button) === null || _intentToLeave$button === void 0 ? void 0 : _intentToLeave$button.type, ""),
    id: "gtm-itc-close-major",
    target: "self",
    rel: ((_intentToLeave$button2 = intentToLeave.button) === null || _intentToLeave$button2 === void 0 ? void 0 : _intentToLeave$button2.follow_link) === "no-follow" ? "nofollow" : "",
    onClick: function onClick(e) {
      e.preventDefault();
      onAccept(e);
    }
  }, (_intentToLeave$button3 = intentToLeave.button) === null || _intentToLeave$button3 === void 0 ? void 0 : _intentToLeave$button3.label))));
};
var IntentToLeave = function IntentToLeave(_ref3) {
  var intentToLeave = _ref3.intentToLeave,
    onAccept = _ref3.onAccept,
    onClose = _ref3.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: "intent-to-leave-wrapper"
  }, /*#__PURE__*/React.createElement(Modal$3, {
    onClose: onClose
  }, /*#__PURE__*/React.createElement(Content$e, {
    intentToLeave: intentToLeave,
    onAccept: onAccept
  })));
};
var resultsPageUrl = function resultsPageUrl(page, _ref) {
  var url = _ref.url,
    query = _ref.query;
  var uri = new URL(url);
  return [uri.origin, uri.pathname, "?", page ? "query=" + query + "&page=" + page : "query=" + query].join("");
};
var Prev = function Prev(_ref2) {
  var search = _ref2.search;
  var currentPage = search.currentPage;
  if (currentPage === 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      window.location.href = resultsPageUrl(currentPage - 1, search);
    },
    className: "icon left-arrow"
  }, "Left arrow");
};
var Next = function Next(_ref3) {
  var search = _ref3.search;
  var currentPage = search.currentPage,
    pagesCount = search.pagesCount;
  if (currentPage === pagesCount) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: function onClick(e) {
      e.preventDefault();
      window.location.href = resultsPageUrl(currentPage + 1, search);
    },
    className: "icon right-arrow"
  }, "Right arrow");
};
var buildPagination = function buildPagination(currentPage, pagesCount) {
  var EDGE_PIECE_LEN = 3;
  var BUFFER_LEN = 1;
  var result = [];
  Array(pagesCount).fill(0).forEach(function (_e, idx) {
    var element = idx + 1;
    if (element <= EDGE_PIECE_LEN) {
      result.push(element);
      return;
    }
    if (element > pagesCount - EDGE_PIECE_LEN) {
      result.push(element);
      return;
    }
    if (element >= currentPage - BUFFER_LEN && element <= currentPage + BUFFER_LEN) {
      result.push(element);
      return;
    }
    if (result[result.length - 1] !== 0) {
      result.push(0);
    }
  });
  return result;
};
var Pagination = function Pagination(_ref4) {
  var search = _ref4.search,
    i18n = _ref4.i18n;
  var query = search.query,
    currentPage = search.currentPage,
    pagesCount = search.pagesCount,
    totalResultsLabel = search.totalResultsLabel,
    currentResultLabel = search.currentResultLabel;
  if (pagesCount <= 1) {
    return /*#__PURE__*/React.createElement("div", {
      className: "slim-footer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "results-info"
    }, /*#__PURE__*/React.createElement("div", null, totalResultsLabel), /*#__PURE__*/React.createElement("div", null, currentResultLabel)));
  }
  var pages = buildPagination(currentPage, pagesCount);
  return /*#__PURE__*/React.createElement("div", {
    className: "slim-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "results-info"
  }, /*#__PURE__*/React.createElement("div", null, totalResultsLabel), /*#__PURE__*/React.createElement("div", null, currentResultLabel)), /*#__PURE__*/React.createElement("div", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement(Prev, {
    search: search
  }), pages.map(function (page, idx) {
    if (!page) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx
      }, "\xB7\xB7\xB7");
    }
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: "#",
      onClick: function onClick(e) {
        e.preventDefault();
        window.location.href = resultsPageUrl(page, search);
      },
      className: "num " + (page === currentPage ? "active" : "")
    }, page);
  }), /*#__PURE__*/React.createElement(Next, {
    search: search
  })), /*#__PURE__*/React.createElement("form", {
    className: "page-picker"
  }, /*#__PURE__*/React.createElement("div", null, i18n.gotoPage), /*#__PURE__*/React.createElement("div", {
    className: "page-input"
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    name: "page",
    min: "1",
    required: true,
    max: pagesCount,
    step: "1"
  }), /*#__PURE__*/React.createElement("input", {
    name: "query",
    defaultValue: query,
    type: "hidden"
  }), /*#__PURE__*/React.createElement("button", {
    className: "icon right-arrow-page"
  }, "Right arrow"))));
};
var ResultItem = function ResultItem(_ref) {
  var title = _ref.title,
    resultLink = _ref.resultLink,
    description = _ref.description;
  return /*#__PURE__*/React.createElement("div", {
    className: "result-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: resultLink
  }, /*#__PURE__*/React.createElement("h6", {
    className: "description-text"
  }, title)), /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: description
    }
  }));
};
var ResultHighlight = function ResultHighlight(_ref) {
  var title = _ref.title,
    description = _ref.description,
    image = _ref.image,
    link = _ref.link,
    links = _ref.links,
    button = _ref.button;
  return /*#__PURE__*/React.createElement("div", {
    className: "result-highlight"
  }, /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "original",
    showCredits: false
  }), /*#__PURE__*/React.createElement("div", {
    className: "description"
  }, /*#__PURE__*/React.createElement("a", {
    className: "title-link",
    href: link.link,
    target: link.target,
    id: link.id,
    rel: link.rel
  }, /*#__PURE__*/React.createElement("h5", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "description-text",
    dangerouslySetInnerHTML: {
      __html: description
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "product-toolbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "links"
  }, links.map(function (link, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: link.link,
      target: link.target,
      id: link.id,
      rel: link.rel
    }, link.label);
  })), /*#__PURE__*/React.createElement(Button$1, {
    settings: button
  }))));
};
var SearchTabs = function SearchTabs(_ref) {
  var query = _ref.query,
    _ref$noResults = _ref.noResults,
    noResults = _ref$noResults === void 0 ? false : _ref$noResults,
    i18n = _ref.i18n;
  if (noResults && !query) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tabs"
    }, /*#__PURE__*/React.createElement("span", {
      className: "accent-paragraph"
    }, noResults && /*#__PURE__*/React.createElement("p", null, i18n.emptyQuery)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "tabs"
  }, /*#__PURE__*/React.createElement("span", {
    className: "accent-paragraph"
  }, !noResults && /*#__PURE__*/React.createElement(React.Fragment, null, i18n.results, " ", /*#__PURE__*/React.createElement("strong", null, "\"", query, "\"")), noResults && /*#__PURE__*/React.createElement("div", {
    id: "gtm-search-no-results",
    dangerouslySetInnerHTML: {
      __html: i18n.noResults.replace("{QUERY}", "<strong>\"" + query + "\"</strong>")
    }
  })));
};
var SearchPage = function SearchPage(_ref) {
  var i18n = _ref.i18n,
    search = _ref.search,
    featuredResult = _ref.featuredResult,
    results = _ref.results;
  var onSearch = function onSearch(e) {
    var value = e.target.value;
    if (value.length === 0) {
      window.location.href = search.url;
    }
  };
  var noResults = !featuredResult && (!results || results.length === 0);
  return /*#__PURE__*/React.createElement("div", {
    className: "search"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-3"
  }, /*#__PURE__*/React.createElement("form", {
    className: "form-group",
    action: search.url
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "control-label"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "text-center"
  }, i18n.pageTitle))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top-sm"
  }, /*#__PURE__*/React.createElement("input", {
    name: "query",
    defaultValue: search.query,
    type: "search",
    className: "form-control",
    placeholder: i18n.inputPlaceholder,
    maxLength: 20,
    ref: function ref(element) {
      return (element || {}).onsearch = onSearch;
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top-sm"
  }, /*#__PURE__*/React.createElement(SearchTabs, {
    query: search.query,
    noResults: noResults,
    i18n: i18n
  }), featuredResult && /*#__PURE__*/React.createElement("div", {
    className: "spacing-top-sm"
  }, /*#__PURE__*/React.createElement(ResultHighlight, featuredResult)), results.map(function (result, idx) {
    return /*#__PURE__*/React.createElement(ResultItem, _extends({
      key: idx
    }, result));
  })))), !noResults && /*#__PURE__*/React.createElement(Pagination, {
    search: search,
    i18n: i18n
  }))));
};
var CountrySelect = function CountrySelect(_ref) {
  var prompt = _ref.prompt,
    options = _ref.options,
    defaultSelected = _ref.defaultSelected,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "style-select country-dropdown"
  }, /*#__PURE__*/React.createElement("select", {
    name: "country",
    id: "country",
    defaultValue: defaultSelected,
    onChange: onChange
  }, prompt && /*#__PURE__*/React.createElement("option", {
    value: ""
  }, prompt), options.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.code,
      value: item.code
    }, item.name);
  }))));
};
var ProductSelect = function ProductSelect(_ref) {
  var prompt = _ref.prompt,
    options = _ref.options,
    defaultSelected = _ref.defaultSelected,
    onChange = _ref.onChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "style-select"
  }, /*#__PURE__*/React.createElement("select", {
    name: "product",
    id: "product",
    defaultValue: defaultSelected,
    onChange: onChange
  }, prompt && /*#__PURE__*/React.createElement("option", {
    value: ""
  }, prompt), options.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      key: item.id,
      value: item.slug
    }, item.name);
  }))));
};
var LOGO = "data:image/svg+xml;base64,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";
function CertifiedProfessionalsPage(_ref) {
  var products = _ref.products,
    countries = _ref.countries,
    list = _ref.list,
    _ref$filter = _ref.filter,
    filter = _ref$filter === void 0 ? {} : _ref$filter,
    i18n = _ref.i18n;
  var formRef = /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement("div", {
    className: "learning-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "product-bar dark-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO,
    alt: "Certified Professionals"
  }), /*#__PURE__*/React.createElement("div", {
    "class": "text-block-widget text-center"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "text-component-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "row"
  }, /*#__PURE__*/React.createElement("div", {
    "class": "col-12 text-box spacing-top-sm"
  }, /*#__PURE__*/React.createElement("p", null, i18n.overview))))))), /*#__PURE__*/React.createElement("form", {
    ref: formRef,
    id: "filter-form",
    method: "GET",
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-cols-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-col"
  }, /*#__PURE__*/React.createElement(ProductSelect, {
    prompt: i18n.product_select.prompt,
    options: products,
    defaultSelected: filter.product,
    onChange: function onChange(_) {
      formRef.current.submit();
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-col"
  }, /*#__PURE__*/React.createElement(CountrySelect, {
    prompt: i18n.country_select.prompt,
    options: countries,
    defaultSelected: filter.country,
    onChange: function onChange(_) {
      formRef.current.submit();
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom"
  }, (!list || list.length === 0) && /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper no-results"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "section-title"
  }, i18n.no_matches)), list && list.length > 0 && list.map(function (item) {
    return /*#__PURE__*/React.createElement(AccordionRow, {
      key: item.id,
      renderContent: function renderContent() {
        return /*#__PURE__*/React.createElement("div", {
          className: "row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "actions-col col-4"
        }), /*#__PURE__*/React.createElement("div", {
          className: "col-7"
        }, /*#__PURE__*/React.createElement("p", null), /*#__PURE__*/React.createElement("div", {
          className: "products-wrapper"
        }, /*#__PURE__*/React.createElement("h6", {
          className: "products-title"
        }, /*#__PURE__*/React.createElement("strong", null, i18n.product_title)), /*#__PURE__*/React.createElement("div", {
          className: "products"
        }, item.published_product_versions.map(function (product_version) {
          return /*#__PURE__*/React.createElement("div", {
            key: product_version.id,
            className: "product-info"
          }, /*#__PURE__*/React.createElement("span", {
            className: "product-name"
          }, product_version.product.name), /*#__PURE__*/React.createElement("span", {
            className: "product-version"
          }, product_version.version));
        }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h6", {
          className: "products-title"
        }, /*#__PURE__*/React.createElement("strong", null, i18n.email)), /*#__PURE__*/React.createElement("div", {
          className: "product-info"
        }, /*#__PURE__*/React.createElement("span", {
          className: "product-name"
        }, item.email)), /*#__PURE__*/React.createElement("div", {
          className: "buttons-wrapper"
        }, /*#__PURE__*/React.createElement("a", {
          className: "btn-active btn-small",
          href: "mailto:" + item.email
        }, i18n.contact_link))))));
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "short-info col-4"
    }, /*#__PURE__*/React.createElement("span", {
      className: "country"
    }, item.country.name)), /*#__PURE__*/React.createElement("div", {
      className: "col-3"
    }, /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, item.name))), /*#__PURE__*/React.createElement("div", {
      className: "col-4"
    }, /*#__PURE__*/React.createElement("span", {
      className: "product"
    }, item.published_product_versions.map(function (product_version) {
      return product_version.product.name;
    }).join(", "))), /*#__PURE__*/React.createElement("div", {
      className: "col-1 col-icon"
    }, /*#__PURE__*/React.createElement("span", {
      className: "icon-plus"
    }), /*#__PURE__*/React.createElement("span", {
      className: "icon-minus"
    }))));
  })));
}
var toQueryString = function toQueryString(obj) {
  var result = [];
  Object.keys(obj).forEach(function (key) {
    result.push(key + "=" + encodeURI(obj[key]));
  });
  return result.join("&");
};
var toQueryObject = function toQueryObject(qString) {
  if (!qString) {
    return {};
  }
  var query = {};
  qString.split("&").forEach(function (keyValueString) {
    var _keyValueString$split = keyValueString.split("="),
      key = _keyValueString$split[0],
      value = _keyValueString$split[1];
    if (key && (value || value === "")) {
      query[key] = decodeURI(value);
    }
  });
  return query;
};
var parsePath = function parsePath(path) {
  var _path$split = path.split("?"),
    pathname = _path$split[0],
    queryString = _path$split[1];
  return [pathname, queryString || ""];
};
var setQueryParam = function setQueryParam(path, key, value) {
  var _parsePath = parsePath(path),
    pathname = _parsePath[0],
    queryString = _parsePath[1];
  var query = toQueryObject(queryString);
  query[key] = value;
  return [pathname, "?", toQueryString(query)].join("");
};
var queryParams = function queryParams(path) {
  var _parsePath2 = parsePath(path),
    queryString = _parsePath2[1];
  return toQueryObject(queryString);
};
var resultsPageUrl$1 = function resultsPageUrl(page, _ref) {
  var path = _ref.path;
  return setQueryParam(path, "page", page);
};
var queryParamsFromPath = function queryParamsFromPath(path) {
  var params = queryParams(path);
  var result = [];
  Object.keys(params).forEach(function (key) {
    if (key !== "page") result.push({
      key: key,
      value: params[key]
    });
  });
  return result;
};
var Prev$1 = function Prev(_ref2) {
  var pagination = _ref2.pagination;
  var currentPage = pagination.currentPage;
  if (currentPage === 1) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: resultsPageUrl$1(currentPage - 1, pagination),
    className: "icon left-arrow"
  }, "Left arrow");
};
var Next$1 = function Next(_ref3) {
  var pagination = _ref3.pagination;
  var currentPage = pagination.currentPage,
    pagesCount = pagination.pagesCount;
  if (currentPage === pagesCount) {
    return null;
  }
  return /*#__PURE__*/React.createElement("a", {
    href: resultsPageUrl$1(currentPage + 1, pagination),
    className: "icon right-arrow"
  }, "Right arrow");
};
var buildPagination$1 = function buildPagination(currentPage, pagesCount) {
  var EDGE_PIECE_LEN = 3;
  var BUFFER_LEN = 1;
  var result = [];
  Array(pagesCount).fill(0).forEach(function (_e, idx) {
    var element = idx + 1;
    if (element <= EDGE_PIECE_LEN) {
      result.push(element);
      return;
    }
    if (element > pagesCount - EDGE_PIECE_LEN) {
      result.push(element);
      return;
    }
    if (element >= currentPage - BUFFER_LEN && element <= currentPage + BUFFER_LEN) {
      result.push(element);
      return;
    }
    if (result[result.length - 1] !== 0) {
      result.push(0);
    }
  });
  return result;
};
var Pagination$1 = function Pagination(_ref4) {
  var pagination = _ref4.pagination;
  var path = pagination.path,
    currentPage = pagination.currentPage,
    pagesCount = pagination.pagesCount,
    i18n = pagination.i18n;
  if (pagesCount <= 1) {
    return null;
  }
  var pages = buildPagination$1(currentPage, pagesCount);
  return /*#__PURE__*/React.createElement("div", {
    className: "pagination-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "labels"
  }, /*#__PURE__*/React.createElement("div", null, i18n.totalItemsLabel), /*#__PURE__*/React.createElement("div", null, i18n.currentItemsLabel)), /*#__PURE__*/React.createElement("div", {
    className: "pagination"
  }, /*#__PURE__*/React.createElement(Prev$1, {
    pagination: pagination
  }), pages.map(function (page, idx) {
    if (!page) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx
      }, "\xB7\xB7\xB7");
    }
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: resultsPageUrl$1(page, pagination),
      className: "num " + (page === currentPage ? "active" : "")
    }, page);
  }), /*#__PURE__*/React.createElement(Next$1, {
    pagination: pagination
  })), /*#__PURE__*/React.createElement("form", {
    className: "page-picker"
  }, /*#__PURE__*/React.createElement("div", null, i18n.gotoPage), /*#__PURE__*/React.createElement("div", {
    className: "page-input"
  }, /*#__PURE__*/React.createElement("input", {
    type: "number",
    name: "page",
    min: "1",
    required: true,
    max: pagesCount,
    step: "1"
  }), queryParamsFromPath(path).map(function (param, idx) {
    return /*#__PURE__*/React.createElement("input", {
      key: idx + "-" + param.key,
      name: param.key,
      defaultValue: param.value,
      type: "hidden"
    });
  }), /*#__PURE__*/React.createElement("button", {
    className: "icon right-arrow-page"
  }, "Right arrow"))));
};
function Navigation$1(_ref) {
  var navigation = _ref.navigation;
  return /*#__PURE__*/React.createElement("nav", {
    className: "menu sticky-menu white-bg",
    "data-sticky-menu": "1",
    "data-menu": "1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fade-left icon-arrow-left"
  }), /*#__PURE__*/React.createElement("ul", {
    className: "menu-cnt"
  }, navigation.map(function (item, idx) {
    return /*#__PURE__*/React.createElement("li", {
      key: idx + "-" + item.id,
      className: "main-menu-link"
    }, /*#__PURE__*/React.createElement("a", {
      href: item.path
    }, item.name));
  })), /*#__PURE__*/React.createElement("div", {
    className: "fade-right icon-arrow-right"
  }));
}
function BlogListPage(_ref) {
  var title = _ref.title,
    list = _ref.list,
    navigation = _ref.navigation,
    pagination = _ref.pagination;
  var listClass = pagination && pagination.pagesCount > 1 ? "white-bg mobile-spacing-top" : "white-bg spacing-bottom mobile-spacing-top";
  return /*#__PURE__*/React.createElement("div", {
    className: "blog-list-page"
  }, /*#__PURE__*/React.createElement(Widget$K, {
    title: title,
    containerSettings: {
      theme: "dark",
      spacing: "both"
    }
  }), navigation && /*#__PURE__*/React.createElement(Navigation$1, {
    navigation: navigation
  }), /*#__PURE__*/React.createElement("div", {
    className: listClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, list.map(function (article) {
    return /*#__PURE__*/React.createElement(ArticleCard, {
      key: article.id,
      article: article
    });
  })), /*#__PURE__*/React.createElement(Pagination$1, {
    pagination: pagination
  }))));
}
var menuStyle$1 = {
  boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
  background: "#fff",
  position: "absolute",
  top: "auto",
  overflow: "auto",
  left: "0",
  zIndex: "5"
};
var itemStyle = function itemStyle(isHighlighted) {
  return {
    padding: "1em",
    cursor: "pointer",
    background: isHighlighted ? "lightgray" : "white"
  };
};
function Search$4(_ref) {
  var url = _ref.url,
    term = _ref.term,
    placeholder = _ref.placeholder,
    all_results = _ref.all_results;
  var _React$useState = React.useState([]),
    articles = _React$useState[0],
    setArticles = _React$useState[1];
  var _React$useState2 = React.useState(term || ''),
    search = _React$useState2[0],
    setSearch = _React$useState2[1];
  var handleProductSearch = function handleProductSearch(term) {
    try {
      setSearch(term);
      if (term.length < 3) {
        setArticles([]);
        return Promise.resolve();
      }
      return Promise.resolve(fetch(url + "?q=" + encodeURIComponent(term), {
        headers: {
          accept: "application/json"
        }
      })).then(function (response) {
        return Promise.resolve(response.json()).then(function (articles) {
          setArticles(articles);
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
  var handleGoToArticle = function handleGoToArticle(articleName) {
    var selectedArticle = articles.find(function (item) {
      return item.title === articleName;
    });
    window.location.href = selectedArticle.url;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "faq-search"
  }, /*#__PURE__*/React.createElement("form", {
    method: "get",
    action: url
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    getItemValue: function getItemValue(item) {
      return item.title;
    },
    items: articles,
    renderMenu: function renderMenu(items, value, style) {
      return /*#__PURE__*/React.createElement("div", {
        style: _extends({}, style, menuStyle$1)
      }, items.slice(0, 6), items.length > 6 && /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "see-all"
      }, all_results, " (", items.length, ")"));
    },
    renderItem: function renderItem(item, isHighlighted) {
      return /*#__PURE__*/React.createElement("div", {
        key: item.id,
        style: itemStyle(isHighlighted)
      }, item.title);
    },
    value: search,
    onChange: function onChange(e) {
      return handleProductSearch(e.target.value);
    },
    onSelect: function onSelect(articleName) {
      return handleGoToArticle(articleName);
    },
    inputProps: {
      placeholder: placeholder,
      className: "faq-search-input"
    },
    wrapperStyle: {
      display: "inline-block",
      width: "100%"
    },
    menuStyle: menuStyle$1
  }), /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "icon-search"
  }), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    name: "q",
    value: search
  })));
}
var formatDate$2 = function formatDate(dateOrString) {
  var date = new Date(dateOrString);
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  return date.toLocaleDateString("en-US", options);
};
function PodcastListPage(_ref) {
  var searchPath = _ref.searchPath,
    i18n = _ref.i18n,
    placeholder = _ref.placeholder,
    title = _ref.title,
    list = _ref.list,
    pagination = _ref.pagination;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Widget$K, {
    title: title,
    containerSettings: {
      theme: "dark"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-shift-3"
  }, /*#__PURE__*/React.createElement(Search$4, {
    url: searchPath,
    placeholder: placeholder,
    all_results: i18n.all_results
  })))), /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, list.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: "podcast-player-extended"
    }, /*#__PURE__*/React.createElement("div", {
      className: "container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-shift-1 podcast-inner cf"
    }, /*#__PURE__*/React.createElement("div", {
      className: "podcast-player-img-wrapper"
    }, /*#__PURE__*/React.createElement(Image, {
      src: item.image,
      variant: "articles_2_columns",
      className: "preview-image"
    })), /*#__PURE__*/React.createElement(PodcastPlayer, {
      source: item.source,
      episode_no: item.episode_no,
      publish_date: formatDate$2(item.publish_date),
      title: item.title,
      summary: item.summary,
      more_url: item.more_url,
      transcription: item.transcription,
      htmlID: item.htmlID
    }))));
  })), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Pagination$1, {
    pagination: pagination
  })));
}
var formatDate$3 = function formatDate(dateOrString) {
  var date = new Date(dateOrString);
  var options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };
  return date.toLocaleDateString("en-US", options);
};
function PodcastSearchResultPage(_ref) {
  var title = _ref.title,
    list = _ref.list;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Widget$K, {
    title: title,
    containerSettings: {
      theme: "dark",
      spacing: "both"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "white-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, list.map(function (article) {
    return /*#__PURE__*/React.createElement("div", {
      key: article.id,
      className: "col-4"
    }, /*#__PURE__*/React.createElement("div", {
      className: "article-preview"
    }, /*#__PURE__*/React.createElement("a", {
      href: article.path
    }, /*#__PURE__*/React.createElement(Image, {
      src: article.image,
      variant: "articles_2_columns",
      className: "preview-image"
    })), /*#__PURE__*/React.createElement("p", {
      className: "article-meta"
    }, /*#__PURE__*/React.createElement("a", {
      href: article.magazine_category.path,
      className: "category"
    }, article.magazine_category.name), /*#__PURE__*/React.createElement("time", null, formatDate$3(article.publish_date))), /*#__PURE__*/React.createElement("h6", {
      className: "article-title"
    }, /*#__PURE__*/React.createElement("a", {
      href: article.path
    }, article.title)), /*#__PURE__*/React.createElement("p", {
      className: "description"
    }, parseMarkdown(article.description))));
  })))));
}
var SocialLinks$1 = function SocialLinks(_ref) {
  var event = _ref.event,
    currentHost = _ref.currentHost,
    i18n = _ref.i18n;
  var eventUrl = [currentHost.endsWith("/") ? currentHost.slice(0, currentHost.length - 1) : currentHost, event.path].join("");
  return /*#__PURE__*/React.createElement("div", {
    className: "social-links-wrapper"
  }, /*#__PURE__*/React.createElement("span", null, i18n.social_links), /*#__PURE__*/React.createElement("div", {
    className: "social-links"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://facebook.com/sharer/sharer.php?u=" + eventUrl,
    className: "icon-facebook",
    id: "news-share-fb",
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://twitter.com/intent/tweet?url=" + eventUrl,
    className: "x-icon dark-logo",
    id: "news-share-tw",
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    href: "https://www.linkedin.com/shareArticle?mini=true&url=" + eventUrl,
    className: "icon-linkedin",
    id: "news-share-g",
    target: "_blank",
    rel: "noreferrer"
  }), /*#__PURE__*/React.createElement("a", {
    href: "mailto:?subject=" + event.title + "&body=" + eventUrl,
    className: "icon-mail"
  })));
};
var eventAddress = function eventAddress(event) {
  return [event.city, event.country && event.country.name].filter(Boolean).join(", ");
};
var monthName = function monthName(date, locale) {
  var options = {
    month: "long"
  };
  return new Intl.DateTimeFormat(locale, options).format(date);
};
var eventDate = function eventDate(event, locale) {
  if (locale === void 0) {
    locale = "en-US";
  }
  var startOn = new Date(event.start_on);
  var endOn = new Date(event.end_on);
  if (event.start_on === event.end_on) {
    return monthName(startOn, locale) + " " + startOn.getDate() + ", " + startOn.getFullYear();
  }
  if (startOn.getMonth() < endOn.getMonth()) {
    return monthName(startOn, locale) + " " + startOn.getDate() + " - " + monthName(endOn, locale) + " " + endOn.getDate() + ", " + endOn.getFullYear();
  }
  return monthName(startOn, locale) + " " + startOn.getDate() + " - " + endOn.getDate() + ", " + startOn.getFullYear();
};
var StructuredData$1 = function StructuredData(_ref) {
  var event = _ref.event;
  var data = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: event.title,
    startDate: event.start_on || "",
    endDate: event.end_on || "",
    location: {
      "@type": "Place",
      name: event.venue,
      address: {
        "@type": "PostalAddress",
        streetAddress: "",
        addressLocality: event.city,
        postalCode: "",
        addressRegion: "",
        addressCountry: event.country
      }
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: "<script type=\"application/ld+json\">" + JSON.stringify(data) + "</script>"
    }
  });
};
var isFutureEvent = function isFutureEvent(event) {
  if (!event.end_on) {
    return false;
  }
  var endDate = new Date(event.end_on);
  return endDate > new Date();
};
var Event = function Event(_ref) {
  var event = _ref.event,
    i18n = _ref.i18n,
    currentHost = _ref.currentHost,
    alwaysOpen = _ref.alwaysOpen;
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(AccordionRow, {
    alwaysOpen: alwaysOpen,
    renderContent: function renderContent() {
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-4 actions-col"
      }, event.image && event.image_link && /*#__PURE__*/React.createElement(A, {
        href: event.image_link
      }, /*#__PURE__*/React.createElement(Image, {
        variant: "articles_2_columns",
        src: event.image
      })), event.image && !event.image_link && /*#__PURE__*/React.createElement(Image, {
        variant: "articles_2_columns",
        src: event.image
      }), event.page && /*#__PURE__*/React.createElement("a", {
        href: event.page.path,
        className: "btn-passive"
      }, i18n.event_page_link), /*#__PURE__*/React.createElement(SocialLinks$1, {
        event: event,
        currentHost: currentHost,
        i18n: i18n
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-8 event-desc-col"
      }, parseMarkdown(event.content)));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "date col-2"
  }, eventDate(event)), /*#__PURE__*/React.createElement("span", {
    className: "address col-2"
  }, eventAddress(event)), /*#__PURE__*/React.createElement("div", {
    className: "event-desc-col col-7"
  }, /*#__PURE__*/React.createElement("span", {
    className: "short-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "event-name"
  }, event.title), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "short-desc"
  }, event.summary))), /*#__PURE__*/React.createElement("div", {
    className: "col-1 col-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-minus"
  })))), isFutureEvent(event) && /*#__PURE__*/React.createElement(StructuredData$1, {
    event: event
  }));
};
var DefaultEvent = function DefaultEvent(_ref) {
  var overlay = _ref.overlay,
    credits = _ref.credits,
    image = _ref.image,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement("section", {
    className: "full-image-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cnt-overlay",
    style: {
      background: "rgba(0, 0, 0, " + overlay + ")"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "image-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, /*#__PURE__*/React.createElement(Image, {
    variant: "full_width_image",
    src: image
  }), /*#__PURE__*/React.createElement(Image, {
    variant: "full_width_image",
    src: image
  })), credits && /*#__PURE__*/React.createElement("span", {
    className: "credits"
  }, credits)), /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "full-image-title large-title"
  }, i18n["default"].title))))));
};
var FeaturedEvent = function FeaturedEvent(_ref2) {
  var event = _ref2.event,
    image = _ref2.image,
    overlay = _ref2.overlay,
    i18n = _ref2.i18n;
  return /*#__PURE__*/React.createElement("section", {
    className: "full-image-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cnt-overlay",
    style: {
      background: "rgba(0, 0, 0, " + overlay + ")"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "full-image"
  }, /*#__PURE__*/React.createElement(Image, {
    variant: "full_width_image",
    src: image
  }), /*#__PURE__*/React.createElement(Image, {
    variant: "mobile_square",
    src: image
  })), /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "full-image-title-inner"
  }, /*#__PURE__*/React.createElement("div", {
    className: "headings"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "full-image-sup-title"
  }, /*#__PURE__*/React.createElement("span", {
    className: "date"
  }, eventDate(event)), event.city), /*#__PURE__*/React.createElement("h1", {
    className: "full-image-title"
  }, event.title), /*#__PURE__*/React.createElement("h5", {
    className: "full-image-sub-title"
  }, event.summary), /*#__PURE__*/React.createElement("a", {
    className: "btn-passive-light",
    href: event.page ? event.page.path : event.path
  }, i18n.featured.learn_more))))));
};
var EventsHeader = function EventsHeader(_ref3) {
  var featured_event = _ref3.featured_event,
    default_event = _ref3.default_event,
    i18n = _ref3.i18n;
  if (featured_event) {
    return /*#__PURE__*/React.createElement(FeaturedEvent, _extends({}, featured_event, {
      i18n: i18n
    }));
  }
  if (default_event) {
    return /*#__PURE__*/React.createElement(DefaultEvent, _extends({}, default_event, {
      i18n: i18n
    }));
  }
  return null;
};
var NoMatches = function NoMatches(_ref) {
  var list = _ref.list,
    message = _ref.message;
  return list.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper no-results no-padding-bottom"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "section-title"
  }, message)));
};
function EventsPage(_ref) {
  var events_header = _ref.events_header,
    past_events_path = _ref.past_events_path,
    list = _ref.list,
    i18n = _ref.i18n,
    current_host = _ref.current_host;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EventsHeader, _extends({}, events_header, {
    i18n: i18n
  })), /*#__PURE__*/React.createElement(NoMatches, {
    list: list,
    message: interpolateI18n(i18n.no_matches, {
      year: new Date().getFullYear()
    })
  }), list.map(function (item) {
    return /*#__PURE__*/React.createElement(Event, {
      key: item.id,
      event: item,
      currentHost: current_host,
      i18n: i18n
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "centered-btn"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn-passive centered-btn",
    href: past_events_path
  }, i18n.past_events)))));
}
function EventDetailPage(_ref) {
  var title = _ref.title,
    event = _ref.event,
    i18n = _ref.i18n,
    events_path = _ref.events_path,
    current_host = _ref.current_host;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Widget$K, {
    title: title,
    containerSettings: {
      theme: "dark",
      spacing: "both"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "accordion accordion-lists accordion-open"
  }, /*#__PURE__*/React.createElement(Event, {
    event: event,
    i18n: i18n,
    currentHost: current_host,
    alwaysOpen: true
  })), /*#__PURE__*/React.createElement("section", {
    className: "call-to-action spacing-bottom theme-blank"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn-passive",
    href: events_path
  }, i18n.all_events_link))));
}
var CountrySelect$1 = function CountrySelect(_ref) {
  var options = _ref.options,
    events_archive_path = _ref.events_archive_path,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement("nav", {
    className: "menu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fade-left icon-arrow-left"
  }), /*#__PURE__*/React.createElement("ul", {
    className: "menu-cnt"
  }, /*#__PURE__*/React.createElement("li", {
    className: "main-menu-link sub-menu-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sub-menu-link"
  }, i18n.sub_menu_link), /*#__PURE__*/React.createElement("div", {
    className: "sub-menu-list"
  }, /*#__PURE__*/React.createElement("div", {
    className: "items-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "list-item"
  }, /*#__PURE__*/React.createElement("a", {
    href: events_archive_path
  }, i18n.sub_menu_list_title)), options.map(function (country, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx,
      className: "list-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: events_archive_path + "?country=" + country.code
    }, country.name));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "fade-right icon-arrow-right"
  }));
};
function PastEventsPage(_ref) {
  var events_header = _ref.events_header,
    events_path = _ref.events_path,
    events_archive_path = _ref.events_archive_path,
    countries = _ref.countries,
    list = _ref.list,
    pagination = _ref.pagination,
    i18n = _ref.i18n,
    current_host = _ref.current_host;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(EventsHeader, _extends({}, events_header, {
    i18n: i18n
  })), countries && /*#__PURE__*/React.createElement(CountrySelect$1, {
    options: countries,
    i18n: i18n,
    events_archive_path: events_archive_path
  }), list.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "spacing-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper no-results no-padding-bottom"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "section-title"
  }, i18n.no_matches))), list.map(function (item) {
    return /*#__PURE__*/React.createElement(Event, {
      key: item.id,
      event: item,
      currentHost: current_host,
      i18n: i18n
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "centered-btn"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn-passive centered-btn",
    href: events_path
  }, i18n.upcoming_events)))), pagination && /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(Pagination$1, {
    pagination: pagination
  })));
}
var Cta = function Cta(_ref) {
  var become_partner_path = _ref.become_partner_path,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement("section", {
    className: "notification-bar light-bg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "notification-bar-inner"
  }, /*#__PURE__*/React.createElement("p", {
    className: "notification-message"
  }, i18n.become_authorized_farm), /*#__PURE__*/React.createElement("a", {
    className: "btn-active btn-small",
    id: "gtm-render-farms-apply-top",
    href: become_partner_path
  }, i18n.learn_how_top))));
};
var FooterCta = function FooterCta(_ref) {
  var i18n = _ref.i18n,
    become_partner_path = _ref.become_partner_path;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("section", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-component accent-paragraph"
  }, /*#__PURE__*/React.createElement("p", {
    className: "text-center"
  }, i18n.disclaimer))), /*#__PURE__*/React.createElement("section", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "text-center"
  }, i18n.become_authorized_farm_alt), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
    className: "call-to-action no-padding-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("a", {
    className: "btn-passive",
    id: "gtm-render-farms-apply-bottom",
    href: become_partner_path
  }, i18n.learn_how_bottom))));
};
var Farm = function Farm(_ref) {
  var farm = _ref.farm,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(AccordionRow, {
    renderContent: function renderContent() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-2 actions-col"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-7 event-desc-col"
      }, /*#__PURE__*/React.createElement("p", null, farm.more_info), /*#__PURE__*/React.createElement("div", {
        className: "products-wrapper"
      }, /*#__PURE__*/React.createElement("h6", null, /*#__PURE__*/React.createElement("strong", null, i18n.products_wrapper_title)), /*#__PURE__*/React.createElement("div", {
        className: "products"
      }, farm.products.map(function (product) {
        return /*#__PURE__*/React.createElement("div", {
          key: product.id,
          className: "product-info"
        }, /*#__PURE__*/React.createElement("span", {
          className: "product-name"
        }, product.name));
      }), farm.website && /*#__PURE__*/React.createElement("div", {
        className: "buttons-wrapper"
      }, /*#__PURE__*/React.createElement("a", {
        id: "website-renderfarm-XRender",
        className: "btn-text btn-small website-link",
        rel: "nofollow noreferrer",
        target: "_blank",
        href: farm.website
      }, i18n.buttons_wrapper_link))))), farm.image && /*#__PURE__*/React.createElement("div", {
        className: "col-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "render-farm-logo"
      }, /*#__PURE__*/React.createElement(Image, {
        src: farm.image,
        variant: "articles_2_columns"
      })))));
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("span", {
    className: "date col-2"
  }, farm.country.name), /*#__PURE__*/React.createElement("div", {
    className: "event-desc-col col-9"
  }, /*#__PURE__*/React.createElement("span", {
    className: "short-info"
  }, /*#__PURE__*/React.createElement("span", {
    className: "event-name"
  }, farm.name))), /*#__PURE__*/React.createElement("div", {
    className: "col-1 col-icon"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-minus"
  }))));
};
var RenderFarmsPage = function RenderFarmsPage(_ref) {
  var filter = _ref.filter,
    products = _ref.products,
    countries = _ref.countries,
    i18n = _ref.i18n,
    list = _ref.list,
    become_partner_path = _ref.become_partner_path;
  var formRef = /*#__PURE__*/React.createRef();
  return /*#__PURE__*/React.createElement("div", {
    className: "render-farms-page"
  }, /*#__PURE__*/React.createElement(Widget$K, {
    title: i18n.section_title,
    containerSettings: {
      theme: "dark",
      spacing: "both"
    }
  }), /*#__PURE__*/React.createElement(Cta, {
    i18n: i18n,
    become_partner_path: become_partner_path
  }), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("form", {
    ref: formRef,
    id: "filter-form",
    method: "GET"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-cols-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-col"
  }, /*#__PURE__*/React.createElement(ProductSelect, {
    prompt: i18n.product_select.prompt,
    options: products,
    defaultSelected: filter.product,
    onChange: function onChange(_) {
      formRef.current.submit();
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "form-col"
  }, /*#__PURE__*/React.createElement(CountrySelect, {
    prompt: i18n.country_select.prompt,
    options: countries,
    defaultSelected: filter.country,
    onChange: function onChange(_) {
      formRef.current.submit();
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("h6", {
    className: "text-center"
  }, i18n.by_country_of_registration), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement("div", {
    className: "spacing-bottom"
  }, (!list || list.length === 0) && /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper no-results"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "section-title"
  }, i18n.no_matches)), list && list.length > 0 && list.map(function (rf) {
    return /*#__PURE__*/React.createElement(Farm, {
      key: rf.id,
      farm: rf,
      i18n: i18n
    });
  })), /*#__PURE__*/React.createElement(FooterCta, {
    i18n: i18n,
    become_partner_path: become_partner_path
  }));
};
var GalleryItem$1 = function GalleryItem(_ref) {
  var path = _ref.path,
    image = _ref.image,
    name = _ref.name,
    author = _ref.author,
    industry = _ref.industry;
  return /*#__PURE__*/React.createElement("a", {
    href: path,
    className: "gallery-thumb col-3"
  }, image && /*#__PURE__*/React.createElement(Image, {
    src: image,
    variant: "articles_2_columns"
  }), /*#__PURE__*/React.createElement("div", {
    className: "opacity-overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "thumb-text"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "thumb-title"
  }, name), /*#__PURE__*/React.createElement("p", {
    className: "meta"
  }, author && /*#__PURE__*/React.createElement("span", {
    className: "name"
  }, author.name), industry && /*#__PURE__*/React.createElement("span", {
    className: "category"
  }, industry.name)))));
};
var GalleryListPage = function GalleryListPage(_ref) {
  var title = _ref.title,
    list = _ref.list,
    navigation = _ref.navigation,
    theme = _ref.theme,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Widget$K, {
    title: title,
    containerSettings: {
      theme: theme,
      spacing: "both"
    }
  }), navigation && /*#__PURE__*/React.createElement(Navigation$1, {
    navigation: navigation
  }), list && list.length > 0 ? /*#__PURE__*/React.createElement("div", {
    className: navigation ? "spacing-both" : "spacing-bottom"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gallery-strip"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, list.map(function (item) {
    return /*#__PURE__*/React.createElement(GalleryItem$1, _extends({
      key: item.id
    }, item));
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper no-results"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "section-title"
  }, i18n.no_matches)));
};
var BuyResellersPage = function BuyResellersPage(_ref) {
  var products = _ref.products,
    countries = _ref.countries,
    filter = _ref.filter,
    resellers_path = _ref.resellers_path,
    render_farms_path = _ref.render_farms_path,
    i18n = _ref.i18n;
  return /*#__PURE__*/React.createElement("div", {
    className: "buy-page"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-title-wrapper"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "section-title"
  }, i18n.section_title)), /*#__PURE__*/React.createElement("form", {
    className: "form-cols-wrapper",
    action: resellers_path,
    method: "get"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-col"
  }, /*#__PURE__*/React.createElement(ProductSelect, {
    prompt: i18n.product_select.prompt,
    options: products,
    defaultSelected: filter.product
  }), /*#__PURE__*/React.createElement(CountrySelect, {
    prompt: i18n.country_select.prompt,
    options: countries,
    defaultSelected: filter.country
  }), /*#__PURE__*/React.createElement("div", {
    className: "text-align-right"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn-active"
  }, i18n.submit_button))))), /*#__PURE__*/React.createElement("section", {
    className: "cta-section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cta-icon-wrapper"
  }, /*#__PURE__*/React.createElement("span", {
    className: "cta-icon icon-cloud"
  }, "\xA0")), /*#__PURE__*/React.createElement("div", {
    className: "cta-headings"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "cta-title"
  }, i18n.cta_title), /*#__PURE__*/React.createElement("h5", {
    className: "cta-sub-title"
  }, i18n.cta_sub_title)), /*#__PURE__*/React.createElement("div", {
    className: "cta-buttons"
  }, /*#__PURE__*/React.createElement("a", {
    href: render_farms_path,
    className: "btn-passive"
  }, i18n.cta_button)))));
};
var Preview = function Preview(_ref) {
  var library = _ref.library,
    widget = _ref.widget,
    theme = _ref.theme;
  var Component = library[widget].Widget;
  var props = library[widget].Defaults;
  if (!props.containerSettings) props.containerSettings = {};
  props.containerSettings.theme = theme;
  props.containerSettings.spacing = "both-lg";
  return /*#__PURE__*/React.createElement(Component, props);
};
var getGroups = function getGroups(widgetList) {
  return widgetList.reduce(function (groups, widget) {
    var category = ADMIN_LIBRARY[widget].Config.category;
    if (!groups[category]) groups[category] = [];
    groups[category].push(widget);
    return groups;
  }, []);
};
var Widgets = function Widgets(_ref) {
  var preselectedWidget = _ref.w,
    theme = _ref.t,
    themes = _ref.themes;
  var widgetList = Object.keys(ADMIN_LIBRARY).sort();
  var widgetGroups = getGroups(widgetList);
  var handleSelect = function handleSelect(e) {
    return e.target.form.submit();
  };
  var currentWidget = ADMIN_LIBRARY[preselectedWidget] || {};
  var defaults = currentWidget === null || currentWidget === void 0 ? void 0 : currentWidget.Defaults;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm light"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("form", {
    method: "get",
    action: "",
    style: {
      display: "flex",
      gap: "1rem",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement("select", {
    name: "w",
    value: preselectedWidget,
    onChange: handleSelect
  }, /*#__PURE__*/React.createElement("option", {
    value: ""
  }, "Please select widget..."), Object.keys(widgetGroups).map(function (group) {
    return /*#__PURE__*/React.createElement("optgroup", {
      label: group,
      key: group
    }, widgetGroups[group].map(function (widget) {
      var _ADMIN_LIBRARY$widget;
      return /*#__PURE__*/React.createElement("option", {
        key: widget,
        value: widget
      }, (_ADMIN_LIBRARY$widget = ADMIN_LIBRARY[widget].Config) === null || _ADMIN_LIBRARY$widget === void 0 ? void 0 : _ADMIN_LIBRARY$widget.title);
    }));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement("select", {
    name: "t",
    value: theme,
    onChange: handleSelect
  }, themes.map(function (theme) {
    return /*#__PURE__*/React.createElement("option", {
      key: theme[0],
      value: theme[0]
    }, theme[1]);
  })))))), !currentWidget.Config && /*#__PURE__*/React.createElement("div", {
    className: "text-center"
  }, "Please select widget..."), currentWidget.Config && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: "1px solid pink",
      borderBottom: "1px solid pink"
    }
  }, /*#__PURE__*/React.createElement(Preview, {
    library: ADMIN_LIBRARY,
    widget: preselectedWidget,
    theme: theme
  })), /*#__PURE__*/React.createElement("div", {
    className: "spacing-both"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("h4", null, /*#__PURE__*/React.createElement("span", {
    className: "muted"
  }, currentWidget.Config.category), " /", " ", currentWidget.Config.title, " (", /*#__PURE__*/React.createElement("code", null, preselectedWidget), ")"), /*#__PURE__*/React.createElement("details", {
    className: "spacing-bottom-xs"
  }, /*#__PURE__*/React.createElement("summary", null, "Defaults"), /*#__PURE__*/React.createElement("pre", {
    style: {
      display: "inline-block",
      padding: "0.125rem 0.75rem",
      borderRadius: "4px",
      backgroundColor: "#efefef"
    }
  }, /*#__PURE__*/React.createElement("code", {
    style: {
      display: "block",
      padding: "1rem"
    }
  }, JSON.stringify(defaults, null, 2))))))));
};
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function ErrorBoundary() {
    return _React$Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ErrorBoundary, _React$Component);
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, info) {
    console.error(error, info);
  };
  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  };
  return ErrorBoundary;
}(React.Component);
var TestPage = function TestPage(_ref) {
  var themes = _ref.themes;
  var widgetList = Object.keys(ADMIN_LIBRARY).sort();
  var _React$useState = React.useState("none"),
    theme = _React$useState[0],
    setTheme = _React$useState[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "sticky",
      top: "0",
      zIndex: 1000,
      borderBottom: "1px solid var(--lighter-gray)",
      backgroundColor: "rgba(255, 255, 255, 0.9)",
      backdropFilter: "blur(5px)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "spacing-both-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "stack gap fill"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group",
    style: {
      marginBottom: 0
    }
  }, /*#__PURE__*/React.createElement("select", {
    value: theme,
    onChange: function onChange(e) {
      return setTheme(e.target.value);
    }
  }, themes.map(function (theme) {
    return /*#__PURE__*/React.createElement("option", {
      key: theme[0],
      value: theme[0]
    }, theme[1]);
  }))))))), widgetList.map(function (widget, idx) {
    return /*#__PURE__*/React.createElement("div", {
      key: idx + "-" + widget.id,
      style: {
        borderTop: "1px solid pink"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "spacing-top spacing-bottom-lg " + theme
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        position: "sticky",
        top: "8rem",
        left: "1rem",
        zIndex: "999",
        display: "inline-block",
        margin: "1rem 0",
        padding: "0.25rem 0.75rem",
        borderRadius: "16px",
        backgroundColor: "pink",
        color: "firebrick",
        fontSize: "var(--fs-small)",
        fontWeight: "500"
      }
    }, ADMIN_LIBRARY[widget].Config.title), /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement(Preview, {
      library: ADMIN_LIBRARY,
      widget: widget,
      theme: theme
    }))));
  }));
};
var ClickAway = function ClickAway(_ref) {
  var children = _ref.children,
    onAwayClick = _ref.onAwayClick;
  var wrapperRef = React.useRef(null);
  React.useEffect(function () {
    var handleClickAway = function handleClickAway(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onAwayClick();
      }
    };
    document.addEventListener("mousedown", handleClickAway);
    return function () {
      document.removeEventListener("mousedown", handleClickAway);
    };
  }, [wrapperRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef
  }, children);
};
var Checkbox$3 = function Checkbox(_ref2) {
  var value = _ref2.value,
    label = _ref2.label,
    name = _ref2.name,
    selected = _ref2.selected,
    onChange = _ref2.onChange;
  var id = "checkbox-id-" + name + "-" + value;
  return /*#__PURE__*/React.createElement("label", {
    className: "checkbox-style",
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: name,
    value: value,
    checked: !!selected.find(function (el) {
      return el.slug === value;
    }),
    id: id,
    onChange: onChange
  }), /*#__PURE__*/React.createElement("span", {
    className: "label-checkbox"
  }, /*#__PURE__*/React.createElement("span", {
    className: "label-text"
  }, label)));
};
var Checkboxes = function Checkboxes(_ref3) {
  var options = _ref3.options,
    name = _ref3.name,
    selected = _ref3.selected,
    onChange = _ref3.onChange;
  return options.map(function (option) {
    return /*#__PURE__*/React.createElement(Checkbox$3, {
      name: name,
      key: name + "-" + option.id,
      value: option.slug,
      selected: selected,
      label: option.name,
      onChange: onChange
    });
  });
};
var GenericSelect = function GenericSelect(_ref4) {
  var prompt = _ref4.prompt,
    options = _ref4.options,
    selected = _ref4.selected,
    name = _ref4.name,
    disabled = _ref4.disabled,
    _onChange = _ref4.onChange;
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setOpen = _React$useState[1];
  return /*#__PURE__*/React.createElement("div", {
    className: "form-field-wrapper"
  }, /*#__PURE__*/React.createElement(ClickAway, {
    onAwayClick: function onAwayClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn-style-select style-select " + (selected.length > 0 ? "active" : ""),
    type: "button",
    disabled: disabled,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, prompt), /*#__PURE__*/React.createElement("div", {
    className: "checkboxes-wrapper " + (open ? "open" : "")
  }, /*#__PURE__*/React.createElement(Checkboxes, {
    options: options,
    name: name,
    selected: selected,
    onChange: function onChange(event) {
      if (event.target.checked) {
        if (!selected.find(function (el) {
          return el.slug === event.target.value;
        })) {
          var item = options.find(function (option) {
            return option.slug === event.target.value;
          });
          if (item) {
            _onChange([].concat(selected, [item]));
          }
        }
      } else {
        _onChange(selected.filter(function (el) {
          return el.slug !== event.target.value;
        }));
      }
      setOpen(false);
    }
  }))));
};
function fetchValues(list, filter) {
  var selected = filter || [];
  return list.filter(function (element) {
    return selected.includes(element.slug);
  });
}
function removeFromCollection(inputs, key, slug) {
  var _extends2;
  return _extends({}, inputs, (_extends2 = {}, _extends2[key] = inputs[key].filter(function (item) {
    return item.slug !== slug;
  }), _extends2));
}
var Tags = function Tags(_ref) {
  var list = _ref.list,
    onRemove = _ref.onRemove;
  return list.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: "tag"
    }, /*#__PURE__*/React.createElement("span", null, item.name), " ", /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "tag-btn",
      onClick: function onClick() {
        return onRemove(item.slug);
      }
    }, "\u2715"));
  });
};
function shouldRenderTags(filter) {
  return filter.industry.length > 0 || filter.product.length > 0 || filter.host_platform.length > 0;
}
var GalleryFilterStrip = function GalleryFilterStrip(_ref2) {
  var products = _ref2.products,
    industries = _ref2.industries,
    host_platforms = _ref2.host_platforms,
    filter = _ref2.filter,
    i18n = _ref2.i18n,
    disabled = _ref2.disabled,
    onChange = _ref2.onChange;
  var _React$useState = React.useState({
      industry: fetchValues(industries, filter.industry),
      product: fetchValues(products, filter.product),
      host_platform: fetchValues(host_platforms, filter.host_platform)
    }),
    inputs = _React$useState[0],
    setInputs = _React$useState[1];
  function handleChange(newInputs) {
    setInputs(newInputs);
    onChange(newInputs);
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "gallery-filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("form", {
    id: "filter-form",
    method: "GET"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-cols-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "f-col"
  }, /*#__PURE__*/React.createElement(GenericSelect, {
    name: "industry",
    prompt: i18n.industry_select.prompt,
    options: industries,
    selected: inputs.industry,
    disabled: disabled,
    onChange: function onChange(newValue) {
      handleChange(_extends({}, inputs, {
        industry: newValue
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "f-col"
  }, /*#__PURE__*/React.createElement(GenericSelect, {
    name: "product",
    prompt: i18n.product_select.prompt,
    options: products,
    selected: inputs.product,
    disabled: disabled,
    onChange: function onChange(newValue) {
      handleChange(_extends({}, inputs, {
        product: newValue
      }));
    }
  })))))), shouldRenderTags(inputs) && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "shift-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tags"
  }, /*#__PURE__*/React.createElement(Tags, {
    list: inputs.industry,
    onRemove: function onRemove(slug) {
      return handleChange(removeFromCollection(inputs, "industry", slug));
    }
  }), /*#__PURE__*/React.createElement(Tags, {
    list: inputs.product,
    onRemove: function onRemove(slug) {
      return handleChange(removeFromCollection(inputs, "product", slug));
    }
  }), /*#__PURE__*/React.createElement(Tags, {
    list: inputs.host_platform,
    onRemove: function onRemove(slug) {
      return handleChange(removeFromCollection(inputs, "host_platform", slug));
    }
  }))))));
};
var index$1 = {
  SearchPage: SearchPage,
  CertifiedProfessionalsPage: CertifiedProfessionalsPage,
  BlogListPage: BlogListPage,
  PodcastListPage: PodcastListPage,
  PodcastSearchPage: PodcastSearchResultPage,
  GalleryContent: GalleryContent,
  EventsPage: EventsPage,
  PastEventsPage: PastEventsPage,
  EventDetailPage: EventDetailPage,
  RenderFarmsPage: RenderFarmsPage,
  GalleryListPage: GalleryListPage,
  BuyResellersPage: BuyResellersPage,
  DocumentationWidgets: Widgets,
  DocumentationTest: TestPage,
  GalleryFilterStrip: GalleryFilterStrip
};
var ArticleComments = Comments.Discussion;
var ArticleStructuredData = StructuredData;
export { ADMIN_LIBRARY, RTE as AdminRTE, AdminUserProvider, ArticleComments, ArticleFooter, ArticleHeader, ArticleStructuredData, Captcha$1 as Captcha, CaptchaConsumer, CaptchaProvider, Captcha as CaptchaWithContext, CartProvider, CountriesConsumer, CountriesProvider, CurrencyProvider, FormsConsumer, FormsProvider, GalleriesStrip, GalleryStipPlaceholder, GeoIpFilter, GeoIpProvider, GlobalNotice, GraphQLProvider, HubSpotContext, HubSpotPopup as HubspotPopup, IntentToLeave, index as LIBRARY, Popup as LanguagePopup, LocaleConsumer, LocaleContext, LocaleProvider, LocalizationUrlContext, index$1 as PAGES, PageUrlConsumer, PageUrlProvider, PodcastPlayer, RelatedArticles, ResellersContext, UpsellCampaign };